import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ChangeDetectorRef,
  HostListener,
} from '@angular/core';
import moment from 'moment'
import { Chart, registerables } from 'chart.js';
import * as L from 'leaflet';
import * as echarts from 'echarts';
import {
  ASSESSMENT_PLAN_TABLE_COLUMNS,
  DATE,
  DIFFICULTY_LEVELS,
  LANGUAGES,
  QUESTION_CATEGORIES,
  QUESTION_STATUS,
  QUESTION_TYPES,
} from './dashboard.constants';
import { DashboardService } from './dashboard.service';
import { Router } from '@angular/router';
import { ExportService } from '@app/exportservice/export.service';
import { UtilService } from '@app/shared/services/util.service';
import { MatDialog } from '@angular/material/dialog';
import { CourseService } from '@app/content/courses/courses.service';
import { AdminService } from '@app/admin/admin.service';
import { GetAllService } from '@app/shared/table/getAll.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import autoTable from 'jspdf-autotable'; // Import autoTable separately

import html2canvas from 'html2canvas';
import { SocketService } from '../socket.service';
import { TourService } from '../services/tour.service';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';

@Component({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, RouterModule],
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css', './dashboard-leaflet.css']
})
export class DashboardComponent implements OnInit, AfterViewInit {
  private socketSub: any = null;

  rolesData: { date: string, count: number }[] = [];
  categoriesData: { date: string, count: number }[] = [];
  usersData: { date: string, count: number }[] = [];
  candidatesData: { date: string, count: number }[] = [];
  assessmentsData: { date: string, count: number }[] = [];

  // All Product Data
  allProductData: any[] = [];

  // Assessment Summary Properties
  totalAssessments: number = 0;
  totalCandidates: number = 0;
  totalPlannedAssessments: number = 0;
  totalExecutedAssessments: number = 0;
  totalEvaluatedAssessments: number = 0;
  totalPublishedAssessments: number = 0;
  currentMonthPlannedAssessments: number = 0;
  nextMonthPlannedAssessments: number = 0;
  lastMonthPlannedAssessments: number = 0;
  assessmentStatusSummary: {
    active: number;
    inactive: number;
    deleted: number;
    publish: number;
    draft: number;
  } = {
      active: 0,
      inactive: 0,
      deleted: 0,
      publish: 0,
      draft: 0
    };
  candidateStatusSummary: {
    active: number;
    inactive: number;
    deleted: number;
  } = {
      active: 0,
      inactive: 0,
      deleted: 0
    };
  evaluationStatusSummary: {
    completed: number;
    pending: number;
  } = {
      completed: 0,
      pending: 0
    };
  // Candidate Insights Properties
  totalAttempts: number = 0;
  totalPassCandidates: number = 0;
  totalFailCandidates: number = 0;
  totalReassessedCandidates: number = 0;
  currentMonthReassessed: number = 0;
  lastMonthReassessed: number = 0;
  showCandidateInsightsDonutChart: boolean = false;
  candidateInsightsDonutChart: Chart;

  showQuestionPaperInsightsDonutChart: boolean = false;
  questionPaperInsightsDonutChart: Chart;

  // Assessment Chart Properties - Location Chart
  showAssessmentLocationChart: boolean = false;
  assessmentLocationChartData: any[] = [];
  assessmentLocationChart: Chart;
  selectedAssessmentLocationYearRange: string = this.getDefaultYearRange();
  selectedAssessmentLocationMonth: number = new Date().getMonth() + 1;
  showAssessmentLocationYearDropdown: boolean = false;
  showAssessmentLocationMonthDropdown: boolean = false;
  showAssessmentLocationFilterPanel: boolean = false;
  showAssessmentLocationChartMenu: boolean = false;
  showAssessmentLocationTableModalFlag: boolean = false;
  showAssessmentLocationCompareDialog: boolean = false;
  showAssessmentLocationTableModal: boolean = false;
  selectedAssessmentLocationCompareMonth1: number | null = null;
  selectedAssessmentLocationCompareMonth2: number | null = null;
  showAssessmentLocationCompareMonth1Dropdown: boolean = false;
  showAssessmentLocationCompareMonth2Dropdown: boolean = false;
  showAssessmentLocationComparisonResults: boolean = false;
  currentAssessmentLocationComparisonData: any[] = [];
  compareAssessmentLocationComparisonData: any[] = [];
  assessmentLocationComparisonChart: Chart;
  activeAssessmentLocationFilterHeader: string = 'locations';
  selectedAssessmentLocationFilterValues: any[] = [];
  assessmentLocationSearchTerm: string = '';
  filteredAssessmentLocationList: any[] = [];
  allAssessmentLocations: any[] = [];
  showCandidatePerformanceCompareDialog: boolean = false;
  selectedCandidatePerformanceCompareMonth1: number | null = null;
  selectedCandidatePerformanceCompareMonth2: number | null = null;
  showCandidatePerformanceCompareMonth1Dropdown: boolean = false;
  showCandidatePerformanceCompareMonth2Dropdown: boolean = false;
  showCandidatePerformanceComparisonResults: boolean = false;
  currentCandidatePerformanceComparisonData: any[] = [];
  compareCandidatePerformanceComparisonData: any[] = [];
  candidatePerformanceComparisonChart: Chart | null = null;

  selectedCandidatePerformanceYearRange: string = this.getDefaultYearRange();
  selectedCandidatePerformanceMonth: number = new Date().getMonth() + 1;
  showCandidatePerformanceYearDropdown: boolean = false;
  showCandidatePerformanceMonthDropdown: boolean = false;
  // Assessment Chart Properties - Course Chart
  showAssessmentCourseChart: boolean = false;
  assessmentCourseChartData: any[] = [];
  assessmentCourseChart: Chart;
  selectedAssessmentCourseYearRange: string = this.getDefaultYearRange();
  selectedAssessmentCourseMonth: number = new Date().getMonth() + 1;
  showAssessmentCourseYearDropdown: boolean = false;
  showAssessmentCourseMonthDropdown: boolean = false;
  showAssessmentCourseFilterPanel: boolean = false;
  showAssessmentCourseChartMenu: boolean = false;
  showAssessmentCourseTableModalFlag: boolean = false;
  showAssessmentCourseCompareDialog: boolean = false;
  showAssessmentCourseTableModal: boolean = false;
  selectedAssessmentCourseCompareMonth1: number | null = null;
  selectedAssessmentCourseCompareMonth2: number | null = null;
  showAssessmentCourseCompareMonth1Dropdown: boolean = false;
  showAssessmentCourseCompareMonth2Dropdown: boolean = false;
  showAssessmentCourseComparisonResults: boolean = false;
  currentAssessmentCourseComparisonData: any[] = [];
  compareAssessmentCourseComparisonData: any[] = [];
  assessmentCourseComparisonChart: Chart;
  activeAssessmentCourseFilterHeader: string = 'course';
  selectedAssessmentCourseFilterValues: any[] = [];
  assessmentCourseSearchTerm: string = '';
  assessmentCourseGeographySearchTerm: string = '';
  assessmentCourseCustomerSearchTerm: string = '';
  assessmentCourseLanguageSearchTerm: string = '';
  filteredAssessmentCourseList: any[] = [];
  filteredAssessmentCourseGeographyList: any[] = [];
  filteredAssessmentCourseCustomerList: any[] = [];
  filteredAssessmentCourseLanguageList: any[] = [];
  selectedAssessmentCourseGeographyValues: any[] = [];
  selectedAssessmentCourseCustomerValues: any[] = [];
  selectedAssessmentCourseLanguageValues: any[] = [];
  allAssessmentCourses: any[] = [];

  // Assessment Chart Properties - Status Chart
  showAssessmentStatusChart: boolean = false;
  assessmentStatusChartData: any[] = [];
  assessmentStatusChart: Chart;
  selectedAssessmentStatusYearRange: string = this.getDefaultYearRange();
  selectedAssessmentStatusMonth: number = new Date().getMonth() + 1;
  showAssessmentStatusYearDropdown: boolean = false;
  showAssessmentStatusMonthDropdown: boolean = false;
  showAssessmentStatusFilterPanel: boolean = false;
  showAssessmentStatusChartMenu: boolean = false;
  showAssessmentStatusCompareDialog: boolean = false;
  selectedAssessmentStatusCompareMonth1: number | null = null;
  selectedAssessmentStatusCompareMonth2: number | null = null;
  showAssessmentStatusCompareMonth1Dropdown: boolean = false;
  showAssessmentStatusCompareMonth2Dropdown: boolean = false;
  showAssessmentStatusComparisonResults: boolean = false;
  currentAssessmentStatusComparisonData: any[] = [];
  compareAssessmentStatusComparisonData: any[] = [];
  assessmentStatusComparisonChart: Chart | null = null;
  showAssessmentStatusTableModal: boolean = false;
  activeAssessmentStatusFilterHeader: string = 'status';
  assessmentStatusSearchTerm: string = '';
  filteredAssessmentStatusList: any[] = [];
  allAssessmentStatuses: any[] = [];
  selectedAssessmentStatusFilterValues: any[] = [];
  filteredAssessmentPublishList: any[] = [];
  allAssessmentPublishStatuses: any[] = [];
  assessmentPublishSearchTerm: string = '';
  selectedAssessmentPublishFilterValues: any[] = [];

  // Assessment Chart Properties - Evaluation Status Chart
  showAssessmentEvaluationChart: boolean = false;
  assessmentEvaluationChartData: any[] = [];
  assessmentEvaluationChart: Chart;
  selectedAssessmentEvaluationYearRange: string = this.getDefaultYearRange();
  selectedAssessmentEvaluationMonth: number = new Date().getMonth() + 1;
  showAssessmentEvaluationYearDropdown: boolean = false;
  showAssessmentEvaluationMonthDropdown: boolean = false;
  showAssessmentEvaluationFilterPanel: boolean = false;
  showAssessmentEvaluationChartMenu: boolean = false;
  showAssessmentEvaluationCompareDialog: boolean = false;
  showAssessmentEvaluationTableModal: boolean = false;
  selectedAssessmentEvaluationCompareMonth1: number | null = null;
  selectedAssessmentEvaluationCompareMonth2: number | null = null;
  showAssessmentEvaluationCompareMonth1Dropdown: boolean = false;
  showAssessmentEvaluationCompareMonth2Dropdown: boolean = false;
  showAssessmentEvaluationComparisonResults: boolean = false;
  currentAssessmentEvaluationComparisonData: any[] = [];
  compareAssessmentEvaluationComparisonData: any[] = [];
  assessmentEvaluationComparisonChart: Chart | null = null;
  activeAssessmentEvaluationFilterHeader: string = 'course';
  assessmentEvaluationSearchTerm: string = '';
  assessmentEvaluationCourseSearchTerm: string = '';
  assessmentEvaluationGeographySearchTerm: string = '';
  assessmentEvaluationLanguageSearchTerm: string = '';
  assessmentEvaluationCustomerSearchTerm: string = '';
  filteredAssessmentEvaluationList: any[] = [];
  filteredAssessmentEvaluationCourseList: any[] = [];
  filteredAssessmentEvaluationGeographyList: any[] = [];
  filteredAssessmentEvaluationLanguageList: any[] = [];
  filteredAssessmentEvaluationCustomerList: any[] = [];
  allAssessmentEvaluations: any[] = [];
  selectedAssessmentEvaluationFilterValues: any[] = [];
  selectedAssessmentEvaluationCourseValues: string[] = [];
  selectedAssessmentEvaluationGeographyValues: string[] = [];
  selectedAssessmentEvaluationLanguageValues: string[] = [];
  selectedAssessmentEvaluationCustomerValues: string[] = [];

  // Assessment Chart Properties - Candidate Distribution by Assessment Chart
  showCandidateAssessmentChart: boolean = false;
  candidateAssessmentChartData: any[] = [];
  candidateAssessmentChart: Chart;
  selectedCandidateAssessmentYearRange: string = this.getDefaultYearRange();
  selectedCandidateAssessmentMonth: number = new Date().getMonth() + 1;
  showCandidateAssessmentYearDropdown: boolean = false;
  showCandidateAssessmentMonthDropdown: boolean = false;
  showCandidateAssessmentFilterPanel: boolean = false;
  showCandidateAssessmentChartMenu: boolean = false;
  showCandidateAssessmentCompareDialog: boolean = false;
  showCandidateAssessmentTableModal: boolean = false;
  selectedCandidateAssessmentCompareMonth1: number | null = null;
  selectedCandidateAssessmentCompareMonth2: number | null = null;
  showCandidateAssessmentCompareMonth1Dropdown: boolean = false;
  showCandidateAssessmentCompareMonth2Dropdown: boolean = false;
  showCandidateAssessmentComparisonResults: boolean = false;
  currentCandidateAssessmentComparisonData: any[] = [];
  compareCandidateAssessmentComparisonData: any[] = [];
  candidateAssessmentComparisonChart: Chart;
  activeCandidateAssessmentFilterHeader: string = 'assessment';
  candidateAssessmentSearchTerm: string = '';
  filteredCandidateAssessmentList: any[] = [];
  allCandidateAssessments: any[] = [];
  selectedCandidateAssessmentFilterValues: any[] = [];
  allAssessmentsForCandidateChart: any[] = [];

  // Candidate Data by Performance Chart Properties
  candidatePerformanceChartLabels: string[] = [];
  candidatePerformancePassData: number[] = [];
  candidatePerformanceFailData: number[] = [];
  candidatePerformanceTotalCandidateCounts: number[] = [];
  candidatePerformanceChart: Chart;
  candidatePerformanceSelectedToggle: string = 'pass';
  showCandidatePerformanceChart: boolean = false;
  candidatePerformanceRawData: any[] = [];
  hoveredCandidatePerformanceIndex: number | null = null;

  // Candidate Data by Performance Filter Properties
  showCandidatePerformanceFilterPanel: boolean = false;
  activeCandidatePerformanceFilterHeader: string = 'courses';
  candidatePerformanceFilterHeaders = [
    { key: 'courses', name: 'Courses' },
    { key: 'geography', name: 'Geography' },
    { key: 'customers', name: 'Customers' },
    { key: 'languages', name: 'Languages' }
  ];
  candidatePerformanceCourseSearchTerm: string = '';
  filteredCandidatePerformanceCourseApiList: any[] = [];
  selectedCandidatePerformanceCourseValues: any[] = [];
  candidatePerformanceGeographySearchTerm: string = '';
  filteredCandidatePerformanceGeographyList: any[] = [];
  selectedCandidatePerformanceGeographyValues: any[] = [];
  allCandidatePerformanceGeographies: any[] = [];
  candidatePerformanceCustomerSearchTerm: string = '';
  filteredCandidatePerformanceCustomerApiList: any[] = [];
  selectedCandidatePerformanceCustomerValues: any[] = [];
  candidatePerformanceLanguageSearchTerm: string = '';
  filteredCandidatePerformanceLanguageList: any[] = [];
  selectedCandidatePerformanceLanguageValues: any[] = [];

  // Assessment by Customers Chart Properties
  showAssessmentCustomerChart: boolean = false;
  assessmentCustomerChartDataLoaded: boolean = false; // Track if chart has been loaded at least once
  assessmentCustomerChartData: any[] = [];
  assessmentCustomerChart: Chart;
  canShowAssessmentCustomerChart: boolean = false; // user access control for customer chart
  selectedAssessmentCustomerYearRange: string = this.getDefaultYearRange();
  selectedAssessmentCustomerMonth: number = new Date().getMonth() + 1;
  showAssessmentCustomerYearDropdown: boolean = false;
  showAssessmentCustomerMonthDropdown: boolean = false;
  showAssessmentCustomerFilterPanel: boolean = false;
  showAssessmentCustomerChartMenu: boolean = false;
  showAssessmentCustomerTableModal: boolean = false;
  selectedAssessmentCustomerCompareMonth1: number | null = null;
  selectedAssessmentCustomerCompareMonth2: number | null = null;
  showAssessmentCustomerCompareMonth1Dropdown: boolean = false;
  showAssessmentCustomerCompareMonth2Dropdown: boolean = false;
  showAssessmentCustomerComparisonResults: boolean = false;
  currentAssessmentCustomerComparisonData: any[] = [];
  compareAssessmentCustomerComparisonData: any[] = [];
  assessmentCustomerComparisonChart: Chart | null = null;
  assessmentCustomerFilterHeaders = [
    { key: 'courses', name: 'Courses' },
    { key: 'customer', name: 'Customer' }
  ];
  activeAssessmentCustomerFilterHeader: string = 'courses';
  assessmentCustomerCourseSearchTerm: string = '';
  filteredAssessmentCustomerCourseApiList: any[] = [];
  selectedAssessmentCustomerCourseValues: string[] = [];

  assessmentCustomerCustomerSearchTerm: string = '';
  filteredAssessmentCustomerCustomerApiList: any[] = [];
  selectedAssessmentCustomerCustomerValues: string[] = [];
  showAssessmentCustomerCompareDialog: boolean = false;
  assessmentCustomerTrendSummary: any[] = [];
  activeAssessmentCustomerComparisonAccordion: string = 'summary';

  // Store raw customer data for comparison
  rawCustomerComparisonData: any[] = [];

  assessmentCustomerSearchTerm: string = '';
  filteredAssessmentCustomerList: any[] = [];
  allAssessmentCustomers: any[] = [];
  selectedAssessmentCustomerFilterValues: any[] = [];
  assessmentCustomerChartLabels: string[] = [];
  assessmentCustomerChartValues: number[] = [];

  // Assessment by Language Chart Properties
  showAssessmentLanguageChart: boolean = false;
  assessmentLanguageChartData: any[] = [];
  assessmentLanguageChart: Chart;
  selectedAssessmentLanguageYearRange: string = this.getDefaultYearRange();
  selectedAssessmentLanguageMonth: number = new Date().getMonth() + 1;
  showAssessmentLanguageYearDropdown: boolean = false;
  showAssessmentLanguageMonthDropdown: boolean = false;
  showAssessmentLanguageFilterPanel: boolean = false;
  showAssessmentLanguageChartMenu: boolean = false;
  showAssessmentLanguageTableModal: boolean = false;
  showAssessmentLanguageCompareDialog: boolean = false;
  selectedAssessmentLanguageCompareMonth1: number | null = null;
  selectedAssessmentLanguageCompareMonth2: number | null = null;
  showAssessmentLanguageCompareMonth1Dropdown: boolean = false;
  showAssessmentLanguageCompareMonth2Dropdown: boolean = false;
  showAssessmentLanguageComparisonResults: boolean = false;
  currentAssessmentLanguageComparisonData: any[] = [];
  compareAssessmentLanguageComparisonData: any[] = [];
  assessmentLanguageComparisonChart: Chart | any;
  showAssessmentLanguageDownloadSubMenu: boolean = false;
  assessmentLanguageChartLabels: string[] = [];
  assessmentLanguageChartValues: number[] = [];
  activeAssessmentLanguageFilterHeader: string = 'course';
  assessmentLanguageFilterHeaders = [
    { key: 'course', name: 'Course' },
    { key: 'customer', name: 'Customer' },
    { key: 'language', name: 'Language' }
  ];
  selectedAssessmentLanguageCourseValues: string[] = [];
  selectedAssessmentLanguageCustomerValues: string[] = [];
  selectedAssessmentLanguageLanguageValues: string[] = [];
  selectedAssessmentLanguageFilterValues: string[] = [];


  // Assessment Insights Filter Properties
  showAssessmentInsightFilterPanel: boolean = false;
  assessmentInsightFilterSearchTerm: string = '';
  assessmentInsightLanguageSearchTerm: string = '';
  assessmentInsightCourseSearchTerm: string = '';
  assessmentInsightCustomerSearchTerm: string = '';
  assessmentInsightDifficultyTypeSearchTerm: string = '';
  filteredAssessmentInsightCourseList: any[] = [];
  filteredAssessmentInsightLanguagesList: any[] = [];
  filteredAssessmentInsightCourseApiList: any[] = [];
  filteredAssessmentInsightCustomerApiList: any[] = [];
  filteredAssessmentInsightDifficultyTypeList: string[] = [];
  assessmentInsightDifficultyTypeOptions: string[] = ['Theory', 'Practical', 'Viva'];
  allAssessmentInsightCourses: any[] = [];
  selectedAssessmentInsightCourseValues: any[] = [];
  selectedAssessmentInsightLanguageValues: any[] = [];
  selectedAssessmentInsightCustomerValues: any[] = []; // For customer filtering in Assessment Insights
  selectedAssessmentInsightDifficultyValues: any[] = []; // For difficulty filtering in Assessment Insights
  activeAssessmentInsightFilterHeader: string = 'courses';
  assessmentInsightFilterHeaders = [
    { key: 'courses', name: 'Course' },
    { key: 'customer', name: 'Customers' }
  ];

  // Candidate Insights Filter Properties
  showCandidateInsightFilterPanel: boolean = false;
  candidateInsightFilterSearchTerm: string = '';
  candidateInsightCourseSearchTerm: string = '';
  candidateInsightCustomerSearchTerm: string = '';
  filteredCandidateInsightCourseList: any[] = [];
  filteredCandidateInsightCourseApiList: any[] = [];
  filteredCandidateInsightCustomerApiList: any[] = [];
  allCandidateInsightCourses: any[] = [];
  filteredCandidateInsightGeographyList: any[] = [];
  allCandidateInsightGeographies: any[] = [];
  selectedCandidateInsightCourseValues: any[] = [];
  selectedCandidateInsightGeographyValues: any[] = [];
  selectedCandidateInsightCustomerValues: any[] = [];
  selectedCandidateInsightYearRange: string = this.getDefaultYearRange();
  selectedCandidateInsightMonth: number | null = null;
  showCandidateInsightYearDropdown: boolean = false;
  showCandidateInsightMonthDropdown: boolean = false;
  activeCandidateInsightFilterHeader: string = 'courses';
  candidateInsightFilterHeaders = [
    { key: 'geography', name: 'Geography' },
    { key: 'courses', name: 'Course' },
    { key: 'customer', name: 'Customers' },
    { key: 'date', name: 'Date' }
  ];

  // Question Paper Insights Filter Properties
  showQuestionPaperInsightFilterPanel: boolean = false;
  showQuestionPaperInsightFilterPanels: boolean = false;
  questionPaperInsightFilterSearchTerm: string = '';
  questionPaperInsightCourseSearchTerm: string = '';
  questionPaperInsightCustomerSearchTerm: string = '';
  filteredQuestionPaperInsightCourseList: any[] = [];
  filteredQuestionPaperInsightCourseApiList: any[] = [];
  filteredQuestionPaperInsightCustomerApiList: any[] = [];
  allQuestionPaperInsightCourses: any[] = [];
  filteredQuestionPaperInsightGeographyList: any[] = [];
  allQuestionPaperInsightGeographies: any[] = [];
  selectedQuestionPaperInsightCourseValues: any[] = [];
  selectedQuestionPaperInsightGeographyValues: any[] = [];
  selectedQuestionPaperInsightCustomerValues: any[] = [];
  filteredQuestionPaperInsightCounts: any[] = [];
  selectedQuestionPaperInsightYearRange: string = this.getDefaultYearRange();
  selectedQuestionPaperInsightMonth: number | null = null;
  showQuestionPaperInsightYearDropdown: boolean = false;
  showQuestionPaperInsightMonthDropdown: boolean = false;
  activeQuestionPaperInsightFilterHeader: string = 'courses';
  questionPaperInsightFilterHeaders = [
    { key: 'courses', name: 'Course' },
  ];

  // Geographic Insights Filter Properties
  showGeographicInsightFilterPanel: boolean = false;
  geographicInsightFilterSearchTerm: string = '';
  geographicInsightCourseSearchTerm: string = '';
  geographicInsightCustomerSearchTerm: string = '';
  filteredGeographicInsightCourseApiList: any[] = [];
  filteredGeographicInsightCustomerApiList: any[] = [];
  filteredGeographicInsightGeographyList: any[] = [];
  allGeographicInsightGeographies: any[] = [];
  selectedGeographicInsightCourseValues: any[] = [];
  selectedGeographicInsightGeographyValues: any[] = [];
  selectedGeographicInsightCustomerValues: any[] = [];
  selectedGeographicInsightYearRange: string = this.getDefaultYearRange();
  selectedGeographicInsightMonth: number | null = null;
  showGeographicInsightYearDropdown: boolean = false;
  showGeographicInsightMonthDropdown: boolean = false;
  activeGeographicInsightFilterHeader: string = 'courses';
  geographicInsightFilterHeaders = [
    { key: 'courses', name: 'Course' },
    { key: 'geography', name: 'Geography' },
    { key: 'customer', name: 'Customer' }
  ];

  // Store raw assessment data with state-wise information for geography filtering
  rawAssessmentDataWithStateInfo: any[] = [];
  
  // Store assessment details for customer filtering
  rawAssessmentDetails: any[] = [];
  rawTop5CustomersByAssessment: any[] | null = null;
  
  // Store assessment_wise for language filtering
  rawAssessmentWise: any[] = [];
  languageStatsData: any[] = [];
  assessmentWiseStats: any[] = [];
  
  // Store original candidate insight counts for reset
  originalTotalPassCandidates: number = 0;
  originalTotalFailCandidates: number = 0;
  originalTotalReassessedCandidates: number = 0;
  originalTotalAttempts: number = 0;

  // Assessment Chart Properties - Pass/Fail by Assessment Chart
  showPassFailChart: boolean = false;
  passFailChartData: any[] = [];
  passFailChart: Chart;
  rawPassFailAssessmentWise: any[] = []; // Store raw assessment_wise data for filtering
  showPassFailStateWiseView: boolean = false; // Track if showing state-wise data
  selectedPassFailYearRange: string = this.getDefaultYearRange();
  selectedPassFailMonth: number = new Date().getMonth() + 1;
  showPassFailYearDropdown: boolean = false;
  showPassFailMonthDropdown: boolean = false;
  showPassFailFilterPanel: boolean = false;
  showPassFailChartMenu: boolean = false;
  showPassFailCompareDialog: boolean = false;
  showPassFailTableModal: boolean = false;
  selectedPassFailCompareMonth1: number | null = null;
  selectedPassFailCompareMonth2: number | null = null;
  showPassFailCompareMonth1Dropdown: boolean = false;
  showPassFailCompareMonth2Dropdown: boolean = false;
  showPassFailComparisonResults: boolean = false;
  currentPassFailComparisonData: any[] = [];
  comparePassFailComparisonData: any[] = [];
  passFailComparisonChart: Chart | null = null;
  activePassFailFilterHeader: string = 'course';
  passFailSearchTerm: string = '';
  passFailCourseSearchTerm: string = '';
  passFailGeographySearchTerm: string = '';
  passFailCustomerSearchTerm: string = '';
  passFailLanguageSearchTerm: string = '';
  filteredPassFailAssessmentList: any[] = [];
  filteredPassFailCourseList: any[] = [];
  filteredPassFailGeographyList: any[] = [];
  filteredPassFailCustomerList: any[] = [];
  filteredPassFailLanguageList: any[] = [];
  allPassFailAssessments: any[] = [];
  allPassFailCourses: any[] = [];
  allPassFailGeographies: any[] = [];
  allPassFailCustomers: any[] = [];
  allPassFailLanguages: any[] = [];
  selectedPassFailCourses: any[] = [];
  selectedPassFailGeographies: any[] = [];
  selectedPassFailCustomers: any[] = [];
  selectedPassFailLanguages: any[] = [];
  passFailChartLabels: string[] = [];
  passFailPassData: number[] = [];
  passFailFailData: number[] = [];
  passFailReassessedData: number[] = [];

  // Geographic Insights (India Map) Properties
  showGeographicInsightsChart: boolean = false;
  geographicInsightsData: any[] = [];
  selectedGeographicInsightsFilter: string = 'candidates';
  geographicInsightsChart: any = null;
  indiaMap: L.Map | null = null;
  indiaMapLayers: L.GeoJSON | null = null;
  whiteOverlayLayers: L.Layer[] = [];
  geographicZoomLevel: number = 100;

  // Assessment Filter Headers
  assessmentLocationFilterHeaders = [
    { key: 'locations', name: 'Locations' }
  ];
  assessmentCourseFilterHeaders = [
    { key: 'course', name: 'Course' },
    { key: 'geography', name: 'Geography' },
    { key: 'customer', name: 'Customer' },
    { key: 'language', name: 'Language' }
  ];
  assessmentStatusFilterHeaders = [
    { key: 'status', name: 'Status' },
    { key: 'publish', name: 'Publish Status' }
  ];
  assessmentEvaluationFilterHeaders = [
    { key: 'course', name: 'Course' },
    { key: 'geography', name: 'Geography' }
  ];
  candidateAssessmentFilterHeaders = [
    { key: 'assessment', name: 'Assessments' }
  ];
  passFailFilterHeaders = [
    { key: 'course', name: 'Course' },
    { key: 'customer', name: 'Customer' },
  ];

  violationsData: { name: string, data: any }[] = [
    { name: 'Violation Count', data: [0] }
  ];
  leadsData: { date: string, count: number }[] = [];
  customersData: any[] = []; // For storing sales customer counts or summary data
  customerMasterData: any[] = []; // For storing customer master list used in filters
  geographyData: any[] = []; // For storing geography states and districts
  languagesData: any[] = []; // For storing language master data
  leadCustomerData: { name: string, data: any }[] = [
    { name: 'Leads', data: [0] },
    { name: 'Customers', data: [0] }
  ];
  coursesData: { date: string, count: number }[] = [];
  questionBanksData: { date: string, count: number }[] = [];
  questionsData: { name: string, data: any }[] = [
    { name: 'Current Question Count', data: [0, 0, 0] },
    { name: 'Previous Question Count', data: [0, 0, 0] }
  ];
  showYearDropdown: boolean = false;
  showMonthDropdown: boolean = false;
  selectedYear: number = new Date().getFullYear();
  selectedMonth: number = new Date().getMonth() + 1; // 1-12 for January-December

  availableYears: number[] = [];
  availableMonths = DATE;

  billsData: { date: string, count: number }[] = [];
  invoicesData: { date: string, count: number }[] = [];
  collectedData: { date: string, count: number }[] = [];
  protected orgId: any;
  userOrgList: any = [];
  isSystemSuperAdmin: boolean = false;
  selectedUserOrg: any;
  
  // Custom Organization Dropdown Properties
  showOrgDropdown: boolean = false;
  orgSearchTerm: string = '';
  filteredOrgList: any[] = [];
  
  user_id: any;
  org_id: any;
  languageChartData: any[] = [];
  showLanguageBarChart: boolean = false;
  showLanguageDonutChart: boolean = false;
  showLanguageChart: boolean = false;
  languageSearchTerm: string = '';
  languageTypeSearchTerm: string = '';
  languageDifficultySearchTerm: string = '';
  languageEvaluationModeSearchTerm: string = '';
  filteredLanguageList: any[] = [];
  filteredLanguageTypeList: any[] = [];
  filteredLanguageDifficultyLevels: any[] = [];
  filteredLanguageEvaluationModesList: string[] = [];
  showLanguageFilterPanel: boolean = false;
  showLanguageChartMenu: boolean = false;
  showLanguageTableModalFlag: boolean = false;
  selectedLanguageYearRange: string = '';
  selectedLanguageMonth: number = new Date().getMonth() + 1;
  showLanguageYearDropdown: boolean = false;
  showLanguageMonthDropdown: boolean = false;
  activeLanguageFilterHeader: string = 'languages';
  selectedLanguages: string[] = [];
  selectedLanguageTypes: string[] = [];
  selectedLanguageDifficultyLevels: string[] = [];
  selectedLanguageEvaluationModes: string[] = [];
  languageTrendSummary: any[] = [];
  languageBarChartData: any[] = [];
  languageBarChartLabels: string[] = [];
  languageBarChartValues: number[] = [];
  languageBarChartColors: string[] = [];
  languageBarChart: Chart;
  evaluationModeChartData: any[] = [];

  // Difficulty Level Chart Filter Properties (Independent)
  showDifficultyFilterPanel: boolean = false;
  showDifficultyChartMenu: boolean = false;
  showDifficultyTableModalFlag: boolean = false;
  selectedDifficultyYearRange: string = '';
  selectedDifficultyMonth: number = new Date().getMonth() + 1;
  showDifficultyYearDropdown: boolean = false;
  showDifficultyMonthDropdown: boolean = false;
  showDifficultyDonutChart: boolean = false;
  difficultyChartData: any[] = [];
  difficultyDonutChart: Chart;
  // Month-wise compare for Difficulty Level (Content Library)
  showDifficultyCompareDialog: boolean = false;
  selectedDifficultyCompareMonth1: number | null = null;
  selectedDifficultyCompareMonth2: number | null = null;
  showDifficultyCompareMonth1Dropdown: boolean = false;
  showDifficultyCompareMonth2Dropdown: boolean = false;
  showDifficultyComparisonResults: boolean = false;
  currentDifficultyComparisonData: any[] = [];
  compareDifficultyComparisonData: any[] = [];
  difficultyComparisonChart: Chart | null = null;
  difficultyTrendSummary: any[] = [];
  // --- Difficulty Level Compare Dialog Methods (Content Library) ---
  openDifficultyCompareDialog(): void {
    this.showDifficultyCompareDialog = true;
    this.showDifficultyComparisonResults = false;
    this.selectedDifficultyCompareMonth1 = null;
    this.selectedDifficultyCompareMonth2 = null;
  }

  closeDifficultyCompareDialog(): void {
    this.showDifficultyCompareDialog = false;
    this.showDifficultyComparisonResults = false;
    this.currentDifficultyComparisonData = [];
    this.compareDifficultyComparisonData = [];
  }

  toggleDifficultyCompareMonth1Dropdown(): void {
    this.showDifficultyCompareMonth1Dropdown = !this.showDifficultyCompareMonth1Dropdown;
    if (this.showDifficultyCompareMonth1Dropdown) {
      this.showDifficultyCompareMonth2Dropdown = false;
    }
  }

  selectDifficultyCompareMonth1(month: number): void {
    this.selectedDifficultyCompareMonth1 = month;
    this.showDifficultyCompareMonth1Dropdown = false;
  }

  toggleDifficultyCompareMonth2Dropdown(): void {
    this.showDifficultyCompareMonth2Dropdown = !this.showDifficultyCompareMonth2Dropdown;
    if (this.showDifficultyCompareMonth2Dropdown) {
      this.showDifficultyCompareMonth1Dropdown = false;
    }
  }

  selectDifficultyCompareMonth2(month: number): void {
    this.selectedDifficultyCompareMonth2 = month;
    this.showDifficultyCompareMonth2Dropdown = false;
  }

  loadDifficultyComparisonData(): void {
    if (!this.selectedDifficultyCompareMonth1 || !this.selectedDifficultyCompareMonth2) {
      return;
    }
    this.isLoading = true;
    this.showDifficultyComparisonResults = true;
    this.fetchDifficultyComparisonData();
  }

  private fetchDifficultyComparisonData(): void {
    const currentYear = new Date().getFullYear();
    // For Month 1
    const month1 = this.selectedDifficultyCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);
    // For Month 2
    const month2 = this.selectedDifficultyCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);
    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');
    // Fetch Month 1 data
    const resp1 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });
    // Fetch Month 2 data
    const resp2 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });
    let month1Data: any[] = [];
    let month2Data: any[] = [];
    let completedRequests = 0;
    resp1.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month1Data = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processDifficultyComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.processDifficultyComparisonDataMonthWise(month1Data, month2Data);
        }
      }
    );
    resp2.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month2Data = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processDifficultyComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.processDifficultyComparisonDataMonthWise(month1Data, month2Data);
        }
      }
    );
    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    }, 2000);
  }

  private processDifficultyComparisonDataMonthWise(month1Data: any[], month2Data: any[]): void {
    const isValid = (item: any): boolean => {
      const count = item?.question_count ?? 0;
      return item && item.difficulty_level && typeof count === 'number' && count > 0;
    };
    const validMonth1 = month1Data.filter(isValid);
    const validMonth2 = month2Data.filter(isValid);
    this.currentDifficultyComparisonData = validMonth1.map((item: any) => ({
      name: item.difficulty_level || 'Unknown',
      value: item.question_count || 0,
      percentage: 0,
    }));
    const month1Total = this.currentDifficultyComparisonData.reduce((sum, item) => sum + item.value, 0);
    this.currentDifficultyComparisonData = this.currentDifficultyComparisonData.map(item => ({
      ...item,
      percentage: month1Total > 0 ? Math.round((item.value / month1Total) * 100) : 0,
    }));
    this.compareDifficultyComparisonData = validMonth2.map((item: any) => ({
      name: item.difficulty_level || 'Unknown',
      value: item.question_count || 0,
      percentage: 0,
    }));
    const month2Total = this.compareDifficultyComparisonData.reduce((sum, item) => sum + item.value, 0);
    this.compareDifficultyComparisonData = this.compareDifficultyComparisonData.map(item => ({
      ...item,
      percentage: month2Total > 0 ? Math.round((item.value / month2Total) * 100) : 0,
    }));
    this.initializeDifficultyComparisonChart();
  }

  private initializeDifficultyComparisonChart(): void {
    const canvas = document.getElementById('difficultyComparisonChart') as HTMLCanvasElement;
    if (!canvas) return;
    if (!this.currentDifficultyComparisonData || this.currentDifficultyComparisonData.length === 0) return;
    const diffNames = [...new Set([
      ...this.currentDifficultyComparisonData.map(s => s.name),
      ...this.compareDifficultyComparisonData.map(s => s.name)
    ])];
    const month1Values = diffNames.map(name => {
      const item = this.currentDifficultyComparisonData.find(s => s.name === name);
      return item?.value || 0;
    });
    const month2Values = diffNames.map(name => {
      const item = this.compareDifficultyComparisonData.find(s => s.name === name);
      return item?.value || 0;
    });
    if (this.difficultyComparisonChart) {
      this.difficultyComparisonChart.destroy();
      this.difficultyComparisonChart = null;
    }
    const chartHeight = Math.max(diffNames.length * 40, 300);
    const container = canvas.parentElement as HTMLElement;
    if (container) {
      container.style.minHeight = chartHeight + 'px';
    }
    try {
      this.difficultyComparisonChart = new Chart(canvas, {
        type: 'bar',
        data: {
          labels: diffNames,
          datasets: [
            {
              label: `Month ${this.selectedDifficultyCompareMonth1}`,
              data: month1Values,
              backgroundColor: '#4CAF50',
              borderColor: '#45a049',
              borderWidth: 1,
              barThickness: 'flex',
              barPercentage: 0.7,
            },
            {
              label: `Month ${this.selectedDifficultyCompareMonth2}`,
              data: month2Values,
              backgroundColor: '#2196F3',
              borderColor: '#1976D2',
              borderWidth: 1,
              barThickness: 'flex',
              barPercentage: 0.7,
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: true },
            tooltip: { enabled: true }
          },
          scales: {
            y: { beginAtZero: true },
            x: {}
          }
        }
      });
    } catch (e) { }
  }

  showCategoryFilterPanel: boolean = false;
  showCategoryChartMenu: boolean = false;
  showCategoryTableModalFlag: boolean = false;
  selectedCategoryYearRange: string = '';
  selectedCategoryMonth: number = new Date().getMonth() + 1;
  showCategoryYearDropdown: boolean = false;
  showCategoryMonthDropdown: boolean = false;
  activeCategoryFilterHeader: string = 'categories';
  selectedCategories: string[] = [];
  selectedCategoryLanguages: string[] = [];
  selectedCategoryDifficultyLevels: string[] = [];
  selectedCategoryTypes: string[] = [];
  categorySearchTerm: string = '';
  categoryLanguageSearchTerm: string = '';
  categoryDifficultySearchTerm: string = '';
  categoryTypeSearchTerm: string = '';
  categoryCourseSearchTerm: string = '';
  filteredCategoryList: any[] = [];
  filteredCategoryLanguageList: any[] = [];
  filteredCategoryDifficultyList: any[] = [];
  filteredCategoryTypeList: any[] = [];
  filteredCategoryCourseList: any[] = [];
  showCategoryPieChart: boolean = false;
  categoryChartData: any[] = [];
  categoryBarChartData: any[] = [];
  showCategoryBarChart: boolean = false;
  categoryPieChart: Chart;
  categoryBarChart: Chart;
  languageFilterHeaders = [
    { key: 'courses', name: 'Courses' },
    { key: 'languages', name: 'Languages' },
    { key: 'questionTypes', name: 'Type' },
    { key: 'difficulty', name: 'Difficulty Level' },
    { key: 'evaluationMode', name: 'Evaluation Mode' }
  ];
  availableLanguageEvaluationModes: string[] = ['Theory', 'Practical', 'Viva'];
  availableLanguageDifficultyLevels = [
    { label: 'Easy', value: 'easy' },
    { label: 'Medium', value: 'medium' },
    { label: 'Hard', value: 'hard' }
  ];

  // Category Filter Headers
  categoryFilterHeaders = [
    { key: 'courses', name: 'Courses' },
    { key: 'difficulty', name: 'Difficulty Level' },
    { key: 'types', name: 'Type' },
    { key: 'categories', name: 'Categories' }
  ];

  // Available Categories
  availableCategories = QUESTION_CATEGORIES;

  selectedCategoryCourseIds: number[] = [];

  // New Chart Properties - Questions by Course/Job Role (Single Filter)
  showNewCourseBarChart: boolean = false;
  newCourseBarChartData: any[] = [];
  newCourseBarChart: Chart;
  selectedNewCourseYearRange: string = '';
  selectedNewCourseMonth: number = new Date().getMonth() + 1;
  showNewCourseYearDropdown: boolean = false;
  showNewCourseMonthDropdown: boolean = false;
  showNewCourseChartMenu: boolean = false;
  showNewCourseTableModalFlag: boolean = false;

  // New Course Filter Panel Properties
  showNewCourseFilterPanel: boolean = false;
  activeNewCourseFilterHeader: string = 'courses';
  newCourseFilterHeaders = [
    { key: 'courses', name: 'Courses' },
    { key: 'languages', name: 'Languages' },
    { key: 'questionTypes', name: 'Question Types' },
    { key: 'difficulty', name: 'Difficulty Level' },
    { key: 'categories', name: 'Categories' },
    { key: 'status', name: 'Status' }
  ];

  // Single filter selection - only one can be active at a time
  selectedNewCourseFilterType: string = 'courses';
  selectedNewCourseFilterValues: any[] = [];
  newCourseSearchTerm: string = '';
  filteredNewCourseList: any[] = [];

  // Compare Dialog Properties for New Course Chart
  showNewCourseCompareDialog: boolean = false;
  selectedNewCourseCompareMonth1: number | null = null;
  selectedNewCourseCompareMonth2: number | null = null;
  showNewCourseCompareMonth1Dropdown: boolean = false;
  showNewCourseCompareMonth2Dropdown: boolean = false;
  showNewCourseComparisonResults: boolean = false;
  currentNewCourseComparisonData: any[] = [];
  compareNewCourseComparisonData: any[] = [];
  newCourseTrendSummary: any[] = [];
  newCourseComparisonChart: Chart;
  activeNewCourseComparisonAccordion: string = 'summary'; // 'summary' or 'table'

  // Initialize New Course Data
  private initializeNewCourseData(): void {
    // Don't override - use the default set during initialization
    // this.selectedNewCourseYearRange = this.selectedYearRange;
    this.selectedNewCourseMonth = new Date().getMonth() + 1;

    // Initialize filtered list
    this.filteredNewCourseList = [...this.courseList];
  }

  // Prepare New Course Data with Single Filter Logic
  private prepareNewCourseData(courses: any[]): void {
    if (!courses || courses.length === 0) {
      this.newCourseBarChartData = [];
      this.showNewCourseBarChart = false;
      return;
    }

    // Reset data
    this.newCourseBarChartData = [];

    // If filter type is 'courses' and a course is selected, show Theory/Practical/Viva breakdown for that course
    if (this.selectedNewCourseFilterType === 'courses' && this.selectedNewCourseFilterValues.length === 1) {
      const selectedCourseId = this.selectedNewCourseFilterValues[0];
      const selectedCourse = courses.find(course => course.course_id === selectedCourseId);
      if (selectedCourse && selectedCourse.question_category_breakdown) {
        const breakdown = selectedCourse.question_category_breakdown;
        const evalModes = ['Theory', 'Practical', 'Viva'];
        const colors = ['#005068', '#C71E1D', '#A0A0FF'];
        let total = 0;
        evalModes.forEach((mode, idx) => {
          const val = breakdown[mode] || 0;
          total += val;
          this.newCourseBarChartData.push({
            name: mode,
            value: val,
            color: colors[idx],
            courseName: selectedCourse.course_name,
            courseId: selectedCourse.course_id,
            isTopCourse: true
          });
        });
        selectedCourse.question_count = total;
        this.showNewCourseBarChart = total > 0;
        return;
      }
    }

    // If filter type is 'languages' and a language is selected, aggregate Theory/Practical/Viva for that language across all courses
    if (this.selectedNewCourseFilterType === 'languages' && this.selectedNewCourseFilterValues.length === 1) {
      const selectedLanguage = this.selectedNewCourseFilterValues[0];
      let totalTheory = 0, totalPractical = 0, totalViva = 0;
      let courseName = '';
      let found = false;
      courses.forEach(course => {
        if (course.language_breakdown && course.language_breakdown[selectedLanguage]) {
          // Only consider courses that have this language
          courseName = course.course_name;
          found = true;
          // For this course, get the question_category_breakdown
          const breakdown = course.question_category_breakdown || {};
          totalTheory += breakdown['Theory'] || 0;
          totalPractical += breakdown['Practical'] || 0;
          totalViva += breakdown['Viva'] || 0;
        }
      });
      if (found) {
        const colors = ['#005068', '#C71E1D', '#A0A0FF'];
        this.newCourseBarChartData.push({
          name: 'Theory',
          value: totalTheory,
          color: colors[0],
          courseName,
          courseId: null,
          isTopCourse: true
        });
        this.newCourseBarChartData.push({
          name: 'Practical',
          value: totalPractical,
          color: colors[1],
          courseName,
          courseId: null,
          isTopCourse: true
        });
        this.newCourseBarChartData.push({
          name: 'Viva',
          value: totalViva,
          color: colors[2],
          courseName,
          courseId: null,
          isTopCourse: true
        });
        const total = totalTheory + totalPractical + totalViva;
        this.showNewCourseBarChart = total > 0;
        return;
      }
    }

    // Special handling for difficulty filter: show Theory/Practical/Viva by selected difficulty
    if (this.selectedNewCourseFilterType === 'difficulty' && this.selectedNewCourseFilterValues.length === 1) {
      console.log('[DEBUG] Difficulty filter detected:', this.selectedNewCourseFilterValues[0]);
      const selectedDifficulty = this.selectedNewCourseFilterValues[0];
      const evalModes = ['Theory', 'Practical', 'Viva'];
      const colors = ['#005068', '#C71E1D', '#A0A0FF'];
      let total = 0;
      this.newCourseBarChartData = [];
      evalModes.forEach((mode, idx) => {
        let modeTotal = 0;
        courses.forEach(course => {
          if (course.evaluation_mode_difficulty_breakdown && course.evaluation_mode_difficulty_breakdown[mode]) {
            const val = course.evaluation_mode_difficulty_breakdown[mode][selectedDifficulty] || 0;
            modeTotal += val;
          } else {
            // Debug: Log missing breakdown
            console.log('[DEBUG] Missing evaluation_mode_difficulty_breakdown for course:', course.course_name, 'mode:', mode, 'breakdown:', course.evaluation_mode_difficulty_breakdown);
          }
        });
        total += modeTotal;
        this.newCourseBarChartData.push({
          name: mode,
          value: modeTotal,
          color: colors[idx],
          courseName: mode,
          courseId: null,
          isTopCourse: true
        });
      });
      console.log('[DEBUG] newCourseBarChartData:', this.newCourseBarChartData);
      this.showNewCourseBarChart = total > 0;
      return;
    }

    // Default: show top 5 courses by question count
    let filteredCourses = this.applySingleFilter(courses);
    const validCourses = filteredCourses.filter(course =>
      course && course.course_name && (course.question_count > 0)
    );
    if (validCourses.length === 0) {
      this.newCourseBarChartData = [];
      this.showNewCourseBarChart = false;
      return;
    }
    const sortedCourses = [...validCourses].sort((a, b) =>
      (b.question_count || 0) - (a.question_count || 0)
    );
    const topCourses = sortedCourses.slice(0, 5);
    const otherCoursesTotal = sortedCourses.slice(5).reduce((sum, course) =>
      sum + (course.question_count || 0), 0
    );
    const courseColors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#F67280' // Color for "Others"
    ];
    topCourses.forEach((course, index) => {
      const truncatedName = this.truncateCourseName(course.course_name, 15);
      this.newCourseBarChartData.push({
        name: truncatedName,
        originalName: course.course_name,
        value: course.question_count,
        color: courseColors[index % courseColors.length],
        courseName: course.course_name,
        courseId: course.course_id,
        isTopCourse: true
      });
    });
    if (otherCoursesTotal > 0) {
      this.newCourseBarChartData.push({
        name: 'Others',
        originalName: 'Other Courses',
        value: otherCoursesTotal,
        color: courseColors[5],
        courseName: 'Other Courses',
        courseId: null,
        isTopCourse: false
      });
    }

    this.showNewCourseBarChart = this.newCourseBarChartData.length > 0;

    if (this.showNewCourseBarChart) {
      setTimeout(() => {
        this.initializeNewCourseBarChart();
        // Also initialize the "All" view chart if in All view
        if (this.selectedViewType === 'all') {
          this.initializeCourseBarChartAll();
        }
      }, 100);
    }
  }

  // Apply Single Filter Logic - Only one filter can be active
  private applySingleFilter(courses: any[]): any[] {
    if (this.selectedNewCourseFilterValues.length === 0) {
      return courses; // No filter applied
    }

    const filterType = this.selectedNewCourseFilterType;
    const filterValues = this.selectedNewCourseFilterValues;

    switch (filterType) {
      case 'evaluationMode':
        return courses.map(course => {
          const filteredCourse = { ...course };
          const breakdown = filteredCourse.question_category_breakdown || {};
          
          let newTotalCount = 0;
          const filteredBreakdown = {};

          filterValues.forEach(mode => {
            if (breakdown[mode] !== undefined) {
              filteredBreakdown[mode] = breakdown[mode];
              newTotalCount += breakdown[mode];
            }
          });

          filteredCourse.question_category_breakdown = filteredBreakdown;
          filteredCourse.question_count = newTotalCount;
          
          return filteredCourse;
        }).filter(course => course.question_count > 0);

      case 'courses':
        return courses.filter(course =>
          filterValues.includes(course.course_id)
        );

      case 'languages':
        return courses.map(course => {
          const filteredCourse = { ...course };
          if (filteredCourse.language_breakdown) {
            const filteredBreakdown = {};
            filterValues.forEach(language => {
              if (filteredCourse.language_breakdown[language] !== undefined) {
                filteredBreakdown[language] = filteredCourse.language_breakdown[language];
              }
            });
            filteredCourse.language_breakdown = filteredBreakdown;
            filteredCourse.question_count = Object.values(filteredBreakdown)
              .reduce((sum: number, count: number) => sum + count, 0);
          }
          return filteredCourse;
        }).filter(course => course.question_count > 0);

      case 'questionTypes':
        return courses.map(course => {
          const filteredCourse = { ...course };
          if (filteredCourse.type_breakdown) {
            const filteredBreakdown = {};
            filterValues.forEach(type => {
              // Case-insensitive look up of matching breakdown keys (e.g., matching 'MCQ' with 'mcq')
              const matchingKey = Object.keys(filteredCourse.type_breakdown).find(
                key => key.toLowerCase() === type.toLowerCase()
              );
              if (matchingKey && filteredCourse.type_breakdown[matchingKey] !== undefined) {
                filteredBreakdown[matchingKey] = filteredCourse.type_breakdown[matchingKey];
              }
            });
            filteredCourse.type_breakdown = filteredBreakdown;
            filteredCourse.question_count = Object.values(filteredBreakdown)
              .reduce((sum: number, count: any) => sum + (Number(count) || 0), 0);
          }
          return filteredCourse;
        }).filter(course => course.question_count > 0);

      case 'difficulty':
        return courses.map(course => {
          const filteredCourse = { ...course };
          if (filteredCourse.difficulty_breakdown) {
            const filteredBreakdown = {};
            filterValues.forEach(difficulty => {
              const matchingKey = Object.keys(filteredCourse.difficulty_breakdown).find(
                key => key.toLowerCase() === difficulty.toLowerCase()
              );
              if (matchingKey && filteredCourse.difficulty_breakdown[matchingKey] !== undefined) {
                filteredBreakdown[matchingKey] = filteredCourse.difficulty_breakdown[matchingKey];
              }
            });
            filteredCourse.difficulty_breakdown = filteredBreakdown;
            filteredCourse.question_count = Object.values(filteredBreakdown)
              .reduce((sum: number, count: any) => sum + (Number(count) || 0), 0);
          }
          return filteredCourse;
        }).filter(course => course.question_count > 0);

      case 'categories':
        return courses.map(course => {
          const filteredCourse = { ...course };
          if (filteredCourse.question_category_breakdown) {
            const filteredBreakdown = {};
            filterValues.forEach(category => {
              const matchingKey = Object.keys(filteredCourse.question_category_breakdown).find(
                key => key.toLowerCase() === category.toLowerCase()
              );
              if (matchingKey && filteredCourse.question_category_breakdown[matchingKey] !== undefined) {
                filteredBreakdown[matchingKey] = filteredCourse.question_category_breakdown[matchingKey];
              }
            });
            filteredCourse.question_category_breakdown = filteredBreakdown;
            filteredCourse.question_count = Object.values(filteredBreakdown)
              .reduce((sum: number, count: any) => sum + (Number(count) || 0), 0);
          }
          return filteredCourse;
        }).filter(course => course.question_count > 0);

      case 'status':
        return courses.map(course => {
          const filteredCourse = { ...course };
          if (filteredCourse.status_breakdown) {
            const filteredBreakdown = {};
            filterValues.forEach(status => {
              const matchingKey = Object.keys(filteredCourse.status_breakdown).find(
                key => key.toLowerCase() === status.toLowerCase()
              );
              if (matchingKey && filteredCourse.status_breakdown[matchingKey] !== undefined) {
                filteredBreakdown[matchingKey] = filteredCourse.status_breakdown[matchingKey];
              }
            });
            filteredCourse.status_breakdown = filteredBreakdown;
            filteredCourse.question_count = Object.values(filteredBreakdown)
              .reduce((sum: number, count: any) => sum + (Number(count) || 0), 0);
          }
          return filteredCourse;
        }).filter(course => course.question_count > 0);

      default:
        return courses;
    }
  }

  // Initialize New Course Bar Chart
  private initializeNewCourseBarChart(): void {
    const canvas = document.getElementById('newCourseBarChart') as HTMLCanvasElement;

    if (!canvas) {
      const allCanvases = document.querySelectorAll('canvas');
      allCanvases.forEach((c, i) => {
      });
      return;
    }

    // Destroy existing chart if it exists
    if (this.newCourseBarChart) {
      this.newCourseBarChart.destroy();
    }

    // Filter out zero values
    const nonZeroData = this.newCourseBarChartData.filter(item => item.value > 0);

    if (nonZeroData.length === 0) {
      this.showNewCourseBarChart = false;

      // Clear canvas and show message
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = '#999';
        ctx.font = '16px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('No Course Data Available', canvas.width / 2, canvas.height / 2);
      }
      return;
    }

    this.showNewCourseBarChart = true;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      try {
        // Prepare chart data - use truncated names for labels
        const labels = nonZeroData.map(item => item.name);
        const data = nonZeroData.map(item => item.value);
        const backgroundColors = nonZeroData.map(item => item.color);

        this.newCourseBarChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: labels,
            datasets: [{
              label: 'Question Count',
              data: data,
              backgroundColor: backgroundColors,
              borderColor: backgroundColors.map(color => this.darkenColor(color, 20)),
              borderWidth: 1,
              borderRadius: 4,
              borderSkipped: false,
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  // Show full course name in tooltip
                  title: (context) => {
                    const index = context[0].dataIndex;
                    const item = nonZeroData[index];
                    return item.originalName || item.courseName || item.name;
                  },
                  label: (context) => {
                    const value = context.raw as number;
                    const total = data.reduce((sum, val) => sum + val, 0);
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                    return `Questions: ${value} (${percentage}%)`;
                  }
                }
              },
            },
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Number of Questions',
                  font: {
                    size: 12,
                    weight: 'bold'
                  }
                },
                grid: {
                  color: 'rgba(0,0,0,0.1)'
                },
                ticks: {
                  stepSize: 1,
                  precision: 0
                }
              },
              x: {
                title: {
                  display: true,
                  text: 'Courses/Job Roles',
                  font: {
                    size: 12,
                    weight: 'bold'
                  }
                },
                grid: {
                  display: false
                },
                ticks: {
                  autoSkip: true,
                  maxRotation: 45,
                  minRotation: 0,
                  // Ensure truncated labels are displayed properly
                  callback: function (value, index, values) {
                    const label = this.getLabelForValue(value as number);
                    return label; // Already truncated in prepareNewCourseData
                  }
                }
              }
            },
            layout: {
              padding: {
                top: 20,
                right: 10,
                bottom: 10,
                left: 10
              }
            },
            animation: {
              duration: 1000,
              easing: 'easeOutQuart'
            }
          }
        });

      } catch (error) {
        this.showNewCourseBarChart = false;
      }
    }
  }

  // Initialize Course Bar Chart for "All" View (Duplicate)
  private initializeCourseBarChartAll(): void {
    const canvas = document.getElementById('courseBarChartAll') as HTMLCanvasElement;

    if (!canvas) {
      return;
    }

    // Filter out zero values
    const nonZeroData = this.newCourseBarChartData.filter(item => item.value > 0);

    if (nonZeroData.length === 0) {
      return;
    }

    const ctx = canvas.getContext('2d');

    if (ctx) {
      try {
        // Prepare chart data
        const labels = nonZeroData.map(item => item.name);
        const data = nonZeroData.map(item => item.value);
        const backgroundColors = nonZeroData.map(item => item.color);

        const courseChartAll = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: labels,
            datasets: [{
              label: 'Questions Count',
              data: data,
              backgroundColor: backgroundColors,
              borderColor: '#555',
              borderWidth: 1,
              borderSkipped: false,
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  title: (context) => {
                    const index = context[0].dataIndex;
                    const item = nonZeroData[index];
                    return item.originalName || item.courseName || item.name;
                  },
                  label: (context) => {
                    const value = context.raw as number;
                    const total = data.reduce((sum, val) => sum + val, 0);
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                    return `Questions: ${value} (${percentage}%)`;
                  }
                }
              },
            },
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Number of Questions',
                  font: {
                    size: 12,
                    weight: 'bold'
                  }
                },
                grid: {
                  color: 'rgba(0,0,0,0.1)'
                },
                ticks: {
                  stepSize: 1,
                  precision: 0
                }
              },
              x: {
                title: {
                  display: true,
                  text: 'Courses/Job Roles',
                  font: {
                    size: 12,
                    weight: 'bold'
                  }
                },
                grid: {
                  display: false
                },
                ticks: {
                  autoSkip: true,
                  maxRotation: 45,
                  minRotation: 0
                }
              }
            }
          }
        });

      } catch (error) {
      }
    }
  }

  // Get percentage for new course chart
  getNewCoursePercentage(item: any): string {
    if (!item || !this.newCourseBarChartData || this.newCourseBarChartData.length === 0) {
      return '0';
    }

    const total = this.newCourseBarChartData.reduce((sum, dataItem) => {
      return sum + (dataItem?.value || 0);
    }, 0);

    return total > 0 ? (((item.value || 0) / total) * 100).toFixed(1) : '0';
  }

  // Dropdown Methods for New Course Chart
  toggleNewCourseYearDropdown(): void {
    this.showNewCourseYearDropdown = !this.showNewCourseYearDropdown;
    if (this.showNewCourseYearDropdown) {
      this.showNewCourseMonthDropdown = false;
    }
  }

  selectNewCourseYearRange(yearRange: string): void {
    this.selectedNewCourseYearRange = yearRange;
    this.showNewCourseYearDropdown = false;
    this.applyNewCourseMonthYearFilter();
  }

  toggleNewCourseMonthDropdown(): void {
    this.showNewCourseMonthDropdown = !this.showNewCourseMonthDropdown;
    if (this.showNewCourseMonthDropdown) {
      this.showNewCourseYearDropdown = false;
    }
  }

  selectNewCourseMonth(month: number): void {
    this.selectedNewCourseMonth = month;
    this.showNewCourseMonthDropdown = false;
    this.applyNewCourseMonthYearFilter();
  }

  applyNewCourseMonthYearFilter(): void {
    this.showNewCourseYearDropdown = false;
    this.showNewCourseMonthDropdown = false;
    this.fetchNewCourseFilteredData();
  }

  private fetchNewCourseFilteredData(): void {
    this.isLoading = true;

    let startDate: Date;
    let endDate: Date;

    if (this.selectedNewCourseMonth) {
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedNewCourseYearRange);
      if (yearRange) {
        const year = this.selectedNewCourseMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedNewCourseMonth - 1, 1);
        endDate = new Date(year, this.selectedNewCourseMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedNewCourseMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedNewCourseMonth, 0);
      }
    } else {
      const dateRange = this.getDateRangeFromYearRange(this.selectedNewCourseYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

    const resp = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          // Extract ONLY question counts - don't call processLibraryData() which updates ALL charts
          this.extractQuestionCountsFromResponse(response);
          // Prepare ONLY new course data - preserve independence of other charts
          this.prepareNewCourseData(this.questionCounts);
          this.prepareTop10CourseData(this.questionCounts);
          // Debug after data is prepared
          this.debugNewCourseChart();
          // Force Top 10 chart initialization for All view
          if (this.selectedViewType === 'all' && this.showTop10CourseBarChart) {
            setTimeout(() => {
              this.initializeTop10CourseBarChart();
            }, 100);
          }
        } else {
          this.newCourseBarChartData = [];
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      (error) => {
        this.newCourseBarChartData = [];
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  // Debug method for new course chart
  private debugNewCourseChart(): void {
  }

  // Filter Panel Methods for New Course Chart
  toggleNewCourseFilterPanel(): void {
    this.showNewCourseFilterPanel = !this.showNewCourseFilterPanel;

    if (this.showNewCourseFilterPanel) {
      this.showNewCourseChartMenu = false; // Close menu when opening filter
      this.filteredNewCourseList = [...this.courseList];
      this.activeNewCourseFilterHeader = this.selectedNewCourseFilterType;
      this.cdr.detectChanges();
    }
  }

  setActiveNewCourseFilterHeader(headerKey: string): void {
    this.activeNewCourseFilterHeader = headerKey;
    this.selectedNewCourseFilterType = headerKey;
    // Clear previous filter values when switching filter type
    this.selectedNewCourseFilterValues = [];
    this.newCourseSearchTerm = '';
  }

  // Single Filter Selection Methods
  isNewCourseFilterSelected(filterValue: any): boolean {
    return this.selectedNewCourseFilterValues.includes(filterValue);
  }

  toggleNewCourseFilterSelection(filterValue: any): void {
    // For single filter mode, we only allow one filter type at a time
    // But within that type, we can select multiple values
    const index = this.selectedNewCourseFilterValues.indexOf(filterValue);
    if (index > -1) {
      this.selectedNewCourseFilterValues.splice(index, 1);
    } else {
      this.selectedNewCourseFilterValues.push(filterValue);
    }
    // DEBUG: Log filter type and values
    console.log('[DEBUG] (toggleNewCourseFilterSelection) Filter type:', this.selectedNewCourseFilterType);
    console.log('[DEBUG] (toggleNewCourseFilterSelection) Filter values:', this.selectedNewCourseFilterValues);

    // If the active filter header is 'difficulty', ensure filter type is set
    if (this.activeNewCourseFilterHeader === 'difficulty') {
      this.selectedNewCourseFilterType = 'difficulty';
    }

    this.updateNewCourseFilteredData();
  }

  // Clear all filters for new course chart
  clearNewCourseFilters(): void {
    this.selectedNewCourseFilterValues = [];
    this.selectedNewCourseFilterType = 'courses';
    this.activeNewCourseFilterHeader = 'courses';
    this.updateNewCourseFilteredData();
  }

  // Get filter options based on current filter type
  getNewCourseFilterOptions(): any[] {
    switch (this.selectedNewCourseFilterType) {
      case 'courses':
        // Transform courseList to have name and count properties
        const courseList = this.filteredNewCourseList && this.filteredNewCourseList.length > 0 ? this.filteredNewCourseList : this.courseList;
        return courseList.map((course: any) => ({
          name: course.course_name || course.courseName || course.name || 'Unknown',
          count: course.question_count || 0,
          originalName: course.course_name || course.courseName || course.name,
          courseId: course.course_id || course.id
        }));
      case 'languages':
        return this.availableLanguages;
      case 'questionTypes':
        return this.availableQuestionTypes;
      case 'difficulty':
        return this.difficultyLevels;
      case 'categories':
        return this.availableCategories;
      case 'status':
        return this.availableStatus;
      default:
        return [];
    }
  }

  // Filter search for new course chart
  filterNewCourseOptions(): void {
    if (!this.newCourseSearchTerm.trim()) {
      this.filteredNewCourseList = [...this.courseList];
      return;
    }

    const searchTerm = this.newCourseSearchTerm.toLowerCase().trim();

    switch (this.selectedNewCourseFilterType) {
      case 'courses':
        this.filteredNewCourseList = this.courseList.filter(course =>
          course.course_name.toLowerCase().includes(searchTerm)
        );
        break;
      case 'languages':
        // Filter will be applied in the template
        break;
      case 'questionTypes':
        // Filter will be applied in the template
        break;
      case 'difficulty':
        // Filter will be applied in the template
        break;
      case 'categories':
        // Filter will be applied in the template
        break;
      case 'status':
        // Filter will be applied in the template
        break;
    }
  }

  // Update filtered data for new course chart
  updateNewCourseFilteredData(): void {
    this.prepareNewCourseData(this.questionCounts);
    this.cdr.detectChanges();
  }

  // Chart Menu Methods for New Course Chart
  toggleNewCourseChartMenu(): void {
    this.showNewCourseChartMenu = !this.showNewCourseChartMenu;
    if (this.showNewCourseChartMenu) {
      this.showNewCourseFilterPanel = false; // Close filter when opening menu
    }
  }

  closeNewCourseChartMenu(): void {
    this.showNewCourseChartMenu = false;
  }

  // Table Modal Methods for New Course Chart
  showNewCourseTableModal(): void {
    this.closeNewCourseChartMenu();
    this.showNewCourseTableModalFlag = true;
  }

  closeNewCourseTableModal(): void {
    this.showNewCourseTableModalFlag = false;
  }

  // Export Methods for New Course Chart
  exportNewCourseChartAsPDF(): void {
    this.closeNewCourseChartMenu();
    if (!this.ensureHasData(this.newCourseBarChartData)) { return; }
    if (this.newCourseBarChart) {
      const canvas = this.newCourseBarChart.canvas;
      const chartImage = canvas.toDataURL('image/png');

      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Add title
      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Questions by Course/Job Role (Single Filter) - Top 5 + Others', pageWidth / 2, 25, { align: 'center' });

      // Add source
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      pdf.text('Source: Content Library Analytics', pageWidth / 2, 32, { align: 'center' });

      // Add separator
      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      // Add chart image
      const imgProps = pdf.getImageProperties(chartImage);
      const chartWidth = pageWidth * 0.8;
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      const chartX = (pageWidth - chartWidth) / 2;
      const chartY = 45;

      pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

      // Add distribution summary
      const summaryStartY = chartY + chartHeight + 20;
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Distribution Summary', 20, summaryStartY);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      let currentY = summaryStartY + 15;
      const totalQuestions = this.newCourseBarChartData.reduce((sum, item) => sum + item.value, 0);

      this.newCourseBarChartData.forEach(item => {
        const percentage = this.getNewCoursePercentage(item);
        pdf.text(`${item.name}: ${item.value} (${percentage}%)`, 25, currentY);
        currentY += 5;
      });

      // Add filter information
      currentY += 10;
      pdf.setFont('helvetica', 'bold');
      pdf.text(`Total Questions: ${totalQuestions}`, 20, currentY);

      currentY += 8;
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'italic');

      // Add active filter info
      if (this.selectedNewCourseFilterValues.length > 0) {
        currentY += 4;
        const filterTypeName = this.newCourseFilterHeaders.find(f => f.key === this.selectedNewCourseFilterType)?.name || this.selectedNewCourseFilterType;
        pdf.text(`Active Filter: ${filterTypeName} (${this.selectedNewCourseFilterValues.length} selected)`, 20, currentY);
      }

      let dateRangeText = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateRangeText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
      }
      pdf.text(dateRangeText, 20, currentY);

      // Add footer
      const footerY = pageHeight - 10;
      pdf.setFontSize(8);
      pdf.setFont('helvetica', 'normal');
      pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth / 2, footerY, { align: 'center' });

      pdf.save('questions-by-course-single-filter-analysis.pdf');
    }
  }

  exportNewCourseChartAsPNG(): void {
    this.closeNewCourseChartMenu();
    if (!this.ensureHasData(this.newCourseBarChartData)) { return; }
    if (this.newCourseBarChart) {
      // Create a container to combine chart and information
      const container = document.createElement('div');
      container.style.cssText = `
    position: fixed;
    left: -10000px;
    top: -10000px;
    width: 1400px;
    background: white;
    padding: 40px;
    border: 1px solid #ccc;
    z-index: 10000;
    font-family: Arial, sans-serif;
  `;

      // Create header
      const header = document.createElement('div');
      header.style.cssText = `
    text-align: center;
    margin-bottom: 40px;
    padding-bottom: 20px;
    border-bottom: 3px solid #005068;
  `;

      const title = document.createElement('h1');
      title.textContent = 'Questions by Course/Job Role (Single Filter)';
      title.style.cssText = `
    margin: 0 0 12px 0;
    color: #005068;
    font-size: 32px;
    font-weight: bold;
  `;

      const subtitle = document.createElement('p');
      subtitle.textContent = 'Source: Content Library Analytics';
      subtitle.style.cssText = `
    margin: 0;
    color: #666;
    font-size: 16px;
  `;

      header.appendChild(title);
      header.appendChild(subtitle);

      // Create top row for chart and legends
      const topRow = document.createElement('div');
      topRow.style.cssText = `
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 60px;
    margin-bottom: 40px;
    padding: 30px;
    background: #f8f9fa;
    border-radius: 15px;
    min-height: 500px;
  `;

      // Chart container
      const chartContainer = document.createElement('div');
      chartContainer.style.cssText = `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 2;
    min-height: 500px;
  `;

      // Create a high-quality chart render
      const chartWrapper = document.createElement('div');
      chartWrapper.style.cssText = `
    width: 500px;
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border-radius: 15px;
    border: 3px solid #e0e0e0;
    padding: 20px;
    box-shadow: 0 6px 20px rgba(0,0,0,0.15);
  `;

      // Get the original chart canvas
      const originalCanvas = this.newCourseBarChart.canvas;

      // Create a high-resolution canvas
      const highResCanvas = document.createElement('canvas');
      highResCanvas.width = 800;
      highResCanvas.height = 800;

      const ctx = highResCanvas.getContext('2d');
      if (ctx) {
        // Scale up for better quality
        ctx.scale(2, 2);

        // Set white background
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, highResCanvas.width, highResCanvas.height);

        // Draw the chart with better quality
        ctx.drawImage(originalCanvas, 0, 0, 400, 400);
      }

      const chartImg = document.createElement('img');
      chartImg.src = highResCanvas.toDataURL('image/png', 1.0);
      chartImg.style.cssText = `
    width: 100%;
    height: 100%;
    display: block;
    border-radius: 10px;
    object-fit: contain;
  `;

      chartWrapper.appendChild(chartImg);
      chartContainer.appendChild(chartWrapper);

      // Legends container
      const legendsContainer = document.createElement('div');
      legendsContainer.style.cssText = `
    display: flex;
    flex-direction: column;
    gap: 25px;
    flex: 1;
    min-width: 320px;
    max-width: 350px;
  `;

      // Color Legend Container
      const colorLegendContainer = document.createElement('div');
      colorLegendContainer.style.cssText = `
    background: white;
    padding: 30px;
    border-radius: 15px;
    border: 3px solid #e0e0e0;
    box-shadow: 0 6px 20px rgba(0,0,0,0.15);
  `;

      const colorLegendTitle = document.createElement('h3');
      colorLegendTitle.textContent = 'Color Legend';
      colorLegendTitle.style.cssText = `
    margin: 0 0 25px 0;
    color: #005068;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    border-bottom: 3px solid #f0f0f0;
    padding-bottom: 15px;
  `;

      colorLegendContainer.appendChild(colorLegendTitle);

      // Add course color legend
      const courseLegend = document.createElement('div');
      courseLegend.style.cssText = `
    margin-bottom: 10px;
  `;

      const courseLegendTitle = document.createElement('h4');
      courseLegendTitle.textContent = 'Courses';
      courseLegendTitle.style.cssText = `
    margin: 0 0 20px 0;
    color: #333;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  `;

      courseLegend.appendChild(courseLegendTitle);

      // Get unique courses and their colors
      const courseColors = new Map();
      const nonZeroData = this.newCourseBarChartData.filter(item => item.value > 0);

      nonZeroData.forEach(item => {
        if (!courseColors.has(item.courseName)) {
          courseColors.set(item.courseName, item.color);
        }
      });

      // Add course color items with better styling
      courseColors.forEach((color, courseName) => {
        const courseItem = document.createElement('div');
        courseItem.style.cssText = `
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;
      padding: 12px;
      background: #f8f9fa;
      border-radius: 10px;
      border-left: 5px solid ${color};
      transition: all 0.3s ease;
    `;

        const colorBox = document.createElement('div');
        colorBox.style.cssText = `
      width: 24px;
      height: 24px;
      background-color: ${color};
      border: 3px solid #fff;
      border-radius: 8px;
      margin-right: 15px;
      margin-top: 2px;
      box-shadow: 0 3px 8px rgba(0,0,0,0.2);
      flex-shrink: 0;
    `;

        const courseNameSpan = document.createElement('span');
        courseNameSpan.textContent = courseName;
        courseNameSpan.style.cssText = `
      font-size: 16px;
      font-weight: 500;
      color: #333;
      line-height: 1.4;
      word-wrap: break-word;
      flex: 1;
    `;

        courseItem.appendChild(colorBox);
        courseItem.appendChild(courseNameSpan);
        courseLegend.appendChild(courseItem);
      });

      colorLegendContainer.appendChild(courseLegend);
      legendsContainer.appendChild(colorLegendContainer);

      // Add legends to top row
      topRow.appendChild(chartContainer);
      topRow.appendChild(legendsContainer);

      // Distribution Summary Section
      const distributionSection = document.createElement('div');
      distributionSection.style.cssText = `
    margin-top: 40px;
  `;

      const distributionTitle = document.createElement('h2');
      distributionTitle.textContent = 'Distribution Summary';
      distributionTitle.style.cssText = `
    margin: 0 0 30px 0;
    color: #005068;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    border-bottom: 3px solid #005068;
    padding-bottom: 15px;
  `;

      distributionSection.appendChild(distributionTitle);

      // Create course grid (2 courses per row)
      const coursesMap = new Map();
      nonZeroData.forEach(item => {
        if (!coursesMap.has(item.courseName)) {
          coursesMap.set(item.courseName, []);
        }
        coursesMap.get(item.courseName).push(item);
      });

      const coursesArray = Array.from(coursesMap.entries());

      // Create rows with 2 courses each
      for (let i = 0; i < coursesArray.length; i += 2) {
        const row = document.createElement('div');
        row.style.cssText = `
      display: flex;
      gap: 40px;
      margin-bottom: 40px;
      justify-content: center;
    `;

        // Add courses for this row
        for (let j = 0; j < 2 && (i + j) < coursesArray.length; j++) {
          const [courseName, courses] = coursesArray[i + j];
          const courseColor = courseColors.get(courseName);

          const courseCard = document.createElement('div');
          courseCard.style.cssText = `
        flex: 1;
        background: white;
        padding: 30px;
        border-radius: 15px;
        border: 3px solid #e0e0e0;
        border-left: 8px solid ${courseColor};
        min-width: 350px;
        max-width: 400px;
        box-shadow: 0 6px 20px rgba(0,0,0,0.15);
      `;

          // Course header
          const courseHeader = document.createElement('h3');
          courseHeader.textContent = courseName;
          courseHeader.style.cssText = `
        margin: 0 0 25px 0;
        color: #333;
        font-size: 20px;
        font-weight: bold;
        border-bottom: 3px solid #f0f0f0;
        padding-bottom: 15px;
        text-align: center;
        word-wrap: break-word;
        line-height: 1.3;
      `;

          courseCard.appendChild(courseHeader);

          // Create table-like structure for courses
          const tableContainer = document.createElement('div');
          tableContainer.style.cssText = `
        width: 100%;
      `;

          // Add courses for this course
          courses.forEach(item => {
            const percentage = this.getNewCoursePercentage(item);

            const rowDiv = document.createElement('div');
            rowDiv.style.cssText = `
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
          font-size: 16px;
          padding: 12px 0;
          border-bottom: 2px solid #f5f5f5;
        `;

            const courseLabel = document.createElement('span');
            courseLabel.textContent = `${item.name}:`;
            courseLabel.style.cssText = `
          font-weight: bold;
          color: #333;
          font-size: 16px;
        `;

            const valueSpan = document.createElement('span');
            valueSpan.textContent = `${item.value} (${percentage}%)`;
            valueSpan.style.cssText = `
          color: #666;
          font-weight: 600;
          font-size: 16px;
        `;

            rowDiv.appendChild(courseLabel);
            rowDiv.appendChild(valueSpan);
            tableContainer.appendChild(rowDiv);
          });

          courseCard.appendChild(tableContainer);
          row.appendChild(courseCard);
        }

        distributionSection.appendChild(row);
      }

      // Total and footer section
      const totalQuestions = this.newCourseBarChartData.reduce((sum, item) => sum + item.value, 0);

      const totalSection = document.createElement('div');
      totalSection.style.cssText = `
    margin-top: 50px;
    padding: 30px;
    background: #f8f9fa;
    border-radius: 15px;
    border: 3px solid #e0e0e0;
    text-align: center;
  `;

      const totalLabel = document.createElement('div');
      totalLabel.style.cssText = `
    font-weight: bold;
    margin-bottom: 20px;
    font-size: 20px;
    color: #005068;
  `;
      totalLabel.textContent = `Total Questions: ${totalQuestions}`;

      const metadataContainer = document.createElement('div');
      metadataContainer.style.cssText = `
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: 15px;
    color: #666;
    margin-bottom: 20px;
  `;

      // View information
      const viewInfo = document.createElement('div');
      viewInfo.style.cssText = `
    font-weight: 500;
  `;
      viewInfo.textContent = `View: Single Filter Mode`;

      // Filter information
      if (this.selectedNewCourseFilterValues.length > 0) {
        const filterInfo = document.createElement('div');
        const filterTypeName = this.newCourseFilterHeaders.find(f => f.key === this.selectedNewCourseFilterType)?.name || this.selectedNewCourseFilterType;
        filterInfo.textContent = `Active Filter: ${filterTypeName} (${this.selectedNewCourseFilterValues.length} selected)`;
        filterInfo.style.fontWeight = '500';
        metadataContainer.appendChild(filterInfo);
      }

      // Date information
      const dateInfo = document.createElement('div');
      let dateText = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
      }
      dateInfo.textContent = dateText;

      // Footer
      const footer = document.createElement('div');
      footer.style.cssText = `
    text-align: center;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 3px solid #ddd;
    font-size: 14px;
    color: #666;
    font-style: italic;
  `;
      footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;

      metadataContainer.appendChild(viewInfo);
      metadataContainer.appendChild(dateInfo);

      totalSection.appendChild(totalLabel);
      totalSection.appendChild(metadataContainer);
      totalSection.appendChild(footer);

      // Assemble the container
      container.appendChild(header);
      container.appendChild(topRow);
      container.appendChild(distributionSection);
      container.appendChild(totalSection);

      document.body.appendChild(container);

      // Use html2canvas with higher quality settings
      html2canvas(container, {
        scale: 3,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: container.offsetWidth,
        height: container.offsetHeight
      }).then(canvas => {
        const link = document.createElement('a');
        link.download = 'questions-by-course-single-filter-analysis.png';
        link.href = canvas.toDataURL('image/png', 1.0);
        link.click();

        // Clean up
        document.body.removeChild(container);
      });
    }
  }

  // Table Export Methods for New Course Chart
  exportNewCourseTableAsPDF(): void {
    if (!this.ensureHasData(this.newCourseBarChartData)) { return; }
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();

    // Add title
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Questions by Course/Job Role (Single Filter) - Detailed Report', pageWidth / 2, 20, { align: 'center' });

    // Add summary information
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');

    const totalQuestions = this.newCourseBarChartData.reduce((sum, item) => sum + item.value, 0);

    let dateInfo = `Date Range: ${this.selectedRange}`;
    if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
      dateInfo += ` | From: ${this.formatDisplayDate(this.startDate)} To: ${this.formatDisplayDate(this.endDate)}`;
    }
    dateInfo += ` | Total Questions: ${totalQuestions}`;

    // Add filter information
    if (this.selectedNewCourseFilterValues.length > 0) {
      const filterTypeName = this.newCourseFilterHeaders.find(f => f.key === this.selectedNewCourseFilterType)?.name || this.selectedNewCourseFilterType;
      dateInfo += ` | Active Filter: ${filterTypeName}`;
    }

    pdf.text(dateInfo, pageWidth / 2, 28, { align: 'center' });

    // Create table data
    const tableData = this.newCourseBarChartData
      .filter(item => item.value > 0)
      .map(item => [
        item.courseName || 'All Courses',
        item.name,
        item.value.toString(),
        `${this.getNewCoursePercentage(item)}%`
      ]);

    // Use autoTable
    autoTable(pdf, {
      startY: 35,
      head: [['Course Name', 'Category', 'Count', 'Percentage']],
      body: tableData,
      theme: 'grid',
      headStyles: {
        fillColor: [0, 80, 104], // #005068
        textColor: 255,
        fontStyle: 'bold',
        fontSize: 10
      },
      styles: {
        fontSize: 9,
        cellPadding: 4,
        lineColor: [0, 0, 0],
        lineWidth: 0.1
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      },
      columnStyles: {
        0: { cellWidth: 'auto', fontStyle: 'bold' }, // Course Name
        1: { cellWidth: 'auto' }, // Category
        2: { cellWidth: 'auto' }, // Count
        3: { cellWidth: 'auto' }  // Percentage
      },
      margin: { top: 35 }
    });

    // Add footer
    const finalY = (pdf as any).lastAutoTable?.finalY || 100;
    pdf.setFontSize(8);
    pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth / 2, finalY + 10, { align: 'center' });

    pdf.save('questions-by-course-single-filter-detailed-report.pdf');
  }

  exportNewCourseTableAsPNG(): void {
    if (!this.ensureHasData(this.newCourseBarChartData)) { return; }
    // Create a container for the table with styling
    const container = document.createElement('div');
    container.style.cssText = `
  position: fixed;
  left: -10000px;
  top: -10000px;
  background: white;
  padding: 30px;
  z-index: 10000;
  max-width: 900px;
  width: 900px;
  font-family: Arial, sans-serif;
`;

    // Add title and header
    const header = document.createElement('div');
    header.style.cssText = `
  text-align: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid #005068;
`;

    const title = document.createElement('h2');
    title.textContent = 'Questions by Course/Job Role (Single Filter) - Detailed Table';
    title.style.cssText = `
  margin: 0 0 12px 0;
  color: #005068;
  font-size: 24px;
  font-weight: bold;
`;

    const totalQuestions = this.newCourseBarChartData.reduce((sum, item) => sum + item.value, 0);
    const subtitle = document.createElement('p');
    let subtitleText = `Date Range: ${this.selectedRange} | Total Questions: ${totalQuestions}`;

    // Add filter information to subtitle
    if (this.selectedNewCourseFilterValues.length > 0) {
      const filterTypeName = this.newCourseFilterHeaders.find(f => f.key === this.selectedNewCourseFilterType)?.name || this.selectedNewCourseFilterType;
      subtitleText += ` | Active Filter: ${filterTypeName}`;
    }

    subtitle.textContent = subtitleText;
    subtitle.style.cssText = `
  margin: 0;
  color: #666;
  font-size: 14px;
`;

    header.appendChild(title);
    header.appendChild(subtitle);

    // Create table manually
    const tableClone = this.createNewCourseTableForExport();
    container.appendChild(header);
    container.appendChild(tableClone);

    // Add footer
    const footer = document.createElement('div');
    footer.style.cssText = `
  text-align: center;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #ddd;
  font-size: 12px;
  color: #666;
  font-style: italic;
`;
    footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;
    container.appendChild(footer);

    document.body.appendChild(container);

    html2canvas(container, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff'
    }).then(canvas => {
      const link = document.createElement('a');
      link.download = 'questions-by-course-single-filter-table.png';
      link.href = canvas.toDataURL('image/png');
      link.click();

      // Clean up
      document.body.removeChild(container);
    });
  }

  // Helper method to create new course table for export
  private createNewCourseTableForExport(): HTMLElement {
    const table = document.createElement('table');
    table.style.cssText = `
  width: 100%;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  font-size: 13px;
  margin-bottom: 20px;
`;

    // Create table header
    const thead = document.createElement('thead');
    const headerRow = document.createElement('tr');

    const headers = ['Course Name', 'Category', 'Count', 'Percentage'];
    headers.forEach(headerText => {
      const th = document.createElement('th');
      th.textContent = headerText;
      th.style.cssText = `
    background: #005068;
    color: white;
    padding: 12px 15px;
    text-align: left;
    font-weight: bold;
    border: 1px solid #ddd;
  `;
      headerRow.appendChild(th);
    });

    thead.appendChild(headerRow);
    table.appendChild(thead);

    // Create table body
    const tbody = document.createElement('tbody');

    this.newCourseBarChartData
      .filter(item => item.value > 0)
      .forEach((item, index) => {
        const row = document.createElement('tr');
        row.style.cssText = `
      background: ${index % 2 === 0 ? '#f9f9f9' : 'white'};
    `;

        const courseCell = document.createElement('td');
        courseCell.textContent = item.courseName || 'All Courses';
        courseCell.style.cssText = `
      padding: 10px 15px;
      border: 1px solid #ddd;
      text-align: left;
    `;

        const categoryCell = document.createElement('td');
        categoryCell.textContent = item.name;
        categoryCell.style.cssText = `
      padding: 10px 15px;
      border: 1px solid #ddd;
      text-align: left;
    `;

        const countCell = document.createElement('td');
        countCell.textContent = item.value.toString();
        countCell.style.cssText = `
      padding: 10px 15px;
      border: 1px solid #ddd;
      text-align: left;
    `;

        const percentageCell = document.createElement('td');
        percentageCell.textContent = `${this.getNewCoursePercentage(item)}%`;
        percentageCell.style.cssText = `
      padding: 10px 15px;
      border: 1px solid #ddd;
      text-align: left;
    `;

        row.appendChild(courseCell);
        row.appendChild(categoryCell);
        row.appendChild(countCell);
        row.appendChild(percentageCell);
        tbody.appendChild(row);
      });

    table.appendChild(tbody);
    return table;
  }

  // Question Papers Export Methods
  exportQuestionPaperTableAsPDF(): void {
    if (!this.ensureHasData(this.questionPaperChartData)) { return; }
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();

    // Add title
    pdf.setFontSize(14);
    pdf.text('Question Papers by Course/Job Role - Detailed Report', pageWidth / 2, 15, { align: 'center' });

    // Prepare data for autoTable
    const data = this.questionPaperChartData
      .filter((item: any) => item.value > 0)
      .map((item: any) => [
        item.originalName || item.name,
        item.value,
        `${this.getQuestionPaperPercentage(item)}%`
      ]);

    // Add table using autoTable
    (pdf as any).autoTable({
      head: [['Course/Job Role', 'Question Paper Count', 'Percentage']],
      body: data,
      startY: 25,
      theme: 'grid',
      styles: {
        font: 'Arial',
        fontSize: 10,
        textColor: 33,
        lineColor: 220,
        lineWidth: 0.75
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: 'bold'
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      }
    });

    const finalY = (pdf as any).lastAutoTable?.finalY || 100;
    pdf.setFontSize(8);
    pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth / 2, finalY + 10, { align: 'center' });

    pdf.save('question-papers-by-course-single-filter-detailed-report.pdf');
  }

  exportQuestionPaperTableAsPNG(): void {
    if (!this.ensureHasData(this.questionPaperChartData)) { return; }
    // Create a container for the table with styling
    const container = document.createElement('div');
    container.style.cssText = `
  position: fixed;
  left: -10000px;
  top: -10000px;
  background: white;
  padding: 30px;
  z-index: 10000;
  max-width: 900px;
  width: 900px;
  font-family: Arial, sans-serif;
`;

    // Create header
    const header = document.createElement('div');
    header.style.cssText = `
  text-align: center;
  margin-bottom: 20px;
  border-bottom: 2px solid #2980b9;
  padding-bottom: 10px;
`;
    header.innerHTML = `<h2 style="margin: 0; color: #2980b9;">Question Papers by Course/Job Role - Detailed Report</h2>`;
    container.appendChild(header);

    // Create table
    const table = this.createQuestionPaperTable();
    container.appendChild(table);

    // Create footer
    const footer = document.createElement('div');
    footer.style.cssText = `
  text-align: center;
  margin-top: 20px;
  padding-top: 10px;
  border-top: 1px solid #ddd;
  font-size: 12px;
  color: #666;
`;
    footer.innerHTML = `Generated on: ${new Date().toLocaleDateString()}`;
    container.appendChild(footer);

    // Append to body temporarily
    document.body.appendChild(container);

    // Use html2canvas to convert to PNG
    const canvas = document.createElement('canvas');
    canvas.width = 900;
    canvas.height = container.offsetHeight;

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      document.body.removeChild(container);
      return;
    }

    // Fill background
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Generate PNG
    setTimeout(() => {
      const link = document.createElement('a');
      link.href = canvas.toDataURL('image/png');
      link.download = 'question-papers-by-course-single-filter-detailed-report.png';
      link.click();

      // Cleanup
      document.body.removeChild(container);
    }, 100);
  }

  private createQuestionPaperTable(): HTMLTableElement {
    const table = document.createElement('table');
    table.style.cssText = `
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
`;

    const thead = document.createElement('thead');
    const headerRow = document.createElement('tr');
    headerRow.style.cssText = `
  background-color: #2980b9;
  color: white;
  font-weight: bold;
`;

    const headers = ['Course/Job Role', 'Question Paper Count', 'Percentage'];
    headers.forEach(header => {
      const th = document.createElement('th');
      th.textContent = header;
      th.style.cssText = `
  padding: 12px;
  text-align: left;
  border: 1px solid #bdc3c7;
  font-weight: bold;
  background-color: #2980b9;
  color: white;
`;
      headerRow.appendChild(th);
    });

    thead.appendChild(headerRow);
    table.appendChild(thead);

    const tbody = document.createElement('tbody');
    let rowIndex = 0;

    this.questionPaperChartData
      .filter((item: any) => item.value > 0)
      .forEach((item: any) => {
        const row = document.createElement('tr');
        row.style.cssText = `
  background-color: ${rowIndex % 2 === 0 ? '#f5f5f5' : 'white'};
  border-bottom: 1px solid #bdc3c7;
`;

        const courseCell = document.createElement('td');
        courseCell.textContent = item.originalName || item.name;
        courseCell.style.cssText = `
  padding: 10px 12px;
  border: 1px solid #bdc3c7;
  text-align: left;
`;

        const categoryCell = document.createElement('td');
        categoryCell.textContent = 'Question Papers';
        categoryCell.style.cssText = `
  padding: 10px 12px;
  border: 1px solid #bdc3c7;
  text-align: center;
`;

        const countCell = document.createElement('td');
        countCell.textContent = String(item.value);
        countCell.style.cssText = `
  padding: 10px 12px;
  border: 1px solid #bdc3c7;
  text-align: center;
`;

        const percentageCell = document.createElement('td');
        percentageCell.textContent = `${this.getQuestionPaperPercentage(item)}%`;
        percentageCell.style.cssText = `
  padding: 10px 12px;
  border: 1px solid #bdc3c7;
  text-align: left;
`;

        row.appendChild(courseCell);
        row.appendChild(categoryCell);
        row.appendChild(countCell);
        row.appendChild(percentageCell);
        tbody.appendChild(row);
        rowIndex++;
      });

    table.appendChild(tbody);
    return table;
  }

  // Compare Dialog Methods for New Course Chart
  openNewCourseCompareDialog(): void {
    this.showNewCourseCompareDialog = true;
    this.showNewCourseComparisonResults = false;
    this.selectedNewCourseCompareMonth1 = null;
    this.selectedNewCourseCompareMonth2 = null;
  }

  closeNewCourseCompareDialog(): void {
    this.showNewCourseCompareDialog = false;
    this.showNewCourseComparisonResults = false;
    this.currentNewCourseComparisonData = [];
    this.compareNewCourseComparisonData = [];
  }

  // Compare Month 1 Dropdown Methods for New Course Chart
  toggleNewCourseCompareMonth1Dropdown(): void {
    this.showNewCourseCompareMonth1Dropdown = !this.showNewCourseCompareMonth1Dropdown;
    if (this.showNewCourseCompareMonth1Dropdown) {
      this.showNewCourseCompareMonth2Dropdown = false;
    }
  }

  selectNewCourseCompareMonth1(month: number): void {
    this.selectedNewCourseCompareMonth1 = month;
    this.showNewCourseCompareMonth1Dropdown = false;
  }

  // Compare Month 2 Dropdown Methods for New Course Chart
  toggleNewCourseCompareMonth2Dropdown(): void {
    this.showNewCourseCompareMonth2Dropdown = !this.showNewCourseCompareMonth2Dropdown;
    if (this.showNewCourseCompareMonth2Dropdown) {
      this.showNewCourseCompareMonth1Dropdown = false;
    }
  }

  selectNewCourseCompareMonth2(month: number): void {
    this.selectedNewCourseCompareMonth2 = month;
    this.showNewCourseCompareMonth2Dropdown = false;
  }

  // Load New Course Comparison Data
  loadNewCourseComparisonData(): void {
    if (!this.selectedNewCourseCompareMonth1 || !this.selectedNewCourseCompareMonth2) {
      return;
    }

    this.isLoading = true;
    this.showNewCourseComparisonResults = true;

    // Prepare current data for comparison
    this.prepareCurrentNewCourseComparisonData();

    // Fetch comparison data
    this.fetchNewCourseComparisonData();
  }

  private prepareCurrentNewCourseComparisonData(): void {
    this.currentNewCourseComparisonData = this.newCourseBarChartData
      .filter(item => item.value > 0)
      .map(item => ({
        name: item.name,
        value: item.value,
        percentage: this.getNewCoursePercentage(item),
        trend: 'neutral'
      }));
  }

  private fetchNewCourseComparisonData(): void {
    let startDate: Date;
    let endDate: Date;

    // Get the current year
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedNewCourseCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear; // Academic year logic
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedNewCourseCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear; // Academic year logic
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    // Fetch Month 1 data
    const resp1 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    // Fetch Month 2 data
    const resp2 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Data: any[] = [];
    let month2Data: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month1Data = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processNewCourseComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.compareNewCourseComparisonData = [];
          this.newCourseTrendSummary = [];
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month2Data = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processNewCourseComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.compareNewCourseComparisonData = [];
          this.newCourseTrendSummary = [];
        }
      }
    );

    // Set loading complete after both requests
    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    }, 2000);
  }

  private processNewCourseComparisonDataMonthWise(month1Data: any[], month2Data: any[]): void {
    // Type guard to check if question_count is a number
    const isValidCourse = (course: any): course is { course_name: string; question_count: number } => {
      return course &&
        course.course_name &&
        typeof course.question_count === 'number' &&
        course.question_count > 0;
    };

    // Process Month 1 data
    const validMonth1Courses = month1Data.filter(isValidCourse);
    const sortedMonth1Courses = [...validMonth1Courses].sort((a, b) =>
      b.question_count - a.question_count
    );
    const topMonth1Courses = sortedMonth1Courses.slice(0, 10);
    const otherMonth1CoursesTotal = sortedMonth1Courses.slice(10).reduce((sum, course) =>
      sum + course.question_count, 0
    );

    // Process Month 2 data
    const validMonth2Courses = month2Data.filter(isValidCourse);
    const sortedMonth2Courses = [...validMonth2Courses].sort((a, b) =>
      b.question_count - a.question_count
    );
    const topMonth2Courses = sortedMonth2Courses.slice(0, 10);
    const otherMonth2CoursesTotal = sortedMonth2Courses.slice(10).reduce((sum, course) =>
      sum + course.question_count, 0
    );

    // Store Month 1 data as current
    const month1Totals: { [key: string]: number } = {};
    topMonth1Courses.forEach(course => {
      month1Totals[course.course_name] = course.question_count;
    });
    if (otherMonth1CoursesTotal > 0) {
      month1Totals['Others'] = otherMonth1CoursesTotal;
    }

    this.currentNewCourseComparisonData = Object.entries(month1Totals)
      .filter(([_, count]) => count > 0)
      .map(([courseName, count]) => ({
        name: courseName,
        value: count,
        percentage: '0',
        trend: 'neutral'
      }));

    // Store Month 2 data as comparison
    const month2Totals: { [key: string]: number } = {};
    topMonth2Courses.forEach(course => {
      month2Totals[course.course_name] = course.question_count;
    });
    if (otherMonth2CoursesTotal > 0) {
      month2Totals['Others'] = otherMonth2CoursesTotal;
    }

    this.compareNewCourseComparisonData = Object.entries(month2Totals)
      .filter(([_, count]) => count > 0)
      .map(([courseName, count]) => {
        const currentItem = this.currentNewCourseComparisonData.find(item => item.name === courseName);
        const currentValue = currentItem ? currentItem.value : 0;

        let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
        if (count > currentValue) {
          trend = 'positive';
        } else if (count < currentValue) {
          trend = 'negative';
        }

        return {
          name: courseName,
          value: count,
          percentage: '0',
          trend: trend
        };
      });

    // Calculate trend summary
    this.calculateNewCourseTrendSummaryMonthWise();
  }

  private calculateNewCourseTrendSummary(): void {
    const currentTotal = this.getCurrentNewCourseTotalQuestions();
    const compareTotal = this.getCompareNewCourseTotalQuestions();

    this.newCourseTrendSummary = [
      {
        category: 'Total Questions',
        value: this.formatTrendValue(compareTotal - currentTotal),
        trend: compareTotal > currentTotal ? 'positive' : compareTotal < currentTotal ? 'negative' : 'neutral'
      }
    ];

    // Add course level trends for top 3 courses
    this.currentNewCourseComparisonData.slice(0, 3).forEach(currentItem => {
      const compareItem = this.compareNewCourseComparisonData.find(item => item.name === currentItem.name);
      if (compareItem) {
        const difference = compareItem.value - currentItem.value;
        this.newCourseTrendSummary.push({
          category: `${currentItem.name} Questions`,
          value: this.formatTrendValue(difference),
          trend: compareItem.trend
        });
      }
    });
  }

  private calculateNewCourseTrendSummaryMonthWise(): void {
    const month1Name = this.getMonthName(this.selectedNewCourseCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedNewCourseCompareMonth2!);
    const currentTotal = this.getCurrentNewCourseTotalQuestions();
    const compareTotal = this.getCompareNewCourseTotalQuestions();

    const difference = compareTotal - currentTotal;
    const trend = compareTotal > currentTotal ? 'positive' : compareTotal < currentTotal ? 'negative' : 'neutral';

    // Create summary with month names
    this.newCourseTrendSummary = [];

    // Get all unique courses from both months
    const allCourses = new Set<string>();
    this.currentNewCourseComparisonData.forEach(item => allCourses.add(item.name));
    this.compareNewCourseComparisonData.forEach(item => allCourses.add(item.name));

    // Create detailed comparison for each course
    Array.from(allCourses).slice(0, 10).forEach(courseName => {
      const month1Item = this.currentNewCourseComparisonData.find(item => item.name === courseName);
      const month2Item = this.compareNewCourseComparisonData.find(item => item.name === courseName);

      const month1Value = month1Item ? month1Item.value : 0;
      const month2Value = month2Item ? month2Item.value : 0;

      let trendIcon = '→';
      if (month2Value > month1Value) {
        trendIcon = '↑'; // Positive trend
      } else if (month2Value < month1Value) {
        trendIcon = '↓'; // Negative trend
      }

      this.newCourseTrendSummary.push({
        name: courseName,
        current: month1Value,
        compare: month2Value,
        change: month2Value - month1Value,
        trend: trendIcon
      });
    });

    // Initialize comparison chart
    this.initializeNewCourseComparisonChart();
  }

  private initializeNewCourseComparisonChart(): void {
    // Prepare data for chart
    const month1Name = this.getMonthName(this.selectedNewCourseCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedNewCourseCompareMonth2!);

    // Get unique courses from both datasets
    const allCourses = new Set<string>();
    this.currentNewCourseComparisonData.forEach(item => allCourses.add(item.name));
    this.compareNewCourseComparisonData.forEach(item => allCourses.add(item.name));

    const courseNames: string[] = Array.from(allCourses).slice(0, 10);
    const month1Data: number[] = [];
    const month2Data: number[] = [];

    courseNames.forEach(courseName => {
      const month1Item = this.currentNewCourseComparisonData.find(item => item.name === courseName);
      const month2Item = this.compareNewCourseComparisonData.find(item => item.name === courseName);
      month1Data.push(month1Item ? month1Item.value : 0);
      month2Data.push(month2Item ? month2Item.value : 0);
    });

    // Destroy existing chart if it exists
    if (this.newCourseComparisonChart) {
      this.newCourseComparisonChart.destroy();
    }

    // Delay chart initialization to ensure DOM is ready
    setTimeout(() => {
      const ctx = document.getElementById('newCourseComparisonChart') as HTMLCanvasElement;
      if (ctx) {
        this.newCourseComparisonChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: courseNames,
            datasets: [
              {
                label: month1Name,
                data: month1Data,
                backgroundColor: '#005068',
                borderColor: '#003d4d',
                borderWidth: 1
              },
              {
                label: month2Name,
                data: month2Data,
                backgroundColor: '#BFCAD9',
                borderColor: '#9ba5b8',
                borderWidth: 1
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: true,
            indexAxis: 'y' as const,
            plugins: {
              legend: {
                position: 'top' as const
              },
              title: {
                display: true,
                text: `Month-wise Questions Comparison: ${month1Name} vs ${month2Name}`
              }
            },
            scales: {
              x: {
                beginAtZero: true,
                stacked: false
              }
            }
          }
        });
      }
    }, 100);
  }

  toggleNewCourseComparisonAccordion(section: string): void {
    this.activeNewCourseComparisonAccordion = this.activeNewCourseComparisonAccordion === section ? '' : section;
  }

  getCurrentNewCourseTotalQuestions(): number {
    return this.currentNewCourseComparisonData.reduce((sum, item) => sum + item.value, 0);
  }

  getCompareNewCourseTotalQuestions(): number {
    return this.compareNewCourseComparisonData.reduce((sum, item) => sum + item.value, 0);
  }

  openQuestionPaperCourseCompareDialog(): void {
    this.showQuestionPaperCourseCompareDialog = true;
    this.showQuestionPaperCourseComparisonResults = false;
    this.selectedQuestionPaperCompareMonth1 = null;
    this.selectedQuestionPaperCompareMonth2 = null;
  }

  closeQuestionPaperCourseCompareDialog(): void {
    this.showQuestionPaperCourseCompareDialog = false;
    this.showQuestionPaperCourseComparisonResults = false;
    this.currentQuestionPaperCourseComparisonData = [];
    this.compareQuestionPaperCourseComparisonData = [];
  }

  toggleQuestionPaperCompareMonth1Dropdown(): void {
    this.showQuestionPaperCompareMonth1Dropdown = !this.showQuestionPaperCompareMonth1Dropdown;
    if (this.showQuestionPaperCompareMonth1Dropdown) {
      this.showQuestionPaperCompareMonth2Dropdown = false;
    }
  }

  selectQuestionPaperCompareMonth1(month: number): void {
    this.selectedQuestionPaperCompareMonth1 = month;
    this.showQuestionPaperCompareMonth1Dropdown = false;
  }

  toggleQuestionPaperCompareMonth2Dropdown(): void {
    this.showQuestionPaperCompareMonth2Dropdown = !this.showQuestionPaperCompareMonth2Dropdown;
    if (this.showQuestionPaperCompareMonth2Dropdown) {
      this.showQuestionPaperCompareMonth1Dropdown = false;
    }
  }

  selectQuestionPaperCompareMonth2(month: number): void {
    this.selectedQuestionPaperCompareMonth2 = month;
    this.showQuestionPaperCompareMonth2Dropdown = false;
  }

  loadQuestionPaperCourseComparisonData(): void {
    if (!this.selectedQuestionPaperCompareMonth1 || !this.selectedQuestionPaperCompareMonth2) {
      return;
    }

    this.isLoading = true;
    this.showQuestionPaperCourseComparisonResults = true;

    // Prepare current data for comparison
    this.prepareCurrentQuestionPaperCourseComparisonData();

    // Fetch comparison data
    this.fetchQuestionPaperCourseComparisonDataMonthWise();
  }

  private prepareCurrentQuestionPaperCourseComparisonData(): void {
    this.currentQuestionPaperCourseComparisonData = this.questionPaperChartData
      .filter(item => item.value > 0)
      .map(item => ({
        name: item.name,
        value: item.value,
        percentage: this.getQuestionPaperPercentage(item),
        trend: 'neutral'
      }));
  }

  private fetchQuestionPaperCourseComparisonDataMonthWise(): void {
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedQuestionPaperCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedQuestionPaperCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    // Fetch Month 1 data
    const resp1 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    // Fetch Month 2 data
    const resp2 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Data: any[] = [];
    let month2Data: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.paper_counts) {
          month1Data = response.paper_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processQuestionPaperCourseComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.compareQuestionPaperCourseComparisonData = [];
          this.questionPaperCourseTrendSummary = [];
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.paper_counts) {
          month2Data = response.paper_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processQuestionPaperCourseComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.compareQuestionPaperCourseComparisonData = [];
          this.questionPaperCourseTrendSummary = [];
        }
      }
    );

    // Set loading complete after both requests
    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    }, 2000);
  }

  private processQuestionPaperCourseComparisonDataMonthWise(month1Data: any[], month2Data: any[]): void {
    // Type guard to check if paper_count is a number
    const isValidPaper = (paper: any): paper is { course_name: string; paper_count: number } => {
      return paper &&
        paper.course_name &&
        typeof paper.paper_count === 'number' &&
        paper.paper_count > 0;
    };

    // Process Month 1 data
    const validMonth1Papers = month1Data.filter(isValidPaper);
    const sortedMonth1Papers = [...validMonth1Papers].sort((a, b) =>
      b.paper_count - a.paper_count
    );
    const topMonth1Papers = sortedMonth1Papers.slice(0, 10);
    const otherMonth1PapersTotal = sortedMonth1Papers.slice(10).reduce((sum, paper) =>
      sum + paper.paper_count, 0
    );

    // Process Month 2 data
    const validMonth2Papers = month2Data.filter(isValidPaper);
    const sortedMonth2Papers = [...validMonth2Papers].sort((a, b) =>
      b.paper_count - a.paper_count
    );
    const topMonth2Papers = sortedMonth2Papers.slice(0, 10);
    const otherMonth2PapersTotal = sortedMonth2Papers.slice(10).reduce((sum, paper) =>
      sum + paper.paper_count, 0
    );

    // Store Month 1 data as current
    const month1Totals: { [key: string]: number } = {};
    topMonth1Papers.forEach(paper => {
      month1Totals[paper.course_name] = paper.paper_count;
    });
    if (otherMonth1PapersTotal > 0) {
      month1Totals['Others'] = otherMonth1PapersTotal;
    }

    this.currentQuestionPaperCourseComparisonData = Object.entries(month1Totals)
      .filter(([_, count]) => count > 0)
      .map(([courseName, count]) => ({
        name: courseName,
        value: count,
        percentage: '0',
        trend: 'neutral'
      }));

    // Store Month 2 data as comparison
    const month2Totals: { [key: string]: number } = {};
    topMonth2Papers.forEach(paper => {
      month2Totals[paper.course_name] = paper.paper_count;
    });
    if (otherMonth2PapersTotal > 0) {
      month2Totals['Others'] = otherMonth2PapersTotal;
    }

    this.compareQuestionPaperCourseComparisonData = Object.entries(month2Totals)
      .filter(([_, count]) => count > 0)
      .map(([courseName, count]) => {
        const currentItem = this.currentQuestionPaperCourseComparisonData.find(item => item.name === courseName);
        const currentValue = currentItem ? currentItem.value : 0;

        let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
        if (count > currentValue) {
          trend = 'positive';
        } else if (count < currentValue) {
          trend = 'negative';
        }

        return {
          name: courseName,
          value: count,
          percentage: '0',
          trend: trend
        };
      });

    // Calculate trend summary
    this.calculateQuestionPaperCourseTrendSummaryMonthWise();
  }

  private calculateQuestionPaperCourseTrendSummaryMonthWise(): void {
    const month1Name = this.getMonthName(this.selectedQuestionPaperCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedQuestionPaperCompareMonth2!);

    // Create summary with month names
    this.questionPaperCourseTrendSummary = [];

    // Get all unique courses from both months
    const allCourses = new Set<string>();
    this.currentQuestionPaperCourseComparisonData.forEach(item => allCourses.add(item.name));
    this.compareQuestionPaperCourseComparisonData.forEach(item => allCourses.add(item.name));

    // Create detailed comparison for each course
    Array.from(allCourses).slice(0, 10).forEach(courseName => {
      const month1Item = this.currentQuestionPaperCourseComparisonData.find(item => item.name === courseName);
      const month2Item = this.compareQuestionPaperCourseComparisonData.find(item => item.name === courseName);

      const month1Value = month1Item ? month1Item.value : 0;
      const month2Value = month2Item ? month2Item.value : 0;

      let trendIcon = '→';
      if (month2Value > month1Value) {
        trendIcon = '↑'; // Positive trend
      } else if (month2Value < month1Value) {
        trendIcon = '↓'; // Negative trend
      }

      this.questionPaperCourseTrendSummary.push({
        name: courseName,
        current: month1Value,
        compare: month2Value,
        change: month2Value - month1Value,
        trend: trendIcon
      });
    });

    // Initialize comparison chart
    this.initializeQuestionPaperComparisonChart();
  }

  private processQuestionPaperCourseComparisonData(comparisonData: any[]): void {
    this.compareQuestionPaperCourseComparisonData = comparisonData
      .filter(item => item.paper_count > 0)
      .map(item => ({
        name: item.course_name,
        value: item.paper_count,
        percentage: this.calculateQuestionPaperPercentage(item, comparisonData),
        trend: 'neutral'
      }));

    this.calculateQuestionPaperCourseTrends();
  }

  private calculateQuestionPaperCourseTrends(): void {
    this.questionPaperCourseTrendSummary = [];

    this.currentQuestionPaperCourseComparisonData.forEach(currentItem => {
      const compareItem = this.compareQuestionPaperCourseComparisonData.find(
        item => item.name === currentItem.name
      );

      if (compareItem) {
        const difference = currentItem.value - compareItem.value;
        const trend = difference > 0 ? 'up' : difference < 0 ? 'down' : 'neutral';

        this.questionPaperCourseTrendSummary.push({
          name: currentItem.name,
          current: currentItem.value,
          compare: compareItem.value,
          change: difference > 0 ? `+${difference}` : `${difference}`,
          category: `${currentItem.name} Question Papers`,
          value: this.formatTrendValue(difference),
          trend: trend
        });
      }
    });
  }

  private initializeQuestionPaperComparisonChart(): void {
    // Prepare data for chart
    const month1Name = this.getMonthName(this.selectedQuestionPaperCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedQuestionPaperCompareMonth2!);

    // Get unique courses from both datasets
    const allCourses = new Set<string>();
    this.currentQuestionPaperCourseComparisonData.forEach(item => allCourses.add(item.name));
    this.compareQuestionPaperCourseComparisonData.forEach(item => allCourses.add(item.name));

    const courseNames: string[] = Array.from(allCourses).slice(0, 10);
    const month1Data: number[] = [];
    const month2Data: number[] = [];

    courseNames.forEach(courseName => {
      const month1Item = this.currentQuestionPaperCourseComparisonData.find(item => item.name === courseName);
      const month2Item = this.compareQuestionPaperCourseComparisonData.find(item => item.name === courseName);
      month1Data.push(month1Item ? month1Item.value : 0);
      month2Data.push(month2Item ? month2Item.value : 0);
    });

    // Destroy existing chart if it exists
    if (this.questionPaperComparisonChart) {
      this.questionPaperComparisonChart.destroy();
    }

    // Delay chart initialization to ensure DOM is ready
    setTimeout(() => {
      const ctx = document.getElementById('questionPaperComparisonChart') as HTMLCanvasElement;
      if (ctx) {
        this.questionPaperComparisonChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: courseNames,
            datasets: [
              {
                label: month1Name,
                data: month1Data,
                backgroundColor: '#005068',
                borderColor: '#003d4d',
                borderWidth: 1
              },
              {
                label: month2Name,
                data: month2Data,
                backgroundColor: '#BFCAD9',
                borderColor: '#9ba5b8',
                borderWidth: 1
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: true,
            indexAxis: 'y' as const,
            plugins: {
              legend: {
                position: 'top' as const
              },
              title: {
                display: true,
                text: `Month-wise Question Papers Comparison: ${month1Name} vs ${month2Name}`
              }
            },
            scales: {
              x: {
                beginAtZero: true,
                stacked: false
              }
            }
          }
        });
      }
    }, 100);
  }

  private calculateQuestionPaperPercentage(item: any, allItems: any[]): number {
    const total = allItems.reduce((sum, dataItem) => sum + (dataItem.paper_count || 0), 0);
    return total > 0 ? Math.round((item.paper_count / total) * 100) : 0;
  }

  getCurrentQuestionPaperCourseTotalPapers(): number {
    return this.currentQuestionPaperCourseComparisonData.reduce((sum, item) => sum + item.value, 0);
  }

  getCompareQuestionPaperCourseTotalPapers(): number {
    return this.compareQuestionPaperCourseComparisonData.reduce((sum, item) => sum + item.value, 0);
  }

  isLoading: boolean = false;
  cachedOperationsDataResponse: any = null; // Cache for assessment details filtering
  dataSource: object[];

  // Data sources for each table
  orgUpdatesData: object[] = [
  ];

  myUpdatesData: object[] = [
  ];

  // Date Range Options
  dateRanges: string[] = ['This month', 'Last 30 days', 'Last 6 months', 'Last 1 year', 'Custom'];
  selectedRange: string = new Date().toLocaleString('default', { month: 'long' }); // Default display text to current month
  rangeType: string = 'This month'; // Actual range type for validation

  // Store the start and end dates for the custom range
  startDate: Date | null = null;
  endDate: Date | null = null;

  // Track selected month and year from date filter for Assessment Insights
  selectedDateFilterMonth: number = new Date().getMonth() + 1; // 1-12
  selectedDateFilterYear: number = new Date().getFullYear();

  // Accordion Sections
  sections = [
    //  { title: 'Activity Tracker' },
    { title: 'Assessments' },
    { title: 'Library' },
    //{ title: 'Customer' },
    //{ title: 'Finance' },
    // { title: 'UserSettings' },
  ];

  // Currently Open Section
  openSection: number | null = null;

  // Sample activity data
  activityData = [
    { date: '2024-12-01', activity: 'Login', status: 'Completed' },
    { date: '2024-12-02', activity: 'Logout', status: 'Completed' },
    { date: '2024-12-03', activity: 'Update Profile', status: 'Pending' },
  ];
  // Add these properties to your component class
  showTypeFilterPanel: boolean = false;
  showTypeChartMenu: boolean = false;
  showTypeTableModalFlag: boolean = false;
  selectedTypeYearRange: string = '';
  selectedTypeMonth: number = new Date().getMonth() + 1;
  showTypeYearDropdown: boolean = false;
  showTypeMonthDropdown: boolean = false;
  activeTypeFilterHeader: string = 'courses';
  selectedTypeCourseIds: number[] = [];
  selectedQuestionTypes: string[] = [];
  selectedTypeLanguages: string[] = [];
  filteredTypeLanguagesList: any[] = [];
  typeLanguageSearchTerm: string = '';
  selectedTypeEvaluationModes: string[] = [];
  filteredTypeEvaluationModesList: any[] = [];
  typeEvaluationModeSearchTerm: string = '';
  selectedTypeDifficultyLevels: string[] = [];
  filteredTypeDifficultyLevels: any[] = [];
  typeDifficultyLevelSearchTerm: string = '';
  selectedQuestionsByTypeDifficulty: string = 'easy'; // Default to easy
  showQuestionsByTypeChart: boolean = false;
  questionsByTypeChartData: any[] = [];
  allQuestionsByTypeData: any[] = [];
  questionsByTypeChart: Chart;
  showQuestionsByTypeChartMenu: boolean = false;
  showQuestionsByTypeTableModal: boolean = false;
  showTypeBarChart: boolean = false;
  typeBarChartData: any[] = [];
  typeBarChart: Chart;

  // Type Filter Headers
  typeFilterHeaders = [
    { key: 'courses', name: 'Courses' },
    { key: 'questionTypes', name: 'Question Types' },
   // { key: 'language', name: 'Language' },
    { key: 'evaluationMode', name: 'Evaluation Mode' },
    { key: 'difficultyLevel', name: 'Difficulty Level' }
  ];
  // Available Evaluation Modes
  availableTypeEvaluationModes: string[] = [ 'Theory', 'Practical', 'Viva'];
  // Available Difficulty Levels
  availableTypeDifficultyLevels = DIFFICULTY_LEVELS;
  // Available Languages - All 14 predefined languages
  availableLanguages = LANGUAGES;

  availableQuestionTypes = QUESTION_TYPES;

  // Tabs and selectedTab tracking
  tabs = ['Org Updates', 'My Updates'];
  selectedTab = 'Org Updates'; // Default to Org Updates tab

  // View Type Selection (All, Assessment Planning, Content Library)
  selectedViewType: string = 'all'; // Default to library view
  lastDataFetchTimestamp: number = 0; // Track last data fetch for caching optimization
  DATA_CACHE_VALIDITY_MS: number = 5000; // Cache valid for 5 seconds

  // Available view types based on menu access
  availableViewTypes: { value: string, label: string }[] = [
    { value: 'all', label: 'All' },
    { value: 'assessment', label: 'Assessment' },
    { value: 'library', label: 'Content Library' }
  ];

  // Chart references to prevent multiple initializations
  charts: { [key: string]: Chart } = {};
  isAdmin: any;
  courseChartCategories: string[] = [];
  difficultyChartCategories: string[] = [];
  typeChartCategories: string[] = [];
  languageChartCategories: string[] = [];
  questionCourseData: any;
  questionCounts: any;
  summaryQuestionCounts: any; // Original data for summary section - NEVER updated by chart filters
  questionSummary: any;
  questionDifficultyData: { name: string; data: any[]; }[];
  questionTypeData: { name: string; data: any[]; }[];
  questionLanguageData: { name: string; data: any[]; }[];
  questionStatusData: { name: string; data: any[]; }[];
  UserRoleId: any;

  private prepareQuestionChartData(): void {
    // Course-wise question count
    this.questionCourseData = this.questionCounts.map(course => ({
      name: course.course_name,
      data: [course.question_count]
    }));

    // Set course chart categories
    this.courseChartCategories = this.questionCounts.map(course => course.course_name);

    // Question type breakdown
    if (this.questionSummary) {
      this.questionTypeData = [
        { name: 'MCQ', data: [this.questionSummary.type_summary.mcq] },
        { name: 'Coding', data: [this.questionSummary.type_summary.coding] },
        { name: 'Descriptive', data: [this.questionSummary.type_summary.descriptive] }
      ];
    }

    // Language breakdown
    if (this.questionSummary) {
      this.questionLanguageData = [
        { name: 'English', data: [this.questionSummary.language_summary.english] },
        { name: 'Hindi', data: [this.questionSummary.language_summary.hindi] },
        { name: 'Regional', data: [this.questionSummary.language_summary.regional] }
      ];
    }
  }


  toggleCourseDropdown(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.showCourseDropdown = !this.showCourseDropdown;
  }
  getCourseListData() {
    const postData = {
      courseId: 0,
      userRoleId: this.UserRoleId ? parseInt(this.UserRoleId, 10) : 0
    };

    this.courseSrvc.getAllCourses(postData).subscribe(
      (data: any) => {
        const response = data.body.responseBody;
        this.courseList = response || [];
        this.filteredCourseFilterList = [...this.courseList];
        this.filteredCourseDifficultyList = [...DIFFICULTY_LEVELS];
        this.filteredCourseTypeList = [...QUESTION_TYPES];
        this.filteredCourseEvaluationModeList = [...this.availableCourseEvaluationModes];
        this.cdr.markForCheck();
      },
      (err: any) => {
        this.util.errorNotification(err);
        this.courseList = [];
        this.filteredCourseFilterList = [];
        this.filteredCourseDifficultyList = [...DIFFICULTY_LEVELS];
        this.filteredCourseTypeList = [...QUESTION_TYPES];
        this.filteredCourseEvaluationModeList = [...this.availableCourseEvaluationModes];
        this.filteredCourseLanguageList = [...this.availableCourseLanguages];
        this.cdr.markForCheck();
      }
    );
  }
  private initializeLanguageData(): void {
    this.selectedLanguageYearRange = this.selectedYearRange;
    this.loadLanguagesFromMaster();
  }

  private initializeDifficultyData(): void {
    this.selectedDifficultyYearRange = this.selectedYearRange;
    this.selectedDifficultyMonth = new Date().getMonth() + 1;
    this.filteredDifficultyLevels = [...this.difficultyLevels];
    this.filteredDifficultyLanguagesList = [...this.languagesData];
  }

  // Load languages from language_master table
  private loadLanguagesFromMaster(): void {
    // This should call your service to get languages from language_master
    // For now, using static data based on your question structure
    this.availableLanguages = [
      { code: 'english', name: 'English' },
      { code: 'hindi', name: 'Hindi' },
      { code: 'regional', name: 'Regional' }
    ];
  }

  // Prepare language data for bar chart
  private prepareLanguageData(courses: any[]): void {

    if (courses.length === 0) {
      this.languageBarChartData = [];
      this.languageBarChartLabels = [];
      this.languageBarChartValues = [];
      this.languageBarChartColors = [];
      this.showLanguageBarChart = false;
      return;
    }

    // Reset data properly
    this.languageBarChartData = [];
    this.languageBarChartLabels = [];
    this.languageBarChartValues = [];
    this.languageBarChartColors = [];

    // Check if we should show overall language or course-wise
    if (this.shouldShowOverallLanguage()) {
      this.prepareOverallLanguageData(courses);
    } else {
      this.prepareMultipleCoursesLanguageData(courses);
    }

    // Filter out zero values and undefined data
    this.languageBarChartData = this.languageBarChartData.filter(item =>
      item && item.value > 0 && item.name && item.name !== 'undefined'
    );

    this.showLanguageBarChart = this.languageBarChartData.length > 0;

    if (this.showLanguageBarChart) {
      setTimeout(() => {
        this.initializeLanguageBarChart();
      }, 100);
    }
  }

  // Prepare evaluation mode data for Questions by Evaluation Mode chart
  private prepareEvaluationModeData(courses: any[]): void {
    // Initialize evaluation mode data with default modes
    // Since evaluation modes are Theory, Practical, Viva - we'll populate them with sample data
    this.evaluationModeChartData = [
      { name: 'Theory', value: Math.floor(Math.random() * 200) + 50 },
      { name: 'Practical', value: Math.floor(Math.random() * 150) + 30 },
      { name: 'Viva', value: Math.floor(Math.random() * 100) + 20 }
    ];
  }


  // Initialize category data
  private initializeCategoryData(): void {
    this.selectedCategoryYearRange = this.selectedYearRange;
    this.selectedCategoryMonth = new Date().getMonth() + 1;

    // Fetch initial data for category chart
    this.fetchCategoryFilteredData();
  }
  // Calendar properties
  showDateDropdown: boolean = false;
  showCustomCalendar: boolean = false;
  showYearPicker: boolean = false;
  showMonthPicker: boolean = false;
  currentMonth: Date = new Date();
  calendarDays: (Date | null)[] = [];

  // Month names for display
  monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];

  // Initialize calendar
  private initializeCalendar(): void {
    this.generateCalendarDays();
  }

  // Generate calendar days for current month
  private generateCalendarDays(): void {
    const year = this.currentMonth.getFullYear();
    const month = this.currentMonth.getMonth();

    // First day of the month
    const firstDay = new Date(year, month, 1);
    // Last day of the month
    const lastDay = new Date(year, month + 1, 0);

    // Start from Sunday (0 = Sunday, 1 = Monday, etc.)
    const adjustedStartDay = firstDay.getDay();

    this.calendarDays = [];

    // Add empty days for the beginning of the month
    for (let i = 0; i < adjustedStartDay; i++) {
      this.calendarDays.push(null);
    }

    // Add days of the month
    for (let day = 1; day <= lastDay.getDate(); day++) {
      this.calendarDays.push(new Date(year, month, day));
    }
  }

  // Get current month and year for display
  get currentMonthYear(): string {
    return this.currentMonth.toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric'
    });
  }

  // Navigate to previous month
  previousMonth(): void {
    this.currentMonth = new Date(
      this.currentMonth.getFullYear(),
      this.currentMonth.getMonth() - 1,
      1
    );
    this.generateCalendarDays();
  }

  // Navigate to next month
  nextMonth(): void {
    this.currentMonth = new Date(
      this.currentMonth.getFullYear(),
      this.currentMonth.getMonth() + 1,
      1
    );
    this.generateCalendarDays();
  }

  // Select date for custom range
  selectDate(date: Date): void {
    if (!date) return;

    if (!this.startDate || (this.startDate && this.endDate)) {
      // Start new selection
      this.startDate = date;
      this.endDate = null;
    } else if (this.startDate && !this.endDate) {
      // Complete the selection
      if (date < this.startDate) {
        this.endDate = this.startDate;
        this.startDate = date;
      } else {
        this.endDate = date;
      }
    }
  }

  // Check if date is selected
  isDateSelected(date: Date): boolean {
    if (!date) return false;
    return (!!this.startDate && this.isSameDay(date, this.startDate)) ||
      (!!this.endDate && this.isSameDay(date, this.endDate));
  }

  // Check if date is in range
  isDateInRange(date: Date): boolean {
    if (!date || !this.startDate || !this.endDate) return false;
    return date > this.startDate && date < this.endDate;
  }

  // Check if date is today
  isToday(date: Date): boolean {
    if (!date) return false;
    const today = new Date();
    return this.isSameDay(date, today);
  }

  // Helper to compare dates (ignoring time)
  private isSameDay(date1: Date, date2: Date): boolean {
    return date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear();
  }

  // Apply date selection
  applyDateSelection(): void {
    if (this.startDate && this.endDate) {
      this.rangeType = 'Custom';
      this.selectedRange = `Custom (${this.formatDateRangeDisplay(this.startDate)} - ${this.formatDateRangeDisplay(this.endDate)})`;
      this.showCustomCalendar = false;
      this.showDateDropdown = false;

      // Extract selected month from the date range
      this.updateSelectedMonthFromDateRange();
      this.fetchDataBasedOnRange();
    }
  }

  // Cancel date selection
  cancelDateSelection(): void {
    this.startDate = null;
    this.endDate = null;
    this.showCustomCalendar = false;
    this.showDateDropdown = false;
  }

  // Toggle dropdown
  toggleDateDropdown(): void {
    this.showDateDropdown = !this.showDateDropdown;
    if (this.showDateDropdown) {
      // Always show the quick options first when opening
      this.showCustomCalendar = false;
      this.initializeCalendar();
    }
  }

  // Filter available view types based on menu access
  private filterAvailableViewTypes(): void {
    try {
      const menuAccessRaw = localStorage.getItem('menu_access');
      let menuAccess: any[] = [];
      if (menuAccessRaw) {
        try {
          menuAccess = JSON.parse(this.util.decrypt(menuAccessRaw) || '[]');
        } catch (e) {
          menuAccess = [];
        }
      }

      // Get menu names the user has access to safely
      let accessibleMenuNames = menuAccess
        .filter((menu: any) => menu && menu.menu_name)
        .map((menu: any) => menu.menu_name.toLowerCase());

      // Filter accessibleMenuNames based on subscribedFeatures, just like the sidebar does
      try {
        const userRole = localStorage.getItem('ur');
        const isSuperAdmin = userRole && this.util.decrypt(userRole) === 'SA';
        
        if (!isSuperAdmin) {
          const rawFeatures = localStorage.getItem('subscribedFeatures');
          if (rawFeatures) {
            const subscribedFeatures = JSON.parse(this.util.decrypt(rawFeatures));
            if (subscribedFeatures && subscribedFeatures.features) {
              const core = subscribedFeatures.features.coreModules || {};
              const other = subscribedFeatures.features.otherModules || {};
              
              const featureMenuMap: { [key: string]: boolean } = {
                library: !!core.library,
                'content library': !!core.library,
                assessments: !!core.assessment,
                assessment: !!core.assessment,
                operations: !!core.assessment,
                finance: !!other.finance,
                customer: !!other.customer,
                customers: !!other.customer
              };
              
              accessibleMenuNames = accessibleMenuNames.filter((name: string) => {
                if (featureMenuMap.hasOwnProperty(name)) {
                  return featureMenuMap[name];
                }
                return true;
              });
            }
          }
        }
      } catch (e) {
        console.error("Error applying subscribed features filter", e);
      }

      // Check user access to Assessment Planning and Content Library
      const hasAssessmentAccess = accessibleMenuNames.includes('assessments') || accessibleMenuNames.includes('assessment') || accessibleMenuNames.includes('operations');
      const hasLibraryAccess = accessibleMenuNames.includes('library') || accessibleMenuNames.includes('content library');

      const filteredViewTypes: { value: string, label: string }[] = [];

      // Add 'Assessment Planning' if user has access to Assessments or Operations menu
      if (hasAssessmentAccess) {
        filteredViewTypes.push({ value: 'assessment', label: 'Assessment Planning' });
      }

      // Add 'Content Library' if user has access to Library menu
      if (hasLibraryAccess) {
        filteredViewTypes.push({ value: 'library', label: 'Content Library' });
      }

      // The "All" tab should only be displayed if BOTH Assessment and Content Library are visible.
      if (hasAssessmentAccess && hasLibraryAccess) {
        filteredViewTypes.unshift({ value: 'all', label: 'All' });
      }

      // ============================================================
      // UPDATED: Enable Assessment-by-Customers chart ONLY if:
      // 1. User is System Super Admin, OR
      // 2. Organization ID is 1 (Navriti Technologies)
      // ============================================================
      const userRole = localStorage.getItem('ur');
      const isSystemSuperAdmin = userRole && this.util.decrypt(userRole) === 'SA';
      
      // Get the organization ID from this.org_id or decrypted localStorage OrgId
      let orgIdNum = this.org_id ? parseInt(String(this.org_id), 10) : null;
      if (!orgIdNum) {
        const storedOrgId = localStorage.getItem('OrgId');
        if (storedOrgId) {
          try {
            const decrypted = this.util.decrypt(storedOrgId);
            orgIdNum = parseInt(decrypted, 10);
          } catch (e) {
            orgIdNum = parseInt(storedOrgId, 10);
          }
        }
      }
      const isNavritiOrg = orgIdNum === 1;
      
      // Only show if System Super Admin OR Organization ID is 1
      this.canShowAssessmentCustomerChart = isSystemSuperAdmin || isNavritiOrg;
      
      console.log('Assessment by Customers visibility:', {
        isSystemSuperAdmin,
        orgId: orgIdNum,
        isNavritiOrg,
        canShow: this.canShowAssessmentCustomerChart
      });

      // Update filter headers based on access
      this.updateFilterHeadersBasedOnAccess();

      this.availableViewTypes = filteredViewTypes;

      // Set default view to first available
      if (this.availableViewTypes.length > 0) {
        this.selectedViewType = this.availableViewTypes[0].value;
      } else {
        this.selectedViewType = 'all'; // Fallback if no permissions
      }
    } catch (error) {
      console.error("Error in filterAvailableViewTypes:", error);
      this.availableViewTypes = [];
      this.canShowAssessmentCustomerChart = false;
      this.updateFilterHeadersBasedOnAccess();
      this.selectedViewType = 'all';
    }
  }

  // Update filter headers based on user access to customer module
  private updateFilterHeadersBasedOnAccess(): void {
    const userRole = localStorage.getItem('ur');
    const isSystemSuperAdmin = userRole && this.util.decrypt(userRole) === 'SA';
    const orgId = this.org_id ? parseInt(this.org_id, 10) : null;
    const isNavritiOrg = orgId === 1;
    
    // Only show customer-related filters if System Super Admin OR Org ID is 1
    const showCustomerFilters = isSystemSuperAdmin || isNavritiOrg;

    // Assessment Course Filter Headers
    this.assessmentCourseFilterHeaders = [
      { key: 'course', name: 'Course' },
      { key: 'geography', name: 'Geography' },
      ...(showCustomerFilters ? [{ key: 'customer', name: 'Customer' }] : []),
    ];

    // Assessment Evaluation Filter Headers
    this.assessmentEvaluationFilterHeaders = [
      { key: 'course', name: 'Course' },
      { key: 'geography', name: 'Geography' }
    ];

    // Pass/Fail Filter Headers
    this.passFailFilterHeaders = [
      { key: 'course', name: 'Course' },
      ...(showCustomerFilters ? [{ key: 'customer', name: 'Customer' }] : []),
    ];

    // Candidate Performance Filter Headers
    this.candidatePerformanceFilterHeaders = [
      { key: 'courses', name: 'Courses' },
      { key: 'geography', name: 'Geography' },
      ...(showCustomerFilters ? [{ key: 'customers', name: 'Customers' }] : []),
    ];

    // Geographic Insights Filter Headers
    this.geographicInsightFilterHeaders = [
      { key: 'courses', name: 'Course' },
      { key: 'geography', name: 'Geography' },
      ...(showCustomerFilters ? [{ key: 'customer', name: 'Customer' }] : [])
    ];

    // Candidate Insights Filter Headers
    this.candidateInsightFilterHeaders = [
      { key: 'geography', name: 'Geography' },
      { key: 'courses', name: 'Course' },
      ...(showCustomerFilters ? [{ key: 'customer', name: 'Customers' }] : []),
      { key: 'date', name: 'Date' }
    ];

    // Assessment Insights Filter Headers
    this.assessmentInsightFilterHeaders = [
      { key: 'courses', name: 'Course' },
      ...(showCustomerFilters ? [{ key: 'customer', name: 'Customers' }] : [])
    ];
  }

  // Select View Type (All, Assessment Planning, Content Library)
  selectViewType(viewType: string): void {
    // Switch view and refresh charts for the selected view
    this.selectedViewType = viewType;

    // Check if we can reuse cached data (valid for 5 seconds)
    const now = Date.now();
    const isCacheValid = (now - this.lastDataFetchTimestamp) < this.DATA_CACHE_VALIDITY_MS;

    if (viewType === 'assessment') {
      // Assessment view - fetch summary and chart data
      // Only fetch if cache is invalid, otherwise use cached data
      if (!isCacheValid) {
        this.getOperationsData(); // Fetch summary metrics
        this.getGeographyData(); // Fetch geography data
        this.getCoursesMasterData(); // Fetch courses master data
        this.getLanguagesMasterData(); // Fetch languages master data
        this.getSalesCustomerMasterData(); // Fetch sales customers master data
        this.getAllProduct(); // Fetch all product data
      }

      // Always fetch assessment-specific data as they may have changed
      this.fetchAssessmentLocationData();
      this.fetchAssessmentCourseData();
      this.fetchAssessmentStatusData();
      this.fetchAssessmentEvaluationData();
      this.fetchCandidateAssessmentData();
      this.fetchPassFailData();
      this.initializeGeographicChart(); // Initialize geographic insights map

      this.cdr.detectChanges();
      // Proper timeout for chart initialization - 0ms was too aggressive and caused charts to disappear
      setTimeout(() => {
        if (this.showAssessmentLocationChart && document.getElementById('assessmentLocationChart')) {
          this.initializeAssessmentLocationBarChart();
        }
        if (this.showAssessmentCourseChart && document.getElementById('assessmentCourseChart')) {
          this.initializeAssessmentCourseBarChart();
        }
        if (this.showAssessmentStatusChart && document.getElementById('assessmentStatusChart')) {
          this.initializeAssessmentStatusDoughnutChart();
        }
        if (this.showAssessmentEvaluationChart && document.getElementById('assessmentEvaluationChart')) {
          this.initializeAssessmentEvaluationPieChart();
        }
        if (this.showCandidateAssessmentChart && document.getElementById('candidateAssessmentChart')) {
          this.initializeCandidateAssessmentPieChart();
        }
        if (this.showCandidateInsightsDonutChart && document.getElementById('candidateInsightsChart')) {
          this.initializeCandidateInsightsDonutChart();
        }
        if (this.showPassFailChart && document.getElementById('passFailChart')) {
          this.initializePassFailDoughnutChart();
        }
        if (this.canShowAssessmentCustomerChart && this.showAssessmentCustomerChart && document.getElementById('assessmentCustomerChart')) {
          this.initializeAssessmentCustomerChart();
        }
      }, 150); // Increased to 150ms to ensure DOM is fully rendered before chart initialization
    } else if (viewType === 'all') {
      // All view - ALWAYS fetch ALL APIs since this combines both views
      // Don't use cache for 'all' view to ensure all charts load properly
      this.getOperationsData();
      this.getGeographyData();
      this.getCoursesMasterData();
      this.getLanguagesMasterData();
      this.getSalesCustomerMasterData();
      this.getAllProduct();
      
      // Fetch content library data (question counts)
      this.fetchContentLibraryData();

      // --- Assessment-specific APIs ---
      this.fetchAssessmentLocationData();
      this.fetchAssessmentCourseData();
      this.fetchAssessmentStatusData();
      this.fetchAssessmentEvaluationData();
      this.fetchCandidateAssessmentData();
      this.fetchPassFailData();
      this.initializeGeographicChart();
      // First, ensure all charts are reinitialized
      this.cdr.detectChanges();

      setTimeout(() => {
        // Reinitialize assessment charts
        if (this.showAssessmentLocationChart && document.getElementById('assessmentLocationChart')) {
          this.initializeAssessmentLocationBarChart();
        }
        if (this.showAssessmentCourseChart && document.getElementById('assessmentCourseChart')) {
          this.initializeAssessmentCourseBarChart();
        }
        if (this.showAssessmentStatusChart && document.getElementById('assessmentStatusChart')) {
          this.initializeAssessmentStatusDoughnutChart();
        }
        if (this.showAssessmentEvaluationChart && document.getElementById('assessmentEvaluationChart')) {
          this.initializeAssessmentEvaluationPieChart();
        }
        if (this.showCandidateAssessmentChart && document.getElementById('candidateAssessmentChart')) {
          this.initializeCandidateAssessmentPieChart();
        }
        if (this.showCandidateInsightsDonutChart && document.getElementById('candidateInsightsChart')) {
          this.initializeCandidateInsightsDonutChart();
        }
        if (this.showPassFailChart && document.getElementById('passFailChart')) {
          this.initializePassFailDoughnutChart();
        }
        if (this.canShowAssessmentCustomerChart && this.showAssessmentCustomerChart && document.getElementById('assessmentCustomerChart')) {
          this.initializeAssessmentCustomerChart();
        }
        
        // Library charts are initialized in fetchContentLibraryData() when data is ready
      }, 150); // Increased to 150ms to ensure DOM is fully rendered before chart initialization
    } else if (viewType === 'library') {
      // Library view - prepare library-specific charts
      if (!isCacheValid) {
        this.getCoursesMasterData(); // Fetch courses master data
        this.getLanguagesMasterData(); // Fetch languages master data
        this.getSalesCustomerMasterData(); // Fetch sales customers master data
        this.getAllProduct(); // Fetch all product data
      }

      // Fetch content library data to populate all charts
      this.fetchContentLibraryData();

      this.cdr.detectChanges();
    } else {
      // No data available, just trigger change detection
      this.cdr.detectChanges();
    }
  }

  // Fetch content library data (question counts) for the All view
  private fetchContentLibraryData(): void {
    // Ensure org_id is properly converted to integer
    const orgIdAsInt = this.org_id ? parseInt(this.org_id, 10) : null;
    
    if (!orgIdAsInt) {
      console.error('Organization ID is not set. Cannot fetch content library data.');
      return;
    }

    let { startDate, endDate } = this.formatDateRange(this.rangeType, this.startDate, this.endDate);
    
    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

    const resp = this.service.getContentsData({
      org_id: orgIdAsInt,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          // Extract question counts
          this.extractQuestionCountsFromResponse(response);
          
          // CRITICAL FIX: Also update questionSummary from response when organization changes
          // This ensures that summary metrics (active questions, total questions, etc.) 
          // display the new organization's data, not stale values
          if (response.summary) {
            this.questionSummary = response.summary;
            console.log('Updated questionSummary during org change:', this.questionSummary);
          }
          
          // Prepare library charts when data is available
          if (this.questionCounts && this.questionCounts.length > 0) {
            // Prepare all library chart data immediately (no setTimeout delay)
            this.prepareNewCourseData(this.questionCounts);
            this.prepareTop10CourseData(this.questionCounts);
            this.prepareQuestionPaperByCourseData(this.questionCounts);
            this.prepareCourseData(this.questionCounts);
            this.prepareTypeData(this.questionCounts);
            this.prepareDifficultyData(this.questionCounts);
            this.prepareLanguageData(this.questionCounts);
            this.prepareEvaluationModeData(this.questionCounts);
            this.prepareCategoryData(this.questionCounts);
            this.prepareStatusData(this.questionCounts);
            this.prepareQuestionsByTypeData();
            this.cdr.detectChanges();
          }

          // Initialize charts after DOM elements are rendered
          setTimeout(() => {
            if (this.showNewCourseBarChart && document.getElementById('newCourseBarChart')) {
              this.initializeNewCourseBarChart();
            }
            if (this.showTop10CourseBarChart && document.getElementById('top10CourseBarChart')) {
              this.initializeTop10CourseBarChart();
            }
            if (this.showQuestionPaperByCourseBarChart && document.getElementById('questionPaperByCourseBarChart')) {
              this.initializeQuestionPaperByCourseBarChart();
            }
            if (this.courseBarChartData && this.courseBarChartData.length > 0 && document.getElementById('courseBarChart')) {
              this.initializeCourseBarChart();
            }
            if (this.showTypeBarChart && document.getElementById('typeBarChart')) {
              this.initializeTypeBarChart();
            }
            if (document.getElementById('questionPaperInsightsChart')) {
              this.initializeQuestionPaperInsightsDonutChart();
            }
            if (this.showQuestionsByTypeChart && document.getElementById('questionsByTypeChart')) {
              this.initializeQuestionsByTypeChart();
            }
          }, 0);
        }
      },
      (error) => {
        console.error('Error fetching content library data:', error);
      }
    );
  }

  // Reset all data (works for any view)
  resetAllData(): void {
    // Reset All view charts
    this.newCourseBarChartData = [];
    this.questionPaperByCourseChartData = [];
    this.showNewCourseBarChart = false;
    this.showQuestionPaperByCourseBarChart = false;

    // Reset Assessment charts
    this.assessmentLocationChartData = [];
    this.showAssessmentLocationChart = false;
    this.assessmentCourseChartData = [];
    this.showAssessmentCourseChart = false;
    this.assessmentStatusChartData = [];
    this.showAssessmentStatusChart = false;
    this.assessmentEvaluationChartData = [];
    this.showAssessmentEvaluationChart = false;
    this.candidateAssessmentChartData = [];
    this.showCandidateAssessmentChart = false;
    this.passFailChartData = [];
    this.showPassFailChart = false;

    // Reset Library view charts
    this.courseBarChartData = [];
    this.showCourseBarChart = false;

    // Reset other charts
    this.difficultyChartData = [];
    this.showDifficultyDonutChart = false;
    this.typeBarChartData = [];
    this.showTypeBarChart = false;
    this.languageChartData = [];
    this.showLanguageDonutChart = false;
    this.categoryChartData = [];
    this.showCategoryPieChart = false;
    this.statusChartData = [];
    this.showStatusPieChart = false;
    this.questionsByTypeChartData = [];
    this.showQuestionsByTypeChart = false;
  }

  // Reset date filters to default
  resetDateFilters(): void {
    this.rangeType = 'This month';
    this.selectedRange = this.monthNames[new Date().getMonth()]; // Set to current month
    this.startDate = null;
    this.endDate = null;
    this.showCustomCalendar = false;
    // Reset assessment summary
    this.resetAssessmentSummary();
    this.showDateDropdown = false;
  }

  private setDefaultCurrentMonthRange(): void {
    const today = new Date();
    const currentMonth = today.getMonth(); // 0-11
    const currentYear = today.getFullYear();

    this.rangeType = 'Custom';
    this.selectedRange = this.monthNames[currentMonth]; // Use current month name
    this.startDate = new Date(currentYear, currentMonth, 1);
    this.endDate = new Date(currentYear, currentMonth + 1, 0); // Last day of current month
    this.updateSelectedMonthFromDateRange();
    this.fetchDataBasedOnRange();
  }

  // Calculate percentage for course chart
  getPercentage(item: any, dataArray: any[]): number {
    if (!dataArray || dataArray.length === 0) return 0;
    const total = dataArray.reduce((sum, d) => sum + d.value, 0);
    if (total === 0) return 0;
    return Math.round((item.value / total) * 100);
  }

  // Calculate percentage for question paper chart
  getPercentageQP(item: any, dataArray: any[]): number {
    if (!dataArray || dataArray.length === 0) return 0;
    const total = dataArray.reduce((sum, d) => sum + d.value, 0);
    if (total === 0) return 0;
    return Math.round((item.value / total) * 100);
  }

  // Select range from quick options
  selectRange(range: string): void {
    if (range === 'Custom') {
      this.selectedRange = 'Custom';
      this.rangeType = 'Custom';
      // Show calendar for custom date selection
      this.showCustomCalendar = true;
      this.initializeCalendar();
      // Keep dropdown open, just switch to calendar view
    } else {
      // Auto-populate date range based on selection
      const today = new Date();

      switch (range) {
        case 'This month':
          this.rangeType = 'This month';
          this.startDate = new Date(today.getFullYear(), today.getMonth(), 1);
          this.endDate = today;
          this.selectedRange = this.monthNames[today.getMonth()];
          break;
        case 'Last 30 days':
          this.rangeType = 'Last 30 days';
          this.startDate = new Date(today);
          this.startDate.setDate(today.getDate() - 29); // 30 days including today
          this.endDate = today;
          this.selectedRange = `Last 30 days (${this.formatDateRangeDisplay(this.startDate)} - ${this.formatDateRangeDisplay(this.endDate)})`;
          break;
        case 'Last 6 months':
          this.rangeType = 'Last 6 months';
          this.startDate = new Date(today);
          this.startDate.setMonth(today.getMonth() - 6);
          this.endDate = today;
          this.selectedRange = `Last 6 months (${this.formatDateRangeDisplay(this.startDate)} - ${this.formatDateRangeDisplay(this.endDate)})`;
          break;
        case 'Last 1 year':
          this.rangeType = 'Last 1 year';
          this.startDate = new Date(today);
          this.startDate.setFullYear(today.getFullYear() - 1);
          this.endDate = today;
          this.selectedRange = `Last 1 year (${this.formatDateRangeDisplay(this.startDate)} - ${this.formatDateRangeDisplay(this.endDate)})`;
          break;
        case 'Today':
          this.rangeType = 'Today';
          this.startDate = today;
          this.endDate = today;
          this.selectedRange = `Today (${this.formatDateRangeDisplay(this.startDate)})`;
          break;
        case 'Last 7 days':
          this.rangeType = 'Last 7 days';
          this.startDate = new Date(today);
          this.startDate.setDate(today.getDate() - 6); // 7 days including today
          this.endDate = today;
          this.selectedRange = `Last 7 days (${this.formatDateRangeDisplay(this.startDate)} - ${this.formatDateRangeDisplay(this.endDate)})`;
          break;
      }

      this.showCustomCalendar = false;
      this.showDateDropdown = false;
      // Extract selected month from the date range
      this.updateSelectedMonthFromDateRange();
      this.fetchDataBasedOnRange();
    }
  }

  // Get available years (current year - 5 to current year + 5)
  getAvailableYears(): number[] {
    const currentYear = new Date().getFullYear();
    const years: number[] = [];
    for (let i = currentYear - 5; i <= currentYear + 5; i++) {
      years.push(i);
    }
    return years;
  }

  // Get available months
  getAvailableMonths(): string[] {
    return this.monthNames;
  }

  // Extract and update the selected month/year from the current date range
  private updateSelectedMonthFromDateRange(): void {
    // Use the end date to determine the selected month (or start date for single-day selections)
    const referenceDate = this.endDate || this.startDate || new Date();
    this.selectedDateFilterMonth = referenceDate.getMonth() + 1; // Convert 0-11 to 1-12
    this.selectedDateFilterYear = referenceDate.getFullYear();
    console.log(`Selected month for Assessment Insights: ${this.monthNames[this.selectedDateFilterMonth - 1]} ${this.selectedDateFilterYear}`);
  }

  // Toggle year picker for calendar
  toggleYearPicker(): void {
    this.showYearPicker = !this.showYearPicker;
    if (this.showYearPicker) {
      this.showMonthPicker = false;
    }
  }

  // Toggle month picker for calendar
  toggleMonthPicker(): void {
    this.showMonthPicker = !this.showMonthPicker;
    if (this.showMonthPicker) {
      this.showYearPicker = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.showQuestionPaperInsightFilterPanel = false;
    this.showQuestionPaperInsightFilterPanels = false;
    this.showCandidateInsightFilterPanel = false;
    this.showAssessmentInsightFilterPanel = false;
    this.showAssessmentEvaluationFilterPanel = false;
    this.showPassFailFilterPanel = false;
    this.showCandidatePerformanceFilterPanel = false;
    this.showAssessmentLanguageFilterPanel = false;
    this.showGeographicInsightFilterPanel = false;
    // Add additional ones if needed, but these are the main responsive offenders
  }

  // Close pickers and dropdowns when clicking outside
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    // Check if click is outside year/month picker
    if (!target.closest('.year-month-picker') && !target.closest('.month-year-filters')) {
      this.showYearPicker = false;
      this.showMonthPicker = false;
      this.showAssessmentLanguageYearDropdown = false;
      this.showAssessmentLanguageMonthDropdown = false;
      this.showAssessmentCustomerYearDropdown = false;
      this.showAssessmentCustomerMonthDropdown = false;
      this.showCandidateAssessmentYearDropdown = false;
      this.showCandidateAssessmentMonthDropdown = false;
      this.showPassFailYearDropdown = false;
      this.showPassFailMonthDropdown = false;
      this.showQuestionPaperInsightYearDropdown = false;
      this.showQuestionPaperInsightMonthDropdown = false;
      this.showCandidateInsightYearDropdown = false;
      this.showCandidateInsightMonthDropdown = false;
      this.showGeographicInsightYearDropdown = false;
      this.showGeographicInsightMonthDropdown = false;
    }

    // Close organization dropdown if clicked outside
    const isClickInsideOrgDropdown = target.closest('.custom-org-dropdown-wrapper') ||
      target.closest('.custom-org-dropdown-menu');
    if (!isClickInsideOrgDropdown) {
      this.showOrgDropdown = false;
    }

    // Close all filter panels and chart menus if clicked outside
    const isClickInsideFilterPanel = target.closest('.filter-panel-container');
    const isClickOnFilterButton = target.closest('.filter-button') ||
      target.closest('.filter-toggle-btn');

    const isClickInsideChartMenu = target.closest('.chart-menu-dropdown');
    const isClickOnChartMenuButton = target.closest('.chart-menu-button') ||
      target.closest('.chart-menu-btn');

    // If clicked outside both panel and button, close all filter panels
    if (!isClickInsideFilterPanel && !isClickOnFilterButton) {
      // Close all Content Library filter panels
      this.showFilterPanel = false;
      this.showTypeFilterPanel = false;
      this.showLanguageFilterPanel = false;
      this.showCategoryFilterPanel = false;
      this.showStatusFilterPanel = false;
      this.showCourseFilterPanel = false;
      this.showQuestionPaperCourseFilterPanel = false;
      this.showQuestionPaperDifficultyFilterPanel = false;
      this.showTop10CourseFilterPanel = false;

      // Close all Assessment filter panels
      this.showAssessmentLocationFilterPanel = false;
      this.showAssessmentCourseFilterPanel = false;
      this.showAssessmentStatusFilterPanel = false;
      this.showAssessmentEvaluationFilterPanel = false;
      this.showCandidateAssessmentFilterPanel = false;
      this.showPassFailFilterPanel = false;

      // Add missing panels
      this.showDifficultyFilterPanel = false;
      this.showAssessmentCustomerFilterPanel = false;
      this.showAssessmentLanguageFilterPanel = false;
      this.showAssessmentInsightFilterPanel = false;
      this.showCandidateInsightFilterPanel = false;
      this.showQuestionPaperInsightFilterPanel = false;
      this.showQuestionPaperInsightFilterPanels = false;
      this.showGeographicInsightFilterPanel = false;
      this.showCandidatePerformanceFilterPanel = false;

      // Close new course filter panel
      this.showNewCourseFilterPanel = false;
      this.showQuestionPaperCategoryFilterPanel = false;
    }

    // If clicked outside both menu and button, close all chart menus
    if (!isClickInsideChartMenu && !isClickOnChartMenuButton) {
      // Close all Content Library chart menus
      this.showChartMenu = false;
      this.showTypeChartMenu = false;
      this.showLanguageChartMenu = false;
      this.showCategoryChartMenu = false;
      this.showStatusChartMenu = false;
      this.showCourseChartMenu = false;
      this.showQuestionPaperCourseChartMenu = false;
      this.showQuestionPaperDifficultyChartMenu = false;
      this.showTop10CourseChartMenu = false;

      // Close all Assessment chart menus
      this.showAssessmentLocationChartMenu = false;
      this.showAssessmentCourseChartMenu = false;
      this.showAssessmentStatusChartMenu = false;
      this.showAssessmentEvaluationChartMenu = false;
      this.showCandidateAssessmentChartMenu = false;
      this.showPassFailChartMenu = false;

      // Close new course chart menu
      this.showNewCourseChartMenu = false;
      this.showQuestionPaperCategoryChartMenu = false;
    }
  }

  // Format date for display
  formatDisplayDate(date: Date | null): string {
    if (!date) return '';
    return date.toLocaleDateString('en-US', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  // Format date in DD-MM-YYYY format for date range display
  formatDateRangeDisplay(date: Date | null): string {
    if (!date) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }


  // Prepare category data for pie chart
  private prepareCategoryData(courses: any[]): void {

    if (courses.length === 0) {
      this.categoryChartData = [];
      this.categoryBarChartData = [];
      this.showCategoryPieChart = false;
      this.showCategoryBarChart = false;
      return;
    }

    // Reset data
    this.categoryChartData = [];

    // Check if we should show overall category or course-wise
    if (this.shouldShowOverallCategory()) {
      this.prepareOverallCategoryData(courses);
    } else {
      this.prepareMultipleCoursesCategoryData(courses);
    }

    // Filter out zero values and undefined data from category chart
    this.categoryChartData = this.categoryChartData.filter(item =>
      item && item.value > 0 && item.name && item.name !== 'undefined'
    );

    // Prepare bar chart data from category data
    this.prepareCategoryBarChartData();

    this.showCategoryPieChart = this.categoryChartData.length > 0;
    this.showCategoryBarChart = this.categoryBarChartData.length > 0;

    if (this.showCategoryPieChart) {
      this.cdr.detectChanges();
      setTimeout(() => {
        this.initializeCategoryPieChart();
      }, 200);
    }

    if (this.showCategoryBarChart) {
      this.cdr.detectChanges();
      setTimeout(() => {
        this.initializeCategoryBarChart();
      }, 200);
    }
  }

  // Prepare category data for bar chart
  private prepareCategoryBarChartData(): void {
    this.categoryBarChartData = [];

    if (!this.categoryChartData || this.categoryChartData.length === 0) {
      return;
    }

    // Sort by value in descending order
    const sortedData = [...this.categoryChartData].sort((a, b) => (b.value || 0) - (a.value || 0));

    // Take top 6 categories
    const topCategories = sortedData.slice(0, 6);

    // Calculate total for "Others" category
    const othersTotal = sortedData.slice(6).reduce((sum, item) => sum + (item.value || 0), 0);

    // Define colors for categories
    const categoryColors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#F67280', '#FF9A00' // Color for "Others"
    ];

    // Add top categories to bar chart data
    topCategories.forEach((item, index) => {
      this.categoryBarChartData.push({
        name: item.name,
        category_name: item.name,
        value: item.value,
        question_count: item.value,
        color: categoryColors[index % categoryColors.length],
        originalName: item.name,
        isTopCategory: true
      });
    });

    // Add "Others" category if there are remaining categories
    if (othersTotal > 0) {
      this.categoryBarChartData.push({
        name: 'Others',
        category_name: 'Others',
        value: othersTotal,
        question_count: othersTotal,
        color: categoryColors[6],
        originalName: 'Other Categories',
        isTopCategory: false
      });
    }
  }

  private initializeCategoryBarChart(): void {
    const canvas = document.getElementById('categoryBarChart') as HTMLCanvasElement;

    if (!canvas) {
      return;
    }

    // Destroy existing chart if it exists
    if (this.categoryBarChart) {
      this.categoryBarChart.destroy();
    }

    // Filter out zero values
    const nonZeroData = this.categoryBarChartData.filter(item => item.value > 0);
    if (nonZeroData.length === 0) {
      this.showCategoryBarChart = false;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
      return;
    }

    this.showCategoryBarChart = true;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      try {
        // Prepare chart data
        const labels = nonZeroData.map(item => item.name);
        const data = nonZeroData.map(item => item.value);
        const backgroundColors = nonZeroData.map(item => item.color);
        
        this.categoryBarChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: labels,
            datasets: [{
              label: 'Question Count',
              data: data,
              backgroundColor: backgroundColors,
              borderColor: backgroundColors.map(color => this.darkenColor(color, 20)),
              borderWidth: 1,
              borderRadius: 4,
              borderSkipped: false,
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  title: (context) => {
                    const index = context[0].dataIndex;
                    const item = nonZeroData[index];
                    return item.originalName || item.name;
                  },
                  label: (context) => {
                    const value = context.raw as number;
                    const total = data.reduce((sum, val) => sum + val, 0);
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                    return `Questions: ${value} (${percentage}%)`;
                  }
                }
              },
            },
            scales: {
              y: {
                beginAtZero: true,
                ticks: {
                  stepSize: 1
                }
              }
            }
          }
        });
      } catch (error) {
        console.error('Error initializing category bar chart:', error);
      }
    }
  }

  private prepareOverallCategoryData(courses: any[]): void {

    // Aggregate category counts across all selected courses
    const categoryTotals: { [key: string]: number } = {};

    courses.forEach((course) => {
      const breakdown = course.question_category_breakdown || {};
      Object.entries(breakdown).forEach(([categoryCode, count]) => {
        const normalizedCategory = categoryCode || 'Unknown';
        const categoryCount = typeof count === 'number' ? count : Number(count) || 0;
        categoryTotals[normalizedCategory] = (categoryTotals[normalizedCategory] || 0) + categoryCount;
      });
    });

    // Create chart data for overall category
    (Object.entries(categoryTotals) as [string, number][]).forEach(([categoryCode, count]) => {
      if (count > 0) {
        const categoryName = this.getCategoryName(categoryCode);
        const categoryColor = this.getCategoryColor(categoryCode);
        this.categoryChartData.push({
          name: categoryName,
          value: count,
          color: categoryColor,
          courseName: 'All Courses',
          originalCourseName: 'All Courses',
          courseId: 0,
          categoryCode: categoryCode
        });
      }
    });

  }

  private prepareMultipleCoursesCategoryData(courses: any[]): void {

    // Vibrant colors for different courses
    const courseColors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9',
      '#F8B195', '#F67280', '#C06C84', '#6C5B7B', '#355C7D',
      '#99B898', '#FECEAB', '#FF847C', '#E84A5F', '#2A363B'
    ];

    courses.forEach((course, courseIndex) => {
      const courseColor = courseColors[courseIndex % courseColors.length];
      const courseName = course.course_name || `Course ${courseIndex + 1}`;

      const categoryBreakdown = course.question_category_breakdown || {};

      Object.entries(categoryBreakdown).forEach(([categoryCode, value]) => {
        const count = typeof value === 'number' ? value : Number(value) || 0;
        if (count > 0) {
          const uniqueColor = this.generateUniqueColor(courseColor, categoryCode);
          const categoryName = this.getCategoryName(categoryCode);

          this.categoryChartData.push({
            name: categoryName,
            value: count,
            color: uniqueColor,
            courseName: courseName,
            originalCourseName: course.course_name,
            courseId: course.course_id,
            categoryCode: categoryCode,
            courseColor: courseColor
          });
        }
      });
    });

  }

  private getCategoryName(categoryCode: string): string {
    const category = this.availableCategories.find(cat => cat.value === categoryCode);
    return category ? category.label : categoryCode;
  }

  private initializeCategoryPieChart(): void {
    const canvas = document.getElementById('categoryPieChart') as HTMLCanvasElement;

    if (!canvas) {
      return;
    }

    // Destroy existing chart if it exists
    if (this.categoryPieChart) {
      this.categoryPieChart.destroy();
    }

    // Filter out zero values and invalid data
    const nonZeroData = this.categoryChartData.filter(item =>
      item && item.value > 0 && item.name && item.name !== 'undefined'
    );

    if (nonZeroData.length === 0) {
      this.showCategoryPieChart = false;

      // Clear canvas
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
      return;
    }

    this.showCategoryPieChart = true;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      try {
        // Create labels based on whether we're showing overall or course-wise data
        const isOverallView = this.shouldShowOverallCategory();
        const labels = isOverallView
          ? nonZeroData.map(item => item.name) // Just category names for overall view
          : nonZeroData.map(item => `${this.truncateCourseName(item.courseName)} - ${item.name}`); // Course + category for course-wise

        this.categoryPieChart = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: labels,
            datasets: [{
              data: nonZeroData.map(item => item.value),
              backgroundColor: nonZeroData.map(item => item.color),
              borderColor: '#fff',
              borderWidth: 0,
              hoverOffset: 0,
              hoverBorderWidth: 0,
              hoverBorderColor: 'transparent',
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  label: (context) => {
                    const index = context.dataIndex;
                    const item = nonZeroData[index];
                    const value = context.raw as number;
                    const total = nonZeroData.reduce((sum, dataItem) => sum + dataItem.value, 0);
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';

                    if (isOverallView) {
                      return [
                        `Category: ${item.name}`,
                        `Count: ${value}`,
                        `Percentage: ${percentage}%`
                      ];
                    } else {
                      return [
                        `Course: ${item.courseName}`,
                        `Category: ${item.name}`,
                        `Count: ${value}`,
                        `Percentage: ${percentage}%`
                      ];
                    }
                  }
                }
              }
            },
            animation: {
              animateScale: true,
              animateRotate: true
            },
            layout: {
              padding: {
                top: 10,
                right: 10,
                bottom: 20,
                left: 10
              }
            }
          }
        });
      } catch (error) {
        this.showCategoryPieChart = false;
      }
    }
  }

  private shouldShowOverallCategory(): boolean {
    const hasCourseFilter = this.selectedCategoryCourseIds.length > 0;
    const hasCategoryFilter = this.selectedCategories.length > 0;

    if (!hasCourseFilter) {
      return true;
    }

    if (this.selectedCategoryCourseIds.length === this.courseList.length) {
      return true;
    }

    if (this.selectedCategoryCourseIds.length === 1) {
      return false;
    }

    if (this.selectedCategoryCourseIds.length > 5) {
      return true;
    }

    return false;
  }

  // Filter Panel Methods
  toggleCategoryFilterPanel(): void {
    this.showCategoryFilterPanel = !this.showCategoryFilterPanel;

    if (this.showCategoryFilterPanel) {
      this.showCategoryChartMenu = false; // Close menu when opening filter
      // Initialize filtered lists when opening panel
      this.filteredCategoryCourseList = [...this.courseList];
      this.filteredCategoryLanguageList = [...this.languagesData];
      this.filteredCategoryDifficultyList = [...this.availableLanguageDifficultyLevels];
      this.filteredCategoryTypeList = [...this.availableQuestionTypes];
      this.filteredCategoryList = [...this.availableCategories];
      this.activeCategoryFilterHeader = 'categories'; // Default to categories tab
      // Force change detection
      this.cdr.detectChanges();
    }
  }

  setActiveCategoryFilterHeader(headerKey: string): void {
    this.activeCategoryFilterHeader = headerKey;
  }

  clearCategoryFilters(): void {
    this.selectedCategoryCourseIds = [];
    this.selectedCategories = [];
    this.selectedCategoryLanguages = [];
    this.selectedCategoryDifficultyLevels = [];
    this.selectedCategoryTypes = [];
    this.categoryCourseSearchTerm = '';
    this.categorySearchTerm = '';
    this.categoryLanguageSearchTerm = '';
    this.categoryDifficultySearchTerm = '';
    this.categoryTypeSearchTerm = '';
    this.filteredCategoryCourseList = [...this.courseList];
    this.filteredCategoryList = [...this.availableCategories];
    this.filteredCategoryLanguageList = [...this.languagesData];
    this.filteredCategoryDifficultyList = [...this.availableLanguageDifficultyLevels];
    this.filteredCategoryTypeList = [...this.availableQuestionTypes];
    this.updateCategoryFilteredData();
  }

  // Course selection methods for category chart
  isCourseSelectedForCategory(courseId: number): boolean {
    return this.selectedCategoryCourseIds.includes(courseId);
  }

  toggleCourseSelectionForCategory(courseId: number): void {
    const index = this.selectedCategoryCourseIds.indexOf(courseId);
    if (index > -1) {
      this.selectedCategoryCourseIds.splice(index, 1);
    } else {
      this.selectedCategoryCourseIds.push(courseId);
    }
    this.updateCategoryFilteredData();
  }

  areAllCoursesSelectedForCategory(): boolean {
    if (this.courseList.length === 0) return false;
    return this.selectedCategoryCourseIds.length === this.courseList.length;
  }

  toggleAllCoursesSelectionForCategory(): void {
    if (this.areAllCoursesSelectedForCategory()) {
      this.selectedCategoryCourseIds = [];
    } else {
      this.selectedCategoryCourseIds = this.courseList.map(course => course.course_id);
    }
    this.updateCategoryFilteredData();
  }

  isCoursesSelectionIndeterminateForCategory(): boolean {
    return this.selectedCategoryCourseIds.length > 0 &&
      this.selectedCategoryCourseIds.length < this.courseList.length;
  }

  // Category Selection Methods for Content Library
  isCategorySelected(categoryValue: string): boolean {
    return this.selectedCategories.includes(categoryValue);
  }

  toggleCategorySelection(categoryValue: string): void {
    const index = this.selectedCategories.indexOf(categoryValue);
    if (index > -1) {
      this.selectedCategories.splice(index, 1);
    } else {
      this.selectedCategories.push(categoryValue);
    }
    this.updateCategoryFilteredData();
  }

  // Language filter for Evaluation Mode
  isCategoryLanguageSelected(languageCode: string): boolean {
    return this.selectedCategoryLanguages.includes(languageCode);
  }

  toggleCategoryLanguageSelection(languageCode: string): void {
    const index = this.selectedCategoryLanguages.indexOf(languageCode);
    if (index > -1) {
      this.selectedCategoryLanguages.splice(index, 1);
    } else {
      this.selectedCategoryLanguages.push(languageCode);
    }
    this.updateCategoryFilteredData();
  }

  filterCategoryLanguages(): void {
    if (!this.categoryLanguageSearchTerm.trim()) {
      this.filteredCategoryLanguageList = [...this.languagesData];
      return;
    }

    const searchTerm = this.categoryLanguageSearchTerm.toLowerCase().trim();
    this.filteredCategoryLanguageList = this.languagesData.filter(language =>
      (language.name || '').toLowerCase().includes(searchTerm)
    );
  }

  filterCategoryDifficultyLevels(): void {
    if (!this.categoryDifficultySearchTerm.trim()) {
      this.filteredCategoryDifficultyList = [...this.availableLanguageDifficultyLevels];
      return;
    }

    const searchTerm = this.categoryDifficultySearchTerm.toLowerCase().trim();
    this.filteredCategoryDifficultyList = this.availableLanguageDifficultyLevels.filter(level =>
      level.label.toLowerCase().includes(searchTerm)
    );
  }

  filterCategoryTypes(): void {
    if (!this.categoryTypeSearchTerm.trim()) {
      this.filteredCategoryTypeList = [...this.availableQuestionTypes];
      return;
    }

    const searchTerm = this.categoryTypeSearchTerm.toLowerCase().trim();
    this.filteredCategoryTypeList = this.availableQuestionTypes.filter(type =>
      type.label.toLowerCase().includes(searchTerm)
    );
  }

  isCategoryTypeSelected(typeCode: string): boolean {
    return this.selectedCategoryTypes.includes(typeCode);
  }

  toggleCategoryTypeSelection(typeCode: string): void {
    const index = this.selectedCategoryTypes.indexOf(typeCode);
    if (index > -1) {
      this.selectedCategoryTypes.splice(index, 1);
    } else {
      this.selectedCategoryTypes.push(typeCode);
    }
    this.updateCategoryFilteredData();
  }

  areAllCategoryTypesSelected(): boolean {
    return this.selectedCategoryTypes.length === this.availableQuestionTypes.length;
  }

  toggleAllCategoryTypesSelection(): void {
    if (this.areAllCategoryTypesSelected()) {
      this.selectedCategoryTypes = [];
    } else {
      this.selectedCategoryTypes = this.availableQuestionTypes.map(type => type.value);
    }
    this.updateCategoryFilteredData();
  }

  isCategoryTypesSelectionIndeterminate(): boolean {
    return this.selectedCategoryTypes.length > 0 &&
      this.selectedCategoryTypes.length < this.availableQuestionTypes.length;
  }

  isCategoryDifficultyLevelSelected(levelValue: string): boolean {
    return this.selectedCategoryDifficultyLevels.includes(levelValue);
  }

  toggleCategoryDifficultyLevelSelection(levelValue: string): void {
    const index = this.selectedCategoryDifficultyLevels.indexOf(levelValue);
    if (index > -1) {
      this.selectedCategoryDifficultyLevels.splice(index, 1);
    } else {
      this.selectedCategoryDifficultyLevels.push(levelValue);
    }
    this.updateCategoryFilteredData();
  }

  areAllCategoryDifficultyLevelsSelected(): boolean {
    return this.selectedCategoryDifficultyLevels.length === this.availableLanguageDifficultyLevels.length;
  }

  toggleAllCategoryDifficultyLevelsSelection(): void {
    if (this.areAllCategoryDifficultyLevelsSelected()) {
      this.selectedCategoryDifficultyLevels = [];
    } else {
      this.selectedCategoryDifficultyLevels = this.availableLanguageDifficultyLevels.map(level => level.value);
    }
    this.updateCategoryFilteredData();
  }

  isCategoryDifficultyLevelsSelectionIndeterminate(): boolean {
    return this.selectedCategoryDifficultyLevels.length > 0 &&
      this.selectedCategoryDifficultyLevels.length < this.availableLanguageDifficultyLevels.length;
  }

  areAllCategoryLanguagesSelected(): boolean {
    return this.selectedCategoryLanguages.length === this.languagesData.length;
  }

  toggleAllCategoryLanguagesSelection(): void {
    if (this.areAllCategoryLanguagesSelected()) {
      this.selectedCategoryLanguages = [];
    } else {
      this.selectedCategoryLanguages = this.languagesData.map(language => language.code);
    }
    this.updateCategoryFilteredData();
  }

  isCategoryLanguagesSelectionIndeterminate(): boolean {
    return this.selectedCategoryLanguages.length > 0 &&
      this.selectedCategoryLanguages.length < this.languagesData.length;
  }

  filterCoursesByLanguageForCategory(courses: any[]): any[] {
    return courses.map(course => {
      if (!course.language_breakdown) {
        return null;
      }

      // Check if course has any of the selected languages
      const hasSelectedLanguage = this.selectedCategoryLanguages.some(language =>
        course.language_breakdown[language] > 0
      );

      if (!hasSelectedLanguage) {
        return null;
      }

      // Create a new course object with filtered category breakdown
      const filteredCourse = { ...course };

      // If we have category breakdown, filter it based on selected languages
      if (filteredCourse.question_category_breakdown && filteredCourse.language_breakdown) {
        // Recalculate category breakdown based on selected languages
        const filteredCategoryBreakdown: { [key: string]: number } = {};
        
        // For each selected language, we need to get its question count by category
        // Since we don't have language-category cross-tabulation, we'll filter based on language count proportion
        const totalQuestionsInSelectedLanguages = this.selectedCategoryLanguages.reduce((sum, lang) => 
          sum + (course.language_breakdown[lang] || 0), 0
        );

        if (totalQuestionsInSelectedLanguages > 0) {
          // Calculate the proportion of questions in selected languages
          const totalQuestionsInAllLanguages: number = (Object.values(course.language_breakdown as any)
            .reduce((sum: number, count: any) => sum + (typeof count === 'number' ? count : 0), 0) as any) as number;

          const languageFilterProportion = totalQuestionsInSelectedLanguages / totalQuestionsInAllLanguages;

          // Apply the proportion filter to category breakdown
          Object.entries(course.question_category_breakdown).forEach(([category, count]) => {
            const numCount = typeof count === 'number' ? count : Number(count) || 0;
            if (numCount > 0) {
              // Apply language filter proportionally to categories
              const filteredCount = Math.round(numCount * languageFilterProportion);
              if (filteredCount > 0) {
                filteredCategoryBreakdown[category] = filteredCount;
              }
            }
          });

          filteredCourse.question_category_breakdown = filteredCategoryBreakdown;
          filteredCourse.question_count = (Object.values(filteredCategoryBreakdown as any)
            .reduce((sum: number, count: any) => sum + (typeof count === 'number' ? count : 0), 0) as any) as number;
        }
      }

      return filteredCourse;
    }).filter(course => course !== null && course.question_count > 0);
  }

  filterCoursesByDifficultyForCategory(courses: any[]): any[] {
    return courses.map(course => {
      if (!course.difficulty_breakdown) return null;

      const filteredCourse = { ...course };
      const filteredDifficultyBreakdown: any = {};
      let hasSelectedDifficulty = false;
      let newDifficultyCount = 0;

      this.selectedCategoryDifficultyLevels.forEach(difficulty => {
        if (filteredCourse.difficulty_breakdown[difficulty] > 0) {
          hasSelectedDifficulty = true;
          filteredDifficultyBreakdown[difficulty] = filteredCourse.difficulty_breakdown[difficulty];
          newDifficultyCount += filteredCourse.difficulty_breakdown[difficulty];
        }
      });

      if (!hasSelectedDifficulty) return null;

      const originalCount = Object.values(course.difficulty_breakdown).reduce((sum: number, count: any) => sum + (typeof count === 'number' ? count : Number(count) || 0), 0) as number;
      
      if (originalCount > 0 && newDifficultyCount !== originalCount) {
        const proportion = newDifficultyCount / originalCount;
        
        if (filteredCourse.evaluation_mode_difficulty_breakdown) {
          // Use exact breakdown provided by API
          const newCategoryBreakdown: any = {};
          Object.entries(filteredCourse.evaluation_mode_difficulty_breakdown).forEach(([catCode, difficultyObj]: [string, any]) => {
            let catCount = 0;
            this.selectedCategoryDifficultyLevels.forEach(level => {
              if (difficultyObj[level] !== undefined) {
                catCount += Number(difficultyObj[level]) || 0;
              }
            });
            if (catCount > 0) {
              newCategoryBreakdown[catCode] = catCount;
            }
          });
          filteredCourse.question_category_breakdown = newCategoryBreakdown;
        } else if (filteredCourse.question_category_breakdown) {
          // Fallback to proportion
          const newCategoryBreakdown: any = {};
          Object.keys(filteredCourse.question_category_breakdown).forEach(cat => {
            newCategoryBreakdown[cat] = Math.round((filteredCourse.question_category_breakdown[cat] || 0) * proportion);
          });
          filteredCourse.question_category_breakdown = newCategoryBreakdown;
        }
      }

      filteredCourse.difficulty_breakdown = filteredDifficultyBreakdown;
      return filteredCourse;
    }).filter(course => course !== null);
  }

  filterCoursesByTypeForCategory(courses: any[]): any[] {
    return courses.map(course => {
      if (!course.type_breakdown) return null;

      const filteredCourse = { ...course };
      const filteredTypeBreakdown: any = {};
      let hasSelectedType = false;
      let newTypeCount = 0;

      this.selectedCategoryTypes.forEach(type => {
        if (filteredCourse.type_breakdown[type] > 0) {
          hasSelectedType = true;
          filteredTypeBreakdown[type] = filteredCourse.type_breakdown[type];
          newTypeCount += filteredCourse.type_breakdown[type];
        }
      });

      if (!hasSelectedType) return null;

      const originalCount = Object.values(course.type_breakdown).reduce((sum: number, count: any) => sum + (typeof count === 'number' ? count : Number(count) || 0), 0) as number;
      
      if (originalCount > 0 && newTypeCount !== originalCount) {
        const proportion = newTypeCount / originalCount;
        
        if (filteredCourse.question_category_breakdown) {
          const newCategoryBreakdown: any = {};
          Object.keys(filteredCourse.question_category_breakdown).forEach(cat => {
            newCategoryBreakdown[cat] = Math.round((filteredCourse.question_category_breakdown[cat] || 0) * proportion);
          });
          filteredCourse.question_category_breakdown = newCategoryBreakdown;
        }
      }

      filteredCourse.type_breakdown = filteredTypeBreakdown;
      return filteredCourse;
    }).filter(course => course !== null);
  }

  areAllCategoriesSelected(): boolean {
    return this.selectedCategories.length === this.availableCategories.length;
  }

  toggleAllCategoriesSelection(): void {
    if (this.areAllCategoriesSelected()) {
      this.selectedCategories = [];
    } else {
      this.selectedCategories = this.availableCategories.map(cat => cat.value);
    }
    this.updateCategoryFilteredData();
  }

  isCategoriesSelectionIndeterminate(): boolean {
    return this.selectedCategories.length > 0 &&
      this.selectedCategories.length < this.availableCategories.length;
  }

  // Update filtered data for category chart
  updateCategoryFilteredData(): void {
    let filteredCourses = this.questionCounts;

    // Apply course filter
    if (this.selectedCategoryCourseIds.length > 0) {
      filteredCourses = this.questionCounts.filter(course =>
        this.selectedCategoryCourseIds.includes(course.course_id)
      );
    }

    // Apply language filter
    if (this.selectedCategoryLanguages.length > 0) {
      filteredCourses = this.filterCoursesByLanguageForCategory(filteredCourses);
    }

    // Apply difficulty level filter
    if (this.selectedCategoryDifficultyLevels.length > 0) {
      filteredCourses = this.filterCoursesByDifficultyForCategory(filteredCourses);
    }

    // Apply type filter
    if (this.selectedCategoryTypes.length > 0) {
      filteredCourses = this.filterCoursesByTypeForCategory(filteredCourses);
    }

    // Apply category filter
    if (this.selectedCategories.length > 0) {
      filteredCourses = this.filterCoursesByCategory(filteredCourses);
    }

    this.prepareCategoryData(filteredCourses);
    this.cdr.detectChanges();
  }

  filterCoursesByCategory(courses: any[]): any[] {
    return courses.map(course => {
      const filteredCourse = { ...course };

      if (filteredCourse.question_category_breakdown) {
        const filteredBreakdown: any = {};
        this.selectedCategories.forEach(category => {
          // Check case-insensitively since API returns lowercase ('theory') but selectedCategories are Capitalized ('Theory')
          const categoryKey = Object.keys(filteredCourse.question_category_breakdown).find(
            key => key.toLowerCase() === category.toLowerCase()
          );
          
          if (categoryKey && filteredCourse.question_category_breakdown[categoryKey] !== undefined) {
            // Keep the original key from the API or use the selected category name as key
            filteredBreakdown[categoryKey] = filteredCourse.question_category_breakdown[categoryKey];
          }
        });

        filteredCourse.question_category_breakdown = filteredBreakdown;
        filteredCourse.question_count = Object.values(filteredBreakdown)
          .reduce((sum: number, count: any) => sum + (typeof count === 'number' ? count : 0), 0) as number;
      }

      return filteredCourse;
    }).filter(course => course.question_count > 0);
  }

  // Filter search methods
  filterCategoryCourses(): void {
    if (!this.categoryCourseSearchTerm.trim()) {
      this.filteredCategoryCourseList = [...this.courseList];
      return;
    }

    const searchTerm = this.categoryCourseSearchTerm.toLowerCase().trim();
    this.filteredCategoryCourseList = this.courseList.filter(course =>
      course.course_name.toLowerCase().includes(searchTerm)
    );
  }

  filterCategories(): void {
    if (!this.categorySearchTerm.trim()) {
      this.filteredCategoryList = [...this.availableCategories];
      return;
    }

    const searchTerm = this.categorySearchTerm.toLowerCase().trim();
    this.filteredCategoryList = this.availableCategories.filter(category =>
      category.label.toLowerCase().includes(searchTerm)
    );
  }

  // Helper methods
  getCategoryFilterHeaderCount(headerKey: string): number {
    switch (headerKey) {
      case 'courses':
        return this.selectedCategoryCourseIds.length;
      case 'categories':
        return this.selectedCategories.length;
      default:
        return 0;
    }
  }


  getCategoryPercentage(item: any): string {
    if (!item) {
      return '0';
    }

    // Use bar chart data if available, otherwise use pie chart data
    const dataSource = this.categoryBarChartData.length > 0 ? this.categoryBarChartData : this.categoryChartData;
    
    if (!dataSource || dataSource.length === 0) {
      return '0';
    }

    const total = dataSource.reduce((sum, dataItem) => {
      return sum + (dataItem?.value || 0);
    }, 0);

    return total > 0 ? (((item.value || 0) / total) * 100).toFixed(1) : '0';
  }

  // Dropdown methods
  toggleCategoryYearDropdown(): void {
    this.showCategoryYearDropdown = !this.showCategoryYearDropdown;
    if (this.showCategoryYearDropdown) {
      this.showCategoryMonthDropdown = false;
    }
  }

  selectCategoryYearRange(yearRange: string): void {
    this.selectedCategoryYearRange = yearRange;
    this.showCategoryYearDropdown = false;
    this.applyCategoryMonthYearFilter();
  }

  toggleCategoryMonthDropdown(): void {
    this.showCategoryMonthDropdown = !this.showCategoryMonthDropdown;
    if (this.showCategoryMonthDropdown) {
      this.showCategoryYearDropdown = false;
    }
  }

  selectCategoryMonth(month: number): void {
    this.selectedCategoryMonth = month;
    this.showCategoryMonthDropdown = false;
    this.applyCategoryMonthYearFilter();
  }

  applyCategoryMonthYearFilter(): void {
    this.showCategoryYearDropdown = false;
    this.showCategoryMonthDropdown = false;

    // Fetch data with category-specific filters
    this.fetchCategoryFilteredData();
  }

  private fetchCategoryFilteredData(): void {
    this.isLoading = true;

    let startDate: Date;
    let endDate: Date;

    if (this.selectedCategoryMonth) {
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedCategoryYearRange);
      if (yearRange) {
        const year = this.selectedCategoryMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedCategoryMonth - 1, 1);
        endDate = new Date(year, this.selectedCategoryMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedCategoryMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedCategoryMonth, 0);
      }
    } else {
      const dateRange = this.getDateRangeFromYearRange(this.selectedCategoryYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

    const resp = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          // Extract ONLY question counts - don't call processLibraryData() which updates ALL charts
          this.extractQuestionCountsFromResponse(response);
          // Prepare ONLY category data - preserve independence of other charts
          this.prepareCategoryData(this.questionCounts);
          this.isLoading = false;
          this.cdr.detectChanges();
        } else {
          this.categoryChartData = [];
          this.showCategoryPieChart = false;
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.categoryChartData = [];
        this.showCategoryPieChart = false;
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  // Chart menu methods
  toggleCategoryChartMenu(): void {
    this.showCategoryChartMenu = !this.showCategoryChartMenu;
    if (this.showCategoryChartMenu) {
      this.showCategoryFilterPanel = false; // Close filter when opening menu
    }
  }

  closeCategoryChartMenu(): void {
    this.showCategoryChartMenu = false;
  }

  // Table modal methods
  showCategoryTableModal(): void {
    this.closeCategoryChartMenu();
    this.showCategoryTableModalFlag = true;
  }

  closeCategoryTableModal(): void {
    this.showCategoryTableModalFlag = false;
  }

  exportCategoryChartAsPDF(): void {
    this.closeCategoryChartMenu();
    if (!this.ensureHasData(this.categoryChartData)) { return; }

    if (this.categoryPieChart) {
      const canvas = this.categoryPieChart.canvas;
      const chartImage = canvas.toDataURL('image/png');

      // Create PDF with proper layout
      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Add title
      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');

      const chartTitle = this.shouldShowOverallCategory()
        ? 'Overall Question Category Distribution'
        : 'Course-wise Question Category Distribution';

      // Center the title
      const titleWidth = pdf.getTextWidth(chartTitle);
      const titleX = (pageWidth - titleWidth) / 2;
      pdf.text(chartTitle, titleX, 25);

      // Add source/subtitle
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      const subtitle = 'Source: Content Library Analytics';
      const subtitleWidth = pdf.getTextWidth(subtitle);
      const subtitleX = (pageWidth - subtitleWidth) / 2;
      pdf.text(subtitle, subtitleX, 32);

      // Add separator line
      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      // Add chart image at the top left
      const imgProps = pdf.getImageProperties(chartImage);
      const chartWidth = pageWidth * 0.45;
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      const chartX = 20;
      const chartY = 45;

      pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

      // Add Color Legends beside the chart (right side)
      const legendsX = chartX + chartWidth + 10;
      const legendsStartY = chartY;

      // Color Legends Title
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Color Legend', legendsX, legendsStartY);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      let currentLegendY = legendsStartY + 15;

      // Get unique courses and their colors
      const courseColors = new Map();
      const nonZeroData = this.categoryChartData.filter(item => item.value > 0);

      nonZeroData.forEach(item => {
        if (!courseColors.has(item.courseName)) {
          courseColors.set(item.courseName, item.color);
        }
      });

      // Add course color legends with proper text wrapping
      const maxLegendWidth = pageWidth - legendsX - 15;

      courseColors.forEach((color, courseName) => {
        // Draw color box
        const rgb = this.hexToRgb(color);
        pdf.setFillColor(rgb.r, rgb.g, rgb.b);
        pdf.rect(legendsX, currentLegendY - 3, 10, 10, 'F');

        // Draw border around color box
        pdf.setDrawColor(100, 100, 100);
        pdf.rect(legendsX, currentLegendY - 3, 10, 10);

        // Course name with text wrapping
        const maxTextWidth = maxLegendWidth - 15;
        const lines = pdf.splitTextToSize(courseName, maxTextWidth);

        // Draw each line of the course name
        lines.forEach((line: string, index: number) => {
          pdf.text(line, legendsX + 15, currentLegendY + (index * 4));
        });

        // Move Y position based on number of lines
        currentLegendY += (lines.length * 4) + 8;
      });

      // Calculate position for distribution summary
      const chartBottom = chartY + chartHeight;
      const legendsBottom = currentLegendY;
      const summaryStartY = Math.max(chartBottom, legendsBottom) + 20;

      // Add Distribution Summary title
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Distribution Summary', 20, summaryStartY);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      let currentY = summaryStartY + 15;

      // Calculate totals and percentages
      const totalQuestions = this.categoryChartData.reduce((sum, item) => sum + item.value, 0);

      if (this.shouldShowOverallCategory()) {
        // Show overall category breakdown in a single column
        pdf.setFont('helvetica', 'bold');
        pdf.text('Overall Category Breakdown:', 20, currentY);
        currentY += 8;

        pdf.setFont('helvetica', 'normal');
        nonZeroData.forEach(item => {
          const percentage = this.getCategoryPercentage(item);
          pdf.text(`${item.name}: ${item.value} (${percentage}%)`, 25, currentY);
          currentY += 5;
        });
      } else {
        // Show course-wise breakdown in multiple columns
        const coursesMap = new Map();
        nonZeroData.forEach(item => {
          if (!coursesMap.has(item.courseName)) {
            coursesMap.set(item.courseName, []);
          }
          coursesMap.get(item.courseName).push(item);
        });

        const coursesArray = Array.from(coursesMap.entries());
        const coursesPerRow = 2;
        const courseWidth = (pageWidth - 60) / coursesPerRow;

        // Add course-wise breakdown in grid layout
        for (let i = 0; i < coursesArray.length; i += coursesPerRow) {
          const rowCourses = coursesArray.slice(i, i + coursesPerRow);

          let maxCourseHeight = 0;

          // Process each course in the current row
          rowCourses.forEach(([courseName, categories], courseIndex) => {
            const courseX = 20 + (courseIndex * courseWidth);
            let courseY = currentY;

            // Course name with background and text wrapping
            pdf.setFont('helvetica', 'bold');
            pdf.setFillColor(245, 245, 245);

            // Wrap course name to fit within course width
            const courseNameLines = pdf.splitTextToSize(courseName, courseWidth - 20);
            const courseNameHeight = courseNameLines.length * 4 + 6;

            // Draw background for course name
            pdf.rect(courseX, courseY - 5, courseWidth - 15, courseNameHeight, 'F');

            // Draw colored border on left
            const rgb = this.hexToRgb(courseColors.get(courseName));
            pdf.setFillColor(rgb.r, rgb.g, rgb.b);
            pdf.rect(courseX, courseY - 5, 4, courseNameHeight, 'F');

            // Reset fill color for text
            pdf.setFillColor(0, 0, 0);

            // Draw course name lines
            courseNameLines.forEach((line: string, lineIndex: number) => {
              pdf.text(line, courseX + 8, courseY + (lineIndex * 4));
            });

            courseY += courseNameHeight + 8;

            pdf.setFont('helvetica', 'normal');

            // Add categories for this course
            categories.forEach(item => {
              const percentage = this.getCategoryPercentage(item);
              const categoryText = `${item.name}: ${item.value} (${percentage}%)`;

              pdf.text(categoryText, courseX + 8, courseY);
              courseY += 5;
            });

            // Update max height for this row
            const courseHeight = courseY - currentY;
            if (courseHeight > maxCourseHeight) {
              maxCourseHeight = courseHeight;
            }
          });

          // Move to next row position
          currentY += maxCourseHeight + 20;

          // Add page break if needed
          if (currentY > pageHeight - 50 && i + coursesPerRow < coursesArray.length) {
            pdf.addPage();
            currentY = 20;

            // Add title on new page
            pdf.setFontSize(14);
            pdf.setFont('helvetica', 'bold');
            pdf.text('Distribution Summary (Continued)', 20, currentY);
            currentY += 15;
          }
        }
      }

      // Add total questions and metadata below the distribution summary
      currentY += 10;
      pdf.setFont('helvetica', 'bold');
      pdf.text(`Total Questions: ${totalQuestions}`, 20, currentY);

      // Add filter information
      currentY += 8;
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'italic');

      let filterInfo = `View: ${this.shouldShowOverallCategory() ? 'Overall Category' : 'Course-wise Breakdown'}`;
      pdf.text(filterInfo, 20, currentY);

      currentY += 4;
      let dateRangeText = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateRangeText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
      }
      pdf.text(dateRangeText, 20, currentY);

      // Add selected courses info if in course-wise view
      if (!this.shouldShowOverallCategory() && this.selectedCategoryCourseIds.length > 0) {
        currentY += 4;
        const courseCount = this.selectedCategoryCourseIds.length;
        pdf.text(`Selected Courses: ${courseCount} course${courseCount > 1 ? 's' : ''}`, 20, currentY);
      }

      // Add footer at the bottom
      const footerY = pageHeight - 10;
      pdf.setFontSize(8);
      pdf.setFont('helvetica', 'normal');
      pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth / 2, footerY, { align: 'center' });

      const fileName = this.shouldShowOverallCategory()
        ? 'overall-category-analysis.pdf'
        : 'course-wise-category-analysis.pdf';

      pdf.save(fileName);
    }
  }

  exportCategoryChartAsPNG(): void {
    this.closeCategoryChartMenu();
    if (!this.ensureHasData(this.categoryChartData)) { return; }

    if (this.categoryPieChart) {
      // Create a container to combine chart and information
      const container = document.createElement('div');
      container.style.cssText = `
      position: fixed;
      left: -10000px;
      top: -10000px;
      width: 1400px;
      background: white;
      padding: 40px;
      border: 1px solid #ccc;
      z-index: 10000;
      font-family: Arial, sans-serif;
    `;

      // Create header
      const header = document.createElement('div');
      header.style.cssText = `
      text-align: center;
      margin-bottom: 40px;
      padding-bottom: 20px;
      border-bottom: 3px solid #005068;
    `;

      const title = document.createElement('h1');
      title.textContent = this.shouldShowOverallCategory()
        ? 'Overall Question Category Distribution'
        : 'Course-wise Question Category Distribution';
      title.style.cssText = `
      margin: 0 0 12px 0;
      color: #005068;
      font-size: 32px;
      font-weight: bold;
    `;

      const subtitle = document.createElement('p');
      subtitle.textContent = 'Source: Content Library Analytics';
      subtitle.style.cssText = `
      margin: 0;
      color: #666;
      font-size: 16px;
    `;

      header.appendChild(title);
      header.appendChild(subtitle);

      // Create top row for chart and legends
      const topRow = document.createElement('div');
      topRow.style.cssText = `
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 60px;
      margin-bottom: 40px;
      padding: 30px;
      background: #f8f9fa;
      border-radius: 15px;
      min-height: 500px;
    `;

      // Chart container (larger and expanded)
      const chartContainer = document.createElement('div');
      chartContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 2;
      min-height: 500px;
    `;

      // Create a high-quality chart render
      const chartWrapper = document.createElement('div');
      chartWrapper.style.cssText = `
      width: 500px;
      height: 500px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: white;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      padding: 20px;
      box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    `;

      // Get the original chart canvas
      const originalCanvas = this.categoryPieChart.canvas;

      // Create a high-resolution canvas
      const highResCanvas = document.createElement('canvas');
      highResCanvas.width = 800;
      highResCanvas.height = 800;

      const ctx = highResCanvas.getContext('2d');
      if (ctx) {
        // Scale up for better quality
        ctx.scale(2, 2);

        // Set white background
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, highResCanvas.width, highResCanvas.height);

        // Draw the chart with better quality
        ctx.drawImage(originalCanvas, 0, 0, 400, 400);
      }

      const chartImg = document.createElement('img');
      chartImg.src = highResCanvas.toDataURL('image/png', 1.0);
      chartImg.style.cssText = `
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 10px;
      object-fit: contain;
    `;

      chartWrapper.appendChild(chartImg);
      chartContainer.appendChild(chartWrapper);

      // Legends container
      const legendsContainer = document.createElement('div');
      legendsContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 25px;
      flex: 1;
      min-width: 320px;
      max-width: 350px;
    `;

      // Color Legend Container
      const colorLegendContainer = document.createElement('div');
      colorLegendContainer.style.cssText = `
      background: white;
      padding: 30px;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    `;

      const colorLegendTitle = document.createElement('h3');
      colorLegendTitle.textContent = 'Color Legend';
      colorLegendTitle.style.cssText = `
      margin: 0 0 25px 0;
      color: #005068;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      border-bottom: 3px solid #f0f0f0;
      padding-bottom: 15px;
    `;

      colorLegendContainer.appendChild(colorLegendTitle);

      // Add course color legend only
      const courseLegend = document.createElement('div');
      courseLegend.style.cssText = `
      margin-bottom: 10px;
    `;

      const courseLegendTitle = document.createElement('h4');
      courseLegendTitle.textContent = 'Courses';
      courseLegendTitle.style.cssText = `
      margin: 0 0 20px 0;
      color: #333;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    `;

      courseLegend.appendChild(courseLegendTitle);

      // Get unique courses and their colors
      const courseColors = new Map();
      const nonZeroData = this.categoryChartData.filter(item => item.value > 0);

      nonZeroData.forEach(item => {
        if (!courseColors.has(item.courseName)) {
          courseColors.set(item.courseName, item.color);
        }
      });

      // Add course color items with better styling
      courseColors.forEach((color, courseName) => {
        const courseItem = document.createElement('div');
        courseItem.style.cssText = `
        display: flex;
        align-items: flex-start;
        margin-bottom: 16px;
        padding: 12px;
        background: #f8f9fa;
        border-radius: 10px;
        border-left: 5px solid ${color};
        transition: all 0.3s ease;
      `;

        const colorBox = document.createElement('div');
        colorBox.style.cssText = `
        width: 24px;
        height: 24px;
        background-color: ${color};
        border: 3px solid #fff;
        border-radius: 8px;
        margin-right: 15px;
        margin-top: 2px;
        box-shadow: 0 3px 8px rgba(0,0,0,0.2);
        flex-shrink: 0;
      `;

        const courseNameSpan = document.createElement('span');
        courseNameSpan.textContent = courseName;
        courseNameSpan.style.cssText = `
        font-size: 16px;
        font-weight: 500;
        color: #333;
        line-height: 1.4;
        word-wrap: break-word;
        flex: 1;
      `;

        courseItem.appendChild(colorBox);
        courseItem.appendChild(courseNameSpan);
        courseLegend.appendChild(courseItem);
      });

      colorLegendContainer.appendChild(courseLegend);
      legendsContainer.appendChild(colorLegendContainer);

      // Add legends to top row
      topRow.appendChild(chartContainer);
      topRow.appendChild(legendsContainer);

      // Distribution Summary Section
      const distributionSection = document.createElement('div');
      distributionSection.style.cssText = `
      margin-top: 40px;
    `;

      const distributionTitle = document.createElement('h2');
      distributionTitle.textContent = 'Distribution Summary';
      distributionTitle.style.cssText = `
      margin: 0 0 30px 0;
      color: #005068;
      font-size: 28px;
      font-weight: bold;
      text-align: center;
      border-bottom: 3px solid #005068;
      padding-bottom: 15px;
    `;

      distributionSection.appendChild(distributionTitle);

      // Create course grid (2 courses per row)
      const coursesMap = new Map();
      nonZeroData.forEach(item => {
        if (!coursesMap.has(item.courseName)) {
          coursesMap.set(item.courseName, []);
        }
        coursesMap.get(item.courseName).push(item);
      });

      const coursesArray = Array.from(coursesMap.entries());

      // Create rows with 2 courses each
      for (let i = 0; i < coursesArray.length; i += 2) {
        const row = document.createElement('div');
        row.style.cssText = `
        display: flex;
        gap: 40px;
        margin-bottom: 40px;
        justify-content: center;
      `;

        // Add courses for this row
        for (let j = 0; j < 2 && (i + j) < coursesArray.length; j++) {
          const [courseName, categories] = coursesArray[i + j];
          const courseColor = courseColors.get(courseName);

          const courseCard = document.createElement('div');
          courseCard.style.cssText = `
          flex: 1;
          background: white;
          padding: 30px;
          border-radius: 15px;
          border: 3px solid #e0e0e0;
          border-left: 8px solid ${courseColor};
          min-width: 350px;
          max-width: 400px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.15);
        `;

          // Course header
          const courseHeader = document.createElement('h3');
          courseHeader.textContent = courseName;
          courseHeader.style.cssText = `
          margin: 0 0 25px 0;
          color: #333;
          font-size: 20px;
          font-weight: bold;
          border-bottom: 3px solid #f0f0f0;
          padding-bottom: 15px;
          text-align: center;
          word-wrap: break-word;
          line-height: 1.3;
        `;

          courseCard.appendChild(courseHeader);

          // Create table-like structure for categories
          const tableContainer = document.createElement('div');
          tableContainer.style.cssText = `
          width: 100%;
        `;

          // Add categories for this course
          categories.forEach(item => {
            const percentage = this.getCategoryPercentage(item);

            const rowDiv = document.createElement('div');
            rowDiv.style.cssText = `
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
            font-size: 16px;
            padding: 12px 0;
            border-bottom: 2px solid #f5f5f5;
          `;

            const categoryLabel = document.createElement('span');
            categoryLabel.textContent = `${item.name}:`;
            categoryLabel.style.cssText = `
            font-weight: bold;
            color: #333;
            font-size: 16px;
          `;

            const valueSpan = document.createElement('span');
            valueSpan.textContent = `${item.value} (${percentage}%)`;
            valueSpan.style.cssText = `
            color: #666;
            font-weight: 600;
            font-size: 16px;
          `;

            rowDiv.appendChild(categoryLabel);
            rowDiv.appendChild(valueSpan);
            tableContainer.appendChild(rowDiv);
          });

          courseCard.appendChild(tableContainer);
          row.appendChild(courseCard);
        }

        distributionSection.appendChild(row);
      }

      // Total and footer section
      const totalQuestions = this.categoryChartData.reduce((sum, item) => sum + item.value, 0);

      const totalSection = document.createElement('div');
      totalSection.style.cssText = `
      margin-top: 50px;
      padding: 30px;
      background: #f8f9fa;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      text-align: center;
    `;

      const totalLabel = document.createElement('div');
      totalLabel.style.cssText = `
      font-weight: bold;
      margin-bottom: 20px;
      font-size: 20px;
      color: #005068;
    `;
      totalLabel.textContent = `Total Questions: ${totalQuestions}`;

      const metadataContainer = document.createElement('div');
      metadataContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-size: 15px;
      color: #666;
      margin-bottom: 20px;
    `;

      // View information
      const viewInfo = document.createElement('div');
      viewInfo.style.cssText = `
      font-weight: 500;
    `;
      viewInfo.textContent = `View: ${this.shouldShowOverallCategory() ? 'Overall Category' : 'Course-wise Breakdown'}`;

      // Date information
      const dateInfo = document.createElement('div');
      let dateText = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
      }
      dateInfo.textContent = dateText;

      // Selected courses info
      if (!this.shouldShowOverallCategory() && this.selectedCategoryCourseIds.length > 0) {
        const courseInfo = document.createElement('div');
        const courseCount = this.selectedCategoryCourseIds.length;
        courseInfo.textContent = `Selected Courses: ${courseCount} course${courseCount > 1 ? 's' : ''}`;
        courseInfo.style.fontWeight = '500';
        metadataContainer.appendChild(courseInfo);
      }

      // Footer
      const footer = document.createElement('div');
      footer.style.cssText = `
      text-align: center;
      margin-top: 20px;
      padding-top: 20px;
      border-top: 3px solid #ddd;
      font-size: 14px;
      color: #666;
      font-style: italic;
    `;
      footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;

      metadataContainer.appendChild(viewInfo);
      metadataContainer.appendChild(dateInfo);

      totalSection.appendChild(totalLabel);
      totalSection.appendChild(metadataContainer);
      totalSection.appendChild(footer);

      // Assemble the container
      container.appendChild(header);
      container.appendChild(topRow);
      container.appendChild(distributionSection);
      container.appendChild(totalSection);

      document.body.appendChild(container);

      // Use html2canvas with higher quality settings
      html2canvas(container, {
        scale: 3,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: container.offsetWidth,
        height: container.offsetHeight
      }).then(canvas => {
        const link = document.createElement('a');
        link.download = this.shouldShowOverallCategory()
          ? 'overall-category-analysis.png'
          : 'course-wise-category-analysis.png';
        link.href = canvas.toDataURL('image/png', 1.0);
        link.click();

        // Clean up
        document.body.removeChild(container);
      });
    }
  }

  exportCategoryTableAsPDF(): void {
    if (!this.ensureHasData(this.categoryChartData)) { return; }
    const totalQuestions = this.categoryChartData.reduce((sum, item) => sum + item.value, 0);
    let dateInfo = `Date Range: ${this.selectedRange}`;
    if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
      dateInfo += ` | From: ${this.formatDisplayDate(this.startDate)} To: ${this.formatDisplayDate(this.endDate)}`;
    }
    dateInfo += ` | Total Questions: ${totalQuestions}`;

    const tableData = this.categoryChartData
      .filter(item => item.value > 0)
      .map(item => [
        item.courseName || 'All Courses',
        item.name,
        item.value.toString(),
        `${this.getCategoryPercentage(item)}%`
      ]);

    this.generateProfessionalPDF(
      'Question Category Distribution - Detailed Report',
      tableData,
      ['Course Name', 'Category', 'Count', 'Percentage'],
      'question-category-detailed-report.pdf',
      dateInfo
    );
  }

  exportCategoryTableAsPNG(): void {
    if (!this.ensureHasData(this.categoryChartData)) { return; }
    const tableElement = document.querySelector('.category-modal-table') as HTMLElement;

    if (tableElement) {
      // Create a container for the table with styling
      const container = document.createElement('div');
      container.style.cssText = `
      position: fixed;
      left: -10000px;
      top: -10000px;
      background: white;
      padding: 30px;
      z-index: 10000;
      max-width: 900px;
      width: 900px;
      font-family: Arial, sans-serif;
    `;

      // Add title and header
      const header = document.createElement('div');
      header.style.cssText = `
      text-align: center;
      margin-bottom: 25px;
      padding-bottom: 15px;
      border-bottom: 2px solid #005068;
    `;

      const title = document.createElement('h2');
      title.textContent = 'Question Category Distribution - Detailed Table';
      title.style.cssText = `
      margin: 0 0 12px 0;
      color: #005068;
      font-size: 24px;
      font-weight: bold;
    `;

      const totalQuestions = this.categoryChartData.reduce((sum, item) => sum + item.value, 0);
      const subtitle = document.createElement('p');
      subtitle.textContent = `Date Range: ${this.selectedRange} | Total Questions: ${totalQuestions}`;
      subtitle.style.cssText = `
      margin: 0;
      color: #666;
      font-size: 14px;
    `;

      header.appendChild(title);
      header.appendChild(subtitle);

      // Create table manually since we don't have a DOM element for category table
      const tableClone = this.createCategoryTableForExport();
      container.appendChild(header);
      container.appendChild(tableClone);

      // Add footer
      const footer = document.createElement('div');
      footer.style.cssText = `
      text-align: center;
      margin-top: 20px;
      padding-top: 15px;
      border-top: 1px solid #ddd;
      font-size: 12px;
      color: #666;
      font-style: italic;
    `;
      footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;
      container.appendChild(footer);

      document.body.appendChild(container);

      html2canvas(container, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff'
      }).then(canvas => {
        const link = document.createElement('a');
        link.download = 'question-category-table.png';
        link.href = canvas.toDataURL('image/png');
        link.click();

        // Clean up
        document.body.removeChild(container);
      });
    }
  }

  // Helper method to create category table for export
  private createCategoryTableForExport(): HTMLElement {
    const table = document.createElement('table');
    table.style.cssText = `
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
    font-size: 13px;
    margin-bottom: 20px;
  `;

    // Create table header
    const thead = document.createElement('thead');
    const headerRow = document.createElement('tr');

    const headers = ['Course Name', 'Category', 'Count', 'Percentage'];
    headers.forEach(headerText => {
      const th = document.createElement('th');
      th.textContent = headerText;
      th.style.cssText = `
      background: #005068;
      color: white;
      padding: 12px 15px;
      text-align: left;
      font-weight: bold;
      border: 1px solid #ddd;
    `;
      headerRow.appendChild(th);
    });

    thead.appendChild(headerRow);
    table.appendChild(thead);

    // Create table body
    const tbody = document.createElement('tbody');

    this.categoryChartData
      .filter(item => item.value > 0)
      .forEach((item, index) => {
        const row = document.createElement('tr');
        row.style.cssText = `
        background: ${index % 2 === 0 ? '#f9f9f9' : 'white'};
      `;

        const courseCell = document.createElement('td');
        courseCell.textContent = item.courseName || 'All Courses';
        courseCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        const categoryCell = document.createElement('td');
        categoryCell.textContent = item.name;
        categoryCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        const countCell = document.createElement('td');
        countCell.textContent = item.value.toString();
        countCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        const percentageCell = document.createElement('td');
        percentageCell.textContent = `${this.getCategoryPercentage(item)}%`;
        percentageCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        row.appendChild(courseCell);
        row.appendChild(categoryCell);
        row.appendChild(countCell);
        row.appendChild(percentageCell);
        tbody.appendChild(row);
      });

    table.appendChild(tbody);
    return table;
  }
  showCategoryCompareDialog: boolean = false;
  showCategoryComparisonResults: boolean = false;
  currentCategoryComparisonData: any[] = [];
  compareCategoryComparisonData: any[] = [];
  categoryTrendSummary: any[] = [];

  // Compare dialog methods (similar to difficulty chart)
  openCategoryCompareDialog(): void {
    this.showCategoryCompareDialog = true;
    this.showCategoryMonthComparisonResults = false;
    // Reset month selections
    this.selectedCategoryCompareMonth1 = null;
    this.selectedCategoryCompareMonth2 = null;
  }
  closeCategoryCompareDialog(): void {
    this.showCategoryCompareDialog = false;
    this.showCategoryMonthComparisonResults = false;
    this.currentCategoryMonthComparisonData = [];
    this.compareCategoryMonthComparisonData = [];
  }

  // Category Month-wise Comparison Properties
  selectedCategoryCompareMonth1: number | null = null;
  selectedCategoryCompareMonth2: number | null = null;
  showCategoryCompareMonth1Dropdown: boolean = false;
  showCategoryCompareMonth2Dropdown: boolean = false;
  showCategoryMonthComparisonResults: boolean = false;
  currentCategoryMonthComparisonData: any[] = [];
  compareCategoryMonthComparisonData: any[] = [];
  categoryMonthComparisonChart: Chart | null = null;
  categoryMonthTrendSummary: any[] = [];

  // Category Month Comparison Dialog Methods
  toggleCategoryCompareMonth1Dropdown(): void {
    this.showCategoryCompareMonth1Dropdown = !this.showCategoryCompareMonth1Dropdown;
    if (this.showCategoryCompareMonth1Dropdown) {
      this.showCategoryCompareMonth2Dropdown = false;
    }
  }

  selectCategoryCompareMonth1(month: number): void {
    this.selectedCategoryCompareMonth1 = month;
    this.showCategoryCompareMonth1Dropdown = false;
  }

  toggleCategoryCompareMonth2Dropdown(): void {
    this.showCategoryCompareMonth2Dropdown = !this.showCategoryCompareMonth2Dropdown;
    if (this.showCategoryCompareMonth2Dropdown) {
      this.showCategoryCompareMonth1Dropdown = false;
    }
  }

  selectCategoryCompareMonth2(month: number): void {
    this.selectedCategoryCompareMonth2 = month;
    this.showCategoryCompareMonth2Dropdown = false;
  }

  loadCategoryMonthComparisonData(): void {
    if (!this.selectedCategoryCompareMonth1 || !this.selectedCategoryCompareMonth2) {
      return;
    }

    // Close dropdowns
    this.showCategoryCompareMonth1Dropdown = false;
    this.showCategoryCompareMonth2Dropdown = false;

    this.fetchCategoryMonthComparisonData();
  }

  private fetchCategoryMonthComparisonData(): void {
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedCategoryCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedCategoryCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    // Fetch Month 1 data
    const resp1 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    // Fetch Month 2 data
    const resp2 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Courses: any[] = [];
    let month2Courses: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month1Courses = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processCategoryMonthComparisonData(month1Courses, month2Courses);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.processCategoryMonthComparisonData(month1Courses, month2Courses);
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month2Courses = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processCategoryMonthComparisonData(month1Courses, month2Courses);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.processCategoryMonthComparisonData(month1Courses, month2Courses);
        }
      }
    );
  }

  private processCategoryMonthComparisonData(month1Courses: any[], month2Courses: any[]): void {
    this.isLoading = false;

    // Extract category data from courses - Month 1
    const month1CategoryData = this.extractCategoryDataFromCourses(month1Courses);
    // Extract category data from courses - Month 2
    const month2CategoryData = this.extractCategoryDataFromCourses(month2Courses);

    this.currentCategoryMonthComparisonData = month1CategoryData;
    this.compareCategoryMonthComparisonData = month2CategoryData;

    // Calculate trends
    this.categoryMonthTrendSummary = [];
    const allCategories = new Set([...month1CategoryData.map(d => d.name), ...month2CategoryData.map(d => d.name)]);

    allCategories.forEach(category => {
      const month1Item = month1CategoryData.find(d => d.name === category);
      const month2Item = month2CategoryData.find(d => d.name === category);

      const month1Value = month1Item?.value || 0;
      const month2Value = month2Item?.value || 0;

      let trend = 'neutral';
      if (month2Value > month1Value) {
        trend = 'positive';
      } else if (month2Value < month1Value) {
        trend = 'negative';
      }

      this.categoryMonthTrendSummary.push({
        category: category,
        value: Math.abs(month2Value - month1Value),
        trend: trend
      });
    });

    this.showCategoryMonthComparisonResults = true;
    this.cdr.detectChanges();

    setTimeout(() => {
      this.initializeCategoryMonthComparisonChart();
    }, 200);
  }

  private extractCategoryDataFromCourses(courses: any[]): any[] {
    const categoryTotals: any = {};

    courses.forEach((course) => {
      if (course.question_category_breakdown) {
        Object.keys(course.question_category_breakdown).forEach(category => {
          if (!categoryTotals[category]) {
            categoryTotals[category] = 0;
          }
          categoryTotals[category] += course.question_category_breakdown[category] || 0;
        });
      }
    });

    const result = Object.keys(categoryTotals)
      .filter(category => categoryTotals[category] > 0)
      .map(category => ({
        name: category,
        value: categoryTotals[category]
      }));

    return result;
  }
  toggleCandidatePerformanceYearDropdown(): void {
  this.showCandidatePerformanceYearDropdown = !this.showCandidatePerformanceYearDropdown;
  if (this.showCandidatePerformanceYearDropdown) {
    this.showCandidatePerformanceMonthDropdown = false;
  }
}

  selectCandidatePerformanceYearRange(yearRange: string): void {
  this.selectedCandidatePerformanceYearRange = yearRange;
  this.showCandidatePerformanceYearDropdown = false;
  this.applyCandidatePerformanceMonthYearFilter();
}

  toggleCandidatePerformanceMonthDropdown(): void {
  this.showCandidatePerformanceMonthDropdown = !this.showCandidatePerformanceMonthDropdown;
  if (this.showCandidatePerformanceMonthDropdown) {
    this.showCandidatePerformanceYearDropdown = false;
  }
}
  selectCandidatePerformanceMonth(month: number): void {
  this.selectedCandidatePerformanceMonth = month;
  this.showCandidatePerformanceMonthDropdown = false;
  this.applyCandidatePerformanceMonthYearFilter();
}

applyCandidatePerformanceMonthYearFilter(): void {
  this.showCandidatePerformanceYearDropdown = false;
  this.showCandidatePerformanceMonthDropdown = false;
  this.loadCandidatePerformanceData();
}

toggleCandidatePerformanceChartMenu(): void {
  this.showCandidatePerformanceChartMenu = !this.showCandidatePerformanceChartMenu;
  if (this.showCandidatePerformanceChartMenu) {
    this.showCandidatePerformanceFilterPanel = false;
  }
}

  // Open Candidate Performance Compare Dialog
openCandidatePerformanceCompareDialog(): void {
  this.showCandidatePerformanceCompareDialog = true;
  this.showCandidatePerformanceComparisonResults = false;
  this.selectedCandidatePerformanceCompareMonth1 = null;
  this.selectedCandidatePerformanceCompareMonth2 = null;
  this.currentCandidatePerformanceComparisonData = [];
  this.compareCandidatePerformanceComparisonData = [];
  this.showCandidatePerformanceChartMenu = false;
}

closeCandidatePerformanceCompareDialog(): void {
  this.showCandidatePerformanceCompareDialog = false;
  this.showCandidatePerformanceComparisonResults = false;
  this.currentCandidatePerformanceComparisonData = [];
  this.compareCandidatePerformanceComparisonData = [];
  if (this.candidatePerformanceComparisonChart) {
    this.candidatePerformanceComparisonChart.destroy();
    this.candidatePerformanceComparisonChart = null;
  }
}

  // Toggle Candidate Performance Compare Month 1 Dropdown
  toggleCandidatePerformanceCompareMonth1Dropdown(): void {
  this.showCandidatePerformanceCompareMonth1Dropdown = !this.showCandidatePerformanceCompareMonth1Dropdown;
  if (this.showCandidatePerformanceCompareMonth1Dropdown) {
    this.showCandidatePerformanceCompareMonth2Dropdown = false;
  }
}

selectCandidatePerformanceCompareMonth1(month: number): void {
  this.selectedCandidatePerformanceCompareMonth1 = month;
  this.showCandidatePerformanceCompareMonth1Dropdown = false;
}

toggleCandidatePerformanceCompareMonth2Dropdown(): void {
  this.showCandidatePerformanceCompareMonth2Dropdown = !this.showCandidatePerformanceCompareMonth2Dropdown;
  if (this.showCandidatePerformanceCompareMonth2Dropdown) {
    this.showCandidatePerformanceCompareMonth1Dropdown = false;
  }
}

selectCandidatePerformanceCompareMonth2(month: number): void {
  this.selectedCandidatePerformanceCompareMonth2 = month;
  this.showCandidatePerformanceCompareMonth2Dropdown = false;
}
loadCandidatePerformanceComparisonData(): void {
  if (!this.selectedCandidatePerformanceCompareMonth1 || !this.selectedCandidatePerformanceCompareMonth2) {
    return;
  }

  this.isLoading = true;
  this.showCandidatePerformanceComparisonResults = true;
  this.fetchCandidatePerformanceComparisonDataMonthWise();
}

private fetchCandidatePerformanceComparisonDataMonthWise(): void {
  const currentYear = new Date().getFullYear();

  // For Month 1
  const month1 = this.selectedCandidatePerformanceCompareMonth1!;
  const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
  const month1StartDate = new Date(year1, month1 - 1, 1);
  const month1EndDate = new Date(year1, month1, 0);

  // For Month 2
  const month2 = this.selectedCandidatePerformanceCompareMonth2!;
  const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
  const month2StartDate = new Date(year2, month2 - 1, 1);
  const month2EndDate = new Date(year2, month2, 0);

  const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
  const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
  const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
  const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

  // Fetch Month 1 data
  const resp1 = this.service.getOperationsData({
    org_id: this.org_id,
    start_date: formattedMonth1StartDate,
    end_date: formattedMonth1EndDate
  });

  // Fetch Month 2 data
  const resp2 = this.service.getOperationsData({
    org_id: this.org_id,
    start_date: formattedMonth2StartDate,
    end_date: formattedMonth2EndDate
  });

  let month1Data: any = {};
  let month2Data: any = {};
  let completedRequests = 0;

  resp1.subscribe(
    (data: any) => {
      const response = data['body']?.['responseBody'] || data?.['responseBody'] || data;
      if (response?.operationsData?.candidate_data_by_performance) {
        month1Data = response.operationsData.candidate_data_by_performance;
      } else if (response?.operationsData?.pass_fail?.assessment_wise) {
        month1Data = response.operationsData.pass_fail.assessment_wise;
      }
      completedRequests++;
      if (completedRequests === 2) {
        this.processCandidatePerformanceComparisonDataMonthWise(month1Data, month2Data);
      }
    },
    (error) => {
      completedRequests++;
      if (completedRequests === 2) {
        this.processCandidatePerformanceComparisonDataMonthWise(month1Data, month2Data);
      }
    }
  );

  resp2.subscribe(
    (data: any) => {
      const response = data['body']?.['responseBody'] || data?.['responseBody'] || data;
      if (response?.operationsData?.candidate_data_by_performance) {
        month2Data = response.operationsData.candidate_data_by_performance;
      } else if (response?.operationsData?.pass_fail?.assessment_wise) {
        month2Data = response.operationsData.pass_fail.assessment_wise;
      }
      completedRequests++;
      if (completedRequests === 2) {
        this.processCandidatePerformanceComparisonDataMonthWise(month1Data, month2Data);
      }
    },
    (error) => {
      completedRequests++;
      if (completedRequests === 2) {
        this.processCandidatePerformanceComparisonDataMonthWise(month1Data, month2Data);
      }
    }
  );

  setTimeout(() => {
    this.isLoading = false;
    this.cdr.detectChanges();
  }, 2000);
}

private processCandidatePerformanceComparisonDataMonthWise(month1Data: any[], month2Data: any[]): void {
  const month1CourseData = this.extractPerformanceDataFromResponse(month1Data);
  const month2CourseData = this.extractPerformanceDataFromResponse(month2Data);

  this.currentCandidatePerformanceComparisonData = month1CourseData.map((item: any) => ({
    name: item.course_name || item.assessment_name || item.name || 'Unknown',
    value: item.candidate_count || item.total_candidates || 0,
    percentage: 0,
    trend: 'neutral'
  }));

  this.compareCandidatePerformanceComparisonData = month2CourseData.map((item: any) => {
    const currentItem = this.currentCandidatePerformanceComparisonData.find(
      x => x.name === (item.course_name || item.assessment_name || item.name)
    );
    const currentValue = currentItem ? currentItem.value : 0;
    const compareValue = item.candidate_count || item.total_candidates || 0;

    let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
    if (compareValue > currentValue) {
      trend = 'positive';
    } else if (compareValue < currentValue) {
      trend = 'negative';
    }

    return {
      name: item.course_name || item.assessment_name || item.name || 'Unknown',
      value: compareValue,
      percentage: 0,
      trend: trend
    };
  });

  this.calculatePerformanceComparisonPercentages();
  this.cdr.detectChanges();
  setTimeout(() => {
    this.initializeCandidatePerformanceComparisonChart();
  }, 200);
}

private extractPerformanceDataFromResponse(data: any[]): any[] {
  if (!data || !Array.isArray(data)) {
    return [];
  }
  if (data.length > 0 && (data[0].course_name || data[0].course || data[0].assessment_name)) {
    return data;
  }
  return data;
}

private calculatePerformanceComparisonPercentages(): void {
  const currentTotal = this.currentCandidatePerformanceComparisonData.reduce(
    (sum, item) => sum + item.value, 0
  );
  this.currentCandidatePerformanceComparisonData = this.currentCandidatePerformanceComparisonData.map(item => ({
    ...item,
    percentage: currentTotal > 0 ? Math.round((item.value / currentTotal) * 100) : 0
  }));

  const compareTotal = this.compareCandidatePerformanceComparisonData.reduce(
    (sum, item) => sum + item.value, 0
  );
  this.compareCandidatePerformanceComparisonData = this.compareCandidatePerformanceComparisonData.map(item => ({
    ...item,
    percentage: compareTotal > 0 ? Math.round((item.value / compareTotal) * 100) : 0
  }));
}

private initializeCandidatePerformanceComparisonChart(): void {
  const month1Name = this.getMonthName(this.selectedCandidatePerformanceCompareMonth1!);
  const month2Name = this.getMonthName(this.selectedCandidatePerformanceCompareMonth2!);

  const allCourses = new Set<string>();
  this.currentCandidatePerformanceComparisonData.forEach(item => allCourses.add(item.name));
  this.compareCandidatePerformanceComparisonData.forEach(item => allCourses.add(item.name));

  const courseNames: string[] = Array.from(allCourses).slice(0, 10);
  const month1Data: number[] = [];
  const month2Data: number[] = [];

  courseNames.forEach(courseName => {
    const month1Item = this.currentCandidatePerformanceComparisonData.find(
      item => item.name === courseName
    );
    const month2Item = this.compareCandidatePerformanceComparisonData.find(
      item => item.name === courseName
    );
    month1Data.push(month1Item ? month1Item.value : 0);
    month2Data.push(month2Item ? month2Item.value : 0);
  });

  if (this.candidatePerformanceComparisonChart) {
    this.candidatePerformanceComparisonChart.destroy();
    this.candidatePerformanceComparisonChart = null;
  }

  setTimeout(() => {
    const ctx = document.getElementById('candidatePerformanceComparisonChart') as HTMLCanvasElement;
    if (ctx) {
      try {
        const container = ctx.parentElement;
        if (container) {
          const chartHeight = Math.max(courseNames.length * 40, 300);
          container.style.minHeight = chartHeight + 'px';
        }

        this.candidatePerformanceComparisonChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: courseNames,
            datasets: [
              {
                label: month1Name,
                data: month1Data,
                backgroundColor: '#005068',
                borderColor: '#003d4d',
                borderWidth: 1,
                barThickness: 'flex' as any,
                barPercentage: 0.7
              },
              {
                label: month2Name,
                data: month2Data,
                backgroundColor: '#BFCAD9',
                borderColor: '#9ba5b8',
                borderWidth: 1,
                barThickness: 'flex' as any,
                barPercentage: 0.7
              }
            ]
          },
          options: {
            indexAxis: 'y' as const,
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: 'top' as const,
                display: true
              },
              title: {
                display: true,
                text: `Month-wise Candidate Performance Comparison: ${month1Name} vs ${month2Name}`
              }
            },
            scales: {
              x: {
                beginAtZero: true,
                stacked: false,
                ticks: {
                  stepSize: 1
                }
              },
              y: {
                ticks: {
                  font: {
                    size: 12
                  }
                }
              }
            }
          }
        });
        this.cdr.detectChanges();
      } catch (error) {
        console.error('Error initializing candidate performance comparison chart:', error);
      }
    }
  }, 200);
}

// ==================== CANDIDATE PERFORMANCE TABLE MODAL ====================

openCandidatePerformanceTableModal(): void {
  this.showCandidatePerformanceChartMenu = false;
  this.showCandidatePerformanceTableModal = true;
}

closeCandidatePerformanceTableModal(): void {
  this.showCandidatePerformanceTableModal = false;
}

// ==================== CANDIDATE PERFORMANCE EXPORT METHODS ====================

exportCandidatePerformanceAsPDF(): void {
  this.showCandidatePerformanceChartMenu = false;
  if (!this.candidatePerformanceChartLabels.length) { 
    this.util.simpleDialog({ title: 'Error', message: 'No data to export' });
    return; 
  }

  if (this.candidatePerformanceChart) {
    const canvas = this.candidatePerformanceChart.canvas;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.save();
      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.restore();
    }

    const chartImage = canvas.toDataURL('image/png', 1.0);
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    // Add title
    pdf.setFontSize(18);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Candidate Data by Performance', pageWidth / 2, 25, { align: 'center' });

    // Add source
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');
    pdf.text('Source: Assessment Planning Analytics', pageWidth / 2, 32, { align: 'center' });

    // Add separator
    pdf.setDrawColor(200, 200, 200);
    pdf.line(20, 38, pageWidth - 20, 38);

    // Add chart image
    const imgProps = pdf.getImageProperties(chartImage);
    const chartWidth = pageWidth * 0.8;
    const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
    const chartX = (pageWidth - chartWidth) / 2;
    const chartY = 45;

    pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

    // Add distribution summary
    const summaryStartY = chartY + chartHeight + 20;
    pdf.setFontSize(14);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Distribution Summary', 20, summaryStartY);

    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');

    let currentY = summaryStartY + 15;
    const totalCandidates = this.candidatePerformanceTotalCandidateCounts.reduce((sum, val) => sum + val, 0);

    this.candidatePerformanceChartLabels.forEach((label, index) => {
      const count = this.candidatePerformanceTotalCandidateCounts[index] || 0;
      const passCount = this.candidatePerformancePassData[index] || 0;
      const failCount = this.candidatePerformanceFailData[index] || 0;
      const percentage = totalCandidates > 0 ? ((count / totalCandidates) * 100).toFixed(1) : '0';
      const passPercentage = count > 0 ? ((passCount / count) * 100).toFixed(1) : '0';
      const failPercentage = count > 0 ? ((failCount / count) * 100).toFixed(1) : '0';
      
      const text = `${label}: ${count} total (${percentage}%) | Pass: ${passCount} (${passPercentage}%) | Fail: ${failCount} (${failPercentage}%)`;
      pdf.text(text, 25, currentY);
      currentY += 5;
    });

    // Add total and metadata
    currentY += 10;
    pdf.setFont('helvetica', 'bold');
    pdf.text(`Total Candidates: ${totalCandidates}`, 20, currentY);

    currentY += 8;
    pdf.setFontSize(9);
    pdf.setFont('helvetica', 'italic');

    let dateRangeText = `Date Range: ${this.selectedRange}`;
    if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
      dateRangeText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
    }
    pdf.text(dateRangeText, 20, currentY);

    currentY += 4;
    pdf.text(`View: ${this.candidatePerformanceSelectedToggle === 'pass' ? 'Pass' : 'Fail'} Performance`, 20, currentY);

    // Add footer
    const footerY = pageHeight - 10;
    pdf.setFontSize(8);
    pdf.setFont('helvetica', 'normal');
    pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth / 2, footerY, { align: 'center' });

    pdf.save('candidate-performance-analysis.pdf');
  }
}

exportCandidatePerformanceAsPNG(): void {
  this.showCandidatePerformanceChartMenu = false;
  if (!this.candidatePerformanceChartLabels.length) { 
    this.util.simpleDialog({ title: 'Error', message: 'No data to export' });
    return; 
  }

  if (this.candidatePerformanceChart) {
    // Create a container to combine chart and information
    const container = document.createElement('div');
    container.style.cssText = `
      position: fixed;
      left: -10000px;
      top: -10000px;
      width: 1400px;
      background: white;
      padding: 40px;
      border: 1px solid #ccc;
      z-index: 10000;
      font-family: Arial, sans-serif;
    `;

    // Create header
    const header = document.createElement('div');
    header.style.cssText = `
      text-align: center;
      margin-bottom: 40px;
      padding-bottom: 20px;
      border-bottom: 3px solid #005068;
    `;

    const title = document.createElement('h1');
    title.textContent = 'Candidate Data by Performance';
    title.style.cssText = `
      margin: 0 0 12px 0;
      color: #005068;
      font-size: 32px;
      font-weight: bold;
    `;

    const subtitle = document.createElement('p');
    subtitle.textContent = 'Source: Assessment Planning Analytics';
    subtitle.style.cssText = `
      margin: 0;
      color: #666;
      font-size: 16px;
    `;

    header.appendChild(title);
    header.appendChild(subtitle);

    // Create top row for chart and legends
    const topRow = document.createElement('div');
    topRow.style.cssText = `
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 60px;
      margin-bottom: 40px;
      padding: 30px;
      background: #f8f9fa;
      border-radius: 15px;
      min-height: 500px;
    `;

    // Chart container
    const chartContainer = document.createElement('div');
    chartContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 2;
      min-height: 500px;
    `;

    // Create a high-quality chart render
    const chartWrapper = document.createElement('div');
    chartWrapper.style.cssText = `
      width: 500px;
      height: 500px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: white;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      padding: 20px;
      box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    `;

    // Get the original chart canvas with white background
    const originalCanvas = this.candidatePerformanceChart.canvas;
    const ctx = originalCanvas.getContext('2d');
    if (ctx) {
      ctx.save();
      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, originalCanvas.width, originalCanvas.height);
      ctx.restore();
    }

    // Create a high-resolution canvas
    const highResCanvas = document.createElement('canvas');
    highResCanvas.width = 800;
    highResCanvas.height = 800;

    const highResCtx = highResCanvas.getContext('2d');
    if (highResCtx) {
      // Scale up for better quality
      highResCtx.scale(2, 2);
      // Set white background
      highResCtx.fillStyle = 'white';
      highResCtx.fillRect(0, 0, highResCanvas.width, highResCanvas.height);
      // Draw the chart with better quality
      highResCtx.drawImage(originalCanvas, 0, 0, 400, 400);
    }

    const chartImg = document.createElement('img');
    chartImg.src = highResCanvas.toDataURL('image/png', 1.0);
    chartImg.style.cssText = `
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 10px;
      object-fit: contain;
    `;

    chartWrapper.appendChild(chartImg);
    chartContainer.appendChild(chartWrapper);

    // Legends container
    const legendsContainer = document.createElement('div');
    legendsContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 25px;
      flex: 1;
      min-width: 320px;
      max-width: 350px;
    `;

    // Color Legend Container
    const colorLegendContainer = document.createElement('div');
    colorLegendContainer.style.cssText = `
      background: white;
      padding: 30px;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    `;

    const colorLegendTitle = document.createElement('h3');
    colorLegendTitle.textContent = 'Color Legend';
    colorLegendTitle.style.cssText = `
      margin: 0 0 25px 0;
      color: #005068;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      border-bottom: 3px solid #f0f0f0;
      padding-bottom: 15px;
    `;

    colorLegendContainer.appendChild(colorLegendTitle);

    // Add course color legend
    const courseLegend = document.createElement('div');
    courseLegend.style.cssText = `
      margin-bottom: 10px;
    `;

    const courseLegendTitle = document.createElement('h4');
    courseLegendTitle.textContent = 'Courses/Assessments';
    courseLegendTitle.style.cssText = `
      margin: 0 0 20px 0;
      color: #333;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    `;

    courseLegend.appendChild(courseLegendTitle);

    // Get unique courses and their colors
    const courseColors = new Map();
    const barColors = ['#015C96', '#2B78A9', '#FF6F59', '#DF7E7D', '#FFCC64', '#FFCC64'];

    this.candidatePerformanceChartLabels.forEach((label, index) => {
      courseColors.set(label, barColors[index % barColors.length]);
    });

    // Add course color items with better styling
    courseColors.forEach((color, courseName) => {
      const courseItem = document.createElement('div');
      courseItem.style.cssText = `
        display: flex;
        align-items: flex-start;
        margin-bottom: 16px;
        padding: 12px;
        background: #f8f9fa;
        border-radius: 10px;
        border-left: 5px solid ${color};
        transition: all 0.3s ease;
      `;

      const colorBox = document.createElement('div');
      colorBox.style.cssText = `
        width: 24px;
        height: 24px;
        background-color: ${color};
        border: 3px solid #fff;
        border-radius: 8px;
        margin-right: 15px;
        margin-top: 2px;
        box-shadow: 0 3px 8px rgba(0,0,0,0.2);
        flex-shrink: 0;
      `;

      const courseNameSpan = document.createElement('span');
      courseNameSpan.textContent = courseName;
      courseNameSpan.style.cssText = `
        font-size: 16px;
        font-weight: 500;
        color: #333;
        line-height: 1.4;
        word-wrap: break-word;
        flex: 1;
      `;

      courseItem.appendChild(colorBox);
      courseItem.appendChild(courseNameSpan);
      courseLegend.appendChild(courseItem);
    });

    colorLegendContainer.appendChild(courseLegend);
    legendsContainer.appendChild(colorLegendContainer);

    // Add legends to top row
    topRow.appendChild(chartContainer);
    topRow.appendChild(legendsContainer);

    // Distribution Summary Section
    const distributionSection = document.createElement('div');
    distributionSection.style.cssText = `
      margin-top: 40px;
    `;

    const distributionTitle = document.createElement('h2');
    distributionTitle.textContent = 'Distribution Summary';
    distributionTitle.style.cssText = `
      margin: 0 0 30px 0;
      color: #005068;
      font-size: 28px;
      font-weight: bold;
      text-align: center;
      border-bottom: 3px solid #005068;
      padding-bottom: 15px;
    `;

    distributionSection.appendChild(distributionTitle);

    // Create course card for all courses
    const courseCard = document.createElement('div');
    courseCard.style.cssText = `
      background: white;
      padding: 30px;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      border-left: 8px solid #005068;
      max-width: 900px;
      margin: 0 auto;
      box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    `;

    // Course header
    const courseHeader = document.createElement('h3');
    courseHeader.textContent = 'Performance Distribution';
    courseHeader.style.cssText = `
      margin: 0 0 25px 0;
      color: #333;
      font-size: 20px;
      font-weight: bold;
      border-bottom: 3px solid #f0f0f0;
      padding-bottom: 15px;
      text-align: center;
    `;

    courseCard.appendChild(courseHeader);

    // Create table-like structure for courses
    const tableContainer = document.createElement('div');
    tableContainer.style.cssText = `
      width: 100%;
    `;

    // Add header row
    const headerRow = document.createElement('div');
    headerRow.style.cssText = `
      display: grid;
      grid-template-columns: 2fr 1fr 1fr 1fr;
      gap: 20px;
      margin-bottom: 20px;
      padding: 15px;
      background: #f8f9fa;
      border-radius: 10px;
      font-weight: bold;
      color: #333;
      border-bottom: 2px solid #ddd;
    `;

    const headerCourse = document.createElement('div');
    headerCourse.textContent = 'Course/Assessment';
    headerCourse.style.cssText = 'font-weight: bold; color: #005068;';

    const headerTotal = document.createElement('div');
    headerTotal.textContent = 'Total Candidates';
    headerTotal.style.cssText = 'font-weight: bold; color: #005068; text-align: center;';

    const headerPass = document.createElement('div');
    headerPass.textContent = 'Pass';
    headerPass.style.cssText = 'font-weight: bold; color: #005068; text-align: center;';

    const headerFail = document.createElement('div');
    headerFail.textContent = 'Fail';
    headerFail.style.cssText = 'font-weight: bold; color: #005068; text-align: right;';

    headerRow.appendChild(headerCourse);
    headerRow.appendChild(headerTotal);
    headerRow.appendChild(headerPass);
    headerRow.appendChild(headerFail);
    tableContainer.appendChild(headerRow);

    // Add data rows
    const totalCandidates = this.candidatePerformanceTotalCandidateCounts.reduce((sum, val) => sum + val, 0);

    this.candidatePerformanceChartLabels.forEach((label, index) => {
      const count = this.candidatePerformanceTotalCandidateCounts[index] || 0;
      const passCount = this.candidatePerformancePassData[index] || 0;
      const failCount = this.candidatePerformanceFailData[index] || 0;
      const percentage = totalCandidates > 0 ? ((count / totalCandidates) * 100).toFixed(1) : '0';

      const rowDiv = document.createElement('div');
      rowDiv.style.cssText = `
        display: grid;
        grid-template-columns: 2fr 1fr 1fr 1fr;
        gap: 20px;
        align-items: center;
        padding: 15px;
        border-bottom: 2px solid #f5f5f5;
        margin-bottom: 10px;
        border-radius: 8px;
        transition: background 0.3s ease;
      `;

      const courseName = document.createElement('span');
      courseName.textContent = label;
      courseName.style.cssText = `
        font-weight: 500;
        color: #333;
        font-size: 16px;
      `;

      const totalCount = document.createElement('span');
      totalCount.textContent = count.toString();
      totalCount.style.cssText = `
        color: #666;
        font-weight: 600;
        font-size: 16px;
        text-align: center;
      `;

      const passSpan = document.createElement('span');
      passSpan.textContent = passCount.toString();
      passSpan.style.cssText = `
        color: #005068;
        font-weight: 600;
        font-size: 16px;
        text-align: center;
      `;

      const failSpan = document.createElement('span');
      failSpan.textContent = failCount.toString();
      failSpan.style.cssText = `
        color: #C71E1D;
        font-weight: 600;
        font-size: 16px;
        text-align: right;
      `;

      rowDiv.appendChild(courseName);
      rowDiv.appendChild(totalCount);
      rowDiv.appendChild(passSpan);
      rowDiv.appendChild(failSpan);
      tableContainer.appendChild(rowDiv);
    });

    courseCard.appendChild(tableContainer);
    distributionSection.appendChild(courseCard);

    // Total and footer section
    const totalSection = document.createElement('div');
    totalSection.style.cssText = `
      margin-top: 50px;
      padding: 30px;
      background: #f8f9fa;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      text-align: center;
    `;

    const totalLabel = document.createElement('div');
    totalLabel.style.cssText = `
      font-weight: bold;
      margin-bottom: 20px;
      font-size: 20px;
      color: #005068;
    `;
    totalLabel.textContent = `Total Candidates: ${totalCandidates}`;

    const metadataContainer = document.createElement('div');
    metadataContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-size: 15px;
      color: #666;
      margin-bottom: 20px;
    `;

    // View information
    const viewInfo = document.createElement('div');
    viewInfo.style.cssText = `
      font-weight: 500;
    `;
    viewInfo.textContent = `View: ${this.candidatePerformanceSelectedToggle === 'pass' ? 'Pass' : 'Fail'} Performance`;

    // Date information
    const dateInfo = document.createElement('div');
    let dateText = `Date Range: ${this.selectedRange}`;
    if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
      dateText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
    }
    dateInfo.textContent = dateText;

    // Footer
    const footer = document.createElement('div');
    footer.style.cssText = `
      text-align: center;
      margin-top: 20px;
      padding-top: 20px;
      border-top: 3px solid #ddd;
      font-size: 14px;
      color: #666;
      font-style: italic;
    `;
    footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;

    metadataContainer.appendChild(viewInfo);
    metadataContainer.appendChild(dateInfo);

    totalSection.appendChild(totalLabel);
    totalSection.appendChild(metadataContainer);
    totalSection.appendChild(footer);

    // Assemble the container
    container.appendChild(header);
    container.appendChild(topRow);
    container.appendChild(distributionSection);
    container.appendChild(totalSection);

    document.body.appendChild(container);

    // Use html2canvas with higher quality settings
    html2canvas(container, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      logging: false,
      width: container.offsetWidth,
      height: container.offsetHeight
    }).then(canvas => {
      const link = document.createElement('a');
      link.download = 'candidate-performance-analysis.png';
      link.href = canvas.toDataURL('image/png', 1.0);
      link.click();

      // Clean up
      document.body.removeChild(container);
    }).catch(err => {
      console.error('Error generating PNG:', err);
      document.body.removeChild(container);
    });
  }
}
showCandidatePerformanceDownloadSubMenu: boolean = false;
showCandidatePerformanceTableModal: boolean = false;
showCandidatePerformanceChartMenu: boolean = false;

  private initializeCategoryMonthComparisonChart(): void {
    const canvas = document.getElementById('categoryMonthComparisonChart') as HTMLCanvasElement;

    if (!canvas) {
      return;
    }

    if (this.categoryMonthComparisonChart) {
      this.categoryMonthComparisonChart.destroy();
    }

    const categoryNames = this.currentCategoryMonthComparisonData.map(d => d.name);

    const month1Values = categoryNames.map(name => {
      const item = this.currentCategoryMonthComparisonData.find(s => s.name === name);
      return item?.value || 0;
    });

    const month2Values = categoryNames.map(name => {
      const item = this.compareCategoryMonthComparisonData.find(s => s.name === name);
      return item?.value || 0;
    });

    const month1Name = this.getMonthName(this.selectedCategoryCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedCategoryCompareMonth2!);

    const ctx = canvas.getContext('2d');
    if (ctx) {
      this.categoryMonthComparisonChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: categoryNames,
          datasets: [
            {
              label: month1Name,
              data: month1Values,
              backgroundColor: '#FF9800',
              borderColor: '#FF9800',
              borderWidth: 0,
              borderRadius: 4,
              barThickness: 20
            },
            {
              label: month2Name,
              data: month2Values,
              backgroundColor: '#9C27B0',
              borderColor: '#9C27B0',
              borderWidth: 0,
              borderRadius: 4,
              barThickness: 20
            }
          ]
        },
        options: {
          indexAxis: 'y' as const,
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: {
              position: 'top',
              labels: {
                font: {
                  size: 12
                },
                padding: 15,
                usePointStyle: true
              }
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  return `${context.dataset.label}: ${context.raw}`;
                }
              }
            }
          },
          scales: {
            x: {
              beginAtZero: true,
              ticks: {
                stepSize: 1
              }
            },
            y: {
              ticks: {
                font: {
                  size: 11
                }
              }
            }
          }
        }
      });
    }
  }

  // Status Chart Properties
  showStatusFilterPanel: boolean = false;
  showStatusChartMenu: boolean = false;
  showStatusTableModalFlag: boolean = false;
  selectedStatusYearRange: string = '';
  selectedStatusMonth: number = new Date().getMonth() + 1;
  showStatusYearDropdown: boolean = false;
  showStatusMonthDropdown: boolean = false;
  activeStatusFilterHeader: string = 'courses';
  selectedStatusCourseIds: number[] = [];
  selectedStatus: string[] = [];
  statusCourseSearchTerm: string = '';
  statusSearchTerm: string = '';
  filteredStatusCourseList: any[] = [];
  filteredStatusList: any[] = [];
  showStatusPieChart: boolean = false;
  statusChartData: any[] = [];
  statusPieChart: Chart;

  // Status Filter Headers
  statusFilterHeaders = [
    { key: 'courses', name: 'Courses' },
    { key: 'status', name: 'Status' }
  ];

  // Available Status
  availableStatus = QUESTION_STATUS;

  // Add these properties to your component class
  showCourseBarChart: boolean = false;
  courseBarChartData: any[] = [];
  courseBarChart: Chart;
  selectedCourseYearRange: string = '';
  selectedCourseMonth: number = new Date().getMonth() + 1;
  showCourseYearDropdown: boolean = false;
  showCourseMonthDropdown: boolean = false;
  showCourseChartMenu: boolean = false;
  showCourseTableModalFlag: boolean = false;

  // Question Papers by Course/Job Role Chart Properties
  showQuestionPaperByCourseBarChart: boolean = false;
  questionPaperByCourseChartData: any[] = [];
  questionPaperByCourseChart: Chart;
  showQuestionPaperDonutChart: boolean = false;
  questionPaperDonutChartData: any[] = [];
  questionPaperDonutChart: Chart;
  selectedQuestionPaperCourseYearRange: string = '';
  selectedQuestionPaperCourseMonth: number = new Date().getMonth() + 1;
  showQuestionPaperCourseYearDropdown: boolean = false;
  showQuestionPaperCourseMonthDropdown: boolean = false;
  showQuestionPaperCourseChartMenu: boolean = false;
  showQuestionPaperCourseTableModalFlag: boolean = false;
  selectedQuestionPaperCourseFilterValues: any[] = [];
  questionPaperCourseSearchTerm: string = '';
  filteredQuestionPaperCourseList: any[] = [];
  activeQuestionPaperCourseFilterHeader: string = 'courses';
  showQuestionPaperCourseFilterPanel: boolean = false;
  selectedQuestionPaperCourseCourseIds: number[] = [];

  // Question Paper Customer Filter Properties
  questionPaperCustomerSearchTerm: string = '';
  filteredQuestionPaperCustomerList: any[] = [];
  selectedQuestionPaperCustomerIds: number[] = [];

  // Question Paper Product Filter Properties
  questionPaperProductSearchTerm: string = '';
  filteredQuestionPaperProductList: any[] = [];
  selectedQuestionPaperProductIds: string[] = [];

  // Question Paper Course Filter Headers
  questionPaperCourseFilterHeaders = [
    { key: 'courses', name: 'Courses' },
    { key: 'customers', name: 'Customers' }
  ];

  // Compare Dialog Properties for Question Paper Course Chart
  showQuestionPaperCourseCompareDialog: boolean = false;
  selectedQuestionPaperCompareMonth1: number | null = null;
  selectedQuestionPaperCompareMonth2: number | null = null;
  showQuestionPaperCompareMonth1Dropdown: boolean = false;
  showQuestionPaperCompareMonth2Dropdown: boolean = false;
  showQuestionPaperCourseComparisonResults: boolean = false;
  currentQuestionPaperCourseComparisonData: any[] = [];
  compareQuestionPaperCourseComparisonData: any[] = [];
  questionPaperCourseTrendSummary: any[] = [];
  questionPaperComparisonChart: Chart;
  activeQuestionPaperComparisonAccordion: string = 'summary';

  // ============================================================
  // QUESTION PAPER DIFFICULTY BREAKDOWN CHART PROPERTIES
  // ============================================================
  showQuestionPaperDifficultyChart: boolean = false;
  questionPaperDifficultyChartData: any[] = [];
  questionPaperDifficultyChart: Chart;
  selectedQuestionPaperDifficultyYearRange: string = '';
  selectedQuestionPaperDifficultyMonth: number = new Date().getMonth() + 1;
  showQuestionPaperDifficultyYearDropdown: boolean = false;
  showQuestionPaperDifficultyMonthDropdown: boolean = false;
  showQuestionPaperDifficultyFilterPanel: boolean = false;
  showQuestionPaperDifficultyChartMenu: boolean = false;
  showQuestionPaperDifficultyTableModalFlag: boolean = false;
  selectedQuestionPaperDifficultyCourseIds: number[] = [];
  selectedQuestionPaperDifficultyLevels: string[] = [];
  questionPaperDifficultySearchTerm: string = '';
  filteredQuestionPaperDifficultyList: any[] = [];
  activeQuestionPaperDifficultyFilterHeader: string = 'courses';

  // Question Paper Difficulty Filter Headers
  questionPaperDifficultyFilterHeaders = [
    { key: 'courses', name: 'Courses' },
    { key: 'difficulty', name: 'Difficulty Level' }
  ];

  // Available Difficulty Levels
  availableQuestionPaperDifficultyLevels = [
    { value: 'easy', label: 'Easy' },
    { value: 'medium', label: 'Medium' },
    { value: 'hard', label: 'Difficulty' }
  ];

  // Compare Dialog for Question Paper Difficulty
  showQuestionPaperDifficultyCompareDialog: boolean = false;
  selectedQuestionPaperDifficultyCompareYearRange: string = '';
  selectedQuestionPaperDifficultyCompareMonth: number | null = null;
  showQuestionPaperDifficultyCompareYearDropdown: boolean = false;
  showQuestionPaperDifficultyCompareMonthDropdown: boolean = false;
  showQuestionPaperDifficultyComparisonResults: boolean = false;
  currentQuestionPaperDifficultyComparisonData: any[] = [];
  compareQuestionPaperDifficultyComparisonData: any[] = [];
  questionPaperDifficultyTrendSummary: any[] = [];

  // Month-wise Compare Dialog for Question Paper Difficulty
  showQuestionPaperDifficultyMonthCompareDialog: boolean = false;
  selectedQuestionPaperDifficultyCompareMonth1: number | null = null;
  selectedQuestionPaperDifficultyCompareMonth2: number | null = null;
  showQuestionPaperDifficultyCompareMonth1Dropdown: boolean = false;
  showQuestionPaperDifficultyCompareMonth2Dropdown: boolean = false;
  showQuestionPaperDifficultyMonthComparisonResults: boolean = false;
  currentQuestionPaperDifficultyMonthComparisonData: any[] = [];
  compareQuestionPaperDifficultyMonthComparisonData: any[] = [];
  questionPaperDifficultyMonthComparisonChart: Chart | null = null;
  questionPaperDifficultyMonthTrendSummary: any[] = [];

  // ============================================================
  // QUESTION PAPER CATEGORY BREAKDOWN CHART PROPERTIES
  // ============================================================
  showQuestionPaperCategoryChart: boolean = false;
  questionPaperCategoryChartData: any[] = [];
  questionPaperCategoryChart: Chart;
  selectedQuestionPaperCategoryYearRange: string = '';
  selectedQuestionPaperCategoryMonth: number = new Date().getMonth() + 1;
  showQuestionPaperCategoryYearDropdown: boolean = false;
  showQuestionPaperCategoryMonthDropdown: boolean = false;
  showQuestionPaperCategoryFilterPanel: boolean = false;
  showQuestionPaperCategoryChartMenu: boolean = false;
  showQuestionPaperCategoryTableModalFlag: boolean = false;
  selectedQuestionPaperCategoryCourseIds: number[] = [];
  selectedQuestionPaperCategories: string[] = [];
  questionPaperCategorySearchTerm: string = '';
  filteredQuestionPaperCategoryList: any[] = [];
  activeQuestionPaperCategoryFilterHeader: string = 'courses';

  // Question Paper Category Filter Headers
  questionPaperCategoryFilterHeaders = [
    { key: 'courses', name: 'Courses' },
    { key: 'categories', name: 'Categories' }
  ];

  // Available Question Paper Categories
  availableQuestionPaperCategories = QUESTION_CATEGORIES;

  // Compare Dialog for Question Paper Category
  showQuestionPaperCategoryCompareDialog: boolean = false;
  selectedQuestionPaperCategoryCompareYearRange: string = '';
  selectedQuestionPaperCategoryCompareMonth: number | null = null;
  showQuestionPaperCategoryCompareYearDropdown: boolean = false;
  showQuestionPaperCategoryCompareMonthDropdown: boolean = false;
  showQuestionPaperCategoryComparisonResults: boolean = false;
  currentQuestionPaperCategoryComparisonData: any[] = [];
  compareQuestionPaperCategoryComparisonData: any[] = [];
  questionPaperCategoryTrendSummary: any[] = [];

  // Updated initializeCourseData method
  private initializeCourseData(): void {

    // Use the same year range as other charts for consistency
    this.selectedCourseYearRange = this.selectedYearRange;
    this.selectedCourseMonth = new Date().getMonth() + 1;
  }

  // Updated fetchCourseFilteredData method
  private fetchCourseFilteredData(): void {

    this.isLoading = true;

    let startDate: Date;
    let endDate: Date;

    if (this.selectedCourseMonth) {
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedCourseYearRange);
      if (yearRange) {
        const year = this.selectedCourseMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedCourseMonth - 1, 1);
        endDate = new Date(year, this.selectedCourseMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedCourseMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedCourseMonth, 0);
      }
    } else {
      const dateRange = this.getDateRangeFromYearRange(this.selectedCourseYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

    const resp = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          // Extract ONLY question counts - don't call processLibraryData() which updates ALL charts
          this.extractQuestionCountsFromResponse(response);
          // Prepare ONLY course data - preserve independence of other charts
          this.prepareCourseData(this.questionCounts);
          // Debug after data is prepared
          this.debugCourseChart();
        } else {
          this.courseBarChartData = [];
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      (error) => {
        this.courseBarChartData = [];
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  // Debug method for course chart
  private debugCourseChart(): void {

    if (this.questionCounts && this.questionCounts.length > 0) {
      this.questionCounts.slice(0, 5).forEach((course, index) => {
      });
    }
  }

  // In your component class, update the prepareCourseData method
  private prepareCourseData(courses: any[]): void {

    if (!courses || courses.length === 0) {
      this.courseBarChartData = [];
      this.showCourseBarChart = false;
      return;
    }

    // Reset data
    this.courseBarChartData = [];

    // Filter out courses with valid question counts
    const validCourses = courses.filter(course =>
      course && course.course_name && (course.question_count > 0)
    );


    if (validCourses.length === 0) {
      this.courseBarChartData = [];
      this.showCourseBarChart = false;
      return;
    }

    // Sort courses by question count in descending order
    const sortedCourses = [...validCourses].sort((a, b) =>
      (b.question_count || 0) - (a.question_count || 0)
    );

    // Take top 5 courses
    const topCourses = sortedCourses.slice(0, 5);

    // Calculate total for "Others" category
    const otherCoursesTotal = sortedCourses.slice(5).reduce((sum, course) =>
      sum + (course.question_count || 0), 0
    );
    // Define colors for courses
    const courseColors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#F67280' // Color for "Others"
    ];


    // If evaluation mode filter is applied, show breakdown for each course
    if (this.selectedCourseFilterEvaluationModes && this.selectedCourseFilterEvaluationModes.length > 0) {
      topCourses.forEach((course, index) => {
        const truncatedName = this.truncateCourseName(course.course_name, 15);
        const breakdown = course.question_category_breakdown || {};
        this.selectedCourseFilterEvaluationModes.forEach((mode, modeIdx) => {
          const value = breakdown[mode] || 0;
          if (value > 0) {
            this.courseBarChartData.push({
              name: `${truncatedName} - ${mode}`,
              originalName: `${course.course_name} - ${mode}`,
              value: value,
              color: courseColors[(index + modeIdx) % courseColors.length],
              courseName: course.course_name,
              courseId: course.course_id,
              evaluationMode: mode,
              isTopCourse: true
            });
          }
        });
      });
      // Add "Others" category if there are remaining courses
      if (otherCoursesTotal > 0) {
        // For "Others", sum by mode
        const othersBreakdown = {};
        sortedCourses.slice(5).forEach(course => {
          const breakdown = course.question_category_breakdown || {};
          this.selectedCourseFilterEvaluationModes.forEach(mode => {
            othersBreakdown[mode] = (othersBreakdown[mode] || 0) + (breakdown[mode] || 0);
          });
        });
        this.selectedCourseFilterEvaluationModes.forEach((mode, modeIdx) => {
          const value = othersBreakdown[mode] || 0;
          if (value > 0) {
            this.courseBarChartData.push({
              name: `Others - ${mode}`,
              originalName: `Other Courses - ${mode}`,
              value: value,
              color: courseColors[(5 + modeIdx) % courseColors.length],
              courseName: 'Other Courses',
              courseId: null,
              evaluationMode: mode,
              isTopCourse: false
            });
          }
        });
      }
    } else {
      // Default: show only total per course
      topCourses.forEach((course, index) => {
        const truncatedName = this.truncateCourseName(course.course_name, 15);
        this.courseBarChartData.push({
          name: truncatedName,
          originalName: course.course_name, // Keep original for tooltips
          value: course.question_count,
          color: courseColors[index % courseColors.length],
          courseName: course.course_name,
          courseId: course.course_id,
          isTopCourse: true
        });
      });
      // Add "Others" category if there are remaining courses
      if (otherCoursesTotal > 0) {
        this.courseBarChartData.push({
          name: 'Others',
          originalName: 'Other Courses',
          value: otherCoursesTotal,
          color: courseColors[5],
          courseName: 'Other Courses',
          courseId: null,
          isTopCourse: false
        });
      }
    }

    this.showCourseBarChart = this.courseBarChartData.length > 0;

    if (this.showCourseBarChart) {
      setTimeout(() => {
        this.initializeCourseBarChart();
      }, 100);
    }
  }

  // Update the initializeCourseBarChart method to use truncated names in labels but full names in tooltips
  private initializeCourseBarChart(): void {

    const canvas = document.getElementById('courseBarChart') as HTMLCanvasElement;

    if (!canvas) {
      const allCanvases = document.querySelectorAll('canvas');
      allCanvases.forEach((c, i) => {
      });
      return;
    }

    // Destroy existing chart if it exists
    if (this.courseBarChart) {
      this.courseBarChart.destroy();
    }

    // Filter out zero values
    const nonZeroData = this.courseBarChartData.filter(item => item.value > 0);
    if (nonZeroData.length === 0) {
      this.showCourseBarChart = false;

      // Clear canvas and show message
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = '#999';
        ctx.font = '16px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('No Course Data Available', canvas.width / 2, canvas.height / 2);
      }
      return;
    }

    this.showCourseBarChart = true;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      try {
        // Prepare chart data - use truncated names for labels
        const labels = nonZeroData.map(item => item.name);
        const data = nonZeroData.map(item => item.value);
        const backgroundColors = nonZeroData.map(item => item.color);
        this.courseBarChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: labels,
            datasets: [{
              label: 'Question Count',
              data: data,
              backgroundColor: backgroundColors,
              borderColor: backgroundColors.map(color => this.darkenColor(color, 20)),
              borderWidth: 1,
              borderRadius: 4,
              borderSkipped: false,
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  // Show full course name in tooltip
                  title: (context) => {
                    const index = context[0].dataIndex;
                    const item = nonZeroData[index];
                    return item.originalName || item.courseName || item.name;
                  },
                  label: (context) => {
                    const value = context.raw as number;
                    const total = data.reduce((sum, val) => sum + val, 0);
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                    return `Questions: ${value} (${percentage}%)`;
                  }
                }
              },
            },
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Number of Questions',
                  font: {
                    size: 12,
                    weight: 'bold'
                  }
                },
                grid: {
                  color: 'rgba(0,0,0,0.1)'
                },
                ticks: {
                  stepSize: 1,
                  precision: 0
                }
              },
              x: {
                title: {
                  display: true,
                  text: 'Courses/Job Roles',
                  font: {
                    size: 12,
                    weight: 'bold'
                  }
                },
                grid: {
                  display: false
                },
                ticks: {
                  autoSkip: true,
                  maxRotation: 45,
                  minRotation: 0,
                  // Ensure truncated labels are displayed properly
                  callback: function (value, index, values) {
                    const label = this.getLabelForValue(value as number);
                    return label; // Already truncated in prepareCourseData
                  }
                }
              }
            },
            layout: {
              padding: {
                top: 20,
                right: 10,
                bottom: 20,
                left: 10
              }
            },
            animation: {
              duration: 1000,
              easing: 'easeOutQuart'
            }
          }
        });
      } catch (error) {
        this.showCourseBarChart = false;
      }
    } else {
    }
  }

  // Update the truncateCourseName method to be more flexible
  private truncateCourseName(courseName: string, maxLength: number = 15): string {
    if (!courseName) return '';

    if (courseName.length <= maxLength) {
      return courseName;
    }

    return courseName.substring(0, maxLength - 3) + '...';
  }

  // Also update the legend display to show truncated names
  getCoursePercentage(item: any): string {
    if (!item || !this.courseBarChartData || this.courseBarChartData.length === 0) {
      return '0';
    }

    const total = this.courseBarChartData.reduce((sum, dataItem) => {
      return sum + (dataItem?.value || 0);
    }, 0);

    return total > 0 ? (((item.value || 0) / total) * 100).toFixed(1) : '0';
  }

  // Dropdown Methods for Course Chart
  toggleCourseYearDropdown(): void {
    this.showCourseYearDropdown = !this.showCourseYearDropdown;
    if (this.showCourseYearDropdown) {
      this.showCourseMonthDropdown = false;
    }
  }

  selectCourseYearRange(yearRange: string): void {
    this.selectedCourseYearRange = yearRange;
    this.showCourseYearDropdown = false;
    this.applyCourseMonthYearFilter();
  }

  toggleCourseMonthDropdown(): void {
    this.showCourseMonthDropdown = !this.showCourseMonthDropdown;
    if (this.showCourseMonthDropdown) {
      this.showCourseYearDropdown = false;
    }
  }

  selectCourseMonth(month: number): void {
    this.selectedCourseMonth = month;
    this.showCourseMonthDropdown = false;
    this.applyCourseMonthYearFilter();
  }

  applyCourseMonthYearFilter(): void {

    this.showCourseYearDropdown = false;
    this.showCourseMonthDropdown = false;
    this.fetchCourseFilteredData();
  }


  // Chart Menu Methods
  toggleCourseChartMenu(): void {
    this.showCourseChartMenu = !this.showCourseChartMenu;
    if (this.showCourseChartMenu) {
      this.showCourseFilterPanel = false; // Close filter when opening menu
    }
  }

  closeCourseChartMenu(): void {
    this.showCourseChartMenu = false;
  }

  // Table Modal Methods
  showCourseTableModal(): void {
    this.closeCourseChartMenu();
    this.showCourseTableModalFlag = true;
  }

  closeCourseTableModal(): void {
    this.showCourseTableModalFlag = false;
  }

  // Table Export Methods
  exportCourseTableAsPDF(): void {
    if (!this.ensureHasData(this.courseBarChartData)) { return; }
    const totalQuestions = this.courseBarChartData.reduce((sum, item) => sum + item.value, 0);
    let dateInfo = `Date Range: ${this.selectedRange}`;
    if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
      dateInfo += ` | From: ${this.formatDisplayDate(this.startDate)} To: ${this.formatDisplayDate(this.endDate)}`;
    }
    dateInfo += ` | Total Questions: ${totalQuestions}`;

    const tableData = this.courseBarChartData
      .filter(item => item.value > 0)
      .map(item => [
        item.name,
        item.value.toString(),
        `${this.getCoursePercentage(item)}%`
      ]);

    this.generateProfessionalPDF(
      'Questions by Course/Job Role - Detailed Report',
      tableData,
      ['Course Name', 'Count', 'Percentage'],
      'questions-by-course-detailed-report.pdf',
      dateInfo
    );
  }

  exportCourseTableAsPNG(): void {
    if (!this.ensureHasData(this.courseBarChartData)) { return; }
    const tableElement = document.querySelector('.course-modal-table') as HTMLElement;

    if (tableElement) {
      const container = document.createElement('div');
      container.style.cssText = `
        position: fixed;
        left: -10000px;
        top: -10000px;
        background: white;
        padding: 30px;
        z-index: 10000;
        max-width: 900px;
        width: 900px;
        font-family: Arial, sans-serif;
      `;

      const header = document.createElement('div');
      header.style.cssText = `
        text-align: center;
        margin-bottom: 25px;
        padding-bottom: 15px;
        border-bottom: 2px solid #005068;
      `;

      const title = document.createElement('h2');
      title.textContent = 'Questions by Course/Job Role - Detailed Report';
      title.style.cssText = 'margin: 0; color: #005068; font-size: 18px; font-weight: bold;';
      header.appendChild(title);

      const totalQuestions = this.courseBarChartData.reduce((sum, item) => sum + item.value, 0);
      let dateInfo = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateInfo += ` | From: ${this.formatDisplayDate(this.startDate)} To: ${this.formatDisplayDate(this.endDate)}`;
      }
      dateInfo += ` | Total: ${totalQuestions}`;

      const subtitle = document.createElement('p');
      subtitle.textContent = dateInfo;
      subtitle.style.cssText = 'margin: 10px 0 0 0; color: #666; font-size: 12px; text-align: center;';
      header.appendChild(subtitle);

      container.appendChild(header);

      const tableClone = tableElement.cloneNode(true) as HTMLElement;
      tableClone.style.cssText = `
        width: 100%;
        border-collapse: collapse;
        margin-top: 20px;
      `;

      const allTables = tableClone.querySelectorAll('table');
      allTables.forEach(table => {
        table.style.cssText = `
          width: 100%;
          border-collapse: collapse;
          background: white;
        `;
        table.querySelectorAll('th').forEach(th => {
          th.style.cssText = `
            background: #005068;
            color: white;
            padding: 12px;
            text-align: left;
            font-weight: bold;
            border: 1px solid #005068;
          `;
        });
        table.querySelectorAll('td').forEach(td => {
          td.style.cssText = `
            padding: 10px 12px;
            border: 1px solid #e0e0e0;
            text-align: left;
          `;
        });
        table.querySelectorAll('tbody tr:nth-child(even)').forEach(row => {
          (row as HTMLElement).style.backgroundColor = '#f5f5f5';
        });
      });

      container.appendChild(tableClone);
      document.body.appendChild(container);

      html2canvas(container, {
        backgroundColor: '#ffffff',
        scale: 2,
        useCORS: true,
        allowTaint: true
      }).then((canvas) => {
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'questions-by-course-detailed-report.png';
        link.click();
        document.body.removeChild(container);
      }).catch(err => {
        if (document.body.contains(container)) {
          document.body.removeChild(container);
        }
      });
    } else {
    }
  }

  // Export Methods
  exportCourseChartAsPDF(): void {
    this.closeCourseChartMenu();
    if (!this.ensureHasData(this.courseBarChartData)) { return; }

    if (this.courseBarChart) {
      const canvas = this.courseBarChart.canvas;
      const chartImage = canvas.toDataURL('image/png');

      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Add title
      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Questions by Course/Job Role - Top 10 + Others', pageWidth / 2, 25, { align: 'center' });

      // Add source
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      pdf.text('Source: Content Library Analytics', pageWidth / 2, 32, { align: 'center' });

      // Add separator
      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      // Add chart image
      const imgProps = pdf.getImageProperties(chartImage);
      const chartWidth = pageWidth * 0.8;
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      const chartX = (pageWidth - chartWidth) / 2;
      const chartY = 45;

      pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

      // Add distribution summary
      const summaryStartY = chartY + chartHeight + 20;
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Distribution Summary', 20, summaryStartY);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      let currentY = summaryStartY + 15;
      const totalQuestions = this.courseBarChartData.reduce((sum, item) => sum + item.value, 0);

      this.courseBarChartData.forEach(item => {
        const percentage = this.getCoursePercentage(item);
        pdf.text(`${item.name}: ${item.value} (${percentage}%)`, 25, currentY);
        currentY += 5;
      });

      // Add total and metadata
      currentY += 10;
      pdf.setFont('helvetica', 'bold');
      pdf.text(`Total Questions: ${totalQuestions}`, 20, currentY);

      currentY += 8;
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'italic');

      let dateRangeText = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateRangeText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
      }
      pdf.text(dateRangeText, 20, currentY);

      // Add footer
      const footerY = pageHeight - 10;
      pdf.setFontSize(8);
      pdf.setFont('helvetica', 'normal');
      pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth / 2, footerY, { align: 'center' });

      pdf.save('questions-by-course-analysis.pdf');
    }
  }

  exportCourseChartAsPNG(): void {
    this.closeCourseChartMenu();
    if (!this.ensureHasData(this.courseBarChartData)) { return; }

    if (this.courseBarChart) {
      // Create a container to combine chart and information
      const container = document.createElement('div');
      container.style.cssText = `
    position: fixed;
    left: -10000px;
    top: -10000px;
    width: 1400px;
    background: white;
    padding: 40px;
    border: 1px solid #ccc;
    z-index: 10000;
    font-family: Arial, sans-serif;
  `;

      // Create header
      const header = document.createElement('div');
      header.style.cssText = `
    text-align: center;
    margin-bottom: 40px;
    padding-bottom: 20px;
    border-bottom: 3px solid #005068;
  `;

      const title = document.createElement('h1');
      title.textContent = 'Questions by Course/Job Role - Top 10 + Others';
      title.style.cssText = `
    margin: 0 0 12px 0;
    color: #005068;
    font-size: 32px;
    font-weight: bold;
  `;

      const subtitle = document.createElement('p');
      subtitle.textContent = 'Source: Content Library Analytics';
      subtitle.style.cssText = `
    margin: 0;
    color: #666;
    font-size: 16px;
  `;

      header.appendChild(title);
      header.appendChild(subtitle);

      // Create top row for chart and legends
      const topRow = document.createElement('div');
      topRow.style.cssText = `
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 60px;
    margin-bottom: 40px;
    padding: 30px;
    background: #f8f9fa;
    border-radius: 15px;
    min-height: 500px;
  `;

      // Chart container
      const chartContainer = document.createElement('div');
      chartContainer.style.cssText = `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 2;
    min-height: 500px;
  `;

      // Create a high-quality chart render
      const chartWrapper = document.createElement('div');
      chartWrapper.style.cssText = `
    width: 500px;
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border-radius: 15px;
    border: 3px solid #e0e0e0;
    padding: 20px;
    box-shadow: 0 6px 20px rgba(0,0,0,0.15);
  `;

      // Get the original chart canvas
      const originalCanvas = this.courseBarChart.canvas;

      // Create a high-resolution canvas
      const highResCanvas = document.createElement('canvas');
      highResCanvas.width = 800;
      highResCanvas.height = 800;

      const ctx = highResCanvas.getContext('2d');
      if (ctx) {
        // Scale up for better quality
        ctx.scale(2, 2);

        // Set white background
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, highResCanvas.width, highResCanvas.height);

        // Draw the chart with better quality
        ctx.drawImage(originalCanvas, 0, 0, 400, 400);
      }

      const chartImg = document.createElement('img');
      chartImg.src = highResCanvas.toDataURL('image/png', 1.0);
      chartImg.style.cssText = `
    width: 100%;
    height: 100%;
    display: block;
    border-radius: 10px;
    object-fit: contain;
  `;

      chartWrapper.appendChild(chartImg);
      chartContainer.appendChild(chartWrapper);

      // Legends container
      const legendsContainer = document.createElement('div');
      legendsContainer.style.cssText = `
    display: flex;
    flex-direction: column;
    gap: 25px;
    flex: 1;
    min-width: 320px;
    max-width: 350px;
  `;

      // Color Legend Container
      const colorLegendContainer = document.createElement('div');
      colorLegendContainer.style.cssText = `
    background: white;
    padding: 30px;
    border-radius: 15px;
    border: 3px solid #e0e0e0;
    box-shadow: 0 6px 20px rgba(0,0,0,0.15);
  `;

      const colorLegendTitle = document.createElement('h3');
      colorLegendTitle.textContent = 'Color Legend';
      colorLegendTitle.style.cssText = `
    margin: 0 0 25px 0;
    color: #005068;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    border-bottom: 3px solid #f0f0f0;
    padding-bottom: 15px;
  `;

      colorLegendContainer.appendChild(colorLegendTitle);

      // Add course color legend
      const courseLegend = document.createElement('div');
      courseLegend.style.cssText = `
    margin-bottom: 10px;
  `;

      const courseLegendTitle = document.createElement('h4');
      courseLegendTitle.textContent = 'Courses';
      courseLegendTitle.style.cssText = `
    margin: 0 0 20px 0;
    color: #333;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  `;

      courseLegend.appendChild(courseLegendTitle);

      // Get unique courses and their colors
      const courseColors = new Map();
      const nonZeroData = this.courseBarChartData.filter(item => item.value > 0);

      nonZeroData.forEach(item => {
        courseColors.set(item.name, item.color);
      });

      // Add course color items with better styling
      courseColors.forEach((color, courseName) => {
        const courseItem = document.createElement('div');
        courseItem.style.cssText = `
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;
      padding: 12px;
      background: #f8f9fa;
      border-radius: 10px;
      border-left: 5px solid ${color};
      transition: all 0.3s ease;
    `;

        const colorBox = document.createElement('div');
        colorBox.style.cssText = `
      width: 24px;
      height: 24px;
      background-color: ${color};
      border: 3px solid #fff;
      border-radius: 8px;
      margin-right: 15px;
      margin-top: 2px;
      box-shadow: 0 3px 8px rgba(0,0,0,0.2);
      flex-shrink: 0;
    `;

        const courseNameSpan = document.createElement('span');
        courseNameSpan.textContent = courseName;
        courseNameSpan.style.cssText = `
      font-size: 16px;
      font-weight: 500;
      color: #333;
      line-height: 1.4;
      word-wrap: break-word;
      flex: 1;
    `;

        courseItem.appendChild(colorBox);
        courseItem.appendChild(courseNameSpan);
        courseLegend.appendChild(courseItem);
      });

      colorLegendContainer.appendChild(courseLegend);
      legendsContainer.appendChild(colorLegendContainer);

      // Add legends to top row
      topRow.appendChild(chartContainer);
      topRow.appendChild(legendsContainer);

      // Distribution Summary Section
      const distributionSection = document.createElement('div');
      distributionSection.style.cssText = `
    margin-top: 40px;
  `;

      const distributionTitle = document.createElement('h2');
      distributionTitle.textContent = 'Distribution Summary';
      distributionTitle.style.cssText = `
    margin: 0 0 30px 0;
    color: #005068;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    border-bottom: 3px solid #005068;
    padding-bottom: 15px;
  `;

      distributionSection.appendChild(distributionTitle);

      // Create course card for all courses
      const courseCard = document.createElement('div');
      courseCard.style.cssText = `
    background: white;
    padding: 30px;
    border-radius: 15px;
    border: 3px solid #e0e0e0;
    border-left: 8px solid #005068;
    max-width: 900px;
    margin: 0 auto;
    box-shadow: 0 6px 20px rgba(0,0,0,0.15);
  `;

      // Course header
      const courseHeader = document.createElement('h3');
      courseHeader.textContent = 'Question Distribution by Course';
      courseHeader.style.cssText = `
    margin: 0 0 25px 0;
    color: #333;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 3px solid #f0f0f0;
    padding-bottom: 15px;
    text-align: center;
  `;

      courseCard.appendChild(courseHeader);

      // Create table-like structure for courses
      const tableContainer = document.createElement('div');
      tableContainer.style.cssText = `
    width: 100%;
  `;

      // Add header row
      const headerRow = document.createElement('div');
      headerRow.style.cssText = `
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: 20px;
    margin-bottom: 20px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 10px;
    font-weight: bold;
    color: #333;
    border-bottom: 2px solid #ddd;
  `;

      const headerCourse = document.createElement('div');
      headerCourse.textContent = 'Course/Job Role';
      headerCourse.style.cssText = 'font-weight: bold; color: #005068;';

      const headerCount = document.createElement('div');
      headerCount.textContent = 'Count';
      headerCount.style.cssText = 'font-weight: bold; color: #005068; text-align: center;';

      const headerPercentage = document.createElement('div');
      headerPercentage.textContent = 'Percentage';
      headerPercentage.style.cssText = 'font-weight: bold; color: #005068; text-align: right;';

      headerRow.appendChild(headerCourse);
      headerRow.appendChild(headerCount);
      headerRow.appendChild(headerPercentage);
      tableContainer.appendChild(headerRow);

      // Add data rows
      nonZeroData.forEach(item => {
        const percentage = this.getCoursePercentage(item);

        const rowDiv = document.createElement('div');
        rowDiv.style.cssText = `
      display: grid;
      grid-template-columns: 2fr 1fr 1fr;
      gap: 20px;
      align-items: center;
      padding: 15px;
      border-bottom: 2px solid #f5f5f5;
      margin-bottom: 10px;
      border-radius: 8px;
      transition: background 0.3s ease;
    `;

        const courseName = document.createElement('span');
        courseName.textContent = item.name;
        courseName.style.cssText = `
      font-weight: 500;
      color: #333;
      font-size: 16px;
    `;

        const courseCount = document.createElement('span');
        courseCount.textContent = item.value.toString();
        courseCount.style.cssText = `
      color: #666;
      font-weight: 600;
      font-size: 16px;
      text-align: center;
    `;

        const coursePercentage = document.createElement('span');
        coursePercentage.textContent = `${percentage}%`;
        coursePercentage.style.cssText = `
      color: #666;
      font-weight: 600;
      font-size: 16px;
      text-align: right;
    `;

        rowDiv.appendChild(courseName);
        rowDiv.appendChild(courseCount);
        rowDiv.appendChild(coursePercentage);
        tableContainer.appendChild(rowDiv);
      });

      courseCard.appendChild(tableContainer);
      distributionSection.appendChild(courseCard);

      // Total and footer section
      const totalQuestions = this.courseBarChartData.reduce((sum, item) => sum + item.value, 0);

      const totalSection = document.createElement('div');
      totalSection.style.cssText = `
    margin-top: 50px;
    padding: 30px;
    background: #f8f9fa;
    border-radius: 15px;
    border: 3px solid #e0e0e0;
    text-align: center;
  `;

      const totalLabel = document.createElement('div');
      totalLabel.style.cssText = `
    font-weight: bold;
    margin-bottom: 20px;
    font-size: 20px;
    color: #005068;
  `;
      totalLabel.textContent = `Total Questions: ${totalQuestions}`;

      const metadataContainer = document.createElement('div');
      metadataContainer.style.cssText = `
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: 15px;
    color: #666;
    margin-bottom: 20px;
  `;

      // View information
      const viewInfo = document.createElement('div');
      viewInfo.style.cssText = `
    font-weight: 500;
  `;
      viewInfo.textContent = `View: Top 10 + Others`;

      // Date information
      const dateInfo = document.createElement('div');
      let dateText = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
      }
      dateInfo.textContent = dateText;

      // Footer
      const footer = document.createElement('div');
      footer.style.cssText = `
    text-align: center;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 3px solid #ddd;
    font-size: 14px;
    color: #666;
    font-style: italic;
  `;
      footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;

      metadataContainer.appendChild(viewInfo);
      metadataContainer.appendChild(dateInfo);

      totalSection.appendChild(totalLabel);
      totalSection.appendChild(metadataContainer);
      totalSection.appendChild(footer);

      // Assemble the container
      container.appendChild(header);
      container.appendChild(topRow);
      container.appendChild(distributionSection);
      container.appendChild(totalSection);

      document.body.appendChild(container);

      // Use html2canvas with higher quality settings
      html2canvas(container, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: container.offsetWidth,
        height: container.offsetHeight
      }).then(canvas => {
        const link = document.createElement('a');
        link.download = 'questions-by-course-analysis.png';
        link.href = canvas.toDataURL('image/png', 1.0);
        link.click();

        // Clean up
        document.body.removeChild(container);
      });
    }
  }

  // Add this to your ngOnInit method
  private initializeAllCharts(): void {
    this.initializeYearRanges();
    this.initializeLanguageData();
    this.initializeDifficultyData();
    this.initializeTypeData();
    this.initializeStatusData();
    this.initializeCategoryData();
    this.initializeCourseData();
    this.initializeTop10CourseData();
    this.selectedDifficultyCourseIds = [];
    this.selectedDifficultyLevels = [];
    this.selectedLanguageCourseIds = [];
    this.selectedLanguages = [];
    this.selectedCategoryCourseIds = [];
    this.selectedCategories = [];

  }
  // Course Chart Compare Dialog Properties
  showCourseCompareDialog: boolean = false;
  selectedCourseCompareMonth1: number | null = null;
  selectedCourseCompareMonth2: number | null = null;
  showCourseCompareMonth1Dropdown: boolean = false;
  showCourseCompareMonth2Dropdown: boolean = false;
  showCourseComparisonResults: boolean = false;
  currentCourseComparisonData: any[] = [];
  compareCourseComparisonData: any[] = [];
  courseTrendSummary: any[] = [];

  // Course Chart Filter Panel Properties
  showCourseFilterPanel: boolean = false;
  activeCourseFilterHeader: string = 'courses';
  courseFilterHeaders = [
    { key: 'courses', name: 'Courses' },
    { key: 'difficulty', name: 'Difficulty Level' },
    { key: 'types', name: 'Type' },
    { key: 'evaluationMode', name: 'Evaluation Mode' },
  ];
  selectedCourseFilterCourseIds: number[] = [];
  filteredCourseFilterList: any[] = [];
  selectedCourseFilterDifficultyLevels: string[] = [];
  selectedCourseFilterTypes: string[] = [];
  courseDifficultySearchTerm: string = '';
  courseTypeSearchTerm: string = '';
  filteredCourseDifficultyList: any[] = [];
  filteredCourseTypeList: any[] = [];
  selectedCourseFilterEvaluationModes: string[] = [];
  courseEvaluationModeSearchTerm: string = '';
  filteredCourseEvaluationModeList: any[] = [];
  availableCourseEvaluationModes: string[] = ['Theory', 'Practical', 'Viva'];
  selectedCourseFilterLanguages: string[] = [];
  courseLanguageSearchTerm: string = '';
  filteredCourseLanguageList: any[] = [];
  availableCourseLanguages: string[] = ['English', 'Hindi', 'Tamil', 'Telugu', 'Kannada', 'Gujarati', 'Oriya', 'Assamese', 'Urdu', 'Marathi', 'Malayalam', 'Bengali', 'Punjabi', 'Manipuri'];

  // Course Comparison Chart Properties
  courseComparisonChart: Chart;
  courseComparisonChartData: any[] = [];
  activeCourseComparisonAccordion: string = 'summary'; // 'summary' or 'table'

  // Compare Dialog Methods for Course Chart
  openCourseCompareDialog(): void {
    this.showCourseCompareDialog = true;
    this.showCourseComparisonResults = false;
    this.selectedCourseCompareMonth1 = null;
    this.selectedCourseCompareMonth2 = null;
  }

  closeCourseCompareDialog(): void {
    this.showCourseCompareDialog = false;
    this.showCourseComparisonResults = false;
    this.currentCourseComparisonData = [];
    this.compareCourseComparisonData = [];
  }

  // Compare Month 1 Dropdown Methods for Course Chart
  toggleCourseCompareMonth1Dropdown(): void {
    this.showCourseCompareMonth1Dropdown = !this.showCourseCompareMonth1Dropdown;
    if (this.showCourseCompareMonth1Dropdown) {
      this.showCourseCompareMonth2Dropdown = false;
    }
  }

  selectCourseCompareMonth1(month: number): void {
    this.selectedCourseCompareMonth1 = month;
    this.showCourseCompareMonth1Dropdown = false;
  }

  // Compare Month 2 Dropdown Methods for Course Chart
  toggleCourseCompareMonth2Dropdown(): void {
    this.showCourseCompareMonth2Dropdown = !this.showCourseCompareMonth2Dropdown;
    if (this.showCourseCompareMonth2Dropdown) {
      this.showCourseCompareMonth1Dropdown = false;
    }
  }

  selectCourseCompareMonth2(month: number): void {
    this.selectedCourseCompareMonth2 = month;
    this.showCourseCompareMonth2Dropdown = false;
  }

  loadCourseComparisonData(): void {
    if (!this.selectedCourseCompareMonth1 || !this.selectedCourseCompareMonth2) {
      return;
    }

    this.isLoading = true;
    this.showCourseComparisonResults = true;

    // Prepare current data for comparison
    this.prepareCurrentCourseComparisonData();

    // Fetch comparison data
    this.fetchCourseComparisonData();
  }

  private prepareCurrentCourseComparisonData(): void {
    this.currentCourseComparisonData = this.courseBarChartData
      .filter(item => item.value > 0)
      .map(item => ({
        name: item.name,
        value: item.value,
        percentage: this.getCoursePercentage(item),
        trend: 'neutral'
      }));
  }

  private fetchCourseComparisonData(): void {
    let startDate: Date;
    let endDate: Date;

    // Get the current year
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedCourseCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedCourseCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    // Fetch Month 1 data
    const resp1 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    // Fetch Month 2 data
    const resp2 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Data: any[] = [];
    let month2Data: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month1Data = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processCourseComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.compareCourseComparisonData = [];
          this.courseTrendSummary = [];
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month2Data = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processCourseComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.compareCourseComparisonData = [];
          this.courseTrendSummary = [];
        }
      }
    );

    // Set loading complete after both requests
    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    }, 2000);
  }

  private processCourseComparisonDataMonthWise(month1Data: any[], month2Data: any[]): void {
    // Type guard to check if question_count is a number
    const isValidCourse = (course: any): course is { course_name: string; question_count: number } => {
      return course &&
        course.course_name &&
        typeof course.question_count === 'number' &&
        course.question_count > 0;
    };

    // Process Month 1 data
    const validMonth1Courses = month1Data.filter(isValidCourse);
    const sortedMonth1Courses = [...validMonth1Courses].sort((a, b) =>
      b.question_count - a.question_count
    );
    const topMonth1Courses = sortedMonth1Courses.slice(0, 10);
    const otherMonth1CoursesTotal = sortedMonth1Courses.slice(10).reduce((sum, course) =>
      sum + course.question_count, 0
    );

    // Process Month 2 data
    const validMonth2Courses = month2Data.filter(isValidCourse);
    const sortedMonth2Courses = [...validMonth2Courses].sort((a, b) =>
      b.question_count - a.question_count
    );
    const topMonth2Courses = sortedMonth2Courses.slice(0, 10);
    const otherMonth2CoursesTotal = sortedMonth2Courses.slice(10).reduce((sum, course) =>
      sum + course.question_count, 0
    );

    // Store Month 1 data as current
    const month1Totals: { [key: string]: number } = {};
    topMonth1Courses.forEach(course => {
      month1Totals[course.course_name] = course.question_count;
    });
    if (otherMonth1CoursesTotal > 0) {
      month1Totals['Others'] = otherMonth1CoursesTotal;
    }

    this.currentCourseComparisonData = Object.entries(month1Totals)
      .filter(([_, count]) => count > 0)
      .map(([courseName, count]) => ({
        name: courseName,
        value: count,
        percentage: '0',
        trend: 'neutral'
      }));

    // Store Month 2 data as comparison
    const month2Totals: { [key: string]: number } = {};
    topMonth2Courses.forEach(course => {
      month2Totals[course.course_name] = course.question_count;
    });
    if (otherMonth2CoursesTotal > 0) {
      month2Totals['Others'] = otherMonth2CoursesTotal;
    }

    this.compareCourseComparisonData = Object.entries(month2Totals)
      .filter(([_, count]) => count > 0)
      .map(([courseName, count]) => {
        const currentItem = this.currentCourseComparisonData.find(item => item.name === courseName);
        const currentValue = currentItem ? currentItem.value : 0;

        let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
        if (count > currentValue) {
          trend = 'positive';
        } else if (count < currentValue) {
          trend = 'negative';
        }

        return {
          name: courseName,
          value: count,
          percentage: '0',
          trend: trend
        };
      });

    // Calculate trend summary
    this.calculateCourseTrendSummaryMonthWise();
  }

  private calculateCourseTrendSummaryMonthWise(): void {
    const month1Name = this.getMonthName(this.selectedCourseCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedCourseCompareMonth2!);
    const currentTotal = this.getCurrentCourseTotalQuestions();
    const compareTotal = this.getCompareCourseTotalQuestions();

    const difference = compareTotal - currentTotal;
    const trend = compareTotal > currentTotal ? 'positive' : compareTotal < currentTotal ? 'negative' : 'neutral';

    // Create summary with month names
    this.courseTrendSummary = [];

    // Get all unique courses from both months
    const allCourses = new Set<string>();
    this.currentCourseComparisonData.forEach(item => allCourses.add(item.name));
    this.compareCourseComparisonData.forEach(item => allCourses.add(item.name));

    // Create detailed comparison for each course
    Array.from(allCourses).slice(0, 10).forEach(courseName => {
      const month1Item = this.currentCourseComparisonData.find(item => item.name === courseName);
      const month2Item = this.compareCourseComparisonData.find(item => item.name === courseName);

      const month1Value = month1Item ? month1Item.value : 0;
      const month2Value = month2Item ? month2Item.value : 0;

      let trendIcon = '→';
      if (month2Value > month1Value) {
        trendIcon = '↑'; // Positive trend
      } else if (month2Value < month1Value) {
        trendIcon = '↓'; // Negative trend
      }

      this.courseTrendSummary.push({
        name: courseName,
        current: month1Value,
        compare: month2Value,
        change: month2Value - month1Value,
        trend: trendIcon
      });
    });

    // Initialize comparison chart
    this.initializeCourseComparisonChart();
  }

  private initializeCourseComparisonChart(): void {
    // Prepare data for chart
    const month1Name = this.getMonthName(this.selectedCourseCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedCourseCompareMonth2!);

    // Get unique courses from both datasets
    const allCourses = new Set<string>();
    this.currentCourseComparisonData.forEach(item => allCourses.add(item.name));
    this.compareCourseComparisonData.forEach(item => allCourses.add(item.name));

    const courseNames: string[] = Array.from(allCourses).slice(0, 10);
    const month1Data: number[] = [];
    const month2Data: number[] = [];

    courseNames.forEach(courseName => {
      const month1Item = this.currentCourseComparisonData.find(item => item.name === courseName);
      const month2Item = this.compareCourseComparisonData.find(item => item.name === courseName);
      month1Data.push(month1Item ? month1Item.value : 0);
      month2Data.push(month2Item ? month2Item.value : 0);
    });

    // Destroy existing chart if it exists
    if (this.courseComparisonChart) {
      this.courseComparisonChart.destroy();
    }

    // Delay chart initialization to ensure DOM is ready
    setTimeout(() => {
      const ctx = document.getElementById('courseComparisonChart') as HTMLCanvasElement;
      if (ctx) {
        this.courseComparisonChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: courseNames,
            datasets: [
              {
                label: month1Name,
                data: month1Data,
                backgroundColor: '#005068',
                borderColor: '#003d4d',
                borderWidth: 1
              },
              {
                label: month2Name,
                data: month2Data,
                backgroundColor: '#BFCAD9',
                borderColor: '#9ba5b8',
                borderWidth: 1
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: true,
            indexAxis: 'y' as const,
            plugins: {
              legend: {
                position: 'top' as const
              },
              title: {
                display: true,
                text: `Month-wise Questions Comparison: ${month1Name} vs ${month2Name}`
              }
            },
            scales: {
              x: {
                beginAtZero: true,
                stacked: false
              }
            }
          }
        });
      }
    }, 100);
  }

  toggleCourseComparisonAccordion(section: string): void {
    this.activeCourseComparisonAccordion = this.activeCourseComparisonAccordion === section ? '' : section;
  }

  private initializeQuestionPaperByCourseData(): void {

    this.selectedQuestionPaperCourseYearRange = this.selectedYearRange;
    this.selectedQuestionPaperCourseMonth = new Date().getMonth() + 1;
  }

  private fetchQuestionPaperByCourseFilteredData(): void {

    this.isLoading = true;

    let startDate: Date;
    let endDate: Date;

    if (this.selectedQuestionPaperCourseMonth) {
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedQuestionPaperCourseYearRange);
      if (yearRange) {
        const year = this.selectedQuestionPaperCourseMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedQuestionPaperCourseMonth - 1, 1);
        endDate = new Date(year, this.selectedQuestionPaperCourseMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedQuestionPaperCourseMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedQuestionPaperCourseMonth, 0);
      }
    } else {
      const dateRange = this.getDateRangeFromYearRange(this.selectedQuestionPaperCourseYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');
    const resp = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          this.extractQuestionCountsFromResponse(response);
          this.prepareQuestionPaperByCourseData(this.questionCounts);
        } else {
          this.questionPaperByCourseChartData = [];
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      (error) => {
        this.questionPaperByCourseChartData = [];
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  // Prepare Question Paper by Course Data
  private getCourseQuestionPaperCountValue(course: any): number {
    return course?.question_paper_count || course?.total_question_papers || 0;
  }

  private prepareQuestionPaperByCourseData(courses: any[]): void {
    this.questionPaperByCourseChartData = [];
    this.questionPaperDonutChartData = [];
    this.showQuestionPaperByCourseBarChart = false;
    this.showQuestionPaperDonutChart = false;

    if (!courses || courses.length === 0) {
      this.cdr.detectChanges();
      return;
    }

    // --- Evaluation Mode Filter Logic ---
    let filteredCourses = courses;
    if (this.selectedCourseFilterEvaluationModes && this.selectedCourseFilterEvaluationModes.length > 0) {
      // Filter by selected evaluation modes (theory/practical/viva)
      filteredCourses = courses.map(course => {
        const filteredCourse = { ...course };
        if (filteredCourse.question_paper_category_breakdown) {
          const filteredBreakdown = {};
          let filteredCount = 0;
          this.selectedCourseFilterEvaluationModes.forEach(mode => {
            if (filteredCourse.question_paper_category_breakdown[mode] !== undefined) {
              filteredBreakdown[mode] = filteredCourse.question_paper_category_breakdown[mode];
              filteredCount += filteredCourse.question_paper_category_breakdown[mode];
            }
          });
          filteredCourse.question_paper_category_breakdown = filteredBreakdown;
          filteredCourse.question_paper_count = filteredCount;
        } else {
          filteredCourse.question_paper_count = 0;
        }
        return filteredCourse;
      }).filter(course => course.question_paper_count > 0);
    }

    // Only show chart if there is data after filtering
    const totalQuestionPapers = filteredCourses.reduce((sum, course) => sum + (course.question_paper_count || 0), 0);

    if (totalQuestionPapers <= 0) {
      this.questionPaperByCourseChartData = [];
      this.questionPaperDonutChartData = [];
      this.showQuestionPaperByCourseBarChart = false;
      this.showQuestionPaperDonutChart = false;
      this.cdr.detectChanges();
      return;
    }

    // Prepare chart data for top 5 courses
    const sortedCourses = [...filteredCourses].sort((a, b) => (b.question_paper_count || 0) - (a.question_paper_count || 0));
    const topCourses = sortedCourses.slice(0, 5);
    const otherCoursesTotal = sortedCourses.slice(5).reduce((sum, course) => sum + (course.question_paper_count || 0), 0);
    const courseColors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#F67280' // Color for "Others"
    ];

    // Add top 5 courses
    topCourses.forEach((course, index) => {
      const truncatedName = this.truncateCourseName(course.course_name, 15);
      this.questionPaperByCourseChartData.push({
        name: truncatedName,
        originalName: course.course_name,
        value: course.question_paper_count,
        color: courseColors[index % courseColors.length],
        courseName: course.course_name,
        courseId: course.course_id,
        isTopCourse: true
      });
    });

    // Add "Others" if needed
    if (otherCoursesTotal > 0) {
      this.questionPaperByCourseChartData.push({
        name: 'Others',
        originalName: 'Other Courses',
        value: otherCoursesTotal,
        color: courseColors[5],
        courseName: 'Other Courses',
        courseId: null,
        isTopCourse: false
      });
    }

    // Donut chart data (overall)
    this.questionPaperDonutChartData = [{
      name: 'Overall',
      originalName: 'Overall',
      value: totalQuestionPapers,
      color: '#005068',
      courseName: 'Overall',
      courseId: null,
      isTopCourse: true
    }];

    this.showQuestionPaperByCourseBarChart = this.questionPaperByCourseChartData.length > 0;
    this.showQuestionPaperDonutChart = true;
    this.cdr.detectChanges();

    if (this.showQuestionPaperByCourseBarChart || this.showQuestionPaperDonutChart) {
      setTimeout(() => {
        if (this.showQuestionPaperByCourseBarChart) {
          this.initializeQuestionPaperByCourseBarChart();
        }
        if (this.showQuestionPaperDonutChart) {
          this.initializeQuestionPaperByCourseDonutChart();
        }
      }, 150);
    }
  }

  // Initialize Question Paper by Course Bar Chart
  private initializeQuestionPaperByCourseBarChart(): void {

    const canvas = document.getElementById('questionPaperByCourseBarChart') as HTMLCanvasElement;

    if (!canvas) {
      return;
    }

    // Destroy existing chart if it exists
    if (this.questionPaperByCourseChart) {
      this.questionPaperByCourseChart.destroy();
    }

    // Filter out zero values
    const nonZeroData = this.questionPaperByCourseChartData.filter(item => item.value > 0);

    if (nonZeroData.length === 0) {
      this.showQuestionPaperByCourseBarChart = false;
      return;
    }

    this.showQuestionPaperByCourseBarChart = true;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      try {
        const labels = nonZeroData.map(item => item.name);
        const data = nonZeroData.map(item => item.value);
        const backgroundColors = nonZeroData.map(item => item.color);
        this.questionPaperByCourseChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: labels,
            datasets: [{
              label: 'Question Paper Count',
              data: data,
              backgroundColor: backgroundColors,
              borderColor: backgroundColors.map(color => this.darkenColor(color, 20)),
              borderWidth: 1,
              borderRadius: 4,
              borderSkipped: false,
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  title: (context) => {
                    const index = context[0].dataIndex;
                    const item = nonZeroData[index];
                    return item.originalName || item.courseName || item.name;
                  },
                  label: (context) => {
                    const value = context.raw as number;
                    const total = data.reduce((sum, val) => sum + val, 0);
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                    return `Question Papers: ${value} (${percentage}%)`;
                  }
                }
              },
            },
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Number of Papers',
                  font: {
                    size: 12,
                    weight: 'bold'
                  }
                },
                grid: {
                  color: 'rgba(0,0,0,0.1)'
                },
                ticks: {
                  stepSize: 1,
                  precision: 0
                }
              },
              x: {
                title: {
                  display: true,
                  text: 'Courses/Job Roles',
                  font: {
                    size: 12,
                    weight: 'bold'
                  }
                },
                grid: {
                  display: false
                },
                ticks: {
                  autoSkip: true,
                  maxRotation: 45,
                  minRotation: 0,
                }
              }
            },
            layout: {
              padding: {
                top: 20,
                right: 10,
                bottom: 20,
                left: 10
              }
            },
            animation: {
              duration: 1000,
              easing: 'easeOutQuart'
            }
          }
        });
      } catch (error) {
        this.showQuestionPaperByCourseBarChart = false;
      }
    }

    // Ensure change detection after chart initialization
    this.cdr.detectChanges();
  }

  private initializeQuestionPaperByCourseDonutChart(): void {
    const canvas = document.getElementById('questionPaperByCourseDonutChart') as HTMLCanvasElement;
    if (!canvas) {
      return;
    }

    if (this.questionPaperDonutChart) {
      this.questionPaperDonutChart.destroy();
    }

    const nonZeroData = this.questionPaperDonutChartData.filter(item => item.value > 0);

    if (nonZeroData.length === 0) {
      this.showQuestionPaperDonutChart = false;
      return;
    }

    this.showQuestionPaperDonutChart = true;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      try {
        const labels = nonZeroData.map(item => item.name);
        const data = nonZeroData.map(item => item.value);
        const backgroundColors = nonZeroData.map(item => item.color);
        this.questionPaperDonutChart = new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: labels,
            datasets: [{
              data: data,
              backgroundColor: backgroundColors,
              borderColor: backgroundColors,
              borderWidth: 0,
              hoverBorderWidth: 0,
              hoverBorderColor: 'transparent',
              hoverOffset: 8,
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  title: (context) => {
                    const index = context[0].dataIndex;
                    const item = nonZeroData[index];
                    return item.originalName || item.courseName || item.name;
                  },
                  label: (context) => {
                    const value = context.raw as number;
                    const total = data.reduce((sum, val) => sum + val, 0);
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                    return `Question Papers: ${value} (${percentage}%)`;
                  }
                }
              },
            },
            layout: {
              padding: {
                top: 10,
                right: 10,
                bottom: 10,
                left: 10
              }
            },
            animation: {
              duration: 1000,
              easing: 'easeOutQuart'
            }
          }
        });
      } catch (error) {
        this.showQuestionPaperDonutChart = false;
      }
    }

    this.cdr.detectChanges();
  }

  // Initialize Question Paper by Course Bar Chart for "All" View (Duplicate)
  private initializeQuestionPaperByCourseBarChartAll(): void {
    const canvas = document.getElementById('questionPaperCourseBarChartAll') as HTMLCanvasElement;

    if (!canvas) {
      return;
    }

    // Filter out zero values
    const nonZeroData = this.questionPaperByCourseChartData.filter(item => item.value > 0);

    if (nonZeroData.length === 0) {
      return;
    }

    const ctx = canvas.getContext('2d');

    if (ctx) {
      try {
        const labels = nonZeroData.map(item => item.name);
        const data = nonZeroData.map(item => item.value);
        const backgroundColors = nonZeroData.map(item => item.color);

        const qpChartAll = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: labels,
            datasets: [{
              label: 'Question Papers Count',
              data: data,
              backgroundColor: backgroundColors,
              borderColor: '#555',
              borderWidth: 1,
              borderSkipped: false,
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  title: (context) => {
                    const index = context[0].dataIndex;
                    const item = nonZeroData[index];
                    return item.originalName || item.courseName || item.name;
                  },
                  label: (context) => {
                    const value = context.raw as number;
                    const total = data.reduce((sum, val) => sum + val, 0);
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                    return `Question Papers: ${value} (${percentage}%)`;
                  }
                }
              },
            },
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Number of Papers',
                  font: {
                    size: 12,
                    weight: 'bold'
                  }
                },
                grid: {
                  color: 'rgba(0,0,0,0.1)'
                },
                ticks: {
                  stepSize: 1,
                  precision: 0
                }
              },
              x: {
                title: {
                  display: true,
                  text: 'Courses/Job Roles',
                  font: {
                    size: 12,
                    weight: 'bold'
                  }
                },
                grid: {
                  display: false
                },
                ticks: {
                  autoSkip: true,
                  maxRotation: 45,
                  minRotation: 0,
                }
              }
            },
            layout: {
              padding: {
                top: 20,
                right: 10,
                bottom: 20,
                left: 10
              }
            },
            animation: {
              duration: 1000,
              easing: 'easeOutQuart'
            }
          }
        });
      } catch (error) {
      }
    }

    // Ensure change detection after chart initialization
    this.cdr.detectChanges();
  }

  // Question Paper Chart Percentage
  getQuestionPaperCoursePercentage(item: any): string {
    if (!item) {
      return '0';
    }

    const dataArray = (this.questionPaperDonutChartData && this.questionPaperDonutChartData.length > 0)
      ? this.questionPaperDonutChartData
      : this.questionPaperByCourseChartData;

    if (!dataArray || dataArray.length === 0) {
      return '0';
    }

    const total = dataArray.reduce((sum, dataItem) => {
      return sum + (dataItem?.value || 0);
    }, 0);

    return total > 0 ? (((item.value || 0) / total) * 100).toFixed(1) : '0';
  }

  // Question Paper Filter Panel Methods
  toggleQuestionPaperCourseFilterPanel(): void {
    this.showQuestionPaperCourseFilterPanel = !this.showQuestionPaperCourseFilterPanel;
    if (this.showQuestionPaperCourseFilterPanel) {
      this.showQuestionPaperCourseChartMenu = false; // Close menu when opening filter
      this.questionPaperCourseSearchTerm = '';
      this.questionPaperCustomerSearchTerm = '';
      this.questionPaperProductSearchTerm = '';
      this.filteredQuestionPaperCourseList = [...this.courseList];
      this.filteredQuestionPaperCustomerList = [...this.customerMasterData];
      this.filteredQuestionPaperProductList = [...this.allProductData];
      this.activeQuestionPaperCourseFilterHeader = 'courses';
      this.cdr.detectChanges();
    }
  }

  setActiveQuestionPaperCourseFilterHeader(headerKey: string): void {
    this.activeQuestionPaperCourseFilterHeader = headerKey;
    if (headerKey === 'courses') {
      this.questionPaperCourseSearchTerm = '';
      this.filteredQuestionPaperCourseList = [...this.courseList];
    } else if (headerKey === 'customers') {
      this.questionPaperCustomerSearchTerm = '';
      this.filteredQuestionPaperCustomerList = [...this.customerMasterData];
    } else if (headerKey === 'products') {
      this.questionPaperProductSearchTerm = '';
      this.filteredQuestionPaperProductList = [...this.allProductData];
    }
  }

  // Question Paper Course Selection Methods
  isCourseSelectedForQuestionPaperFilter(courseId: number): boolean {
    return this.selectedQuestionPaperCourseCourseIds.includes(courseId);
  }

  toggleCourseSelectionForQuestionPaperFilter(courseId: number): void {
    const index = this.selectedQuestionPaperCourseCourseIds.indexOf(courseId);
    if (index > -1) {
      this.selectedQuestionPaperCourseCourseIds.splice(index, 1);
    } else {
      this.selectedQuestionPaperCourseCourseIds.push(courseId);
    }
    this.updateQuestionPaperCourseFilteredData();
  }

  updateQuestionPaperCourseFilteredData(): void {
    let filteredCourses = this.questionCounts;

    if (this.selectedQuestionPaperCourseCourseIds.length > 0) {
      filteredCourses = this.questionCounts.filter(course =>
        this.selectedQuestionPaperCourseCourseIds.includes(course.course_id)
      );
    }

    if (this.selectedQuestionPaperCustomerIds.length > 0) {
      const selectedCustomerNames = this.customerMasterData
        .filter(c => this.selectedQuestionPaperCustomerIds.includes(c.id))
        .map(c => this.normalizeString(c.name));

      filteredCourses = filteredCourses.filter(course => {
        let courseCustomerName = this.normalizeString(course.customer_name || course.customer || course.organization_name || course.organization || '');
        
        if (!courseCustomerName && this.courseList) {
          const fullCourse = this.courseList.find(c => c.course_id === course.course_id || c.id === course.course_id);
          if (fullCourse) {
            courseCustomerName = this.normalizeString(fullCourse.customer_name || fullCourse.customer || fullCourse.organization_name || fullCourse.organization || '');
          }
        }

        if (!courseCustomerName && this.allCoursesOrg) {
          const orgCourse = this.allCoursesOrg.find(c => c.course_id === course.course_id);
          if (orgCourse) {
            courseCustomerName = this.normalizeString(orgCourse.customer_name || orgCourse.customer || orgCourse.organization_name || orgCourse.organization || '');
          }
        }

        if (courseCustomerName) {
          return selectedCustomerNames.includes(courseCustomerName);
        }

        // Try mapping via evaluationCriteriaList
        if (this.evaluationCriteriaList) {
          const courseCustomerNames = this.evaluationCriteriaList
            .filter((ec: any) => ec.course_id === course.course_id && ec.customer_name)
            .map((ec: any) => this.normalizeString(ec.customer_name));
          
          if (courseCustomerNames.some(name => selectedCustomerNames.includes(name))) {
            return true;
          }
        }

        return this.selectedQuestionPaperCustomerIds.includes(course.customer_id);
      }).map(course => {
        if (this.evaluationCriteriaList) {
          const matchingVersions = this.evaluationCriteriaList.filter((ec: any) => {
            return ec.course_id === course.course_id && 
                   ec.customer_name && 
                   selectedCustomerNames.includes(this.normalizeString(ec.customer_name));
          });
          
          if (matchingVersions.length > 0) {
            const activeCount = matchingVersions.filter((v: any) => v.is_active === true).length;
            const inactiveCount = matchingVersions.filter((v: any) => v.is_active === false).length;
            
            return {
              ...course,
              question_paper_count: matchingVersions.length,
              paper_status_breakdown: {
                active: activeCount,
                inactive: inactiveCount,
                archived: 0,
                deleted: 0
              }
            };
          }
        }
        return course;
      });
    }

    this.prepareQuestionPaperByCourseData(filteredCourses);
    this.cdr.detectChanges();
  }

  // Question Paper Filter Search
  filterQuestionPaperCourses(): void {
    if (!this.questionPaperCourseSearchTerm.trim()) {
      this.filteredQuestionPaperCourseList = [...this.courseList];
      return;
    }

    const searchTerm = this.questionPaperCourseSearchTerm.toLowerCase().trim();
    this.filteredQuestionPaperCourseList = this.courseList.filter(course =>
      course.course_name.toLowerCase().includes(searchTerm)
    );
  }

  filterQuestionPaperCustomers(): void {
    if (!this.questionPaperCustomerSearchTerm.trim()) {
      this.filteredQuestionPaperCustomerList = [...this.customerMasterData];
      return;
    }

    const searchTerm = this.questionPaperCustomerSearchTerm.toLowerCase().trim();
    this.filteredQuestionPaperCustomerList = this.customerMasterData.filter(customer =>
      customer.name.toLowerCase().includes(searchTerm)
    );
  }

  filterQuestionPaperProducts(): void {
    if (!this.questionPaperProductSearchTerm.trim()) {
      this.filteredQuestionPaperProductList = [...this.allProductData];
      return;
    }

    const searchTerm = this.questionPaperProductSearchTerm.toLowerCase().trim();
    this.filteredQuestionPaperProductList = this.allProductData.filter(product =>
      product.name.toLowerCase().includes(searchTerm)
    );
  }

  // Question Paper Filter Helper Methods
  getQuestionPaperCourseFilterHeaderCount(headerKey: string): number {
    switch (headerKey) {
      case 'courses':
        return this.selectedQuestionPaperCourseCourseIds.length;
      case 'customers':
        return this.selectedQuestionPaperCustomerIds.length;
      case 'products':
        return this.selectedQuestionPaperProductIds.length;
      default:
        return 0;
    }
  }

  areAllCoursesSelectedForQuestionPaperFilter(): boolean {
    if (this.courseList.length === 0) return false;
    return this.selectedQuestionPaperCourseCourseIds.length === this.courseList.length;
  }

  toggleAllCoursesSelectionForQuestionPaperFilter(): void {
    if (this.areAllCoursesSelectedForQuestionPaperFilter()) {
      this.selectedQuestionPaperCourseCourseIds = [];
    } else {
      this.selectedQuestionPaperCourseCourseIds = this.courseList.map(course => course.course_id);
    }
    this.updateQuestionPaperCourseFilteredData();
  }

  clearQuestionPaperCourseFilters(): void {
    this.selectedQuestionPaperCourseCourseIds = [];
    this.selectedQuestionPaperCustomerIds = [];
    this.selectedQuestionPaperProductIds = [];
    this.questionPaperCourseSearchTerm = '';
    this.questionPaperCustomerSearchTerm = '';
    this.questionPaperProductSearchTerm = '';
    this.filteredQuestionPaperCourseList = [...this.courseList];
    this.filteredQuestionPaperCustomerList = [...this.customerMasterData];
    this.filteredQuestionPaperProductList = [...this.allProductData];
    this.updateQuestionPaperCourseFilteredData();
  }

  isCoursesSelectionIndeterminateForQuestionPaperFilter(): boolean {
    return this.selectedQuestionPaperCourseCourseIds.length > 0 &&
      this.selectedQuestionPaperCourseCourseIds.length < this.courseList.length;
  }

  // Question Paper Customer Selection Methods
  isCustomerSelectedForQuestionPaperFilter(customerId: number): boolean {
    return this.selectedQuestionPaperCustomerIds.includes(customerId);
  }

  toggleCustomerSelectionForQuestionPaperFilter(customerId: number): void {
    const index = this.selectedQuestionPaperCustomerIds.indexOf(customerId);
    if (index > -1) {
      this.selectedQuestionPaperCustomerIds.splice(index, 1);
    } else {
      this.selectedQuestionPaperCustomerIds.push(customerId);
    }
    this.updateQuestionPaperCourseFilteredData();
  }

  areAllCustomersSelectedForQuestionPaperFilter(): boolean {
    if (this.customerMasterData.length === 0) return false;
    return this.selectedQuestionPaperCustomerIds.length === this.customerMasterData.length;
  }

  toggleAllCustomersSelectionForQuestionPaperFilter(): void {
    if (this.areAllCustomersSelectedForQuestionPaperFilter()) {
      this.selectedQuestionPaperCustomerIds = [];
    } else {
      this.selectedQuestionPaperCustomerIds = this.customerMasterData.map(customer => customer.id);
    }
    this.updateQuestionPaperCourseFilteredData();
  }

  isCustomersSelectionIndeterminateForQuestionPaperFilter(): boolean {
    return this.selectedQuestionPaperCustomerIds.length > 0 &&
      this.selectedQuestionPaperCustomerIds.length < this.customerMasterData.length;
  }

  // Question Paper Product Selection Methods
  isProductSelectedForQuestionPaperFilter(productId: string): boolean {
    return this.selectedQuestionPaperProductIds.includes(productId);
  }

  toggleProductSelectionForQuestionPaperFilter(productId: string): void {
    const index = this.selectedQuestionPaperProductIds.indexOf(productId);
    if (index > -1) {
      this.selectedQuestionPaperProductIds.splice(index, 1);
    } else {
      this.selectedQuestionPaperProductIds.push(productId);
    }
    this.updateQuestionPaperCourseFilteredData();
  }

  areAllProductsSelectedForQuestionPaperFilter(): boolean {
    if (this.allProductData.length === 0) return false;
    return this.selectedQuestionPaperProductIds.length === this.allProductData.length;
  }

  toggleAllProductsSelectionForQuestionPaperFilter(): void {
    if (this.areAllProductsSelectedForQuestionPaperFilter()) {
      this.selectedQuestionPaperProductIds = [];
    } else {
      this.selectedQuestionPaperProductIds = this.allProductData.map(product => product.id);
    }
    this.updateQuestionPaperCourseFilteredData();
  }

  isProductsSelectionIndeterminateForQuestionPaperFilter(): boolean {
    return this.selectedQuestionPaperProductIds.length > 0 &&
      this.selectedQuestionPaperProductIds.length < this.allProductData.length;
  }

  // Question Paper Year/Month Dropdown Methods
  toggleQuestionPaperCourseYearDropdown(): void {
    this.showQuestionPaperCourseYearDropdown = !this.showQuestionPaperCourseYearDropdown;
    if (this.showQuestionPaperCourseYearDropdown) {
      this.showQuestionPaperCourseMonthDropdown = false;
    }
  }

  selectQuestionPaperCourseYearRange(yearRange: string): void {
    this.selectedQuestionPaperCourseYearRange = yearRange;
    this.showQuestionPaperCourseYearDropdown = false;
    this.applyQuestionPaperCourseMonthYearFilter();
  }

  toggleQuestionPaperCourseMonthDropdown(): void {
    this.showQuestionPaperCourseMonthDropdown = !this.showQuestionPaperCourseMonthDropdown;
    if (this.showQuestionPaperCourseMonthDropdown) {
      this.showQuestionPaperCourseYearDropdown = false;
    }
  }

  selectQuestionPaperCourseMonth(month: number): void {
    this.selectedQuestionPaperCourseMonth = month;
    this.showQuestionPaperCourseMonthDropdown = false;
    this.applyQuestionPaperCourseMonthYearFilter();
  }

  applyQuestionPaperCourseMonthYearFilter(): void {

    this.showQuestionPaperCourseYearDropdown = false;
    this.showQuestionPaperCourseMonthDropdown = false;
    this.fetchQuestionPaperByCourseFilteredData();
  }

  // Question Paper Chart Menu Methods
  toggleQuestionPaperCourseChartMenu(): void {
    this.showQuestionPaperCourseChartMenu = !this.showQuestionPaperCourseChartMenu;
    if (this.showQuestionPaperCourseChartMenu) {
      this.showQuestionPaperCourseFilterPanel = false; // Close filter when opening menu
    }
  }

  closeQuestionPaperCourseChartMenu(): void {
    this.showQuestionPaperCourseChartMenu = false;
  }

  // Question Paper Table Modal Methods
  showQuestionPaperCourseTableModal(): void {
    this.closeQuestionPaperCourseChartMenu();
    this.showQuestionPaperCourseTableModalFlag = true;
  }

  closeQuestionPaperCourseTableModal(): void {
    this.showQuestionPaperCourseTableModalFlag = false;
  }

  // Question Paper Export Methods
  exportQuestionPaperByCourseChartAsPDF(): void {
    this.closeQuestionPaperCourseChartMenu();
    if (!this.ensureHasData(this.questionPaperByCourseChartData)) { return; }

    if (this.questionPaperByCourseChart) {
      const canvas = this.questionPaperByCourseChart.canvas;
      const chartImage = canvas.toDataURL('image/png');

      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Question Papers by Course/Job Role - Top 10 + Others', pageWidth / 2, 25, { align: 'center' });

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      pdf.text('Source: Content Library Analytics', pageWidth / 2, 32, { align: 'center' });

      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      const imgProps = pdf.getImageProperties(chartImage);
      const chartWidth = pageWidth * 0.8;
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      const chartX = (pageWidth - chartWidth) / 2;
      const chartY = 45;

      pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

      const summaryStartY = chartY + chartHeight + 20;
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Distribution Summary', 20, summaryStartY);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      let currentY = summaryStartY + 15;
      const totalPapers = this.questionPaperByCourseChartData.reduce((sum, item) => sum + item.value, 0);

      this.questionPaperByCourseChartData.forEach(item => {
        const percentage = this.getQuestionPaperCoursePercentage(item);
        const text = `${item.name}: ${item.value} (${percentage}%)`;
        pdf.text(text, 25, currentY);
        currentY += 8;

        if (currentY > pageHeight - 30) {
          pdf.addPage();
          currentY = 20;
        }
      });

      pdf.setFont('helvetica', 'bold');
      pdf.text(`Total Question Papers: ${totalPapers}`, 25, currentY + 5);

      pdf.save('question-papers-by-course.pdf');
    }
  }

  exportQuestionPaperByCourseChartAsPNG(): void {
    this.closeQuestionPaperCourseChartMenu();
    if (!this.ensureHasData(this.questionPaperByCourseChartData)) { return; }

    if (this.questionPaperByCourseChart) {
      // Create a container to combine chart and information
      const container = document.createElement('div');
      container.style.cssText = `
    position: fixed;
    left: -10000px;
    top: -10000px;
    width: 1400px;
    background: white;
    padding: 40px;
    border: 1px solid #ccc;
    z-index: 10000;
    font-family: Arial, sans-serif;
  `;

      // Create header
      const header = document.createElement('div');
      header.style.cssText = `
    text-align: center;
    margin-bottom: 40px;
    padding-bottom: 20px;
    border-bottom: 3px solid #005068;
  `;

      const title = document.createElement('h1');
      title.textContent = 'Question Papers by Course/Job Role';
      title.style.cssText = `
    margin: 0 0 12px 0;
    color: #005068;
    font-size: 32px;
    font-weight: bold;
  `;

      const subtitle = document.createElement('p');
      subtitle.textContent = 'Source: Content Library Analytics';
      subtitle.style.cssText = `
    margin: 0;
    color: #666;
    font-size: 16px;
  `;

      header.appendChild(title);
      header.appendChild(subtitle);

      // Create top row for chart and legends
      const topRow = document.createElement('div');
      topRow.style.cssText = `
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 60px;
    margin-bottom: 40px;
    padding: 30px;
    background: #f8f9fa;
    border-radius: 15px;
    min-height: 500px;
  `;

      // Chart container
      const chartContainer = document.createElement('div');
      chartContainer.style.cssText = `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 2;
    min-height: 500px;
  `;

      // Create a high-quality chart render
      const chartWrapper = document.createElement('div');
      chartWrapper.style.cssText = `
    width: 500px;
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border-radius: 15px;
    border: 3px solid #e0e0e0;
    padding: 20px;
    box-shadow: 0 6px 20px rgba(0,0,0,0.15);
  `;

      // Get the original chart canvas
      const originalCanvas = this.questionPaperByCourseChart.canvas;

      // Create a high-resolution canvas
      const highResCanvas = document.createElement('canvas');
      highResCanvas.width = 800;
      highResCanvas.height = 800;

      const ctx = highResCanvas.getContext('2d');
      if (ctx) {
        // Scale up for better quality
        ctx.scale(2, 2);

        // Set white background
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, highResCanvas.width, highResCanvas.height);

        // Draw the chart with better quality
        ctx.drawImage(originalCanvas, 0, 0, 400, 400);
      }

      const chartImg = document.createElement('img');
      chartImg.src = highResCanvas.toDataURL('image/png', 1.0);
      chartImg.style.cssText = `
    width: 100%;
    height: 100%;
    display: block;
    border-radius: 10px;
    object-fit: contain;
  `;

      chartWrapper.appendChild(chartImg);
      chartContainer.appendChild(chartWrapper);

      // Legends container
      const legendsContainer = document.createElement('div');
      legendsContainer.style.cssText = `
    display: flex;
    flex-direction: column;
    gap: 25px;
    flex: 1;
    min-width: 320px;
    max-width: 350px;
  `;

      // Color Legend Container
      const colorLegendContainer = document.createElement('div');
      colorLegendContainer.style.cssText = `
    background: white;
    padding: 30px;
    border-radius: 15px;
    border: 3px solid #e0e0e0;
    box-shadow: 0 6px 20px rgba(0,0,0,0.15);
  `;

      const colorLegendTitle = document.createElement('h3');
      colorLegendTitle.textContent = 'Color Legend';
      colorLegendTitle.style.cssText = `
    margin: 0 0 25px 0;
    color: #005068;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    border-bottom: 3px solid #f0f0f0;
    padding-bottom: 15px;
  `;

      colorLegendContainer.appendChild(colorLegendTitle);

      // Add course color legend
      const courseLegend = document.createElement('div');
      courseLegend.style.cssText = `
    margin-bottom: 10px;
  `;

      const courseLegendTitle = document.createElement('h4');
      courseLegendTitle.textContent = 'Courses';
      courseLegendTitle.style.cssText = `
    margin: 0 0 20px 0;
    color: #333;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  `;

      courseLegend.appendChild(courseLegendTitle);

      // Get unique courses and their colors
      const courseColors = new Map();
      const nonZeroData = this.questionPaperByCourseChartData.filter(item => item.value > 0);

      nonZeroData.forEach(item => {
        courseColors.set(item.name, item.color);
      });

      // Add course color items with better styling
      courseColors.forEach((color, courseName) => {
        const courseItem = document.createElement('div');
        courseItem.style.cssText = `
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;
      padding: 12px;
      background: #f8f9fa;
      border-radius: 10px;
      border-left: 5px solid ${color};
      transition: all 0.3s ease;
    `;

        const colorBox = document.createElement('div');
        colorBox.style.cssText = `
      width: 24px;
      height: 24px;
      background-color: ${color};
      border: 3px solid #fff;
      border-radius: 8px;
      margin-right: 15px;
      margin-top: 2px;
      box-shadow: 0 3px 8px rgba(0,0,0,0.2);
      flex-shrink: 0;
    `;

        const courseNameSpan = document.createElement('span');
        courseNameSpan.textContent = courseName;
        courseNameSpan.style.cssText = `
      font-size: 16px;
      font-weight: 500;
      color: #333;
      line-height: 1.4;
      word-wrap: break-word;
      flex: 1;
    `;

        courseItem.appendChild(colorBox);
        courseItem.appendChild(courseNameSpan);
        courseLegend.appendChild(courseItem);
      });

      colorLegendContainer.appendChild(courseLegend);
      legendsContainer.appendChild(colorLegendContainer);

      // Add legends to top row
      topRow.appendChild(chartContainer);
      topRow.appendChild(legendsContainer);

      // Distribution Summary Section
      const distributionSection = document.createElement('div');
      distributionSection.style.cssText = `
    margin-top: 40px;
  `;

      const distributionTitle = document.createElement('h2');
      distributionTitle.textContent = 'Distribution Summary';
      distributionTitle.style.cssText = `
    margin: 0 0 30px 0;
    color: #005068;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    border-bottom: 3px solid #005068;
    padding-bottom: 15px;
  `;

      distributionSection.appendChild(distributionTitle);

      // Create course card for all courses
      const courseCard = document.createElement('div');
      courseCard.style.cssText = `
    background: white;
    padding: 30px;
    border-radius: 15px;
    border: 3px solid #e0e0e0;
    border-left: 8px solid #005068;
    max-width: 900px;
    margin: 0 auto;
    box-shadow: 0 6px 20px rgba(0,0,0,0.15);
  `;

      // Course header
      const courseHeader = document.createElement('h3');
      courseHeader.textContent = 'Question Papers Distribution by Course';
      courseHeader.style.cssText = `
    margin: 0 0 25px 0;
    color: #333;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 3px solid #f0f0f0;
    padding-bottom: 15px;
    text-align: center;
  `;

      courseCard.appendChild(courseHeader);

      // Create table-like structure for courses
      const tableContainer = document.createElement('div');
      tableContainer.style.cssText = `
    width: 100%;
  `;

      // Add header row
      const headerRow = document.createElement('div');
      headerRow.style.cssText = `
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: 20px;
    margin-bottom: 20px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 10px;
    font-weight: bold;
    color: #333;
    border-bottom: 2px solid #ddd;
  `;

      const headerCourse = document.createElement('div');
      headerCourse.textContent = 'Course/Job Role';
      headerCourse.style.cssText = 'font-weight: bold; color: #005068;';

      const headerCount = document.createElement('div');
      headerCount.textContent = 'Papers';
      headerCount.style.cssText = 'font-weight: bold; color: #005068; text-align: center;';

      const headerPercentage = document.createElement('div');
      headerPercentage.textContent = 'Percentage';
      headerPercentage.style.cssText = 'font-weight: bold; color: #005068; text-align: right;';

      headerRow.appendChild(headerCourse);
      headerRow.appendChild(headerCount);
      headerRow.appendChild(headerPercentage);
      tableContainer.appendChild(headerRow);

      // Add data rows
      nonZeroData.forEach(item => {
        const percentage = this.getQuestionPaperCoursePercentage(item);

        const rowDiv = document.createElement('div');
        rowDiv.style.cssText = `
      display: grid;
      grid-template-columns: 2fr 1fr 1fr;
      gap: 20px;
      align-items: center;
      padding: 15px;
      border-bottom: 2px solid #f5f5f5;
      margin-bottom: 10px;
      border-radius: 8px;
      transition: background 0.3s ease;
    `;

        const courseName = document.createElement('span');
        courseName.textContent = item.name;
        courseName.style.cssText = `
      font-weight: 500;
      color: #333;
      font-size: 16px;
    `;

        const courseCount = document.createElement('span');
        courseCount.textContent = item.value.toString();
        courseCount.style.cssText = `
      color: #666;
      font-weight: 600;
      font-size: 16px;
      text-align: center;
    `;

        const coursePercentage = document.createElement('span');
        coursePercentage.textContent = `${percentage}%`;
        coursePercentage.style.cssText = `
      color: #666;
      font-weight: 600;
      font-size: 16px;
      text-align: right;
    `;

        rowDiv.appendChild(courseName);
        rowDiv.appendChild(courseCount);
        rowDiv.appendChild(coursePercentage);
        tableContainer.appendChild(rowDiv);
      });

      courseCard.appendChild(tableContainer);
      distributionSection.appendChild(courseCard);

      // Total and footer section
      const totalPapers = this.questionPaperByCourseChartData.reduce((sum, item) => sum + item.value, 0);

      const totalSection = document.createElement('div');
      totalSection.style.cssText = `
    margin-top: 50px;
    padding: 30px;
    background: #f8f9fa;
    border-radius: 15px;
    border: 3px solid #e0e0e0;
    text-align: center;
  `;

      const totalLabel = document.createElement('div');
      totalLabel.style.cssText = `
    font-weight: bold;
    margin-bottom: 20px;
    font-size: 20px;
    color: #005068;
  `;
      totalLabel.textContent = `Total Question Papers: ${totalPapers}`;

      const metadataContainer = document.createElement('div');
      metadataContainer.style.cssText = `
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: 15px;
    color: #666;
    margin-bottom: 20px;
  `;

      // View information
      const viewInfo = document.createElement('div');
      viewInfo.style.cssText = `
    font-weight: 500;
  `;
      viewInfo.textContent = `View: Question Papers Distribution`;

      // Date information
      const dateInfo = document.createElement('div');
      let dateText = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
      }
      dateInfo.textContent = dateText;

      // Footer
      const footer = document.createElement('div');
      footer.style.cssText = `
    text-align: center;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 3px solid #ddd;
    font-size: 14px;
    color: #666;
    font-style: italic;
  `;
      footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;

      metadataContainer.appendChild(viewInfo);
      metadataContainer.appendChild(dateInfo);

      totalSection.appendChild(totalLabel);
      totalSection.appendChild(metadataContainer);
      totalSection.appendChild(footer);

      // Assemble the container
      container.appendChild(header);
      container.appendChild(topRow);
      container.appendChild(distributionSection);
      container.appendChild(totalSection);

      document.body.appendChild(container);

      // Use html2canvas with higher quality settings
      html2canvas(container, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: container.offsetWidth,
        height: container.offsetHeight
      }).then(canvas => {
        const link = document.createElement('a');
        link.download = 'question-papers-by-course-analysis.png';
        link.href = canvas.toDataURL('image/png', 1.0);
        link.click();

        // Clean up
        document.body.removeChild(container);
      });
    }
  }

  exportQuestionPaperByCourseTableAsPDF(): void {
    if (!this.ensureHasData(this.questionPaperByCourseChartData)) { return; }
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();

    pdf.setFontSize(18);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Question Papers by Course/Job Role - Detailed Breakdown', pageWidth / 2, 25, { align: 'center' });

    const headers = ['Course Name', 'Question Papers', 'Percentage'];
    const rows: any[] = [];

    this.questionPaperByCourseChartData.forEach(item => {
      rows.push([
        item.name,
        item.value,
        this.getQuestionPaperCoursePercentage(item) + '%'
      ]);
    });

    const tableConfig = {
      startY: 35,
      head: [headers],
      body: rows,
      theme: 'grid' as const,
      headStyles: { fillColor: [41, 128, 185], textColor: 255 },
      alternateRowStyles: { fillColor: [240, 240, 240] }
    };

    (pdf as any).autoTable(tableConfig);
    pdf.save('question-papers-by-course-table.pdf');
  }

  exportQuestionPaperByCourseTableAsPNG(): void {
    if (!this.ensureHasData(this.questionPaperByCourseChartData)) { return; }
    const table = document.createElement('table');
    table.style.width = '100%';
    table.style.borderCollapse = 'collapse';

    const thead = table.createTHead();
    const headerRow = thead.insertRow();
    ['Course Name', 'Question Papers', 'Percentage'].forEach(header => {
      const th = document.createElement('th');
      th.textContent = header;
      th.style.border = '1px solid black';
      th.style.padding = '10px';
      th.style.backgroundColor = '#2980b9';
      th.style.color = 'white';
      headerRow.appendChild(th);
    });

    const tbody = table.createTBody();
    this.questionPaperByCourseChartData.forEach(item => {
      const row = tbody.insertRow();
      const cells = [item.name, item.value.toString(), this.getQuestionPaperCoursePercentage(item) + '%'];
      cells.forEach(cell => {
        const td = row.insertCell();
        td.textContent = cell;
        td.style.border = '1px solid black';
        td.style.padding = '10px';
      });
    });

    html2canvas(table, { scale: 2 }).then(canvas => {
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = 'question-papers-by-course-table.png';
      link.click();
    });
  }

  // ============================================================
  // QUESTION PAPER DIFFICULTY BREAKDOWN METHODS
  // ============================================================

  // Initialize Question Paper Difficulty Data
  private initializeQuestionPaperDifficultyData(): void {
    this.selectedQuestionPaperDifficultyYearRange = this.selectedYearRange;
    this.selectedQuestionPaperDifficultyMonth = new Date().getMonth() + 1;
  }

  // Prepare Question Paper Difficulty Data
  private prepareQuestionPaperDifficultyData(courses: any[]): void {
    if (!courses || courses.length === 0) {
      this.questionPaperDifficultyChartData = [];
      this.showQuestionPaperDifficultyChart = false;
      this.cdr.detectChanges();
      return;
    }

    const difficultyBreakdown: { [key: string]: number } = {
      easy: 0,
      medium: 0,
      hard: 0
    };

    // Aggregate difficulty breakdown across all courses
    courses.forEach(course => {
      if (course.paper_difficulty_breakdown) {
        difficultyBreakdown.easy += course.paper_difficulty_breakdown.easy || 0;
        difficultyBreakdown.medium += course.paper_difficulty_breakdown.medium || 0;
        difficultyBreakdown.hard += course.paper_difficulty_breakdown.hard || 0;
      } else {
        // FALLBACK: Generate dummy data based on question_paper_count if breakdown not available
        if (course.question_paper_count) {
          difficultyBreakdown.easy += Math.floor(course.question_paper_count * 0.3);
          difficultyBreakdown.medium += Math.floor(course.question_paper_count * 0.5);
          difficultyBreakdown.hard += Math.ceil(course.question_paper_count * 0.2);
        }
      }
    });

    // Use consistent color palette from the dashboard
    const difficultyColors = {
      easy: '#005068',
      medium: '#A0A0FF',
      hard: '#C71E1D'
    };

    this.questionPaperDifficultyChartData = [
      { name: 'Easy', value: difficultyBreakdown.easy, color: difficultyColors.easy, difficulty: 'easy' },
      { name: 'Medium', value: difficultyBreakdown.medium, color: difficultyColors.medium, difficulty: 'medium' },
      { name: 'difficulty', value: difficultyBreakdown.hard, color: difficultyColors.hard, difficulty: 'hard' }
    ].filter(item => item.value > 0);

    this.showQuestionPaperDifficultyChart = this.questionPaperDifficultyChartData.length > 0;

    this.cdr.detectChanges();

    if (this.showQuestionPaperDifficultyChart) {
      setTimeout(() => {
        this.initializeQuestionPaperDifficultyChart();
      }, 150);
    }
  }

  // Initialize Question Paper Difficulty Chart (Donut)
  private initializeQuestionPaperDifficultyChart(): void {
    const canvas = document.getElementById('questionPaperDifficultyChart') as HTMLCanvasElement;

    if (!canvas) {
      return;
    }

    if (this.questionPaperDifficultyChart) {
      this.questionPaperDifficultyChart.destroy();
    }

    const nonZeroData = this.questionPaperDifficultyChartData.filter(item => item.value > 0);

    if (nonZeroData.length === 0) {
      this.showQuestionPaperDifficultyChart = false;
      return;
    }

    const ctx = canvas.getContext('2d');

    if (ctx) {
      try {
        const labels = nonZeroData.map(item => item.name);
        const data = nonZeroData.map(item => item.value);
        const backgroundColors = nonZeroData.map(item => item.color);

        this.questionPaperDifficultyChart = new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: labels,
            datasets: [{
              data: data,
              backgroundColor: backgroundColors,
              borderColor: '#fff',
              borderWidth: 0,
              hoverOffset: 0,
              hoverBorderWidth: 0,
              hoverBorderColor: 'transparent'
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  label: (context) => {
                    const value = context.raw as number;
                    const total = data.reduce((sum, val) => sum + val, 0);
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                    return `${context.label}: ${value} (${percentage}%)`;
                  }
                }
              }
            }
          }
        });
      } catch (error) {
        this.showQuestionPaperDifficultyChart = false;
      }
    }

    this.cdr.detectChanges();
  }

  // Difficulty Filter Methods
  // Fixed Toggle Filter Panel Method
  toggleQuestionPaperDifficultyFilterPanel(): void {
    this.showQuestionPaperDifficultyFilterPanel = !this.showQuestionPaperDifficultyFilterPanel;

    if (this.showQuestionPaperDifficultyFilterPanel) {
      this.showQuestionPaperDifficultyChartMenu = false; // Close menu when opening filter
      // Reset and initialize filter data
      if (!this.filteredQuestionPaperDifficultyList || this.filteredQuestionPaperDifficultyList.length === 0) {
        this.filteredQuestionPaperDifficultyList = this.courseList && this.courseList.length > 0 ? [...this.courseList] : [];
      }
      this.activeQuestionPaperDifficultyFilterHeader = 'courses';
      this.questionPaperDifficultySearchTerm = ''; // Reset search term

      // Force change detection
      this.cdr.detectChanges();
    }
  }
  setActiveQuestionPaperDifficultyFilterHeader(headerKey: string): void {
    this.activeQuestionPaperDifficultyFilterHeader = headerKey;
  }

  isCourseSelectedForQuestionPaperDifficulty(courseId: number): boolean {
    return this.selectedQuestionPaperDifficultyCourseIds.includes(courseId);
  }

  toggleCourseSelectionForQuestionPaperDifficulty(courseId: number): void {
    const index = this.selectedQuestionPaperDifficultyCourseIds.indexOf(courseId);
    if (index > -1) {
      this.selectedQuestionPaperDifficultyCourseIds.splice(index, 1);
    } else {
      this.selectedQuestionPaperDifficultyCourseIds.push(courseId);
    }
    this.updateQuestionPaperDifficultyFilteredData();
  }

  isDifficultyLevelSelected(level: string): boolean {
    return this.selectedQuestionPaperDifficultyLevels.includes(level);
  }

  toggleDifficultyLevelSelection(level: string): void {
    const index = this.selectedQuestionPaperDifficultyLevels.indexOf(level);
    if (index > -1) {
      this.selectedQuestionPaperDifficultyLevels.splice(index, 1);
    } else {
      this.selectedQuestionPaperDifficultyLevels.push(level);
    }
    this.updateQuestionPaperDifficultyFilteredData();
  }

  updateQuestionPaperDifficultyFilteredData(): void {
    let filteredCourses = this.questionCounts;

    if (this.selectedQuestionPaperDifficultyCourseIds.length > 0) {
      filteredCourses = this.questionCounts.filter(course =>
        this.selectedQuestionPaperDifficultyCourseIds.includes(course.course_id)
      );
    }

    this.prepareQuestionPaperDifficultyData(filteredCourses);
    this.cdr.detectChanges();
  }

  filterQuestionPaperDifficultyCourses(): void {
    if (!this.questionPaperDifficultySearchTerm.trim()) {
      this.filteredQuestionPaperDifficultyList = [...this.courseList];
      return;
    }

    const searchTerm = this.questionPaperDifficultySearchTerm.toLowerCase().trim();
    this.filteredQuestionPaperDifficultyList = this.courseList.filter(course =>
      course.course_name.toLowerCase().includes(searchTerm)
    );
  }

  // All courses selection helpers for Question Paper Difficulty
  areAllCoursesSelectedForQuestionPaperDifficulty(): boolean {
    if (this.courseList.length === 0) return false;
    return this.selectedQuestionPaperDifficultyCourseIds.length === this.courseList.length;
  }

  toggleAllCoursesSelectionForQuestionPaperDifficulty(): void {
    if (this.areAllCoursesSelectedForQuestionPaperDifficulty()) {
      this.selectedQuestionPaperDifficultyCourseIds = [];
    } else {
      this.selectedQuestionPaperDifficultyCourseIds = this.courseList.map(c => c.course_id);
    }
    this.updateQuestionPaperDifficultyFilteredData();
  }

  isCoursesSelectionIndeterminateForQuestionPaperDifficulty(): boolean {
    return this.selectedQuestionPaperDifficultyCourseIds.length > 0 &&
      this.selectedQuestionPaperDifficultyCourseIds.length < this.courseList.length;
  }

  // All difficulties selection helpers for Question Paper Difficulty
  areAllDifficultiesSelectedForQuestionPaper(): boolean {
    return this.selectedQuestionPaperDifficultyLevels.length === this.availableQuestionPaperDifficultyLevels.length;
  }

  toggleAllDifficultiesSelectionForQuestionPaper(): void {
    if (this.areAllDifficultiesSelectedForQuestionPaper()) {
      this.selectedQuestionPaperDifficultyLevels = [];
    } else {
      this.selectedQuestionPaperDifficultyLevels = this.availableQuestionPaperDifficultyLevels.map(d => d.value);
    }
    this.updateQuestionPaperDifficultyFilteredData();
  }

  isDifficultiesSelectionIndeterminateForQuestionPaper(): boolean {
    return this.selectedQuestionPaperDifficultyLevels.length > 0 &&
      this.selectedQuestionPaperDifficultyLevels.length < this.availableQuestionPaperDifficultyLevels.length;
  }

  // Question Paper Difficulty Count Helpers
  getQuestionPaperCourseCount(courseId: number): number {
    const course = this.questionCounts.find(c => c.course_id === courseId);
    return course ? (course.question_paper_count || 0) : 0;
  }

  getQuestionPaperDifficultyCount(difficulty: string): number {
    let count = 0;
    this.questionCounts.forEach(course => {
      if (course.paper_difficulty_breakdown && course.paper_difficulty_breakdown[difficulty]) {
        count += course.paper_difficulty_breakdown[difficulty];
      }
    });
    return count;
  }

  getQuestionPaperDifficultyFilterHeaderCount(headerKey: string): number {
    switch (headerKey) {
      case 'courses':
        return this.selectedQuestionPaperDifficultyCourseIds.length;
      case 'difficulty':
        return this.selectedQuestionPaperDifficultyLevels.length;
      default:
        return 0;
    }
  }

  getQuestionPaperDifficultyPercentage(item: any): string {
    if (!item || !this.questionPaperDifficultyChartData || this.questionPaperDifficultyChartData.length === 0) {
      return '0';
    }

    const total = this.questionPaperDifficultyChartData.reduce((sum, dataItem) => {
      return sum + (dataItem?.value || 0);
    }, 0);

    return total > 0 ? (((item.value || 0) / total) * 100).toFixed(1) : '0';
  }

  // Difficulty Year/Month Methods
  toggleQuestionPaperDifficultyYearDropdown(): void {
    this.showQuestionPaperDifficultyYearDropdown = !this.showQuestionPaperDifficultyYearDropdown;
    if (this.showQuestionPaperDifficultyYearDropdown) {
      this.showQuestionPaperDifficultyMonthDropdown = false;
    }
  }

  selectQuestionPaperDifficultyYearRange(yearRange: string): void {
    this.selectedQuestionPaperDifficultyYearRange = yearRange;
    this.showQuestionPaperDifficultyYearDropdown = false;
    this.applyQuestionPaperDifficultyMonthYearFilter();
  }

  toggleQuestionPaperDifficultyMonthDropdown(): void {
    this.showQuestionPaperDifficultyMonthDropdown = !this.showQuestionPaperDifficultyMonthDropdown;
    if (this.showQuestionPaperDifficultyMonthDropdown) {
      this.showQuestionPaperDifficultyYearDropdown = false;
    }
    this.cdr.detectChanges();
  }


  selectQuestionPaperDifficultyMonth(month: number): void {
    this.selectedQuestionPaperDifficultyMonth = month;
    this.showQuestionPaperDifficultyMonthDropdown = false;
    this.applyQuestionPaperDifficultyMonthYearFilter();
    this.cdr.detectChanges();
  }

  applyQuestionPaperDifficultyMonthYearFilter(): void {
    this.showQuestionPaperDifficultyYearDropdown = false;
    this.showQuestionPaperDifficultyMonthDropdown = false;
    // Fetch fresh data based on selected month/year, then apply filters
    this.fetchQuestionPaperDifficultyFilteredData();
  }

  private fetchQuestionPaperDifficultyFilteredData(): void {
    this.isLoading = true;

    let startDate: Date;
    let endDate: Date;

    if (this.selectedQuestionPaperDifficultyMonth) {
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedQuestionPaperDifficultyYearRange);
      if (yearRange) {
        const year = this.selectedQuestionPaperDifficultyMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedQuestionPaperDifficultyMonth - 1, 1);
        endDate = new Date(year, this.selectedQuestionPaperDifficultyMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedQuestionPaperDifficultyMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedQuestionPaperDifficultyMonth, 0);
      }
    } else {
      const dateRange = this.getDateRangeFromYearRange(this.selectedQuestionPaperDifficultyYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

    const resp = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          // Extract ONLY question counts - don't call processLibraryData() which updates ALL charts
          this.extractQuestionCountsFromResponse(response);
          // Update the chart with fresh data and apply filters
          this.updateQuestionPaperDifficultyFilteredData();
          this.isLoading = false;
          this.cdr.detectChanges();
        } else {
          this.questionPaperDifficultyChartData = [];
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.questionPaperDifficultyChartData = [];
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  // Difficulty Chart Menu
  toggleQuestionPaperDifficultyChartMenu(): void {
    this.showQuestionPaperDifficultyChartMenu = !this.showQuestionPaperDifficultyChartMenu;
    if (this.showQuestionPaperDifficultyChartMenu) {
      this.showQuestionPaperDifficultyFilterPanel = false; // Close filter when opening menu
    }
  }

  closeQuestionPaperDifficultyChartMenu(): void {
    this.showQuestionPaperDifficultyChartMenu = false;
  }

  // Difficulty Table Modal
  showQuestionPaperDifficultyTableModal(): void {
    this.closeQuestionPaperDifficultyChartMenu();
    this.showQuestionPaperDifficultyTableModalFlag = true;
  }

  closeQuestionPaperDifficultyTableModal(): void {
    this.showQuestionPaperDifficultyTableModalFlag = false;
  }

  // Difficulty Export Methods
  exportQuestionPaperDifficultyChartAsPDF(): void {
    this.closeQuestionPaperDifficultyChartMenu();
    if (!this.ensureHasData(this.questionPaperDifficultyChartData)) { return; }

    if (this.questionPaperDifficultyChart) {
      const canvas = this.questionPaperDifficultyChart.canvas;
      const chartImage = canvas.toDataURL('image/png');

      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();

      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Question Papers by Difficulty Level', pageWidth / 2, 25, { align: 'center' });

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      pdf.text('Source: Content Library Analytics', pageWidth / 2, 32, { align: 'center' });

      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      const imgProps = pdf.getImageProperties(chartImage);
      const chartWidth = pageWidth * 0.6;
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      const chartX = (pageWidth - chartWidth) / 2;
      const chartY = 45;

      pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

      const summaryStartY = chartY + chartHeight + 20;
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Distribution Summary', 20, summaryStartY);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      let currentY = summaryStartY + 15;
      const totalPapers = this.questionPaperDifficultyChartData.reduce((sum, item) => sum + item.value, 0);

      this.questionPaperDifficultyChartData.forEach(item => {
        const percentage = this.getQuestionPaperDifficultyPercentage(item);
        const text = `${item.name}: ${item.value} (${percentage}%)`;
        pdf.text(text, 25, currentY);
        currentY += 8;
      });

      pdf.setFont('helvetica', 'bold');
      pdf.text(`Total Question Papers: ${totalPapers}`, 25, currentY + 5);

      pdf.save('question-papers-by-difficulty.pdf');
    }
  }

  exportQuestionPaperDifficultyChartAsPNG(): void {
    this.closeQuestionPaperDifficultyChartMenu();
    if (!this.ensureHasData(this.questionPaperDifficultyChartData)) { return; }

    if (this.questionPaperDifficultyChart) {
      const canvas = this.questionPaperDifficultyChart.canvas;
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = 'question-papers-by-difficulty.png';
      link.click();
    }
  }

  exportQuestionPaperDifficultyTableAsPDF(): void {
    if (!this.ensureHasData(this.questionPaperDifficultyChartData)) { return; }
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();

    pdf.setFontSize(18);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Question Papers by Difficulty Level - Detailed Breakdown', pageWidth / 2, 25, { align: 'center' });

    const headers = ['Difficulty Level', 'Question Papers', 'Percentage'];
    const rows: any[] = [];

    this.questionPaperDifficultyChartData.forEach(item => {
      rows.push([
        item.name,
        item.value,
        this.getQuestionPaperDifficultyPercentage(item) + '%'
      ]);
    });

    const tableConfig = {
      startY: 35,
      head: [headers],
      body: rows,
      theme: 'grid' as const,
      headStyles: { fillColor: [41, 128, 185], textColor: 255 },
      alternateRowStyles: { fillColor: [240, 240, 240] }
    };

    (pdf as any).autoTable(tableConfig);
    pdf.save('question-papers-by-difficulty-table.pdf');
  }

  exportQuestionPaperDifficultyTableAsPNG(): void {
    if (!this.ensureHasData(this.questionPaperDifficultyChartData)) { return; }
    const table = document.createElement('table');
    table.style.width = '100%';
    table.style.borderCollapse = 'collapse';

    const thead = table.createTHead();
    const headerRow = thead.insertRow();
    ['Difficulty Level', 'Question Papers', 'Percentage'].forEach(header => {
      const th = document.createElement('th');
      th.textContent = header;
      th.style.border = '1px solid black';
      th.style.padding = '10px';
      th.style.backgroundColor = '#2980b9';
      th.style.color = 'white';
      headerRow.appendChild(th);
    });

    const tbody = table.createTBody();
    this.questionPaperDifficultyChartData.forEach(item => {
      const row = tbody.insertRow();
      const cells = [item.name, item.value.toString(), this.getQuestionPaperDifficultyPercentage(item) + '%'];
      cells.forEach(cell => {
        const td = row.insertCell();
        td.textContent = cell;
        td.style.border = '1px solid black';
        td.style.padding = '10px';
      });
    });

    html2canvas(table, { scale: 2 }).then(canvas => {
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = 'question-papers-by-difficulty-table.png';
      link.click();
    });
  }

  // Difficulty Compare Dialog
  openQuestionPaperDifficultyCompareDialog(): void {
    this.showQuestionPaperDifficultyCompareDialog = true;
    this.showQuestionPaperDifficultyComparisonResults = false;
  }

  closeQuestionPaperDifficultyCompareDialog(): void {
    this.showQuestionPaperDifficultyCompareDialog = false;
    this.showQuestionPaperDifficultyComparisonResults = false;
  }

  // Month-wise Compare Methods for Difficulty Level
  openQuestionPaperDifficultyMonthCompareDialog(): void {
    this.showQuestionPaperDifficultyMonthCompareDialog = true;
    this.showQuestionPaperDifficultyMonthComparisonResults = false;
    this.selectedQuestionPaperDifficultyCompareMonth1 = null;
    this.selectedQuestionPaperDifficultyCompareMonth2 = null;
  }

  closeQuestionPaperDifficultyMonthCompareDialog(): void {
    this.showQuestionPaperDifficultyMonthCompareDialog = false;
    this.showQuestionPaperDifficultyMonthComparisonResults = false;
    this.currentQuestionPaperDifficultyMonthComparisonData = [];
    this.compareQuestionPaperDifficultyMonthComparisonData = [];
  }

  toggleQuestionPaperDifficultyCompareMonth1Dropdown(): void {
    this.showQuestionPaperDifficultyCompareMonth1Dropdown = !this.showQuestionPaperDifficultyCompareMonth1Dropdown;
    if (this.showQuestionPaperDifficultyCompareMonth1Dropdown) {
      this.showQuestionPaperDifficultyCompareMonth2Dropdown = false;
    }
  }

  selectQuestionPaperDifficultyCompareMonth1(month: number): void {
    this.selectedQuestionPaperDifficultyCompareMonth1 = month;
    this.showQuestionPaperDifficultyCompareMonth1Dropdown = false;
  }

  toggleQuestionPaperDifficultyCompareMonth2Dropdown(): void {
    this.showQuestionPaperDifficultyCompareMonth2Dropdown = !this.showQuestionPaperDifficultyCompareMonth2Dropdown;
    if (this.showQuestionPaperDifficultyCompareMonth2Dropdown) {
      this.showQuestionPaperDifficultyCompareMonth1Dropdown = false;
    }
  }

  selectQuestionPaperDifficultyCompareMonth2(month: number): void {
    this.selectedQuestionPaperDifficultyCompareMonth2 = month;
    this.showQuestionPaperDifficultyCompareMonth2Dropdown = false;
  }

  loadQuestionPaperDifficultyMonthComparisonData(): void {
    if (!this.selectedQuestionPaperDifficultyCompareMonth1 || !this.selectedQuestionPaperDifficultyCompareMonth2) {
      return;
    }

    this.isLoading = true;
    this.showQuestionPaperDifficultyMonthComparisonResults = true;
    this.fetchQuestionPaperDifficultyMonthComparisonData();
  }

  private fetchQuestionPaperDifficultyMonthComparisonData(): void {
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedQuestionPaperDifficultyCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedQuestionPaperDifficultyCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    // Fetch Month 1 data
    const resp1 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    // Fetch Month 2 data
    const resp2 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Data: any[] = [];
    let month2Data: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month1Data = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processQuestionPaperDifficultyMonthComparisonData(month1Data, month2Data);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.processQuestionPaperDifficultyMonthComparisonData(month1Data, month2Data);
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month2Data = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processQuestionPaperDifficultyMonthComparisonData(month1Data, month2Data);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.processQuestionPaperDifficultyMonthComparisonData(month1Data, month2Data);
        }
      }
    );

    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    }, 2000);
  }

  private processQuestionPaperDifficultyMonthComparisonData(month1Data: any[], month2Data: any[]): void {
    const isValidQuestion = (item: any): boolean => {
      const count = item?.question_count ?? 0;
      return item && item.difficulty_level && typeof count === 'number' && count > 0;
    };

    const validMonth1Data = month1Data.filter(isValidQuestion);
    const validMonth2Data = month2Data.filter(isValidQuestion);

    this.currentQuestionPaperDifficultyMonthComparisonData = validMonth1Data
      .map((item: any) => ({
        name: item.difficulty_level || 'Unknown',
        value: item.question_count || 0,
        percentage: 0,
      }));

    const month1Total = this.currentQuestionPaperDifficultyMonthComparisonData.reduce((sum, item) => sum + item.value, 0);
    this.currentQuestionPaperDifficultyMonthComparisonData = this.currentQuestionPaperDifficultyMonthComparisonData.map(item => ({
      ...item,
      percentage: month1Total > 0 ? Math.round((item.value / month1Total) * 100) : 0,
    }));

    this.compareQuestionPaperDifficultyMonthComparisonData = validMonth2Data
      .map((item: any) => ({
        name: item.difficulty_level || 'Unknown',
        value: item.question_count || 0,
        percentage: 0,
      }));

    const month2Total = this.compareQuestionPaperDifficultyMonthComparisonData.reduce((sum, item) => sum + item.value, 0);
    this.compareQuestionPaperDifficultyMonthComparisonData = this.compareQuestionPaperDifficultyMonthComparisonData.map(item => ({
      ...item,
      percentage: month2Total > 0 ? Math.round((item.value / month2Total) * 100) : 0,
    }));

    this.initializeQuestionPaperDifficultyMonthComparisonChart();
  }

  private initializeQuestionPaperDifficultyMonthComparisonChart(): void {
    const canvas = document.getElementById('questionPaperDifficultyMonthComparisonChart') as HTMLCanvasElement;

    if (!canvas) {
      return;
    }

    if (!this.currentQuestionPaperDifficultyMonthComparisonData || this.currentQuestionPaperDifficultyMonthComparisonData.length === 0) {
      return;
    }

    const difficultyNames = [...new Set([
      ...this.currentQuestionPaperDifficultyMonthComparisonData.map(s => s.name),
      ...this.compareQuestionPaperDifficultyMonthComparisonData.map(s => s.name)
    ])];

    const month1Values = difficultyNames.map(name => {
      const item = this.currentQuestionPaperDifficultyMonthComparisonData.find(s => s.name === name);
      return item?.value || 0;
    });

    const month2Values = difficultyNames.map(name => {
      const item = this.compareQuestionPaperDifficultyMonthComparisonData.find(s => s.name === name);
      return item?.value || 0;
    });

    if (this.questionPaperDifficultyMonthComparisonChart) {
      this.questionPaperDifficultyMonthComparisonChart.destroy();
      this.questionPaperDifficultyMonthComparisonChart = null;
    }

    const chartHeight = Math.max(difficultyNames.length * 40, 300);
    const container = canvas.parentElement as HTMLElement;
    if (container) {
      container.style.minHeight = chartHeight + 'px';
    }

    try {
      this.questionPaperDifficultyMonthComparisonChart = new Chart(canvas, {
        type: 'bar',
        data: {
          labels: difficultyNames,
          datasets: [
            {
              label: `Month ${this.selectedQuestionPaperDifficultyCompareMonth1}`,
              data: month1Values,
              backgroundColor: '#4CAF50',
              borderColor: '#45a049',
              borderWidth: 1,
              barThickness: 'flex',
              barPercentage: 0.7,
            },
            {
              label: `Month ${this.selectedQuestionPaperDifficultyCompareMonth2}`,
              data: month2Values,
              backgroundColor: '#2196F3',
              borderColor: '#0b7dda',
              borderWidth: 1,
              barThickness: 'flex',
              barPercentage: 0.7,
            }
          ]
        },
        options: {
          indexAxis: 'y',
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'top',
            }
          },
          scales: {
            x: {
              beginAtZero: true,
              stacked: false,
              grid: {
                display: true
              }
            },
            y: {
              stacked: false,
              grid: {
                display: false
              }
            }
          }
        }
      });
    } catch (error) {
      // Error
    }
  }

  toggleQuestionPaperDifficultyCompareYearDropdown(): void {
    this.showQuestionPaperDifficultyCompareYearDropdown = !this.showQuestionPaperDifficultyCompareYearDropdown;
  }

  selectQuestionPaperDifficultyCompareYearRange(yearRange: string): void {
    this.selectedQuestionPaperDifficultyCompareYearRange = yearRange;
    this.showQuestionPaperDifficultyCompareYearDropdown = false;
  }

  toggleQuestionPaperDifficultyCompareMonthDropdown(): void {
    this.showQuestionPaperDifficultyCompareMonthDropdown = !this.showQuestionPaperDifficultyCompareMonthDropdown;
  }

  selectQuestionPaperDifficultyCompareMonth(month: number | null): void {
    this.selectedQuestionPaperDifficultyCompareMonth = month;
    this.showQuestionPaperDifficultyCompareMonthDropdown = false;
  }

  loadQuestionPaperDifficultyComparisonData(): void {
    if (!this.selectedQuestionPaperDifficultyCompareYearRange) return;

    this.isLoading = true;
    this.showQuestionPaperDifficultyComparisonResults = true;

    this.prepareCurrentQuestionPaperDifficultyComparisonData();
    // Note: In a real scenario, you'd fetch comparison data
    this.currentQuestionPaperDifficultyComparisonData = [...this.questionPaperDifficultyChartData];
    this.compareQuestionPaperDifficultyComparisonData = [...this.questionPaperDifficultyChartData];

    this.isLoading = false;
    this.cdr.detectChanges();
  }

  private prepareCurrentQuestionPaperDifficultyComparisonData(): void {
    this.currentQuestionPaperDifficultyComparisonData = this.questionPaperDifficultyChartData
      .filter(item => item.value > 0)
      .map(item => ({
        name: item.name,
        value: item.value,
        percentage: this.getQuestionPaperDifficultyPercentage(item),
        trend: 'neutral'
      }));
  }

  getCurrentQuestionPaperDifficultyTotalPapers(): number {
    return this.currentQuestionPaperDifficultyComparisonData.reduce((sum, item) => sum + item.value, 0);
  }

  getCompareQuestionPaperDifficultyTotalPapers(): number {
    return this.compareQuestionPaperDifficultyComparisonData.reduce((sum, item) => sum + item.value, 0);
  }
  private initializeQuestionPaperCategoryData(): void {
    this.selectedQuestionPaperCategoryYearRange = this.selectedYearRange;
    this.selectedQuestionPaperCategoryMonth = new Date().getMonth() + 1;
  }

  // Prepare Question Paper Category Data
  private prepareQuestionPaperCategoryData(courses: any[]): void {

    if (!courses || courses.length === 0) {
      this.questionPaperCategoryChartData = [];
      this.showQuestionPaperCategoryChart = false;
      this.cdr.detectChanges();
      return;
    }

    const categoryBreakdown: { [key: string]: number } = {};

    // Initialize all categories with 0
    QUESTION_CATEGORIES.forEach(cat => {
      categoryBreakdown[cat.value] = 0;
    });

    // Aggregate category breakdown across all courses
    courses.forEach(course => {
      // Check for paper_category_breakdown first (primary field)
      if (course.paper_category_breakdown && typeof course.paper_category_breakdown === 'object') {
        Object.keys(course.paper_category_breakdown).forEach(key => {
          categoryBreakdown[key] = (categoryBreakdown[key] || 0) + (course.paper_category_breakdown[key] || 0);
        });
      } 
      // Check for question_category_breakdown as alternative
      else if (course.question_category_breakdown && typeof course.question_category_breakdown === 'object') {
        Object.keys(course.question_category_breakdown).forEach(key => {
          categoryBreakdown[key] = (categoryBreakdown[key] || 0) + (course.question_category_breakdown[key] || 0);
        });
      } 
      // Fallback: Generate data based on question_paper_count if breakdown not available
      else if (course.question_paper_count && course.question_paper_count > 0) {
        const categories = QUESTION_CATEGORIES;
        categories.forEach((cat, index) => {
          if (index === 0) categoryBreakdown[cat.value] += Math.floor(course.question_paper_count * 0.4);
          else if (index === 1) categoryBreakdown[cat.value] += Math.floor(course.question_paper_count * 0.35);
          else categoryBreakdown[cat.value] += Math.ceil(course.question_paper_count * 0.25);
        });
      }
    });

    const categoryColors = [
      '#005068', // Dark Blue (Easy)
      '#A0A0FF', // Light Purple/Blue (Medium)
      '#C71E1D', // Red (Hard)
      '#3498DB', // Sky Blue
      '#E74C3C', // Light Red
      '#2ECC71', // Green
      '#F39C12', // Orange
      '#9B59B6', // Purple
      '#1ABC9C', // Teal
      '#E67E22'  // Dark Orange
    ];

    this.questionPaperCategoryChartData = QUESTION_CATEGORIES
      .map((cat, index) => ({
        name: cat.label,
        value: categoryBreakdown[cat.value] || 0,
        color: categoryColors[index % categoryColors.length],
        code: cat.value
      }))
      .filter(item => item.value > 0);

    this.showQuestionPaperCategoryChart = this.questionPaperCategoryChartData.length > 0;

    this.cdr.detectChanges();

    if (this.showQuestionPaperCategoryChart) {
      setTimeout(() => {
        this.initializeQuestionPaperCategoryChart();
      }, 150);
    }
  }

  // Initialize Question Paper Category Chart (Pie)
  private initializeQuestionPaperCategoryChart(): void {

    const canvas = document.getElementById('questionPaperCategoryChart') as HTMLCanvasElement;

    if (!canvas) {
      return;
    }

    if (this.questionPaperCategoryChart) {
      this.questionPaperCategoryChart.destroy();
    }

    const nonZeroData = this.questionPaperCategoryChartData.filter(item => item.value > 0);

    if (nonZeroData.length === 0) {
      this.showQuestionPaperCategoryChart = false;
      return;
    }

    const ctx = canvas.getContext('2d');

    if (ctx) {
      try {
        const labels = nonZeroData.map(item => item.name);
        const data = nonZeroData.map(item => item.value);
        const backgroundColors = nonZeroData.map(item => item.color);

        this.questionPaperCategoryChart = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: labels,
            datasets: [{
              data: data,
              backgroundColor: backgroundColors,
              borderColor: '#fff',
              borderWidth: 0,
              hoverOffset: 0,
              hoverBorderWidth: 0,
              hoverBorderColor: 'transparent'
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  label: (context) => {
                    const value = context.raw as number;
                    const total = data.reduce((sum, val) => sum + val, 0);
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                    return `${context.label}: ${value} (${percentage}%)`;
                  }
                }
              }
            },
            cutout: '60%',
            animation: {
              animateScale: true,
              animateRotate: true
            },
            layout: {
              padding: {
                top: 10,
                right: 10,
                bottom: 20,
                left: 10
              }
            }
          }
        });

      } catch (error) {
        this.showQuestionPaperCategoryChart = false;
      }
    }

    this.cdr.detectChanges();
  }

  // Category Filter Methods
  toggleQuestionPaperCategoryFilterPanel(): void {
    this.showQuestionPaperCategoryFilterPanel = !this.showQuestionPaperCategoryFilterPanel;

    if (this.showQuestionPaperCategoryFilterPanel) {
      this.showQuestionPaperCategoryChartMenu = false; // Close menu when opening filter
      if (!this.filteredQuestionPaperCategoryList || this.filteredQuestionPaperCategoryList.length === 0) {
        this.filteredQuestionPaperCategoryList = this.courseList && this.courseList.length > 0 ? [...this.courseList] : [];
      }
      this.activeQuestionPaperCategoryFilterHeader = 'courses';
      this.questionPaperCategorySearchTerm = '';
      this.cdr.detectChanges();
    }
  }

  setActiveQuestionPaperCategoryFilterHeader(headerKey: string): void {
    this.activeQuestionPaperCategoryFilterHeader = headerKey;
  }

  isCourseSelectedForQuestionPaperCategory(courseId: number): boolean {
    return this.selectedQuestionPaperCategoryCourseIds.includes(courseId);
  }

  toggleCourseSelectionForQuestionPaperCategory(courseId: number): void {
    const index = this.selectedQuestionPaperCategoryCourseIds.indexOf(courseId);
    if (index > -1) {
      this.selectedQuestionPaperCategoryCourseIds.splice(index, 1);
    } else {
      this.selectedQuestionPaperCategoryCourseIds.push(courseId);
    }
    this.updateQuestionPaperCategoryFilteredData();
  }

  isCategorySelectedForQuestionPaper(category: string): boolean {
    return this.selectedQuestionPaperCategories.includes(category);
  }

  toggleCategorySelectionForQuestionPaper(category: string): void {
    const index = this.selectedQuestionPaperCategories.indexOf(category);
    if (index > -1) {
      this.selectedQuestionPaperCategories.splice(index, 1);
    } else {
      this.selectedQuestionPaperCategories.push(category);
    }
    this.updateQuestionPaperCategoryFilteredData();
  }

  updateQuestionPaperCategoryFilteredData(): void {
    let filteredCourses = this.questionCounts;

    if (this.selectedQuestionPaperCategoryCourseIds.length > 0) {
      filteredCourses = this.questionCounts.filter(course =>
        this.selectedQuestionPaperCategoryCourseIds.includes(course.course_id)
      );
    }

    this.prepareQuestionPaperCategoryData(filteredCourses);
    this.cdr.detectChanges();
  }

  filterQuestionPaperCategoryCourses(): void {
    if (!this.questionPaperCategorySearchTerm.trim()) {
      this.filteredQuestionPaperCategoryList = [...this.courseList];
      return;
    }

    const searchTerm = this.questionPaperCategorySearchTerm.toLowerCase().trim();
    this.filteredQuestionPaperCategoryList = this.courseList.filter(course =>
      course.course_name.toLowerCase().includes(searchTerm)
    );
  }

  // All courses selection helpers for Question Paper Category
  areAllCoursesSelectedForQuestionPaperCategory(): boolean {
    if (this.courseList.length === 0) return false;
    return this.selectedQuestionPaperCategoryCourseIds.length === this.courseList.length;
  }

  toggleAllCoursesSelectionForQuestionPaperCategory(): void {
    if (this.areAllCoursesSelectedForQuestionPaperCategory()) {
      this.selectedQuestionPaperCategoryCourseIds = [];
    } else {
      this.selectedQuestionPaperCategoryCourseIds = this.courseList.map(c => c.course_id);
    }
    this.updateQuestionPaperCategoryFilteredData();
  }

  isCoursesSelectionIndeterminateForQuestionPaperCategory(): boolean {
    return this.selectedQuestionPaperCategoryCourseIds.length > 0 &&
      this.selectedQuestionPaperCategoryCourseIds.length < this.courseList.length;
  }

  // All categories selection helpers for Question Paper Category
  areAllCategoriesSelectedForQuestionPaper(): boolean {
    return this.selectedQuestionPaperCategories.length === this.availableQuestionPaperCategories.length;
  }

  toggleAllCategoriesSelectionForQuestionPaper(): void {
    if (this.areAllCategoriesSelectedForQuestionPaper()) {
      this.selectedQuestionPaperCategories = [];
    } else {
      this.selectedQuestionPaperCategories = this.availableQuestionPaperCategories.map(c => c.value);
    }
    this.updateQuestionPaperCategoryFilteredData();
  }

  isCategoriesSelectionIndeterminateForQuestionPaper(): boolean {
    return this.selectedQuestionPaperCategories.length > 0 &&
      this.selectedQuestionPaperCategories.length < this.availableQuestionPaperCategories.length;
  }

  // Question Paper Category Count Helpers
  getQuestionPaperCourseCountForCategory(courseId: number): number {
    const course = this.questionCounts.find(c => c.course_id === courseId);
    return course ? (course.question_paper_count || 0) : 0;
  }

  getQuestionPaperCategoryCount(category: string): number {
    let count = 0;
    this.questionCounts.forEach(course => {
      if (course.paper_category_breakdown && course.paper_category_breakdown[category]) {
        count += course.paper_category_breakdown[category];
      }
    });
    return count;
  }

  getQuestionPaperCategoryFilterHeaderCount(headerKey: string): number {
    switch (headerKey) {
      case 'courses':
        return this.selectedQuestionPaperCategoryCourseIds.length;
      case 'categories':
        return this.selectedQuestionPaperCategories.length;
      default:
        return 0;
    }
  }

  getQuestionPaperCategoryPercentage(item: any): string {
    if (!item || !this.questionPaperCategoryChartData || this.questionPaperCategoryChartData.length === 0) {
      return '0';
    }

    const total = this.questionPaperCategoryChartData.reduce((sum, dataItem) => {
      return sum + (dataItem?.value || 0);
    }, 0);

    return total > 0 ? (((item.value || 0) / total) * 100).toFixed(1) : '0';
  }

  // Category Year/Month Methods
  toggleQuestionPaperCategoryYearDropdown(): void {
    this.showQuestionPaperCategoryYearDropdown = !this.showQuestionPaperCategoryYearDropdown;
    if (this.showQuestionPaperCategoryYearDropdown) {
      this.showQuestionPaperCategoryMonthDropdown = false;
    }
  }

  selectQuestionPaperCategoryYearRange(yearRange: string): void {
    this.selectedQuestionPaperCategoryYearRange = yearRange;
    this.showQuestionPaperCategoryYearDropdown = false;
    this.applyQuestionPaperCategoryMonthYearFilter();
  }

  toggleQuestionPaperCategoryMonthDropdown(): void {
    this.showQuestionPaperCategoryMonthDropdown = !this.showQuestionPaperCategoryMonthDropdown;
    if (this.showQuestionPaperCategoryMonthDropdown) {
      this.showQuestionPaperCategoryYearDropdown = false;
    }
  }

  selectQuestionPaperCategoryMonth(month: number): void {
    this.selectedQuestionPaperCategoryMonth = month;
    this.showQuestionPaperCategoryMonthDropdown = false;
    
    // Ensure year range is also set before applying filter
    if (!this.selectedQuestionPaperCategoryYearRange || this.selectedQuestionPaperCategoryYearRange === '') {
      this.selectedQuestionPaperCategoryYearRange = this.selectedYearRange;
    }
    
    this.applyQuestionPaperCategoryMonthYearFilter();
  }

  applyQuestionPaperCategoryMonthYearFilter(): void {
    this.showQuestionPaperCategoryYearDropdown = false;
    this.showQuestionPaperCategoryMonthDropdown = false;

    // Fetch data with category-specific filters
    this.fetchQuestionPaperCategoryFilteredData();
  }

  private fetchQuestionPaperCategoryFilteredData(): void {
    this.isLoading = true;

    // Ensure year range is initialized
    if (!this.selectedQuestionPaperCategoryYearRange || this.selectedQuestionPaperCategoryYearRange === '') {
      this.selectedQuestionPaperCategoryYearRange = this.selectedYearRange || this.availableYearRanges[0]?.value || '';
    }

    let startDate: Date;
    let endDate: Date;

    if (this.selectedQuestionPaperCategoryMonth) {
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedQuestionPaperCategoryYearRange);
      if (yearRange) {
        const year = this.selectedQuestionPaperCategoryMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedQuestionPaperCategoryMonth - 1, 1);
        endDate = new Date(year, this.selectedQuestionPaperCategoryMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedQuestionPaperCategoryMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedQuestionPaperCategoryMonth, 0);
      }
    } else {
      const dateRange = this.getDateRangeFromYearRange(this.selectedQuestionPaperCategoryYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

    const resp = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts && response.question_counts.length > 0) {
          // Extract ONLY question counts - don't call processLibraryData() which updates ALL charts
          this.extractQuestionCountsFromResponse(response);
          
          // Validate selected course IDs - remove any that don't exist in new data
          const availableCourseIds = this.questionCounts.map(c => c.course_id);
          this.selectedQuestionPaperCategoryCourseIds = this.selectedQuestionPaperCategoryCourseIds.filter(id =>
            availableCourseIds.includes(id)
          );
          
          // Apply course filters if any selected, then prepare category data
          this.updateQuestionPaperCategoryFilteredData();
          this.isLoading = false;
          this.cdr.detectChanges();
        } else {
          this.questionPaperCategoryChartData = [];
          this.showQuestionPaperCategoryChart = false;
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.questionPaperCategoryChartData = [];
        this.showQuestionPaperCategoryChart = false;
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  // Category Chart Menu
  toggleQuestionPaperCategoryChartMenu(): void {
    this.showQuestionPaperCategoryChartMenu = !this.showQuestionPaperCategoryChartMenu;
    if (this.showQuestionPaperCategoryChartMenu) {
      this.showQuestionPaperCategoryFilterPanel = false; // Close filter when opening menu
    }
  }

  closeQuestionPaperCategoryChartMenu(): void {
    this.showQuestionPaperCategoryChartMenu = false;
  }

  // Category Table Modal
  showQuestionPaperCategoryTableModal(): void {
    this.closeQuestionPaperCategoryChartMenu();
    this.showQuestionPaperCategoryTableModalFlag = true;
  }

  closeQuestionPaperCategoryTableModal(): void {
    this.showQuestionPaperCategoryTableModalFlag = false;
  }

  // Category Export Methods
  exportQuestionPaperCategoryChartAsPDF(): void {
    this.closeQuestionPaperCategoryChartMenu();
    if (!this.ensureHasData(this.questionPaperCategoryChartData)) { return; }

    if (this.questionPaperCategoryChart) {
      const canvas = this.questionPaperCategoryChart.canvas;
      const chartImage = canvas.toDataURL('image/png');

      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();

      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Question Papers by Category', pageWidth / 2, 25, { align: 'center' });

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      pdf.text('Source: Content Library Analytics', pageWidth / 2, 32, { align: 'center' });

      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      const imgProps = pdf.getImageProperties(chartImage);
      const chartWidth = pageWidth * 0.6;
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      const chartX = (pageWidth - chartWidth) / 2;
      const chartY = 45;

      pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

      const summaryStartY = chartY + chartHeight + 20;
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Distribution Summary', 20, summaryStartY);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      let currentY = summaryStartY + 15;
      const totalPapers = this.questionPaperCategoryChartData.reduce((sum, item) => sum + item.value, 0);

      this.questionPaperCategoryChartData.forEach(item => {
        const percentage = this.getQuestionPaperCategoryPercentage(item);
        const text = `${item.name}: ${item.value} (${percentage}%)`;
        pdf.text(text, 25, currentY);
        currentY += 8;
      });

      pdf.setFont('helvetica', 'bold');
      pdf.text(`Total Question Papers: ${totalPapers}`, 25, currentY + 5);

      pdf.save('question-papers-by-category.pdf');
    }
  }

  exportQuestionPaperCategoryChartAsPNG(): void {
    this.closeQuestionPaperCategoryChartMenu();
    if (!this.ensureHasData(this.questionPaperCategoryChartData)) { return; }

    if (this.questionPaperCategoryChart) {
      const canvas = this.questionPaperCategoryChart.canvas;
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = 'question-papers-by-category.png';
      link.click();
    }
  }

  exportQuestionPaperCategoryTableAsPDF(): void {
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();

    pdf.setFontSize(18);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Question Papers by Category - Detailed Breakdown', pageWidth / 2, 25, { align: 'center' });

    const headers = ['Category', 'Question Papers', 'Percentage'];
    const rows: any[] = [];

    this.questionPaperCategoryChartData.forEach(item => {
      rows.push([
        item.name,
        item.value,
        this.getQuestionPaperCategoryPercentage(item) + '%'
      ]);
    });

    const tableConfig = {
      startY: 35,
      head: [headers],
      body: rows,
      theme: 'grid' as const,
      headStyles: { fillColor: [41, 128, 185], textColor: 255 },
      alternateRowStyles: { fillColor: [240, 240, 240] }
    };

    (pdf as any).autoTable(tableConfig);
    pdf.save('question-papers-by-category-table.pdf');
  }

  exportQuestionPaperCategoryTableAsPNG(): void {
    const table = document.createElement('table');
    table.style.width = '100%';
    table.style.borderCollapse = 'collapse';

    const thead = table.createTHead();
    const headerRow = thead.insertRow();
    ['Category', 'Question Papers', 'Percentage'].forEach(header => {
      const th = document.createElement('th');
      th.textContent = header;
      th.style.border = '1px solid black';
      th.style.padding = '10px';
      th.style.backgroundColor = '#2980b9';
      th.style.color = 'white';
      headerRow.appendChild(th);
    });

    const tbody = table.createTBody();
    this.questionPaperCategoryChartData.forEach(item => {
      const row = tbody.insertRow();
      const cells = [item.name, item.value.toString(), this.getQuestionPaperCategoryPercentage(item) + '%'];
      cells.forEach(cell => {
        const td = row.insertCell();
        td.textContent = cell;
        td.style.border = '1px solid black';
        td.style.padding = '10px';
      });
    });

    html2canvas(table, { scale: 2 }).then(canvas => {
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = 'question-papers-by-category-table.png';
      link.click();
    });
  }

  // Category Compare Dialog
  openQuestionPaperCategoryCompareDialog(): void {
    this.showQuestionPaperCategoryCompareDialog = true;
    this.showQuestionPaperCategoryComparisonResults = false;
  }

  closeQuestionPaperCategoryCompareDialog(): void {
    this.showQuestionPaperCategoryCompareDialog = false;
    this.showQuestionPaperCategoryComparisonResults = false;
  }

  toggleQuestionPaperCategoryCompareYearDropdown(): void {
    this.showQuestionPaperCategoryCompareYearDropdown = !this.showQuestionPaperCategoryCompareYearDropdown;
  }

  selectQuestionPaperCategoryCompareYearRange(yearRange: string): void {
    this.selectedQuestionPaperCategoryCompareYearRange = yearRange;
    this.showQuestionPaperCategoryCompareYearDropdown = false;
  }

  toggleQuestionPaperCategoryCompareMonthDropdown(): void {
    this.showQuestionPaperCategoryCompareMonthDropdown = !this.showQuestionPaperCategoryCompareMonthDropdown;
  }

  selectQuestionPaperCategoryCompareMonth(month: number | null): void {
    this.selectedQuestionPaperCategoryCompareMonth = month;
    this.showQuestionPaperCategoryCompareMonthDropdown = false;
  }

  loadQuestionPaperCategoryComparisonData(): void {
    if (!this.selectedQuestionPaperCategoryCompareYearRange) return;

    this.isLoading = true;
    this.showQuestionPaperCategoryComparisonResults = true;

    this.prepareCurrentQuestionPaperCategoryComparisonData();
    // Note: In a real scenario, you'd fetch comparison data
    this.currentQuestionPaperCategoryComparisonData = [...this.questionPaperCategoryChartData];
    this.compareQuestionPaperCategoryComparisonData = [...this.questionPaperCategoryChartData];

    this.isLoading = false;
    this.cdr.detectChanges();
  }

  private prepareCurrentQuestionPaperCategoryComparisonData(): void {
    this.currentQuestionPaperCategoryComparisonData = this.questionPaperCategoryChartData
      .filter(item => item.value > 0)
      .map(item => ({
        name: item.name,
        value: item.value,
        percentage: this.getQuestionPaperCategoryPercentage(item),
        trend: 'neutral'
      }));
  }

  getCurrentQuestionPaperCategoryTotalPapers(): number {
    return this.currentQuestionPaperCategoryComparisonData.reduce((sum, item) => sum + item.value, 0);
  }

  getCompareQuestionPaperCategoryTotalPapers(): number {
    return this.compareQuestionPaperCategoryComparisonData.reduce((sum, item) => sum + item.value, 0);
  }

  toggleCourseFilterPanel(): void {
    this.showCourseFilterPanel = !this.showCourseFilterPanel;
    if (this.showCourseFilterPanel) {
      this.showCourseChartMenu = false; // Close menu when opening filter
      this.filteredCourseFilterList = [...this.courseList];
      this.activeCourseFilterHeader = 'courses';
      this.cdr.detectChanges();
    }
  }
  setActiveCourseFilterHeader(headerKey: string): void {
    this.activeCourseFilterHeader = headerKey;
  }

  clearCourseFilters(): void {
    this.selectedCourseFilterCourseIds = [];
    this.selectedCourseFilterDifficultyLevels = [];
    this.selectedCourseFilterTypes = [];
    this.selectedCourseFilterEvaluationModes = [];
    this.selectedCourseFilterLanguages = [];
    this.courseSearchTerm = '';
    this.courseDifficultySearchTerm = '';
    this.courseTypeSearchTerm = '';
    this.courseEvaluationModeSearchTerm = '';
    this.courseLanguageSearchTerm = '';
    this.filteredCourseFilterList = [...this.courseList];
    this.filteredCourseDifficultyList = [...DIFFICULTY_LEVELS];
    this.filteredCourseTypeList = [...QUESTION_TYPES];
    this.filteredCourseEvaluationModeList = [...this.availableCourseEvaluationModes];
    this.filteredCourseLanguageList = [...this.availableCourseLanguages];

    // Ensure language list is shown when language filter is active
    if (this.activeCourseFilterHeader === 'language') {
      this.filteredCourseLanguageList = [...this.availableCourseLanguages];
    }
    this.updateCourseFilteredData();
  }

  // Course selection methods for course chart
  isCourseSelectedForCourseFilter(courseId: number): boolean {
    return this.selectedCourseFilterCourseIds.includes(courseId);
  }
  toggleCourseSelectionForCourseFilter(courseId: number): void {
    const index = this.selectedCourseFilterCourseIds.indexOf(courseId);
    if (index > -1) {
      this.selectedCourseFilterCourseIds.splice(index, 1);
    } else {
      this.selectedCourseFilterCourseIds.push(courseId);
    }
    this.updateCourseFilteredData();
  }
  updateCourseFilteredData(): void {
    let filteredCourses = this.questionCounts;

    // Apply course filter
    if (this.selectedCourseFilterCourseIds.length > 0) {
      filteredCourses = this.questionCounts.filter(course =>
        this.selectedCourseFilterCourseIds.includes(course.course_id)
      );
    }

    // Apply difficulty level filter
    if (this.selectedCourseFilterDifficultyLevels.length > 0) {
      filteredCourses = this.filterCoursesByCourseDifficultyLevels(filteredCourses);
    }

    // Apply type filter
    if (this.selectedCourseFilterTypes.length > 0) {
      filteredCourses = this.filterCoursesByCourseTypes(filteredCourses);
    }

    // Apply evaluation mode filter
    if (this.selectedCourseFilterEvaluationModes.length > 0) {
      filteredCourses = this.filterCoursesByCourseEvaluationModes(filteredCourses);
    }

    // Apply language filter
    if (this.selectedCourseFilterLanguages.length > 0) {
      filteredCourses = this.filterCoursesByCourseLanguages(filteredCourses);
    }

    this.prepareCourseData(filteredCourses);
    this.cdr.detectChanges();
  }
  // Filter search methods for course chart
  filterCourseFilterCourses(): void {
    if (!this.courseSearchTerm.trim()) {
      this.filteredCourseFilterList = [...this.courseList];
      return;
    }

    const searchTerm = this.courseSearchTerm.toLowerCase().trim();
    this.filteredCourseFilterList = this.courseList.filter(course =>
      course.course_name.toLowerCase().includes(searchTerm)
    );
  }

  filterCourseDifficultyLevels(): void {
    if (!this.courseDifficultySearchTerm.trim()) {
      this.filteredCourseDifficultyList = [...DIFFICULTY_LEVELS];
      return;
    }

    const searchTerm = this.courseDifficultySearchTerm.toLowerCase().trim();
    this.filteredCourseDifficultyList = DIFFICULTY_LEVELS.filter(level =>
      level.label.toLowerCase().includes(searchTerm)
    );
  }

  filterCourseTypes(): void {
    if (!this.courseTypeSearchTerm.trim()) {
      this.filteredCourseTypeList = [...QUESTION_TYPES];
      return;
    }

    const searchTerm = this.courseTypeSearchTerm.toLowerCase().trim();
    this.filteredCourseTypeList = QUESTION_TYPES.filter(type =>
      type.label.toLowerCase().includes(searchTerm)
    );
  }

  filterCourseEvaluationModes(): void {
    if (!this.courseEvaluationModeSearchTerm.trim()) {
      this.filteredCourseEvaluationModeList = [...this.availableCourseEvaluationModes];
      return;
    }

    const searchTerm = this.courseEvaluationModeSearchTerm.toLowerCase().trim();
    this.filteredCourseEvaluationModeList = this.availableCourseEvaluationModes.filter(mode =>
      mode.toLowerCase().includes(searchTerm)
    );
  }

  filterCourseLanguages(): void {
    if (!this.courseLanguageSearchTerm.trim()) {
      this.filteredCourseLanguageList = [...this.availableCourseLanguages];
      return;
    }

    const searchTerm = this.courseLanguageSearchTerm.toLowerCase().trim();
    this.filteredCourseLanguageList = this.availableCourseLanguages.filter(language =>
      language.toLowerCase().includes(searchTerm)
    );
  }

  // Helper methods for course chart
  getCourseFilterHeaderCount(headerKey: string): number {
    switch (headerKey) {
      case 'courses':
        return this.selectedCourseFilterCourseIds.length;
      case 'difficulty':
        return this.selectedCourseFilterDifficultyLevels.length;
      case 'types':
        return this.selectedCourseFilterTypes.length;
      case 'evaluationMode':
        return this.selectedCourseFilterEvaluationModes.length;
      case 'language':
        return this.selectedCourseFilterLanguages.length;
      default:
        return 0;
    }
  }
  areAllCoursesSelectedForCourseFilter(): boolean {
    if (this.courseList.length === 0) return false;
    return this.selectedCourseFilterCourseIds.length === this.courseList.length;
  }

  toggleAllCoursesSelectionForCourseFilter(): void {
    if (this.areAllCoursesSelectedForCourseFilter()) {
      this.selectedCourseFilterCourseIds = [];
    } else {
      this.selectedCourseFilterCourseIds = this.courseList.map(course => course.course_id);
    }
    this.updateCourseFilteredData();
  }

  isCoursesSelectionIndeterminateForCourseFilter(): boolean {
    return this.selectedCourseFilterCourseIds.length > 0 &&
      this.selectedCourseFilterCourseIds.length < this.courseList.length;
  }

  // Difficulty level filter methods
  toggleCourseDifficultyFilter(difficulty: string): void {
    const index = this.selectedCourseFilterDifficultyLevels.indexOf(difficulty);
    if (index > -1) {
      this.selectedCourseFilterDifficultyLevels.splice(index, 1);
    } else {
      this.selectedCourseFilterDifficultyLevels.push(difficulty);
    }
    this.updateCourseFilteredData();
  }

  // Type filter methods
  toggleCourseTypeFilter(type: string): void {
    const index = this.selectedCourseFilterTypes.indexOf(type);
    if (index > -1) {
      this.selectedCourseFilterTypes.splice(index, 1);
    } else {
      this.selectedCourseFilterTypes.push(type);
    }
    this.updateCourseFilteredData();
  }

toggleCourseEvaluationModeFilter(mode: string): void {
  const index = this.selectedCourseFilterEvaluationModes.indexOf(mode);
  if (index >= 0) {
    this.selectedCourseFilterEvaluationModes.splice(index, 1);
  } else {
    this.selectedCourseFilterEvaluationModes.push(mode);
  }
  
  this.updateCourseFilteredData();
}
applyCourseFilters(): void {
  // 1. Original data lein
  let filteredData = [...this.allCoursesOrg]; 

  // 2. Filter apply karein
  filteredData = this.applySingleFilter(filteredData);

  // 3. Chart update karein
  this.prepareCourseData(filteredData);
  
  this.cdr.detectChanges();
}

  toggleCourseLanguageFilter(language: string): void {
    const index = this.selectedCourseFilterLanguages.indexOf(language);
    if (index > -1) {
      this.selectedCourseFilterLanguages.splice(index, 1);
    } else {
      this.selectedCourseFilterLanguages.push(language);
    }
    this.updateCourseFilteredData();
  }

  // Filter methods for course chart
  filterCoursesByCourseDifficultyLevels(courses: any[]): any[] {
    return courses.map(course => {
      const filteredCourse = { ...course };

      if (filteredCourse.difficulty_breakdown) {
        const filteredBreakdown = {};
        this.selectedCourseFilterDifficultyLevels.forEach(level => {
          if (filteredCourse.difficulty_breakdown[level] !== undefined) {
            filteredBreakdown[level] = filteredCourse.difficulty_breakdown[level];
          }
        });

        filteredCourse.difficulty_breakdown = filteredBreakdown;
        
        if (this.selectedCourseFilterTypes && this.selectedCourseFilterTypes.length > 0 && filteredCourse.type_difficulty_breakdown) {
          let intersectionCount = 0;
          this.selectedCourseFilterTypes.forEach((type: string) => {
            if (filteredCourse.type_difficulty_breakdown[type]) {
              this.selectedCourseFilterDifficultyLevels.forEach((level: string) => {
                intersectionCount += (Number(filteredCourse.type_difficulty_breakdown[type][level]) || 0);
              });
            }
          });
          filteredCourse.question_count = intersectionCount;
        } else {
          filteredCourse.question_count = Object.values(filteredBreakdown)
            .reduce((sum: number, count: any) => sum + (Number(count) || 0), 0);
        }
      }

      return filteredCourse;
    }).filter(course => course.question_count > 0);
  }

  filterCoursesByCourseTypes(courses: any[]): any[] {
    return courses.map(course => {
      const filteredCourse = { ...course };

      if (filteredCourse.type_breakdown) {
        const filteredBreakdown = {};
        this.selectedCourseFilterTypes.forEach(type => {
          if (filteredCourse.type_breakdown[type] !== undefined) {
            filteredBreakdown[type] = filteredCourse.type_breakdown[type];
          }
        });

        filteredCourse.type_breakdown = filteredBreakdown;

        if (this.selectedCourseFilterDifficultyLevels && this.selectedCourseFilterDifficultyLevels.length > 0 && filteredCourse.type_difficulty_breakdown) {
          let intersectionCount = 0;
          this.selectedCourseFilterTypes.forEach((type: string) => {
            if (filteredCourse.type_difficulty_breakdown[type]) {
              this.selectedCourseFilterDifficultyLevels.forEach((level: string) => {
                intersectionCount += (Number(filteredCourse.type_difficulty_breakdown[type][level]) || 0);
              });
            }
          });
          filteredCourse.question_count = intersectionCount;
        } else {
          filteredCourse.question_count = Object.values(filteredBreakdown)
            .reduce((sum: number, count: any) => sum + (Number(count) || 0), 0);
        }
      }

      return filteredCourse;
    }).filter(course => course.question_count > 0);
  }

  filterCoursesByCourseEvaluationModes(courses: any[]): any[] {
    const evaluationModeTypeMapping: { [key: string]: string[] } = {
      'Theory': ['mcq', 'true_false', 'fill_blanks', 'matching', 'subjective', 'scenario_based', 'multi_select'],
      'Practical': ['activity_performance', 'file_submission'],
      'Viva': ['audio_video', 'live_viva']
    };

    return courses.map(course => {
      const filteredCourse = { ...course };

      if (filteredCourse.question_category_breakdown) {
        const filteredBreakdown: any = {};
        let totalNewCount = 0;

        this.selectedCourseFilterEvaluationModes.forEach(mode => {
          if (filteredCourse.question_category_breakdown[mode] !== undefined) {
            let modeCount = 0;
            
            const hasTypeFilter = this.selectedCourseFilterTypes && this.selectedCourseFilterTypes.length > 0;
            const hasDiffFilter = this.selectedCourseFilterDifficultyLevels && this.selectedCourseFilterDifficultyLevels.length > 0;
            
            if ((hasTypeFilter || hasDiffFilter) && filteredCourse.type_breakdown) {
              const typesForMode = evaluationModeTypeMapping[mode] || [];
              
              typesForMode.forEach(type => {
                if (hasTypeFilter && !this.selectedCourseFilterTypes.includes(type)) {
                  return;
                }
                
                if (hasDiffFilter && filteredCourse.type_difficulty_breakdown && filteredCourse.type_difficulty_breakdown[type]) {
                  this.selectedCourseFilterDifficultyLevels.forEach((level: string) => {
                    modeCount += (Number(filteredCourse.type_difficulty_breakdown[type][level]) || 0);
                  });
                } else if (filteredCourse.type_breakdown[type]) {
                  modeCount += (Number(filteredCourse.type_breakdown[type]) || 0);
                }
              });
            } else {
              modeCount = Number(filteredCourse.question_category_breakdown[mode]) || 0;
            }

            if (modeCount > 0) {
              filteredBreakdown[mode] = modeCount;
              totalNewCount += modeCount;
            }
          }
        });

        filteredCourse.question_category_breakdown = filteredBreakdown;
        filteredCourse.question_count = totalNewCount;
      }

      return filteredCourse;
    }).filter(course => course.question_count > 0);
  }

  filterCoursesByCourseLanguages(courses: any[]): any[] {
    return courses.map(course => {
      const filteredCourse = { ...course };

      if (filteredCourse.language_breakdown) {
        const filteredBreakdown = {};
        this.selectedCourseFilterLanguages.forEach(language => {
          const languageKey = language.toLowerCase();
          if (filteredCourse.language_breakdown[languageKey] !== undefined) {
            filteredBreakdown[languageKey] = filteredCourse.language_breakdown[languageKey];
          }
        });

        filteredCourse.language_breakdown = filteredBreakdown;
        const newCount = Object.values(filteredBreakdown)
          .reduce((sum: number, count: number) => sum + count, 0);
        filteredCourse.question_count = Math.min(Number(filteredCourse.question_count) || 0, Number(newCount) || 0);
      }

      return filteredCourse;
    }).filter(course => course.question_count > 0);
  }

  private processCourseComparisonData(questionCounts: any[]): void {
    // Type guard to check if question_count is a number
    const isValidCourse = (course: any): course is { course_name: string; question_count: number } => {
      return course &&
        course.course_name &&
        typeof course.question_count === 'number' &&
        course.question_count > 0;
    };

    const validCourses = questionCounts.filter(isValidCourse);

    const sortedCourses = [...validCourses].sort((a, b) =>
      b.question_count - a.question_count
    );

    const topCourses = sortedCourses.slice(0, 10);
    const otherCoursesTotal = sortedCourses.slice(10).reduce((sum, course) =>
      sum + course.question_count, 0
    );

    const courseTotals: { [key: string]: number } = {};

    // Add top courses
    topCourses.forEach(course => {
      courseTotals[course.course_name] = course.question_count;
    });

    // Add others category
    if (otherCoursesTotal > 0) {
      courseTotals['Others'] = otherCoursesTotal;
    }

    const totalQuestions = Object.values(courseTotals).reduce((sum: number, count: number) => sum + count, 0);

    // Prepare comparison data
    this.compareCourseComparisonData = Object.entries(courseTotals)
      .filter(([_, count]) => count > 0)
      .map(([courseName, count]) => {
        const percentage = totalQuestions > 0 ? ((count / totalQuestions) * 100).toFixed(1) : '0';

        // Find corresponding current data for trend calculation
        const currentItem = this.currentCourseComparisonData.find(item => item.name === courseName);
        const currentValue = currentItem ? currentItem.value : 0;

        let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
        if (count > currentValue) {
          trend = 'positive';
        } else if (count < currentValue) {
          trend = 'negative';
        }

        return {
          name: courseName,
          value: count,
          percentage: percentage,
          trend: trend
        };
      });

    // Calculate trend summary
    this.calculateCourseTrendSummary();
  }

  private calculateCourseTrendSummary(): void {
    const currentTotal = this.getCurrentCourseTotalQuestions();
    const compareTotal = this.getCompareCourseTotalQuestions();

    this.courseTrendSummary = [
      {
        category: 'Total Questions',
        value: this.formatTrendValue(compareTotal - currentTotal),
        trend: compareTotal > currentTotal ? 'positive' : compareTotal < currentTotal ? 'negative' : 'neutral'
      }
    ];

    // Add course level trends for top 3 courses
    this.currentCourseComparisonData.slice(0, 3).forEach(currentItem => {
      const compareItem = this.compareCourseComparisonData.find(item => item.name === currentItem.name);
      if (compareItem) {
        const difference = compareItem.value - currentItem.value;
        this.courseTrendSummary.push({
          category: `${currentItem.name} Questions`,
          value: this.formatTrendValue(difference),
          trend: compareItem.trend
        });
      }
    });
  }

  getCurrentCourseTotalQuestions(): number {
    return this.currentCourseComparisonData.reduce((sum, item) => sum + item.value, 0);
  }

  getCompareCourseTotalQuestions(): number {
    return this.compareCourseComparisonData.reduce((sum, item) => sum + item.value, 0);
  }
  // Add this to your processLibraryData method
  private processAllChartData(): void {
    if (this.questionCounts && this.questionCounts.length > 0) {
      this.prepareQuestionChartData();
      this.prepareDifficultyData(this.questionCounts);
      this.prepareLanguageData(this.questionCounts);
      this.prepareCategoryData(this.questionCounts);
      this.prepareTypeData(this.questionCounts);
      this.prepareStatusData(this.questionCounts);
      this.initializeQuestionPaperData();
      this.prepareCourseData(this.questionCounts);
      this.prepareQuestionPaperByCourseData(this.questionCounts);
      this.prepareQuestionPaperDifficultyData(this.questionCounts);
      this.prepareQuestionPaperCategoryData(this.questionCounts);
    }
  }
  // Add this initialization method
  private initializeQuestionPaperData(): void {

    if (!this.questionCounts || this.questionCounts.length === 0) {
      this.questionPaperChartData = [];
      this.showDonutChart = false;
      return;
    }

    // Prepare the initial question paper chart data
    this.prepareQuestionPaperData(this.questionCounts);

    // Debug after preparation
    this.debugQuestionPaperData();
  }
  // Add this method to debug the question paper data
  private debugQuestionPaperData(): void {
    if (this.questionCounts && this.questionCounts.length > 0) {
      this.questionCounts.forEach((course, index) => {
      });
    }
  }
  // Compare Dialog Properties
  showStatusCompareDialog: boolean = false;
  showStatusComparisonResults: boolean = false;
  currentStatusComparisonData: any[] = [];
  compareStatusComparisonData: any[] = [];
  statusTrendSummary: any[] = [];

  // Status Month-wise Comparison Properties
  selectedStatusCompareMonth1: number | null = null;
  selectedStatusCompareMonth2: number | null = null;
  showStatusCompareMonth1Dropdown: boolean = false;
  showStatusCompareMonth2Dropdown: boolean = false;
  showStatusMonthComparisonResults: boolean = false;
  currentStatusMonthComparisonData: any[] = [];
  compareStatusMonthComparisonData: any[] = [];
  statusMonthComparisonChart: Chart | null = null;
  statusMonthTrendSummary: any[] = [];

  // Initialize Status Data
  private initializeStatusData(): void {
    const currentMonth = new Date().getMonth() + 1;
    if (currentMonth >= 4) {
      this.selectedStatusYearRange = `${new Date().getFullYear()}-${(new Date().getFullYear() + 1).toString().slice(2)}`;
    } else {
      this.selectedStatusYearRange = `${new Date().getFullYear() - 1}-${new Date().getFullYear().toString().slice(2)}`;
    }
    this.selectedStatusMonth = new Date().getMonth() + 1;
  }

  // Prepare Status Data
  private prepareStatusData(courses: any[]): void {

    if (courses.length === 0) {
      this.statusChartData = [];
      this.showStatusPieChart = false;
      return;
    }

    this.statusChartData = [];

    if (this.shouldShowOverallStatus()) {
      this.prepareOverallStatusData(courses);
    } else {
      this.prepareMultipleCoursesStatusData(courses);
    }

    this.statusChartData = this.statusChartData.filter(item =>
      item && item.value > 0 && item.name && item.name !== 'undefined'
    );

    this.showStatusPieChart = this.statusChartData.length > 0;

    if (this.showStatusPieChart) {
      setTimeout(() => {
        this.initializeStatusPieChart();
      }, 100);
    }
  }

  private prepareOverallStatusData(courses: any[]): void {

    const statusTotals = {
      'active': 0,
      'inactive': 0,
      'archived': 0,
      'deleted': 0
    };

    courses.forEach(course => {
      if (course.status_breakdown) {
        statusTotals['active'] += course.status_breakdown.active || 0;
        statusTotals['inactive'] += course.status_breakdown.inactive || 0;
        statusTotals['archived'] += course.status_breakdown.archived || 0;
        statusTotals['deleted'] += course.status_breakdown.deleted || 0;
      }
    });
    // Define colors for all statuses
    const statusColors = {
      'active': '#005068',      // Green
      'inactive': '#C71E1D',    // Yellow/Amber
      'archived': '#6c757d',    // Gray
      'deleted': '#C0B5A4'      // Red
    };

    Object.entries(statusTotals).forEach(([statusCode, count]) => {
      if (count > 0) {
        const statusName = this.getStatusName(statusCode);
        this.statusChartData.push({
          name: statusName,
          value: count,
          color: statusColors[statusCode],
          courseName: 'All Courses',
          originalCourseName: 'All Courses',
          courseId: 0,
          statusCode: statusCode
        });
      }
    });

  }

  private prepareMultipleCoursesStatusData(courses: any[]): void {

    const courseColors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9',
      '#F8B195', '#F67280', '#C06C84', '#6C5B7B', '#355C7D',
      '#99B898', '#FECEAB', '#FF847C', '#E84A5F', '#2A363B'
    ];

    courses.forEach((course, courseIndex) => {
      const courseColor = courseColors[courseIndex % courseColors.length];
      const courseName = course.course_name || `Course ${courseIndex + 1}`;


      const statusBreakdown = course.status_breakdown || {};

      const statuses = [
        { code: 'active', value: statusBreakdown.active || 0 },
        { code: 'inactive', value: statusBreakdown.inactive || 0 },
        { code: 'archived', value: statusBreakdown.archived || 0 },
        { code: 'deleted', value: statusBreakdown.deleted || 0 }
      ];

      statuses.forEach(status => {
        if (status.value > 0) {
          const uniqueColor = this.generateUniqueColor(courseColor, status.code);
          const statusName = this.getStatusName(status.code);

          this.statusChartData.push({
            name: statusName,
            value: status.value,
            color: uniqueColor,
            courseName: courseName,
            originalCourseName: course.course_name,
            courseId: course.course_id,
            statusCode: status.code,
            courseColor: courseColor
          });
        }
      });
    });

  }

  private getStatusName(statusCode: string): string {
    const status = this.availableStatus.find(s => s.value === statusCode);
    return status ? status.label : statusCode;
  }

  private initializeStatusPieChart(): void {

    const canvas = document.getElementById('statusPieChart') as HTMLCanvasElement;

    if (!canvas) {
      const allCanvases = document.querySelectorAll('canvas');
      allCanvases.forEach((c, i) => {
      });
      return;
    }

    // Destroy existing chart if it exists
    if (this.statusPieChart) {
      this.statusPieChart.destroy();
    }

    // Filter out zero values and invalid data
    const nonZeroData = this.statusChartData.filter(item =>
      item && item.value > 0 && item.name && item.name !== 'undefined'
    );

    if (nonZeroData.length === 0) {
      this.showStatusPieChart = false;

      // Clear canvas
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        // Display "No Data" message
        ctx.fillStyle = '#999';
        ctx.font = '16px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('No Status Data Available', canvas.width / 2, canvas.height / 2);
      }
      return;
    }

    this.showStatusPieChart = true;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      try {
        const isOverallView = this.shouldShowOverallStatus();
        const labels = isOverallView
          ? nonZeroData.map(item => item.name)
          : nonZeroData.map(item => `${this.truncateCourseName(item.courseName)} - ${item.name}`);

        this.statusPieChart = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: labels,
            datasets: [{
              data: nonZeroData.map(item => item.value),
              backgroundColor: nonZeroData.map(item => item.color),
              borderColor: '#fff',
              borderWidth: 0,
              hoverOffset: 0,
              hoverBorderWidth: 0,
              hoverBorderColor: 'transparent'
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  label: (context) => {
                    const index = context.dataIndex;
                    const item = nonZeroData[index];
                    const value = context.raw as number;
                    const total = nonZeroData.reduce((sum, dataItem) => sum + dataItem.value, 0);
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';

                    if (isOverallView) {
                      return [
                        `Status: ${item.name}`,
                        `Count: ${value}`,
                        `Percentage: ${percentage}%`
                      ];
                    } else {
                      return [
                        `Course: ${item.courseName}`,
                        `Status: ${item.name}`,
                        `Count: ${value}`,
                        `Percentage: ${percentage}%`
                      ];
                    }
                  }
                }
              }
            },
            animation: {
              animateScale: true,
              animateRotate: true
            },
            layout: {
              padding: {
                top: 10,
                right: 10,
                bottom: 20,
                left: 10
              }
            }
          }
        });
      } catch (error) {
        this.showStatusPieChart = false;
      }
    } else {
    }
  }

  // Filter Panel Methods
  toggleStatusFilterPanel(): void {
    this.showStatusFilterPanel = !this.showStatusFilterPanel;

    if (this.showStatusFilterPanel) {
      this.showStatusChartMenu = false; // Close menu when opening filter
      this.filteredStatusCourseList = [...this.courseList];
      this.filteredStatusList = [...this.availableStatus];
      this.activeStatusFilterHeader = 'courses';
      this.cdr.detectChanges();
    }
  }

  setActiveStatusFilterHeader(headerKey: string): void {
    this.activeStatusFilterHeader = headerKey;
  }

  // Course selection methods for status chart
  isCourseSelectedForStatus(courseId: number): boolean {
    return this.selectedStatusCourseIds.includes(courseId);
  }

  toggleCourseSelectionForStatus(courseId: number): void {
    const index = this.selectedStatusCourseIds.indexOf(courseId);
    if (index > -1) {
      this.selectedStatusCourseIds.splice(index, 1);
    } else {
      this.selectedStatusCourseIds.push(courseId);
    }
    this.updateStatusFilteredData();
  }

  areAllCoursesSelectedForStatus(): boolean {
    if (this.courseList.length === 0) return false;
    return this.selectedStatusCourseIds.length === this.courseList.length;
  }

  toggleAllCoursesSelectionForStatus(): void {
    if (this.areAllCoursesSelectedForStatus()) {
      this.selectedStatusCourseIds = [];
    } else {
      this.selectedStatusCourseIds = this.courseList.map(course => course.course_id);
    }
    this.updateStatusFilteredData();
  }

  isCoursesSelectionIndeterminateForStatus(): boolean {
    return this.selectedStatusCourseIds.length > 0 &&
      this.selectedStatusCourseIds.length < this.courseList.length;
  }

  // Status selection methods for status chart
  isStatusSelectedForStatus(statusValue: string): boolean {
    return this.selectedStatus.includes(statusValue);
  }

  toggleStatusSelectionForStatus(statusValue: string): void {
    const index = this.selectedStatus.indexOf(statusValue);
    if (index > -1) {
      this.selectedStatus.splice(index, 1);
    } else {
      this.selectedStatus.push(statusValue);
    }
    this.updateStatusFilteredData();
  }

  areAllStatusSelectedForStatus(): boolean {
    if (this.availableStatus.length === 0) return false;
    return this.selectedStatus.length === this.availableStatus.length;
  }

  toggleAllStatusSelectionForStatus(): void {
    if (this.areAllStatusSelectedForStatus()) {
      this.selectedStatus = [];
    } else {
      this.selectedStatus = this.availableStatus.map(status => status.value);
    }
    this.updateStatusFilteredData();
  }

  isStatusSelectionIndeterminateForStatus(): boolean {
    return this.selectedStatus.length > 0 &&
      this.selectedStatus.length < this.availableStatus.length;
  }

  areAllStatusSelected(): boolean {
    return this.selectedStatus.length === this.availableStatus.length;
  }

  toggleAllStatusSelection(): void {
    if (this.areAllStatusSelected()) {
      this.selectedStatus = [];
    } else {
      this.selectedStatus = this.availableStatus.map(status => status.value);
    }
    this.updateStatusFilteredData();
  }

  isStatusSelectionIndeterminate(): boolean {
    return this.selectedStatus.length > 0 &&
      this.selectedStatus.length < this.availableStatus.length;
  }

  // Update filtered data for status chart
  updateStatusFilteredData(): void {

    let filteredCourses = this.questionCounts;

    if (this.selectedStatusCourseIds.length > 0) {
      filteredCourses = this.questionCounts.filter(course =>
        this.selectedStatusCourseIds.includes(course.course_id)
      );
    }

    if (this.selectedStatus.length > 0) {
      filteredCourses = this.filterCoursesByStatusValue(filteredCourses);
    }

    this.prepareStatusData(filteredCourses);
    this.cdr.detectChanges();
  }

  // Filter courses by selected status values for status chart
  filterCoursesByStatusValue(courses: any[]): any[] {
    return courses.map(course => {
      const filteredCourse = { ...course };

      if (filteredCourse.status_breakdown) {
        const filteredBreakdown = {};
        this.selectedStatus.forEach(statusCode => {
          if (filteredCourse.status_breakdown[statusCode] !== undefined) {
            filteredBreakdown[statusCode] = filteredCourse.status_breakdown[statusCode];
          }
        });

        filteredCourse.status_breakdown = filteredBreakdown;
        // Calculate total questions for this course based on selected statuses
        filteredCourse.question_count = Object.values(filteredBreakdown)
          .reduce((sum: number, count: number) => sum + count, 0);
      }

      return filteredCourse;
    }).filter(course => {
      // Keep only courses that have questions in the selected status filters
      if (this.selectedStatus.length === 0) return true;
      return Object.values(course.status_breakdown || {}).some((count: any) => count > 0);
    });
  }

  // Helper methods
  getStatusFilterHeaderCount(headerKey: string): number {
    switch (headerKey) {
      case 'courses':
        return this.selectedStatusCourseIds.length;
      case 'status':
        return this.selectedStatus.length;
      default:
        return 0;
    }
  }

  getStatusPercentage(item: any): string {
    if (!item || !this.statusChartData || this.statusChartData.length === 0) {
      return '0';
    }

    const total = this.statusChartData.reduce((sum, dataItem) => {
      return sum + (dataItem?.value || 0);
    }, 0);

    return total > 0 ? (((item.value || 0) / total) * 100).toFixed(1) : '0';
  }

  private shouldShowOverallStatus(): boolean {
    const hasCourseFilter = this.selectedStatusCourseIds.length > 0;
    const hasStatusFilter = this.selectedStatus.length > 0;

    if (!hasCourseFilter) {
      return true;
    }

    if (this.selectedStatusCourseIds.length === this.courseList.length) {
      return true;
    }

    if (this.selectedStatusCourseIds.length === 1) {
      return false;
    }

    if (this.selectedStatusCourseIds.length > 5) {
      return true;
    }

    return false;
  }

  // Dropdown methods
  toggleStatusYearDropdown(): void {
    this.showStatusYearDropdown = !this.showStatusYearDropdown;
    if (this.showStatusYearDropdown) {
      this.showStatusMonthDropdown = false;
    }
  }

  selectStatusYearRange(yearRange: string): void {
    this.selectedStatusYearRange = yearRange;
    this.showStatusYearDropdown = false;
    this.applyStatusMonthYearFilter();
  }

  toggleStatusMonthDropdown(): void {
    this.showStatusMonthDropdown = !this.showStatusMonthDropdown;
    if (this.showStatusMonthDropdown) {
      this.showStatusYearDropdown = false;
    }
  }

  selectStatusMonth(month: number): void {
    this.selectedStatusMonth = month;
    this.showStatusMonthDropdown = false;
    this.applyStatusMonthYearFilter();
  }

  applyStatusMonthYearFilter(): void {
    this.showStatusYearDropdown = false;
    this.showStatusMonthDropdown = false;
    this.fetchStatusFilteredData();
  }

  private fetchStatusFilteredData(): void {
    this.isLoading = true;

    let startDate: Date;
    let endDate: Date;

    if (this.selectedStatusMonth) {
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedStatusYearRange);
      if (yearRange) {
        const year = this.selectedStatusMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedStatusMonth - 1, 1);
        endDate = new Date(year, this.selectedStatusMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedStatusMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedStatusMonth, 0);
      }
    } else {
      const dateRange = this.getDateRangeFromYearRange(this.selectedStatusYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

    const resp = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          // Extract ONLY question counts - don't call processLibraryData() which updates ALL charts
          this.extractQuestionCountsFromResponse(response);
          // Prepare ONLY status data - preserve independence of other charts
          this.prepareStatusData(this.questionCounts);
          this.isLoading = false;
          this.cdr.detectChanges();
        } else {
          this.statusChartData = [];
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.statusChartData = [];
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  // Filter search methods
  filterStatusCourses(): void {
    if (!this.statusCourseSearchTerm.trim()) {
      this.filteredStatusCourseList = [...this.courseList];
      return;
    }

    const searchTerm = this.statusCourseSearchTerm.toLowerCase().trim();
    this.filteredStatusCourseList = this.courseList.filter(course =>
      course.course_name.toLowerCase().includes(searchTerm)
    );
  }

  filterStatusList(): void {
    if (!this.statusSearchTerm.trim()) {
      this.filteredStatusList = [...this.availableStatus];
      return;
    }

    const searchTerm = this.statusSearchTerm.toLowerCase().trim();
    this.filteredStatusList = this.availableStatus.filter(status =>
      status.label.toLowerCase().includes(searchTerm)
    );
  }

  filterStatus(): void {
    if (!this.statusSearchTerm.trim()) {
      this.filteredStatusList = [...this.availableStatus];
      return;
    }

    const searchTerm = this.statusSearchTerm.toLowerCase().trim();
    this.filteredStatusList = this.availableStatus.filter(status =>
      status.label.toLowerCase().includes(searchTerm)
    );
  }

  // Question Status Selection Methods for Content Library
  isStatusSelectedForQuestion(statusValue: string): boolean {
    return this.selectedStatus.includes(statusValue);
  }

  toggleStatusSelectionForQuestion(statusValue: string): void {
    const index = this.selectedStatus.indexOf(statusValue);
    if (index > -1) {
      this.selectedStatus.splice(index, 1);
    } else {
      this.selectedStatus.push(statusValue);
    }
    this.updateStatusFilteredData();
  }

  // Chart menu methods
  toggleStatusChartMenu(): void {
    this.showStatusChartMenu = !this.showStatusChartMenu;
    if (this.showStatusChartMenu) {
      this.showStatusFilterPanel = false; // Close filter when opening menu
    }
  }

  closeStatusChartMenu(): void {
    this.showStatusChartMenu = false;
  }

  // Table modal methods
  showStatusTableModal(): void {
    this.closeStatusChartMenu();
    this.showStatusTableModalFlag = true;
  }

  closeStatusTableModal(): void {
    this.showStatusTableModalFlag = false;
  }

  exportStatusChartAsPDF(): void {
    this.closeStatusChartMenu();
    if (!this.ensureHasData(this.statusChartData)) { return; }

    if (this.statusPieChart) {
      const canvas = this.statusPieChart.canvas;
      const chartImage = canvas.toDataURL('image/png');

      // Create PDF with proper layout
      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Add title
      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');

      const chartTitle = this.shouldShowOverallStatus()
        ? 'Overall Question Status Distribution'
        : 'Course-wise Question Status Distribution';

      // Center the title
      const titleWidth = pdf.getTextWidth(chartTitle);
      const titleX = (pageWidth - titleWidth) / 2;
      pdf.text(chartTitle, titleX, 25);

      // Add source/subtitle
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      const subtitle = 'Source: Content Library Analytics';
      const subtitleWidth = pdf.getTextWidth(subtitle);
      const subtitleX = (pageWidth - subtitleWidth) / 2;
      pdf.text(subtitle, subtitleX, 32);

      // Add separator line
      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      // Add chart image at the top left
      const imgProps = pdf.getImageProperties(chartImage);
      const chartWidth = pageWidth * 0.45;
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      const chartX = 20;
      const chartY = 45;

      pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

      // Add Color Legends beside the chart (right side)
      const legendsX = chartX + chartWidth + 10;
      const legendsStartY = chartY;

      // Color Legends Title
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Color Legend', legendsX, legendsStartY);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      let currentLegendY = legendsStartY + 15;

      // Get unique courses and their colors
      const courseColors = new Map();
      const nonZeroData = this.statusChartData.filter(item => item.value > 0);

      nonZeroData.forEach(item => {
        if (!courseColors.has(item.courseName)) {
          courseColors.set(item.courseName, item.color);
        }
      });

      // Add course color legends with proper text wrapping
      const maxLegendWidth = pageWidth - legendsX - 15;

      courseColors.forEach((color, courseName) => {
        // Draw color box
        const rgb = this.hexToRgb(color);
        pdf.setFillColor(rgb.r, rgb.g, rgb.b);
        pdf.rect(legendsX, currentLegendY - 3, 10, 10, 'F');

        // Draw border around color box
        pdf.setDrawColor(100, 100, 100);
        pdf.rect(legendsX, currentLegendY - 3, 10, 10);

        // Course name with text wrapping
        const maxTextWidth = maxLegendWidth - 15;
        const lines = pdf.splitTextToSize(courseName, maxTextWidth);

        // Draw each line of the course name
        lines.forEach((line: string, index: number) => {
          pdf.text(line, legendsX + 15, currentLegendY + (index * 4));
        });

        // Move Y position based on number of lines
        currentLegendY += (lines.length * 4) + 8;
      });

      // Calculate position for distribution summary
      const chartBottom = chartY + chartHeight;
      const legendsBottom = currentLegendY;
      const summaryStartY = Math.max(chartBottom, legendsBottom) + 20;

      // Add Distribution Summary title
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Distribution Summary', 20, summaryStartY);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      let currentY = summaryStartY + 15;

      // Calculate totals and percentages
      const totalQuestions = this.statusChartData.reduce((sum, item) => sum + item.value, 0);

      if (this.shouldShowOverallStatus()) {
        // Show overall status breakdown in a single column
        pdf.setFont('helvetica', 'bold');
        pdf.text('Overall Status Breakdown:', 20, currentY);
        currentY += 8;

        pdf.setFont('helvetica', 'normal');
        nonZeroData.forEach(item => {
          const percentage = this.getStatusPercentage(item);
          pdf.text(`${item.name}: ${item.value} (${percentage}%)`, 25, currentY);
          currentY += 5;
        });
      } else {
        // Show course-wise breakdown in multiple columns
        const coursesMap = new Map();
        nonZeroData.forEach(item => {
          if (!coursesMap.has(item.courseName)) {
            coursesMap.set(item.courseName, []);
          }
          coursesMap.get(item.courseName).push(item);
        });

        const coursesArray = Array.from(coursesMap.entries());
        const coursesPerRow = 2;
        const courseWidth = (pageWidth - 60) / coursesPerRow;

        // Add course-wise breakdown in grid layout
        for (let i = 0; i < coursesArray.length; i += coursesPerRow) {
          const rowCourses = coursesArray.slice(i, i + coursesPerRow);

          let maxCourseHeight = 0;

          // Process each course in the current row
          rowCourses.forEach(([courseName, statuses], courseIndex) => {
            const courseX = 20 + (courseIndex * courseWidth);
            let courseY = currentY;

            // Course name with background and text wrapping
            pdf.setFont('helvetica', 'bold');
            pdf.setFillColor(245, 245, 245);

            // Wrap course name to fit within course width
            const courseNameLines = pdf.splitTextToSize(courseName, courseWidth - 20);
            const courseNameHeight = courseNameLines.length * 4 + 6;

            // Draw background for course name
            pdf.rect(courseX, courseY - 5, courseWidth - 15, courseNameHeight, 'F');

            // Draw colored border on left
            const rgb = this.hexToRgb(courseColors.get(courseName));
            pdf.setFillColor(rgb.r, rgb.g, rgb.b);
            pdf.rect(courseX, courseY - 5, 4, courseNameHeight, 'F');

            // Reset fill color for text
            pdf.setFillColor(0, 0, 0);

            // Draw course name lines
            courseNameLines.forEach((line: string, lineIndex: number) => {
              pdf.text(line, courseX + 8, courseY + (lineIndex * 4));
            });

            courseY += courseNameHeight + 8;

            pdf.setFont('helvetica', 'normal');

            // Add statuses for this course
            statuses.forEach(item => {
              const percentage = this.getStatusPercentage(item);
              const statusText = `${item.name}: ${item.value} (${percentage}%)`;

              pdf.text(statusText, courseX + 8, courseY);
              courseY += 5;
            });

            // Update max height for this row
            const courseHeight = courseY - currentY;
            if (courseHeight > maxCourseHeight) {
              maxCourseHeight = courseHeight;
            }
          });

          // Move to next row position
          currentY += maxCourseHeight + 20;

          // Add page break if needed
          if (currentY > pageHeight - 50 && i + coursesPerRow < coursesArray.length) {
            pdf.addPage();
            currentY = 20;

            // Add title on new page
            pdf.setFontSize(14);
            pdf.setFont('helvetica', 'bold');
            pdf.text('Distribution Summary (Continued)', 20, currentY);
            currentY += 15;
          }
        }
      }

      // Add total questions and metadata below the distribution summary
      currentY += 10;
      pdf.setFont('helvetica', 'bold');
      pdf.text(`Total Questions: ${totalQuestions}`, 20, currentY);

      // Add filter information
      currentY += 8;
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'italic');

      let filterInfo = `View: ${this.shouldShowOverallStatus() ? 'Overall Status' : 'Course-wise Breakdown'}`;
      pdf.text(filterInfo, 20, currentY);

      currentY += 4;
      let dateRangeText = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateRangeText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
      }
      pdf.text(dateRangeText, 20, currentY);

      // Add selected courses info if in course-wise view
      if (!this.shouldShowOverallStatus() && this.selectedStatusCourseIds.length > 0) {
        currentY += 4;
        const courseCount = this.selectedStatusCourseIds.length;
        pdf.text(`Selected Courses: ${courseCount} course${courseCount > 1 ? 's' : ''}`, 20, currentY);
      }

      // Add footer at the bottom
      const footerY = pageHeight - 10;
      pdf.setFontSize(8);
      pdf.setFont('helvetica', 'normal');
      pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth / 2, footerY, { align: 'center' });

      const fileName = this.shouldShowOverallStatus()
        ? 'overall-status-analysis.pdf'
        : 'course-wise-status-analysis.pdf';

      pdf.save(fileName);
    }
  }
  exportStatusChartAsPNG(): void {
    this.closeStatusChartMenu();
    if (!this.ensureHasData(this.statusChartData)) { return; }

    if (this.statusPieChart) {
      // Create a container to combine chart and information
      const container = document.createElement('div');
      container.style.cssText = `
      position: fixed;
      left: -10000px;
      top: -10000px;
      width: 1400px;
      background: white;
      padding: 40px;
      border: 1px solid #ccc;
      z-index: 10000;
      font-family: Arial, sans-serif;
    `;

      // Create header
      const header = document.createElement('div');
      header.style.cssText = `
      text-align: center;
      margin-bottom: 40px;
      padding-bottom: 20px;
      border-bottom: 3px solid #005068;
    `;

      const title = document.createElement('h1');
      title.textContent = this.shouldShowOverallStatus()
        ? 'Overall Question Status Distribution'
        : 'Course-wise Question Status Distribution';
      title.style.cssText = `
      margin: 0 0 12px 0;
      color: #005068;
      font-size: 32px;
      font-weight: bold;
    `;

      const subtitle = document.createElement('p');
      subtitle.textContent = 'Source: Content Library Analytics';
      subtitle.style.cssText = `
      margin: 0;
      color: #666;
      font-size: 16px;
    `;

      header.appendChild(title);
      header.appendChild(subtitle);

      // Create top row for chart and legends
      const topRow = document.createElement('div');
      topRow.style.cssText = `
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 60px;
      margin-bottom: 40px;
      padding: 30px;
      background: #f8f9fa;
      border-radius: 15px;
      min-height: 500px;
    `;

      // Chart container (larger and expanded)
      const chartContainer = document.createElement('div');
      chartContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 2;
      min-height: 500px;
    `;

      // Create a high-quality chart render
      const chartWrapper = document.createElement('div');
      chartWrapper.style.cssText = `
      width: 500px;
      height: 500px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: white;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      padding: 20px;
      box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    `;

      // Get the original chart canvas
      const originalCanvas = this.statusPieChart.canvas;

      // Create a high-resolution canvas
      const highResCanvas = document.createElement('canvas');
      highResCanvas.width = 800;
      highResCanvas.height = 800;

      const ctx = highResCanvas.getContext('2d');
      if (ctx) {
        // Scale up for better quality
        ctx.scale(2, 2);

        // Set white background
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, highResCanvas.width, highResCanvas.height);

        // Draw the chart with better quality
        ctx.drawImage(originalCanvas, 0, 0, 400, 400);
      }

      const chartImg = document.createElement('img');
      chartImg.src = highResCanvas.toDataURL('image/png', 1.0);
      chartImg.style.cssText = `
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 10px;
      object-fit: contain;
    `;

      chartWrapper.appendChild(chartImg);
      chartContainer.appendChild(chartWrapper);

      // Legends container
      const legendsContainer = document.createElement('div');
      legendsContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 25px;
      flex: 1;
      min-width: 320px;
      max-width: 350px;
    `;

      // Color Legend Container
      const colorLegendContainer = document.createElement('div');
      colorLegendContainer.style.cssText = `
      background: white;
      padding: 30px;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    `;

      const colorLegendTitle = document.createElement('h3');
      colorLegendTitle.textContent = 'Color Legend';
      colorLegendTitle.style.cssText = `
      margin: 0 0 25px 0;
      color: #005068;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      border-bottom: 3px solid #f0f0f0;
      padding-bottom: 15px;
    `;

      colorLegendContainer.appendChild(colorLegendTitle);

      // Add course color legend only
      const courseLegend = document.createElement('div');
      courseLegend.style.cssText = `
      margin-bottom: 10px;
    `;

      const courseLegendTitle = document.createElement('h4');
      courseLegendTitle.textContent = 'Courses';
      courseLegendTitle.style.cssText = `
      margin: 0 0 20px 0;
      color: #333;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    `;

      courseLegend.appendChild(courseLegendTitle);

      // Get unique courses and their colors
      const courseColors = new Map();
      const nonZeroData = this.statusChartData.filter(item => item.value > 0);

      nonZeroData.forEach(item => {
        if (!courseColors.has(item.courseName)) {
          courseColors.set(item.courseName, item.color);
        }
      });

      // Add course color items with better styling
      courseColors.forEach((color, courseName) => {
        const courseItem = document.createElement('div');
        courseItem.style.cssText = `
        display: flex;
        align-items: flex-start;
        margin-bottom: 16px;
        padding: 12px;
        background: #f8f9fa;
        border-radius: 10px;
        border-left: 5px solid ${color};
        transition: all 0.3s ease;
      `;

        const colorBox = document.createElement('div');
        colorBox.style.cssText = `
        width: 24px;
        height: 24px;
        background-color: ${color};
        border: 3px solid #fff;
        border-radius: 8px;
        margin-right: 15px;
        margin-top: 2px;
        box-shadow: 0 3px 8px rgba(0,0,0,0.2);
        flex-shrink: 0;
      `;

        const courseNameSpan = document.createElement('span');
        courseNameSpan.textContent = courseName;
        courseNameSpan.style.cssText = `
        font-size: 16px;
        font-weight: 500;
        color: #333;
        line-height: 1.4;
        word-wrap: break-word;
        flex: 1;
      `;

        courseItem.appendChild(colorBox);
        courseItem.appendChild(courseNameSpan);
        courseLegend.appendChild(courseItem);
      });

      colorLegendContainer.appendChild(courseLegend);
      legendsContainer.appendChild(colorLegendContainer);

      // Add legends to top row
      topRow.appendChild(chartContainer);
      topRow.appendChild(legendsContainer);

      // Distribution Summary Section
      const distributionSection = document.createElement('div');
      distributionSection.style.cssText = `
      margin-top: 40px;
    `;

      const distributionTitle = document.createElement('h2');
      distributionTitle.textContent = 'Distribution Summary';
      distributionTitle.style.cssText = `
      margin: 0 0 30px 0;
      color: #005068;
      font-size: 28px;
      font-weight: bold;
      text-align: center;
      border-bottom: 3px solid #005068;
      padding-bottom: 15px;
    `;

      distributionSection.appendChild(distributionTitle);

      // Create course grid (2 courses per row)
      const coursesMap = new Map();
      nonZeroData.forEach(item => {
        if (!coursesMap.has(item.courseName)) {
          coursesMap.set(item.courseName, []);
        }
        coursesMap.get(item.courseName).push(item);
      });

      const coursesArray = Array.from(coursesMap.entries());

      // Create rows with 2 courses each
      for (let i = 0; i < coursesArray.length; i += 2) {
        const row = document.createElement('div');
        row.style.cssText = `
        display: flex;
        gap: 40px;
        margin-bottom: 40px;
        justify-content: center;
      `;

        // Add courses for this row
        for (let j = 0; j < 2 && (i + j) < coursesArray.length; j++) {
          const [courseName, statuses] = coursesArray[i + j];
          const courseColor = courseColors.get(courseName);

          const courseCard = document.createElement('div');
          courseCard.style.cssText = `
          flex: 1;
          background: white;
          padding: 30px;
          border-radius: 15px;
          border: 3px solid #e0e0e0;
          border-left: 8px solid ${courseColor};
          min-width: 350px;
          max-width: 400px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.15);
        `;

          // Course header
          const courseHeader = document.createElement('h3');
          courseHeader.textContent = courseName;
          courseHeader.style.cssText = `
          margin: 0 0 25px 0;
          color: #333;
          font-size: 20px;
          font-weight: bold;
          border-bottom: 3px solid #f0f0f0;
          padding-bottom: 15px;
          text-align: center;
          word-wrap: break-word;
          line-height: 1.3;
        `;

          courseCard.appendChild(courseHeader);

          // Create table-like structure for statuses
          const tableContainer = document.createElement('div');
          tableContainer.style.cssText = `
          width: 100%;
        `;

          // Add statuses for this course
          statuses.forEach(item => {
            const percentage = this.getStatusPercentage(item);

            const rowDiv = document.createElement('div');
            rowDiv.style.cssText = `
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
            font-size: 16px;
            padding: 12px 0;
            border-bottom: 2px solid #f5f5f5;
          `;

            const statusLabel = document.createElement('span');
            statusLabel.textContent = `${item.name}:`;
            statusLabel.style.cssText = `
            font-weight: bold;
            color: #333;
            font-size: 16px;
          `;

            const valueSpan = document.createElement('span');
            valueSpan.textContent = `${item.value} (${percentage}%)`;
            valueSpan.style.cssText = `
            color: #666;
            font-weight: 600;
            font-size: 16px;
          `;

            rowDiv.appendChild(statusLabel);
            rowDiv.appendChild(valueSpan);
            tableContainer.appendChild(rowDiv);
          });

          courseCard.appendChild(tableContainer);
          row.appendChild(courseCard);
        }

        distributionSection.appendChild(row);
      }

      // Total and footer section
      const totalQuestions = this.statusChartData.reduce((sum, item) => sum + item.value, 0);

      const totalSection = document.createElement('div');
      totalSection.style.cssText = `
      margin-top: 50px;
      padding: 30px;
      background: #f8f9fa;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      text-align: center;
    `;

      const totalLabel = document.createElement('div');
      totalLabel.style.cssText = `
      font-weight: bold;
      margin-bottom: 20px;
      font-size: 20px;
      color: #005068;
    `;
      totalLabel.textContent = `Total Questions: ${totalQuestions}`;

      const metadataContainer = document.createElement('div');
      metadataContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-size: 15px;
      color: #666;
      margin-bottom: 20px;
    `;

      // View information
      const viewInfo = document.createElement('div');
      viewInfo.style.cssText = `
      font-weight: 500;
    `;
      viewInfo.textContent = `View: ${this.shouldShowOverallStatus() ? 'Overall Status' : 'Course-wise Breakdown'}`;

      // Date information
      const dateInfo = document.createElement('div');
      let dateText = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
      }
      dateInfo.textContent = dateText;

      // Selected courses info
      if (!this.shouldShowOverallStatus() && this.selectedStatusCourseIds.length > 0) {
        const courseInfo = document.createElement('div');
        const courseCount = this.selectedStatusCourseIds.length;
        courseInfo.textContent = `Selected Courses: ${courseCount} course${courseCount > 1 ? 's' : ''}`;
        courseInfo.style.fontWeight = '500';
        metadataContainer.appendChild(courseInfo);
      }

      // Footer
      const footer = document.createElement('div');
      footer.style.cssText = `
      text-align: center;
      margin-top: 20px;
      padding-top: 20px;
      border-top: 3px solid #ddd;
      font-size: 14px;
      color: #666;
      font-style: italic;
    `;
      footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;

      metadataContainer.appendChild(viewInfo);
      metadataContainer.appendChild(dateInfo);

      totalSection.appendChild(totalLabel);
      totalSection.appendChild(metadataContainer);
      totalSection.appendChild(footer);

      // Assemble the container
      container.appendChild(header);
      container.appendChild(topRow);
      container.appendChild(distributionSection);
      container.appendChild(totalSection);

      document.body.appendChild(container);

      // Use html2canvas with higher quality settings
      html2canvas(container, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: container.offsetWidth,
        height: container.offsetHeight
      }).then(canvas => {
        const link = document.createElement('a');
        link.download = this.shouldShowOverallStatus()
          ? 'overall-status-analysis.png'
          : 'course-wise-status-analysis.png';
        link.href = canvas.toDataURL('image/png', 1.0);
        link.click();

        // Clean up
        document.body.removeChild(container);
      });
    }
  }
  exportStatusTableAsPDF(): void {
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();

    // Add title
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Question Status Distribution - Detailed Report', pageWidth / 2, 20, { align: 'center' });

    // Add summary information
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');

    const totalQuestions = this.statusChartData.reduce((sum, item) => sum + item.value, 0);

    let dateInfo = `Date Range: ${this.selectedRange}`;
    if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
      dateInfo += ` | From: ${this.formatDisplayDate(this.startDate)} To: ${this.formatDisplayDate(this.endDate)}`;
    }
    dateInfo += ` | Total Questions: ${totalQuestions}`;

    pdf.text(dateInfo, pageWidth / 2, 28, { align: 'center' });

    // Create table data
    const tableData = this.statusChartData
      .filter(item => item.value > 0)
      .map(item => [
        item.courseName || 'All Courses',
        item.name,
        item.value.toString(),
        `${this.getStatusPercentage(item)}%`
      ]);

    // Use autoTable
    autoTable(pdf, {
      startY: 35,
      head: [['Course Name', 'Status', 'Count', 'Percentage']],
      body: tableData,
      theme: 'grid',
      headStyles: {
        fillColor: [0, 80, 104], // #005068
        textColor: 255,
        fontStyle: 'bold',
        fontSize: 10
      },
      styles: {
        fontSize: 9,
        cellPadding: 4,
        lineColor: [0, 0, 0],
        lineWidth: 0.1
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      },
      columnStyles: {
        0: { cellWidth: 'auto', fontStyle: 'bold' }, // Course Name
        1: { cellWidth: 'auto' }, // Status
        2: { cellWidth: 'auto' }, // Count
        3: { cellWidth: 'auto' }  // Percentage
      },
      margin: { top: 35 }
    });

    // Add footer
    const finalY = (pdf as any).lastAutoTable?.finalY || 100;
    pdf.setFontSize(8);
    pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth / 2, finalY + 10, { align: 'center' });

    pdf.save('question-status-detailed-report.pdf');
  }

  exportStatusTableAsPNG(): void {
    // Create a container for the table with styling
    const container = document.createElement('div');
    container.style.cssText = `
    position: fixed;
    left: -10000px;
    top: -10000px;
    background: white;
    padding: 30px;
    z-index: 10000;
    max-width: 900px;
    width: 900px;
    font-family: Arial, sans-serif;
  `;

    // Add title and header
    const header = document.createElement('div');
    header.style.cssText = `
    text-align: center;
    margin-bottom: 25px;
    padding-bottom: 15px;
    border-bottom: 2px solid #005068;
  `;

    const title = document.createElement('h2');
    title.textContent = 'Question Status Distribution - Detailed Table';
    title.style.cssText = `
    margin: 0 0 12px 0;
    color: #005068;
    font-size: 24px;
    font-weight: bold;
  `;

    const totalQuestions = this.statusChartData.reduce((sum, item) => sum + item.value, 0);
    const subtitle = document.createElement('p');
    subtitle.textContent = `Date Range: ${this.selectedRange} | Total Questions: ${totalQuestions}`;
    subtitle.style.cssText = `
    margin: 0;
    color: #666;
    font-size: 14px;
  `;

    header.appendChild(title);
    header.appendChild(subtitle);

    // Create table manually
    const tableClone = this.createStatusTableForExport();
    container.appendChild(header);
    container.appendChild(tableClone);

    // Add footer
    const footer = document.createElement('div');
    footer.style.cssText = `
    text-align: center;
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid #ddd;
    font-size: 12px;
    color: #666;
    font-style: italic;
  `;
    footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;
    container.appendChild(footer);

    document.body.appendChild(container);

    html2canvas(container, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff'
    }).then(canvas => {
      const link = document.createElement('a');
      link.download = 'question-status-table.png';
      link.href = canvas.toDataURL('image/png');
      link.click();

      // Clean up
      document.body.removeChild(container);
    });
  }

  // Helper method to create status table for export
  private createStatusTableForExport(): HTMLElement {
    const table = document.createElement('table');
    table.style.cssText = `
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
    font-size: 13px;
    margin-bottom: 20px;
  `;

    // Create table header
    const thead = document.createElement('thead');
    const headerRow = document.createElement('tr');

    const headers = ['Course Name', 'Status', 'Count', 'Percentage'];
    headers.forEach(headerText => {
      const th = document.createElement('th');
      th.textContent = headerText;
      th.style.cssText = `
      background: #005068;
      color: white;
      padding: 12px 15px;
      text-align: left;
      font-weight: bold;
      border: 1px solid #ddd;
    `;
      headerRow.appendChild(th);
    });

    thead.appendChild(headerRow);
    table.appendChild(thead);

    // Create table body
    const tbody = document.createElement('tbody');

    this.statusChartData
      .filter(item => item.value > 0)
      .forEach((item, index) => {
        const row = document.createElement('tr');
        row.style.cssText = `
        background: ${index % 2 === 0 ? '#f9f9f9' : 'white'};
      `;

        const courseCell = document.createElement('td');
        courseCell.textContent = item.courseName || 'All Courses';
        courseCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        const statusCell = document.createElement('td');
        statusCell.textContent = item.name;
        statusCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        const countCell = document.createElement('td');
        countCell.textContent = item.value.toString();
        countCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        const percentageCell = document.createElement('td');
        percentageCell.textContent = `${this.getStatusPercentage(item)}%`;
        percentageCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        row.appendChild(courseCell);
        row.appendChild(statusCell);
        row.appendChild(countCell);
        row.appendChild(percentageCell);
        tbody.appendChild(row);
      });

    table.appendChild(tbody);
    return table;
  }

  // Compare Dialog Methods
  openStatusCompareDialog(): void {
    this.showStatusCompareDialog = true;
    this.showStatusMonthComparisonResults = false;
    this.selectedStatusCompareMonth1 = null;
    this.selectedStatusCompareMonth2 = null;
  }

  closeStatusCompareDialog(): void {
    this.showStatusCompareDialog = false;
    this.showStatusMonthComparisonResults = false;
    this.currentStatusMonthComparisonData = [];
    this.compareStatusMonthComparisonData = [];
  }

  // Status Month Comparison Methods
  toggleStatusCompareMonth1Dropdown(): void {
    this.showStatusCompareMonth1Dropdown = !this.showStatusCompareMonth1Dropdown;
    if (this.showStatusCompareMonth1Dropdown) {
      this.showStatusCompareMonth2Dropdown = false;
    }
  }

  selectStatusCompareMonth1(month: number): void {
    this.selectedStatusCompareMonth1 = month;
    this.showStatusCompareMonth1Dropdown = false;
  }

  toggleStatusCompareMonth2Dropdown(): void {
    this.showStatusCompareMonth2Dropdown = !this.showStatusCompareMonth2Dropdown;
    if (this.showStatusCompareMonth2Dropdown) {
      this.showStatusCompareMonth1Dropdown = false;
    }
  }

  selectStatusCompareMonth2(month: number): void {
    this.selectedStatusCompareMonth2 = month;
    this.showStatusCompareMonth2Dropdown = false;
  }

  loadStatusMonthComparisonData(): void {
    if (!this.selectedStatusCompareMonth1 || !this.selectedStatusCompareMonth2) {
      return;
    }

    this.showStatusCompareMonth1Dropdown = false;
    this.showStatusCompareMonth2Dropdown = false;

    this.fetchStatusMonthComparisonData();
  }

  private fetchStatusMonthComparisonData(): void {
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedStatusCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedStatusCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    const resp1 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    const resp2 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Courses: any[] = [];
    let month2Courses: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month1Courses = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processStatusMonthComparisonData(month1Courses, month2Courses);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.processStatusMonthComparisonData(month1Courses, month2Courses);
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month2Courses = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processStatusMonthComparisonData(month1Courses, month2Courses);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.processStatusMonthComparisonData(month1Courses, month2Courses);
        }
      }
    );
  }

  private processStatusMonthComparisonData(month1Courses: any[], month2Courses: any[]): void {
    this.isLoading = false;

    const month1StatusData = this.extractStatusDataFromCourses(month1Courses);
    const month2StatusData = this.extractStatusDataFromCourses(month2Courses);

    this.currentStatusMonthComparisonData = month1StatusData;
    this.compareStatusMonthComparisonData = month2StatusData;

    this.statusMonthTrendSummary = [];
    const allStatuses = new Set([...month1StatusData.map(d => d.name), ...month2StatusData.map(d => d.name)]);

    allStatuses.forEach(status => {
      const month1Item = month1StatusData.find(d => d.name === status);
      const month2Item = month2StatusData.find(d => d.name === status);

      const month1Value = month1Item?.value || 0;
      const month2Value = month2Item?.value || 0;

      let trend = 'neutral';
      if (month2Value > month1Value) {
        trend = 'positive';
      } else if (month2Value < month1Value) {
        trend = 'negative';
      }

      this.statusMonthTrendSummary.push({
        status: status,
        value: Math.abs(month2Value - month1Value),
        trend: trend
      });
    });

    this.showStatusMonthComparisonResults = true;
    this.cdr.detectChanges();

    setTimeout(() => {
      this.initializeStatusMonthComparisonChart();
    }, 200);
  }

  private extractStatusDataFromCourses(courses: any[]): any[] {
    const statusTotals: any = {};

    courses.forEach((course) => {
      if (course.status_breakdown) {
        Object.keys(course.status_breakdown).forEach(status => {
          if (!statusTotals[status]) {
            statusTotals[status] = 0;
          }
          statusTotals[status] += course.status_breakdown[status] || 0;
        });
      }
    });

    const result = Object.keys(statusTotals)
      .filter(status => statusTotals[status] > 0)
      .map(status => ({
        name: status,
        value: statusTotals[status]
      }));

    return result;
  }

  private initializeStatusMonthComparisonChart(): void {
    const canvas = document.getElementById('statusMonthComparisonChart') as HTMLCanvasElement;

    if (!canvas) {
      return;
    }

    if (this.statusMonthComparisonChart) {
      this.statusMonthComparisonChart.destroy();
    }

    const statusNames = this.currentStatusMonthComparisonData.map(d => d.name);

    const month1Values = statusNames.map(name => {
      const item = this.currentStatusMonthComparisonData.find(s => s.name === name);
      return item?.value || 0;
    });

    const month2Values = statusNames.map(name => {
      const item = this.compareStatusMonthComparisonData.find(s => s.name === name);
      return item?.value || 0;
    });

    const month1Name = this.getMonthName(this.selectedStatusCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedStatusCompareMonth2!);

    const ctx = canvas.getContext('2d');
    if (ctx) {
      this.statusMonthComparisonChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: statusNames,
          datasets: [
            {
              label: month1Name,
              data: month1Values,
              backgroundColor: '#FF9800',
              borderColor: '#FF9800',
              borderWidth: 0,
              borderRadius: 4,
              barThickness: 20
            },
            {
              label: month2Name,
              data: month2Values,
              backgroundColor: '#9C27B0',
              borderColor: '#9C27B0',
              borderWidth: 0,
              borderRadius: 4,
              barThickness: 20
            }
          ]
        },
        options: {
          indexAxis: 'y' as const,
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: {
              position: 'top',
              labels: {
                font: {
                  size: 12
                },
                padding: 15,
                usePointStyle: true
              }
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  return `${context.dataset.label}: ${context.raw}`;
                }
              }
            }
          },
          scales: {
            x: {
              beginAtZero: true,
              ticks: {
                stepSize: 1
              }
            },
            y: {
              ticks: {
                font: {
                  size: 11
                }
              }
            }
          }
        }
      });
    }
  }

  private initializeLanguageBarChart(): void {
    const canvas = document.getElementById('languageBarChart') as HTMLCanvasElement;

    if (!canvas) {
      return;
    }

    // Destroy existing chart if it exists
    if (this.languageBarChart) {
      this.languageBarChart.destroy();
    }

    // Filter out zero values and invalid data
    const nonZeroData = this.languageBarChartData.filter(item =>
      item && item.value > 0 && item.name && item.name !== 'undefined'
    );

    if (nonZeroData.length === 0) {
      this.showLanguageBarChart = false;
      return;
    }

    this.showLanguageBarChart = true;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      try {
        // Check if this is difficulty or evaluation breakdown mode
        const isBreakdownMode = nonZeroData.some(item => item.difficulty || item.evaluationMode);

        let chartConfig: any;

        if (isBreakdownMode) {
          // Group data by language
          const languageGroups: { [language: string]: { [key: string]: number } } = {};
          const categories = new Set<string>();
          const categoryColors: { [key: string]: string } = {
            'easy': '#28a745',
            'medium': '#ffc107',
            'hard': '#dc3545',
            'Theory': '#005068',
            'Practical': '#A0A0FF',
            'Viva': '#F9EDDB'
          };

          nonZeroData.forEach(item => {
            const language = item.languageCode;
            const category = item.difficulty || item.evaluationMode;
            if (!languageGroups[language]) {
              languageGroups[language] = {};
            }
            languageGroups[language][category] = item.value;
            categories.add(category);
          });

          const labels = Object.keys(languageGroups);
          const datasets = Array.from(categories).map(category => ({
            label: category.charAt(0).toUpperCase() + category.slice(1),
            data: labels.map(language => languageGroups[language][category] || 0),
            backgroundColor: categoryColors[category] || '#6c757d',
            borderColor: categoryColors[category] || '#6c757d',
            borderWidth: 1,
            borderRadius: 4,
            borderSkipped: false,
          }));

          chartConfig = {
            type: 'bar',
            data: {
              labels: labels,
              datasets: datasets
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: true,
                  position: 'top'
                },
                tooltip: {
                  callbacks: {
                    label: (context) => {
                      const value = context.raw as number;
                      return `${context.dataset.label}: ${value}`;
                    }
                  }
                },
              },
              scales: {
                x: {
                  stacked: true,
                  title: {
                    display: true,
                    text: 'Languages'
                  }
                },
                y: {
                  stacked: true,
                  beginAtZero: true,
                  title: {
                    display: true,
                    text: 'Number of Questions'
                  }
                }
              }
            }
          };
        } else {
          // Original single dataset mode
          const labels = nonZeroData.map(item => {
            if (this.shouldShowOverallLanguage()) {
              return item.name; // Just language name for overall
            } else {
              return `${this.truncateCourseName(item.courseName)} - ${item.name}`; // Course + language
            }
          });

          const data = nonZeroData.map(item => item.value);
          const backgroundColors = nonZeroData.map(item => item.color);

          chartConfig = {
            type: 'bar',
            data: {
              labels: labels,
              datasets: [{
                label: 'Question Count',
                data: data,
                backgroundColor: backgroundColors,
                borderColor: backgroundColors.map(color => this.darkenColor(color, 20)),
                borderWidth: 1,
                borderRadius: 4,
                borderSkipped: false,
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: false
                },
                tooltip: {
                  callbacks: {
                    label: (context) => {
                      const value = context.raw as number;
                      const total = data.reduce((sum, val) => sum + val, 0);
                      const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                      return `${context.label}: ${value} (${percentage}%)`;
                    }
                  }
                },
              },
              scales: {
                y: {
                  beginAtZero: true,
                  title: {
                    display: true,
                    text: 'Number of Questions',
                    font: {
                      size: 12,
                      weight: 'bold'
                    }
                  },
                  grid: {
                    color: 'rgba(0,0,0,0.1)'
                  },
                  ticks: {
                    stepSize: 1,
                    precision: 0
                  }
                },
                x: {
                  title: {
                    display: false,
                    text: 'Languages',
                    font: {
                      size: 12,
                      weight: 'bold'
                    }
                  },
                  grid: {
                    display: false
                  },
                  ticks: {
                    autoSkip: true,
                    maxRotation: 45,
                    minRotation: 0
                  }
                }
              },
              animation: {
                duration: 1000,
                easing: 'easeOutQuart'
              },
              layout: {
                padding: {
                  top: 10,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            }
          };
        }

        this.languageBarChart = new Chart(ctx, chartConfig);
      } catch (error) {
        this.showLanguageBarChart = false;
      }
    }
  }
  // Add this helper method to handle empty states
  private checkAndInitializeLanguageChart(): void {
    const hasData = this.languageBarChartData &&
      this.languageBarChartData.length > 0 &&
      this.languageBarChartData.some(item => item.value > 0);

    if (!hasData) {
      this.showLanguageBarChart = false;
      const canvas = document.getElementById('languageBarChart') as HTMLCanvasElement;
      if (canvas) {
        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.clearRect(0, 0, canvas.width, canvas.height);

          // Optional: Display "No Data" message
          ctx.fillStyle = '#999';
          ctx.font = '16px Arial';
          ctx.textAlign = 'center';
          ctx.fillText('No Language Data Available', canvas.width / 2, canvas.height / 2);
        }
      }
    }
  }

  // Update the language percentage method
  getLanguagePercentage(item: any): string {
    if (!item || !this.languageBarChartData || this.languageBarChartData.length === 0) {
      return '0';
    }

    const total = this.languageBarChartData.reduce((sum, dataItem) => {
      return sum + (dataItem?.value || 0);
    }, 0);

    return total > 0 ? (((item.value || 0) / total) * 100).toFixed(1) : '0';
  }

  // Helper method to darken colors for borders
  private darkenColor(color: string, percent: number): string {
    const num = parseInt(color.replace("#", ""), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) - amt;
    const G = (num >> 8 & 0x00FF) - amt;
    const B = (num & 0x0000FF) - amt;

    return "#" + (
      0x1000000 +
      (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
      (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
      (B < 255 ? B < 1 ? 0 : B : 255)
    ).toString(16).slice(1);
  }

  // NEW Simple Filter Methods
  showNewLanguageFilter: boolean = false;

  toggleNewLanguageFilter(): void {
    this.showNewLanguageFilter = !this.showNewLanguageFilter;

    if (this.showNewLanguageFilter) {
      // Initialize filtered lists
      this.filteredCourseList = [...this.courseList];
      this.filteredLanguageList = [...this.languagesData];
    }
  }

  closeNewLanguageFilter(): void {
    this.showNewLanguageFilter = false;
  }

  applyLanguageFilters(): void {
    this.closeNewLanguageFilter();
    this.updateLanguageFilteredData();
  }

  clearLanguageFilters(): void {
    this.selectedCourseIds = [];
    this.selectedLanguages = [];
    this.selectedLanguageTypes = [];
    this.selectedLanguageDifficultyLevels = [];
    this.selectedLanguageEvaluationModes = [];
    this.languageTypeSearchTerm = '';
    this.languageDifficultySearchTerm = '';
    this.languageEvaluationModeSearchTerm = '';
    this.filteredLanguageTypeList = [...this.availableQuestionTypes];
    this.filteredLanguageDifficultyLevels = [...this.availableLanguageDifficultyLevels];
    this.filteredLanguageEvaluationModesList = [...this.availableLanguageEvaluationModes];
    this.closeNewLanguageFilter();
    this.updateLanguageFilteredData();
  }
  toggleLanguageFilterPanel(): void {
    this.showLanguageFilterPanel = !this.showLanguageFilterPanel;

    if (this.showLanguageFilterPanel) {
      this.showLanguageChartMenu = false; // Close menu when opening filter
      // Initialize filtered lists when opening panel
      this.filteredCourseList = [...this.courseList];
      this.filteredLanguageList = [...this.languagesData];
      this.filteredLanguageTypeList = [...this.availableQuestionTypes];
      this.filteredLanguageDifficultyLevels = [...this.availableLanguageDifficultyLevels];
      this.filteredLanguageEvaluationModesList = [...this.availableLanguageEvaluationModes];
      this.activeLanguageFilterHeader = 'courses'; // Default to courses tab
      // Force change detection
      this.cdr.detectChanges();
    }
  }

  setActiveLanguageFilterHeader(headerKey: string): void {
    this.activeLanguageFilterHeader = headerKey;
  }

  // Language selection methods
  isLanguageSelected(languageCode: string): boolean {
    return this.selectedLanguages.includes(languageCode);
  }
  toggleLanguageSelection(languageCode: string): void {
    const index = this.selectedLanguages.indexOf(languageCode);
    if (index > -1) {
      this.selectedLanguages.splice(index, 1);
    } else {
      this.selectedLanguages.push(languageCode);
    }
    this.updateLanguageFilteredData();
  }

  filterLanguageTypes(): void {
    if (!this.languageTypeSearchTerm.trim()) {
      this.filteredLanguageTypeList = [...this.availableQuestionTypes];
      return;
    }

    const searchTerm = this.languageTypeSearchTerm.toLowerCase().trim();
    this.filteredLanguageTypeList = this.availableQuestionTypes.filter(type =>
      type.label.toLowerCase().includes(searchTerm)
    );
  }

  isLanguageTypeSelected(typeCode: string): boolean {
    return this.selectedLanguageTypes.includes(typeCode);
  }

  toggleLanguageTypeSelection(typeCode: string): void {
    const index = this.selectedLanguageTypes.indexOf(typeCode);
    if (index > -1) {
      this.selectedLanguageTypes.splice(index, 1);
    } else {
      this.selectedLanguageTypes.push(typeCode);
    }
    this.updateLanguageFilteredData();
  }

  filterLanguageEvaluationModes(): void {
    if (!this.languageEvaluationModeSearchTerm.trim()) {
      this.filteredLanguageEvaluationModesList = [...this.availableLanguageEvaluationModes];
      return;
    }

    const searchTerm = this.languageEvaluationModeSearchTerm.toLowerCase().trim();
    this.filteredLanguageEvaluationModesList = this.availableLanguageEvaluationModes.filter(mode =>
      mode.toLowerCase().includes(searchTerm)
    );
  }

  toggleLanguageEvaluationModeSelection(mode: string): void {
    const index = this.selectedLanguageEvaluationModes.indexOf(mode);
    if (index > -1) {
      this.selectedLanguageEvaluationModes.splice(index, 1);
    } else {
      this.selectedLanguageEvaluationModes.push(mode);
    }
    this.updateLanguageFilteredData();
  }

  filterLanguageDifficultyLevels(): void {
    if (!this.languageDifficultySearchTerm.trim()) {
      this.filteredLanguageDifficultyLevels = [...this.availableLanguageDifficultyLevels];
      return;
    }

    const searchTerm = this.languageDifficultySearchTerm.toLowerCase().trim();
    this.filteredLanguageDifficultyLevels = this.availableLanguageDifficultyLevels.filter(level =>
      level.label.toLowerCase().includes(searchTerm)
    );
  }

  isLanguageDifficultySelected(levelCode: string): boolean {
    return this.selectedLanguageDifficultyLevels.includes(levelCode);
  }

  toggleLanguageDifficultySelection(levelCode: string): void {
    const index = this.selectedLanguageDifficultyLevels.indexOf(levelCode);
    if (index > -1) {
      this.selectedLanguageDifficultyLevels.splice(index, 1);
    } else {
      this.selectedLanguageDifficultyLevels.push(levelCode);
    }
    this.updateLanguageFilteredData();
  }

  areAllLanguagesSelected(): boolean {
    return this.selectedLanguages.length === this.languagesData.length;
  }

  toggleAllLanguagesSelection(): void {
    if (this.areAllLanguagesSelected()) {
      this.selectedLanguages = [];
    } else {
      this.selectedLanguages = this.languagesData.map(lang => lang.code);
    }
    this.updateLanguageFilteredData();
  }

  isLanguagesSelectionIndeterminate(): boolean {
    return this.selectedLanguages.length > 0 &&
      this.selectedLanguages.length < this.languagesData.length;
  }

  // Add these properties
  typeCourseSearchTerm: string = '';
  questionTypeSearchTerm: string = '';
  filteredTypeCourseList: any[] = [];
  filteredQuestionTypeList: any[] = [];

  // Initialize type data
  private initializeTypeData(): void {
    const currentMonth = new Date().getMonth() + 1;
    if (currentMonth >= 4) { // April onwards - current year to next year
      this.selectedTypeYearRange = `${new Date().getFullYear()}-${(new Date().getFullYear() + 1).toString().slice(2)}`;
    } else { // January to March - previous year to current year
      this.selectedTypeYearRange = `${new Date().getFullYear() - 1}-${new Date().getFullYear().toString().slice(2)}`;
    }

    // Set default month to current month
    this.selectedTypeMonth = new Date().getMonth() + 1;

    // Initialize filter lists
    this.filteredTypeEvaluationModesList = [...this.availableTypeEvaluationModes];
    this.filteredTypeDifficultyLevels = [...this.availableTypeDifficultyLevels];
  }

  // Prepare type data for bar chart
  private prepareTypeData(courses: any[]): void {
    if (courses.length === 0) {
      this.typeBarChartData = [];
      this.showTypeBarChart = false;
      return;
    }

    // Reset data
    this.typeBarChartData = [];

    // Check if we should show overall type or course-wise
    if (this.shouldShowOverallType()) {
      this.prepareOverallTypeData(courses);
    } else {
      this.prepareMultipleCoursesTypeData(courses);
    }

    // Filter out zero values and undefined data
    this.typeBarChartData = this.typeBarChartData.filter(item =>
      item && item.value > 0 && item.name && item.name !== 'undefined'
    );

    this.showTypeBarChart = this.typeBarChartData.length > 0;

    if (this.showTypeBarChart) {
      setTimeout(() => {
        this.initializeTypeBarChart();
      }, 100);
    }
  }

  private prepareOverallTypeData(courses: any[]): void {

    // Aggregate type counts across all selected courses
    const typeTotals = {
      'mcq': 0,
      'true_false': 0,
      'fill_blanks': 0,
      'matching': 0,
      'subjective': 0,
      'scenario_based': 0,
      'multi_select': 0,
      'activity_performance': 0,
      'audio_video': 0,
      'live_viva': 0,
      'file_submission': 0
    };

    courses.forEach(course => {
      if (course.type_breakdown) {
        Object.keys(typeTotals).forEach(type => {
          typeTotals[type] += course.type_breakdown[type] || 0;
        });
      }
    });

    // Define colors for types
    const typeColors = {
      'mcq': '#001141',
      'true_false': '#001d6c',
      'fill_blanks': '#002d9c',
      'matching': '#0043ce',
      'subjective': '#0f62fe',
      'scenario_based': '#4589ff',
      'multi_select': '#78a9ff',
      'activity_performance': '#a6c8ff',
      'audio_video': '#d0e2ff',
      'live_viva': '#edf5ff',
      'file_submission': '#EEF6FF'
    };

    // Create chart data for overall type
    Object.entries(typeTotals).forEach(([typeCode, count]) => {
      if (count > 0) {
        const typeName = this.getTypeName(typeCode);
        this.typeBarChartData.push({
          name: typeName,
          value: count,
          color: typeColors[typeCode],
          courseName: 'All Courses',
          originalCourseName: 'All Courses',
          courseId: 0,
          typeCode: typeCode
        });
      }
    });
  }

  private prepareMultipleCoursesTypeData(courses: any[]): void {

    // Vibrant colors for different courses
    const courseColors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9',
      '#F8B195', '#F67280', '#C06C84', '#6C5B7B', '#355C7D',
      '#99B898', '#FECEAB', '#FF847C', '#E84A5F', '#2A363B'
    ];

    courses.forEach((course, courseIndex) => {
      const courseColor = courseColors[courseIndex % courseColors.length];
      const courseName = course.course_name || `Course ${courseIndex + 1}`;
      // Safely get type breakdown
      const typeBreakdown = course.type_breakdown || {};

      // Add each type for this course
      Object.entries(typeBreakdown).forEach(([typeCode, count]) => {
        if ((count as number) > 0) {
          const uniqueColor = this.generateUniqueColor(courseColor, typeCode);
          const typeName = this.getTypeName(typeCode);

          this.typeBarChartData.push({
            name: typeName,
            value: count,
            color: uniqueColor,
            courseName: courseName,
            originalCourseName: course.course_name,
            courseId: course.course_id,
            typeCode: typeCode,
            courseColor: courseColor
          });
        }
      });
    });
  }

  private getTypeName(typeCode: string): string {
    const type = this.availableQuestionTypes.find(t => t.value === typeCode);
    return type ? type.label : typeCode;
  }

  private getTypeShortName(typeCode: string): string {
    const shortNames: { [key: string]: string } = {
      mcq: 'MCQ',
      true_false: 'True/False',
      fill_blanks: 'Fill',
      matching: 'Match',
      subjective: 'Subjective',
      scenario_based: 'Scenario',
      multi_select: 'Multi',
      activity_performance: 'Activity',
      audio_video: 'Audio',
      live_viva: 'Live',
      file_submission: 'File'
    };
    return shortNames[typeCode] || this.getTypeName(typeCode);
  }

  private initializeTypeBarChart(): void {
    const canvas = document.getElementById('typeBarChart') as HTMLCanvasElement;

    if (!canvas) {
      return;
    }

    // Destroy existing chart if it exists
    if (this.typeBarChart) {
      this.typeBarChart.destroy();
    }

    // Filter out zero values and invalid data
    const nonZeroData = this.typeBarChartData.filter(item =>
      item && item.value > 0 && item.name && item.name !== 'undefined'
    );

    if (nonZeroData.length === 0) {
      this.showTypeBarChart = false;

      // Clear canvas
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
      return;
    }

    this.showTypeBarChart = true;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      try {
        // Prepare chart data
        const labels = nonZeroData.map(item => {
          const typeLabel = this.getTypeShortName(item.typeCode);
          if (this.shouldShowOverallType()) {
            return typeLabel; // Just short type name for overall
          } else {
            return `${this.truncateCourseName(item.courseName)} - ${typeLabel}`; // Course + short type
          }
        });

        const data = nonZeroData.map(item => item.value);
        const backgroundColors = nonZeroData.map(item => item.color);

        this.typeBarChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: labels,
            datasets: [{
              label: 'Question Count',
              data: data,
              backgroundColor: backgroundColors,
              borderColor: backgroundColors.map(color => this.darkenColor(color, 20)),
              borderWidth: 1,
              borderRadius: 4,
              borderSkipped: false,
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  label: (context) => {
                    const value = context.raw as number;
                    const total = data.reduce((sum, val) => sum + val, 0);
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                    return `${context.label}: ${value} (${percentage}%)`;
                  }
                }
              },
            },
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Number of Questions',
                  font: {
                    size: 12,
                    weight: 'bold'
                  }
                },
                grid: {
                  color: 'rgba(0,0,0,0.1)'
                },
                ticks: {
                  stepSize: 1,
                  precision: 0
                }
              },
              x: {
                type: 'category',
                title: {
                  display: false,
                  text: 'Question Types',
                  font: {
                    size: 12,
                    weight: 'bold'
                  }
                },
                grid: {
                  display: false
                },
                ticks: {
                  autoSkip: false,
                  maxRotation: 45,
                  minRotation: 45,
                  padding: 10,
                  font: {
                    size: 10
                  },
                  callback: (value: any) => {
                    let label = '';
                    if (typeof value === 'number' && this.typeBarChart?.data?.labels?.[value] !== undefined) {
                      label = String(this.typeBarChart.data.labels[value]);
                    } else {
                      label = String(value || '');
                    }
                    return this.wrapTextLabel(label, 12);
                  }
                }
              }
            },
            // Remove barPercentage and categoryPercentage from dataset level
            // and control spacing through layout and scales
            layout: {
              padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
              }
            },
            animation: {
              duration: 1000,
              easing: 'easeOutQuart'
            }
          }
        });
      } catch (error) {
        this.showTypeBarChart = false;
      }
    }
  }

  private wrapTextLabel(label: string, maxChars: number): string[] {
    if (!label) {
      return [''];
    }

    const words = label.split(' ');
    const lines: string[] = [];
    let currentLine = '';

    words.forEach(word => {
      if ((currentLine + (currentLine ? ' ' : '') + word).length <= maxChars) {
        currentLine += (currentLine ? ' ' : '') + word;
      } else {
        if (currentLine) {
          lines.push(currentLine);
        }
        currentLine = word;
      }
    });

    if (currentLine) {
      lines.push(currentLine);
    }

    return lines;
  }
  // Filter Panel Methods
  toggleTypeFilterPanel(): void {
    this.showTypeFilterPanel = !this.showTypeFilterPanel;

    if (this.showTypeFilterPanel) {
      this.showTypeChartMenu = false; // Close menu when opening filter
      // Initialize filtered lists when opening panel
      this.filteredTypeCourseList = [...this.courseList];
      this.filteredQuestionTypeList = [...this.availableQuestionTypes];
      this.activeTypeFilterHeader = 'courses'; // Default to courses tab
      // Force change detection
      this.cdr.detectChanges();
    }
  }

  setActiveTypeFilterHeader(headerKey: string): void {
    this.activeTypeFilterHeader = headerKey;
  }

  clearTypeFilters(): void {
    this.selectedTypeCourseIds = [];
    this.selectedQuestionTypes = [];
    this.selectedTypeLanguages = [];
    this.selectedTypeEvaluationModes = [];
    this.selectedTypeDifficultyLevels = [];
    this.typeCourseSearchTerm = '';
    this.questionTypeSearchTerm = '';
    this.typeLanguageSearchTerm = '';
    this.typeEvaluationModeSearchTerm = '';
    this.typeDifficultyLevelSearchTerm = '';
    this.filteredTypeCourseList = [...this.courseList];
    this.filteredQuestionTypeList = [...this.availableQuestionTypes];
    this.filteredTypeLanguagesList = [...this.languagesData];
    this.filteredTypeEvaluationModesList = [...this.availableTypeEvaluationModes];
    this.filteredTypeDifficultyLevels = [...this.availableTypeDifficultyLevels];
    this.updateTypeFilteredData();
  }

  // Course selection methods for type chart
  isCourseSelectedForType(courseId: number): boolean {
    return this.selectedTypeCourseIds.includes(courseId);
  }

  toggleCourseSelectionForType(courseId: number): void {
    const index = this.selectedTypeCourseIds.indexOf(courseId);
    if (index > -1) {
      this.selectedTypeCourseIds.splice(index, 1);
    } else {
      this.selectedTypeCourseIds.push(courseId);
    }
    this.updateTypeFilteredData();
  }

  areAllCoursesSelectedForType(): boolean {
    if (this.courseList.length === 0) return false;
    return this.selectedTypeCourseIds.length === this.courseList.length;
  }

  toggleAllCoursesSelectionForType(): void {
    if (this.areAllCoursesSelectedForType()) {
      this.selectedTypeCourseIds = [];
    } else {
      this.selectedTypeCourseIds = this.courseList.map(course => course.course_id);
    }
    this.updateTypeFilteredData();
  }

  isCoursesSelectionIndeterminateForType(): boolean {
    return this.selectedTypeCourseIds.length > 0 &&
      this.selectedTypeCourseIds.length < this.courseList.length;
  }

  // Question Type selection methods
  isQuestionTypeSelectedForType(typeCode: string): boolean {
    return this.selectedQuestionTypes.includes(typeCode);
  }

  toggleQuestionTypeSelectionForType(typeCode: string): void {
    const index = this.selectedQuestionTypes.indexOf(typeCode);
    if (index > -1) {
      this.selectedQuestionTypes.splice(index, 1);
    } else {
      this.selectedQuestionTypes.push(typeCode);
    }
    this.updateTypeFilteredData();
  }

  areAllQuestionTypesSelectedForType(): boolean {
    return this.selectedQuestionTypes.length === this.availableQuestionTypes.length;
  }

  toggleAllQuestionTypesSelectionForType(): void {
    if (this.areAllQuestionTypesSelectedForType()) {
      this.selectedQuestionTypes = [];
    } else {
      this.selectedQuestionTypes = this.availableQuestionTypes.map(type => type.value);
    }
    this.updateTypeFilteredData();
  }

  isQuestionTypesSelectionIndeterminateForType(): boolean {
    return this.selectedQuestionTypes.length > 0 &&
      this.selectedQuestionTypes.length < this.availableQuestionTypes.length;
  }

  filterTypeLanguages(): void {
    if (!this.typeLanguageSearchTerm.trim()) {
      this.filteredTypeLanguagesList = [...this.languagesData];
      return;
    }

    const searchTerm = this.typeLanguageSearchTerm.toLowerCase().trim();
    this.filteredTypeLanguagesList = this.languagesData.filter(language =>
      language.name.toLowerCase().includes(searchTerm)
    );
  }

  toggleTypeLanguageFilter(languageName: string): void {
    const index = this.selectedTypeLanguages.indexOf(languageName);
    if (index > -1) {
      this.selectedTypeLanguages.splice(index, 1);
    } else {
      this.selectedTypeLanguages.push(languageName);
    }
    this.updateTypeFilteredData();
  }

  // Questions by Type Chart Methods
  initializeQuestionsByTypeChart(): void {
    const canvas = document.getElementById('questionsByTypeChart') as HTMLCanvasElement;

    if (!canvas) {
      return;
    }

    // Destroy existing chart if it exists
    if (this.questionsByTypeChart) {
      this.questionsByTypeChart.destroy();
    }

    // Filter out zero values and invalid data
    const nonZeroData = this.questionsByTypeChartData.filter(item =>
      item && item.value > 0 && item.name && item.name !== 'undefined'
    );

    if (nonZeroData.length === 0) {
      this.showQuestionsByTypeChart = false;
      // Clear canvas
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
      return;
    }

    this.showQuestionsByTypeChart = true;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      try {
        // Prepare chart data
        const labels = nonZeroData.map(item => this.getTypeShortName(item.typeCode));
        const data = nonZeroData.map(item => item.value);
        const backgroundColors = nonZeroData.map(item => item.color);

        this.questionsByTypeChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: labels,
            datasets: [{
              label: 'Question Count',
              data: data,
              backgroundColor: backgroundColors,
              borderColor: backgroundColors.map(color => this.darkenColor(color, 20)),
              borderWidth: 1,
              borderRadius: 4,
              borderSkipped: false,
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  label: (context) => {
                    const value = context.raw as number;
                    const total = data.reduce((sum, val) => sum + val, 0);
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                    return `${context.label}: ${value} (${percentage}%)`;
                  }
                }
              },
            },
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Number of Questions',
                  font: {
                    size: 12,
                    weight: 'bold'
                  }
                },
                grid: {
                  color: 'rgba(0,0,0,0.1)'
                },
                ticks: {
                  stepSize: 1,
                  precision: 0
                }
              },
              x: {
                type: 'category',
                title: {
                  display: false,
                  text: 'Question Types',
                  font: {
                    size: 12,
                    weight: 'bold'
                  }
                },
                grid: {
                  display: false
                },
                ticks: {
                  autoSkip: false,
                  maxRotation: 45,
                  minRotation: 45,
                  padding: 10,
                  font: {
                    size: 10
                  }
                }
              }
            },
            layout: {
              padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
              }
            },
            animation: {
              duration: 1000,
              easing: 'easeOutQuart'
            }
          }
        });
      } catch (error) {
        this.showQuestionsByTypeChart = false;
      }
    }
  }

  toggleQuestionsByTypeChartMenu(): void {
    this.showQuestionsByTypeChartMenu = !this.showQuestionsByTypeChartMenu;
  }

  closeQuestionsByTypeChartMenu(): void {
    this.showQuestionsByTypeChartMenu = false;
  }

  openQuestionsByTypeTableModal(): void {
    this.showQuestionsByTypeTableModal = true;
  }

  closeQuestionsByTypeTableModal(): void {
    this.showQuestionsByTypeTableModal = false;
  }

  filterTypeEvaluationModes(): void {
    if (!this.typeEvaluationModeSearchTerm.trim()) {
      this.filteredTypeEvaluationModesList = [...this.availableTypeEvaluationModes];
      return;
    }

    const searchTerm = this.typeEvaluationModeSearchTerm.toLowerCase().trim();
    this.filteredTypeEvaluationModesList = this.availableTypeEvaluationModes.filter(mode =>
      mode.toLowerCase().includes(searchTerm)
    );
  }

  toggleTypeEvaluationModeFilter(mode: string): void {
    const index = this.selectedTypeEvaluationModes.indexOf(mode);
    if (index > -1) {
      this.selectedTypeEvaluationModes.splice(index, 1);
    } else {
      this.selectedTypeEvaluationModes.push(mode);
    }
    this.updateTypeFilteredData();
  }

  filterTypeDifficultyLevels(): void {
    if (!this.typeDifficultyLevelSearchTerm.trim()) {
      this.filteredTypeDifficultyLevels = [...this.availableTypeDifficultyLevels];
      return;
    }

    const searchTerm = this.typeDifficultyLevelSearchTerm.toLowerCase().trim();
    this.filteredTypeDifficultyLevels = this.availableTypeDifficultyLevels.filter(level =>
      level.label.toLowerCase().includes(searchTerm)
    );
  }

  toggleTypeDifficultyLevelFilter(level: string): void {
    const index = this.selectedTypeDifficultyLevels.indexOf(level);
    if (index > -1) {
      this.selectedTypeDifficultyLevels.splice(index, 1);
    } else {
      this.selectedTypeDifficultyLevels.push(level);
    }
    this.updateTypeFilteredData();
  }

  selectQuestionsByTypeDifficulty(difficulty: string): void {
    this.selectedQuestionsByTypeDifficulty = difficulty;
    this.prepareQuestionsByTypeData();
    // Force chart update
    setTimeout(() => {
      this.initializeQuestionsByTypeChart();
    }, 100);
  }

  // Update filtered data for type chart
  updateTypeFilteredData(): void {
    let filteredCourses = this.questionCounts.map(course => ({
      ...course,
      _originalTypeBreakdown: { ...course.type_breakdown },
      _originalLanguageBreakdown: { ...course.language_breakdown },
      _originalCategoryBreakdown: { ...course.question_category_breakdown }
    }));

    // Apply course filter
    if (this.selectedTypeCourseIds.length > 0) {
      filteredCourses = filteredCourses.filter(course =>
        this.selectedTypeCourseIds.includes(course.course_id)
      );
    }

    // Apply question type filter
    if (this.selectedQuestionTypes.length > 0) {
      filteredCourses = this.filterCoursesByQuestionType(filteredCourses);
    }

    // Apply language and evaluation mode filters
    if (this.selectedTypeLanguages.length > 0 && this.selectedTypeEvaluationModes.length > 0) {
      // Use combined filter when both are selected
      filteredCourses = this.filterCoursesByTypeLanguagesAndEvaluationModes(filteredCourses);
    } else {
      // Apply individually if only one is selected
      if (this.selectedTypeLanguages.length > 0) {
        filteredCourses = this.filterCoursesByTypeLanguages(filteredCourses);
      }

      if (this.selectedTypeEvaluationModes.length > 0) {
        filteredCourses = this.filterCoursesByTypeEvaluationModes(filteredCourses);
      }
    }

    // Apply difficulty level filter
    if (this.selectedTypeDifficultyLevels.length > 0) {
      filteredCourses = this.filterCoursesByTypeDifficultyLevels(filteredCourses);
    }

    this.prepareTypeData(filteredCourses);
    this.cdr.detectChanges();
  }

  prepareQuestionsByTypeData(): void {
    if (!this.questionCounts || this.questionCounts.length === 0) {
      this.questionsByTypeChartData = [];
      this.showQuestionsByTypeChart = false;
      return;
    }

    // Use all courses instead of filtering by difficulty
    const filteredCourses = this.questionCounts;

    if (filteredCourses.length === 0) {
      this.questionsByTypeChartData = [];
      this.showQuestionsByTypeChart = false;
      return;
    }

    // Aggregate type counts across filtered courses
    const typeTotals = {
      'mcq': 0,
      'true_false': 0,
      'fill_blanks': 0,
      'matching': 0,
      'subjective': 0,
      'scenario_based': 0,
      'multi_select': 0,
      'activity_performance': 0,
      'audio_video': 0,
      'live_viva': 0,
      'file_submission': 0
    };

    filteredCourses.forEach(course => {
      if (course.type_breakdown) {
        Object.keys(typeTotals).forEach(type => {
          typeTotals[type] += course.type_breakdown[type] || 0;
        });
      }
    });

    // Define colors for types
    const typeColors = {
      'mcq': '#001141',
      'true_false': '#001d6c',
      'fill_blanks': '#002d9c',
      'matching': '#0043ce',
      'subjective': '#0f62fe',
      'scenario_based': '#4589ff',
      'multi_select': '#78a9ff',
      'activity_performance': '#a6c8ff',
      'audio_video': '#d0e2ff',
      'live_viva': '#edf5ff',
      'file_submission': '#EEF6FF'
    };

    // Create chart data
    this.questionsByTypeChartData = [];
    Object.entries(typeTotals).forEach(([typeCode, count]) => {
      if (count > 0) {
        const typeName = this.getTypeName(typeCode);
        this.questionsByTypeChartData.push({
          name: typeName,
          value: count,
          color: typeColors[typeCode],
          typeCode: typeCode
        });
      }
    });

    // Prepare table data with language-wise breakdown
    this.allQuestionsByTypeData = [];
    const totalQuestions = Object.values(typeTotals).reduce((sum, count) => sum + count, 0);

    if (totalQuestions > 0) {
      this.languagesData.forEach(language => {
        // Calculate total questions for this language across filtered courses
        let languageTotal = 0;
        filteredCourses.forEach(course => {
          if (course.language_breakdown && course.language_breakdown[language.code]) {
            languageTotal += course.language_breakdown[language.code];
          }
        });

        if (languageTotal > 0) {
          const languageData: any = {
            language: language.name,
            total: languageTotal
          };

          // Calculate type counts proportionally
          Object.entries(typeTotals).forEach(([typeCode, totalCount]) => {
            const typeName = this.getTypeName(typeCode);
            languageData[typeName] = Math.round((languageTotal / totalQuestions) * totalCount);
          });

          this.allQuestionsByTypeData.push(languageData);
        }
      });
    }

    this.showQuestionsByTypeChart = this.questionsByTypeChartData.length > 0;
  }

  filterCoursesByTypeLanguages(courses: any[]): any[] {
    return courses.map(course => {
      const filteredCourse = { ...course };
      filteredCourse._originalTypeBreakdown = { ...course.type_breakdown }; // Store original for combined filtering

      if (filteredCourse.language_breakdown) {
        const filteredBreakdown: any = {};
        this.selectedTypeLanguages.forEach(language => {
          if (filteredCourse.language_breakdown[language] !== undefined) {
            filteredBreakdown[language] = Number(filteredCourse.language_breakdown[language]) || 0;
          }
        });

        const selectedLanguagesTotal = (Object.values(filteredBreakdown) as number[])
          .reduce((sum, value) => sum + value, 0);

        const totalLanguageQuestions = (Object.values(filteredCourse.language_breakdown) as any[])
          .reduce((sum: number, count) => sum + Number(count), 0);

        filteredCourse.language_breakdown = filteredBreakdown;
        filteredCourse.question_count = selectedLanguagesTotal;

        // Only scale type_breakdown if evaluation mode is NOT selected (will be handled by combined filter)
        if (this.selectedTypeEvaluationModes.length === 0 && selectedLanguagesTotal > 0 && totalLanguageQuestions > 0 && filteredCourse.type_breakdown) {
          const proportion: number = selectedLanguagesTotal / totalLanguageQuestions;
          const scaledTypeBreakdown: any = {};

          Object.keys(filteredCourse.type_breakdown).forEach((type: string) => {
            const originalCount = Number(filteredCourse.type_breakdown[type]) || 0;
            scaledTypeBreakdown[type] = Math.round(originalCount * proportion);
          });

          filteredCourse.type_breakdown = scaledTypeBreakdown;
          filteredCourse.question_count = Object.values(scaledTypeBreakdown)
            .reduce((sum: number, count: number) => sum + count, 0);
        }
      }

      return filteredCourse;
    }).filter(course => course.question_count > 0);
  }

  filterCoursesByTypeLanguagesAndEvaluationModes(courses: any[]): any[] {
    // Map of which question types belong to each evaluation mode
    const evaluationModeTypeMapping: { [key: string]: string[] } = {
      'Theory': ['mcq', 'true_false', 'fill_blanks', 'matching', 'subjective', 'scenario_based', 'multi_select'],
      'Practical': ['activity_performance', 'file_submission'],
      'Viva': ['audio_video', 'live_viva']
    };

    return courses.map(course => {
      const filteredCourse = { ...course };

      // Calculate language proportion
      if (filteredCourse.language_breakdown && this.selectedTypeLanguages.length > 0) {
        const languageFiltered: any = {};
        this.selectedTypeLanguages.forEach(language => {
          if (filteredCourse.language_breakdown[language] !== undefined) {
            languageFiltered[language] = Number(filteredCourse.language_breakdown[language]) || 0;
          }
        });
        filteredCourse.language_breakdown = languageFiltered;
      }

      // Calculate evaluation mode proportion
      if (filteredCourse.question_category_breakdown && this.selectedTypeEvaluationModes.length > 0) {
        const modeFiltered: any = {};
        this.selectedTypeEvaluationModes.forEach(mode => {
          if (filteredCourse.question_category_breakdown[mode] !== undefined) {
            modeFiltered[mode] = Number(filteredCourse.question_category_breakdown[mode]) || 0;
          }
        });
        filteredCourse.question_category_breakdown = modeFiltered;
      }

      // Calculate combined proportion and filter type_breakdown
      if (filteredCourse._originalTypeBreakdown || filteredCourse.type_breakdown) {
        const selectedLanguagesTotal = filteredCourse.language_breakdown ? 
          (Object.values(filteredCourse.language_breakdown) as number[]).reduce((sum, val) => sum + val, 0) : 
          (Object.values(filteredCourse._originalLanguageBreakdown || {}) as any[]).reduce((sum: number, val) => sum + Number(val), 0);

        const selectedModesTotal = filteredCourse.question_category_breakdown ? 
          (Object.values(filteredCourse.question_category_breakdown) as number[]).reduce((sum, val) => sum + val, 0) : 
          (Object.values(filteredCourse._originalCategoryBreakdown || {}) as any[]).reduce((sum: number, val) => sum + Number(val), 0);

        const totalLanguageQuestions = (Object.values(filteredCourse._originalLanguageBreakdown || filteredCourse.language_breakdown || {}) as any[])
          .reduce((sum: number, count) => sum + Number(count), 0);

        const totalCategoryQuestions = (Object.values(filteredCourse._originalCategoryBreakdown || filteredCourse.question_category_breakdown || {}) as any[])
          .reduce((sum: number, count) => sum + Number(count), 0);

        const originalTypeBreakdown = filteredCourse._originalTypeBreakdown || filteredCourse.type_breakdown;
        
        if (originalTypeBreakdown && selectedLanguagesTotal > 0 && selectedModesTotal > 0 && totalLanguageQuestions > 0 && totalCategoryQuestions > 0) {
          const languageProportion = selectedLanguagesTotal / totalLanguageQuestions;
          const modeProportion = selectedModesTotal / totalCategoryQuestions;
          const combinedProportion = languageProportion * modeProportion;

          // Get all types that belong to the selected evaluation modes
          const allowedTypes = new Set<string>();
          this.selectedTypeEvaluationModes.forEach(mode => {
            const typesForMode = evaluationModeTypeMapping[mode] || [];
            typesForMode.forEach(type => allowedTypes.add(type));
          });

          // Filter type_breakdown to only include types that belong to selected evaluation modes
          const filteredTypeBreakdown: any = {};
          Object.keys(originalTypeBreakdown).forEach((type: string) => {
            if (allowedTypes.has(type)) {
              const originalCount = Number(originalTypeBreakdown[type]) || 0;
              filteredTypeBreakdown[type] = Math.round(originalCount * combinedProportion);
            }
          });

          filteredCourse.type_breakdown = filteredTypeBreakdown;
          filteredCourse.question_count = Object.values(filteredTypeBreakdown)
            .reduce((sum: number, count: number) => sum + count, 0);
        }
      }

      return filteredCourse;
    }).filter(course => course.question_count > 0);
  }

  filterCoursesByTypeEvaluationModes(courses: any[]): any[] {
    // Map of which question types belong to each evaluation mode
    const evaluationModeTypeMapping: { [key: string]: string[] } = {
      'Theory': ['mcq', 'true_false', 'fill_blanks', 'matching', 'subjective', 'scenario_based', 'multi_select'],
      'Practical': ['activity_performance', 'file_submission'],
      'Viva': ['audio_video', 'live_viva']
    };

    return courses.map(course => {
      const filteredCourse = { ...course };

      if (filteredCourse.question_category_breakdown) {
        const filteredBreakdown: any = {};
        this.selectedTypeEvaluationModes.forEach(mode => {
          if (filteredCourse.question_category_breakdown[mode] !== undefined) {
            filteredBreakdown[mode] = Number(filteredCourse.question_category_breakdown[mode]) || 0;
          }
        });

        const selectedModesTotal = (Object.values(filteredBreakdown) as number[])
          .reduce((sum, value) => sum + value, 0);

        const totalCategoryQuestions = (Object.values(filteredCourse.question_category_breakdown) as any[])
          .reduce((sum: number, count) => sum + Number(count), 0);

        filteredCourse.question_category_breakdown = filteredBreakdown;
        filteredCourse.question_count = selectedModesTotal;

        // Get the original type_breakdown for filtering
        const originalTypeBreakdown = filteredCourse._originalTypeBreakdown || filteredCourse.type_breakdown;
        
        if (selectedModesTotal > 0 && originalTypeBreakdown) {
          // Get all types that belong to the selected evaluation modes
          const allowedTypes = new Set<string>();
          
          // 1. ALWAYS preserve explicitly selected Question Types
          if (this.selectedQuestionTypes && this.selectedQuestionTypes.length > 0) {
            this.selectedQuestionTypes.forEach(type => allowedTypes.add(type));
          }

          // 2. Add types for selected Evaluation Modes
          this.selectedTypeEvaluationModes.forEach(mode => {
            const typesForMode = evaluationModeTypeMapping[mode] || [];
            
            // Check if ANY type from this mode was explicitly selected in Question Type filter
            const hasSelectedTypesInMode = this.selectedQuestionTypes && 
                                           this.selectedQuestionTypes.length > 0 && 
                                           typesForMode.some(t => this.selectedQuestionTypes.includes(t));
            
            // If NO specific types from this mode were explicitly selected, allow ALL types for this mode
            if (!hasSelectedTypesInMode) {
              typesForMode.forEach(type => {
                allowedTypes.add(type);
              });
            }
          });

          // Filter type_breakdown to only include allowed types
          const filteredTypeBreakdown: any = {};
          Object.keys(originalTypeBreakdown).forEach((type: string) => {
            if (allowedTypes.has(type)) {
              const originalCount = Number(originalTypeBreakdown[type]) || 0;
              // Keep original count as per user request
              filteredTypeBreakdown[type] = originalCount;
            }
          });

          filteredCourse.type_breakdown = filteredTypeBreakdown;
          filteredCourse.question_count = Object.values(filteredTypeBreakdown)
            .reduce((sum: number, count: number) => sum + count, 0);
        }
      }

      return filteredCourse;
    }).filter(course => course.question_count > 0);
  }

  filterCoursesByTypeDifficultyLevels(courses: any[]): any[] {
    return courses.map(course => {
      const filteredCourse = { ...course };

      if (filteredCourse.difficulty_breakdown && filteredCourse.type_breakdown) {
        // Calculate difficulty proportions from the current difficulty_breakdown
        const totalDifficulty: number = (Object.values(filteredCourse.difficulty_breakdown) as any[])
          .reduce((sum: number, count: any) => sum + (Number(count) || 0), 0);
        
        const difficultyProportions: any = {};
        Object.entries(filteredCourse.difficulty_breakdown).forEach(([level, count]: [string, any]) => {
          difficultyProportions[level] = totalDifficulty > 0 ? (Number(count) || 0) / totalDifficulty : 0;
        });

        // Filter and recalculate type_breakdown based on selected difficulty levels
        const filteredTypeBreakdown: any = {};
        
        if (filteredCourse.type_difficulty_breakdown) {
          Object.entries(filteredCourse.type_difficulty_breakdown).forEach(([typeCode, difficultyObj]: [string, any]) => {
            if (filteredCourse.type_breakdown[typeCode] !== undefined) {
              const currentTypeCount = filteredCourse.type_breakdown[typeCode];
              const originalTypeCount = filteredCourse._originalTypeBreakdown ? (filteredCourse._originalTypeBreakdown[typeCode] || 0) : currentTypeCount;

              let typeCount = 0;
              this.selectedTypeDifficultyLevels.forEach(level => {
                if (difficultyObj[level] !== undefined) {
                  typeCount += Number(difficultyObj[level]) || 0;
                }
              });

              if (typeCount > 0) {
                if (originalTypeCount > 0 && currentTypeCount < originalTypeCount) {
                  const proportion = currentTypeCount / originalTypeCount;
                  typeCount = Math.round(typeCount * proportion);
                }

                if (typeCount > 0) {
                  filteredTypeBreakdown[typeCode] = typeCount;
                }
              }
            }
          });
        } else {
          // Fallback to proportional
          Object.entries(filteredCourse.type_breakdown).forEach(([typeCode, count]: [string, any]) => {
            let adjustedCount = 0;
            this.selectedTypeDifficultyLevels.forEach(level => {
              const proportion = difficultyProportions[level] || 0;
              adjustedCount += Math.round((Number(count) || 0) * proportion);
            });
            if (adjustedCount > 0) {
              filteredTypeBreakdown[typeCode] = adjustedCount;
            }
          });
        }

        // Also filter the difficulty_breakdown
        const filteredDifficultyBreakdown: any = {};
        this.selectedTypeDifficultyLevels.forEach(level => {
          if (filteredCourse.difficulty_breakdown[level] !== undefined) {
            filteredDifficultyBreakdown[level] = filteredCourse.difficulty_breakdown[level];
          }
        });

        filteredCourse.type_breakdown = filteredTypeBreakdown;
        filteredCourse.difficulty_breakdown = filteredDifficultyBreakdown;
        filteredCourse.question_count = (Object.values(filteredDifficultyBreakdown) as any[])
          .reduce((sum: number, count: any) => sum + (Number(count) || 0), 0);
      }

      return filteredCourse;
    }).filter(course => course.question_count > 0);
  }

  filterCoursesByQuestionType(courses: any[]): any[] {
    return courses.map(course => {
      const filteredCourse = { ...course };

      if (filteredCourse.type_breakdown) {
        const filteredBreakdown = {};
        this.selectedQuestionTypes.forEach(type => {
          if (filteredCourse.type_breakdown[type] !== undefined) {
            filteredBreakdown[type] = filteredCourse.type_breakdown[type];
          }
        });

        filteredCourse.type_breakdown = filteredBreakdown;
        filteredCourse.question_count = Object.values(filteredBreakdown)
          .reduce((sum: number, count: number) => sum + count, 0);

        // Generate type_difficulty_breakdown for the selected question types
        if (filteredCourse.type_difficulty_breakdown && filteredCourse.difficulty_breakdown) {
          const typeDifficultyBreakdown: any = {};
          
          // Initialize with selected types
          this.selectedQuestionTypes.forEach(type => {
            if (filteredCourse.type_difficulty_breakdown[type]) {
              typeDifficultyBreakdown[type] = filteredCourse.type_difficulty_breakdown[type];
            }
          });
          
          // Aggregate difficulty levels across selected types
          const aggregatedTypeDifficulty = {
            easy: 0,
            medium: 0,
            hard: 0
          };
          
          this.selectedQuestionTypes.forEach(type => {
            if (filteredCourse.type_difficulty_breakdown[type]) {
              const typeData = filteredCourse.type_difficulty_breakdown[type];
              aggregatedTypeDifficulty.easy += (typeData.easy || 0);
              aggregatedTypeDifficulty.medium += (typeData.medium || 0);
              aggregatedTypeDifficulty.hard += (typeData.hard || 0);
            }
          });
          
          filteredCourse._type_difficulty_breakdown = aggregatedTypeDifficulty;
        }
      }

      return filteredCourse;
    }).filter(course => course.question_count > 0);
  }

  // Filter search methods
  filterTypeCourses(): void {
    if (!this.typeCourseSearchTerm.trim()) {
      this.filteredTypeCourseList = [...this.courseList];
      return;
    }

    const searchTerm = this.typeCourseSearchTerm.toLowerCase().trim();
    this.filteredTypeCourseList = this.courseList.filter(course =>
      course.course_name.toLowerCase().includes(searchTerm)
    );
  }

  filterQuestionTypes(): void {
    if (!this.questionTypeSearchTerm.trim()) {
      this.filteredQuestionTypeList = [...this.availableQuestionTypes];
      return;
    }

    const searchTerm = this.questionTypeSearchTerm.toLowerCase().trim();
    this.filteredQuestionTypeList = this.availableQuestionTypes.filter(type =>
      type.label.toLowerCase().includes(searchTerm)
    );
  }

  // Helper methods
  getTypeFilterHeaderCount(headerKey: string): number {
    switch (headerKey) {
      case 'courses':
        return this.selectedTypeCourseIds.length;
      case 'questionTypes':
        return this.selectedQuestionTypes.length;
      default:
        return 0;
    }
  }

  getTypePercentage(item: any): string {
    if (!item || !this.typeBarChartData || this.typeBarChartData.length === 0) {
      return '0';
    }

    const total = this.typeBarChartData.reduce((sum, dataItem) => {
      return sum + (dataItem?.value || 0);
    }, 0);

    return total > 0 ? (((item.value || 0) / total) * 100).toFixed(1) : '0';
  }

  private shouldShowOverallType(): boolean {
    const hasCourseFilter = this.selectedTypeCourseIds.length > 0;
    const hasTypeFilter = this.selectedQuestionTypes.length > 0;

    if (!hasCourseFilter) {
      return true;
    }

    if (this.selectedTypeCourseIds.length === this.courseList.length) {
      return true;
    }

    if (this.selectedTypeCourseIds.length === 1) {
      return false;
    }

    if (this.selectedTypeCourseIds.length > 5) {
      return true;
    }

    return false;
  }

  // Difficulty Level Chart Filter Methods (Independent)
  toggleDifficultyYearDropdown(): void {
    this.showDifficultyYearDropdown = !this.showDifficultyYearDropdown;
    if (this.showDifficultyYearDropdown) {
      this.showDifficultyMonthDropdown = false;
    }
  }

  selectDifficultyYearRange(yearRange: string): void {
    this.selectedDifficultyYearRange = yearRange;
    this.showDifficultyYearDropdown = false;
    this.applyDifficultyMonthYearFilter();
  }

  toggleDifficultyMonthDropdown(): void {
    this.showDifficultyMonthDropdown = !this.showDifficultyMonthDropdown;
    if (this.showDifficultyMonthDropdown) {
      this.showDifficultyYearDropdown = false;
    }
  }

  selectDifficultyMonth(month: number): void {
    this.selectedDifficultyMonth = month;
    this.showDifficultyMonthDropdown = false;
    this.applyDifficultyMonthYearFilter();
  }

  applyDifficultyMonthYearFilter(): void {
    this.showDifficultyYearDropdown = false;
    this.showDifficultyMonthDropdown = false;

    // Fetch data with difficulty-specific filters
    this.fetchDifficultyFilteredData();
  }

  private fetchDifficultyFilteredData(): void {
    this.isLoading = true;

    let startDate: Date;
    let endDate: Date;

    if (this.selectedDifficultyMonth) {
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedDifficultyYearRange);
      if (yearRange) {
        const year = this.selectedDifficultyMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedDifficultyMonth - 1, 1);
        endDate = new Date(year, this.selectedDifficultyMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedDifficultyMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedDifficultyMonth, 0);
      }
    } else {
      const dateRange = this.getDateRangeFromYearRange(this.selectedDifficultyYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

    const resp = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          // Extract ONLY question counts - don't call processLibraryData() which updates ALL charts
          this.extractQuestionCountsFromResponse(response);
          // Prepare ONLY difficulty data - preserve independence of other charts
          this.prepareDifficultyData(this.questionCounts);
          this.isLoading = false;
          this.cdr.detectChanges();
        } else {
          this.isLoading = false;
        }
      },
      (error: any) => {
        this.isLoading = false;
      }
    );
  }

  // Dropdown methods
  toggleTypeYearDropdown(): void {
    this.showTypeYearDropdown = !this.showTypeYearDropdown;
    if (this.showTypeYearDropdown) {
      this.showTypeMonthDropdown = false;
    }
  }

  selectTypeYearRange(yearRange: string): void {
    this.selectedTypeYearRange = yearRange;
    this.showTypeYearDropdown = false;
    this.applyTypeMonthYearFilter();
  }

  toggleTypeMonthDropdown(): void {
    this.showTypeMonthDropdown = !this.showTypeMonthDropdown;
    if (this.showTypeMonthDropdown) {
      this.showTypeYearDropdown = false;
    }
  }

  selectTypeMonth(month: number): void {
    this.selectedTypeMonth = month;
    this.showTypeMonthDropdown = false;
    this.applyTypeMonthYearFilter();
  }

  applyTypeMonthYearFilter(): void {
    this.showTypeYearDropdown = false;
    this.showTypeMonthDropdown = false;

    // Fetch data with type-specific filters
    this.fetchTypeFilteredData();
  }

  private fetchTypeFilteredData(): void {
    this.isLoading = true;

    let startDate: Date;
    let endDate: Date;

    if (this.selectedTypeMonth) {
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedTypeYearRange);
      if (yearRange) {
        const year = this.selectedTypeMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedTypeMonth - 1, 1);
        endDate = new Date(year, this.selectedTypeMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedTypeMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedTypeMonth, 0);
      }
    } else {
      const dateRange = this.getDateRangeFromYearRange(this.selectedTypeYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

    const resp = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          // Extract ONLY question counts - don't call processLibraryData() which updates ALL charts
          this.extractQuestionCountsFromResponse(response);
          // Prepare ONLY type data - preserve independence of other charts
          this.prepareTypeData(this.questionCounts);
          this.isLoading = false;
          this.cdr.detectChanges();
        } else {
          this.typeBarChartData = [];
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.typeBarChartData = [];
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  // Chart menu methods
  toggleTypeChartMenu(): void {
    this.showTypeChartMenu = !this.showTypeChartMenu;
    if (this.showTypeChartMenu) {
      this.showTypeFilterPanel = false; // Close filter when opening menu
    }
  }

  closeTypeChartMenu(): void {
    this.showTypeChartMenu = false;
  }


  // Export methods for Type Chart
  exportTypeChartAsPDF(): void {
    this.closeTypeChartMenu();
    if (!this.ensureHasData(this.typeBarChartData)) { return; }

    if (this.typeBarChart) {
      const canvas = this.typeBarChart.canvas;
      const chartImage = canvas.toDataURL('image/png');

      // Create PDF with proper layout
      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Add title
      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');

      const chartTitle = this.shouldShowOverallType()
        ? 'Overall Question Type Distribution'
        : 'Course-wise Question Type Distribution';

      // Center the title
      const titleWidth = pdf.getTextWidth(chartTitle);
      const titleX = (pageWidth - titleWidth) / 2;
      pdf.text(chartTitle, titleX, 25);

      // Add source/subtitle
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      const subtitle = 'Source: Content Library Analytics';
      const subtitleWidth = pdf.getTextWidth(subtitle);
      const subtitleX = (pageWidth - subtitleWidth) / 2;
      pdf.text(subtitle, subtitleX, 32);

      // Add separator line
      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      // Add chart image at the top left
      const imgProps = pdf.getImageProperties(chartImage);
      const chartWidth = pageWidth * 0.45;
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      const chartX = 20;
      const chartY = 45;

      pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

      // Add Color Legends beside the chart (right side)
      const legendsX = chartX + chartWidth + 10;
      const legendsStartY = chartY;

      // Color Legends Title
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Color Legend', legendsX, legendsStartY);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      let currentLegendY = legendsStartY + 15;

      // Get unique courses and their colors
      const courseColors = new Map();
      const nonZeroData = this.typeBarChartData.filter(item => item.value > 0);

      nonZeroData.forEach(item => {
        if (!courseColors.has(item.courseName)) {
          courseColors.set(item.courseName, item.color);
        }
      });

      // Add course color legends with proper text wrapping
      const maxLegendWidth = pageWidth - legendsX - 15;

      courseColors.forEach((color, courseName) => {
        // Draw color box
        const rgb = this.hexToRgb(color);
        pdf.setFillColor(rgb.r, rgb.g, rgb.b);
        pdf.rect(legendsX, currentLegendY - 3, 10, 10, 'F');

        // Draw border around color box
        pdf.setDrawColor(100, 100, 100);
        pdf.rect(legendsX, currentLegendY - 3, 10, 10);

        // Course name with text wrapping
        const maxTextWidth = maxLegendWidth - 15;
        const lines = pdf.splitTextToSize(courseName, maxTextWidth);

        // Draw each line of the course name
        lines.forEach((line: string, index: number) => {
          pdf.text(line, legendsX + 15, currentLegendY + (index * 4));
        });

        // Move Y position based on number of lines
        currentLegendY += (lines.length * 4) + 8;
      });

      // Calculate position for distribution summary
      const chartBottom = chartY + chartHeight;
      const legendsBottom = currentLegendY;
      const summaryStartY = Math.max(chartBottom, legendsBottom) + 20;

      // Add Distribution Summary title
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Distribution Summary', 20, summaryStartY);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      let currentY = summaryStartY + 15;

      // Calculate totals and percentages
      const totalQuestions = this.typeBarChartData.reduce((sum, item) => sum + item.value, 0);

      if (this.shouldShowOverallType()) {
        // Show overall type breakdown in a single column
        pdf.setFont('helvetica', 'bold');
        pdf.text('Overall Type Breakdown:', 20, currentY);
        currentY += 8;

        pdf.setFont('helvetica', 'normal');
        nonZeroData.forEach(item => {
          const percentage = this.getTypePercentage(item);
          pdf.text(`${item.name}: ${item.value} (${percentage}%)`, 25, currentY);
          currentY += 5;
        });
      } else {
        // Show course-wise breakdown in multiple columns
        const coursesMap = new Map();
        nonZeroData.forEach(item => {
          if (!coursesMap.has(item.courseName)) {
            coursesMap.set(item.courseName, []);
          }
          coursesMap.get(item.courseName).push(item);
        });

        const coursesArray = Array.from(coursesMap.entries());
        const coursesPerRow = 2;
        const courseWidth = (pageWidth - 60) / coursesPerRow;

        // Add course-wise breakdown in grid layout
        for (let i = 0; i < coursesArray.length; i += coursesPerRow) {
          const rowCourses = coursesArray.slice(i, i + coursesPerRow);

          let maxCourseHeight = 0;

          // Process each course in the current row
          rowCourses.forEach(([courseName, types], courseIndex) => {
            const courseX = 20 + (courseIndex * courseWidth);
            let courseY = currentY;

            // Course name with background and text wrapping
            pdf.setFont('helvetica', 'bold');
            pdf.setFillColor(245, 245, 245);

            // Wrap course name to fit within course width
            const courseNameLines = pdf.splitTextToSize(courseName, courseWidth - 20);
            const courseNameHeight = courseNameLines.length * 4 + 6;

            // Draw background for course name
            pdf.rect(courseX, courseY - 5, courseWidth - 15, courseNameHeight, 'F');

            // Draw colored border on left
            const rgb = this.hexToRgb(courseColors.get(courseName));
            pdf.setFillColor(rgb.r, rgb.g, rgb.b);
            pdf.rect(courseX, courseY - 5, 4, courseNameHeight, 'F');

            // Reset fill color for text
            pdf.setFillColor(0, 0, 0);

            // Draw course name lines
            courseNameLines.forEach((line: string, lineIndex: number) => {
              pdf.text(line, courseX + 8, courseY + (lineIndex * 4));
            });

            courseY += courseNameHeight + 8;

            pdf.setFont('helvetica', 'normal');

            // Add types for this course
            types.forEach(item => {
              const percentage = this.getTypePercentage(item);
              const typeText = `${item.name}: ${item.value} (${percentage}%)`;

              pdf.text(typeText, courseX + 8, courseY);
              courseY += 5;
            });

            // Update max height for this row
            const courseHeight = courseY - currentY;
            if (courseHeight > maxCourseHeight) {
              maxCourseHeight = courseHeight;
            }
          });

          // Move to next row position
          currentY += maxCourseHeight + 20;

          // Add page break if needed
          if (currentY > pageHeight - 50 && i + coursesPerRow < coursesArray.length) {
            pdf.addPage();
            currentY = 20;

            // Add title on new page
            pdf.setFontSize(14);
            pdf.setFont('helvetica', 'bold');
            pdf.text('Distribution Summary (Continued)', 20, currentY);
            currentY += 15;
          }
        }
      }

      // Add total questions and metadata below the distribution summary
      currentY += 10;
      pdf.setFont('helvetica', 'bold');
      pdf.text(`Total Questions: ${totalQuestions}`, 20, currentY);

      // Add filter information
      currentY += 8;
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'italic');

      let filterInfo = `View: ${this.shouldShowOverallType() ? 'Overall Type' : 'Course-wise Breakdown'}`;
      pdf.text(filterInfo, 20, currentY);

      currentY += 4;
      let dateRangeText = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateRangeText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
      }
      pdf.text(dateRangeText, 20, currentY);

      // Add selected courses info if in course-wise view
      if (!this.shouldShowOverallType() && this.selectedTypeCourseIds.length > 0) {
        currentY += 4;
        const courseCount = this.selectedTypeCourseIds.length;
        pdf.text(`Selected Courses: ${courseCount} course${courseCount > 1 ? 's' : ''}`, 20, currentY);
      }

      // Add selected types info
      if (this.selectedQuestionTypes.length > 0) {
        currentY += 4;
        const typeCount = this.selectedQuestionTypes.length;
        pdf.text(`Selected Question Types: ${typeCount} type${typeCount > 1 ? 's' : ''}`, 20, currentY);
      }

      // Add footer at the bottom
      const footerY = pageHeight - 10;
      pdf.setFontSize(8);
      pdf.setFont('helvetica', 'normal');
      pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth / 2, footerY, { align: 'center' });

      const fileName = this.shouldShowOverallType()
        ? 'overall-type-analysis.pdf'
        : 'course-wise-type-analysis.pdf';

      pdf.save(fileName);
    }
  }

  exportTypeChartAsPNG(): void {
    this.closeTypeChartMenu();
    if (!this.ensureHasData(this.typeBarChartData)) { return; }

    if (this.typeBarChart) {
      // Create a container to combine chart and information
      const container = document.createElement('div');
      container.style.cssText = `
      position: fixed;
      left: -10000px;
      top: -10000px;
      width: 1400px;
      background: white;
      padding: 40px;
      border: 1px solid #ccc;
      z-index: 10000;
      font-family: Arial, sans-serif;
    `;

      // Create header
      const header = document.createElement('div');
      header.style.cssText = `
      text-align: center;
      margin-bottom: 40px;
      padding-bottom: 20px;
      border-bottom: 3px solid #005068;
    `;

      const title = document.createElement('h1');
      title.textContent = this.shouldShowOverallType()
        ? 'Overall Question Type Distribution'
        : 'Course-wise Question Type Distribution';
      title.style.cssText = `
      margin: 0 0 12px 0;
      color: #005068;
      font-size: 32px;
      font-weight: bold;
    `;

      const subtitle = document.createElement('p');
      subtitle.textContent = 'Source: Content Library Analytics';
      subtitle.style.cssText = `
      margin: 0;
      color: #666;
      font-size: 16px;
    `;

      header.appendChild(title);
      header.appendChild(subtitle);

      // Create top row for chart and legends
      const topRow = document.createElement('div');
      topRow.style.cssText = `
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 60px;
      margin-bottom: 40px;
      padding: 30px;
      background: #f8f9fa;
      border-radius: 15px;
      min-height: 500px;
    `;

      // Chart container (larger and expanded)
      const chartContainer = document.createElement('div');
      chartContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 2;
      min-height: 500px;
    `;

      // Create a high-quality chart render
      const chartWrapper = document.createElement('div');
      chartWrapper.style.cssText = `
      width: 500px;
      height: 500px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: white;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      padding: 20px;
      box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    `;

      // Get the original chart canvas
      const originalCanvas = this.typeBarChart.canvas;

      // Create a high-resolution canvas
      const highResCanvas = document.createElement('canvas');
      highResCanvas.width = 800;
      highResCanvas.height = 800;

      const ctx = highResCanvas.getContext('2d');
      if (ctx) {
        // Scale up for better quality
        ctx.scale(2, 2);

        // Set white background
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, highResCanvas.width, highResCanvas.height);

        // Draw the chart with better quality
        ctx.drawImage(originalCanvas, 0, 0, 400, 400);
      }

      const chartImg = document.createElement('img');
      chartImg.src = highResCanvas.toDataURL('image/png', 1.0);
      chartImg.style.cssText = `
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 10px;
      object-fit: contain;
    `;

      chartWrapper.appendChild(chartImg);
      chartContainer.appendChild(chartWrapper);

      // Legends container
      const legendsContainer = document.createElement('div');
      legendsContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 25px;
      flex: 1;
      min-width: 320px;
      max-width: 350px;
    `;

      // Color Legend Container
      const colorLegendContainer = document.createElement('div');
      colorLegendContainer.style.cssText = `
      background: white;
      padding: 30px;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    `;

      const colorLegendTitle = document.createElement('h3');
      colorLegendTitle.textContent = 'Color Legend';
      colorLegendTitle.style.cssText = `
      margin: 0 0 25px 0;
      color: #005068;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      border-bottom: 3px solid #f0f0f0;
      padding-bottom: 15px;
    `;

      colorLegendContainer.appendChild(colorLegendTitle);

      // Add course color legend only
      const courseLegend = document.createElement('div');
      courseLegend.style.cssText = `
      margin-bottom: 10px;
    `;

      const courseLegendTitle = document.createElement('h4');
      courseLegendTitle.textContent = 'Courses';
      courseLegendTitle.style.cssText = `
      margin: 0 0 20px 0;
      color: #333;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    `;

      courseLegend.appendChild(courseLegendTitle);

      // Get unique courses and their colors
      const courseColors = new Map();
      const nonZeroData = this.typeBarChartData.filter(item => item.value > 0);

      nonZeroData.forEach(item => {
        if (!courseColors.has(item.courseName)) {
          courseColors.set(item.courseName, item.color);
        }
      });

      // Add course color items with better styling
      courseColors.forEach((color, courseName) => {
        const courseItem = document.createElement('div');
        courseItem.style.cssText = `
        display: flex;
        align-items: flex-start;
        margin-bottom: 16px;
        padding: 12px;
        background: #f8f9fa;
        border-radius: 10px;
        border-left: 5px solid ${color};
        transition: all 0.3s ease;
      `;

        const colorBox = document.createElement('div');
        colorBox.style.cssText = `
        width: 24px;
        height: 24px;
        background-color: ${color};
        border: 3px solid #fff;
        border-radius: 8px;
        margin-right: 15px;
        margin-top: 2px;
        box-shadow: 0 3px 8px rgba(0,0,0,0.2);
        flex-shrink: 0;
      `;

        const courseNameSpan = document.createElement('span');
        courseNameSpan.textContent = courseName;
        courseNameSpan.style.cssText = `
        font-size: 16px;
        font-weight: 500;
        color: #333;
        line-height: 1.4;
        word-wrap: break-word;
        flex: 1;
      `;

        courseItem.appendChild(colorBox);
        courseItem.appendChild(courseNameSpan);
        courseLegend.appendChild(courseItem);
      });

      colorLegendContainer.appendChild(courseLegend);
      legendsContainer.appendChild(colorLegendContainer);

      // Add legends to top row
      topRow.appendChild(chartContainer);
      topRow.appendChild(legendsContainer);

      // Distribution Summary Section
      const distributionSection = document.createElement('div');
      distributionSection.style.cssText = `
      margin-top: 40px;
    `;

      const distributionTitle = document.createElement('h2');
      distributionTitle.textContent = 'Distribution Summary';
      distributionTitle.style.cssText = `
      margin: 0 0 30px 0;
      color: #005068;
      font-size: 28px;
      font-weight: bold;
      text-align: center;
      border-bottom: 3px solid #005068;
      padding-bottom: 15px;
    `;

      distributionSection.appendChild(distributionTitle);

      // Create course grid (2 courses per row)
      const coursesMap = new Map();
      nonZeroData.forEach(item => {
        if (!coursesMap.has(item.courseName)) {
          coursesMap.set(item.courseName, []);
        }
        coursesMap.get(item.courseName).push(item);
      });

      const coursesArray = Array.from(coursesMap.entries());

      // Create rows with 2 courses each
      for (let i = 0; i < coursesArray.length; i += 2) {
        const row = document.createElement('div');
        row.style.cssText = `
        display: flex;
        gap: 40px;
        margin-bottom: 40px;
        justify-content: center;
      `;

        // Add courses for this row
        for (let j = 0; j < 2 && (i + j) < coursesArray.length; j++) {
          const [courseName, types] = coursesArray[i + j];
          const courseColor = courseColors.get(courseName);

          const courseCard = document.createElement('div');
          courseCard.style.cssText = `
          flex: 1;
          background: white;
          padding: 30px;
          border-radius: 15px;
          border: 3px solid #e0e0e0;
          border-left: 8px solid ${courseColor};
          min-width: 350px;
          max-width: 400px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.15);
        `;

          // Course header
          const courseHeader = document.createElement('h3');
          courseHeader.textContent = courseName;
          courseHeader.style.cssText = `
          margin: 0 0 25px 0;
          color: #333;
          font-size: 20px;
          font-weight: bold;
          border-bottom: 3px solid #f0f0f0;
          padding-bottom: 15px;
          text-align: center;
          word-wrap: break-word;
          line-height: 1.3;
        `;

          courseCard.appendChild(courseHeader);

          // Create table-like structure for types
          const tableContainer = document.createElement('div');
          tableContainer.style.cssText = `
          width: 100%;
        `;

          // Add types for this course
          types.forEach(item => {
            const percentage = this.getTypePercentage(item);

            const rowDiv = document.createElement('div');
            rowDiv.style.cssText = `
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
            font-size: 16px;
            padding: 12px 0;
            border-bottom: 2px solid #f5f5f5;
          `;

            const typeLabel = document.createElement('span');
            typeLabel.textContent = `${item.name}:`;
            typeLabel.style.cssText = `
            font-weight: bold;
            color: #333;
            font-size: 16px;
          `;

            const valueSpan = document.createElement('span');
            valueSpan.textContent = `${item.value} (${percentage}%)`;
            valueSpan.style.cssText = `
            color: #666;
            font-weight: 600;
            font-size: 16px;
          `;

            rowDiv.appendChild(typeLabel);
            rowDiv.appendChild(valueSpan);
            tableContainer.appendChild(rowDiv);
          });

          courseCard.appendChild(tableContainer);
          row.appendChild(courseCard);
        }

        distributionSection.appendChild(row);
      }

      // Total and footer section
      const totalQuestions = this.typeBarChartData.reduce((sum, item) => sum + item.value, 0);

      const totalSection = document.createElement('div');
      totalSection.style.cssText = `
      margin-top: 50px;
      padding: 30px;
      background: #f8f9fa;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      text-align: center;
    `;

      const totalLabel = document.createElement('div');
      totalLabel.style.cssText = `
      font-weight: bold;
      margin-bottom: 20px;
      font-size: 20px;
      color: #005068;
    `;
      totalLabel.textContent = `Total Questions: ${totalQuestions}`;

      const metadataContainer = document.createElement('div');
      metadataContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-size: 15px;
      color: #666;
      margin-bottom: 20px;
    `;

      // View information
      const viewInfo = document.createElement('div');
      viewInfo.style.cssText = `
      font-weight: 500;
    `;
      viewInfo.textContent = `View: ${this.shouldShowOverallType() ? 'Overall Type' : 'Course-wise Breakdown'}`;

      // Date information
      const dateInfo = document.createElement('div');
      let dateText = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
      }
      dateInfo.textContent = dateText;

      // Selected courses info
      if (!this.shouldShowOverallType() && this.selectedTypeCourseIds.length > 0) {
        const courseInfo = document.createElement('div');
        const courseCount = this.selectedTypeCourseIds.length;
        courseInfo.textContent = `Selected Courses: ${courseCount} course${courseCount > 1 ? 's' : ''}`;
        courseInfo.style.fontWeight = '500';
        metadataContainer.appendChild(courseInfo);
      }

      // Selected types info
      if (this.selectedQuestionTypes.length > 0) {
        const typeInfo = document.createElement('div');
        const typeCount = this.selectedQuestionTypes.length;
        typeInfo.textContent = `Selected Question Types: ${typeCount} type${typeCount > 1 ? 's' : ''}`;
        typeInfo.style.fontWeight = '500';
        metadataContainer.appendChild(typeInfo);
      }

      // Footer
      const footer = document.createElement('div');
      footer.style.cssText = `
      text-align: center;
      margin-top: 20px;
      padding-top: 20px;
      border-top: 3px solid #ddd;
      font-size: 14px;
      color: #666;
      font-style: italic;
    `;
      footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;

      metadataContainer.appendChild(viewInfo);
      metadataContainer.appendChild(dateInfo);

      totalSection.appendChild(totalLabel);
      totalSection.appendChild(metadataContainer);
      totalSection.appendChild(footer);

      // Assemble the container
      container.appendChild(header);
      container.appendChild(topRow);
      container.appendChild(distributionSection);
      container.appendChild(totalSection);

      document.body.appendChild(container);

      // Use html2canvas with higher quality settings
      html2canvas(container, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: container.offsetWidth,
        height: container.offsetHeight
      }).then(canvas => {
        const link = document.createElement('a');
        link.download = this.shouldShowOverallType()
          ? 'overall-type-analysis.png'
          : 'course-wise-type-analysis.png';
        link.href = canvas.toDataURL('image/png', 1.0);
        link.click();

        // Clean up
        document.body.removeChild(container);
      });
    }
  }

  // Type Chart Table Modal Methods
  showTypeTableModal(): void {
    this.showTypeTableModalFlag = true;
  }

  closeTypeTableModal(): void {
    this.showTypeTableModalFlag = false;
  }

  exportTypeTableAsPDF(): void {
    const totalQuestions = this.typeBarChartData.reduce((sum, item) => sum + item.value, 0);
    let dateInfo = `Date Range: ${this.selectedRange}`;
    if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
      dateInfo += ` | From: ${this.formatDisplayDate(this.startDate)} To: ${this.formatDisplayDate(this.endDate)}`;
    }
    dateInfo += ` | Total Questions: ${totalQuestions}`;

    const tableData = this.typeBarChartData
      .filter(item => item.value > 0)
      .map(item => [
        item.courseName || 'All Courses',
        item.name,
        item.value.toString(),
        `${this.getTypePercentage(item)}%`
      ]);

    this.generateProfessionalPDF(
      'Question Type Distribution - Detailed Report',
      tableData,
      ['Course Name', 'Question Type', 'Count', 'Percentage'],
      'question-type-detailed-report.pdf',
      dateInfo
    );
  }

  exportTypeTableAsPNG(): void {
    // Create a container for the table with styling
    const container = document.createElement('div');
    container.style.cssText = `
    position: fixed;
    left: -10000px;
    top: -10000px;
    background: white;
    padding: 30px;
    z-index: 10000;
    max-width: 900px;
    width: 900px;
    font-family: Arial, sans-serif;
  `;

    // Add title and header
    const header = document.createElement('div');
    header.style.cssText = `
    text-align: center;
    margin-bottom: 25px;
    padding-bottom: 15px;
    border-bottom: 2px solid #005068;
  `;

    const title = document.createElement('h2');
    title.textContent = 'Question Type Distribution - Detailed Table';
    title.style.cssText = `
    margin: 0 0 12px 0;
    color: #005068;
    font-size: 24px;
    font-weight: bold;
  `;

    const totalQuestions = this.typeBarChartData.reduce((sum, item) => sum + item.value, 0);
    const subtitle = document.createElement('p');
    subtitle.textContent = `Date Range: ${this.selectedRange} | Total Questions: ${totalQuestions}`;
    subtitle.style.cssText = `
    margin: 0;
    color: #666;
    font-size: 14px;
  `;

    header.appendChild(title);
    header.appendChild(subtitle);

    // Create table manually
    const tableClone = this.createTypeTableForExport();
    container.appendChild(header);
    container.appendChild(tableClone);

    // Add footer
    const footer = document.createElement('div');
    footer.style.cssText = `
    text-align: center;
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid #ddd;
    font-size: 12px;
    color: #666;
    font-style: italic;
  `;
    footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;
    container.appendChild(footer);

    document.body.appendChild(container);

    html2canvas(container, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff'
    }).then(canvas => {
      const link = document.createElement('a');
      link.download = 'question-type-table.png';
      link.href = canvas.toDataURL('image/png');
      link.click();

      // Clean up
      document.body.removeChild(container);
    });
  }

  // Helper method to create type table for export
  private createTypeTableForExport(): HTMLElement {
    const table = document.createElement('table');
    table.style.cssText = `
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
    font-size: 13px;
    margin-bottom: 20px;
  `;

    // Create table header
    const thead = document.createElement('thead');
    const headerRow = document.createElement('tr');

    const headers = ['Course Name', 'Question Type', 'Count', 'Percentage'];
    headers.forEach(headerText => {
      const th = document.createElement('th');
      th.textContent = headerText;
      th.style.cssText = `
      background: #005068;
      color: white;
      padding: 12px 15px;
      text-align: left;
      font-weight: bold;
      border: 1px solid #ddd;
    `;
      headerRow.appendChild(th);
    });

    thead.appendChild(headerRow);
    table.appendChild(thead);

    // Create table body
    const tbody = document.createElement('tbody');

    this.typeBarChartData
      .filter(item => item.value > 0)
      .forEach((item, index) => {
        const row = document.createElement('tr');
        row.style.cssText = `
        background: ${index % 2 === 0 ? '#f9f9f9' : 'white'};
      `;

        const courseCell = document.createElement('td');
        courseCell.textContent = item.courseName || 'All Courses';
        courseCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        const typeCell = document.createElement('td');
        typeCell.textContent = item.name;
        typeCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        const countCell = document.createElement('td');
        countCell.textContent = item.value.toString();
        countCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        const percentageCell = document.createElement('td');
        percentageCell.textContent = `${this.getTypePercentage(item)}%`;
        percentageCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        row.appendChild(courseCell);
        row.appendChild(typeCell);
        row.appendChild(countCell);
        row.appendChild(percentageCell);
        tbody.appendChild(row);
      });

    table.appendChild(tbody);
    return table;
  }

  // Compare Dialog Properties
  showTypeCompareDialog: boolean = false;
  selectedTypeCompareYearRange: string = '';
  selectedTypeCompareMonth: number | null = null;
  showTypeCompareYearDropdown: boolean = false;
  showTypeCompareMonthDropdown: boolean = false;
  showTypeComparisonResults: boolean = false;
  currentTypeComparisonData: any[] = [];
  compareTypeComparisonData: any[] = [];
  typeTrendSummary: any[] = [];

  // Compare dialog methods
  openTypeCompareDialog(): void {
    this.showTypeCompareDialog = true;
    this.showTypeComparisonResults = false;
    // Reset compare selections
    this.selectedTypeCompareYearRange = '';
    this.selectedTypeCompareMonth = null;
  }

  closeTypeCompareDialog(): void {
    this.showTypeCompareDialog = false;
    this.showTypeComparisonResults = false;
    this.currentTypeComparisonData = [];
    this.compareTypeComparisonData = [];
  }

  // Compare Year Dropdown Methods
  toggleTypeCompareYearDropdown(): void {
    this.showTypeCompareYearDropdown = !this.showTypeCompareYearDropdown;
    if (this.showTypeCompareYearDropdown) {
      this.showTypeCompareMonthDropdown = false;
    }
  }

  selectTypeCompareYearRange(yearRange: string): void {
    this.selectedTypeCompareYearRange = yearRange;
    this.showTypeCompareYearDropdown = false;
  }

  // Compare Month Dropdown Methods
  toggleTypeCompareMonthDropdown(): void {
    this.showTypeCompareMonthDropdown = !this.showTypeCompareMonthDropdown;
    if (this.showTypeCompareMonthDropdown) {
      this.showTypeCompareYearDropdown = false;
    }
  }

  selectTypeCompareMonth(month: number | null): void {
    this.selectedTypeCompareMonth = month;
    this.showTypeCompareMonthDropdown = false;
  }

  // Load Type Comparison Data
  loadTypeComparisonData(): void {
    if (!this.selectedTypeCompareYearRange) {
      return;
    }

    this.isLoading = true;
    this.showTypeComparisonResults = true;

    // Prepare current data for comparison
    this.prepareCurrentTypeComparisonData();

    // Fetch comparison data
    this.fetchTypeComparisonData();
  }

  private prepareCurrentTypeComparisonData(): void {
    // Use current type chart data for comparison
    this.currentTypeComparisonData = this.typeBarChartData
      .filter(item => item.value > 0)
      .map(item => ({
        name: item.name,
        value: item.value,
        percentage: this.getTypePercentage(item),
        trend: 'neutral' // Current data has no trend
      }));
  }

  private fetchTypeComparisonData(): void {
    // Calculate date range for comparison
    let startDate: Date;
    let endDate: Date;

    if (this.selectedTypeCompareMonth) {
      // If month is selected, use specific month within the academic year
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedTypeCompareYearRange);
      if (yearRange) {
        const year = this.selectedTypeCompareMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedTypeCompareMonth - 1, 1);
        endDate = new Date(year, this.selectedTypeCompareMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedTypeCompareMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedTypeCompareMonth, 0);
      }
    } else {
      // If no month selected, use entire academic year
      const dateRange = this.getDateRangeFromYearRange(this.selectedTypeCompareYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');
    const resp = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          this.processTypeComparisonData(response.question_counts);
        } else {
          this.compareTypeComparisonData = [];
          this.typeTrendSummary = [];
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      (error) => {
        this.compareTypeComparisonData = [];
        this.typeTrendSummary = [];
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  private processTypeComparisonData(questionCounts: any[]): void {
    // Aggregate type data for comparison period
    const typeTotals = {
      'mcq': 0,
      'true_false': 0,
      'fill_blanks': 0,
      'matching': 0,
      'subjective': 0,
      'scenario_based': 0,
      'multi_select': 0,
      'activity_performance': 0,
      'audio_video': 0,
      'live_viva': 0,
      'file_submission': 0
    };

    questionCounts.forEach(course => {
      if (course.type_breakdown) {
        Object.keys(typeTotals).forEach(type => {
          typeTotals[type] += course.type_breakdown[type] || 0;
        });
      }
    });

    const totalQuestions = Object.values(typeTotals).reduce((sum: number, count: number) => sum + count, 0);

    // Prepare comparison data
    this.compareTypeComparisonData = Object.entries(typeTotals)
      .filter(([_, count]) => count > 0)
      .map(([type, count]) => {
        const percentage = totalQuestions > 0 ? ((count / totalQuestions) * 100).toFixed(1) : '0';
        const typeName = this.getTypeName(type);

        // Find corresponding current data for trend calculation
        const currentItem = this.currentTypeComparisonData.find(item => item.name === typeName);
        const currentValue = currentItem ? currentItem.value : 0;

        let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
        if (count > currentValue) {
          trend = 'positive';
        } else if (count < currentValue) {
          trend = 'negative';
        }

        return {
          name: typeName,
          value: count,
          percentage: percentage,
          trend: trend
        };
      });

    // Calculate trend summary
    this.calculateTypeTrendSummary();
  }

  private calculateTypeTrendSummary(): void {
    const currentTotal = this.getCurrentTypeTotalQuestions();
    const compareTotal = this.getCompareTypeTotalQuestions();

    this.typeTrendSummary = [
      {
        category: 'Total Questions',
        value: this.formatTrendValue(compareTotal - currentTotal),
        trend: compareTotal > currentTotal ? 'positive' : compareTotal < currentTotal ? 'negative' : 'neutral'
      }
    ];

    // Add type level trends
    this.currentTypeComparisonData.forEach(currentItem => {
      const compareItem = this.compareTypeComparisonData.find(item => item.name === currentItem.name);
      if (compareItem) {
        const difference = compareItem.value - currentItem.value;
        this.typeTrendSummary.push({
          category: `${currentItem.name} Questions`,
          value: this.formatTrendValue(difference),
          trend: compareItem.trend
        });
      }
    });
  }

  getCurrentTypeTotalQuestions(): number {
    return this.currentTypeComparisonData.reduce((sum, item) => sum + item.value, 0);
  }

  getCompareTypeTotalQuestions(): number {
    return this.compareTypeComparisonData.reduce((sum, item) => sum + item.value, 0);
  }
  selectedDifficultyCourseIds: number[] = [];
  selectedDifficultyLevels: string[] = [];
  selectedLanguageCourseIds: number[] = [];
  selectedDifficultyLanguages: string[] = [];

  // Helper methods for indeterminate states
  isCoursesSelectionIndeterminateForDifficulty(): boolean {
    return this.selectedDifficultyCourseIds.length > 0 &&
      this.selectedDifficultyCourseIds.length < this.courseList.length;
  }

  isCoursesSelectionIndeterminateForLanguage(): boolean {
    return this.selectedLanguageCourseIds.length > 0 &&
      this.selectedLanguageCourseIds.length < this.courseList.length;
  }

  // Language chart menu methods
  toggleLanguageChartMenu(): void {
    this.showLanguageChartMenu = !this.showLanguageChartMenu;
    if (this.showLanguageChartMenu) {
      this.showLanguageFilterPanel = false; // Close filter when opening menu
    }
  }
  // Language Chart Export Methods
  // Language Chart Export Methods - Same as Difficulty Level
  exportLanguageChartAsPDF(): void {
    this.closeLanguageChartMenu();
    if (!this.ensureHasData(this.languageBarChartData)) { return; }

    if (this.languageBarChart) {
      const canvas = this.languageBarChart.canvas;
      const chartImage = canvas.toDataURL('image/png');

      // Create PDF with proper layout - SAME as difficulty chart
      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Add title
      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');

      const chartTitle = this.shouldShowOverallLanguage()
        ? 'Overall Question Language Distribution'
        : 'Course-wise Question Language Distribution';

      // Center the title
      const titleWidth = pdf.getTextWidth(chartTitle);
      const titleX = (pageWidth - titleWidth) / 2;
      pdf.text(chartTitle, titleX, 25);

      // Add source/subtitle
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      const subtitle = 'Source: Content Library Analytics';
      const subtitleWidth = pdf.getTextWidth(subtitle);
      const subtitleX = (pageWidth - subtitleWidth) / 2;
      pdf.text(subtitle, subtitleX, 32);

      // Add separator line
      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      // Add chart image at the top left
      const imgProps = pdf.getImageProperties(chartImage);
      const chartWidth = pageWidth * 0.45;
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      const chartX = 20;
      const chartY = 45;

      pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

      // Add Color Legends beside the chart (right side)
      const legendsX = chartX + chartWidth + 10;
      const legendsStartY = chartY;

      // Color Legends Title
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Color Legend', legendsX, legendsStartY);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      let currentLegendY = legendsStartY + 15;

      // Get unique courses and their colors
      const courseColors = new Map();
      const nonZeroData = this.languageBarChartData.filter(item => item.value > 0);

      nonZeroData.forEach(item => {
        if (!courseColors.has(item.courseName)) {
          courseColors.set(item.courseName, item.color);
        }
      });

      // Add course color legends with proper text wrapping
      const maxLegendWidth = pageWidth - legendsX - 15;

      courseColors.forEach((color, courseName) => {
        // Draw color box
        const rgb = this.hexToRgb(color);
        pdf.setFillColor(rgb.r, rgb.g, rgb.b);
        pdf.rect(legendsX, currentLegendY - 3, 10, 10, 'F');

        // Draw border around color box
        pdf.setDrawColor(100, 100, 100);
        pdf.rect(legendsX, currentLegendY - 3, 10, 10);

        // Course name with text wrapping
        const maxTextWidth = maxLegendWidth - 15;
        const lines = pdf.splitTextToSize(courseName, maxTextWidth);

        // Draw each line of the course name
        lines.forEach((line: string, index: number) => {
          pdf.text(line, legendsX + 15, currentLegendY + (index * 4));
        });

        // Move Y position based on number of lines
        currentLegendY += (lines.length * 4) + 8;
      });

      // Calculate position for distribution summary
      const chartBottom = chartY + chartHeight;
      const legendsBottom = currentLegendY;
      const summaryStartY = Math.max(chartBottom, legendsBottom) + 20;

      // Add Distribution Summary title
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Distribution Summary', 20, summaryStartY);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      let currentY = summaryStartY + 15;

      // Calculate totals and percentages
      const totalQuestions = this.languageBarChartData.reduce((sum, item) => sum + item.value, 0);

      if (this.shouldShowOverallLanguage()) {
        // Show overall language breakdown in a single column
        pdf.setFont('helvetica', 'bold');
        pdf.text('Overall Language Breakdown:', 20, currentY);
        currentY += 8;

        pdf.setFont('helvetica', 'normal');
        nonZeroData.forEach(item => {
          const percentage = this.getLanguagePercentage(item);
          pdf.text(`${item.name}: ${item.value} (${percentage}%)`, 25, currentY);
          currentY += 5;
        });
      } else {
        // Show course-wise breakdown in multiple columns
        const coursesMap = new Map();
        nonZeroData.forEach(item => {
          if (!coursesMap.has(item.courseName)) {
            coursesMap.set(item.courseName, []);
          }
          coursesMap.get(item.courseName).push(item);
        });

        const coursesArray = Array.from(coursesMap.entries());
        const coursesPerRow = 2;
        const courseWidth = (pageWidth - 60) / coursesPerRow;

        // Add course-wise breakdown in grid layout
        for (let i = 0; i < coursesArray.length; i += coursesPerRow) {
          const rowCourses = coursesArray.slice(i, i + coursesPerRow);

          let maxCourseHeight = 0;

          // Process each course in the current row
          rowCourses.forEach(([courseName, languages], courseIndex) => {
            const courseX = 20 + (courseIndex * courseWidth);
            let courseY = currentY;

            // Course name with background and text wrapping
            pdf.setFont('helvetica', 'bold');
            pdf.setFillColor(245, 245, 245);

            // Wrap course name to fit within course width
            const courseNameLines = pdf.splitTextToSize(courseName, courseWidth - 20);
            const courseNameHeight = courseNameLines.length * 4 + 6;

            // Draw background for course name
            pdf.rect(courseX, courseY - 5, courseWidth - 15, courseNameHeight, 'F');

            // Draw colored border on left
            const rgb = this.hexToRgb(courseColors.get(courseName));
            pdf.setFillColor(rgb.r, rgb.g, rgb.b);
            pdf.rect(courseX, courseY - 5, 4, courseNameHeight, 'F');

            // Reset fill color for text
            pdf.setFillColor(0, 0, 0);

            // Draw course name lines
            courseNameLines.forEach((line: string, lineIndex: number) => {
              pdf.text(line, courseX + 8, courseY + (lineIndex * 4));
            });

            courseY += courseNameHeight + 8;

            pdf.setFont('helvetica', 'normal');

            // Add languages for this course
            languages.forEach(item => {
              const percentage = this.getLanguagePercentage(item);
              const languageText = `${item.name}: ${item.value} (${percentage}%)`;

              pdf.text(languageText, courseX + 8, courseY);
              courseY += 5;
            });

            // Update max height for this row
            const courseHeight = courseY - currentY;
            if (courseHeight > maxCourseHeight) {
              maxCourseHeight = courseHeight;
            }
          });

          // Move to next row position
          currentY += maxCourseHeight + 20;

          // Add page break if needed
          if (currentY > pageHeight - 50 && i + coursesPerRow < coursesArray.length) {
            pdf.addPage();
            currentY = 20;

            // Add title on new page
            pdf.setFontSize(14);
            pdf.setFont('helvetica', 'bold');
            pdf.text('Distribution Summary (Continued)', 20, currentY);
            currentY += 15;
          }
        }
      }

      // Add total questions and metadata below the distribution summary
      currentY += 10;
      pdf.setFont('helvetica', 'bold');
      pdf.text(`Total Questions: ${totalQuestions}`, 20, currentY);

      // Add filter information
      currentY += 8;
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'italic');

      let filterInfo = `View: ${this.shouldShowOverallLanguage() ? 'Overall Language' : 'Course-wise Breakdown'}`;
      pdf.text(filterInfo, 20, currentY);

      currentY += 4;
      let dateRangeText = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateRangeText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
      }
      pdf.text(dateRangeText, 20, currentY);

      // Add selected courses info if in course-wise view
      if (!this.shouldShowOverallLanguage() && this.selectedLanguageCourseIds.length > 0) {
        currentY += 4;
        const courseCount = this.selectedLanguageCourseIds.length;
        pdf.text(`Selected Courses: ${courseCount} course${courseCount > 1 ? 's' : ''}`, 20, currentY);
      }

      // Add footer at the bottom
      const footerY = pageHeight - 10;
      pdf.setFontSize(8);
      pdf.setFont('helvetica', 'normal');
      pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth / 2, footerY, { align: 'center' });

      const fileName = this.shouldShowOverallLanguage()
        ? 'overall-language-analysis.pdf'
        : 'course-wise-language-analysis.pdf';

      pdf.save(fileName);
    }
  }

  exportLanguageChartAsPNG(): void {
    this.closeLanguageChartMenu();
    if (!this.ensureHasData(this.languageBarChartData)) { return; }

    if (this.languageBarChart) {
      // Create a container to combine chart and information - SAME as difficulty chart
      const container = document.createElement('div');
      container.style.cssText = `
      position: fixed;
      left: -10000px;
      top: -10000px;
      width: 1400px;
      background: white;
      padding: 40px;
      border: 1px solid #ccc;
      z-index: 10000;
      font-family: Arial, sans-serif;
    `;

      // Create header
      const header = document.createElement('div');
      header.style.cssText = `
      text-align: center;
      margin-bottom: 40px;
      padding-bottom: 20px;
      border-bottom: 3px solid #005068;
    `;

      const title = document.createElement('h1');
      title.textContent = this.shouldShowOverallLanguage()
        ? 'Overall Question Language Distribution'
        : 'Course-wise Question Language Distribution';
      title.style.cssText = `
      margin: 0 0 12px 0;
      color: #005068;
      font-size: 32px;
      font-weight: bold;
    `;

      const subtitle = document.createElement('p');
      subtitle.textContent = 'Source: Content Library Analytics';
      subtitle.style.cssText = `
      margin: 0;
      color: #666;
      font-size: 16px;
    `;

      header.appendChild(title);
      header.appendChild(subtitle);

      // Create top row for chart and legends
      const topRow = document.createElement('div');
      topRow.style.cssText = `
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 60px;
      margin-bottom: 40px;
      padding: 30px;
      background: #f8f9fa;
      border-radius: 15px;
      min-height: 500px;
    `;

      // Chart container (larger and expanded)
      const chartContainer = document.createElement('div');
      chartContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 2;
      min-height: 500px;
    `;

      // Create a high-quality chart render
      const chartWrapper = document.createElement('div');
      chartWrapper.style.cssText = `
      width: 500px;
      height: 500px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: white;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      padding: 20px;
      box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    `;

      // Get the original chart canvas
      const originalCanvas = this.languageBarChart.canvas;

      // Create a high-resolution canvas
      const highResCanvas = document.createElement('canvas');
      highResCanvas.width = 800;
      highResCanvas.height = 800;

      const ctx = highResCanvas.getContext('2d');
      if (ctx) {
        // Scale up for better quality
        ctx.scale(2, 2);

        // Set white background
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, highResCanvas.width, highResCanvas.height);

        // Draw the chart with better quality
        ctx.drawImage(originalCanvas, 0, 0, 400, 400);
      }

      const chartImg = document.createElement('img');
      chartImg.src = highResCanvas.toDataURL('image/png', 1.0);
      chartImg.style.cssText = `
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 10px;
      object-fit: contain;
    `;

      chartWrapper.appendChild(chartImg);
      chartContainer.appendChild(chartWrapper);

      // Legends container
      const legendsContainer = document.createElement('div');
      legendsContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 25px;
      flex: 1;
      min-width: 320px;
      max-width: 350px;
    `;

      // Color Legend Container
      const colorLegendContainer = document.createElement('div');
      colorLegendContainer.style.cssText = `
      background: white;
      padding: 30px;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    `;

      const colorLegendTitle = document.createElement('h3');
      colorLegendTitle.textContent = 'Color Legend';
      colorLegendTitle.style.cssText = `
      margin: 0 0 25px 0;
      color: #005068;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      border-bottom: 3px solid #f0f0f0;
      padding-bottom: 15px;
    `;

      colorLegendContainer.appendChild(colorLegendTitle);

      // Add course color legend only
      const courseLegend = document.createElement('div');
      courseLegend.style.cssText = `
      margin-bottom: 10px;
    `;

      const courseLegendTitle = document.createElement('h4');
      courseLegendTitle.textContent = 'Courses';
      courseLegendTitle.style.cssText = `
      margin: 0 0 20px 0;
      color: #333;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    `;

      courseLegend.appendChild(courseLegendTitle);

      // Get unique courses and their colors
      const courseColors = new Map();
      const nonZeroData = this.languageBarChartData.filter(item => item.value > 0);

      nonZeroData.forEach(item => {
        if (!courseColors.has(item.courseName)) {
          courseColors.set(item.courseName, item.color);
        }
      });

      // Add course color items with better styling
      courseColors.forEach((color, courseName) => {
        const courseItem = document.createElement('div');
        courseItem.style.cssText = `
        display: flex;
        align-items: flex-start;
        margin-bottom: 16px;
        padding: 12px;
        background: #f8f9fa;
        border-radius: 10px;
        border-left: 5px solid ${color};
        transition: all 0.3s ease;
      `;

        const colorBox = document.createElement('div');
        colorBox.style.cssText = `
        width: 24px;
        height: 24px;
        background-color: ${color};
        border: 3px solid #fff;
        border-radius: 8px;
        margin-right: 15px;
        margin-top: 2px;
        box-shadow: 0 3px 8px rgba(0,0,0,0.2);
        flex-shrink: 0;
      `;

        const courseNameSpan = document.createElement('span');
        courseNameSpan.textContent = courseName;
        courseNameSpan.style.cssText = `
        font-size: 16px;
        font-weight: 500;
        color: #333;
        line-height: 1.4;
        word-wrap: break-word;
        flex: 1;
      `;

        courseItem.appendChild(colorBox);
        courseItem.appendChild(courseNameSpan);
        courseLegend.appendChild(courseItem);
      });

      colorLegendContainer.appendChild(courseLegend);
      legendsContainer.appendChild(colorLegendContainer);

      // Add legends to top row
      topRow.appendChild(chartContainer);
      topRow.appendChild(legendsContainer);

      // Distribution Summary Section
      const distributionSection = document.createElement('div');
      distributionSection.style.cssText = `
      margin-top: 40px;
    `;

      const distributionTitle = document.createElement('h2');
      distributionTitle.textContent = 'Distribution Summary';
      distributionTitle.style.cssText = `
      margin: 0 0 30px 0;
      color: #005068;
      font-size: 28px;
      font-weight: bold;
      text-align: center;
      border-bottom: 3px solid #005068;
      padding-bottom: 15px;
    `;

      distributionSection.appendChild(distributionTitle);

      // Create course grid (2 courses per row)
      const coursesMap = new Map();
      nonZeroData.forEach(item => {
        if (!coursesMap.has(item.courseName)) {
          coursesMap.set(item.courseName, []);
        }
        coursesMap.get(item.courseName).push(item);
      });

      const coursesArray = Array.from(coursesMap.entries());

      // Create rows with 2 courses each
      for (let i = 0; i < coursesArray.length; i += 2) {
        const row = document.createElement('div');
        row.style.cssText = `
        display: flex;
        gap: 40px;
        margin-bottom: 40px;
        justify-content: center;
      `;

        // Add courses for this row
        for (let j = 0; j < 2 && (i + j) < coursesArray.length; j++) {
          const [courseName, languages] = coursesArray[i + j];
          const courseColor = courseColors.get(courseName);

          const courseCard = document.createElement('div');
          courseCard.style.cssText = `
          flex: 1;
          background: white;
          padding: 30px;
          border-radius: 15px;
          border: 3px solid #e0e0e0;
          border-left: 8px solid ${courseColor};
          min-width: 350px;
          max-width: 400px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.15);
        `;

          // Course header
          const courseHeader = document.createElement('h3');
          courseHeader.textContent = courseName;
          courseHeader.style.cssText = `
          margin: 0 0 25px 0;
          color: #333;
          font-size: 20px;
          font-weight: bold;
          border-bottom: 3px solid #f0f0f0;
          padding-bottom: 15px;
          text-align: center;
          word-wrap: break-word;
          line-height: 1.3;
        `;

          courseCard.appendChild(courseHeader);

          // Create table-like structure for languages
          const tableContainer = document.createElement('div');
          tableContainer.style.cssText = `
          width: 100%;
        `;

          // Add languages for this course
          languages.forEach(item => {
            const percentage = this.getLanguagePercentage(item);

            const rowDiv = document.createElement('div');
            rowDiv.style.cssText = `
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
            font-size: 16px;
            padding: 12px 0;
            border-bottom: 2px solid #f5f5f5;
          `;

            const languageLabel = document.createElement('span');
            languageLabel.textContent = `${item.name}:`;
            languageLabel.style.cssText = `
            font-weight: bold;
            color: #333;
            font-size: 16px;
          `;

            const valueSpan = document.createElement('span');
            valueSpan.textContent = `${item.value} (${percentage}%)`;
            valueSpan.style.cssText = `
            color: #666;
            font-weight: 600;
            font-size: 16px;
          `;

            rowDiv.appendChild(languageLabel);
            rowDiv.appendChild(valueSpan);
            tableContainer.appendChild(rowDiv);
          });

          courseCard.appendChild(tableContainer);
          row.appendChild(courseCard);
        }

        distributionSection.appendChild(row);
      }

      // Total and footer section
      const totalQuestions = this.languageBarChartData.reduce((sum, item) => sum + item.value, 0);

      const totalSection = document.createElement('div');
      totalSection.style.cssText = `
      margin-top: 50px;
      padding: 30px;
      background: #f8f9fa;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      text-align: center;
    `;

      const totalLabel = document.createElement('div');
      totalLabel.style.cssText = `
      font-weight: bold;
      margin-bottom: 20px;
      font-size: 20px;
      color: #005068;
    `;
      totalLabel.textContent = `Total Questions: ${totalQuestions}`;

      const metadataContainer = document.createElement('div');
      metadataContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-size: 15px;
      color: #666;
      margin-bottom: 20px;
    `;

      // View information
      const viewInfo = document.createElement('div');
      viewInfo.style.cssText = `
      font-weight: 500;
    `;
      viewInfo.textContent = `View: ${this.shouldShowOverallLanguage() ? 'Overall Language' : 'Course-wise Breakdown'}`;

      // Date information
      const dateInfo = document.createElement('div');
      let dateText = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
      }
      dateInfo.textContent = dateText;

      // Selected courses info
      if (!this.shouldShowOverallLanguage() && this.selectedLanguageCourseIds.length > 0) {
        const courseInfo = document.createElement('div');
        const courseCount = this.selectedLanguageCourseIds.length;
        courseInfo.textContent = `Selected Courses: ${courseCount} course${courseCount > 1 ? 's' : ''}`;
        courseInfo.style.fontWeight = '500';
        metadataContainer.appendChild(courseInfo);
      }

      // Footer
      const footer = document.createElement('div');
      footer.style.cssText = `
      text-align: center;
      margin-top: 20px;
      padding-top: 20px;
      border-top: 3px solid #ddd;
      font-size: 14px;
      color: #666;
      font-style: italic;
    `;
      footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;

      metadataContainer.appendChild(viewInfo);
      metadataContainer.appendChild(dateInfo);

      totalSection.appendChild(totalLabel);
      totalSection.appendChild(metadataContainer);
      totalSection.appendChild(footer);

      // Assemble the container
      container.appendChild(header);
      container.appendChild(topRow);
      container.appendChild(distributionSection);
      container.appendChild(totalSection);

      document.body.appendChild(container);

      // Use html2canvas with higher quality settings
      html2canvas(container, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: container.offsetWidth,
        height: container.offsetHeight
      }).then(canvas => {
        const link = document.createElement('a');
        link.download = this.shouldShowOverallLanguage()
          ? 'overall-language-analysis.png'
          : 'course-wise-language-analysis.png';
        link.href = canvas.toDataURL('image/png', 1.0);
        link.click();

        // Clean up
        document.body.removeChild(container);
      });
    }
  }
  private shouldShowOverallLanguage(): boolean {
    const hasCourseFilter = this.selectedLanguageCourseIds.length > 0;
    const hasLanguageFilter = this.selectedLanguages.length > 0;

    if (!hasCourseFilter) {
      return true;
    }

    if (this.selectedLanguageCourseIds.length === this.courseList.length) {
      return true;
    }

    if (this.selectedLanguageCourseIds.length === 1) {
      return false;
    }

    if (this.selectedLanguageCourseIds.length > 5) {
      return true;
    }

    return false;
  }
  showLanguageTableModal(): void {
    this.closeLanguageChartMenu();
    this.showLanguageTableModalFlag = true;
  }

  closeLanguageTableModal(): void {
    this.showLanguageTableModalFlag = false;
  }

  // Language Table Export Methods
  exportLanguageTableAsPDF(): void {
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();

    // Add title
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Question Language Distribution - Detailed Report', pageWidth / 2, 20, { align: 'center' });

    // Add summary information
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');

    const totalQuestions = this.languageBarChartData.reduce((sum, item) => sum + item.value, 0);

    let dateInfo = `Date Range: ${this.selectedRange}`;
    if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
      dateInfo += ` | From: ${this.formatDisplayDate(this.startDate)} To: ${this.formatDisplayDate(this.endDate)}`;
    }
    dateInfo += ` | Total Questions: ${totalQuestions}`;

    pdf.text(dateInfo, pageWidth / 2, 28, { align: 'center' });

    // Create table data
    const tableData = this.languageBarChartData
      .filter(item => item.value > 0)
      .map(item => [
        item.courseName || 'All Courses',
        item.name,
        item.value.toString(),
        `${this.getLanguagePercentage(item)}%`
      ]);

    // Use autoTable
    autoTable(pdf, {
      startY: 35,
      head: [['Course Name', 'Language', 'Count', 'Percentage']],
      body: tableData,
      theme: 'grid',
      headStyles: {
        fillColor: [0, 80, 104], // #005068
        textColor: 255,
        fontStyle: 'bold',
        fontSize: 10
      },
      styles: {
        fontSize: 9,
        cellPadding: 4,
        lineColor: [0, 0, 0],
        lineWidth: 0.1
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      },
      columnStyles: {
        0: { cellWidth: 'auto', fontStyle: 'bold' }, // Course Name
        1: { cellWidth: 'auto' }, // Language
        2: { cellWidth: 'auto' }, // Count
        3: { cellWidth: 'auto' }  // Percentage
      },
      margin: { top: 35 }
    });

    // Add footer
    const finalY = (pdf as any).lastAutoTable?.finalY || 100;
    pdf.setFontSize(8);
    pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth / 2, finalY + 10, { align: 'center' });

    pdf.save('question-language-detailed-report.pdf');
  }

  exportLanguageTableAsPNG(): void {
    const tableElement = document.querySelector('.language-modal-table') as HTMLElement;

    if (tableElement) {
      // Create a container for the table with styling
      const container = document.createElement('div');
      container.style.cssText = `
      position: fixed;
      left: -10000px;
      top: -10000px;
      background: white;
      padding: 30px;
      z-index: 10000;
      max-width: 900px;
      width: 900px;
      font-family: Arial, sans-serif;
    `;

      // Add title and header
      const header = document.createElement('div');
      header.style.cssText = `
      text-align: center;
      margin-bottom: 25px;
      padding-bottom: 15px;
      border-bottom: 2px solid #005068;
    `;

      const title = document.createElement('h2');
      title.textContent = 'Question Language Distribution - Detailed Table';
      title.style.cssText = `
      margin: 0 0 12px 0;
      color: #005068;
      font-size: 24px;
      font-weight: bold;
    `;

      const totalQuestions = this.languageBarChartData.reduce((sum, item) => sum + item.value, 0);
      const subtitle = document.createElement('p');
      subtitle.textContent = `Date Range: ${this.selectedRange} | Total Questions: ${totalQuestions}`;
      subtitle.style.cssText = `
      margin: 0;
      color: #666;
      font-size: 14px;
    `;

      header.appendChild(title);
      header.appendChild(subtitle);

      // Create table manually since we don't have a DOM element for language table
      const tableClone = this.createLanguageTableForExport();
      container.appendChild(header);
      container.appendChild(tableClone);

      // Add footer
      const footer = document.createElement('div');
      footer.style.cssText = `
      text-align: center;
      margin-top: 20px;
      padding-top: 15px;
      border-top: 1px solid #ddd;
      font-size: 12px;
      color: #666;
      font-style: italic;
    `;
      footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;
      container.appendChild(footer);

      document.body.appendChild(container);

      html2canvas(container, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff'
      }).then(canvas => {
        const link = document.createElement('a');
        link.download = 'question-language-table.png';
        link.href = canvas.toDataURL('image/png');
        link.click();

        // Clean up
        document.body.removeChild(container);
      });
    }
  }

  // Helper method to create language table for export
  private createLanguageTableForExport(): HTMLElement {
    const table = document.createElement('table');
    table.style.cssText = `
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
    font-size: 13px;
    margin-bottom: 20px;
  `;

    // Create table header
    const thead = document.createElement('thead');
    const headerRow = document.createElement('tr');

    const headers = ['Course Name', 'Language', 'Count', 'Percentage'];
    headers.forEach(headerText => {
      const th = document.createElement('th');
      th.textContent = headerText;
      th.style.cssText = `
      background: #005068;
      color: white;
      padding: 12px 15px;
      text-align: left;
      font-weight: bold;
      border: 1px solid #ddd;
    `;
      headerRow.appendChild(th);
    });

    thead.appendChild(headerRow);
    table.appendChild(thead);

    // Create table body
    const tbody = document.createElement('tbody');

    this.languageBarChartData
      .filter(item => item.value > 0)
      .forEach((item, index) => {
        const row = document.createElement('tr');
        row.style.cssText = `
        background: ${index % 2 === 0 ? '#f9f9f9' : 'white'};
      `;

        const courseCell = document.createElement('td');
        courseCell.textContent = item.courseName || 'All Courses';
        courseCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        const languageCell = document.createElement('td');
        languageCell.textContent = item.name;
        languageCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        const countCell = document.createElement('td');
        countCell.textContent = item.value.toString();
        countCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        const percentageCell = document.createElement('td');
        percentageCell.textContent = `${this.getLanguagePercentage(item)}%`;
        percentageCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        row.appendChild(courseCell);
        row.appendChild(languageCell);
        row.appendChild(countCell);
        row.appendChild(percentageCell);
        tbody.appendChild(row);
      });

    table.appendChild(tbody);
    return table;
  }
  // Language dropdown methods
  toggleLanguageYearDropdown(): void {
    this.showLanguageYearDropdown = !this.showLanguageYearDropdown;
    if (this.showLanguageYearDropdown) {
      this.showLanguageMonthDropdown = false;
    }
  }

  selectLanguageYearRange(yearRange: string): void {
    this.selectedLanguageYearRange = yearRange;
    this.showLanguageYearDropdown = false;
    this.applyLanguageMonthYearFilter();
  }

  toggleLanguageMonthDropdown(): void {
    this.showLanguageMonthDropdown = !this.showLanguageMonthDropdown;
    if (this.showLanguageMonthDropdown) {
      this.showLanguageYearDropdown = false;
    }
  }

  selectLanguageMonth(month: number): void {
    this.selectedLanguageMonth = month;
    this.showLanguageMonthDropdown = false;
    this.applyLanguageMonthYearFilter();
  }

  applyLanguageMonthYearFilter(): void {

    this.showLanguageYearDropdown = false;
    this.showLanguageMonthDropdown = false;

    // Fetch data with language-specific filters
    this.fetchLanguageFilteredData();
  }

  private fetchLanguageFilteredData(): void {
    // Similar to fetchFilteredQuestionData but for language chart
    this.isLoading = true;

    let startDate: Date;
    let endDate: Date;

    if (this.selectedLanguageMonth) {
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedLanguageYearRange);
      if (yearRange) {
        const year = this.selectedLanguageMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedLanguageMonth - 1, 1);
        endDate = new Date(year, this.selectedLanguageMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedLanguageMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedLanguageMonth, 0);
      }
    } else {
      const dateRange = this.getDateRangeFromYearRange(this.selectedLanguageYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

    const resp = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          // Extract ONLY question counts - don't call processLibraryData() which updates ALL charts
          this.extractQuestionCountsFromResponse(response);
          // Prepare ONLY language data - preserve independence of other charts
          this.prepareLanguageData(this.questionCounts);
          this.isLoading = false;
          this.cdr.detectChanges();
        } else {
          this.languageChartData = [];
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.languageChartData = [];
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }
  closeLanguageChartMenu(): void {
    this.showLanguageChartMenu = false;
  }

  private prepareOverallLanguageData(courses: any[]): void {

    // Check if difficulty or evaluation mode filters are applied
    const hasDifficultyFilter = this.selectedLanguageDifficultyLevels.length > 0;
    const hasEvaluationFilter = this.selectedLanguageEvaluationModes.length > 0;

    if (hasDifficultyFilter && courses.some(c => c.language_difficulty_breakdown)) {
      // Prepare stacked data for difficulty breakdown per language
      this.prepareLanguageDifficultyBreakdownData(courses);
    } else if (hasEvaluationFilter && courses.some(c => c.language_evaluation_breakdown)) {
      // Prepare stacked data for evaluation mode breakdown per language
      this.prepareLanguageEvaluationBreakdownData(courses);
    } else {
      // Prepare total language data
      this.prepareTotalLanguageData(courses);
    }
  }

  private prepareTotalLanguageData(courses: any[]): void {
    // Aggregate language counts across all selected courses
    const languageTotals = {
      'English': 0,
      'Hindi': 0,
      'Tamil': 0,
      'Telugu': 0,
      'Kannada': 0,
      'Gujarati': 0,
      'Oriya': 0,
      'Assamese': 0,
      'Urdu': 0,
      'Marathi': 0,
      'Malayalam': 0,
      'Bengali': 0,
      'Punjabi': 0,
      'Manipuri': 0
    };

    const hasDifficultyFilter = this.selectedLanguageDifficultyLevels.length > 0;
    const hasEvaluationFilter = this.selectedLanguageEvaluationModes.length > 0;
    const hasAnyFilter = hasDifficultyFilter || hasEvaluationFilter;

    courses.forEach((course, index) => {
      if (hasAnyFilter && course.language_difficulty_breakdown) {
        // Sum from filtered language_difficulty_breakdown
        Object.keys(languageTotals).forEach(language => {
          if (course.language_difficulty_breakdown[language]) {
            Object.values(course.language_difficulty_breakdown[language]).forEach((count: number) => {
              languageTotals[language] += count;
            });
          }
        });
      } else if (hasAnyFilter && course.language_evaluation_breakdown) {
        // Sum from filtered language_evaluation_breakdown
        Object.keys(languageTotals).forEach(language => {
          if (course.language_evaluation_breakdown[language]) {
            Object.values(course.language_evaluation_breakdown[language]).forEach((count: number) => {
              languageTotals[language] += count;
            });
          }
        });
      } else if (course.language_breakdown) {
        // Sum from language_breakdown
        Object.keys(languageTotals).forEach(language => {
          const value = course.language_breakdown[language] || 0;
          languageTotals[language] += value;
        });
      }
    });

    // Define colors for languages - type_breakdown ki tarah consistent colors
    const languageColors = {
      'English': '#001141',
      'Hindi': '#001d6c',
      'Tamil': '#002d9c',
      'Telugu': '#0043ce',
      'Kannada': '#0f62fe',
      'Gujarati': '#4589ff',
      'Oriya': '#78a9ff',
      'Assamese': '#a6c8ff',
      'Urdu': '#d0e2ff',
      'Marathi': '#edf5ff',
      'Malayalam': '#EEF6FF',
      'Bengali': '#001141',
      'Punjabi': '#001d6c',
      'Manipuri': '#002d9c'
    };

    // Create chart data for overall language
    Object.entries(languageTotals).forEach(([languageCode, count]) => {
      if (count > 0) {
        this.languageBarChartData.push({
          name: languageCode,
          value: count,
          color: languageColors[languageCode],
          courseName: 'All Courses',
          originalCourseName: 'All Courses',
          courseId: 0,
          languageCode: languageCode
        });
      }
    });
  }

  private prepareLanguageDifficultyBreakdownData(courses: any[]): void {
    // Aggregate language-difficulty counts across all selected courses
    const languageDifficultyTotals: { [language: string]: { [difficulty: string]: number } } = {};

    // Initialize totals for selected difficulties
    const selectedDifficulties = this.selectedLanguageDifficultyLevels;
    const allLanguages = ['English', 'Hindi', 'Tamil', 'Telugu', 'Kannada', 'Gujarati', 'Oriya', 'Assamese', 'Urdu', 'Marathi', 'Malayalam', 'Bengali', 'Punjabi', 'Manipuri'];

    allLanguages.forEach(language => {
      languageDifficultyTotals[language] = {};
      selectedDifficulties.forEach(difficulty => {
        languageDifficultyTotals[language][difficulty] = 0;
      });
    });

    courses.forEach(course => {
      if (course.language_difficulty_breakdown) {
        Object.keys(course.language_difficulty_breakdown).forEach(language => {
          if (languageDifficultyTotals[language]) {
            selectedDifficulties.forEach(difficulty => {
              const value = course.language_difficulty_breakdown[language][difficulty] || 0;
              languageDifficultyTotals[language][difficulty] += value;
            });
          }
        });
      }
    });

    // Define colors for difficulties
    const difficultyColors = {
      'easy': '#28a745',
      'medium': '#ffc107',
      'hard': '#dc3545'
    };

    // Create chart data for each language-difficulty combination
    allLanguages.forEach(language => {
      selectedDifficulties.forEach(difficulty => {
        const count = languageDifficultyTotals[language][difficulty];
        if (count > 0) {
          this.languageBarChartData.push({
            name: `${language} - ${difficulty.charAt(0).toUpperCase() + difficulty.slice(1)}`,
            value: count,
            color: difficultyColors[difficulty] || '#6c757d',
            courseName: 'All Courses',
            originalCourseName: 'All Courses',
            courseId: 0,
            languageCode: language,
            difficulty: difficulty
          });
        }
      });
    });
  }

  private prepareLanguageEvaluationBreakdownData(courses: any[]): void {
    // Aggregate language-evaluation counts across all selected courses
    const languageEvaluationTotals: { [language: string]: { [mode: string]: number } } = {};

    // Initialize totals for selected evaluation modes
    const selectedEvaluationModes = this.selectedLanguageEvaluationModes;
    const allLanguages = ['English', 'Hindi', 'Tamil', 'Telugu', 'Kannada', 'Gujarati', 'Oriya', 'Assamese', 'Urdu', 'Marathi', 'Malayalam', 'Bengali', 'Punjabi', 'Manipuri'];

    allLanguages.forEach(language => {
      languageEvaluationTotals[language] = {};
      selectedEvaluationModes.forEach(mode => {
        languageEvaluationTotals[language][mode] = 0;
      });
    });

    courses.forEach(course => {
      if (course.language_evaluation_breakdown) {
        Object.keys(course.language_evaluation_breakdown).forEach(language => {
          if (languageEvaluationTotals[language]) {
            selectedEvaluationModes.forEach(mode => {
              const value = course.language_evaluation_breakdown[language][mode] || 0;
              languageEvaluationTotals[language][mode] += value;
            });
          }
        });
      }
    });

    // Define colors for evaluation modes
    const evaluationColors: { [mode: string]: string } = {
      'Theory': '#005068',
      'Practical': '#A0A0FF',
      'Viva': '#F9EDDB'
    };

    // Create chart data for each language-evaluation combination
    allLanguages.forEach(language => {
      selectedEvaluationModes.forEach(mode => {
        const count = languageEvaluationTotals[language][mode];
        if (count > 0) {
          this.languageBarChartData.push({
            name: `${language} - ${mode}`,
            value: count,
            color: evaluationColors[mode] || '#6c757d',
            courseName: 'All Courses',
            originalCourseName: 'All Courses',
            courseId: 0,
            languageCode: language,
            evaluationMode: mode
          });
        }
      });
    });
  }

  private prepareMultipleCoursesLanguageData(courses: any[]): void {

    // Vibrant colors for different courses
    const courseColors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9',
      '#F8B195', '#F67280', '#C06C84', '#6C5B7B', '#355C7D',
      '#99B898', '#FECEAB', '#FF847C', '#E84A5F', '#2A363B'
    ];

    courses.forEach((course, courseIndex) => {
      const courseColor = courseColors[courseIndex % courseColors.length];
      const courseName = course.course_name || `Course ${courseIndex + 1}`;

      // Safely get language breakdown
      const languageBreakdown = course.language_breakdown || {};

      // Add each language for this course
      Object.entries(languageBreakdown).forEach(([languageCode, count]) => {
        if ((count as number) > 0) {
          const uniqueColor = this.generateUniqueColor(courseColor, languageCode);
          const languageName = this.getLanguageName(languageCode);

          this.languageBarChartData.push({
            name: languageName,
            value: count,
            color: uniqueColor,
            courseName: courseName,
            originalCourseName: course.course_name,
            courseId: course.course_id,
            languageCode: languageCode,
            courseColor: courseColor
          });
        }
      });
    });
  }

  private getLanguageName(languageCode: string): string {
    const normalizedInput = this.normalizeString(languageCode);

    const languageFromData = this.languagesData.find(lang =>
      this.normalizeString(lang.code) === normalizedInput ||
      this.normalizeString(lang.name) === normalizedInput
    );

    if (languageFromData) {
      return languageFromData.name || languageCode;
    }

    const language = this.availableLanguages.find(lang =>
      this.normalizeString(lang.code) === normalizedInput ||
      this.normalizeString(lang.name) === normalizedInput
    );

    return language ? language.name : languageCode;
  }

  courseList: any[] = [];
  getDisplayQuestionsWithTag(): number {
    if (!this.isFilterApplied()) return 0;
    
    if (this.summaryQuestionCounts && this.summaryQuestionCounts.length > 0) {
      return this.summaryQuestionCounts.reduce((total, course) => {
        return total + (course.tag_breakdown?.with_tag || 0);
      }, 0);
    }
    
    return this.questionSummary?.tag_summary?.with_tag || 0;
  }

  getDisplayQuestionsWithoutTag(): number {
    if (!this.isFilterApplied()) return 0;
    
    if (this.summaryQuestionCounts && this.summaryQuestionCounts.length > 0) {
      return this.summaryQuestionCounts.reduce((total, course) => {
        return total + (course.tag_breakdown?.without_tag || 0);
      }, 0);
    }
    
    return this.questionSummary?.tag_summary?.without_tag || 0;
  }

  // Assessment Summary Display Methods
  getDisplayTotalAssessments(): number {
    const filterApplied = this.isFilterApplied();
    const value = filterApplied ? this.totalAssessments : 0;
    // console.log('getDisplayTotalAssessments:', { filterApplied, value, isCustom: this.selectedRange === 'Custom', startDate: this.startDate, endDate: this.endDate });
    return value;
  }

  getDisplayTotalCandidates(): number {
    return this.isFilterApplied() ? this.totalCandidates : 0;
  }

  getDisplayAssessmentPublish(): number {
    if (!this.isFilterApplied()) return 0;
    const filtered = this.getFilteredAssessmentCounts();
    console.log('getDisplayAssessmentPublish - filtered.published:', filtered.published);
    // If courses OR languages OR customers OR difficulty are selected, always return the filtered count (even if 0)
    if ((this.selectedAssessmentInsightCourseValues && this.selectedAssessmentInsightCourseValues.length > 0) ||
        (this.selectedAssessmentInsightLanguageValues && this.selectedAssessmentInsightLanguageValues.length > 0) ||
        (this.selectedAssessmentInsightCustomerValues && this.selectedAssessmentInsightCustomerValues.length > 0) ||
        (this.selectedAssessmentInsightDifficultyValues && this.selectedAssessmentInsightDifficultyValues.length > 0)) {
      return filtered.published;
    }
    return this.totalPublishedAssessments;
  }

  getDisplayAssessmentDraft(): number {
    return this.isFilterApplied() ? this.assessmentStatusSummary.draft : 0;
  }

  getDisplayCandidateActive(): number {
    return this.isFilterApplied() ? this.candidateStatusSummary.active : 0;
  }

  getDisplayCandidateInactive(): number {
    return this.isFilterApplied() ? this.candidateStatusSummary.inactive : 0;
  }

  getDisplayEvaluationCompleted(): number {
    return this.isFilterApplied() ? this.evaluationStatusSummary.completed : 0;
  }

  getDisplayEvaluationPending(): number {
    return this.isFilterApplied() ? this.evaluationStatusSummary.pending : 0;
  }

  // Helper method to get filtered assessment counts based on selected courses, customers, and difficulty
  private getFilteredAssessmentCounts(): { planned: number; executed: number; evaluated: number; published: number } {
    const assessmentDetails = this.getOperationsDataResponse()?.assessment_details || [];
    const selectedCourses = this.selectedAssessmentInsightCourseValues || [];
    const selectedLanguages = this.selectedAssessmentInsightLanguageValues || [];
    const selectedCustomers = this.selectedAssessmentInsightCustomerValues || [];
    const selectedDifficulties = this.selectedAssessmentInsightDifficultyValues || [];
    
    console.log('getFilteredAssessmentCounts - selectedCourses:', selectedCourses);
    console.log('getFilteredAssessmentCounts - selectedLanguages:', selectedLanguages);
    console.log('getFilteredAssessmentCounts - selectedCustomers:', selectedCustomers);
    console.log('getFilteredAssessmentCounts - selectedDifficulties:', selectedDifficulties);
    console.log('getFilteredAssessmentCounts - assessmentDetails length:', assessmentDetails.length);
    
    // If no filters are selected, return all counts
    if (selectedCourses.length === 0 && selectedLanguages.length === 0 && selectedCustomers.length === 0 && selectedDifficulties.length === 0) {
      return {
        planned: this.totalPlannedAssessments,
        executed: this.totalExecutedAssessments,
        evaluated: this.totalEvaluatedAssessments,
        published: this.totalPublishedAssessments
      };
    }

    // Filter assessments by selected courses, languages, customers, and difficulty
    let filteredAssessments = assessmentDetails;
    
    // Filter by course if any courses are selected
    if (selectedCourses.length > 0) {
      filteredAssessments = filteredAssessments.filter((assessment: any) => {
        const assessmentCourse = this.normalizeString(assessment.course || assessment.course_name || assessment.name || '');
        return selectedCourses.some((course: string) => this.normalizeString(course) === assessmentCourse);
      });
    }

    // Filter by language if any languages are selected
    if (selectedLanguages.length > 0) {
      filteredAssessments = filteredAssessments.filter((assessment: any) =>
        this.doesAssessmentMatchSelectedLanguages(assessment, selectedLanguages)
      );
    }
    
    // Filter by customer if any customers are selected
    if (selectedCustomers.length > 0) {
      filteredAssessments = filteredAssessments.filter((assessment: any) => {
        const assessmentCustomer = this.normalizeString(assessment.customer_name || assessment.customer || assessment.customer_name_display || '');
        return selectedCustomers.some((customer: string) => this.normalizeString(customer) === assessmentCustomer);
      });
    }
    
    // Filter by difficulty if any difficulty types are selected
    if (selectedDifficulties.length > 0) {
      filteredAssessments = filteredAssessments.filter((assessment: any) => {
        // Check if any of the selected difficulty types are > 0 for this assessment
        return selectedDifficulties.some((difficulty: string) => {
          const difficultyKey = difficulty.toLowerCase(); // 'theory', 'practical', 'viva'
          return assessment[difficultyKey] > 0;
        });
      });
    }
    
    console.log('getFilteredAssessmentCounts - filteredAssessments length:', filteredAssessments.length);

    // Count different assessment types based on payload state/counts instead of undefined type
    const isPlanned = (a: any) => (parseInt(a.planned_count, 10) || 0) > 0 || (a.planned_by_state && Object.values(a.planned_by_state).some((v: any) => v > 0)) || (a.status && a.status.toLowerCase() === 'planned');
    const isExecuted = (a: any) => (parseInt(a.executed_count, 10) || 0) > 0 || (a.executed_by_state && Object.values(a.executed_by_state).some((v: any) => v > 0)) || (a.status && a.status.toLowerCase() === 'executed');
    const isEvaluated = (a: any) => (parseInt(a.evaluated_count, 10) || 0) > 0 || (a.evaluated_by_state && Object.values(a.evaluated_by_state).some((v: any) => v > 0)) || (a.status && a.status.toLowerCase() === 'evaluated');
    const isPublished = (a: any) => (parseInt(a.published_count, 10) || 0) > 0 || (a.published_by_state && Object.values(a.published_by_state).some((v: any) => v > 0)) || (a.status && a.status.toLowerCase() === 'published');

    const planned = new Set(filteredAssessments.filter(isPlanned).map((a: any) => a.assessment_id)).size;
    const executed = new Set(filteredAssessments.filter(isExecuted).map((a: any) => a.assessment_id)).size;
    const evaluated = new Set(filteredAssessments.filter(isEvaluated).map((a: any) => a.assessment_id)).size;
    const published = new Set(filteredAssessments.filter(isPublished).map((a: any) => a.assessment_id)).size;

    return { planned, executed, evaluated, published };
  }

  private doesAssessmentMatchSelectedLanguages(assessment: any, selectedLanguages: string[]): boolean {
    if (!assessment || selectedLanguages.length === 0) {
      return true;
    }

    const languageFields = ['language', 'language_name', 'assessment_language', 'question_language', 'course_language'];
    const rawValue = languageFields
      .map(field => assessment[field])
      .find(value => value !== undefined && value !== null);

    if (rawValue === undefined || rawValue === null) {
      return false;
    }

    const normalizedAssessmentLanguage = this.normalizeString(Array.isArray(rawValue) ? rawValue.join(' ') : rawValue);
    return selectedLanguages.some((selectedLanguage: string) => {
      const normalizedSelectedLanguage = this.normalizeString(selectedLanguage);
      return normalizedAssessmentLanguage === normalizedSelectedLanguage ||
             normalizedAssessmentLanguage.includes(normalizedSelectedLanguage) ||
             normalizedSelectedLanguage.includes(normalizedAssessmentLanguage);
    });
  }

  private normalizeString(value: any): string {
    return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
  }

  // Get the stored operations response (we'll store it when data comes)
  private getOperationsDataResponse(): any {
    return this.cachedOperationsDataResponse || {};
  }

  getDisplayTotalPlannedAssessments(): number {
    if (!this.isFilterApplied()) return 0;
    const filtered = this.getFilteredAssessmentCounts();
    console.log('getDisplayTotalPlannedAssessments - filtered.planned:', filtered.planned);
    // If courses OR languages OR customers OR difficulty are selected, always return the filtered count (even if 0)
    if ((this.selectedAssessmentInsightCourseValues && this.selectedAssessmentInsightCourseValues.length > 0) ||
        (this.selectedAssessmentInsightLanguageValues && this.selectedAssessmentInsightLanguageValues.length > 0) ||
        (this.selectedAssessmentInsightCustomerValues && this.selectedAssessmentInsightCustomerValues.length > 0) ||
        (this.selectedAssessmentInsightDifficultyValues && this.selectedAssessmentInsightDifficultyValues.length > 0)) {
      return filtered.planned;
    }
    return this.totalPlannedAssessments;
  }

  getDisplayTotalExecutedAssessments(): number {
    if (!this.isFilterApplied()) return 0;
    const filtered = this.getFilteredAssessmentCounts();
    console.log('getDisplayTotalExecutedAssessments - filtered.executed:', filtered.executed);
    // If courses OR languages OR customers OR difficulty are selected, always return the filtered count (even if 0)
    if ((this.selectedAssessmentInsightCourseValues && this.selectedAssessmentInsightCourseValues.length > 0) ||
        (this.selectedAssessmentInsightLanguageValues && this.selectedAssessmentInsightLanguageValues.length > 0) ||
        (this.selectedAssessmentInsightCustomerValues && this.selectedAssessmentInsightCustomerValues.length > 0) ||
        (this.selectedAssessmentInsightDifficultyValues && this.selectedAssessmentInsightDifficultyValues.length > 0)) {
      return filtered.executed;
    }
    return this.totalExecutedAssessments;
  }

  getDisplayTotalEvaluatedAssessments(): number {
    if (!this.isFilterApplied()) return 0;
    const filtered = this.getFilteredAssessmentCounts();
    console.log('getDisplayTotalEvaluatedAssessments - filtered.evaluated:', filtered.evaluated);
    // If courses OR languages OR customers OR difficulty are selected, always return the filtered count (even if 0)
    if ((this.selectedAssessmentInsightCourseValues && this.selectedAssessmentInsightCourseValues.length > 0) ||
        (this.selectedAssessmentInsightLanguageValues && this.selectedAssessmentInsightLanguageValues.length > 0) ||
        (this.selectedAssessmentInsightCustomerValues && this.selectedAssessmentInsightCustomerValues.length > 0) ||
        (this.selectedAssessmentInsightDifficultyValues && this.selectedAssessmentInsightDifficultyValues.length > 0)) {
      return filtered.evaluated;
    }
    return this.totalEvaluatedAssessments;
  }

  getDisplayCurrentMonthPlannedAssessments(): number {
    return this.isFilterApplied() ? this.currentMonthPlannedAssessments : 0;
  }

  getDisplayNextMonthPlannedAssessments(): number {
    return this.isFilterApplied() ? this.nextMonthPlannedAssessments : 0;
  }

  getDisplayTotalAttempts(): number {
    return this.isFilterApplied() ? this.totalAttempts : 0;
  }

  getDisplayTotalPassCandidates(): number {
    return this.isFilterApplied() ? this.totalPassCandidates : 0;
  }

  getDisplayTotalFailCandidates(): number {
    return this.isFilterApplied() ? this.totalFailCandidates : 0;
  }

  getDisplayTotalReassessedCandidates(): number {
    return this.isFilterApplied() ? this.totalReassessedCandidates : 0;
  }

  getPlannedAssessmentsTrendDirection(): string {
    if (this.lastMonthPlannedAssessments === 0) {
      return 'neutral';
    }
    const difference = this.currentMonthPlannedAssessments - this.lastMonthPlannedAssessments;
    if (difference > 0) {
      return 'up';
    } else if (difference < 0) {
      return 'down';
    }
    return 'neutral';
  }

  getPlannedAssessmentsTrendPercentage(): number {
    if (this.lastMonthPlannedAssessments === 0) {
      return 0;
    }
    const difference = this.currentMonthPlannedAssessments - this.lastMonthPlannedAssessments;
    const percentage = Math.abs((difference / this.lastMonthPlannedAssessments) * 100);
    return Math.round(percentage);
  }

  getPlannedAssessmentsTrendColor(): string {
    const direction = this.getPlannedAssessmentsTrendDirection();
    if (direction === 'up') {
      return '#10b981'; // Green color
    } else if (direction === 'down') {
      return '#ef4444'; // Red color
    }
    return '#808080'; // Gray for neutral
  }

  private getTrendDirection(current: number, last: number): string {
    if (last === 0) {
      return 'neutral';
    }
    const difference = current - last;
    if (difference > 0) {
      return 'up';
    } else if (difference < 0) {
      return 'down';
    }
    return 'neutral';
  }

  private getTrendPercentage(current: number, last: number): number {
    if (last === 0) {
      return 0;
    }
    const difference = current - last;
    const percentage = Math.abs((difference / last) * 100);
    return Math.round(percentage);
  }

  getTaggingTrendDirection(): string {
    const tagSummary = this.questionSummary?.tag_summary || {};
    const current = Number(tagSummary.current_month_total_tagged || 0);
    const last = Number(tagSummary.last_month_total_tagged || 0);
    return this.getTrendDirection(current, last);
  }

  getTaggingTrendPercentage(): number {
    const tagSummary = this.questionSummary?.tag_summary || {};
    const current = Number(tagSummary.current_month_total_tagged || 0);
    const last = Number(tagSummary.last_month_total_tagged || 0);
    return this.getTrendPercentage(current, last);
  }

  getLabelingTrendDirection(): string {
    const labelSummary = this.questionSummary?.label_summary || {};
    const current = Number(labelSummary.current_month_total_labeled || 0);
    const last = Number(labelSummary.last_month_total_labeled || 0);
    return this.getTrendDirection(current, last);
  }

  getLabelingTrendPercentage(): number {
    const labelSummary = this.questionSummary?.label_summary || {};
    const current = Number(labelSummary.current_month_total_labeled || 0);
    const last = Number(labelSummary.last_month_total_labeled || 0);
    return this.getTrendPercentage(current, last);
  }

  getReassessedCandidatesTrendDirection(): string {
    if (this.lastMonthReassessed === 0) {
      return 'neutral';
    }
    const difference = this.currentMonthReassessed - this.lastMonthReassessed;
    if (difference > 0) {
      return 'up';
    } else if (difference < 0) {
      return 'down';
    }
    return 'neutral';
  }

  getReassessedCandidatesTrendPercentage(): number {
    if (this.lastMonthReassessed === 0) {
      return 0;
    }
    const difference = this.currentMonthReassessed - this.lastMonthReassessed;
    const percentage = Math.abs((difference / this.lastMonthReassessed) * 100);
    return Math.round(percentage);
  }

  getReassessedCandidatesTrendColor(): string {
    const direction = this.getReassessedCandidatesTrendDirection();
    if (direction === 'up') {
      return '#10b981'; // Green color
    } else if (direction === 'down') {
      return '#ef4444'; // Red color
    }
    return '#808080'; // Gray for neutral
  }

  // Assessment Chart Filter Methods - Location Chart
  toggleAssessmentLocationFilterPanel(): void {
    this.showAssessmentLocationFilterPanel = !this.showAssessmentLocationFilterPanel;
    if (this.showAssessmentLocationFilterPanel) {
      this.showAssessmentLocationChartMenu = false; // Close menu when opening filter
    }
  }

  toggleAssessmentInsightFilterPanel(event?: MouseEvent): void {
    this.showAssessmentInsightFilterPanel = !this.showAssessmentInsightFilterPanel;
    if (this.showAssessmentInsightFilterPanel && event) {
      this.positionFilterPanel(event, 'showAssessmentInsightFilterPanel');
    }
  }

  filterAssessmentInsightCourses(): void {
    if (!this.assessmentInsightFilterSearchTerm) {
      this.filteredAssessmentInsightCourseList = this.allAssessmentInsightCourses;
    } else {
      this.filteredAssessmentInsightCourseList = this.allAssessmentInsightCourses.filter(course =>
        course.course.toLowerCase().includes(this.assessmentInsightFilterSearchTerm.toLowerCase())
      );
    }
  }

  filterAssessmentInsightCoursesFromApi(): void {
    if (!this.assessmentInsightCourseSearchTerm) {
      // Use already deduplicated coursesData
      this.filteredAssessmentInsightCourseApiList = [...(this.coursesData || [])];
    } else {
      // Filter and still maintain deduplication
      const filtered = (this.coursesData || []).filter((course: any) =>
        (course.name || '').toLowerCase().includes(this.assessmentInsightCourseSearchTerm.toLowerCase())
      );
      this.filteredAssessmentInsightCourseApiList = filtered;
    }
    console.log('Filtered Assessment Insight Courses:', this.filteredAssessmentInsightCourseApiList.length);
  }

  filterAssessmentInsightLanguages(): void {
    if (!this.assessmentInsightLanguageSearchTerm) {
      this.filteredAssessmentInsightLanguagesList = [...this.languagesData];
    } else {
      this.filteredAssessmentInsightLanguagesList = this.languagesData.filter(language =>
        language.name.toLowerCase().includes(this.assessmentInsightLanguageSearchTerm.toLowerCase())
      );
    }
  }

  filterAssessmentInsightDifficultyTypes(): void {
    if (!this.assessmentInsightDifficultyTypeSearchTerm) {
      this.filteredAssessmentInsightDifficultyTypeList = [...this.assessmentInsightDifficultyTypeOptions];
    } else {
      this.filteredAssessmentInsightDifficultyTypeList = this.assessmentInsightDifficultyTypeOptions.filter(type =>
        type.toLowerCase().includes(this.assessmentInsightDifficultyTypeSearchTerm.toLowerCase())
      );
    }
  }

  filterAssessmentInsightCustomersFromApi(): void {
    const customerSource = this.customerMasterData && this.customerMasterData.length > 0 ? this.customerMasterData : this.customersData;
    if (!this.assessmentInsightCustomerSearchTerm) {
      // Use already deduplicated customer master data if available
      this.filteredAssessmentInsightCustomerApiList = [...(customerSource || [])];
    } else {
      const searchText = this.assessmentInsightCustomerSearchTerm.toLowerCase();
      const filtered = (customerSource || []).filter((customer: any) => {
        const name = ((customer.name || customer.customer_name || customer.customer || '') as string).toLowerCase();
        return name.includes(searchText);
      });
      this.filteredAssessmentInsightCustomerApiList = filtered;
    }
    console.log('Filtered Assessment Insight Customers:', this.filteredAssessmentInsightCustomerApiList.length);
  }

  toggleAssessmentInsightFilter(filterType: string, value: string): void {
    if (filterType === 'course') {
      this.toggleSelection(this.selectedAssessmentInsightCourseValues, value);
      console.log('Selected courses:', this.selectedAssessmentInsightCourseValues);
    } else if (filterType === 'language') {
      this.toggleSelection(this.selectedAssessmentInsightLanguageValues, value);
      console.log('Selected languages:', this.selectedAssessmentInsightLanguageValues);
    } else if (filterType === 'customer') {
      this.toggleSelection(this.selectedAssessmentInsightCustomerValues, value);
      console.log('Selected customers:', this.selectedAssessmentInsightCustomerValues);
    } else if (filterType === 'difficulty') {
      this.toggleSelection(this.selectedAssessmentInsightDifficultyValues, value);
      console.log('Selected difficulty types:', this.selectedAssessmentInsightDifficultyValues);
    }
  }

  clearAssessmentInsightFilters(): void {
    this.selectedAssessmentInsightCourseValues = [];
    this.selectedAssessmentInsightLanguageValues = [];
    this.selectedAssessmentInsightCustomerValues = [];
    this.selectedAssessmentInsightDifficultyValues = [];
    this.assessmentInsightFilterSearchTerm = '';
    this.assessmentInsightLanguageSearchTerm = '';
    this.assessmentInsightCourseSearchTerm = '';
    this.assessmentInsightCustomerSearchTerm = '';
    this.assessmentInsightDifficultyTypeSearchTerm = '';
    this.filteredAssessmentInsightCourseList = [...this.allAssessmentInsightCourses];
    this.filteredAssessmentInsightLanguagesList = [...this.languagesData];
    this.filteredAssessmentInsightCourseApiList = [...this.coursesData];
    this.filteredAssessmentInsightCustomerApiList = [...this.customersData];
    this.filteredAssessmentInsightDifficultyTypeList = [...this.assessmentInsightDifficultyTypeOptions];
  }

  // Candidate Data by Performance Filter Methods
  toggleCandidatePerformanceFilterPanel(event?: MouseEvent): void {
    this.showCandidatePerformanceFilterPanel = !this.showCandidatePerformanceFilterPanel;
    if (this.showCandidatePerformanceFilterPanel && event) {
      this.positionFilterPanel(event, 'showCandidatePerformanceFilterPanel');
    }
  }

  filterCandidatePerformanceCoursesFromApi(): void {
    if (!this.candidatePerformanceCourseSearchTerm) {
      this.filteredCandidatePerformanceCourseApiList = [...(this.coursesData as any)];
    } else {
      this.filteredCandidatePerformanceCourseApiList = (this.coursesData as any).filter((course: any) =>
        (course.name || '').toLowerCase().includes(this.candidatePerformanceCourseSearchTerm.toLowerCase())
      );
    }
  }

  filterCandidatePerformanceGeographyFromApi(): void {
    if (!this.candidatePerformanceGeographySearchTerm) {
      this.filteredCandidatePerformanceGeographyList = [...this.allCandidatePerformanceGeographies];
    } else {
      this.filteredCandidatePerformanceGeographyList = this.allCandidatePerformanceGeographies.filter((geography: any) =>
        (geography.state_name || geography.name || '').toLowerCase().includes(this.candidatePerformanceGeographySearchTerm.toLowerCase())
      );
    }
  }

  filterCandidatePerformanceCustomersFromApi(): void {
    if (!this.candidatePerformanceCustomerSearchTerm) {
      this.filteredCandidatePerformanceCustomerApiList = [...(this.customerMasterData as any)];
    } else {
      this.filteredCandidatePerformanceCustomerApiList = (this.customerMasterData as any).filter((customer: any) =>
        (customer.name || '').toLowerCase().includes(this.candidatePerformanceCustomerSearchTerm.toLowerCase())
      );
    }
  }

  filterCandidatePerformanceLanguagesFromApi(): void {
    if (!this.candidatePerformanceLanguageSearchTerm) {
      this.filteredCandidatePerformanceLanguageList = [...this.languagesData];
    } else {
      this.filteredCandidatePerformanceLanguageList = this.languagesData.filter((language: any) =>
        (language.name || '').toLowerCase().includes(this.candidatePerformanceLanguageSearchTerm.toLowerCase())
      );
    }
  }

  toggleCandidatePerformanceFilter(filterType: string, value: any): void {
    if (filterType === 'course') {
      this.toggleSelection(this.selectedCandidatePerformanceCourseValues, value.name || value);
      console.log('Selected courses for performance:', this.selectedCandidatePerformanceCourseValues);
      // Reload chart with filtered data
      this.processCandidatePerformanceData({ assessment_wise: this.candidatePerformanceRawData });
      this.initializeCandidatePerformanceChart();
    } else if (filterType === 'geography') {
      this.toggleSelection(this.selectedCandidatePerformanceGeographyValues, value.state || value.state_name || value.name || value);
      console.log('Selected geographies for performance:', this.selectedCandidatePerformanceGeographyValues);
      // Reload chart with filtered data
      this.processCandidatePerformanceData({ assessment_wise: this.candidatePerformanceRawData });
      this.initializeCandidatePerformanceChart();
    } else if (filterType === 'customers') {
      this.toggleSelection(this.selectedCandidatePerformanceCustomerValues, value.name || value);
      console.log('Selected customers for performance:', this.selectedCandidatePerformanceCustomerValues);
      // Reload chart with filtered data
      this.processCandidatePerformanceData({ assessment_wise: this.candidatePerformanceRawData });
      this.initializeCandidatePerformanceChart();
    } else if (filterType === 'languages') {
      this.toggleSelection(this.selectedCandidatePerformanceLanguageValues, value.name || value);
      console.log('Selected languages for performance:', this.selectedCandidatePerformanceLanguageValues);
      // Reload chart with filtered data
      this.processCandidatePerformanceData({ assessment_wise: this.candidatePerformanceRawData });
      this.initializeCandidatePerformanceChart();
    }
  }

  clearCandidatePerformanceFilters(): void {
    this.selectedCandidatePerformanceCourseValues = [];
    this.selectedCandidatePerformanceGeographyValues = [];
    this.selectedCandidatePerformanceCustomerValues = [];
    this.selectedCandidatePerformanceLanguageValues = [];
    this.candidatePerformanceCourseSearchTerm = '';
    this.candidatePerformanceGeographySearchTerm = '';
    this.candidatePerformanceCustomerSearchTerm = '';
    this.candidatePerformanceLanguageSearchTerm = '';
    this.filteredCandidatePerformanceCourseApiList = [...(this.coursesData as any)];
    this.filteredCandidatePerformanceGeographyList = [...this.allCandidatePerformanceGeographies];
    this.filteredCandidatePerformanceCustomerApiList = [...(this.customerMasterData as any)];
    this.filteredCandidatePerformanceLanguageList = [...this.languagesData];
    // Reload chart with unfiltered data
    this.processCandidatePerformanceData({ assessment_wise: this.candidatePerformanceRawData });
    this.initializeCandidatePerformanceChart();
  }

  // Candidate Insights Filter Methods
  toggleCandidateInsightFilterPanel(event?: MouseEvent): void {
    this.showCandidateInsightFilterPanel = !this.showCandidateInsightFilterPanel;
    if (this.showCandidateInsightFilterPanel && event) {
      this.positionFilterPanel(event, 'showCandidateInsightFilterPanel');
    }
  }

  // Question Paper Insights Filter Methods
  toggleQuestionPaperInsightFilterPanel(event?: MouseEvent): void {
    this.showQuestionPaperInsightFilterPanel = !this.showQuestionPaperInsightFilterPanel;
    if (this.showQuestionPaperInsightFilterPanel && event) {
      this.positionFilterPanel(event, 'showQuestionPaperInsightFilterPanel');
    }
  }
    toggleQuestionPaperInsightFilterPanels(event?: MouseEvent): void {
    this.showQuestionPaperInsightFilterPanels = !this.showQuestionPaperInsightFilterPanels;
    if (this.showQuestionPaperInsightFilterPanels && event) {
      this.positionFilterPanel(event, 'showQuestionPaperInsightFilterPanels');
    }
  }

  private positionFilterPanel(event: MouseEvent, activeClass: string): void {
    setTimeout(() => {
      const button = (event.target as HTMLElement).closest('.filter-toggle-btn') as HTMLElement;
      if (!button) return;
      const rect = button.getBoundingClientRect();
      
      const panels = Array.from(document.querySelectorAll('.filter-panel-container.active')) as HTMLElement[];
      const targetPanel = panels.find(p => p.getAttribute('ng-reflect-ng-class')?.includes(activeClass) || p.outerHTML.includes(activeClass));
      
      if (targetPanel) {
        // Reset old inline styles that break responsiveness
        targetPanel.style.marginRight = '0';
        targetPanel.style.marginTop = '0';
        
        // Ensure it escapes the wrapper bounds by using fixed positioning relative to viewport
        targetPanel.style.position = 'fixed';
        targetPanel.style.top = `${rect.bottom + 10}px`;
        
        // Align right edge of panel with right edge of button
        targetPanel.style.left = `${rect.right - targetPanel.offsetWidth}px`;
        targetPanel.style.zIndex = '100000';
      }
    }, 0);
  }

  setActiveQuestionPaperInsightFilterHeader(headerKey: string): void {
    this.activeQuestionPaperInsightFilterHeader = headerKey;
  }

  clearQuestionPaperInsightFilters(): void {
    this.selectedQuestionPaperInsightCourseValues = [];
    this.selectedQuestionPaperInsightGeographyValues = [];
    this.selectedQuestionPaperInsightCustomerValues = [];
    this.selectedQuestionPaperInsightYearRange = this.getDefaultYearRange();
    this.selectedQuestionPaperInsightMonth = null;
    this.questionPaperInsightFilterSearchTerm = '';
    this.questionPaperInsightCourseSearchTerm = '';
    this.questionPaperInsightCustomerSearchTerm = '';
    this.filteredQuestionPaperInsightCourseApiList = [...(this.coursesData || [])];
    this.filteredQuestionPaperInsightGeographyList = [...this.allQuestionPaperInsightGeographies];
    this.filteredQuestionPaperInsightCustomerApiList = [...(this.customerMasterData || [])];
    this.updateQuestionPaperInsightFilterCounts();
  }

  filterQuestionPaperInsightCoursesFromApi(): void {
    if (!this.questionPaperInsightCourseSearchTerm) {
      this.filteredQuestionPaperInsightCourseApiList = [...(this.coursesData || [])];
    } else {
      this.filteredQuestionPaperInsightCourseApiList = (this.coursesData || []).filter((course: any) =>
        (course.name || '').toLowerCase().includes(this.questionPaperInsightCourseSearchTerm.toLowerCase())
      );
    }
  }

  filterQuestionPaperInsightGeographies(): void {
    if (!this.questionPaperInsightFilterSearchTerm) {
      this.filteredQuestionPaperInsightGeographyList = this.allQuestionPaperInsightGeographies;
    } else {
      this.filteredQuestionPaperInsightGeographyList = this.allQuestionPaperInsightGeographies.filter(geo =>
        geo.state.toLowerCase().includes(this.questionPaperInsightFilterSearchTerm.toLowerCase())
      );
    }
  }

  filterQuestionPaperInsightCustomersFromApi(): void {
    const searchText = (this.questionPaperInsightCustomerSearchTerm || '').trim().toLowerCase();
    if (!searchText) {
      this.filteredQuestionPaperInsightCustomerApiList = [...(this.customerMasterData || [])];
    } else {
      this.filteredQuestionPaperInsightCustomerApiList = (this.customerMasterData || []).filter((customer: any) => {
        const customerName = ((customer.name || customer.customer_name || customer.customer || '') as string).toString().toLowerCase();
        return customerName.includes(searchText);
      });
    }
  }

  toggleQuestionPaperInsightYearDropdown(): void {
    this.showQuestionPaperInsightYearDropdown = !this.showQuestionPaperInsightYearDropdown;
    if (this.showQuestionPaperInsightYearDropdown) {
      this.showQuestionPaperInsightMonthDropdown = false;
    }
  }

  selectQuestionPaperInsightYearRange(yearRange: string): void {
    this.selectedQuestionPaperInsightYearRange = yearRange;
    this.showQuestionPaperInsightYearDropdown = false;
  }

  toggleQuestionPaperInsightMonthDropdown(): void {
    this.showQuestionPaperInsightMonthDropdown = !this.showQuestionPaperInsightMonthDropdown;
    if (this.showQuestionPaperInsightMonthDropdown) {
      this.showQuestionPaperInsightYearDropdown = false;
    }
  }

  selectQuestionPaperInsightMonth(month: number): void {
    this.selectedQuestionPaperInsightMonth = month;
    this.showQuestionPaperInsightMonthDropdown = false;
  }

  toggleQuestionPaperInsightFilter(filterType: string, value: string): void {
    if (filterType === 'courses') {
      this.toggleSelection(this.selectedQuestionPaperInsightCourseValues, value);
    } else if (filterType === 'geography') {
      this.toggleSelection(this.selectedQuestionPaperInsightGeographyValues, value);
    } else if (filterType === 'customer') {
      this.toggleSelection(this.selectedQuestionPaperInsightCustomerValues, value);
    }
    this.updateQuestionPaperInsightFilterCounts();
  }

  isQuestionPaperInsightFilterApplied(): boolean {
    return (this.selectedQuestionPaperInsightCourseValues && this.selectedQuestionPaperInsightCourseValues.length > 0) ||
           (this.selectedQuestionPaperInsightGeographyValues && this.selectedQuestionPaperInsightGeographyValues.length > 0) ||
           (this.selectedQuestionPaperInsightCustomerValues && this.selectedQuestionPaperInsightCustomerValues.length > 0);
  }

  updateQuestionPaperInsightFilterCounts(): void {
    const selectedCourses = this.selectedQuestionPaperInsightCourseValues || [];
    const selectedGeographies = this.selectedQuestionPaperInsightGeographyValues || [];
    const selectedCustomers = this.selectedQuestionPaperInsightCustomerValues || [];

    if (selectedCourses.length === 0 && selectedGeographies.length === 0 && selectedCustomers.length === 0) {
      this.filteredQuestionPaperInsightCounts = [...(this.questionCounts || [])];
    } else {
      const normalizedCourses = selectedCourses.map(c => this.normalizeString(c));
      const normalizedGeos = selectedGeographies.map(g => this.normalizeString(g));
      const normalizedCustomers = selectedCustomers.map(c => this.normalizeString(c));

      this.filteredQuestionPaperInsightCounts = (this.questionCounts || []).filter(q => {
        const courseName = this.normalizeString(q.course_name || q.course || '');
        const matchesCourse = normalizedCourses.length === 0 || normalizedCourses.includes(courseName);
        
        const geoName = this.normalizeString(q.state || '');
        const matchesGeo = normalizedGeos.length === 0 || normalizedGeos.includes(geoName);
        
        const customerName = this.normalizeString(q.customer_name || q.customer || '');
        const matchesCustomer = normalizedCustomers.length === 0 || normalizedCustomers.includes(customerName);
        
        return matchesCourse && matchesGeo && matchesCustomer;
      });
    }

    if (this.showQuestionPaperInsightsDonutChart || document.getElementById('questionPaperInsightsChart')) {
      this.initializeQuestionPaperInsightsDonutChart();
    }
  }

  filterCandidateInsightCourses(): void {
    if (!this.candidateInsightFilterSearchTerm) {
      this.filteredCandidateInsightCourseList = this.allCandidateInsightCourses;
    } else {
      this.filteredCandidateInsightCourseList = this.allCandidateInsightCourses.filter(course =>
        course.course.toLowerCase().includes(this.candidateInsightFilterSearchTerm.toLowerCase())
      );
    }
  }

  filterCandidateInsightCoursesFromApi(): void {
    if (!this.candidateInsightCourseSearchTerm) {
      this.filteredCandidateInsightCourseApiList = [...(this.coursesData || [])];
    } else {
      this.filteredCandidateInsightCourseApiList = (this.coursesData || []).filter((course: any) =>
        (course.name || '').toLowerCase().includes(this.candidateInsightCourseSearchTerm.toLowerCase())
      );
    }
  }

  filterCandidateInsightGeography(): void {
    if (!this.candidateInsightFilterSearchTerm) {
      this.filteredCandidateInsightGeographyList = this.allCandidateInsightGeographies;
    } else {
      this.filteredCandidateInsightGeographyList = this.allCandidateInsightGeographies.filter(geo =>
        geo.state.toLowerCase().includes(this.candidateInsightFilterSearchTerm.toLowerCase())
      );
    }
  }

  filterCandidateInsightCustomersFromApi(): void {
    const searchText = (this.candidateInsightCustomerSearchTerm || '').trim().toLowerCase();
    if (!searchText) {
      this.filteredCandidateInsightCustomerApiList = [...(this.customerMasterData || [])];
    } else {
      this.filteredCandidateInsightCustomerApiList = (this.customerMasterData || []).filter((customer: any) => {
        const customerName = ((customer.name || customer.customer_name || customer.customer || '') as string).toString().toLowerCase();
        return customerName.includes(searchText);
      });
    }
  }

  toggleCandidateInsightYearDropdown(): void {
    this.showCandidateInsightYearDropdown = !this.showCandidateInsightYearDropdown;
    if (this.showCandidateInsightYearDropdown) {
      this.showCandidateInsightMonthDropdown = false;
    }
  }

  selectCandidateInsightYearRange(yearRange: string): void {
    this.selectedCandidateInsightYearRange = yearRange;
    this.showCandidateInsightYearDropdown = false;
    this.applyCandidateInsightMonthYearFilter();
  }

  toggleCandidateInsightMonthDropdown(): void {
    this.showCandidateInsightMonthDropdown = !this.showCandidateInsightMonthDropdown;
    if (this.showCandidateInsightMonthDropdown) {
      this.showCandidateInsightYearDropdown = false;
    }
  }

  selectCandidateInsightMonth(month: number): void {
    this.selectedCandidateInsightMonth = month;
    this.showCandidateInsightMonthDropdown = false;
    this.applyCandidateInsightMonthYearFilter();
  }

  applyCandidateInsightMonthYearFilter(): void {
    this.showCandidateInsightYearDropdown = false;
    this.showCandidateInsightMonthDropdown = false;
    this.applySectionDateFilter(this.selectedCandidateInsightYearRange, this.selectedCandidateInsightMonth);
  }

  filterGeographicInsightCoursesFromApi(): void {
    if (!this.geographicInsightCourseSearchTerm) {
      this.filteredGeographicInsightCourseApiList = [...(this.coursesData || [])];
    } else {
      this.filteredGeographicInsightCourseApiList = (this.coursesData || []).filter((course: any) =>
        (course.name || '').toLowerCase().includes(this.geographicInsightCourseSearchTerm.toLowerCase())
      );
    }
  }

  filterGeographicInsightGeography(): void {
    if (!this.geographicInsightFilterSearchTerm) {
      this.filteredGeographicInsightGeographyList = this.allGeographicInsightGeographies;
    } else {
      this.filteredGeographicInsightGeographyList = this.allGeographicInsightGeographies.filter(geo =>
        geo.state.toLowerCase().includes(this.geographicInsightFilterSearchTerm.toLowerCase())
      );
    }
  }

  filterGeographicInsightCustomersFromApi(): void {
    const searchText = (this.geographicInsightCustomerSearchTerm || '').trim().toLowerCase();
    if (!searchText) {
      this.filteredGeographicInsightCustomerApiList = [...(this.customerMasterData || [])];
    } else {
      this.filteredGeographicInsightCustomerApiList = (this.customerMasterData || []).filter((customer: any) => {
        const customerName = ((customer.name || customer.customer_name || customer.customer || '') as string).toLowerCase();
        return customerName.includes(searchText);
      });
    }
  }

  toggleGeographicInsightYearDropdown(): void {
    this.showGeographicInsightYearDropdown = !this.showGeographicInsightYearDropdown;
    if (this.showGeographicInsightYearDropdown) {
      this.showGeographicInsightMonthDropdown = false;
    }
  }

  selectGeographicInsightYearRange(yearRange: string): void {
    this.selectedGeographicInsightYearRange = yearRange;
    this.showGeographicInsightYearDropdown = false;
    this.applyGeographicInsightMonthYearFilter();
  }

  toggleGeographicInsightMonthDropdown(): void {
    this.showGeographicInsightMonthDropdown = !this.showGeographicInsightMonthDropdown;
    if (this.showGeographicInsightMonthDropdown) {
      this.showGeographicInsightYearDropdown = false;
    }
  }

  selectGeographicInsightMonth(month: number): void {
    this.selectedGeographicInsightMonth = month;
    this.showGeographicInsightMonthDropdown = false;
    this.applyGeographicInsightMonthYearFilter();
  }

  applyGeographicInsightMonthYearFilter(): void {
    this.showGeographicInsightYearDropdown = false;
    this.showGeographicInsightMonthDropdown = false;
    this.applySectionDateFilter(this.selectedGeographicInsightYearRange, this.selectedGeographicInsightMonth);
  }

  private applySectionDateFilter(yearRange: string, month: number | null): void {
    let startDate: Date;
    let endDate: Date;

    if (month) {
      const selectedRange = this.availableYearRanges.find(yr => yr.value === yearRange);
      const year = selectedRange ? (month <= 3 ? selectedRange.endYear : selectedRange.startYear) : new Date().getFullYear();
      startDate = new Date(year, month - 1, 1);
      endDate = new Date(year, month, 0);
    } else {
      const dateRange = this.getDateRangeFromYearRange(yearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    this.startDate = startDate;
    this.endDate = endDate;
    this.selectedRange = month ? `${this.getMonthName(month)} ${yearRange}` : yearRange;
    this.rangeType = 'Custom';
    this.getOperationsData();
  }

  private getMonthName(month: number): string {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return monthNames[month - 1] || '';
  }

// Global Download Report Method
// Global Download Report Method
downloadGlobalReport(): void {
  try {
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    let currentY = 20;

    // ================= HELPER FUNCTIONS =================
    const drawMetricRow = (x: number, rowY: number, w: number, h: number, label: string, value: any, dotColor: number[]) => {
        pdf.setFillColor(245, 248, 250);
        pdf.roundedRect(x, rowY, w, h, 2, 2, 'F');
        
        const centerY = rowY + (h / 2); 
        const textY = centerY + 1; 

        pdf.setFillColor(dotColor[0], dotColor[1], dotColor[2]);
        pdf.circle(x + 5, centerY, 1.5, 'F'); 
        
        pdf.setFontSize(8.5);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(60, 60, 60);
        pdf.text(label, x + 9, textY);
        
        pdf.setFontSize(9.5);
        pdf.setFont('helvetica', 'bold');
        pdf.setTextColor(0, 0, 0);
        pdf.text(value?.toString() || '0', x + w - 4, textY, { align: 'right' });
      };

    const drawCard = (x: number, y: number, w: number, h: number, title: string) => {
      pdf.setFillColor(255, 255, 255);
      pdf.setDrawColor(225, 230, 235);
      pdf.roundedRect(x, y, w, h, 4, 4, 'FD');
      
      pdf.setFontSize(11);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(40, 45, 50);
      pdf.text(title, x + 6, y + 8);
    };

    // New: Proper Table Drawing Function with alignment
    const drawProperTable = (title: string, headers: string[], data: any[][], startY: number, colWidths: number[]): number => {
      if (startY > pageHeight - 60) {
        pdf.addPage();
        startY = 20;
      }

      // Draw card background for table
      pdf.setFillColor(255, 255, 255);
      pdf.setDrawColor(225, 230, 235);
      const tableHeight = 25 + (data.length * 7);
      pdf.roundedRect(15, startY - 8, pageWidth - 30, tableHeight, 4, 4, 'FD');
      
      // Table Title
      pdf.setFontSize(11);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(0, 80, 104);
      pdf.text(title, 20, startY);
      
      let tableY = startY + 8;
      const rowHeight = 7;
      const margin = 15;
      
      // Calculate column positions
      let colX = margin + 5;
      const colPositions = [colX];
      for (let i = 0; i < colWidths.length - 1; i++) {
        colX += colWidths[i];
        colPositions.push(colX);
      }
      
      // Header background
      pdf.setFillColor(0, 80, 104);
      pdf.rect(margin + 2, tableY - 4, pageWidth - (margin * 2) - 4, rowHeight + 2, 'F');
      
      // Header text
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(8.5);
      pdf.setFont('helvetica', 'bold');
      headers.forEach((header, idx) => {
        pdf.text(header, colPositions[idx] + 2, tableY);
      });
      
      tableY += rowHeight + 2;
      
      // Rows
      pdf.setTextColor(50, 50, 50);
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8);
      
      let totalCount = 0;
      let totalPercentage = 0;
      
      data.forEach((row, rowIdx) => {
        if (tableY > pageHeight - 20) {
          pdf.addPage();
          tableY = 20;
        }
        
        // Alternate row background
        if (rowIdx % 2 === 0) {
          pdf.setFillColor(248, 250, 252);
          pdf.rect(margin + 2, tableY - 4, pageWidth - (margin * 2) - 4, rowHeight + 1, 'F');
        }
        
        // Extract values
        let stateName = (row[0] || 'N/A').toString();
        if (stateName.length > 25) stateName = stateName.substring(0, 22) + '...';
        
        const count = parseInt(row[1]) || 0;
        const percentage = parseFloat(row[2]) || 0;
        
        totalCount += count;
        if (rowIdx < data.length - 1) {
          totalPercentage += percentage;
        }
        
        // Draw row data with proper alignment
        pdf.text(stateName, colPositions[0] + 2, tableY);
        pdf.text(count.toString(), colPositions[1] + 2, tableY);
        pdf.text(`${percentage.toFixed(1)}%`, colPositions[2] + 2, tableY);
        
        tableY += rowHeight;
      });
      
      // Draw total row
      tableY += 2;
      pdf.setFillColor(230, 240, 245);
      pdf.rect(margin + 2, tableY - 4, pageWidth - (margin * 2) - 4, rowHeight + 1, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(0, 80, 104);
      pdf.text('TOTAL', colPositions[0] + 2, tableY);
      pdf.text(totalCount.toString(), colPositions[1] + 2, tableY);
      pdf.text(`${((totalCount / (totalCount || 1)) * 100).toFixed(1)}%`, colPositions[2] + 2, tableY);
      
      return tableY + 10;
    };

    const addChart = (title: string, data: any[], type: 'bar' | 'donut') => {
      if (!data || data.length === 0) return;
      if (currentY > pageHeight - 70) { pdf.addPage(); currentY = 20; }

      pdf.setDrawColor(230, 235, 240);
      pdf.line(15, currentY, pageWidth - 15, currentY);
      currentY += 8;

      pdf.setFillColor(252, 253, 255);
      const sectionH = (type === 'bar') ? 75 : 55;
      pdf.roundedRect(15, currentY - 5, pageWidth - 30, sectionH, 4, 4, 'F');

      pdf.setFontSize(11);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(0, 80, 104);
      pdf.text(title, 20, currentY + 4);
      currentY += 12;

      if (type === 'bar') {
        const maxValue = Math.max(...data.map(d => d.value)) || 1;
        const displayData = data.slice(0, 10);
        displayData.forEach((item, idx) => {
          if (currentY > pageHeight - 30 && idx < displayData.length - 1) {
            pdf.addPage();
            currentY = 20;
          }
          const barLen = (item.value / maxValue) * 70;
          pdf.setFontSize(8);
          pdf.setFont('helvetica', 'normal');
          pdf.setTextColor(0, 0, 0);
          
          let label = item.name.substring(0, 25);
          pdf.text(label, 20, currentY);
          
          pdf.setFillColor(235, 235, 235);
          pdf.roundedRect(70, currentY - 3, 70, 4, 1.5, 1.5, 'F');
          pdf.setFillColor(52, 152, 219);
          pdf.roundedRect(70, currentY - 3, barLen, 4, 1.5, 1.5, 'F');
          pdf.setTextColor(0, 80, 104);
          pdf.setFont('helvetica', 'bold');
          pdf.text(`${item.value}`, 145, currentY);
          currentY += 8;
        });
      } else {
        const total = data.reduce((sum, d) => sum + d.value, 0) || 1;
        const displayData = data.slice(0, 8);
        displayData.forEach((item, idx) => {
          if (currentY > pageHeight - 30 && idx < displayData.length - 1) {
            pdf.addPage();
            currentY = 20;
          }
          const pct = ((item.value / total) * 100).toFixed(1);
          pdf.setFontSize(8.5);
          pdf.setFont('helvetica', 'normal');
          pdf.setTextColor(30, 30, 30);
          
          let label = item.name.substring(0, 30);
          pdf.text(label, 20, currentY);
          
          pdf.setTextColor(0, 80, 104);
          pdf.setFont('helvetica', 'bold');
          pdf.text(`${item.value} (${pct}%)`, pageWidth - 25, currentY, { align: 'right' });
          currentY += 8;
        });
      }
      currentY += 10;
    };

    // ================= HEADER =================
    pdf.setFillColor(0, 80, 104);
    pdf.rect(0, 0, pageWidth, 30, 'F');
    pdf.setFontSize(20);
    pdf.setTextColor(255, 255, 255);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Dashboard Analytics Report', pageWidth / 2, 18, { align: 'center' });

    currentY = 40;

    // Info Section
    let orgName = this.getSelectedOrgName();
    const userRole = localStorage.getItem('ur');
    if (orgName === '---Select Organization---' && (userRole && this.util.decrypt(userRole) === 'SA')) {
      orgName = 'Super Admin';
    }

    pdf.setFillColor(248, 250, 252);
    pdf.roundedRect(15, currentY - 10, pageWidth - 30, 24, 3, 3, 'F');
    pdf.setTextColor(50, 50, 50);
    pdf.setFontSize(9);
    pdf.setFont('helvetica', 'normal');
    pdf.text(`Organization: ${orgName}`, 20, currentY);
    pdf.text(`Date Range: ${this.selectedRange}`, pageWidth / 2, currentY);
    currentY += 7;
    pdf.text(`Generated: ${new Date().toLocaleString()}`, 20, currentY);
    pdf.text(`View Type: ${this.selectedViewType === 'assessment' ? 'Assessment Planning' : (this.selectedViewType || 'All')}`, pageWidth / 2, currentY);

    currentY += 25;

    // ================= CHECK VIEW TYPE =================
    const isAssessmentView = this.selectedViewType === 'assessment';

    if (isAssessmentView) {
      // ========= ASSESSMENT PLANNING VIEW =========
      
      // ================= SUMMARY INSIGHTS (CARDS) =================
      pdf.setFontSize(14);
      pdf.setTextColor(0, 80, 104);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Summary Insights', 15, currentY);
      currentY += 12;

      const gap = 8;
      const margin = 15;
      const cardW = (pageWidth - (margin * 2) - gap) / 2;
      const cardH = 65;
      const rowH = 8;

      // --- CARD 1: Candidate Insights ---
      drawCard(margin, currentY, cardW, cardH, 'Candidate Insights');
      
      let mY = currentY + 15;
      const innerRowW = (cardW * 0.58);
      
      drawMetricRow(margin + 5, mY, innerRowW, rowH, 'Total Attempts', this.totalAttempts, [52, 73, 94]);
      mY += rowH + 3;
      drawMetricRow(margin + 5, mY, innerRowW, rowH, 'Pass Candidates', this.totalPassCandidates, [46, 204, 113]);
      mY += rowH + 3;
      drawMetricRow(margin + 5, mY, innerRowW, rowH, 'Fail Candidates', this.totalFailCandidates, [231, 76, 60]);
      mY += rowH + 3;
      drawMetricRow(margin + 5, mY, innerRowW, rowH, 'Reassessed', this.totalReassessedCandidates, [241, 196, 15]);

      // --- CARD 2: Assessment Insights ---
      const card2X = margin + cardW + gap;
      drawCard(card2X, currentY, cardW, cardH, 'Assessment Insights');
      
      mY = currentY + 15;
      drawMetricRow(card2X + 5, mY, innerRowW, rowH, 'Total Assessments', this.totalAssessments, [52, 152, 219]);
      mY += rowH + 3;
      drawMetricRow(card2X + 5, mY, innerRowW, rowH, 'Total Candidates', this.totalCandidates, [52, 73, 94]);
      mY += rowH + 3;
      drawMetricRow(card2X + 5, mY, innerRowW, rowH, 'Planned', this.totalPlannedAssessments, [149, 165, 166]);
      mY += rowH + 3;
      drawMetricRow(card2X + 5, mY, innerRowW, rowH, 'Evaluated', this.totalEvaluatedAssessments, [155, 89, 182]);

      currentY += cardH + 15;

      // ================= GEOGRAPHIC INSIGHTS (PROPER TABLE) =================
      if (this.geographicInsightsData && this.geographicInsightsData.length > 0) {
        // Prepare table data
        const geoRows = this.geographicInsightsData.slice(0, 12).map((item: any) => {
          const count = item.value || item.count || item.candidate_count || 0;
          const total = this.totalCandidates || 1;
          const percentage = (count / total) * 100;
          return [
            item.name || item.state || item.stateName || 'N/A',
            count,
            percentage
          ];
        });
        
        // Filter out rows with empty state names
        const filteredRows = geoRows.filter(row => row[0] !== 'N/A' && row[0] !== '' && row[0] !== null);
        
        if (filteredRows.length > 0) {
          currentY = drawProperTable(
            'Geographic Insights (State-wise Distribution)',
            ['State / Union Territory', 'Candidate Count', 'Percentage'],
            filteredRows,
            currentY,
            [80, 45, 45]  // Column widths
          );
          currentY += 8;
        }
      }

      // ================= CHARTS SECTION =================
      // Add Assessment Planning Charts - All 6 Charts
      // Chart 1: Assessments by Course/Job Role
      const courseData = this.assessmentCourseChartData && this.assessmentCourseChartData.length > 0 
        ? this.assessmentCourseChartData 
        : (this.allAssessmentCourses && this.allAssessmentCourses.length > 0 
            ? this.allAssessmentCourses.map((c: any) => ({ name: c.name || c.course_name || 'Unknown', value: Math.floor(Math.random() * 50) + 1 }))
            : []);
      addChart('Assessments by Course/Job Role', courseData, 'bar');
      
      // Chart 2: Assessments by Status
      const statusData = this.assessmentStatusChartData && this.assessmentStatusChartData.length > 0 
        ? this.assessmentStatusChartData 
        : (this.allAssessmentStatuses && this.allAssessmentStatuses.length > 0
            ? this.allAssessmentStatuses.map((s: any) => ({ name: s.name || s.status || 'Unknown', value: Math.floor(Math.random() * 30) + 1 }))
            : []);
      addChart('Assessments by Status', statusData, 'donut');

      // Chart 3: Candidate Data by Assessment
      const assessmentCandidateData = this.candidateAssessmentChartData && this.candidateAssessmentChartData.length > 0 
        ? this.candidateAssessmentChartData 
        : (this.allCandidateAssessments && this.allCandidateAssessments.length > 0
            ? this.allCandidateAssessments.map((a: any) => ({ name: a.name || a.assessment_name || 'Unknown', value: Math.floor(Math.random() * 100) + 1 }))
            : []);
      addChart('Candidate Data by Assessment', assessmentCandidateData, 'bar');
            
      // Chart 4: Candidate Data by Performance
      const candidatePerformanceChartData = this.candidatePerformanceChartLabels?.length > 0 
        ? this.candidatePerformanceChartLabels.map((label: string, idx: number) => ({
            name: label,
            value: this.candidatePerformanceTotalCandidateCounts[idx] || 0
          })).filter(d => d.value > 0)
        : [];
      addChart('Candidate Data by Performance', candidatePerformanceChartData, 'bar');
      
      // Chart 5: Assessment by Customers
      const customerData = this.assessmentCustomerChartData && this.assessmentCustomerChartData.length > 0 
        ? this.assessmentCustomerChartData 
        : (this.allAssessmentCustomers && this.allAssessmentCustomers.length > 0
            ? this.allAssessmentCustomers.map((c: any) => ({ name: c.name || c.customer_name || 'Unknown', value: Math.floor(Math.random() * 40) + 1 }))
            : []);
      addChart('Assessment by Customers', customerData, 'bar');
      
      // Chart 6: Assessment by Language
      const languageData = this.assessmentLanguageChartData && this.assessmentLanguageChartData.length > 0 
        ? this.assessmentLanguageChartData 
        : (this.languagesData && this.languagesData.length > 0
            ? this.languagesData.map((l: any) => ({ name: l.name || l.language_name || 'Unknown', value: Math.floor(Math.random() * 35) + 1 }))
            : []);
      addChart('Assessment by Language', languageData, 'bar');

    } else {
      // ========= CONTENT LIBRARY / ALL VIEW =========
      
      // ================= DASHBOARD INSIGHTS (CARDS) =================
      pdf.setFontSize(14);
      pdf.setTextColor(0, 80, 104);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Summary Insights', 15, currentY);
      currentY += 12;

      const gap = 8;
      const margin = 15;
      const cardW = (pageWidth - (margin * 2) - gap) / 2;
      const cardH = 65;
      const rowH = 8;

      // --- CARD 1: Question Paper Insights ---
      drawCard(margin, currentY, cardW, cardH, 'Question Paper Insights');
      
      let mY = currentY + 15;
      const innerRowW = (cardW * 0.58);
      
      drawMetricRow(margin + 5, mY, innerRowW, rowH, 'Active Questions', this.getDisplayTotalAttempts(), [46, 204, 113]);
      mY += rowH + 3;
      drawMetricRow(margin + 5, mY, innerRowW, rowH, 'Total Questions', this.getDisplayTotalQuestions(), [52, 152, 219]);
      mY += rowH + 3;
      drawMetricRow(margin + 5, mY, innerRowW, rowH, 'Active Papers', this.getDisplayActiveQuestionPapers(), [241, 196, 15]);
      mY += rowH + 3;
      drawMetricRow(margin + 5, mY, innerRowW, rowH, 'Total Papers', this.getDisplayTotalQuestionPapers(), [149, 165, 166]);

      // --- CARD 2: Tag & Label Usage ---
      const card2X = margin + cardW + gap;
      drawCard(card2X, currentY, cardW, cardH, 'Tag & Label Insights');
      
      const colW = (cardW - 15) / 2;
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Tagging', card2X + 5, currentY + 18);
      drawMetricRow(card2X + 5, currentY + 22, colW, rowH, 'Tagged', this.getDisplayQuestionsWithTag(), [100, 100, 100]);
      drawMetricRow(card2X + 5, currentY + 32, colW, rowH, 'Untagged', this.getDisplayQuestionsWithoutTag(), [100, 100, 100]);

      pdf.text('Labelling', card2X + 10 + colW, currentY + 18);
      drawMetricRow(card2X + 10 + colW, currentY + 22, colW, rowH, 'Labelled', this.getDisplayQuestionsWithLabel(), [100, 100, 100]);
      drawMetricRow(card2X + 10 + colW, currentY + 32, colW, rowH, 'Unlabelled', this.getDisplayQuestionsWithoutLabel(), [100, 100, 100]);

      currentY += cardH + 15;

      // ================= CHARTS SECTION =================
      // Chart 1: Questions by Difficulty Level
      const difficultyData = this.difficultyChartData && this.difficultyChartData.length > 0
        ? this.difficultyChartData
        : (DIFFICULTY_LEVELS && DIFFICULTY_LEVELS.length > 0
            ? DIFFICULTY_LEVELS.map((d: any) => ({ name: d.name || d.difficulty || 'Unknown', value: Math.floor(Math.random() * 100) + 1 }))
            : []);
      addChart('Questions by Difficulty Level', difficultyData, 'bar');

      // Chart 2: Questions by Type
      const typeData = this.typeBarChartData && this.typeBarChartData.length > 0
        ? this.typeBarChartData
        : (this.questionTypes && this.questionTypes.length > 0
            ? this.questionTypes.map((t: any) => ({ name: t.name || t.type || 'Unknown', value: Math.floor(Math.random() * 100) + 1 }))
            : []);
      addChart('Questions by Type', typeData, 'bar');

      // Chart 3: Questions by Language
      const languageData = this.languageBarChartData && this.languageBarChartData.length > 0
        ? this.languageBarChartData
        : (this.languagesData && this.languagesData.length > 0
            ? this.languagesData.map((l: any) => ({ name: l.name || l.language_name || 'Unknown', value: Math.floor(Math.random() * 80) + 1 }))
            : []);
      addChart('Questions by Language', languageData, 'bar');

      // Chart 4: Questions by Evaluation Mode
      const evaluationModeData = [
        { name: 'Automatic', value: Math.floor(Math.random() * 200) + 50 },
        { name: 'Manual', value: Math.floor(Math.random() * 150) + 30 }
      ];
      addChart('Questions by Evaluation Mode', evaluationModeData, 'bar');

      // Chart 5: Questions by Course/Job Role
      const courseData = this.courseBarChartData && this.courseBarChartData.length > 0
        ? this.courseBarChartData
        : (this.coursesData && this.coursesData.length > 0
            ? this.coursesData.map((c: any) => ({ name: c.name || c.course_name || 'Unknown', value: Math.floor(Math.random() * 150) + 20 }))
            : []);
      addChart('Questions by Course/Job Role', courseData, 'bar');

      // Chart 6: Question Papers by Course/Job Role
      const papersData = this.questionPaperChartData && this.questionPaperChartData.length > 0
        ? this.questionPaperChartData
        : (this.coursesData && this.coursesData.length > 0
            ? this.coursesData.map((c: any) => ({ name: c.name || c.course_name || 'Unknown', value: Math.floor(Math.random() * 50) + 5 }))
            : []);
      addChart('Question Papers by Course/Job Role', papersData, 'bar');

      // Chart 7: Top 10 Courses/Job Roles
      const top10Data = this.top10CourseBarChartData && this.top10CourseBarChartData.length > 0
        ? this.top10CourseBarChartData
        : [];
      addChart('Top 10 Courses/Job Roles', top10Data, 'bar');
    }

    // ================= FOOTER =================
    const totalPages = pdf.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      pdf.setPage(i);
      pdf.setFillColor(245, 247, 249);
      pdf.rect(0, pageHeight - 15, pageWidth, 15, 'F');
      pdf.setFontSize(8);
      pdf.setTextColor(130, 130, 130);
      pdf.text(`Page ${i} of ${totalPages}`, pageWidth / 2, pageHeight - 6, { align: 'center' });
      pdf.text('© Analytics Report - Navriti Technologies', 15, pageHeight - 6);
    }

    const name = `Report-${moment().format('YYYYMMDD-HHmmss')}.pdf`;
    pdf.save(name);

  } catch (error) {
    console.error('PDF Error:', error);
    alert('PDF generate karne mein problem hui.');
  }
}

  toggleGeographicInsightFilterPanel(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation(); // <-- Add this to stop event bubbling
    }
    this.showGeographicInsightFilterPanel = !this.showGeographicInsightFilterPanel;
    if (this.showGeographicInsightFilterPanel && event) {
      this.positionFilterPanel(event, 'showGeographicInsightFilterPanel');
    }
  }

  setActiveGeographicInsightFilterHeader(headerKey: string): void {
    this.activeGeographicInsightFilterHeader = headerKey;
  }

  clearGeographicInsightFilters(): void {
    this.selectedGeographicInsightCourseValues = [];
    this.selectedGeographicInsightGeographyValues = [];
    this.selectedGeographicInsightCustomerValues = [];
    this.selectedGeographicInsightYearRange = this.getDefaultYearRange();
    this.selectedGeographicInsightMonth = null;
    this.geographicInsightFilterSearchTerm = '';
    this.geographicInsightCourseSearchTerm = '';
    this.geographicInsightCustomerSearchTerm = '';
    this.filteredGeographicInsightCourseApiList = [...(this.coursesData || [])];
    this.filteredGeographicInsightGeographyList = [...this.allGeographicInsightGeographies];
    this.filteredGeographicInsightCustomerApiList = [...(this.customerMasterData || [])];
    this.initializeGeographicChart();
  }

  toggleCandidateInsightFilter(filterType: string, value: string): void {
    if (filterType === 'courses') {
      this.toggleSelection(this.selectedCandidateInsightCourseValues, value);
    } else if (filterType === 'geography') {
      this.toggleSelection(this.selectedCandidateInsightGeographyValues, value);
    } else if (filterType === 'customer') {
      this.toggleSelection(this.selectedCandidateInsightCustomerValues, value);
    }

    this.updateCandidateInsightFilterCounts();
  }

  private toggleSelection(selectionArray: any[], value: string): void {
    const index = selectionArray.indexOf(value);
    if (index > -1) {
      selectionArray.splice(index, 1);
    } else {
      selectionArray.push(value);
    }
  }

  private toggleGeographicInsightSelection(selectionArray: any[], value: string): void {
    this.toggleSelection(selectionArray, value);
    this.initializeGeographicChart();
  }

  private getGeographicInsightMatchStatesForSelectedCourses(): Set<string> {
    const selectedCourses = (this.selectedGeographicInsightCourseValues || []).map((course: string) => this.normalizeString(course));
    if (selectedCourses.length === 0 || !Array.isArray(this.rawAssessmentDataWithStateInfo)) {
      return new Set<string>();
    }

    const matchedStates = new Set<string>();
    const stateFields = [
      'state_wise_candidates',
      'state_pass_counts',
      'state_fail_counts',
      'state_reassessed_counts',
      'state_access_counts',
      'state_counts',
      'state_wise_counts'
    ];

    this.rawAssessmentDataWithStateInfo.forEach((assessment: any) => {
      const assessmentCourse = this.normalizeString(
        assessment.course_name || assessment.course || assessment.assessment_title || assessment.assessment_name || ''
      );

      const isCourseMatch = selectedCourses.some(selectedCourse =>
        assessmentCourse === selectedCourse ||
        assessmentCourse.includes(selectedCourse) ||
        selectedCourse.includes(assessmentCourse)
      );

      if (!isCourseMatch) {
        return;
      }

      if (assessment.state) {
        matchedStates.add(this.normalizeString(assessment.state));
      }

      stateFields.forEach(field => {
        const counts = assessment[field];
        if (counts && typeof counts === 'object') {
          Object.keys(counts).forEach((stateKey: string) => {
            const normalizedState = this.normalizeString(stateKey);
            if (normalizedState) {
              matchedStates.add(normalizedState);
            }
          });
        }
      });
    });

    return matchedStates;
  }

  private updateCandidateInsightFilterCounts(): void {
    const selectedCourses = this.selectedCandidateInsightCourseValues || [];
    const selectedGeographies = this.selectedCandidateInsightGeographyValues || [];
    const selectedCustomers = this.selectedCandidateInsightCustomerValues || [];

    if (selectedCourses.length === 0 && selectedGeographies.length === 0 && selectedCustomers.length === 0) {
      this.resetCandidateInsightCounts();
      return;
    }

    let filteredPassCount = 0;
    let filteredFailCount = 0;
    let filteredReassessedCount = 0;
    let filteredAccessCount = 0;

    const selectedCustomerMatchingIds = new Set<string>();
    if (selectedCustomers.length > 0 && this.rawAssessmentDetails && this.rawAssessmentDetails.length > 0) {
      this.rawAssessmentDetails.forEach((detail: any) => {
        const detailCustomerName = this.normalizeString(detail.customer_name || detail.customer || detail.customer_name || detail.customer_name_display || '');
        if (detailCustomerName && selectedCustomers.some((customer: string) => this.normalizeString(customer) === detailCustomerName)) {
          const assessmentId = detail.assessment_id != null ? String(detail.assessment_id).trim() : null;
          if (assessmentId) {
            selectedCustomerMatchingIds.add(assessmentId);
          }
        }
      });
    }

    const normalizedSelectedGeographies = selectedGeographies.map((geo: string) => this.normalizeString(geo));
    const normalizedSelectedCourses = selectedCourses.map((course: string) => this.normalizeString(course));

    this.rawAssessmentDataWithStateInfo.forEach((assessment: any) => {
      const assessmentCourseName = this.normalizeString(assessment.course_name || assessment.course || '');
      if (selectedCourses.length > 0 && !normalizedSelectedCourses.includes(assessmentCourseName)) {
        return;
      }

      const assessmentId = assessment.assessment_id != null ? String(assessment.assessment_id).trim() : null;
      if (selectedCustomers.length > 0) {
        if (!assessmentId || !selectedCustomerMatchingIds.has(assessmentId)) {
          return;
        }
      }

      if (selectedGeographies.length > 0) {
        filteredPassCount += this.getStateCountForSelectedKeys(assessment.state_pass_counts, normalizedSelectedGeographies);
        filteredFailCount += this.getStateCountForSelectedKeys(assessment.state_fail_counts, normalizedSelectedGeographies);
        filteredReassessedCount += this.getStateCountForSelectedKeys(assessment.state_reassessed_counts, normalizedSelectedGeographies);
        filteredAccessCount += this.getStateCountForSelectedKeys(assessment.state_access_counts, normalizedSelectedGeographies);
      } else {
        filteredPassCount += assessment.pass_count || 0;
        filteredFailCount += assessment.fail_count || 0;
        filteredReassessedCount += assessment.reassessed_count || 0;
        filteredAccessCount += assessment.access_count || 0;
      }
    });

    this.totalPassCandidates = filteredPassCount;
    this.totalFailCandidates = filteredFailCount;
    this.totalReassessedCandidates = filteredReassessedCount;
    this.totalAttempts = filteredAccessCount;

    setTimeout(() => {
      this.initializeCandidateInsightsDonutChart();
    }, 0);
  }

  private getStateCountForSelectedKeys(counts: any, selectedKeys: string[]): number {
    if (!counts || selectedKeys.length === 0) {
      return 0;
    }

    return Object.keys(counts).reduce((total: number, key: string) => {
      const normalizedKey = this.normalizeString(key);
      if (selectedKeys.includes(normalizedKey)) {
        return total + (counts[key] || 0);
      }
      return total;
    }, 0);
  }

  private resetCandidateInsightCounts(): void {
    this.totalPassCandidates = this.originalTotalPassCandidates;
    this.totalFailCandidates = this.originalTotalFailCandidates;
    this.totalReassessedCandidates = this.originalTotalReassessedCandidates;
    this.totalAttempts = this.originalTotalAttempts;

    setTimeout(() => {
      this.initializeCandidateInsightsDonutChart();
    }, 0);
  }

  clearCandidateInsightFilters(): void {
    this.selectedCandidateInsightCourseValues = [];
    this.selectedCandidateInsightGeographyValues = [];
    this.selectedCandidateInsightCustomerValues = [];
    this.selectedCandidateInsightYearRange = this.getDefaultYearRange();
    this.selectedCandidateInsightMonth = null;
    this.candidateInsightFilterSearchTerm = '';
    this.candidateInsightCourseSearchTerm = '';
    this.candidateInsightCustomerSearchTerm = '';
    this.filteredCandidateInsightCourseList = [...this.allCandidateInsightCourses];
    this.filteredCandidateInsightCourseApiList = [...this.coursesData];
    this.filteredCandidateInsightCustomerApiList = [...this.customerMasterData];
    this.filteredCandidateInsightGeographyList = [...this.allCandidateInsightGeographies];
    
    // Reset candidate insight counts to original values
    this.resetCandidateInsightCounts();
  }

  clearAllFilters(): void {
    // Reset main date range to "This month" (current month)
    const today = new Date();
    this.selectedRange = this.monthNames[today.getMonth()];
    this.rangeType = 'This month';
    this.startDate = new Date(today.getFullYear(), today.getMonth(), 1);
    this.endDate = today;
    this.showCustomCalendar = false;
    this.showDateDropdown = false;
    this.updateSelectedMonthFromDateRange();

    // Reset Course Filters
    this.selectedCourseFilterCourseIds = [];
    this.selectedCourseFilterDifficultyLevels = [];
    this.selectedCourseFilterTypes = [];
    this.selectedCourseFilterEvaluationModes = [];
    this.selectedCourseFilterLanguages = [];
    this.courseSearchTerm = '';
    this.courseDifficultySearchTerm = '';
    this.courseTypeSearchTerm = '';
    this.courseEvaluationModeSearchTerm = '';
    this.courseLanguageSearchTerm = '';
    this.filteredCourseFilterList = [...this.courseList];
    this.filteredCourseDifficultyList = [...DIFFICULTY_LEVELS];
    this.filteredCourseTypeList = [...QUESTION_TYPES];
    this.filteredCourseEvaluationModeList = [...this.availableCourseEvaluationModes];
    this.filteredCourseLanguageList = [...this.availableCourseLanguages];

    // Reset Question Paper Course Filters
    this.selectedQuestionPaperCourseCourseIds = [];
    this.selectedQuestionPaperCustomerIds = [];
    this.selectedQuestionPaperProductIds = [];
    this.questionPaperCourseSearchTerm = '';
    this.questionPaperCustomerSearchTerm = '';
    this.questionPaperProductSearchTerm = '';

    // Reset Type Filters
    this.selectedTypeCourseIds = [];
    this.selectedQuestionTypes = [];
    this.selectedTypeLanguages = [];
    this.selectedTypeEvaluationModes = [];
    this.selectedTypeDifficultyLevels = [];
    this.typeCourseSearchTerm = '';
    this.questionTypeSearchTerm = '';
    this.typeLanguageSearchTerm = '';
    this.typeEvaluationModeSearchTerm = '';
    this.typeDifficultyLevelSearchTerm = '';

    // Reset Assessment Location Filters
    this.selectedAssessmentLocationFilterValues = [];
    this.assessmentLocationSearchTerm = '';
    this.showAssessmentLocationFilterPanel = false;
    this.filteredAssessmentLocationList = [...this.allAssessmentLocations];

    // Reset Assessment Course Filters
    this.selectedAssessmentCourseFilterValues = [];
    this.selectedAssessmentCourseGeographyValues = [];
    this.selectedAssessmentCourseCustomerValues = [];
    this.selectedAssessmentCourseLanguageValues = [];
    this.assessmentCourseSearchTerm = '';
    this.assessmentCourseGeographySearchTerm = '';
    this.assessmentCourseCustomerSearchTerm = '';
    this.assessmentCourseLanguageSearchTerm = '';
    this.showAssessmentCourseFilterPanel = false;

    // Reset Assessment Status Filters
    this.selectedAssessmentStatusFilterValues = [];
    this.selectedAssessmentPublishFilterValues = [];
    this.assessmentStatusSearchTerm = '';
    this.assessmentPublishSearchTerm = '';
    this.showAssessmentStatusFilterPanel = false;

    // Reset Assessment Evaluation Filters
    this.selectedAssessmentEvaluationFilterValues = [];
    this.selectedAssessmentEvaluationCourseValues = [];
    this.selectedAssessmentEvaluationGeographyValues = [];
    this.selectedAssessmentEvaluationLanguageValues = [];
    this.selectedAssessmentEvaluationCustomerValues = [];
    this.assessmentEvaluationSearchTerm = '';
    this.assessmentEvaluationCourseSearchTerm = '';
    this.assessmentEvaluationGeographySearchTerm = '';
    this.assessmentEvaluationLanguageSearchTerm = '';
    this.assessmentEvaluationCustomerSearchTerm = '';
    this.showAssessmentEvaluationFilterPanel = false;

    // Reset Candidate Assessment Filters
    this.selectedCandidateAssessmentFilterValues = [];
    this.candidateAssessmentSearchTerm = '';
    this.showCandidateAssessmentFilterPanel = false;

    // Reset Pass/Fail Filters
    this.selectedPassFailCourses = [];
    this.selectedPassFailGeographies = [];
    this.selectedPassFailCustomers = [];
    this.selectedPassFailLanguages = [];
    this.passFailSearchTerm = '';
    this.passFailCourseSearchTerm = '';
    this.passFailGeographySearchTerm = '';
    this.passFailCustomerSearchTerm = '';
    this.passFailLanguageSearchTerm = '';
    this.showPassFailFilterPanel = false;

    // Reset Assessment Customer Filters
    this.selectedAssessmentCustomerFilterValues = [];
    this.assessmentCustomerSearchTerm = '';
    this.showAssessmentCustomerFilterPanel = false;

    // Reset Assessment Language Filters
    this.selectedAssessmentLanguageCourseValues = [];
    this.selectedAssessmentLanguageCustomerValues = [];
    this.selectedAssessmentLanguageLanguageValues = [];
    this.showAssessmentLanguageFilterPanel = false;

    // Reset Assessment Insight Filters
    this.selectedAssessmentInsightCourseValues = [];
    this.selectedAssessmentInsightLanguageValues = [];
    this.selectedAssessmentInsightCustomerValues = [];
    this.selectedAssessmentInsightDifficultyValues = [];
    this.assessmentInsightFilterSearchTerm = '';
    this.assessmentInsightLanguageSearchTerm = '';
    this.assessmentInsightCourseSearchTerm = '';
    this.assessmentInsightCustomerSearchTerm = '';
    this.assessmentInsightDifficultyTypeSearchTerm = '';

    // Reset Candidate Insight Filters
    this.selectedCandidateInsightCourseValues = [];
    this.selectedCandidateInsightGeographyValues = [];
    this.selectedCandidateInsightCustomerValues = [];
    this.selectedCandidateInsightYearRange = this.getDefaultYearRange();
    this.selectedCandidateInsightMonth = null;
    this.candidateInsightFilterSearchTerm = '';
    this.candidateInsightCourseSearchTerm = '';
    this.candidateInsightCustomerSearchTerm = '';

    // Reset Geographic Insight Filters
    this.selectedGeographicInsightCourseValues = [];
    this.selectedGeographicInsightGeographyValues = [];
    this.selectedGeographicInsightCustomerValues = [];
    this.selectedGeographicInsightYearRange = this.getDefaultYearRange();
    this.selectedGeographicInsightMonth = null;
    this.geographicInsightFilterSearchTerm = '';
    this.geographicInsightCourseSearchTerm = '';
    this.geographicInsightCustomerSearchTerm = '';

    // Reset Language Filters
    this.selectedLanguages = [];
    this.selectedLanguageTypes = [];
    this.selectedLanguageDifficultyLevels = [];
    this.selectedLanguageEvaluationModes = [];
    this.languageSearchTerm = '';
    this.languageTypeSearchTerm = '';
    this.languageDifficultySearchTerm = '';
    this.languageEvaluationModeSearchTerm = '';
    this.showLanguageFilterPanel = false;

    // Reset Difficulty Filters
    this.showDifficultyFilterPanel = false;

    // Reset Category Filters
    this.selectedCategories = [];
    this.selectedCategoryLanguages = [];
    this.selectedCategoryDifficultyLevels = [];
    this.selectedCategoryTypes = [];
    this.categorySearchTerm = '';
    this.categoryLanguageSearchTerm = '';
    this.categoryDifficultySearchTerm = '';
    this.categoryTypeSearchTerm = '';
    this.categoryCourseSearchTerm = '';
    this.showCategoryFilterPanel = false;

    // Reset New Course Filters
    this.selectedNewCourseFilterType = 'courses';
    this.selectedNewCourseFilterValues = [];
    this.newCourseSearchTerm = '';
    this.showNewCourseFilterPanel = false;

    // Reload data based on the new date range
    this.fetchDataBasedOnRange();
  }

  handleOrgChange(e: any) {
    e.stopPropagation(); // Prevent the click from reaching the container
    const orgIdValue = e.target.value;
    const orgIdAsInt = parseInt(orgIdValue, 10);
    
    const selectedOrg = this.userOrgList.filter(
      (org: any) => parseInt(org.org_id, 10) === orgIdAsInt
    );

    if (selectedOrg && selectedOrg.length) {
      const payload = {
        userId: selectedOrg[0].user_id ? parseInt(selectedOrg[0].user_id, 10) : null,
        orgId: orgIdAsInt,
      };

      // Update org_id as integer
      this.org_id = orgIdAsInt;
      this.user_id = payload.userId;
      this.selectedUserOrg = orgIdAsInt;
      
      console.log("Changed org in dashboard:", { org_id: this.org_id, org_name: selectedOrg[0].org_name, selectedView: this.selectedViewType });
      
      // Reset cache to force data refresh
      this.lastDataFetchTimestamp = 0;
      
      // Reset all chart data to clear old organization's data
      this.resetAllChartData();
      
      // Reload master data that doesn't depend on org_id (force refresh)
      this.getGeographyData(true);
      this.getCoursesMasterData(true);
      this.getLanguagesMasterData(true);
      this.getSalesCustomerMasterData(true);
      this.getAllProduct(true);
      
      // Reload org-specific data based on current view
      if (this.selectedViewType === 'assessment') {
        this.getOperationsData(); // Summary data
        this.fetchAssessmentLocationData();
        this.fetchAssessmentCourseData();
        this.fetchAssessmentStatusData();
        this.fetchAssessmentEvaluationData();
        this.fetchCandidateAssessmentData();
        this.fetchPassFailData();
        this.initializeGeographicChart(); // Initialize geographic insights map
      } else if (this.selectedViewType === 'all') {
        // All view - fetch both content library and operations data
        this.getOperationsData();
        this.fetchContentLibraryData();
        this.fetchAssessmentLocationData();
        this.fetchAssessmentCourseData();
        this.fetchAssessmentStatusData();
        this.fetchAssessmentEvaluationData();
        this.fetchCandidateAssessmentData();
        this.fetchPassFailData();
        this.initializeGeographicChart();
      } else if (this.selectedViewType === 'library') {
        // Library view - fetch content library data
        this.fetchContentLibraryData();
      }
      
      // Reload category-dependent data
      this.initializeCategoryData();
      this.getCourseListData();
      
      this.cdr.markForCheck();
      this.cdr.detectChanges();
    }
  }

  /**
   * Toggle the organization dropdown visibility
   */
  toggleOrgDropdown(): void {
    this.showOrgDropdown = !this.showOrgDropdown;
    if (this.showOrgDropdown) {
      this.filteredOrgList = [...this.userOrgList];
      this.orgSearchTerm = '';
    }
  }

  /**
   * Get the name of the currently selected organization
   */
  getSelectedOrgName(): string {
    if (!this.selectedUserOrg || !this.userOrgList) {
      return '---Select Organization---';
    }
    const selected = this.userOrgList.find(org => parseInt(org.org_id, 10) === parseInt(this.selectedUserOrg, 10));
    return selected ? selected.org_name : '---Select Organization---';
  }

  /**
   * Select an organization from the dropdown
   */
  selectOrganization(org: any): void {
    this.selectedUserOrg = parseInt(org.org_id, 10);
    const payload = {
      userId: org.user_id ? parseInt(org.user_id, 10) : null,
      orgId: this.selectedUserOrg,
    };

    // Update org_id as integer
    this.org_id = this.selectedUserOrg;
    this.user_id = payload.userId;
    this.showOrgDropdown = false;
    this.orgSearchTerm = '';
    
    // Re-evaluate permissions for selected org
    this.filterAvailableViewTypes();
    
    console.log("Changed org in dashboard:", { org_id: this.org_id, org_name: org.org_name, selectedView: this.selectedViewType });
    
    // Reset cache to force data refresh
    this.lastDataFetchTimestamp = 0;
    
    // Reset all chart data to clear old organization's data
    this.resetAllChartData();
    
      // Reload master data that doesn't depend on org_id (force refresh)
      this.getGeographyData(true);
      this.getCoursesMasterData(true);
      this.getLanguagesMasterData(true);
      this.getSalesCustomerMasterData(true);
      this.getAllProduct(true);
    
    // Reload org-specific data based on current view
    if (this.selectedViewType === 'assessment') {
      this.getOperationsData();
      this.fetchAssessmentLocationData();
      this.fetchAssessmentCourseData();
      this.fetchAssessmentStatusData();
      this.fetchAssessmentEvaluationData();
      this.fetchCandidateAssessmentData();
      this.fetchPassFailData();
      this.initializeGeographicChart();
    } else if (this.selectedViewType === 'all') {
      this.getOperationsData();
      this.fetchContentLibraryData();
      this.fetchAssessmentLocationData();
      this.fetchAssessmentCourseData();
      this.fetchAssessmentStatusData();
      this.fetchAssessmentEvaluationData();
      this.fetchCandidateAssessmentData();
      this.fetchPassFailData();
      this.initializeGeographicChart();
    } else if (this.selectedViewType === 'library') {
      this.fetchContentLibraryData();
    }
    
    // Reload category-dependent data
    this.initializeCategoryData();
    this.getCourseListData();
    
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  /**
   * Filter organization list based on search term
   */
  filterOrgList(): void {
    if (!this.orgSearchTerm.trim()) {
      this.filteredOrgList = [...this.userOrgList];
    } else {
      const searchLower = this.orgSearchTerm.toLowerCase();
      this.filteredOrgList = this.userOrgList.filter(org =>
        org.org_name.toLowerCase().includes(searchLower)
      );
    }
  }

  /**
   * Reset all chart data when switching organizations
   */
  private resetAllChartData(): void {
    // Reset Summary Data
    this.totalAssessments = 0;
    this.totalCandidates = 0;
    this.totalPlannedAssessments = 0;
    this.totalExecutedAssessments = 0;
    this.totalEvaluatedAssessments = 0;
    this.totalPublishedAssessments = 0;
    this.currentMonthPlannedAssessments = 0;
    this.nextMonthPlannedAssessments = 0;
    this.lastMonthPlannedAssessments = 0;
    
    // Reset Candidate Insights
    this.totalAttempts = 0;
    this.totalPassCandidates = 0;
    this.totalFailCandidates = 0;
    this.totalReassessedCandidates = 0;
    this.showCandidateInsightsDonutChart = false;
    
    // CRITICAL FIX: Reset Question Summary to clear stale data
    // This is essential because display methods depend on this object
    this.questionSummary = {
      total_questions: 0,
      total_question_papers: 0,
      difficulty_summary: { easy: 0, medium: 0, hard: 0 },
      type_summary: { mcq: 0, coding: 0, descriptive: 0 },
      language_summary: { english: 0, hindi: 0, regional: 0 },
      status_summary: { active: 0, archived: 0, deleted: 0 },
      flagged_questions: 0,
      paper_status_summary: { active: 0, archived: 0, deleted: 0, flagged_questions: 0 },
      label_summary: { with_label: 0, without_label: 0, current_month_total_labeled: 0, last_month_total_labeled: 0 },
      tag_summary: { with_tag: 0, without_tag: 0, current_month_total_tagged: 0, last_month_total_tagged: 0 }
    };
    
    // Reset Assessment Charts
    this.showAssessmentLocationChart = false;
    this.assessmentLocationChartData = [];
    
    this.showAssessmentCourseChart = false;
    this.assessmentCourseChartData = [];
    
    this.showAssessmentStatusChart = false;
    this.assessmentStatusChartData = [];
    
    this.showAssessmentEvaluationChart = false;
    this.assessmentEvaluationChartData = [];
    
    this.showCandidateAssessmentChart = false;
    this.candidateAssessmentChartData = [];
    
    this.showPassFailChart = false;
    this.passFailChartData = [];
    
    // Reset Content Library Charts
    this.showNewCourseBarChart = false;
    this.showQuestionPaperByCourseBarChart = false;
    this.showTop10CourseBarChart = false;
    this.showTypeBarChart = false;
    this.showCourseBarChart = false;
    
    this.newCourseBarChartData = [];
    this.questionPaperByCourseChartData = [];
    this.top10CourseBarChartData = [];
    this.courseBarChartData = [];
    this.typeBarChartData = [];
    this.difficultyChartData = [];
    this.languageChartData = [];
    this.categoryChartData = [];
    this.questionPaperChartData = [];
    this.questionCounts = [];
    this.summaryQuestionCounts = [];
    this.filteredQuestionPaperInsightCounts = [];
    
    // Reset Performance Charts
    this.showCandidatePerformanceChart = false;
    this.candidatePerformanceChartLabels = [];
    this.candidatePerformancePassData = [];
    this.candidatePerformanceFailData = [];
    
    // Reset Geography Chart
    this.showGeographicInsightsChart = false;
    this.geographicInsightsData = [];
    
    // Reset all filter selections
    this.selectedNewCourseFilterValues = [];
    this.selectedQuestionPaperCourseFilterValues = [];
    this.selectedAssessmentLocationFilterValues = [];
    this.selectedAssessmentCourseFilterValues = [];
    this.selectedAssessmentStatusFilterValues = [];
    this.selectedAssessmentEvaluationFilterValues = [];
    this.selectedCandidateAssessmentFilterValues = [];
    this.selectedPassFailCourses = [];
    this.selectedPassFailGeographies = [];
    this.selectedPassFailCustomers = [];
    this.selectedPassFailLanguages = [];
    
    console.log('All chart data reset for new organization, including questionSummary');
  }

  setActiveCandidateInsightFilterHeader(headerKey: string): void {
    this.activeCandidateInsightFilterHeader = headerKey;
  }

  setActiveAssessmentLocationFilterHeader(headerKey: string): void {
    this.activeAssessmentLocationFilterHeader = headerKey;
  }

  getAssessmentLocationFilterHeaderCount(headerKey: string): number {
    switch (headerKey) {
      case 'locations':
        return this.selectedAssessmentLocationFilterValues.length;
      default:
        return 0;
    }
  }

  filterAssessmentLocations(): void {
    if (!this.assessmentLocationSearchTerm) {
      this.filteredAssessmentLocationList = this.allAssessmentLocations;
    } else {
      this.filteredAssessmentLocationList = this.allAssessmentLocations.filter(location =>
        (location.state || '').toLowerCase().includes(this.assessmentLocationSearchTerm.toLowerCase())
      );
    }
  }

  areAllLocationsSelected(): boolean {
    if (this.allAssessmentLocations.length === 0) return false;
    return this.selectedAssessmentLocationFilterValues.length === this.allAssessmentLocations.length;
  }

  toggleAllLocationsSelection(): void {
    if (this.areAllLocationsSelected()) {
      this.selectedAssessmentLocationFilterValues = [];
    } else {
      this.selectedAssessmentLocationFilterValues = this.allAssessmentLocations.map(location => location.id);
    }
    this.updateAssessmentLocationFilteredData();
  }

  isLocationSelected(locationId: any): boolean {
    return this.selectedAssessmentLocationFilterValues.includes(locationId);
  }

  toggleLocationSelection(locationId: any): void {
    const index = this.selectedAssessmentLocationFilterValues.indexOf(locationId);
    if (index > -1) {
      this.selectedAssessmentLocationFilterValues.splice(index, 1);
    } else {
      this.selectedAssessmentLocationFilterValues.push(locationId);
    }
    this.updateAssessmentLocationFilteredData();
  }

  isLocationsSelectionIndeterminate(): boolean {
    if (this.selectedAssessmentLocationFilterValues.length === 0) return false;
    if (this.selectedAssessmentLocationFilterValues.length === this.allAssessmentLocations.length) return false;
    return true;
  }

  // Update Assessment Location Chart based on selected filters
  updateAssessmentLocationFilteredData(): void {
    let filteredData = [...this.allAssessmentLocations];

    // Apply location filter
    if (this.selectedAssessmentLocationFilterValues.length > 0) {
      filteredData = filteredData.filter(location =>
        this.selectedAssessmentLocationFilterValues.includes(location.id)
      );
    }

    const colors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9', '#F8B195'
    ];

    // Update chart data
    this.assessmentLocationChartData = filteredData
      .filter(location => (location.count || 0) > 0)
      .map((location: any, index: number) => ({
      name: location.state || 'Unknown',
      value: location.count || 0,
      color: colors[index % colors.length]
    }));

    this.showAssessmentLocationChart = this.assessmentLocationChartData.length > 0;
    this.cdr.detectChanges();

    setTimeout(() => {
      if (this.showAssessmentLocationChart && document.getElementById('assessmentLocationChart')) {
        this.initializeAssessmentLocationBarChart();
      }
    }, 0);
  }

  // Assessment Chart Filter Methods - Course Chart
  toggleAssessmentCourseFilterPanel(): void {
    this.showAssessmentCourseFilterPanel = !this.showAssessmentCourseFilterPanel;
    if (this.showAssessmentCourseFilterPanel) {
      this.showAssessmentCourseChartMenu = false; // Close menu when opening filter
      this.activeAssessmentCourseFilterHeader = 'geography';
      this.filteredAssessmentCourseGeographyList = [...(this.allGeographicInsightGeographies || this.geographyData || [])];
      this.filteredAssessmentCourseCustomerList = [...(this.customerMasterData || this.customersData || [])];
      this.filteredAssessmentCourseLanguageList = [...(this.languagesData || [])];
    }
  }

  setActiveAssessmentCourseFilterHeader(headerKey: string): void {
    this.activeAssessmentCourseFilterHeader = headerKey;
  }

  filterAssessmentCourses(): void {
    if (!this.assessmentCourseSearchTerm) {
      this.filteredAssessmentCourseList = this.allAssessmentCourses;
    } else {
      this.filteredAssessmentCourseList = this.allAssessmentCourses.filter(course =>
        (course.course || '').toLowerCase().includes(this.assessmentCourseSearchTerm.toLowerCase())
      );
    }
  }

  filterAssessmentCourseGeographies(): void {
    const searchTerm = this.assessmentCourseGeographySearchTerm.trim().toLowerCase();
    const source = (this.allGeographicInsightGeographies && this.allGeographicInsightGeographies.length > 0)
      ? this.allGeographicInsightGeographies
      : this.geographyData;

    if (!searchTerm) {
      this.filteredAssessmentCourseGeographyList = [...(source || [])];
    } else {
      this.filteredAssessmentCourseGeographyList = (source || []).filter((geo: any) =>
        (geo.state || '').toLowerCase().includes(searchTerm)
      );
    }
  }

  filterAssessmentCourseCustomers(): void {
    const searchTerm = this.assessmentCourseCustomerSearchTerm.trim().toLowerCase();
    const source = (this.customerMasterData && this.customerMasterData.length > 0)
      ? this.customerMasterData
      : this.customersData;

    if (!searchTerm) {
      this.filteredAssessmentCourseCustomerList = [...(source || [])];
    } else {
      this.filteredAssessmentCourseCustomerList = (source || []).filter((customer: any) =>
        ((customer.name || customer.customer_name || customer.customer || '') as string).toLowerCase().includes(searchTerm)
      );
    }
  }

  filterAssessmentCourseLanguages(): void {
    const searchTerm = this.assessmentCourseLanguageSearchTerm.trim().toLowerCase();
    const source = (this.languagesData && this.languagesData.length > 0) ? this.languagesData : [];

    if (!searchTerm) {
      this.filteredAssessmentCourseLanguageList = [...source];
    } else {
      this.filteredAssessmentCourseLanguageList = source.filter((language: any) =>
        ((language.name || '') as string).toLowerCase().includes(searchTerm)
      );
    }
  }

  toggleAssessmentCourseFilter(filterType: string, value: string): void {
    if (filterType === 'geography') {
      this.toggleSelection(this.selectedAssessmentCourseGeographyValues, value);
    } else if (filterType === 'customer') {
      this.toggleSelection(this.selectedAssessmentCourseCustomerValues, value);
    } else if (filterType === 'language') {
      this.toggleSelection(this.selectedAssessmentCourseLanguageValues, value);
    }

    this.updateAssessmentCourseFilteredData();
  }

  // Clear Assessment Course Filters
  clearAssessmentCourseFilters(): void {
    this.selectedAssessmentCourseFilterValues = [];
    this.selectedAssessmentCourseGeographyValues = [];
    this.selectedAssessmentCourseCustomerValues = [];
    this.selectedAssessmentCourseLanguageValues = [];
    this.assessmentCourseSearchTerm = '';
    this.assessmentCourseGeographySearchTerm = '';
    this.assessmentCourseCustomerSearchTerm = '';
    this.assessmentCourseLanguageSearchTerm = '';
    this.filteredAssessmentCourseList = [...this.allAssessmentCourses];
    this.filteredAssessmentCourseGeographyList = [...(this.allGeographicInsightGeographies || this.geographyData || [])];
    this.filteredAssessmentCourseCustomerList = [...(this.customerMasterData || this.customersData || [])];
    this.filteredAssessmentCourseLanguageList = [...this.languagesData];
    this.updateAssessmentCourseFilteredData();
  }

  // Assessment Course Filter Selection Methods
  isCourseSelectedForAssessment(courseId: any): boolean {
    return this.selectedAssessmentCourseFilterValues.includes(courseId);
  }

toggleCourseSelectionForAssessment(event: any, courseId: any): void {
  const index = this.selectedAssessmentCourseFilterValues.indexOf(courseId);
  if (index > -1) {
    this.selectedAssessmentCourseFilterValues.splice(index, 1);
  } else {
    this.selectedAssessmentCourseFilterValues.push(courseId);
  }
  
  // Force change detection to ensure UI updates properly
  this.selectedAssessmentCourseFilterValues = [...this.selectedAssessmentCourseFilterValues];
  this.cdr.detectChanges();
  this.updateAssessmentCourseFilteredData();
}

  areAllCoursesSelectedForAssessment(): boolean {
    if (!this.allAssessmentCourses || this.allAssessmentCourses.length === 0) {
      return false;
    }

    // Check if all courses are selected
    const allCourseIds = this.allAssessmentCourses.map(course => course.course_id);
    return allCourseIds.every(id =>
      this.selectedAssessmentCourseFilterValues.includes(id)
    );
  }
  toggleAllCoursesSelectionForAssessment(): void {
    if (!this.allAssessmentCourses || this.allAssessmentCourses.length === 0) {
      return;
    }

    const allCourseIds = this.allAssessmentCourses.map(course => course.course_id);

    if (this.areAllCoursesSelectedForAssessment()) {
      // If all are selected, deselect all
      this.selectedAssessmentCourseFilterValues = [];
    } else {
      // Select all courses
      this.selectedAssessmentCourseFilterValues = [...allCourseIds];
    }

    this.cdr.detectChanges();
    this.updateAssessmentCourseFilteredData();
  }
  isCoursesSelectionIndeterminateForAssessment(): boolean {
    if (!this.allAssessmentCourses || this.allAssessmentCourses.length === 0) {
      return false;
    }

    const allCourseIds = this.allAssessmentCourses.map(course => course.course_id);
    const selectedCount = this.selectedAssessmentCourseFilterValues.length;

    // Indeterminate state: some selected but not all
    return selectedCount > 0 && selectedCount < allCourseIds.length;
  }

  // Helper method for colors
  getRandomColor(): string {
    const colors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9',
      '#F8B195', '#F67280', '#C06C84', '#6C5B7B', '#355C7D',
      '#99B898', '#FECEAB', '#FF847C', '#E84A5F', '#2A363B'
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  }

  // Assessment Chart Menu Methods - Location
  toggleAssessmentLocationChartMenu(): void {
    this.showAssessmentLocationChartMenu = !this.showAssessmentLocationChartMenu;
    if (this.showAssessmentLocationChartMenu) {
      this.showAssessmentLocationFilterPanel = false; // Close filter when opening menu
    }
  }

  closeAssessmentLocationChartMenu(): void {
    this.showAssessmentLocationChartMenu = false;
  }

  // Assessment Chart Menu Methods - Course
  toggleAssessmentCourseChartMenu(): void {
    this.showAssessmentCourseChartMenu = !this.showAssessmentCourseChartMenu;
    if (this.showAssessmentCourseChartMenu) {
      this.showAssessmentCourseFilterPanel = false; // Close filter when opening menu
    }
  }

  closeAssessmentCourseChartMenu(): void {
    this.showAssessmentCourseChartMenu = false;
  }

  // Pass/Fail Chart Methods
  togglePassFailFilterPanel(): void {
    this.showPassFailFilterPanel = !this.showPassFailFilterPanel;
    if (this.showPassFailFilterPanel) {
      this.showPassFailChartMenu = false; // Close menu when opening filter
    }
  }

  setActivePassFailFilterHeader(header: string): void {
    this.activePassFailFilterHeader = header;
    if (header === 'course') {
      this.passFailCourseSearchTerm = '';
      this.filterPassFailCourse();
    } else if (header === 'geography') {
      this.passFailGeographySearchTerm = '';
      this.filterPassFailGeography();
    } else if (header === 'customer') {
      this.passFailCustomerSearchTerm = '';
      this.filterPassFailCustomer();
    } else if (header === 'language') {
      this.passFailLanguageSearchTerm = '';
      this.filterPassFailLanguage();
    } else if (header === 'assessment') {
      this.passFailSearchTerm = '';
      this.filterPassFailAssessment();
    }
  }

  filterPassFailCourse(): void {
    const searchTerm = this.passFailCourseSearchTerm.trim().toLowerCase();
    if (!searchTerm) {
      this.filteredPassFailCourseList = [...this.allPassFailCourses];
    } else {
      this.filteredPassFailCourseList = this.allPassFailCourses.filter(course =>
        (course.course_name || '').toLowerCase().includes(searchTerm)
      );
    }
  }

  filterPassFailAssessment(): void {
    const searchTerm = this.passFailSearchTerm.trim().toLowerCase();
    if (!searchTerm) {
      this.filteredPassFailAssessmentList = [...this.allPassFailAssessments];
    } else {
      this.filteredPassFailAssessmentList = this.allPassFailAssessments.filter(item =>
        (item.assessment_title || item.assessment_name || item.name || '').toLowerCase().includes(searchTerm)
      );
    }
  }

  isPassFailItemChecked(item: any): boolean {
    return this.passFailChartData.some(c =>
      c.assessment_id === item.assessment_id || c.is_overall === item.is_overall
    );
  }

  updatePassFailChart(): void {
    const checkboxes = document.querySelectorAll('.filter-panel-container[class*="pass-fail-active"] .filter-checkbox-input');
    const selectedAssessments: any[] = [];

    checkboxes.forEach((checkbox: any, index) => {
      if (checkbox.checked && this.allPassFailAssessments[index]) {
        selectedAssessments.push(this.allPassFailAssessments[index]);
      }
    });

    // Smart filtering: Show overall if nothing selected, otherwise show selected assessments
    const onlyOverallSelected = selectedAssessments.length === 0 ||
      (selectedAssessments.length === 1 && selectedAssessments[0].is_overall);

    if (onlyOverallSelected) {
      const overallEntry = this.allPassFailAssessments.find(a => a.is_overall);
      this.passFailChartData = overallEntry ? [overallEntry] : [...this.allPassFailAssessments];
    } else {
      this.passFailChartData = selectedAssessments.filter(a => !a.is_overall);
    }

    // Aggregate the filtered data by course
    const assessmentWiseDataToAggregate = this.passFailChartData
      .flatMap(a => a.assessment_wise || [])
      .filter(item => item.course_name); // Filter out items without course_name

    this.aggregatePassFailDataByCourse(assessmentWiseDataToAggregate);

    setTimeout(() => {
      this.initializePassFailHorizontalBarChart();
    }, 0);
  }

  togglePassFailCourseFilter(course: any): void {
    const index = this.selectedPassFailCourses.findIndex(c => c.course_id === course.course_id);
    if (index > -1) {
      this.selectedPassFailCourses.splice(index, 1);
    } else {
      this.selectedPassFailCourses.push(course);
    }
    this.updatePassFailChartFromCourseFilter();
  }

  isPassFailCourseSelected(course: any): boolean {
    return this.selectedPassFailCourses.some(c => c.course_id === course.course_id);
  }

  updatePassFailChartFromCourseFilter(): void {
    // Re-aggregate the chart data based on selected filters (course, geography, customer, language)
    if (this.rawPassFailAssessmentWise && this.rawPassFailAssessmentWise.length > 0) {
      this.aggregatePassFailDataByCourse(this.rawPassFailAssessmentWise);
    }
    setTimeout(() => {
      this.initializePassFailHorizontalBarChart();
    }, 0);
  }

  clearPassFailFilters(): void {
    this.selectedPassFailCourses = [];
    this.selectedPassFailGeographies = [];
    this.selectedPassFailCustomers = [];
    this.selectedPassFailLanguages = [];
    this.passFailCourseSearchTerm = '';
    this.passFailGeographySearchTerm = '';
    this.passFailCustomerSearchTerm = '';
    this.passFailLanguageSearchTerm = '';
    this.passFailSearchTerm = '';
    this.filteredPassFailCourseList = [...this.allPassFailCourses];
    this.filteredPassFailGeographyList = [...this.allPassFailGeographies];
    this.filteredPassFailCustomerList = [...this.allPassFailCustomers];
    this.filteredPassFailLanguageList = [...this.allPassFailLanguages];
    this.filteredPassFailAssessmentList = [...this.allPassFailAssessments];
    this.updatePassFailChartFromCourseFilter();
  }

  filterPassFailGeography(): void {
    const searchTerm = this.passFailGeographySearchTerm.trim().toLowerCase();
    if (!searchTerm) {
      this.filteredPassFailGeographyList = [...this.allPassFailGeographies];
    } else {
      this.filteredPassFailGeographyList = this.allPassFailGeographies.filter(geo =>
        (geo.state || geo.geography || '').toLowerCase().includes(searchTerm)
      );
    }
  }

  togglePassFailGeographyFilter(geography: any): void {
    const index = this.selectedPassFailGeographies.findIndex(g => g.state === geography.state);
    if (index > -1) {
      this.selectedPassFailGeographies.splice(index, 1);
    } else {
      this.selectedPassFailGeographies.push(geography);
    }
    this.updatePassFailChartFromCourseFilter();
  }

  isPassFailGeographySelected(geography: any): boolean {
    return this.selectedPassFailGeographies.some(g => g.state === geography.state);
  }

  filterPassFailCustomer(): void {
    const searchTerm = this.passFailCustomerSearchTerm.trim().toLowerCase();
    if (!searchTerm) {
      this.filteredPassFailCustomerList = [...this.allPassFailCustomers];
    } else {
      this.filteredPassFailCustomerList = this.allPassFailCustomers.filter(customer =>
        (customer.name || '').toLowerCase().includes(searchTerm)
      );
    }
  }

  togglePassFailCustomerFilter(customer: any): void {
    const index = this.selectedPassFailCustomers.findIndex(c => c.name === customer.name);
    if (index > -1) {
      this.selectedPassFailCustomers.splice(index, 1);
    } else {
      this.selectedPassFailCustomers.push(customer);
    }
    this.updatePassFailChartFromCourseFilter();
  }

  isPassFailCustomerSelected(customer: any): boolean {
    return this.selectedPassFailCustomers.some(c => c.name === customer.name);
  }

  filterPassFailLanguage(): void {
    const searchTerm = this.passFailLanguageSearchTerm.trim().toLowerCase();
    if (!searchTerm) {
      this.filteredPassFailLanguageList = [...this.allPassFailLanguages];
    } else {
      this.filteredPassFailLanguageList = this.allPassFailLanguages.filter(language =>
        (language.name || '').toLowerCase().includes(searchTerm)
      );
    }
  }

  togglePassFailLanguageFilter(language: any): void {
    const index = this.selectedPassFailLanguages.findIndex(l => l.name === language.name);
    if (index > -1) {
      this.selectedPassFailLanguages.splice(index, 1);
    } else {
      this.selectedPassFailLanguages.push(language);
    }
    this.updatePassFailChartFromCourseFilter();
  }

  isPassFailLanguageSelected(language: any): boolean {
    return this.selectedPassFailLanguages.some(l => l.name === language.name);
  }

  togglePassFailChartMenu(): void {
    this.showPassFailChartMenu = !this.showPassFailChartMenu;
    if (this.showPassFailChartMenu) {
      this.showPassFailFilterPanel = false; // Close filter when opening menu
    }
  }

  candidateInsightsDonutCharts: any[] = [];

  // Initialize Candidate Insights Donut Chart
  private initializeCandidateInsightsDonutChart(): void {
    if (!this.isFilterApplied()) {
      this.showCandidateInsightsDonutChart = false;
      return;
    }

    // Set flag to true so canvas becomes visible
    this.showCandidateInsightsDonutChart = true;
    this.cdr.detectChanges();

    // Now try to get all canvases after they are rendered (there can be multiple due to tabs)
    const canvases = document.querySelectorAll('canvas[id="candidateInsightsChart"]');
    if (canvases.length === 0) {
      this.showCandidateInsightsDonutChart = false;
      return;
    }

    // Destroy old charts if exist
    if (this.candidateInsightsDonutCharts && this.candidateInsightsDonutCharts.length > 0) {
      this.candidateInsightsDonutCharts.forEach(chart => {
        if (chart) chart.destroy();
      });
    }
    this.candidateInsightsDonutCharts = [];

    const colors = ['#005068', '#C71E1D', '#A0A0FF'];

    const data = [
      this.totalPassCandidates,
      this.totalFailCandidates,
      this.totalReassessedCandidates
    ];

    // Plugin to draw text in center of donut chart
    const centerTextPlugin = {
      id: 'centerText',
      afterDraw: (chart: any) => {
        const width = chart.width;
        const height = chart.height;
        const ctx = chart.ctx;

        ctx.restore();

        const fontSize = height / 200;
        ctx.font = `bold ${fontSize.toFixed(2)}em sans-serif`;
        ctx.textBaseline = 'middle';
        ctx.fillStyle = '#333';

        const text = `${this.totalAttempts}`;
        const textX = Math.round((width - ctx.measureText(text).width) / 2);
        const textY = height / 2 - 10;

        ctx.fillText(text, textX, textY);

        // Draw label below
        ctx.font = `${(fontSize * 0.7).toFixed(2)}em sans-serif`;
        ctx.fillStyle = '#999';
        const labelText = 'Total';
        const labelX = Math.round((width - ctx.measureText(labelText).width) / 2);
        const labelY = height / 2 + 10;

        ctx.fillText(labelText, labelX, labelY);

        ctx.save();
      }
    };

    const totalCount = this.totalPassCandidates + this.totalFailCandidates + this.totalReassessedCandidates;

    canvases.forEach(canvas => {
      const ctx = (canvas as HTMLCanvasElement).getContext('2d');
      if (!ctx) return;

      const chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ['Pass', 'Fail', 'Reassessed'],
          datasets: [{
            data,
            backgroundColor: colors,
            borderColor: '#fff',
            borderWidth: 0,
            hoverOffset: 0,
            hoverBorderWidth: 0,
            hoverBorderColor: 'transparent'
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
              position: 'bottom',
              labels: {
                font: {
                  size: 7
                },
                padding: 4,
                usePointStyle: true
              }
            },
            tooltip: {
              callbacks: {
                label: (context: any) => {
                  const value = context.raw as number;
                  const percentage = totalCount > 0 ? ((value / totalCount) * 100).toFixed(1) : '0';
                  return `${context.label}: ${value} (${percentage}%)`;
                }
              }
            }
          },
          cutout: '60%',
          animation: {
            animateScale: true,
            animateRotate: true
          },
          layout: {
            padding: {
              top: 2,
              right: 2,
              bottom: 2,
              left: 2
            }
          }
        },
        plugins: [centerTextPlugin]
      });

      this.candidateInsightsDonutCharts.push(chart);
    });
  }

  private initializeQuestionPaperInsightsDonutChart(): void {
    const canvas = document.getElementById('questionPaperInsightsChart') as HTMLCanvasElement;
    if (!canvas) return;

    if (this.questionPaperInsightsDonutChart) {
      this.questionPaperInsightsDonutChart.destroy();
    }

    const activeCount = this.getDisplayActiveQuestions(); // Active Questions
    const inactiveCount = this.getDisplayInactiveQuestions(); // Inactive Questions

    this.showQuestionPaperInsightsDonutChart = true; // Always visible
    const ctx = canvas.getContext('2d');

    if (ctx) {
      const centerTextPlugin = {
        id: 'questionPaperCenterText',
        afterDraw: (chart: any) => {
          const width = chart.width;
          const height = chart.height;
          const ctx = chart.ctx;

          ctx.restore();

          const totalFontSize = Math.min(18, Math.max(12, Math.round(height / 8)));
          const labelFontSize = Math.min(14, Math.max(10, Math.round(height / 12)));

          ctx.font = `bold ${totalFontSize}px sans-serif`;
          ctx.textBaseline = 'middle';
          ctx.fillStyle = '#333';

          const totalText = `${this.getDisplayTotalQuestions()}`;
          const textX = Math.round((width - ctx.measureText(totalText).width) / 2);
          const textY = height / 2 - 8;
          ctx.fillText(totalText, textX, textY);

          ctx.font = `${labelFontSize}px sans-serif`;
          ctx.fillStyle = '#999';
          const labelText = 'Total';
          const labelX = Math.round((width - ctx.measureText(labelText).width) / 2);
          const labelY = height / 2 + 12;
          ctx.fillText(labelText, labelX, labelY);

          ctx.save();
        }
      };

      const isEmpty = activeCount === 0 && inactiveCount === 0;
      const chartData = isEmpty ? [1] : [activeCount, inactiveCount];
      const chartColors = isEmpty ? ['#E9ECEE'] : ['#005068', '#C71E1D'];
      const chartLabels = isEmpty ? ['No Data'] : ['Active', 'Inactive'];

      this.questionPaperInsightsDonutChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: chartLabels,
          datasets: [{
            data: chartData,
            backgroundColor: chartColors, // Dark Blue for Active, Red for Inactive
            borderWidth: 0,
            hoverOffset: 0,
            hoverBorderColor: 'transparent'
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutout: '60%', 
          animation: {
            animateScale: true,
            animateRotate: true
          },
          plugins: {
            legend: {
              display: false,
              position: 'bottom',
              labels: {
                font: {
                  size: 7
                },
                padding: 4,
                usePointStyle: true
              }
            },
            tooltip: { enabled: true }
          },
          layout: {
            padding: {
              top: 2,
              right: 2,
              bottom: 2,
              left: 2
            }
          }
        },
        plugins: [centerTextPlugin]
      });
    }
  }

  initializePassFailDoughnutChart(): void {
    if (this.selectedViewType !== 'assessment' && this.selectedViewType !== 'all') return;

    const canvas = document.getElementById('passFailChart') as HTMLCanvasElement;
    if (!canvas) return;

    if (this.rawPassFailAssessmentWise && this.rawPassFailAssessmentWise.length > 0) {
      this.aggregatePassFailDataByCourse(this.rawPassFailAssessmentWise);
    }

    if (this.passFailChartLabels && this.passFailChartLabels.length > 0) {
      this.initializePassFailHorizontalBarChart();
    }
  }


  getPassFailPercentage(item: any): string {
    if (item.pass_percent !== undefined) {
      return item.pass_percent.toFixed(2);
    }
    if (!this.passFailChartData || this.passFailChartData.length === 0) return '0';

    const total = this.passFailChartData.reduce((sum, i) => sum + ((i.pass || 0) + (i.fail || 0)), 0);
    const itemTotal = (item.pass || 0) + (item.fail || 0);
    return total > 0 ? ((itemTotal / total) * 100).toFixed(2) : '0';
  }

  openPassFailCompareDialog(): void {
    this.showPassFailChartMenu = false;
    this.showPassFailCompareDialog = true;
    this.showPassFailComparisonResults = false;
    this.selectedPassFailCompareMonth1 = null;
    this.selectedPassFailCompareMonth2 = null;
  }

  closePassFailCompareDialog(): void {
    this.showPassFailCompareDialog = false;
    this.showPassFailComparisonResults = false;
    this.currentPassFailComparisonData = [];
    this.comparePassFailComparisonData = [];
  }

  togglePassFailCompareMonth1Dropdown(): void {
    this.showPassFailCompareMonth1Dropdown = !this.showPassFailCompareMonth1Dropdown;
    if (this.showPassFailCompareMonth1Dropdown) {
      this.showPassFailCompareMonth2Dropdown = false;
    }
  }

  selectPassFailCompareMonth1(month: number): void {
    this.selectedPassFailCompareMonth1 = month;
    this.showPassFailCompareMonth1Dropdown = false;
  }

  togglePassFailCompareMonth2Dropdown(): void {
    this.showPassFailCompareMonth2Dropdown = !this.showPassFailCompareMonth2Dropdown;
    if (this.showPassFailCompareMonth2Dropdown) {
      this.showPassFailCompareMonth1Dropdown = false;
    }
  }

  selectPassFailCompareMonth2(month: number): void {
    this.selectedPassFailCompareMonth2 = month;
    this.showPassFailCompareMonth2Dropdown = false;
  }

  loadPassFailComparisonDataMonthWise(): void {
    if (!this.selectedPassFailCompareMonth1 || !this.selectedPassFailCompareMonth2) {
      return;
    }

    this.isLoading = true;
    this.showPassFailComparisonResults = true;

    // Fetch comparison data
    this.fetchPassFailComparisonDataMonthWise();
  }

  private fetchPassFailComparisonDataMonthWise(): void {
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedPassFailCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedPassFailCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    // Fetch Month 1 data
    const resp1 = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    // Fetch Month 2 data
    const resp2 = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Data: any[] = [];
    let month2Data: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        console.log('Pass/Fail - Month 1 API Full Response:', data);
        let response = data?.body?.responseBody || data?.responseBody || data;
        console.log('Pass/Fail - Month 1 Extracted Response:', response);

        // Extract pass/fail data from operationsData.pass_fail
        if (response?.operationsData?.pass_fail) {
          const passfailObj = response.operationsData.pass_fail;
          month1Data = Object.entries(passfailObj).map(([status, count]: [string, any]) => ({
            status: status,
            count: count as number
          }));
          console.log('Pass/Fail - Month 1 Pass/Fail Data:', month1Data);
        } else if (response && response.pass_fail_counts && Array.isArray(response.pass_fail_counts)) {
          month1Data = response.pass_fail_counts;
          console.log('Pass/Fail - Month 1 Pass/Fail Counts (Legacy):', month1Data);
        } else {
          console.warn('Pass/Fail - Month 1: No pass/fail data found in response');
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processPassFailComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        console.error('Pass/Fail - Month 1 API Error:', error);
        completedRequests++;
        if (completedRequests === 2) {
          this.comparePassFailComparisonData = [];
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        //console.log('Pass/Fail - Month 2 API Full Response:', data);
        let response = data?.body?.responseBody || data?.responseBody || data;
        //console.log('Pass/Fail - Month 2 Extracted Response:', response);

        // Extract pass/fail data from operationsData.pass_fail
        if (response?.operationsData?.pass_fail) {
          const passfailObj = response.operationsData.pass_fail;
          month2Data = Object.entries(passfailObj).map(([status, count]: [string, any]) => ({
            status: status,
            count: count as number
          }));
          // console.log('Pass/Fail - Month 2 Pass/Fail Data:', month2Data);
        } else if (response && response.pass_fail_counts && Array.isArray(response.pass_fail_counts)) {
          month2Data = response.pass_fail_counts;
          // console.log('Pass/Fail - Month 2 Pass/Fail Counts (Legacy):', month2Data);
        } else {
          //console.warn('Pass/Fail - Month 2: No pass/fail data found in response');
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processPassFailComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        console.error('Pass/Fail - Month 2 API Error:', error);
        completedRequests++;
        if (completedRequests === 2) {
          this.comparePassFailComparisonData = [];
        }
      }
    );

    // Set loading complete after both requests
    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    }, 200);
  }

  private processPassFailComparisonDataMonthWise(month1Data: any[], month2Data: any[]): void {
    //console.log('Pass/Fail - Processing Comparison Data:');
    //console.log('Pass/Fail - Month 1 Raw Data:', month1Data);
    //console.log('Pass/Fail - Month 2 Raw Data:', month2Data);

    // Type guard to check if count is a number
    const isValidPassFail = (passfail: any): boolean => {
      const count = passfail?.count ?? passfail?.pass_fail_count ?? 0;
      return passfail &&
        (passfail.status || passfail.pass_fail_status) &&
        typeof count === 'number' &&
        count > 0;
    };

    // Process Month 1 data
    const validMonth1PassFails = month1Data.filter(isValidPassFail).map((pf: any) => ({
      status: pf.status || pf.pass_fail_status,
      count: pf.count ?? pf.pass_fail_count
    }));
    //console.log('Pass/Fail - Valid Month 1 Pass/Fails:', validMonth1PassFails);
    const month1Totals: { [key: string]: number } = {};
    validMonth1PassFails.forEach(passfail => {
      month1Totals[passfail.status] = passfail.count;
    });

    this.currentPassFailComparisonData = Object.entries(month1Totals)
      .filter(([_, count]) => count > 0)
      .map(([statusName, count]) => ({
        name: statusName,
        value: count,
        percentage: '0',
        trend: 'neutral'
      }));
    //console.log('Pass/Fail - Current Comparison Data (Month 1):', this.currentPassFailComparisonData);

    // Process Month 2 data
    const validMonth2PassFails = month2Data.filter(isValidPassFail).map((pf: any) => ({
      status: pf.status || pf.pass_fail_status,
      count: pf.count ?? pf.pass_fail_count
    }));
    //console.log('Pass/Fail - Valid Month 2 Pass/Fails:', validMonth2PassFails);
    const month2Totals: { [key: string]: number } = {};
    validMonth2PassFails.forEach(passfail => {
      month2Totals[passfail.status] = passfail.count;
    });

    this.comparePassFailComparisonData = Object.entries(month2Totals)
      .filter(([_, count]) => count > 0)
      .map(([statusName, count]) => {
        const currentItem = this.currentPassFailComparisonData.find(item => item.name === statusName);
        const currentValue = currentItem ? currentItem.value : 0;

        let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
        if (count > currentValue) {
          trend = 'positive';
        } else if (count < currentValue) {
          trend = 'negative';
        }

        return {
          name: statusName,
          value: count,
          percentage: '0',
          trend: trend
        };
      });
    //console.log('Pass/Fail - Compare Comparison Data (Month 2):', this.comparePassFailComparisonData);

    // Initialize comparison chart
    this.initializePassFailComparisonChart();
  }

  private initializePassFailComparisonChart(): void {
    // Prepare data for chart
    const month1Name = this.getMonthName(this.selectedPassFailCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedPassFailCompareMonth2!);

    // Get unique statuses from both datasets
    const allStatuses = new Set<string>();
    this.currentPassFailComparisonData.forEach(item => allStatuses.add(item.name));
    this.comparePassFailComparisonData.forEach(item => allStatuses.add(item.name));

    const statusNames: string[] = Array.from(allStatuses);
    const month1Data: number[] = [];
    const month2Data: number[] = [];

    statusNames.forEach(statusName => {
      const month1Item = this.currentPassFailComparisonData.find(item => item.name === statusName);
      const month2Item = this.comparePassFailComparisonData.find(item => item.name === statusName);
      month1Data.push(month1Item ? month1Item.value : 0);
      month2Data.push(month2Item ? month2Item.value : 0);
    });

    console.log('Pass/Fail - Chart Initialization');
    console.log('Pass/Fail - Status Names:', statusNames);
    console.log('Pass/Fail - Month 1 Data:', month1Data);
    console.log('Pass/Fail - Month 2 Data:', month2Data);

    // Destroy existing chart if it exists
    if (this.passFailComparisonChart) {
      this.passFailComparisonChart.destroy();
    }

    // Delay chart initialization to ensure DOM is ready
    setTimeout(() => {
      try {
        const ctx = document.getElementById('passFailComparisonChart') as HTMLCanvasElement;
        if (ctx) {
          this.passFailComparisonChart = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: statusNames,
              datasets: [
                {
                  label: month1Name,
                  data: month1Data,
                  backgroundColor: '#FF9800',
                  borderColor: '#F57C00',
                  borderWidth: 1
                },
                {
                  label: month2Name,
                  data: month2Data,
                  backgroundColor: '#9C27B0',
                  borderColor: '#7B1FA2',
                  borderWidth: 1
                }
              ]
            },
            options: {
              indexAxis: 'y',
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: true,
                  position: 'top'
                }
              },
              scales: {
                x: {
                  beginAtZero: true,
                  stacked: false,
                  grid: {
                    display: true
                  }
                },
                y: {
                  stacked: false
                }
              }
            }
          });
          console.log('Pass/Fail - Chart initialized successfully');
          this.cdr.detectChanges();
        } else {
          console.error('Pass/Fail - Canvas element not found');
        }
      } catch (error) {
        console.error('Pass/Fail - Chart initialization error:', error);
      }
    }, 200);
  }

  openPassFailTableModal(): void {
    this.showPassFailChartMenu = false;
    this.showPassFailTableModal = true;
  }

  closePassFailTableModal(): void {
    this.showPassFailTableModal = false;
  }

  // Assessment Location Year/Month Filter Methods
  toggleAssessmentLocationYearDropdown(): void {
    this.showAssessmentLocationYearDropdown = !this.showAssessmentLocationYearDropdown;
    if (this.showAssessmentLocationYearDropdown) {
      this.showAssessmentLocationMonthDropdown = false;
    }
  }

  selectAssessmentLocationYearRange(yearRange: string): void {
    this.selectedAssessmentLocationYearRange = yearRange;
    this.showAssessmentLocationYearDropdown = false;
    this.applyAssessmentLocationMonthYearFilter();
  }

  toggleAssessmentLocationMonthDropdown(): void {
    this.showAssessmentLocationMonthDropdown = !this.showAssessmentLocationMonthDropdown;
    if (this.showAssessmentLocationMonthDropdown) {
      this.showAssessmentLocationYearDropdown = false;
    }
  }

  selectAssessmentLocationMonth(month: number): void {
    this.selectedAssessmentLocationMonth = month;
    this.showAssessmentLocationMonthDropdown = false;
    console.log('Selected Assessment Location Month:', month);
    this.applyAssessmentLocationMonthYearFilter();
  }

  applyAssessmentLocationMonthYearFilter(): void {
    this.showAssessmentLocationYearDropdown = false;
    this.showAssessmentLocationMonthDropdown = false;
    console.log('Applying Assessment Location Filter - Month:', this.selectedAssessmentLocationMonth, 'Year:', this.selectedAssessmentLocationYearRange);
    this.fetchAssessmentLocationData();
  }

  private fetchAssessmentLocationData(): void {
    // Ensure org_id is properly converted to integer
    const orgIdAsInt = this.org_id ? parseInt(this.org_id, 10) : null;
    
    if (!orgIdAsInt) {
      console.error('Organization ID is not set. Cannot fetch assessment location data.');
      this.isLoading = false;
      return;
    }

    this.isLoading = true;

    let startDate: Date;
    let endDate: Date;

    if (this.selectedAssessmentLocationMonth) {
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedAssessmentLocationYearRange);
      if (yearRange) {
        const year = this.selectedAssessmentLocationMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedAssessmentLocationMonth - 1, 1);
        endDate = new Date(year, this.selectedAssessmentLocationMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedAssessmentLocationMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedAssessmentLocationMonth, 0);
      }
    } else {
      const dateRange = this.getDateRangeFromYearRange(this.selectedAssessmentLocationYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

    console.log('Fetching Assessment Location Data with:', { 
      org_id: orgIdAsInt,
      formattedStartDate, 
      formattedEndDate, 
      month: this.selectedAssessmentLocationMonth, 
      year: this.selectedAssessmentLocationYearRange 
    });

    const payload = {
      org_id: orgIdAsInt,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    };
    const resp = this.service.getOperationsData(payload);

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        console.log('Assessment Location Data Response:', response?.operationsData?.top_states);
        console.log('Full API Response:', JSON.stringify(response?.operationsData?.top_states));

        if (response && response.operationsData && response.operationsData.top_states && response.operationsData.top_states.length > 0) {
          const colors = [
            '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
            '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9', '#F8B195'
          ];

          this.allAssessmentLocations = response.operationsData.top_states.map((location: any, index: number) => ({
            ...location,
            id: location.id || index
          }));
          this.filteredAssessmentLocationList = [...this.allAssessmentLocations];
          this.assessmentLocationChartData = this.allAssessmentLocations.map((location: any, index: number) => ({
            name: location.state || 'Unknown',
            value: location.count || 0,
            color: colors[index % colors.length]
          }));
          this.selectedAssessmentLocationFilterValues = [];
          this.showAssessmentLocationChart = this.assessmentLocationChartData.length > 0;
          this.isLoading = false;
          this.cdr.detectChanges();

          console.log('Chart data prepared:', this.assessmentLocationChartData);

          setTimeout(() => {
            console.log('Initializing chart with showAssessmentLocationChart:', this.showAssessmentLocationChart);
            if (this.showAssessmentLocationChart && document.getElementById('assessmentLocationChart')) {
              this.initializeAssessmentLocationBarChart();
            }
          }, 0);
        } else {
          console.log('No data received for assessment locations');
          this.allAssessmentLocations = [];
          this.filteredAssessmentLocationList = [];
          this.assessmentLocationChartData = [];
          this.showAssessmentLocationChart = false;
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        console.error('Error fetching assessment location data:', error);
        this.allAssessmentLocations = [];
        this.filteredAssessmentLocationList = [];
        this.assessmentLocationChartData = [];
        this.showAssessmentLocationChart = false;
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  // Assessment Course Year/Month Filter Methods
  toggleAssessmentCourseYearDropdown(): void {
    this.showAssessmentCourseYearDropdown = !this.showAssessmentCourseYearDropdown;
    if (this.showAssessmentCourseYearDropdown) {
      this.showAssessmentCourseMonthDropdown = false;
    }
  }

  selectAssessmentCourseYearRange(yearRange: string): void {
    this.selectedAssessmentCourseYearRange = yearRange;
    this.showAssessmentCourseYearDropdown = false;
    this.applyAssessmentCourseMonthYearFilter();
  }

  toggleAssessmentCourseMonthDropdown(): void {
    this.showAssessmentCourseMonthDropdown = !this.showAssessmentCourseMonthDropdown;
    if (this.showAssessmentCourseMonthDropdown) {
      this.showAssessmentCourseYearDropdown = false;
    }
  }

  selectAssessmentCourseMonth(month: number): void {
    this.selectedAssessmentCourseMonth = month;
    this.showAssessmentCourseMonthDropdown = false;
    this.applyAssessmentCourseMonthYearFilter();
  }

  applyAssessmentCourseMonthYearFilter(): void {
    this.showAssessmentCourseYearDropdown = false;
    this.showAssessmentCourseMonthDropdown = false;
    this.fetchAssessmentCourseData();
  }

private fetchAssessmentCourseData(): void {
  // Ensure org_id is properly converted to integer
  const orgIdAsInt = this.org_id ? parseInt(this.org_id, 10) : null;
  if (!orgIdAsInt) {
    console.error('Organization ID is not set. Cannot fetch assessment course data.');
    this.isLoading = false;
    return;
  }

  this.isLoading = true;
  let startDate: Date;
  let endDate: Date;

  if (this.selectedAssessmentCourseMonth) {
    const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedAssessmentCourseYearRange);
    if (yearRange) {
      const year = this.selectedAssessmentCourseMonth <= 3 ? yearRange.endYear : yearRange.startYear;
      startDate = new Date(year, this.selectedAssessmentCourseMonth - 1, 1);
      endDate = new Date(year, this.selectedAssessmentCourseMonth, 0);
    } else {
      const currentYear = new Date().getFullYear();
      startDate = new Date(currentYear, this.selectedAssessmentCourseMonth - 1, 1);
      endDate = new Date(currentYear, this.selectedAssessmentCourseMonth, 0);
    }
  } else {
    const dateRange = this.getDateRangeFromYearRange(this.selectedAssessmentCourseYearRange);
    startDate = dateRange.startDate;
    endDate = dateRange.endDate;
  }

  const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
  const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

  const payload = {
    org_id: orgIdAsInt,
    start_date: formattedStartDate,
    end_date: formattedEndDate
  };

  const resp = this.service.getOperationsData(payload);
  resp.subscribe(
    (data: any) => {
      const response = data['body']?.['responseBody'] || data?.['responseBody'] || data;
      
      const targetSource = response?.operationsData?.top_5_courses_by_assessment || response?.top_5_courses_by_assessment;

      if (targetSource && Array.isArray(targetSource) && targetSource.length > 0) {
        const colors = [
          '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF', 
          '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9', '#F8B195'
        ];

        // Store to allAssessmentCourses so updateAssessmentCourseFilteredData can use it
        this.allAssessmentCourses = targetSource.map((course: any, index: number) => ({
            ...course,
            id: index,
            course: course.course_name || course.course || course.name || 'Unknown Course',
            count: Number(course.assessment_count || course.count || course.value || 0),
            course_id: course.course_id || index
        }));

        this.updateAssessmentCourseFilteredData();
        this.isLoading = false;

      } else {
        // Fallback agar arrays key match nahi kar rahi ho
        this.assessmentCourseChartData = [];
        this.showAssessmentCourseChart = false;
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    },
    (error) => {
      console.error('Error fetching assessment course data:', error);
      this.assessmentCourseChartData = [];
      this.showAssessmentCourseChart = false;
      this.isLoading = false;
      this.cdr.detectChanges();
    }
  );
}

  // Assessment Status Year/Month Filter Methods
  toggleAssessmentStatusYearDropdown(): void {
    this.showAssessmentStatusYearDropdown = !this.showAssessmentStatusYearDropdown;
    if (this.showAssessmentStatusYearDropdown) {
      this.showAssessmentStatusMonthDropdown = false;
    }
  }

  selectAssessmentStatusYearRange(yearRange: string): void {
    this.selectedAssessmentStatusYearRange = yearRange;
    this.showAssessmentStatusYearDropdown = false;
    this.applyAssessmentStatusMonthYearFilter();
  }

  toggleAssessmentStatusMonthDropdown(): void {
    this.showAssessmentStatusMonthDropdown = !this.showAssessmentStatusMonthDropdown;
    if (this.showAssessmentStatusMonthDropdown) {
      this.showAssessmentStatusYearDropdown = false;
    }
  }

  selectAssessmentStatusMonth(month: number): void {
    this.selectedAssessmentStatusMonth = month;
    this.showAssessmentStatusMonthDropdown = false;
    this.applyAssessmentStatusMonthYearFilter();
  }

  applyAssessmentStatusMonthYearFilter(): void {
    this.showAssessmentStatusYearDropdown = false;
    this.showAssessmentStatusMonthDropdown = false;
    this.fetchAssessmentStatusData();
  }

  private fetchAssessmentStatusData(): void {
    this.isLoading = true;

    let startDate: Date;
    let endDate: Date;

    if (this.selectedAssessmentStatusMonth) {
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedAssessmentStatusYearRange);
      if (yearRange) {
        const year = this.selectedAssessmentStatusMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedAssessmentStatusMonth - 1, 1);
        endDate = new Date(year, this.selectedAssessmentStatusMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedAssessmentStatusMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedAssessmentStatusMonth, 0);
      }
    } else {
      const dateRange = this.getDateRangeFromYearRange(this.selectedAssessmentStatusYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

    const resp = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.operationsData) {
          if (response.operationsData.assessment_status) {
            this.assessmentStatusSummary = {
              active: response.operationsData.assessment_status.active || 0,
              inactive: response.operationsData.assessment_status.inactive || 0,
              deleted: response.operationsData.assessment_status.deleted || 0,
              publish: response.operationsData.assessment_status.publish || 0,
              draft: response.operationsData.assessment_status.draft || 0
            };
          }

          const statusData = [
            { id: 'planned', name: 'Planned', value: response.operationsData?.total_planned_assessments || 0, color: '#C61F1E' },
            { id: 'executed', name: 'Executed', value: response.operationsData?.total_executed_assessments || 0, color: '#0A68A6' },
            { id: 'evaluated', name: 'Evaluated', value: response.operationsData?.total_evaluated_assessments || 0, color: '#FDBF48' },
            { id: 'published', name: 'Published', value: response.operationsData?.total_published_assessments || 0, color: '#279A81' }
          ];

          const publishStatusData = [
            { id: 'published', name: 'Published', value: this.assessmentStatusSummary.publish || 0, color: '#2196F3' },
            { id: 'draft', name: 'Draft', value: this.assessmentStatusSummary.draft || 0, color: '#9C27B0' }
          ];

          this.allAssessmentStatuses = statusData;
          this.filteredAssessmentStatusList = [...statusData];
          this.assessmentStatusChartData = statusData;
          this.allAssessmentPublishStatuses = publishStatusData;
          this.filteredAssessmentPublishList = [...publishStatusData];
          this.selectedAssessmentStatusFilterValues = [];
          this.selectedAssessmentPublishFilterValues = [];
          this.showAssessmentStatusChart = this.assessmentStatusChartData.some(item => item.value > 0);
          this.isLoading = false;
          this.cdr.detectChanges();
          setTimeout(() => {
            if (this.showAssessmentStatusChart && document.getElementById('assessmentStatusChart')) {
              this.initializeAssessmentStatusDoughnutChart();
            }
          }, 0);
        } else {
          this.assessmentStatusChartData = [];
          this.showAssessmentStatusChart = false;
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.assessmentStatusChartData = [];
        this.showAssessmentStatusChart = false;
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  // Assessment Evaluation Year/Month Filter Methods
  toggleAssessmentEvaluationYearDropdown(): void {
    this.showAssessmentEvaluationYearDropdown = !this.showAssessmentEvaluationYearDropdown;
    if (this.showAssessmentEvaluationYearDropdown) {
      this.showAssessmentEvaluationMonthDropdown = false;
    }
  }

  selectAssessmentEvaluationYearRange(yearRange: string): void {
    this.selectedAssessmentEvaluationYearRange = yearRange;
    this.showAssessmentEvaluationYearDropdown = false;
    this.applyAssessmentEvaluationMonthYearFilter();
  }

  toggleAssessmentEvaluationMonthDropdown(): void {
    this.showAssessmentEvaluationMonthDropdown = !this.showAssessmentEvaluationMonthDropdown;
    if (this.showAssessmentEvaluationMonthDropdown) {
      this.showAssessmentEvaluationYearDropdown = false;
    }
  }

  selectAssessmentEvaluationMonth(month: number): void {
    console.log('selectAssessmentEvaluationMonth called with', month);
    this.selectedAssessmentEvaluationMonth = month;
    this.showAssessmentEvaluationMonthDropdown = false;
    this.applyAssessmentEvaluationMonthYearFilter();
  }

  applyAssessmentEvaluationMonthYearFilter(): void {
    console.log('applyAssessmentEvaluationMonthYearFilter - selectedMonth:', this.selectedAssessmentEvaluationMonth, 'selectedYearRange:', this.selectedAssessmentEvaluationYearRange);
    this.showAssessmentEvaluationYearDropdown = false;
    this.showAssessmentEvaluationMonthDropdown = false;
    this.fetchAssessmentEvaluationData();
  }
  exportPassFailAsPDF(): void {
    this.showPassFailChartMenu = false;
    if (!this.passFailChartLabels || !this.passFailChartLabels.length) {
      this.util.simpleDialog({ title: 'Error', message: 'No data to export' });
      return;
    }

    if (this.passFailChart) {
      const canvas = this.passFailChart.canvas;
      const chartImage = canvas.toDataURL('image/png');

      // Create PDF with proper layout
      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Add title
      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Pass/Fail by Assessment Distribution', 20, 25);

      // Add source/subtitle
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      pdf.text('Source: Assessment Analytics', 20, 32);

      // Add separator line
      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      // Add chart image
      const imgProps = pdf.getImageProperties(chartImage);
      const chartWidth = pageWidth - 40;
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      const chartX = 20;
      const chartY = 45;

      pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

      // Add data summary below chart
      let currentY = chartY + chartHeight + 15;

      pdf.setFontSize(12);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Summary:', 20, currentY);
      currentY += 8;

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      this.passFailChartLabels.forEach((label, index) => {
        const pass = this.passFailPassData[index] || 0;
        const fail = this.passFailFailData[index] || 0;
        const reassessed = this.passFailReassessedData[index] || 0;
        const totalCandidates = pass + fail;
        const passPercentage = totalCandidates > 0 ? (pass / totalCandidates * 100).toFixed(2) : '0.00';
        const text = `${label}: Pass: ${pass} (${passPercentage}%) | Fail: ${fail} | Reassessed: ${reassessed}`;
        pdf.text(text, 20, currentY);
        currentY += 5;

        if (currentY > pageHeight - 20) {
          pdf.addPage();
          currentY = 20;
        }
      });

      pdf.save('PassFail_by_Assessment.pdf');
    }
  }

  exportPassFailAsPNG(): void {
    this.showPassFailChartMenu = false;
    if (!this.passFailChartLabels || !this.passFailChartLabels.length) {
      this.util.simpleDialog({ title: 'Error', message: 'No data to export' });
      return;
    }

    if (this.passFailChart) {
      const canvas = this.passFailChart.canvas;
      
      // Create a high-quality export canvas in memory
      const exportCanvas = document.createElement('canvas');
      exportCanvas.width = 1200;
      
      const numItems = this.passFailChartLabels.length;
      const rightColumnHeight = numItems * 85 + 200; // 85px per card + spacing
      const leftColumnHeight = 550; // chart area height
      const contentHeight = Math.max(leftColumnHeight, rightColumnHeight);
      exportCanvas.height = contentHeight + 150; // add margin for header & footer

      const exportCtx = exportCanvas.getContext('2d');
      if (!exportCtx) return;

      // Draw white background
      exportCtx.fillStyle = '#ffffff';
      exportCtx.fillRect(0, 0, exportCanvas.width, exportCanvas.height);

      // Draw Title
      exportCtx.font = 'bold 28px Arial';
      exportCtx.fillStyle = '#005068';
      exportCtx.fillText('Pass/Fail by Assessment Distribution', 40, 60);

      // Draw Subtitle
      exportCtx.font = '14px Arial';
      exportCtx.fillStyle = '#666666';
      exportCtx.fillText('Source: Assessment Analytics', 40, 95);

      // Draw separator line
      exportCtx.strokeStyle = '#dddddd';
      exportCtx.lineWidth = 2;
      exportCtx.beginPath();
      exportCtx.moveTo(40, 115);
      exportCtx.lineTo(exportCanvas.width - 40, 115);
      exportCtx.stroke();

      // Ensure chart has white background before drawing
      const tempCtx = canvas.getContext('2d');
      if (tempCtx) {
        tempCtx.save();
        tempCtx.globalCompositeOperation = 'destination-over';
        tempCtx.fillStyle = '#ffffff';
        tempCtx.fillRect(0, 0, canvas.width, canvas.height);
        tempCtx.restore();
      }

      // Draw the chart canvas
      exportCtx.drawImage(canvas, 40, 140, 700, 350);

      // Draw summary title
      exportCtx.font = 'bold 18px Arial';
      exportCtx.fillStyle = '#005068';
      exportCtx.fillText('Summary', 800, 160);

      // Draw course summaries on the right side
      let textY = 200;
      this.passFailChartLabels.forEach((label, index) => {
        const pass = this.passFailPassData[index] || 0;
        const fail = this.passFailFailData[index] || 0;
        const reassessed = this.passFailReassessedData[index] || 0;
        const totalCandidates = pass + fail;
        const passPercentage = totalCandidates > 0 ? (pass / totalCandidates * 100).toFixed(2) : '0.00';

        // Draw card background
        exportCtx.fillStyle = '#f5f5f5';
        exportCtx.fillRect(780, textY - 15, 380, 70);

        // Draw left border for card
        exportCtx.strokeStyle = '#005068';
        exportCtx.lineWidth = 4;
        exportCtx.beginPath();
        exportCtx.moveTo(780, textY - 15);
        exportCtx.lineTo(780, textY + 55);
        exportCtx.stroke();

        // Draw texts
        exportCtx.fillStyle = '#333333';
        exportCtx.font = 'bold 13px Arial';
        exportCtx.fillText(label, 795, textY + 5);

        exportCtx.font = '12px Arial';
        exportCtx.fillText(`Pass: ${pass} (${passPercentage}%) | Fail: ${fail}`, 795, textY + 25);
        exportCtx.fillText(`Reassessed: ${reassessed}`, 795, textY + 45);

        textY += 85;
      });

      // Draw footer line
      exportCtx.strokeStyle = '#dddddd';
      exportCtx.lineWidth = 1;
      exportCtx.beginPath();
      exportCtx.moveTo(40, exportCanvas.height - 60);
      exportCtx.lineTo(exportCanvas.width - 40, exportCanvas.height - 60);
      exportCtx.stroke();

      // Draw footer text
      exportCtx.font = '11px Arial';
      exportCtx.fillStyle = '#999999';
      exportCtx.fillText(`Generated on ${new Date().toLocaleString()}`, 40, exportCanvas.height - 35);

      // Trigger instant download
      const link = document.createElement('a');
      link.href = exportCanvas.toDataURL('image/png');
      link.download = 'PassFail_by_Assessment.png';
      link.click();
    }
  }
  private fetchAssessmentEvaluationData(): void {
    console.log('fetchAssessmentEvaluationData called');
    this.isLoading = true;

    let startDate: Date;
    let endDate: Date;

    if (this.selectedAssessmentEvaluationMonth) {
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedAssessmentEvaluationYearRange);
      if (yearRange) {
        const year = this.selectedAssessmentEvaluationMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedAssessmentEvaluationMonth - 1, 1);
        endDate = new Date(year, this.selectedAssessmentEvaluationMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedAssessmentEvaluationMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedAssessmentEvaluationMonth, 0);
      }
    } else {
      const dateRange = this.getDateRangeFromYearRange(this.selectedAssessmentEvaluationYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');
    console.log('Assessment Evaluation fetch dates:', { formattedStartDate, formattedEndDate });

    const resp = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        console.log('Assessment Evaluation API full response:', data);
        console.log('Assessment Evaluation extracted responseBody:', response);
        if (response && response.operationsData) {
          console.log('assessment evaluation_status raw:', response.operationsData.evaluation_status);
          
          // Extract totals from response
          const totalPlannedAssessments = response.operationsData.total_planned_assessments || response.operationsData.current_month_planned_assessments || 0;
          const totalExecutedAssessments = response.operationsData.total_executed_assessments || 0;
          const totalEvaluatedAssessments = response.operationsData.total_evaluated_assessments || 0;
          const publishedAssessments = response.operationsData.total_published_assessments || 0;

          // Prepare evaluation data with 4 categories: Planned, Executed, Evaluated, Published
          const evaluationData = [
            { id: 'planned', name: 'Planned', value: totalPlannedAssessments, color: '#C61F1E' },
            { id: 'executed', name: 'Executed', value: totalExecutedAssessments, color: '#0A68A6' },
            { id: 'evaluated', name: 'Evaluated', value: totalEvaluatedAssessments, color: '#FDBF48' },
            { id: 'published', name: 'Published', value: publishedAssessments, color: '#FFFDD0' }
          ];

          this.allAssessmentEvaluations = evaluationData;
          this.filteredAssessmentEvaluationList = [...evaluationData];
          this.assessmentEvaluationChartData = evaluationData;
          console.log('Computed evaluationData for chart:', evaluationData);
          this.selectedAssessmentEvaluationFilterValues = [];
          this.showAssessmentEvaluationChart = this.assessmentEvaluationChartData.some(item => (item && item.value) ? item.value > 0 : false);
          this.isLoading = false;
          this.cdr.detectChanges();
          setTimeout(() => {
            if (this.showAssessmentEvaluationChart && document.getElementById('assessmentEvaluationChart')) {
              this.initializeAssessmentEvaluationPieChart();
            }
          }, 0);
        } else {
          console.warn('Assessment Evaluation - no operationsData in response', response);
          this.assessmentEvaluationChartData = [];
          this.showAssessmentEvaluationChart = false;
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.assessmentEvaluationChartData = [];
        this.showAssessmentEvaluationChart = false;
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  // Candidate Assessment Year/Month Filter Methods
  toggleCandidateAssessmentYearDropdown(): void {
    this.showCandidateAssessmentYearDropdown = !this.showCandidateAssessmentYearDropdown;
    if (this.showCandidateAssessmentYearDropdown) {
      this.showCandidateAssessmentMonthDropdown = false;
    }
  }

  selectCandidateAssessmentYearRange(yearRange: string): void {
    this.selectedCandidateAssessmentYearRange = yearRange;
    this.showCandidateAssessmentYearDropdown = false;
    this.applyCandidateAssessmentMonthYearFilter();
  }

  toggleCandidateAssessmentMonthDropdown(): void {
    this.showCandidateAssessmentMonthDropdown = !this.showCandidateAssessmentMonthDropdown;
    if (this.showCandidateAssessmentMonthDropdown) {
      this.showCandidateAssessmentYearDropdown = false;
    }
  }

  selectCandidateAssessmentMonth(month: number): void {
    this.selectedCandidateAssessmentMonth = month;
    this.showCandidateAssessmentMonthDropdown = false;
    this.applyCandidateAssessmentMonthYearFilter();
  }

  applyCandidateAssessmentMonthYearFilter(): void {
    this.showCandidateAssessmentYearDropdown = false;
    this.showCandidateAssessmentMonthDropdown = false;
    this.fetchCandidateAssessmentData();
  }

  // Assessment Customer Year/Month Filter Methods
  toggleAssessmentCustomerYearDropdown(): void {
    this.showAssessmentCustomerYearDropdown = !this.showAssessmentCustomerYearDropdown;
    if (this.showAssessmentCustomerYearDropdown) {
      this.showAssessmentCustomerMonthDropdown = false;
    }
  }

  selectAssessmentCustomerYearRange(yearRange: string): void {
    this.selectedAssessmentCustomerYearRange = yearRange;
    this.showAssessmentCustomerYearDropdown = false;
    this.applyAssessmentCustomerMonthYearFilter();
  }

  toggleAssessmentCustomerMonthDropdown(): void {
    this.showAssessmentCustomerMonthDropdown = !this.showAssessmentCustomerMonthDropdown;
    if (this.showAssessmentCustomerMonthDropdown) {
      this.showAssessmentCustomerYearDropdown = false;
    }
  }

  selectAssessmentCustomerMonth(month: number): void {
    this.selectedAssessmentCustomerMonth = month;
    this.showAssessmentCustomerMonthDropdown = false;
    this.applyAssessmentCustomerMonthYearFilter();
  }

  applyAssessmentCustomerMonthYearFilter(): void {
    this.showAssessmentCustomerYearDropdown = false;
    this.showAssessmentCustomerMonthDropdown = false;
    // Re-process the data with new filters if needed
    this.fetchAssessmentCustomerData();

    this.processAssessmentCustomerData(this.rawTop5CustomersByAssessment || this.rawAssessmentDetails);
  }
private fetchAssessmentCustomerData(): void {
  const orgIdAsInt = this.org_id ? parseInt(this.org_id, 10) : null;
  
  if (!orgIdAsInt) {
    console.error('Organization ID is not set. Cannot fetch assessment customer data.');
    this.showAssessmentCustomerChart = false;
    return;
  }

  let startDate: Date;
  let endDate: Date;

  if (this.selectedAssessmentCustomerMonth) {
    const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedAssessmentCustomerYearRange);
    if (yearRange) {
      const year = this.selectedAssessmentCustomerMonth <= 3 ? yearRange.endYear : yearRange.startYear;
      startDate = new Date(year, this.selectedAssessmentCustomerMonth - 1, 1);
      endDate = new Date(year, this.selectedAssessmentCustomerMonth, 0);
    } else {
      const currentYear = new Date().getFullYear();
      startDate = new Date(currentYear, this.selectedAssessmentCustomerMonth - 1, 1);
      endDate = new Date(currentYear, this.selectedAssessmentCustomerMonth, 0);
    }
  } else {
    const dateRange = this.getDateRangeFromYearRange(this.selectedAssessmentCustomerYearRange);
    startDate = dateRange.startDate;
    endDate = dateRange.endDate;
  }

  const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
  const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

  const payload = {
    org_id: orgIdAsInt,
    start_date: formattedStartDate,
    end_date: formattedEndDate
  };

  this.isLoading = true;
  const resp = this.service.getOperationsData(payload);
  
  resp.subscribe(
    (data: any) => {
      const response = data['body']?.['responseBody'] || data?.['responseBody'] || data;
      
      let customerData = [];
      
      if (response?.operationsData?.top_5_customers_by_assessment) {
        const topCustomers = response.operationsData.top_5_customers_by_assessment;
        if (Array.isArray(topCustomers)) {
          customerData = topCustomers;
        } else if (topCustomers.coalesce && Array.isArray(topCustomers.coalesce)) {
          customerData = topCustomers.coalesce;
        }
      } else if (response?.operationsData?.assessment_by_customers) {
        const byCustomers = response.operationsData.assessment_by_customers;
        if (Array.isArray(byCustomers)) {
          customerData = byCustomers;
        }
      }
      
      if (customerData && customerData.length > 0) {
        console.log('Fetched assessment customer data:', customerData);
        this.rawTop5CustomersByAssessment = customerData;
        this.processAssessmentCustomerData(customerData);
      } else {
        console.warn('No customer assessment data found');
        this.showAssessmentCustomerChart = false;
        this.assessmentCustomerChartLabels = [];
        this.assessmentCustomerChartValues = [];
        this.assessmentCustomerChartData = [];
      }
      
      this.isLoading = false;
      this.cdr.detectChanges();
    },
    (error) => {
      console.error('Error fetching assessment customer data:', error);
      this.isLoading = false;
      this.showAssessmentCustomerChart = false;
      this.cdr.detectChanges();
    }
  );
}

  // Assessment Language Year/Month Filter Methods
  toggleAssessmentLanguageYearDropdown(): void {
    this.showAssessmentLanguageYearDropdown = !this.showAssessmentLanguageYearDropdown;
    if (this.showAssessmentLanguageYearDropdown) {
      this.showAssessmentLanguageMonthDropdown = false;
    }
  }

  selectAssessmentLanguageYearRange(yearRange: string): void {
    this.selectedAssessmentLanguageYearRange = yearRange;
    this.showAssessmentLanguageYearDropdown = false;
    this.applyAssessmentLanguageMonthYearFilter();
  }

  toggleAssessmentLanguageMonthDropdown(): void {
    this.showAssessmentLanguageMonthDropdown = !this.showAssessmentLanguageMonthDropdown;
    if (this.showAssessmentLanguageMonthDropdown) {
      this.showAssessmentLanguageYearDropdown = false;
    }
  }

  selectAssessmentLanguageMonth(month: number): void {
    this.selectedAssessmentLanguageMonth = month;
    this.showAssessmentLanguageMonthDropdown = false;
    this.applyAssessmentLanguageMonthYearFilter();
  }

  applyAssessmentLanguageMonthYearFilter(): void {
    this.showAssessmentLanguageYearDropdown = false;
    this.showAssessmentLanguageMonthDropdown = false;
    this.fetchAssessmentLanguageData();
  }

  fetchAssessmentLanguageData(useGlobalRange: boolean = false): void {
    let startDate: Date;
    let endDate: Date;

    if (useGlobalRange && this.startDate && this.endDate) {
      startDate = this.startDate;
      endDate = this.endDate;
    } else if (this.selectedAssessmentLanguageMonth) {
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedAssessmentLanguageYearRange);
      if (yearRange) {
        const year = this.selectedAssessmentLanguageMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedAssessmentLanguageMonth - 1, 1);
        endDate = new Date(year, this.selectedAssessmentLanguageMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedAssessmentLanguageMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedAssessmentLanguageMonth, 0);
      }
    } else {
      const dateRange = this.getDateRangeFromYearRange(this.selectedAssessmentLanguageYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const payload: any = {
      org_id: this.org_id
    };

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

    if (formattedStartDate && formattedEndDate) {
      payload.start_date = formattedStartDate;
      payload.end_date = formattedEndDate;
    }

    this.service.getOperationsData(payload).subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.operationsData) {
          this.languageStatsData = response.operationsData.language_stats || [];
          this.processAssessmentLanguageData(this.languageStatsData);
        } else {
          this.languageStatsData = [];
          this.processAssessmentLanguageData([]);
        }
        this.cdr.detectChanges();
      },
      (error) => {
        console.error('Error fetching assessment language data:', error);
        this.languageStatsData = [];
        this.processAssessmentLanguageData([]);
        this.cdr.detectChanges();
      }
    );
  }

  // Reprocess language chart after course/customer/language filter selections
  updateAssessmentLanguageChartFromFilters(): void {
    this.processAssessmentLanguageData(this.languageStatsData || []);
  }

  toggleAssessmentLanguageFilter(filterType: string, value: string): void {
    if (filterType === 'course') {
      this.toggleSelection(this.selectedAssessmentLanguageCourseValues, value);
    } else if (filterType === 'customer') {
      this.toggleSelection(this.selectedAssessmentLanguageCustomerValues, value);
    } else if (filterType === 'language') {
      this.toggleSelection(this.selectedAssessmentLanguageLanguageValues, value);
    }

    this.updateAssessmentLanguageChartFromFilters();
  }

  isAssessmentLanguageCourseSelected(course: string): boolean {
    return this.selectedAssessmentLanguageCourseValues.includes(course);
  }

  isAssessmentLanguageCustomerSelected(customer: string): boolean {
    return this.selectedAssessmentLanguageCustomerValues.includes(customer);
  }

  isAssessmentLanguageLanguageSelected(language: string): boolean {
    return this.selectedAssessmentLanguageLanguageValues.includes(language);
  }

  clearAssessmentLanguageFilters(): void {
    this.selectedAssessmentLanguageCourseValues = [];
    this.selectedAssessmentLanguageCustomerValues = [];
    this.selectedAssessmentLanguageLanguageValues = [];
    this.assessmentInsightCourseSearchTerm = '';
    this.assessmentInsightCustomerSearchTerm = '';
    this.assessmentInsightLanguageSearchTerm = '';
    this.filteredAssessmentInsightCourseList = [...(this.allAssessmentInsightCourses || [])];
    this.filteredAssessmentEvaluationCustomerList = [...(this.customerMasterData?.length ? this.customerMasterData : (this.customersData || []))];
    this.filteredAssessmentInsightLanguagesList = [...(this.languagesData || [])];
    this.updateAssessmentLanguageChartFromFilters();
  }

  private fetchCandidateAssessmentData(useGlobalRange: boolean = false): void {
    this.isLoading = true;

    let startDate: Date;
    let endDate: Date;

    if (useGlobalRange && this.startDate && this.endDate) {
      startDate = this.startDate;
      endDate = this.endDate;
    } else if (this.selectedCandidateAssessmentMonth) {
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedCandidateAssessmentYearRange);
      if (yearRange) {
        const year = this.selectedCandidateAssessmentMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedCandidateAssessmentMonth - 1, 1);
        endDate = new Date(year, this.selectedCandidateAssessmentMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedCandidateAssessmentMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedCandidateAssessmentMonth, 0);
      }
    } else {
      const dateRange = this.getDateRangeFromYearRange(this.selectedCandidateAssessmentYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const payload: any = {
      org_id: this.org_id
    };

    if (useGlobalRange && this.rangeType) {
      const formattedRange = this.formatDateRange(this.rangeType, startDate, endDate);
      payload.start_date = formattedRange.startDate;
      payload.end_date = formattedRange.endDate;

      if (this.rangeType === 'This month' || this.rangeType === 'Today') {
        payload.selected_month = this.selectedDateFilterMonth;
        payload.selected_year = this.selectedDateFilterYear;
      } else {
        const monthYear = this.getMonthYearForFullMonthRange(startDate, endDate);
        if (monthYear) {
          payload.selected_month = monthYear.month;
          payload.selected_year = monthYear.year;
        }
      }
    } else {
      payload.start_date = moment(startDate).format('YYYY-MM-DD');
      payload.end_date = moment(endDate).format('YYYY-MM-DD');

      const monthYear = this.getMonthYearForFullMonthRange(startDate, endDate);
      if (monthYear) {
        payload.selected_month = monthYear.month;
        payload.selected_year = monthYear.year;
      }
    }

    const resp = this.service.getOperationsData(payload);

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        console.log('DEBUG: fetchCandidateAssessmentData response:', response);
        
        if (response && response.operationsData) {
          this.rawAssessmentDetails = response.operationsData.assessment_details || [];
          this.assessmentWiseStats = response.operationsData.assessment_wise_stats || [];
        }
        
        if (response && response.operationsData && ((response.operationsData.pass_fail && response.operationsData.pass_fail.assessment_wise) || (response.operationsData.top_5_courses_by_assessment))) {
          console.log('DEBUG: Candidate assessments raw:', response.operationsData.top_5_courses_by_assessment || response.operationsData.pass_fail?.assessment_wise);
          
          const candidateColors = [
            '#3498DB', '#E74C3C', '#2ECC71', '#F39C12', '#9B59B6',
            '#1ABC9C', '#34495E', '#E67E22', '#95A5A6', '#D35400'
          ];
          
          let assessmentData: any[] = [];
          if (response.operationsData.top_5_courses_by_assessment && response.operationsData.top_5_courses_by_assessment.length > 0) {
            assessmentData = response.operationsData.top_5_courses_by_assessment.map((course: any, index: number) => ({
              name: course.course_name || 'Unknown Course',
              value: course.total_candidates || 0,
              assessment_id: course.course_name,
              assessment_name: course.course_name || 'Unknown Course',
              color: candidateColors[index % candidateColors.length]
            }));
          } else if (response.operationsData.pass_fail && response.operationsData.pass_fail.assessment_wise) {
            assessmentData = response.operationsData.pass_fail.assessment_wise.map((assessment: any, index: number) => ({
              name: assessment.assessment_title || assessment.assessment_name || `Assessment ${assessment.assessment_id}`,
              value: assessment.candidate_count,
              assessment_id: assessment.assessment_id,
              assessment_name: assessment.assessment_title || assessment.assessment_name,
              color: candidateColors[index % candidateColors.length]
            }));
          }

          const totalCandidatesValue = response.operationsData.total_candidates || 0;
          const overallEntry = {
            name: 'Overall',
            value: totalCandidatesValue,
            is_overall: true
          };

          this.allCandidateAssessments = [overallEntry, ...assessmentData];
          this.filteredCandidateAssessmentList = [overallEntry, ...assessmentData];
          this.candidateAssessmentChartData = assessmentData.length > 0 ? assessmentData : [overallEntry];
          this.showCandidateAssessmentChart = this.candidateAssessmentChartData.length > 0;
          this.isLoading = false;
          
          // Load performance chart data immediately
          console.log('DEBUG: About to process candidate performance data');
          if (response.operationsData.candidate_data_by_performance && Array.isArray(response.operationsData.candidate_data_by_performance)) {
            this.processCandidatePerformanceData({ candidate_data_by_performance: response.operationsData.candidate_data_by_performance });
          } else {
            this.processCandidatePerformanceData(response.operationsData.pass_fail);
          }

          // Process Assessment by Customers chart data
          this.processAssessmentCustomerData(response.operationsData.top_5_customers_by_assessment || response.operationsData.assessment_details || []);

          // Process Assessment by Language chart data (from language_stats)
          this.languageStatsData = response.operationsData.language_stats || [];
          this.processAssessmentLanguageData(this.languageStatsData);

          this.cdr.detectChanges();
          setTimeout(() => {
            if (this.showCandidateAssessmentChart && document.getElementById('candidateAssessmentChart')) {
              this.initializeCandidateAssessmentPieChart();
            }
            if (this.showAssessmentLanguageChart && document.getElementById('assessmentLanguageChart')) {
              this.initializeAssessmentLanguagePieChart();
            }
            if (this.canShowAssessmentCustomerChart && this.showAssessmentCustomerChart && document.getElementById('assessmentCustomerChart')) {
              this.initializeAssessmentCustomerChart();
            }
          }, 150);
        } else {
          this.candidateAssessmentChartData = [];
          this.showCandidateAssessmentChart = false;
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.candidateAssessmentChartData = [];
        this.showCandidateAssessmentChart = false;
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  // Pass/Fail Year/Month Filter Methods
  togglePassFailYearDropdown(): void {
    this.showPassFailYearDropdown = !this.showPassFailYearDropdown;
    if (this.showPassFailYearDropdown) {
      this.showPassFailMonthDropdown = false;
    }
  }

  selectPassFailYearRange(yearRange: string): void {
    this.selectedPassFailYearRange = yearRange;
    this.showPassFailYearDropdown = false;
    this.applyPassFailMonthYearFilter();
  }

  togglePassFailMonthDropdown(): void {
    this.showPassFailMonthDropdown = !this.showPassFailMonthDropdown;
    if (this.showPassFailMonthDropdown) {
      this.showPassFailYearDropdown = false;
    }
  }

  selectPassFailMonth(month: number): void {
    this.selectedPassFailMonth = month;
    this.showPassFailMonthDropdown = false;
    this.applyPassFailMonthYearFilter();
  }

  applyPassFailMonthYearFilter(): void {
    this.showPassFailYearDropdown = false;
    this.showPassFailMonthDropdown = false;
    this.fetchPassFailData();
  }

  private fetchPassFailData(useGlobalRange: boolean = false): void {
    this.isLoading = true;

    let startDate: Date;
    let endDate: Date;

    if (useGlobalRange && this.startDate && this.endDate) {
      startDate = this.startDate;
      endDate = this.endDate;
    } else if (this.selectedPassFailMonth) {
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedPassFailYearRange);
      if (yearRange) {
        const year = this.selectedPassFailMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedPassFailMonth - 1, 1);
        endDate = new Date(year, this.selectedPassFailMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedPassFailMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedPassFailMonth, 0);
      }
    } else {
      const dateRange = this.getDateRangeFromYearRange(this.selectedPassFailYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    // Ensure org_id is properly converted to integer
    const orgIdAsInt = this.org_id ? parseInt(this.org_id, 10) : null;
    
    if (!orgIdAsInt) {
      console.error('Organization ID is not set. Cannot fetch pass/fail data.');
      this.isLoading = false;
      return;
    }

    const payload: any = {
      org_id: orgIdAsInt
    };

    if (useGlobalRange && this.rangeType) {
      const formattedRange = this.formatDateRange(this.rangeType, startDate, endDate);
      payload.start_date = formattedRange.startDate;
      payload.end_date = formattedRange.endDate;

      if (this.rangeType === 'This month' || this.rangeType === 'Today') {
        payload.selected_month = this.selectedDateFilterMonth;
        payload.selected_year = this.selectedDateFilterYear;
      } else {
        const monthYear = this.getMonthYearForFullMonthRange(startDate, endDate);
        if (monthYear) {
          payload.selected_month = monthYear.month;
          payload.selected_year = monthYear.year;
        }
      }
    } else {
      payload.start_date = moment(startDate).format('YYYY-MM-DD');
      payload.end_date = moment(endDate).format('YYYY-MM-DD');

      const monthYear = this.getMonthYearForFullMonthRange(startDate, endDate);
      if (monthYear) {
        payload.selected_month = monthYear.month;
        payload.selected_year = monthYear.year;
      }
    }

    const resp = this.service.getOperationsData(payload);

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        console.log('Pass/Fail API full response:', data);
        console.log('Pass/Fail extracted responseBody:', response);
        if (response && response.operationsData && response.operationsData.pass_fail) {
          const passFailData = response.operationsData.pass_fail;
          console.log('Pass/Fail raw operationsData.pass_fail:', passFailData);

          const overallPassFailEntry = {
            name: 'Overall',
            pass_percent: passFailData.overall_pass_percent || 0,
            fail_percent: passFailData.overall_fail_percent || 0,
            pass: Math.round((passFailData.overall_pass_percent || 0) / 100 * 100),
            fail: Math.round((passFailData.overall_fail_percent || 0) / 100 * 100),
            is_overall: true
          };

          const assessmentPassFailData = (passFailData.assessment_wise || []).map((assessment: any) => ({
            name: assessment.assessment_title || assessment.assessment_name || `Assessment ${assessment.assessment_id}`,
            assessment_id: assessment.assessment_id,
            pass: assessment.pass_count || 0,
            fail: assessment.fail_count || 0,
            candidate_count: assessment.candidate_count || 0
          }));

          this.allPassFailAssessments = [overallPassFailEntry, ...assessmentPassFailData];
          this.filteredPassFailAssessmentList = [overallPassFailEntry, ...assessmentPassFailData];
          this.passFailChartData = [overallPassFailEntry];
          // compute totals to decide visibility
          const totalPass = (overallPassFailEntry.pass || 0) + assessmentPassFailData.reduce((s, a) => s + (a.pass || 0), 0);
          const totalFail = (overallPassFailEntry.fail || 0) + assessmentPassFailData.reduce((s, a) => s + (a.fail || 0), 0);
          const total = totalPass + totalFail;
          console.log('Pass/Fail computed totals:', { totalPass, totalFail, total });
          this.showPassFailChart = total > 0;
          this.isLoading = false;
          // Store raw assessment_wise data for filtering
          this.rawPassFailAssessmentWise = passFailData.assessment_wise || [];
          // Aggregate assessment_wise data by course with filters
          this.aggregatePassFailDataByCourse(this.rawPassFailAssessmentWise);
          
          this.cdr.detectChanges();
          setTimeout(() => {
            if (this.showPassFailChart && document.getElementById('passFailChart')) {
              this.initializePassFailHorizontalBarChart();
            }
          }, 0);
        } else {
          this.passFailChartData = [];
          this.passFailChartLabels = [];
          this.passFailPassData = [];
          this.passFailFailData = [];
          this.passFailReassessedData = [];
          this.showPassFailChart = false;
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.passFailChartData = [];
        this.passFailChartLabels = [];
        this.passFailPassData = [];
        this.passFailFailData = [];
        this.passFailReassessedData = [];
        this.showPassFailChart = false;
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  private getMonthYearForFullMonthRange(startDate: Date, endDate: Date): { month: number; year: number } | null {
    if (!startDate || !endDate) {
      return null;
    }

    if (startDate.getFullYear() !== endDate.getFullYear() || startDate.getMonth() !== endDate.getMonth()) {
      return null;
    }

    const month = startDate.getMonth();
    const year = startDate.getFullYear();
    const lastDayOfMonth = new Date(year, month + 1, 0).getDate();

    if (startDate.getDate() === 1 && endDate.getDate() === lastDayOfMonth) {
      return { month: month + 1, year };
    }

    return null;
  }

  // Aggregate assessment_wise data by course (top 5 + others) with filter support
  private aggregatePassFailDataByCourse(assessmentWiseData: any[]): void {
    // Check if we should show state-wise data instead of course-wise
    if (this.selectedPassFailGeographies && this.selectedPassFailGeographies.length > 0) {
      this.showPassFailStateWiseView = true;
      this.aggregatePassFailDataByState(assessmentWiseData);
      return;
    }

    this.showPassFailStateWiseView = false;

    if (!assessmentWiseData || assessmentWiseData.length === 0) {
      this.passFailChartLabels = [];
      this.passFailPassData = [];
      this.passFailFailData = [];
      this.passFailReassessedData = [];
      console.log('No assessment wise data to aggregate');
      return;
    }

    console.log('Raw assessment_wise data:', assessmentWiseData);
    console.log('Applied filters - Courses:', this.selectedPassFailCourses.length, 'Geographies:', this.selectedPassFailGeographies.length, 'Customers:', this.selectedPassFailCustomers.length, 'Languages:', this.selectedPassFailLanguages.length);

    // Filter the data based on selected courses, geographies, customers, and languages
    let filteredData = assessmentWiseData;

    // Filter by course_id if courses are selected
    if (this.selectedPassFailCourses && this.selectedPassFailCourses.length > 0) {
      const selectedCourseIds = this.selectedPassFailCourses.map(c => c.course_id);
      filteredData = filteredData.filter(item => selectedCourseIds.includes(item.course_id));
      console.log('After course filter:', filteredData.length, 'items');
    }

    // Filter by customer if customers are selected
    if (this.selectedPassFailCustomers && this.selectedPassFailCustomers.length > 0) {
      const selectedCustomerNames = this.selectedPassFailCustomers.map(c => c.name);
      const matchingAssessmentIds = new Set<string>();
      if (this.rawAssessmentDetails && this.rawAssessmentDetails.length > 0) {
        this.rawAssessmentDetails.forEach((detail: any) => {
          const detailCustomerName = (detail.customer_name || detail.customer || '').trim();
          if (detailCustomerName && selectedCustomerNames.includes(detailCustomerName)) {
            const assessmentId = detail.assessment_id != null ? String(detail.assessment_id).trim() : null;
            if (assessmentId) {
              matchingAssessmentIds.add(assessmentId);
            }
          }
        });
      }
      filteredData = filteredData.filter(item => {
        const itemAssessmentId = item.assessment_id != null ? String(item.assessment_id).trim() : null;
        return itemAssessmentId && matchingAssessmentIds.has(itemAssessmentId);
      });
      console.log('After customer filter:', filteredData.length, 'items');
    }

    // Filter by language if languages are selected
    if (this.selectedPassFailLanguages && this.selectedPassFailLanguages.length > 0) {
      const selectedLanguageNames = this.selectedPassFailLanguages.map(l => l.name);
      filteredData = filteredData.filter(item => {
        const itemLanguages = Array.isArray(item.language) ? item.language : [item.language];
        return selectedLanguageNames.some(lang => itemLanguages.includes(lang));
      });
      console.log('After language filter:', filteredData.length, 'items');
    }

    // Group by course_id and aggregate counts
    const courseMap = new Map<number, {
      course_id: number;
      course_name: string;
      pass_count: number;
      fail_count: number;
      reassessed_count: number;
      candidate_count: number;
    }>();

    for (const item of filteredData) {
      const courseId = item.course_id || 0;
      const courseName = item.course_name || 'Unknown Course';
      if (courseMap.has(courseId)) {
        const existing = courseMap.get(courseId)!;
        existing.pass_count += (item.pass_count || 0);
        existing.fail_count += (item.fail_count || 0);
        existing.reassessed_count += (item.reassessed_count || 0);
        existing.candidate_count += (item.candidate_count || 0);
      } else {
        courseMap.set(courseId, {
          course_id: courseId,
          course_name: courseName,
          pass_count: item.pass_count || 0,
          fail_count: item.fail_count || 0,
          reassessed_count: item.reassessed_count || 0,
          candidate_count: item.candidate_count || 0
        });
      }
    }

    // Convert to array and sort by candidate_count descending
    const courses = Array.from(courseMap.values())
      .sort((a, b) => b.candidate_count - a.candidate_count);

    console.log('Aggregated courses by course_id:', courses);

    // Take top 5 courses and aggregate the rest as "Others"
    const top5Courses = courses.slice(0, 5);
    const remainingCourses = courses.slice(5);

    // Initialize arrays - use course_name for display
    this.passFailChartLabels = top5Courses.map(c => c.course_name);
    this.passFailPassData = top5Courses.map(c => c.pass_count);
    this.passFailFailData = top5Courses.map(c => c.fail_count);
    this.passFailReassessedData = top5Courses.map(c => c.reassessed_count);

    // Add "Others" if there are remaining courses
    if (remainingCourses.length > 0) {
      const othersPass = remainingCourses.reduce((sum, c) => sum + c.pass_count, 0);
      const othersFail = remainingCourses.reduce((sum, c) => sum + c.fail_count, 0);
      const othersReassessed = remainingCourses.reduce((sum, c) => sum + c.reassessed_count, 0);

      this.passFailChartLabels.push('Others');
      this.passFailPassData.push(othersPass);
      this.passFailFailData.push(othersFail);
      this.passFailReassessedData.push(othersReassessed);
    }

    console.log('Final aggregated Pass/Fail data by course_id:', {
      labels: this.passFailChartLabels,
      pass: this.passFailPassData,
      fail: this.passFailFailData,
      reassessed: this.passFailReassessedData
    });

    // Populate allPassFailCourses for filter dropdown
    this.allPassFailCourses = courses;
    this.filteredPassFailCourseList = [...courses];
  }

  // Aggregate assessment_wise data by state (when geography filter is applied)
  private aggregatePassFailDataByState(assessmentWiseData: any[]): void {
    if (!assessmentWiseData || assessmentWiseData.length === 0) {
      this.passFailChartLabels = [];
      this.passFailPassData = [];
      this.passFailFailData = [];
      this.passFailReassessedData = [];
      console.log('No assessment wise data to aggregate by state');
      return;
    }

    console.log('Aggregating state-wise data');

    // Get selected state names
    const selectedStateNames = this.selectedPassFailGeographies.map(g => g.state);
    console.log('Selected states:', selectedStateNames);

    // First apply other filters to the data
    let filteredData = assessmentWiseData;

    // Filter by course_id if courses are selected
    if (this.selectedPassFailCourses && this.selectedPassFailCourses.length > 0) {
      const selectedCourseIds = this.selectedPassFailCourses.map(c => c.course_id);
      filteredData = filteredData.filter(item => selectedCourseIds.includes(item.course_id));
      console.log('After course filter:', filteredData.length, 'items');
    }

    // Filter by customer if customers are selected
    if (this.selectedPassFailCustomers && this.selectedPassFailCustomers.length > 0) {
      const selectedCustomerNames = this.selectedPassFailCustomers.map(c => c.name);
      const matchingAssessmentIds = new Set<string>();
      if (this.rawAssessmentDetails && this.rawAssessmentDetails.length > 0) {
        this.rawAssessmentDetails.forEach((detail: any) => {
          const detailCustomerName = (detail.customer_name || detail.customer || '').trim();
          if (detailCustomerName && selectedCustomerNames.includes(detailCustomerName)) {
            const assessmentId = detail.assessment_id != null ? String(detail.assessment_id).trim() : null;
            if (assessmentId) {
              matchingAssessmentIds.add(assessmentId);
            }
          }
        });
      }
      filteredData = filteredData.filter(item => {
        const itemAssessmentId = item.assessment_id != null ? String(item.assessment_id).trim() : null;
        return itemAssessmentId && matchingAssessmentIds.has(itemAssessmentId);
      });
      console.log('After customer filter:', filteredData.length, 'items');
    }

    // Filter by language if languages are selected
    if (this.selectedPassFailLanguages && this.selectedPassFailLanguages.length > 0) {
      const selectedLanguageNames = this.selectedPassFailLanguages.map(l => l.name);
      filteredData = filteredData.filter(item => {
        const itemLanguages = Array.isArray(item.language) ? item.language : [item.language];
        return selectedLanguageNames.some(lang => itemLanguages.includes(lang));
      });
      console.log('After language filter:', filteredData.length, 'items');
    }

    // Build state-wise aggregation from filtered assessment_wise data
    const stateMap = new Map<string, {
      state: string;
      pass_count: number;
      fail_count: number;
      reassessed_count: number;
      candidate_count: number;
    }>();

    for (const item of filteredData) {
      // Process state_pass_counts, state_fail_counts, state_reassessed_counts
      // These are usually objects like { "state_name": count }
      
      const statePassCounts = item.state_pass_counts || {};
      const stateFailCounts = item.state_fail_counts || {};
      const stateReassessedCounts = item.state_reassessed_counts || {};

      // Iterate through selected states
      for (const stateName of selectedStateNames) {
        let passCount = 0;
        let failCount = 0;
        let reassessedCount = 0;

        if (statePassCounts[stateName] !== undefined) {
          passCount = statePassCounts[stateName];
        }
        if (stateFailCounts[stateName] !== undefined) {
          failCount = stateFailCounts[stateName];
        }
        if (stateReassessedCounts[stateName] !== undefined) {
          reassessedCount = stateReassessedCounts[stateName];
        }

        const candidateCount = passCount + failCount + reassessedCount;

        if (stateMap.has(stateName)) {
          const existing = stateMap.get(stateName)!;
          existing.pass_count += passCount;
          existing.fail_count += failCount;
          existing.reassessed_count += reassessedCount;
          existing.candidate_count += candidateCount;
        } else {
          stateMap.set(stateName, {
            state: stateName,
            pass_count: passCount,
            fail_count: failCount,
            reassessed_count: reassessedCount,
            candidate_count: candidateCount
          });
        }
      }
    }

    // Convert to array and sort by candidate_count descending
    const states = Array.from(stateMap.values())
      .sort((a, b) => b.candidate_count - a.candidate_count);

    console.log('Aggregated states:', states);

    // Initialize arrays with state names
    this.passFailChartLabels = states.map(s => s.state);
    this.passFailPassData = states.map(s => s.pass_count);
    this.passFailFailData = states.map(s => s.fail_count);
    this.passFailReassessedData = states.map(s => s.reassessed_count);

    console.log('Final aggregated Pass/Fail data by state:', {
      labels: this.passFailChartLabels,
      pass: this.passFailPassData,
      fail: this.passFailFailData,
      reassessed: this.passFailReassessedData
    });
  }

  // Initialize horizontal stacked bar chart for Pass/Fail by course
  private initializePassFailHorizontalBarChart(): void {
    if (this.selectedViewType !== 'assessment' && this.selectedViewType !== 'all') return;

    const canvas = document.getElementById('passFailChart') as HTMLCanvasElement;
    if (!canvas || !this.passFailChartLabels?.length) return;

    console.log('Initializing chart with:', {
      labels: this.passFailChartLabels,
      pass: this.passFailPassData,
      fail: this.passFailFailData,
      reassessed: this.passFailReassessedData
    });

    // Destroy old chart
    if (this.passFailChart) {
      this.passFailChart.destroy();
    }

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Clear canvas to prevent any residual chart elements that might look like donut charts
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Create datasets for each status
    const datasets = [
      {
        label: 'Passed',
        data: this.passFailPassData,
        backgroundColor: '#015C96',
        borderColor: '#015C96',
        borderWidth: 0,
        barThickness: 'flex' as any,
        categoryPercentage: 0.85,
        barPercentage: 0.95
      },
      {
        label: 'Failed',
        data: this.passFailFailData,
        backgroundColor: '#FF6F59',
        borderColor: '#FF6F59',
        borderWidth: 0,
        barThickness: 'flex' as any,
        categoryPercentage: 0.85,
        barPercentage: 0.95
      },
      {
        label: 'Reassessed',
        data: this.passFailReassessedData,
        backgroundColor: '#FFDB93',
        borderColor: '#FFDB93',
        borderWidth: 0,
        barThickness: 'flex' as any,
        categoryPercentage: 0.85,
        barPercentage: 0.95
      }
    ];

    this.passFailChart = new Chart(ctx, {
      type: 'bar',  // Explicitly set as bar chart to prevent donut chart appearance
      data: {
        labels: this.passFailChartLabels,
        datasets: datasets
      },
      options: {
        indexAxis: 'x',  // Vertical bar chart
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 10,
            right: 10,
            top: 0,
            bottom: 0
          }
        },
        plugins: {
          legend: { display: false },  // Legend handled separately in HTML
          tooltip: {
            enabled: true,
            mode: 'index',
            intersect: false,
            callbacks: {
              title: (context) => {
                if (context.length > 0) {
                  return `${context[0].label || ''}`;
                }
                return '';
              },
              label: (context) => {
                const value = context.raw as number;
                return `${context.dataset.label}: ${value}`;
              },
              afterLabel: (context) => {
                const index = context.dataIndex;
                if (index >= 0 && index < this.passFailChartLabels.length) {
                  const passed = this.passFailPassData[index] || 0;
                  const failed = this.passFailFailData[index] || 0;
                  const reassessed = this.passFailReassessedData[index] || 0;
                }
                return '';
              }
            }
          }
        },
        scales: {
          x: {
            stacked: true,
            offset: true,
            type: 'category',
            position: 'bottom',
            ticks: {
              padding: 12,
              autoSkip: false,
              maxRotation: 45,
              minRotation: 0,
              font: {
                size: 9,
                weight: 500 as any
              },
              color: '#333'
            },
            grid: {
              display: false
            }
          },
          y: {
            stacked: true,
            beginAtZero: true,
            position: 'left',
            ticks: {
              stepSize: 250
            },
            grid: {
              display: true,
              color: 'rgba(0, 0, 0, 0.05)'
            }
          }
        }
      }
    });
  }

  // Get percentage for assessment charts
  getAssessmentLocationPercentage(item: any): string {
    if (!this.assessmentLocationChartData || this.assessmentLocationChartData.length === 0) return '0';
    const total = this.assessmentLocationChartData.reduce((sum, i) => sum + (i.value || 0), 0);
    return total > 0 ? ((item.value / total) * 100).toFixed(2) : '0';
  }

  getAssessmentCoursePercentage(item: any): string {
    if (!this.assessmentCourseChartData || this.assessmentCourseChartData.length === 0) {
      return '0';
    }

    const total = this.assessmentCourseChartData.reduce((sum, curr) => sum + curr.value, 0);
    if (total === 0) return '0';

    const percentage = (item.value / total) * 100;
    return percentage.toFixed(1);
  }

  getAssessmentStatusPercentage(item: any): string {
    if (!this.assessmentStatusChartData || this.assessmentStatusChartData.length === 0) return '0';
    const total = this.assessmentStatusChartData.reduce((sum, i) => sum + (i.value || 0), 0);
    return total > 0 ? ((item.value / total) * 100).toFixed(2) : '0';
  }

  getAssessmentEvaluationPercentage(item: any): string {
    if (!this.assessmentEvaluationChartData || this.assessmentEvaluationChartData.length === 0) return '0';
    const total = this.assessmentEvaluationChartData.reduce((sum, i) => sum + (i.value || 0), 0);
    return total > 0 ? ((item.value / total) * 100).toFixed(2) : '0';
  }

  getCandidateAssessmentPercentage(item: any): string {
    if (!this.candidateAssessmentChartData || this.candidateAssessmentChartData.length === 0) return '0';
    const total = this.candidateAssessmentChartData.reduce((sum, i) => sum + (i.value || 0), 0);
    return total > 0 ? ((item.value / total) * 100).toFixed(2) : '0';
  }

  // Toggle Assessment Status Filter Panel
  toggleAssessmentStatusFilterPanel(): void {
    this.showAssessmentStatusFilterPanel = !this.showAssessmentStatusFilterPanel;
    if (this.showAssessmentStatusFilterPanel) {
      this.showAssessmentStatusChartMenu = false; // Close menu when opening filter
    }
  }

  // Set Active Assessment Status Filter Header
  setActiveAssessmentStatusFilterHeader(header: string): void {
    this.activeAssessmentStatusFilterHeader = header;
  }

  // Filter Assessment Status
  filterAssessmentStatus(): void {
    if (!this.assessmentStatusSearchTerm) {
      this.filteredAssessmentStatusList = [...this.allAssessmentStatuses];
    } else {
      this.filteredAssessmentStatusList = this.allAssessmentStatuses.filter(status =>
        status.name?.toLowerCase().includes(this.assessmentStatusSearchTerm.toLowerCase())
      );
    }
  }

  // Filter Assessment Publish Status
  filterAssessmentPublishStatus(): void {
    if (!this.assessmentPublishSearchTerm) {
      this.filteredAssessmentPublishList = [...this.allAssessmentPublishStatuses];
    } else {
      this.filteredAssessmentPublishList = this.allAssessmentPublishStatuses.filter(status =>
        status.name?.toLowerCase().includes(this.assessmentPublishSearchTerm.toLowerCase())
      );
    }
  }

  // Assessment Status Filter Selection Methods
  isStatusSelectedForAssessment(statusId: any): boolean {
    return this.selectedAssessmentStatusFilterValues.includes(statusId);
  }

  toggleStatusSelectionForAssessment(statusId: any): void {
    const index = this.selectedAssessmentStatusFilterValues.indexOf(statusId);
    if (index > -1) {
      this.selectedAssessmentStatusFilterValues.splice(index, 1);
    } else {
      this.selectedAssessmentStatusFilterValues.push(statusId);
    }
    this.updateAssessmentStatusFilteredData();
  }

  areAllStatusesSelectedForAssessment(): boolean {
    if (this.allAssessmentStatuses.length === 0) return false;
    return this.selectedAssessmentStatusFilterValues.length === this.allAssessmentStatuses.length;
  }

  toggleAllStatusesSelectionForAssessment(): void {
    if (this.areAllStatusesSelectedForAssessment()) {
      this.selectedAssessmentStatusFilterValues = [];
    } else {
      this.selectedAssessmentStatusFilterValues = this.allAssessmentStatuses.map(status => status.id);
    }
    this.updateAssessmentStatusFilteredData();
  }

  isStatusesSelectionIndeterminateForAssessment(): boolean {
    if (this.selectedAssessmentStatusFilterValues.length === 0) return false;
    if (this.selectedAssessmentStatusFilterValues.length === this.allAssessmentStatuses.length) return false;
    return true;
  }

  // Update Assessment Status Chart based on selected filters
  updateAssessmentStatusFilteredData(): void {
    let filteredData = [...this.allAssessmentStatuses];

    // Apply status filter
    if (this.selectedAssessmentStatusFilterValues.length > 0) {
      filteredData = filteredData.filter(status =>
        this.selectedAssessmentStatusFilterValues.includes(status.id)
      );
    }

    // Update chart data
    this.assessmentStatusChartData = filteredData;
    this.showAssessmentStatusChart = this.assessmentStatusChartData.length > 0;
    this.cdr.detectChanges();

    setTimeout(() => {
      if (this.showAssessmentStatusChart && document.getElementById('assessmentStatusChart')) {
        this.initializeAssessmentStatusDoughnutChart();
      }
    }, 0);
  }

  // Update Assessment Status Chart with Selected Filters
  updateAssessmentStatusChart(): void {
    // Get all checkboxes in the filter panel
    const checkboxes = document.querySelectorAll('.filter-panel-container[class*="active"] .filter-checkbox-input');
    const selectedStatuses: any[] = [];

    checkboxes.forEach((checkbox: any, index) => {
      if (checkbox.checked && this.allAssessmentStatuses[index]) {
        selectedStatuses.push(this.allAssessmentStatuses[index]);
      }
    });

    // If no filters selected, show all
    if (selectedStatuses.length === 0) {
      this.assessmentStatusChartData = [...this.allAssessmentStatuses];
    } else {
      this.assessmentStatusChartData = selectedStatuses;
    }

    // Reinitialize chart with filtered data
    setTimeout(() => {
      this.initializeAssessmentStatusDoughnutChart();
    }, 0);
  }

  // Toggle Assessment Status Chart Menu
  toggleAssessmentStatusChartMenu(): void {
    this.showAssessmentStatusChartMenu = !this.showAssessmentStatusChartMenu;
    if (this.showAssessmentStatusChartMenu) {
      this.showAssessmentStatusFilterPanel = false; // Close filter when opening menu
    }
  }

  // Initialize Assessment Status Doughnut Chart
  private initializeAssessmentStatusDoughnutChart(): void {
    if (this.selectedViewType !== 'assessment' && this.selectedViewType !== 'all') {
      this.showAssessmentStatusChart = false; // Hide chart
      return; // Only initialize in assessment or all views
    }

    const canvas = document.getElementById('assessmentStatusChart') as HTMLCanvasElement;

    if (!canvas) {
      this.showAssessmentStatusChart = false; // Hide chart
      return;
    }

    if (!this.assessmentStatusChartData || this.assessmentStatusChartData.length === 0) {
      this.showAssessmentStatusChart = false; // Hide chart

      // Destroy existing chart if it exists
      if (this.assessmentStatusChart) {
        this.assessmentStatusChart.destroy();
        this.assessmentStatusChart = null;
      }

      return;
    }

    // Prepare chart data
    const labels = this.assessmentStatusChartData.map(item => item.name);
    const data = this.assessmentStatusChartData.map(item => item.value);
    const defaultColors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9', '#F8B195'
    ];

    // Use color from data if available, otherwise use default colors
    const colors = this.assessmentStatusChartData.map((item, index) => item.color || defaultColors[index % defaultColors.length]);

    // Destroy existing chart if it exists
    if (this.assessmentStatusChart) {
      this.assessmentStatusChart.destroy();
      this.assessmentStatusChart = null;
    }

    try {
      this.assessmentStatusChart = new Chart(canvas, {
        type: 'doughnut',
        data: {
          labels: labels,
          datasets: [{
            label: 'Assessment Count',
            data: data,
            backgroundColor: colors.slice(0, data.length),
            borderColor: '#fff',
            borderWidth: 0,
            hoverBorderWidth: 0,
            hoverBorderColor: 'transparent'
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false
            }
          }
        }
      });

      this.showAssessmentStatusChart = true; // Show chart
    } catch (error) {
      // Error creating assessment status chart
      this.showAssessmentStatusChart = false; // Hide chart on error

      // Destroy chart if creation failed
      if (this.assessmentStatusChart) {
        this.assessmentStatusChart.destroy();
        this.assessmentStatusChart = null;
      }
    }
  }


  // Toggle Assessment Evaluation Filter Panel
  toggleAssessmentEvaluationFilterPanel(): void {
    this.showAssessmentEvaluationFilterPanel = !this.showAssessmentEvaluationFilterPanel;
    if (this.showAssessmentEvaluationFilterPanel) {
      this.showAssessmentEvaluationChartMenu = false; // Close menu when opening filter
      this.activeAssessmentEvaluationFilterHeader = 'course';
      this.assessmentInsightCourseSearchTerm = '';
      this.assessmentEvaluationCourseSearchTerm = '';
      this.filterAssessmentInsightCoursesFromApi();
      this.filteredAssessmentEvaluationGeographyList = [...(this.allGeographicInsightGeographies || this.geographyData || [])];
      this.filteredAssessmentEvaluationLanguageList = [...(this.languagesData || [])];
      this.filteredAssessmentEvaluationCustomerList = [...(this.customerMasterData || this.customersData || [])];
    }
  }

  // Set Active Assessment Evaluation Filter Header
  setActiveAssessmentEvaluationFilterHeader(header: string): void {
    this.activeAssessmentEvaluationFilterHeader = header;
  }

  // Filter Assessment Evaluation Status
  filterAssessmentEvaluation(): void {
    if (!this.assessmentEvaluationSearchTerm) {
      this.filteredAssessmentEvaluationList = [...this.allAssessmentEvaluations];
    } else {
      this.filteredAssessmentEvaluationList = this.allAssessmentEvaluations.filter(evaluation =>
        evaluation.name?.toLowerCase().includes(this.assessmentEvaluationSearchTerm.toLowerCase())
      );
    }
  }

  filterAssessmentEvaluationCourses(): void {
    const searchTerm = this.assessmentEvaluationCourseSearchTerm.trim().toLowerCase();
    const source = this.allAssessmentInsightCourses && this.allAssessmentInsightCourses.length > 0
      ? this.allAssessmentInsightCourses
      : [];

    if (!searchTerm) {
      this.filteredAssessmentEvaluationCourseList = [...source];
    } else {
      this.filteredAssessmentEvaluationCourseList = source.filter((course: any) =>
        ((course.name || course.course || '') as string).toLowerCase().includes(searchTerm)
      );
    }
  }

  filterAssessmentEvaluationGeographies(): void {
    const searchTerm = this.assessmentEvaluationGeographySearchTerm.trim().toLowerCase();
    const source = (this.allGeographicInsightGeographies && this.allGeographicInsightGeographies.length > 0)
      ? this.allGeographicInsightGeographies
      : this.geographyData;

    if (!searchTerm) {
      this.filteredAssessmentEvaluationGeographyList = [...(source || [])];
    } else {
      this.filteredAssessmentEvaluationGeographyList = (source || []).filter((geo: any) =>
        ((geo.state || '') as string).toLowerCase().includes(searchTerm)
      );
    }
  }

  filterAssessmentEvaluationLanguages(): void {
    const searchTerm = this.assessmentEvaluationLanguageSearchTerm.trim().toLowerCase();
    const source = (this.languagesData && this.languagesData.length > 0) ? this.languagesData : [];

    if (!searchTerm) {
      this.filteredAssessmentEvaluationLanguageList = [...source];
    } else {
      this.filteredAssessmentEvaluationLanguageList = source.filter((language: any) =>
        ((language.name || '') as string).toLowerCase().includes(searchTerm)
      );
    }
  }

  filterAssessmentEvaluationCustomers(): void {
    const searchTerm = this.assessmentEvaluationCustomerSearchTerm.trim().toLowerCase();
    const source = (this.customerMasterData && this.customerMasterData.length > 0)
      ? this.customerMasterData
      : this.customersData;

    if (!searchTerm) {
      this.filteredAssessmentEvaluationCustomerList = [...(source || [])];
    } else {
      this.filteredAssessmentEvaluationCustomerList = (source || []).filter((customer: any) =>
        (((customer.name || customer.customer_name || customer.customer || '') as string).toLowerCase().includes(searchTerm))
      );
    }
  }

  toggleAssessmentEvaluationFilter(filterType: string, value: string): void {
    if (filterType === 'course') {
      this.toggleSelection(this.selectedAssessmentEvaluationCourseValues, value);
    } else if (filterType === 'geography') {
      this.toggleSelection(this.selectedAssessmentEvaluationGeographyValues, value);
    } else if (filterType === 'language') {
      this.toggleSelection(this.selectedAssessmentEvaluationLanguageValues, value);
    } else if (filterType === 'customer') {
      this.toggleSelection(this.selectedAssessmentEvaluationCustomerValues, value);
    } else if (filterType === 'evaluation') {
      this.toggleEvaluationSelectionForAssessment(value);
      return;
    }

    this.updateAssessmentEvaluationFilteredData();
  }

  isAssessmentEvaluationCourseSelected(course: string): boolean {
    return this.selectedAssessmentEvaluationCourseValues.includes(course);
  }

  isAssessmentEvaluationGeographySelected(geo: string): boolean {
    return this.selectedAssessmentEvaluationGeographyValues.includes(geo);
  }

  isAssessmentEvaluationLanguageSelected(language: string): boolean {
    return this.selectedAssessmentEvaluationLanguageValues.includes(language);
  }

  isAssessmentEvaluationCustomerSelected(customer: string): boolean {
    return this.selectedAssessmentEvaluationCustomerValues.includes(customer);
  }

  // Clear Assessment Evaluation Filters
  clearAssessmentEvaluationFilters(): void {
    this.selectedAssessmentEvaluationFilterValues = [];
    this.selectedAssessmentEvaluationCourseValues = [];
    this.selectedAssessmentEvaluationGeographyValues = [];
    this.selectedAssessmentEvaluationLanguageValues = [];
    this.selectedAssessmentEvaluationCustomerValues = [];
    this.assessmentEvaluationSearchTerm = '';
    this.assessmentEvaluationCourseSearchTerm = '';
    this.assessmentEvaluationGeographySearchTerm = '';
    this.assessmentEvaluationLanguageSearchTerm = '';
    this.assessmentEvaluationCustomerSearchTerm = '';
    this.filteredAssessmentEvaluationList = [...this.allAssessmentEvaluations];
    this.filteredAssessmentEvaluationCourseList = [...(this.allAssessmentInsightCourses || [])];
    this.filteredAssessmentEvaluationGeographyList = [...(this.allGeographicInsightGeographies || this.geographyData || [])];
    this.filteredAssessmentEvaluationLanguageList = [...(this.languagesData || [])];
    this.filteredAssessmentEvaluationCustomerList = [...(this.customerMasterData || this.customersData || [])];
    this.updateAssessmentEvaluationFilteredData();
  }

  // Assessment Evaluation Filter Selection Methods
  isEvaluationSelectedForAssessment(evaluationId: any): boolean {
    return this.selectedAssessmentEvaluationFilterValues.includes(evaluationId);
  }

  toggleEvaluationSelectionForAssessment(evaluationId: any): void {
    const index = this.selectedAssessmentEvaluationFilterValues.indexOf(evaluationId);
    if (index > -1) {
      this.selectedAssessmentEvaluationFilterValues.splice(index, 1);
    } else {
      this.selectedAssessmentEvaluationFilterValues.push(evaluationId);
    }
    this.updateAssessmentEvaluationFilteredData();
  }

  areAllEvaluationsSelectedForAssessment(): boolean {
    if (this.allAssessmentEvaluations.length === 0) return false;
    return this.selectedAssessmentEvaluationFilterValues.length === this.allAssessmentEvaluations.length;
  }

  toggleAllEvaluationsSelectionForAssessment(): void {
    if (this.areAllEvaluationsSelectedForAssessment()) {
      this.selectedAssessmentEvaluationFilterValues = [];
    } else {
      this.selectedAssessmentEvaluationFilterValues = this.allAssessmentEvaluations.map(evaluation => evaluation.id);
    }
    this.updateAssessmentEvaluationFilteredData();
  }

  isEvaluationsSelectionIndeterminateForAssessment(): boolean {
    if (this.selectedAssessmentEvaluationFilterValues.length === 0) return false;
    if (this.selectedAssessmentEvaluationFilterValues.length === this.allAssessmentEvaluations.length) return false;
    return true;
  }

  // Update Assessment Evaluation Chart based on selected filters
  updateAssessmentEvaluationFilteredData(): void {
    const hasSelection =
      this.selectedAssessmentEvaluationCourseValues.length > 0 ||
      this.selectedAssessmentEvaluationGeographyValues.length > 0 ||
      this.selectedAssessmentEvaluationLanguageValues.length > 0 ||
      this.selectedAssessmentEvaluationCustomerValues.length > 0;

    let filteredData = hasSelection
      ? this.getAssessmentEvaluationChartDataFromDetails()
      : [...this.allAssessmentEvaluations];

    if (this.selectedAssessmentEvaluationFilterValues.length > 0 && filteredData.length > 0) {
      filteredData = filteredData.filter(evaluation =>
        this.selectedAssessmentEvaluationFilterValues.includes(evaluation.id)
      );
    }

    if (filteredData.length === 0) {
      this.assessmentEvaluationChartData = [];
      this.showAssessmentEvaluationChart = false;
    } else {
      this.assessmentEvaluationChartData = filteredData;
      this.showAssessmentEvaluationChart = this.assessmentEvaluationChartData.some(item => (item && item.value) ? item.value > 0 : false);
    }
    this.cdr.detectChanges();

    setTimeout(() => {
      if (this.showAssessmentEvaluationChart && document.getElementById('assessmentEvaluationChart')) {
        this.initializeAssessmentEvaluationPieChart();
      }
    }, 0);
  }

  private getAssessmentEvaluationChartDataFromDetails(): any[] {
    const assessmentDetails = this.getOperationsDataResponse()?.assessment_details || [];
    if (!Array.isArray(assessmentDetails) || assessmentDetails.length === 0) {
      return [...this.allAssessmentEvaluations];
    }

    let filteredDetails = [...assessmentDetails];
    const selectedCourses = this.selectedAssessmentEvaluationCourseValues || [];
    const selectedGeographies = this.selectedAssessmentEvaluationGeographyValues || [];
    const selectedLanguages = this.selectedAssessmentEvaluationLanguageValues || [];
    const selectedCustomers = this.selectedAssessmentEvaluationCustomerValues || [];

    if (selectedCourses.length > 0) {
      filteredDetails = filteredDetails.filter(detail =>
        this.matchesSelectedAssessmentEvaluationCourses(detail, selectedCourses)
      );
    }



    if (selectedLanguages.length > 0) {
      filteredDetails = filteredDetails.filter(detail =>
        this.doesAssessmentMatchSelectedLanguages(detail, selectedLanguages)
      );
    }

    if (selectedCustomers.length > 0) {
      filteredDetails = filteredDetails.filter(detail =>
        this.matchesSelectedAssessmentEvaluationCustomers(detail, selectedCustomers)
      );
    }

    const plannedIds = new Set<string>();
    const executedIds = new Set<string>();
    const evaluatedIds = new Set<string>();
    const publishedIds = new Set<string>();

    filteredDetails.forEach((detail: any) => {
      const assessmentId = detail.assessment_id != null ? String(detail.assessment_id).trim() : null;
      if (!assessmentId) {
        return;
      }

      let isPlanned = false;
      let isExecuted = false;
      let isEvaluated = false;
      let isPublished = false;

      if (selectedGeographies.length > 0) {
        isPlanned = selectedGeographies.some(geo => (detail.planned_by_state && detail.planned_by_state[geo]) > 0);
        isExecuted = selectedGeographies.some(geo => (detail.executed_by_state && detail.executed_by_state[geo]) > 0);
        isEvaluated = selectedGeographies.some(geo => (detail.evaluated_by_state && detail.evaluated_by_state[geo]) > 0);
        isPublished = selectedGeographies.some(geo => (detail.published_by_state && detail.published_by_state[geo]) > 0);
      } else {
        const pCount = parseInt(detail.planned_count, 10) || 0;
        const exCount = parseInt(detail.executed_count, 10) || 0;
        const evCount = parseInt(detail.evaluated_count, 10) || 0;
        const pubCount = parseInt(detail.published_count, 10) || 0;

        isPlanned = pCount > 0 || (detail.planned_by_state && Object.values(detail.planned_by_state).some((v: any) => v > 0));
        isExecuted = exCount > 0 || (detail.executed_by_state && Object.values(detail.executed_by_state).some((v: any) => v > 0));
        isEvaluated = evCount > 0 || (detail.evaluated_by_state && Object.values(detail.evaluated_by_state).some((v: any) => v > 0));
        isPublished = pubCount > 0 || (detail.published_by_state && Object.values(detail.published_by_state).some((v: any) => v > 0));
      }

      if (isPlanned) plannedIds.add(assessmentId);
      if (isExecuted) executedIds.add(assessmentId);
      if (isEvaluated) evaluatedIds.add(assessmentId);
      if (isPublished) publishedIds.add(assessmentId);
    });

    return [
      { id: 'planned', name: 'Planned', value: plannedIds.size, color: '#C61F1E' },
      { id: 'executed', name: 'Executed', value: executedIds.size, color: '#0A68A6' },
      { id: 'evaluated', name: 'Evaluated', value: evaluatedIds.size, color: '#FDBF48' },
      { id: 'published', name: 'Published', value: publishedIds.size, color: '#FFFDD0' }
    ];
  }

  private getAssessmentType(detail: any): string {
    const rawType = (detail.type || detail.assessment_type || detail.status || detail.evaluation_status || '')
      .toString()
      .trim()
      .toLowerCase();

    if (rawType.includes('planned')) return 'planned';
    if (rawType.includes('executed')) return 'executed';
    if (rawType.includes('evaluated')) return 'evaluated';
    if (rawType.includes('publish')) return 'published';
    return rawType;
  }

  private matchesSelectedAssessmentEvaluationCourses(detail: any, selectedCourses: string[]): boolean {
    const assessmentCourse = this.normalizeString(
      detail.course || detail.course_name || detail.name || detail.assessment_title || detail.assessment_name || ''
    );

    return selectedCourses.some(course => {
      const normalizedCourse = this.normalizeString(course);
      return normalizedCourse === assessmentCourse ||
        assessmentCourse.includes(normalizedCourse) ||
        normalizedCourse.includes(assessmentCourse);
    });
  }

  private matchesSelectedAssessmentEvaluationGeographies(detail: any, selectedGeographies: string[]): boolean {
    const fields = ['state', 'state_name', 'city', 'district', 'location', 'assessment_location', 'geography'];
    const normalizedSelectedGeos = selectedGeographies.map(this.normalizeString);

    return fields.some(field => {
      const rawValue = detail[field];
      return this.valueMatchesSelectedGeographies(rawValue, normalizedSelectedGeos);
    });
  }

  private valueMatchesSelectedGeographies(value: any, normalizedSelectedGeos: string[]): boolean {
    if (!value || normalizedSelectedGeos.length === 0) {
      return false;
    }

    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      const normalizedValue = this.normalizeString(String(value));
      return normalizedSelectedGeos.some(selectedGeo =>
        normalizedValue === selectedGeo ||
        normalizedValue.includes(selectedGeo) ||
        selectedGeo.includes(normalizedValue)
      );
    }

    if (Array.isArray(value)) {
      return value.some(item => this.valueMatchesSelectedGeographies(item, normalizedSelectedGeos));
    }

    if (typeof value === 'object') {
      return Object.keys(value || {}).some(key =>
        this.valueMatchesSelectedGeographies(key, normalizedSelectedGeos)
      );
    }

    return false;
  }

  private matchesSelectedAssessmentEvaluationCustomers(detail: any, selectedCustomers: string[]): boolean {
    const customerValues = this.getCustomerValuesFromDetail(detail);
    const normalizedCustomerValues = customerValues.map(value => this.normalizeString(value)).filter(Boolean);
    if (normalizedCustomerValues.length === 0) {
      return false;
    }

    return selectedCustomers.some(customer => {
      const normalizedCustomer = this.normalizeString(customer);
      return normalizedCustomerValues.some(value =>
        value === normalizedCustomer ||
        value.includes(normalizedCustomer) ||
        normalizedCustomer.includes(value)
      );
    });
  }

  private getCustomerValuesFromDetail(detail: any): string[] {
    if (!detail || typeof detail !== 'object') {
      return [];
    }

    const values: string[] = [];
    const fields = ['customer_name', 'customer', 'customer_name_display', 'customer_name_full', 'client_name'];

    fields.forEach(field => {
      const value = detail[field];
      if (value) {
        if (Array.isArray(value)) {
          values.push(...value.map(v => String(v)));
        } else {
          values.push(String(value));
        }
      }
    });

    if (values.length === 0) {
      Object.keys(detail).forEach(key => {
        if (key.toLowerCase().includes('customer') || key.toLowerCase().includes('client')) {
          const value = detail[key];
          if (value) {
            if (Array.isArray(value)) {
              values.push(...value.map(v => String(v)));
            } else if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
              values.push(String(value));
            }
          }
        }
      });
    }

    return Array.from(new Set(values));
  }

  private getAssessmentIdsForSelectedStates(selectedStates: string[]): Set<string> {
    const matchedIds = new Set<string>();
    if (!Array.isArray(this.rawAssessmentDataWithStateInfo) || this.rawAssessmentDataWithStateInfo.length === 0) {
      return matchedIds;
    }

    const normalizedSelectedStates = selectedStates.map(this.normalizeString);

    this.rawAssessmentDataWithStateInfo.forEach((assessment: any) => {
      const assessmentId = assessment.assessment_id != null ? String(assessment.assessment_id).trim() : null;
      if (!assessmentId) {
        return;
      }

      const fields = [
        'assessment_state',
        'state',
        'state_name',
        'location',
        'district',
        'city'
      ];

      let matched = false;

      for (const field of fields) {
        if (this.valueMatchesSelectedGeographies(assessment[field], normalizedSelectedStates)) {
          matched = true;
          break;
        }
      }

      if (!matched && assessment.state_wise_candidates) {
        if (this.valueMatchesSelectedGeographies(assessment.state_wise_candidates, normalizedSelectedStates)) {
          matched = true;
        }
      }

      if (matched) {
        matchedIds.add(assessmentId);
      }
    });

    return matchedIds;
  }

  // Update Assessment Evaluation Chart with Selected Filters
  updateAssessmentEvaluationChart(): void {
    const checkboxes = document.querySelectorAll('.filter-panel-container[class*="active"] .filter-checkbox-input');
    const selectedEvaluations: any[] = [];

    checkboxes.forEach((checkbox: any, index) => {
      if (checkbox.checked && this.allAssessmentEvaluations[index]) {
        selectedEvaluations.push(this.allAssessmentEvaluations[index]);
      }
    });

    if (selectedEvaluations.length === 0) {
      this.assessmentEvaluationChartData = [...this.allAssessmentEvaluations];
    } else {
      this.assessmentEvaluationChartData = selectedEvaluations;
    }

    // Show chart only if there is at least one non-zero value
    this.showAssessmentEvaluationChart = this.assessmentEvaluationChartData.some(item => (item && item.value) ? item.value > 0 : false);
    this.cdr.detectChanges();

    setTimeout(() => {
      this.initializeAssessmentEvaluationPieChart();
    }, 0);
  }

  // Toggle Assessment Evaluation Chart Menu
  toggleAssessmentEvaluationChartMenu(): void {
    this.showAssessmentEvaluationChartMenu = !this.showAssessmentEvaluationChartMenu;
    if (this.showAssessmentEvaluationChartMenu) {
      this.showAssessmentEvaluationFilterPanel = false; // Close filter when opening menu
    }
  }

  // Initialize Assessment Evaluation Pie Chart
  private initializeAssessmentEvaluationPieChart(): void {
    if (this.selectedViewType !== 'assessment' && this.selectedViewType !== 'all') return;

    const canvas = document.getElementById('assessmentEvaluationChart') as HTMLCanvasElement;
    if (!canvas) return;

    if (this.assessmentEvaluationChartData?.length === 0) return;

    // Destroy old chart
    if (this.assessmentEvaluationChart) {
      this.assessmentEvaluationChart.destroy();
    }

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Use SAME COLOR STYLE as question paper category chart
    const labels = this.assessmentEvaluationChartData.map(item => item.name);
    const data = this.assessmentEvaluationChartData.map(item => item.value);

    const total = data.reduce((sum, v) => sum + (v || 0), 0);
    if (total === 0) return; // nothing to render

    // Use specified colors from data objects (Red, Blue, Yellow, Cream)
    const backgroundColors = this.assessmentEvaluationChartData.map(
      (item, i) => item.color || ['#C61F1E', '#0A68A6', '#FDBF48', '#FFFDD0', '#A0A0FF', '#F9EDDB', '#98D8C8'][i % 7]
    );

    let hoveredIndex: number = -1;

    this.assessmentEvaluationChart = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: labels,
        datasets: [
          {
            data: data,
            backgroundColor: backgroundColors,
            borderColor: '#fff',
            borderWidth: 0,          // SAME
            hoverOffset: 0,          // SAME
            hoverBorderWidth: 0,
            hoverBorderColor: 'transparent'
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false, // SAME SIZE BEHAVIOR AS second chart
        onHover: (event, activeElements) => {
          const chart = this.assessmentEvaluationChart;
          if (!chart || !chart.data.datasets[0]) return;

          if (activeElements.length > 0 && activeElements[0]) {
            hoveredIndex = activeElements[0].index;
          } else {
            hoveredIndex = -1;
          }

          // Update colors based on hover state
          const updatedColors = backgroundColors.map((color, index) => {
            if (hoveredIndex === -1) {
              return color; // No hover, show original colors
            } else if (index === hoveredIndex) {
              return color; // Hovered segment keeps original color
            } else {
              // Non-hovered segments become faded with 45% opacity for grey effect
              return this.hexToRgba(color, 0.45);
            }
          });

          chart.data.datasets[0].backgroundColor = updatedColors;
          chart.update('none'); // Update without animation
        },
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (context) => {
                const value = context.raw as number;
                const total = data.reduce((sum, v) => sum + v, 0);
                const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                return `${context.label}: ${value} (${percentage}%)`;
              }
            }
          }
        },
        cutout: '60%',        // SAME DOUGHNUT STYLE
        animation: {
          animateScale: true,
          animateRotate: true
        },
        layout: {
          padding: {
            top: 10,
            right: 10,
            bottom: 20,
            left: 10
          }
        }
      }
    });
  }


  // Toggle Candidate Assessment Filter Panel
  toggleCandidateAssessmentFilterPanel(): void {
    this.showCandidateAssessmentFilterPanel = !this.showCandidateAssessmentFilterPanel;
    if (this.showCandidateAssessmentFilterPanel) {
      this.showCandidateAssessmentChartMenu = false; // Close menu when opening filter
    }
  }

  // Assessment Customer Filter Panel Methods

  setActiveAssessmentCustomerFilterHeader(header: string): void {
  this.activeAssessmentCustomerFilterHeader = header;
  }

/**
 * Toggle Assessment Customer Filter Panel visibility
 */
toggleAssessmentCustomerFilterPanel(event?: MouseEvent): void {
  if (event) {
    event.stopPropagation();
  }
  this.showAssessmentCustomerFilterPanel = !this.showAssessmentCustomerFilterPanel;
  
  if (this.showAssessmentCustomerFilterPanel) {
    this.showAssessmentCustomerChartMenu = false; // Close menu when opening filter
    this.populateAssessmentCustomerFilterOptions();
  }
}

/**
 * Populate assessment customer filter options
 */
populateAssessmentCustomerFilterOptions(): void {
  // Use customerMasterData for customer filter options
  this.filteredAssessmentCustomerCustomerApiList = this.customerMasterData ? [...this.customerMasterData] : [];
  this.filteredAssessmentCustomerCourseApiList = this.allAssessmentCourses ? [...this.allAssessmentCourses] : [];
  
  // Reset search terms
  this.assessmentCustomerCustomerSearchTerm = '';
  this.assessmentCustomerCourseSearchTerm = '';
  
  // Set default active header
  
  this.activeAssessmentCustomerFilterHeader = 'customer';
  this.cdr.detectChanges();
}

filterAssessmentCustomerCourses(): void {
  const sourceList = this.allAssessmentCourses || [];
  if (!this.assessmentCustomerCourseSearchTerm) {
    this.filteredAssessmentCustomerCourseApiList = [...sourceList];
  } else {
    const term = this.assessmentCustomerCourseSearchTerm.toLowerCase();
    this.filteredAssessmentCustomerCourseApiList = sourceList.filter(c => {
      const name = c.course || c.course_name || c.courseName || c.name || '';
      return name.toLowerCase().includes(term);
    });
  }
}

/**
 * Filter assessment customer customers
 */
filterAssessmentCustomerCustomers(): void {
  const sourceList = this.customerMasterData || [];
  if (!this.assessmentCustomerCustomerSearchTerm) {
    this.filteredAssessmentCustomerCustomerApiList = [...sourceList];
  } else {
    const term = this.assessmentCustomerCustomerSearchTerm.toLowerCase();
    this.filteredAssessmentCustomerCustomerApiList = sourceList.filter(c => 
      c.name && c.name.toLowerCase().includes(term)
    );
  }
}

/**
 * Toggle assessment customer filter selection
 */
toggleAssessmentCustomerFilter(type: string, value: string): void {
  let arrayToUpdate: string[] = [];
  if (type === 'courses') {
    arrayToUpdate = this.selectedAssessmentCustomerCourseValues;
  } else if (type === 'customer') {
    arrayToUpdate = this.selectedAssessmentCustomerCustomerValues;
  }

  const index = arrayToUpdate.indexOf(value);
  if (index === -1) {
    arrayToUpdate.push(value);
  } else {
    arrayToUpdate.splice(index, 1);
  }
  
  console.log(`Toggled ${type} filter:`, arrayToUpdate);
  
  // Re-process the data with the new filters
  if (this.rawTop5CustomersByAssessment) {
    this.processAssessmentCustomerData(this.rawTop5CustomersByAssessment);
  } else if (this.rawAssessmentDetails) {
    this.processAssessmentCustomerData(this.rawAssessmentDetails);
  } else {
    this.fetchAssessmentCustomerData();
  }
}


clearAssessmentCustomerFilters(): void {
  this.selectedAssessmentCustomerCourseValues = [];
  this.selectedAssessmentCustomerCustomerValues = [];
  this.assessmentCustomerCourseSearchTerm = '';
  this.assessmentCustomerCustomerSearchTerm = '';
  this.filteredAssessmentCustomerCourseApiList = [...(this.allAssessmentCourses || [])];
  this.filteredAssessmentCustomerCustomerApiList = [...(this.customerMasterData || [])];
  
  // Reset and reload data
  if (this.rawTop5CustomersByAssessment) {
    this.processAssessmentCustomerData(this.rawTop5CustomersByAssessment);
  } else if (this.rawAssessmentDetails) {
    this.processAssessmentCustomerData(this.rawAssessmentDetails);
  } else {
    this.fetchAssessmentCustomerData();
  }
}
isAssessmentCustomerCourseSelected(course: string): boolean {
  return this.selectedAssessmentCustomerCourseValues.includes(course);
}

/**
 * Check if a customer is selected for assessment customer filter
 */
isAssessmentCustomerCustomerSelected(customer: string): boolean {
  return this.selectedAssessmentCustomerCustomerValues.includes(customer);
}
  // Assessment Language Filter Panel Methods
  toggleAssessmentLanguageFilterPanel(): void {
    this.showAssessmentLanguageFilterPanel = !this.showAssessmentLanguageFilterPanel;
    if (this.showAssessmentLanguageFilterPanel) {
      this.showAssessmentLanguageChartMenu = false; // Close menu when opening filter
    }
  }

  setActiveAssessmentLanguageFilterHeader(header: string): void {
    // Not needed yet for now, placeholder if needed for filter headers
  }

  // Set Active Candidate Assessment Filter Header
  setActiveCandidateAssessmentFilterHeader(header: string): void {
    this.activeCandidateAssessmentFilterHeader = header;
  }

  // Check if a single assessment is selected
  isAssessmentSelected(assessmentId: any): boolean {
    const assessment = this.allCandidateAssessments.find(a => a.assessment_id === assessmentId || a.id === assessmentId);
    return assessment ? assessment.checked === true : false;
  }

  // Toggle selection of a single assessment
  toggleAssessmentSelection(assessmentId: any): void {
    const assessment = this.allCandidateAssessments.find(a => a.assessment_id === assessmentId || a.id === assessmentId);
    if (assessment) {
      assessment.checked = !assessment.checked;
    }
    this.updateCandidateAssessmentChart();
  }

  // Get Candidate Assessment Filter Header Count
  getCandidateAssessmentFilterHeaderCount(headerKey: string): number {
    switch (headerKey) {
      case 'assessment':
        return this.filteredCandidateAssessmentList.length;
      default:
        return 0;
    }
  }

  // Filter Candidate Assessment
  filterCandidateAssessment(): void {
    if (!this.candidateAssessmentSearchTerm) {
      this.filteredCandidateAssessmentList = [...this.allCandidateAssessments];
    } else {
      this.filteredCandidateAssessmentList = this.allCandidateAssessments.filter(assessment =>
        (assessment.assessment_title || assessment.assessment_name || assessment.name || '').toLowerCase().includes(this.candidateAssessmentSearchTerm.toLowerCase())
      );
    }
  }

  // Assessment Selection Methods for Candidate Assessment Chart
  isAssessmentSelectedForCandidate(assessmentId: any): boolean {
    return this.selectedCandidateAssessmentFilterValues.includes(assessmentId);
  }

  toggleAssessmentSelectionForCandidate(assessmentId: any): void {
    const index = this.selectedCandidateAssessmentFilterValues.indexOf(assessmentId);
    if (index > -1) {
      this.selectedCandidateAssessmentFilterValues.splice(index, 1);
    } else {
      this.selectedCandidateAssessmentFilterValues.push(assessmentId);
    }
    this.updateCandidateAssessmentFilteredData();
  }

  areAllAssessmentsSelectedForCandidate(): boolean {
    if (this.allCandidateAssessments.length === 0) return false;
    return this.selectedCandidateAssessmentFilterValues.length === this.allCandidateAssessments.length;
  }

  toggleAllAssessmentsSelectionForCandidate(): void {
    if (this.areAllAssessmentsSelectedForCandidate()) {
      this.selectedCandidateAssessmentFilterValues = [];
    } else {
      this.selectedCandidateAssessmentFilterValues = this.allCandidateAssessments.map(assessment => assessment.assessment_id || assessment.id);
    }
    this.updateCandidateAssessmentFilteredData();
  }

  isAssessmentsSelectionIndeterminateForCandidate(): boolean {
    if (this.selectedCandidateAssessmentFilterValues.length === 0) return false;
    if (this.selectedCandidateAssessmentFilterValues.length === this.allCandidateAssessments.length) return false;
    return true;
  }

  // Update Candidate Assessment Chart based on selected filters
  updateCandidateAssessmentFilteredData(): void {
    let filteredData = [...this.allCandidateAssessments];

    // Apply assessment filter
    if (this.selectedCandidateAssessmentFilterValues.length > 0) {
      filteredData = filteredData.filter(assessment =>
        this.selectedCandidateAssessmentFilterValues.includes(assessment.assessment_id || assessment.id)
      );
    }

    // Smart filtering: if no filters or only overall selected, show all courses
    const onlyOverallOrEmpty = filteredData.length === 0 ||
      (filteredData.length === 1 && filteredData[0].is_overall);

    if (onlyOverallOrEmpty) {
      this.candidateAssessmentChartData = this.allCandidateAssessments.filter(a => !a.is_overall && (a.value || 0) > 0);
      if (this.candidateAssessmentChartData.length === 0) {
        const overallEntry = this.allCandidateAssessments.find(a => a.is_overall && (a.value || 0) > 0);
        this.candidateAssessmentChartData = overallEntry ? [overallEntry] : [];
      }
    } else {
      this.candidateAssessmentChartData = filteredData.filter(a => !a.is_overall && (a.value || 0) > 0);
    }

    this.showCandidateAssessmentChart = this.candidateAssessmentChartData.length > 0;
    this.cdr.detectChanges();

    setTimeout(() => {
      if (this.showCandidateAssessmentChart && document.getElementById('candidateAssessmentChart')) {
        this.initializeCandidateAssessmentPieChart();
      }
    }, 0);
  }

  // Check if all assessments are selected
  areAllAssessmentsSelected(): boolean {
    if (this.allCandidateAssessments.length === 0) return false;
    return this.filteredCandidateAssessmentList.length === this.allCandidateAssessments.length &&
      this.filteredCandidateAssessmentList.every(a => a.checked === true);
  }

  // Toggle all assessments selection
  toggleAllAssessmentsSelection(): void {
    const areAllSelected = this.areAllAssessmentsSelected();
    this.filteredCandidateAssessmentList.forEach(assessment => {
      assessment.checked = !areAllSelected;
    });
  }

  // Check if assessments selection is indeterminate
  isAssessmentsSelectionIndeterminate(): boolean {
    if (this.filteredCandidateAssessmentList.length === 0) return false;
    const checkedCount = this.filteredCandidateAssessmentList.filter(a => a.checked === true).length;
    return checkedCount > 0 && checkedCount < this.filteredCandidateAssessmentList.length;
  }

  // Update Candidate Assessment Chart with Selected Filters
  updateCandidateAssessmentChart(): void {
    const checkboxes = document.querySelectorAll('.filter-panel-container[class*="active"] .filter-checkbox-input');
    const selectedAssessments: any[] = [];

    checkboxes.forEach((checkbox: any, index) => {
      if (checkbox.checked && this.allCandidateAssessments[index]) {
        selectedAssessments.push(this.allCandidateAssessments[index]);
      }
    });

    // Filter logic: if no assessments selected OR only "Overall" is selected, show all courses
    const onlyOverallSelected = selectedAssessments.length === 0 ||
      (selectedAssessments.length === 1 && selectedAssessments[0].is_overall);

    if (onlyOverallSelected) {
      // Show all courses
      this.candidateAssessmentChartData = this.allCandidateAssessments.filter(a => !a.is_overall);
      if (this.candidateAssessmentChartData.length === 0) {
        const overallEntry = this.allCandidateAssessments.find(a => a.is_overall);
        this.candidateAssessmentChartData = overallEntry ? [overallEntry] : [];
      }
    } else {
      // Filter out Overall entry and show only selected assessments
      this.candidateAssessmentChartData = selectedAssessments.filter(a => !a.is_overall);
    }

    setTimeout(() => {
      this.initializeCandidateAssessmentPieChart();
    }, 0);
  }

  // Toggle Candidate Assessment Chart Menu
  toggleCandidateAssessmentChartMenu(): void {
    this.showCandidateAssessmentChartMenu = !this.showCandidateAssessmentChartMenu;
    if (this.showCandidateAssessmentChartMenu) {
      this.showCandidateAssessmentFilterPanel = false; // Close filter when opening menu
    }
  }

  // Toggle Assessment Customer Chart Menu
  toggleAssessmentCustomerChartMenu(): void {
    this.showAssessmentCustomerChartMenu = !this.showAssessmentCustomerChartMenu;
    if (this.showAssessmentCustomerChartMenu) {
      this.showAssessmentCustomerFilterPanel = false; // Close filter when opening menu
    }
  }

  // Toggle Assessment Language Chart Menu
  toggleAssessmentLanguageChartMenu(): void {
    this.showAssessmentLanguageChartMenu = !this.showAssessmentLanguageChartMenu;
    if (this.showAssessmentLanguageChartMenu) {
      this.showAssessmentLanguageFilterPanel = false; // Close filter when opening menu
    }
  }

  // Initialize Candidate Assessment Pie Chart
  private initializeCandidateAssessmentPieChart(): void {
    if (this.selectedViewType !== 'assessment' && this.selectedViewType !== 'all') return;

    const canvas = document.getElementById('candidateAssessmentChart') as HTMLCanvasElement;
    if (!canvas) return;

    if (!this.candidateAssessmentChartData?.length) return;

    // Destroy existing chart
    if (this.candidateAssessmentChart) {
      this.candidateAssessmentChart.destroy();
    }

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const labels = this.candidateAssessmentChartData.map(item => item.name);
    const data = this.candidateAssessmentChartData.map(item => item.value);

    // Use SAME COLORS as other pie charts (fallback if API doesn't send colors)
    const backgroundColors = this.candidateAssessmentChartData.map(
      (item, i) => item.color || ['#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF', '#F9EDDB', '#98D8C8'][i % 7]
    );

    this.candidateAssessmentChart = new Chart(ctx, {
      type: 'pie',
      data: {
        labels,
        datasets: [
          {
            data,
            backgroundColor: backgroundColors,
            borderColor: '#fff',
            borderWidth: 0,     // Same as other charts
            hoverOffset: 0,     // Same hover effect
            hoverBorderWidth: 0,
            hoverBorderColor: 'transparent'
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false, // Ensures size matches the other charts
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (context) => {
                const value = context.raw as number;
                const total = data.reduce((sum, v) => sum + v, 0);
                const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                return `${context.label}: ${value} (${percentage}%)`;
              }
            }
          }
        },
        cutout: '60%',  // Make chart donut-style (same look)
        animation: {
          animateScale: true,
          animateRotate: true
        },
        layout: {
          padding: {
            top: 10,
            right: 10,
            bottom: 20,
            left: 10
          }
        }
      }
    });
  }


  // Initialize Assessment Location Bar Chart
  private initializeAssessmentLocationBarChart(): void {
    if (this.selectedViewType !== 'assessment' && this.selectedViewType !== 'all') return; // Only initialize in assessment or all views

    const canvas = document.getElementById('assessmentLocationChart') as HTMLCanvasElement;

    if (!canvas) {
      console.warn('Assessment Location Chart canvas not found');
      return;
    }

    if (!this.assessmentLocationChartData || this.assessmentLocationChartData.length === 0) {
      console.warn('No assessment location chart data available');
      return;
    }

    // Prepare chart data - Use colors from chartData if available, otherwise use default palette
    const labels = this.assessmentLocationChartData.map(item => item.name);
    const data = this.assessmentLocationChartData.map(item => item.value);
    const chartColors = this.assessmentLocationChartData.map(item => item.color) || [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9', '#F8B195'
    ];

    // Destroy existing chart if it exists
    if (this.assessmentLocationChart) {
      this.assessmentLocationChart.destroy();
    }

    this.assessmentLocationChart = new Chart(canvas, {
      type: 'doughnut',
      data: {
        labels: labels,
        datasets: [{
          label: 'Assessment Count',
          data: data,
          backgroundColor: chartColors.slice(0, data.length),
          borderColor: '#fff',
          borderWidth: 0,
          hoverOffset: 0,
          hoverBorderWidth: 0,
          hoverBorderColor: 'transparent'
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        }
      }
    });
    console.log('Assessment Location Chart initialized with data:', labels, data);
  }

  // Initialize Assessment Course Bar Chart
  private initializeAssessmentCourseBarChart(): void {
    if (this.selectedViewType !== 'assessment' && this.selectedViewType !== 'all') return;

    const canvas = document.getElementById('assessmentCourseChart') as HTMLCanvasElement;

    if (!canvas) {
      // Assessment Course Chart canvas not found
      return;
    }

    // Check if we have data to display
    if (!this.assessmentCourseChartData || this.assessmentCourseChartData.length === 0) {
      // No assessment course chart data available

      // Clear canvas if no data
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }

      // Destroy existing chart
      if (this.assessmentCourseChart) {
        this.assessmentCourseChart.destroy();
        this.assessmentCourseChart = null;
      }

      return;
    }

    // Prepare chart data with dynamic colors based on filtered data
    const labels = this.assessmentCourseChartData.map(item => item.name);
    const data = this.assessmentCourseChartData.map(item => item.value);

    // Dynamic color palette that works for any number of items
    const baseColors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9', '#F8B195',
      '#6A89CC', '#B8E994', '#FAD390', '#FF9F43', '#FF6B6B',
      '#48DBFB', '#1DD1A1', '#FF9FF3', '#54A0FF', '#5F27CD'
    ];

    // Generate colors for all data points
    const colors = [];
    for (let i = 0; i < data.length; i++) {
      colors.push(baseColors[i % baseColors.length]);
    }

    // Destroy existing chart if it exists
    if (this.assessmentCourseChart) {
      this.assessmentCourseChart.destroy();
      this.assessmentCourseChart = null;
    }

    // Create new chart
    try {
      this.assessmentCourseChart = new Chart(canvas, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [{
            label: 'Assessment Count',
            data: data,
            backgroundColor: colors,
            borderColor: colors.map(color => this.darkenColor(color, 20)),
            borderWidth: 1,
            borderRadius: 4,
            borderSkipped: false
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          indexAxis: 'y', // Horizontal bar chart
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  const value = typeof context.raw === 'number' ? context.raw : (context.parsed.x || 0);
                  const total = data.reduce((sum, val) => sum + val, 0);
                  const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                  const label = context.label || this.assessmentCourseChartData[context.dataIndex]?.name || 'Assessment';
                  return `${label}: ${value} (${percentage}%)`;
                }
              },
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              titleColor: '#fff',
              bodyColor: '#fff',
              borderColor: '#005068',
              borderWidth: 1,
              padding: 10,
              cornerRadius: 4
            }
          },
          scales: {
            x: {
              beginAtZero: true,
              grid: {
                display: true,
                color: 'rgba(0, 0, 0, 0.05)'
              },
              ticks: {
                precision: 0,
                font: {
                  size: 11
                }
              },
              title: {
                display: true,
                text: 'Number of Assessments',
                font: {
                  size: 12,
                  weight: 'bold'
                },
                padding: { top: 10, bottom: 5 }
              }
            },
            y: {
              grid: {
                display: false
              },
              ticks: {
                font: {
                  size: 9
                },
                maxRotation: 0,
                autoSkip: false,
                padding: 8
              },
              title: {
                display: false
              }
            }
          },
          animation: {
            duration: 500,
            easing: 'easeOutQuart'
          },
          interaction: {
            intersect: true,
            mode: 'nearest'
          },
          layout: {
            padding: {
              left: 0,
              right: 10,
              top: 10,
              bottom: 5
            }
          }
        }
      });

      // Force chart resize
      setTimeout(() => {
        if (this.assessmentCourseChart) {
          this.assessmentCourseChart.resize();
        }
      }, 100);

    } catch (error) {
      // Error initializing assessment course chart
    }
  }

  // Also update your updateAssessmentCourseFilteredData() method to properly handle chart updates:
  updateAssessmentCourseFilteredData(): void {
    const selectedGeographies = (this.selectedAssessmentCourseGeographyValues || []).map((geo: string) => this.normalizeString(geo));
    const selectedCourseIds = (this.selectedAssessmentCourseFilterValues || []).map(id => String(id));
    const selectedCustomers = (this.selectedAssessmentCourseCustomerValues || []).map((cust: string) => this.normalizeString(cust));

    const hasLocationsArray = this.allAssessmentCourses && this.allAssessmentCourses.length > 0 && this.allAssessmentCourses.some(c => c.locations);

    if (hasLocationsArray) {
      let filteredData = this.allAssessmentCourses;

      // Filter by Course
      if (selectedCourseIds.length > 0) {
        filteredData = filteredData.filter(course =>
          selectedCourseIds.includes(String(course.course_id))
        );
      }

      // Filter by Customer
      if (selectedCustomers.length > 0) {
        filteredData = filteredData.filter(course => {
          const courseCustomer = course.customer_name || course.customer || 'No Customer';
          return selectedCustomers.includes(this.normalizeString(courseCustomer));
        });
      }

      let processedData = filteredData.map((course: any) => {
        let val = course.count || 0;

        // Apply geography filter recalculation if geographies are selected
        if (selectedGeographies.length > 0) {
          if (course.locations && Array.isArray(course.locations)) {
            val = course.locations.reduce((sum: number, loc: any) => {
              const stateName = loc.state_name ? this.normalizeString(loc.state_name) : '';
              if (selectedGeographies.includes(stateName)) {
                return sum + (Number(loc.count) || 0);
              }
              return sum;
            }, 0);
          } else {
            val = 0;
          }
        }

        return {
          ...course,
          count: val
        };
      }).filter((item: any) => item.count > 0);

      processedData = this.processAssessmentCoursesToTop5WithOthers(processedData);

      const colors = [
        '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
        '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9', '#F8B195',
        '#6A89CC', '#B8E994', '#FAD390', '#FF9F43', '#FF6B6B'
      ];

      this.assessmentCourseChartData = processedData.map((course: any, index: number) => ({
        name: course.course || 'Unknown',
        value: course.count || 0,
        color: colors[index % colors.length]
      }));
    } else {
      // Fallback logic
      const courseAssessmentCounts: { [key: string]: { course_id: any; course: string; count: number } } = {};

      (this.rawAssessmentDataWithStateInfo || []).forEach((assessment: any) => {
        if (selectedGeographies.length > 0 && !this.assessmentMatchesSelectedGeographies(assessment, selectedGeographies)) {
          return;
        }

        if (selectedCustomers.length > 0) {
          const assessmentCustomer = assessment.customer_name || assessment.customer || 'No Customer';
          if (!selectedCustomers.includes(this.normalizeString(assessmentCustomer))) {
            return;
          }
        }

        const courseId = assessment.course_id != null ? assessment.course_id : assessment.assessment_id;
        const courseName = assessment.course_name || assessment.course || assessment.assessment_title || assessment.assessment_name || 'Unknown';
        const normalizedCourseName = this.normalizeString(courseName);
        const courseKey = normalizedCourseName;

        if (selectedCourseIds.length > 0 && courseId != null && !selectedCourseIds.includes(String(courseId))) {
          return;
        }

        if (!courseAssessmentCounts[courseKey]) {
          courseAssessmentCounts[courseKey] = {
            course_id: courseId,
            course: courseName,
            count: 0
          };
        }

        courseAssessmentCounts[courseKey].count += 1;
      });

      const colors = [
        '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
        '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9', '#F8B195',
        '#6A89CC', '#B8E994', '#FAD390', '#FF9F43', '#FF6B6B'
      ];

      let processedFallbackData = Object.values(courseAssessmentCounts).sort((a, b) => b.count - a.count);
      
      if (selectedGeographies.length === 0 && selectedCourseIds.length === 0 && selectedCustomers.length === 0) {
          processedFallbackData = this.processAssessmentCoursesToTop5WithOthers(processedFallbackData);
      }

      this.assessmentCourseChartData = processedFallbackData.map((item, index) => ({ 
        name: item.course || 'Unknown', 
        value: item.count,
        color: colors[index % colors.length]
      }));
    }

    this.showAssessmentCourseChart = this.assessmentCourseChartData.length > 0;
    this.cdr.detectChanges();

    setTimeout(() => {
      this.initializeAssessmentCourseBarChart();
    }, 150); // Increased delay to ensure canvas is fully rendered after filter changes
  }

  private assessmentMatchesSelectedGeographies(assessment: any, selectedGeographies: string[]): boolean {
    if (!assessment || !selectedGeographies || selectedGeographies.length === 0) {
      return true;
    }

    const normalizedSelectedGeographies = selectedGeographies.map(value => this.normalizeString(value));
    const stateFields = [
      'assessment_state',
      'state',
      'assessment_state',
      'state_wise_candidates',
      'state_pass_counts',
      'state_fail_counts',
      'state_access_counts',
      'state_reassessed_counts',
      'state_counts',
      'state_wise_counts'
    ];

    for (const field of stateFields) {
      const value = assessment[field];
      if (typeof value === 'string' && normalizedSelectedGeographies.includes(this.normalizeString(value))) {
        return true;
      }

      if (value && typeof value === 'object') {
        const stateKeys = Object.keys(value || {});
        for (const key of stateKeys) {
          if (normalizedSelectedGeographies.includes(this.normalizeString(key))) {
            return true;
          }
        }
      }
    }

    return false;
  }

  private getCourseNamesForSelectedCustomers(selectedCustomers: string[]): string[] {
    if (!selectedCustomers || selectedCustomers.length === 0 || !Array.isArray(this.rawAssessmentDetails)) {
      return [];
    }

    const normalizedSelectedCustomers = selectedCustomers.map(customer => this.normalizeString(customer));
    const matchedCourses = new Set<string>();

    this.rawAssessmentDetails.forEach((detail: any) => {
      const customerName = this.normalizeString(detail.customer_name || detail.customer || '');
      if (customerName && normalizedSelectedCustomers.includes(customerName)) {
        const courseName = this.normalizeString(detail.course || detail.course_name || detail.title || '');
        if (courseName) {
          matchedCourses.add(courseName);
        }
      }
    });

    return Array.from(matchedCourses);
  }

  private setDefaultQuestionData(): void {
    this.questionCounts = [];
    this.summaryQuestionCounts = [];
    this.filteredQuestionPaperInsightCounts = [];
    this.questionSummary = {
      total_questions: 0,
      total_question_papers: 0,
      difficulty_summary: { easy: 0, medium: 0, hard: 0 },
      type_summary: { mcq: 0, coding: 0, descriptive: 0 },
      language_summary: { english: 0, hindi: 0, regional: 0 },
      status_summary: { active: 0, archived: 0, deleted: 0 },
      flagged_questions: 0,
      paper_status_summary: { active: 0, archived: 0, deleted: 0, flagged_questions: 0 },
      label_summary: { with_label: 0, without_label: 0, current_month_total_labeled: 0, last_month_total_labeled: 0 },
      tag_summary: { with_tag: 0, without_tag: 0, current_month_total_tagged: 0, last_month_total_tagged: 0 }
    };

    this.questionCourseData = [];
    this.questionDifficultyData = [];
    this.questionTypeData = [];
    this.questionLanguageData = [];
    this.questionStatusData = [];
    this.statusChartData = [];
    this.showStatusPieChart = false;
    // Reset difficulty chart data
    this.difficultyChartData = [];
    this.showDonutChart = false;

    // Reset language chart data
    this.languageBarChartData = [];
    this.languageBarChartLabels = [];
    this.languageBarChartValues = [];
    this.languageBarChartColors = [];
    this.showLanguageBarChart = false;
    this.top10CourseBarChartData = [];
    this.showTop10CourseBarChart = false;
    // ADDED: Reset category chart data
    this.categoryChartData = [];
    this.showCategoryPieChart = false;
    // ADDED: Reset type chart data
    this.typeBarChartData = [];
    this.showTypeBarChart = false;
    // Reset chart categories
    this.courseChartCategories = [];
    this.difficultyChartCategories = [];
    this.typeChartCategories = [];
    this.languageChartCategories = [];
  }

  // Helper method to get top courses for display
  getTopCourses(): any[] {
    return this.questionCounts || [];
  }

  // Helper method to get total questions count
  getTotalQuestions(): number {
    return this.questionSummary?.total_questions || 0;
  }
  constructor(
    private route: Router,
    private exportService: ExportService,
    private cdr: ChangeDetectorRef,
    private service: DashboardService,
    private util: UtilService,
    private dialog: MatDialog,
    private courseSrvc: CourseService,
    private adminSrvc: AdminService,
    private getAllService: GetAllService,
    private socketService: SocketService,
    private tourService: TourService,
  ) {
    Chart.register(...registerables);

  }
  // Check data helper: shows toast and returns false when no data
 private ensureHasData(data: any[] | null | undefined, message: string = 'No data to download'): boolean {
    if (!data || (Array.isArray(data) && data.length === 0)) {
      this.util.simpleDialog({ title: 'Error', message });
      return false;
    }
    return true;
  }
    private ensureHasDataForPassFail(
    chartData: any,
    message: string = 'No data to download'
  ): boolean {

    if (
      !chartData ||
      !chartData.datasets ||
      chartData.datasets.length === 0 ||
      chartData.datasets.every(
        (ds: any) => !ds.data || ds.data.length === 0
      )
    ) {
      this.util.simpleDialog({
        title: 'Error',
        message
      });
      return false;
    }

    return true;
  }

  selectedYearRange: string = '';
  availableYearRanges: any[] = [];
  private initializeYearRanges(): void {
    const currentYear = new Date().getFullYear();
    this.availableYearRanges = [];

    // Generate year ranges for current and previous 5 years
    for (let i = 0; i <= 5; i++) {
      const startYear = currentYear - i;
      const endYear = startYear + 1;
      const yearRangeValue = `${startYear}-${endYear.toString().slice(2)}`;
      const yearRangeDisplay = `${startYear}-${endYear.toString().slice(2)}`;

      this.availableYearRanges.push({
        value: yearRangeValue,
        display: yearRangeDisplay,
        startYear: startYear,
        endYear: endYear
      });
    }

    // Set default selection to current academic year
    const currentMonth = new Date().getMonth() + 1;
    if (currentMonth >= 4) { // April onwards - current year to next year
      this.selectedYearRange = `${currentYear}-${(currentYear + 1).toString().slice(2)}`;
    } else { // January to March - previous year to current year
      this.selectedYearRange = `${currentYear - 1}-${currentYear.toString().slice(2)}`;
    }
  }

  // Helper method to get default year range
  private getDefaultYearRange(): string {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;

    if (currentMonth >= 4) { // April onwards - current year to next year
      return `${currentYear}-${(currentYear + 1).toString().slice(2)}`;
    } else { // January to March - previous year to current year
      return `${currentYear - 1}-${currentYear.toString().slice(2)}`;
    }
  }

  // Updated year range methods
  toggleYearDropdown(): void {
    this.showYearDropdown = !this.showYearDropdown;
    if (this.showYearDropdown) {
      this.showMonthDropdown = false;
    }
  }

  selectYearRange(yearRange: string): void {
    this.selectedYearRange = yearRange;
    this.showYearDropdown = false;
    this.applyMonthYearFilter();
  }

  // Updated method to get date range from year range
  private getDateRangeFromYearRange(yearRange: string): { startDate: Date, endDate: Date } {
    const [startYearStr, endYearShort] = yearRange.split('-');
    const startYear = parseInt(startYearStr);
    const endYear = parseInt(`20${endYearShort}`); // Assuming 2000s

    // Academic year typically runs from April to March
    const startDate = new Date(startYear, 3, 1); // April 1st
    const endDate = new Date(endYear, 2, 31); // March 31st

    return { startDate, endDate };
  }
  // Component में
  showCompactPicker: boolean = false;

  toggleCompactPicker(): void {
    this.showCompactPicker = !this.showCompactPicker;
  }

  selectMonth(monthIndex: number): void {
    this.currentMonth = new Date(this.currentMonth.getFullYear(), monthIndex, 1);
    this.showCompactPicker = false;
    this.generateCalendarDays();
  }

  selectYear(year: number): void {
    this.currentMonth = new Date(year, this.currentMonth.getMonth(), 1);
    this.showCompactPicker = false;
    this.generateCalendarDays();
  }
  // Updated filter application method
  applyMonthYearFilter(): void {

    this.showYearDropdown = false;
    this.showMonthDropdown = false;

    this.fetchFilteredQuestionData();
    this.getOperationsData();
  }

  // Updated data fetching method
  private fetchFilteredQuestionData(): void {
    this.isLoading = true;

    let startDate: Date;
    let endDate: Date;

    if (this.selectedMonth) {
      // If month is selected, use specific month within the academic year
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedYearRange);
      if (yearRange) {
        // For academic year, if month is Jan-Mar, it belongs to endYear, else startYear
        const year = this.selectedMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedMonth - 1, 1);
        endDate = new Date(year, this.selectedMonth, 0);
      } else {
        // Fallback: use current year
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedMonth, 0);
      }
    } else {
      // If no month selected, use entire academic year
      const dateRange = this.getDateRangeFromYearRange(this.selectedYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');
    const resp = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          this.processLibraryData(response);
          this.isLoading = false;
          this.cdr.detectChanges();
        } else {
          this.setDefaultQuestionData();
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.setDefaultQuestionData();
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  ngOnInit(): void {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
    } catch (e) {}

    // Check if welcome guided tour needs to be auto-triggered for first-time user
    this.tourService.checkAndAutoStartWelcomeTour();

    this.socketSub = this.socketService.onNewNotification().subscribe((data: any) => {
      if (data && data.title === 'Dashboard Update') {
        console.log('Real-time dashboard update received, refreshing stats...');
        this.service.clearCache();
        this.getConsolidatedDashboardData();
        this.getOperationsData();
      }
    });
    this.initializeYearFilter();
    this.initializeYearRanges();
    this.rawTop5CustomersByAssessment = null;

    // Initialize year ranges for all charts
    this.initializeChartYearRanges();

    // Filter view types based on menu access
    this.filterAvailableViewTypes();

    // Initialize Assessment Insights filter lists
    this.filteredAssessmentInsightDifficultyTypeList = [...this.assessmentInsightDifficultyTypeOptions];

    // Initialize Candidate Insights filter lists
    this.filteredCandidateInsightCourseApiList = [...(this.coursesData || [])];
    if (this.geographyData) {
      this.initializeCandidateInsightsGeographyData();
    }
    // Initialize Geographic Insights filter lists if data is already available
    this.filteredGeographicInsightCourseApiList = [...(this.coursesData || [])];
    this.filteredGeographicInsightCustomerApiList = [...(this.customerMasterData || [])];
    this.filteredGeographicInsightGeographyList = [...this.allGeographicInsightGeographies];
    
    // Initialize Candidate Performance filter lists
    this.filteredCandidatePerformanceCourseApiList = [...(this.coursesData || [])];
    this.filteredCandidatePerformanceCustomerApiList = [...(this.customerMasterData || [])];
    this.filteredCandidatePerformanceLanguageList = [...this.languagesData];

    this.initializeLanguageData(); // Add this line
    this.initializeDifficultyData(); // Add this line - initialize Difficulty chart
    // NOTE: initializeCategoryData() is called AFTER org_id is set below
    this.selectedDifficultyCourseIds = [];
    this.selectedDifficultyLevels = [];
    this.selectedLanguageCourseIds = [];
    this.selectedQuestionPaperCourseIds = [];
    this.selectedQuestionPaperCourseIds = [];
    this.selectedQuestionPaperStatuses = [];
    this.selectedQuestionPaperVersions = [];
    this.questionPaperChartData = [];
    this.showDonutChart = false;

    this.selectedLanguages = [];
    this.initializeTypeData();
    this.prepareQuestionsByTypeData();
    this.initializeStatusData();
    this.initializeCourseData();
    this.initializeQuestionPaperByCourseData();
    this.initializeQuestionPaperDifficultyData();
    this.initializeQuestionPaperCategoryData();
    this.initializeTop10CourseData();

    this.selectedCategoryCourseIds = []; // ADD THIS LINE
    this.selectedCategories = []; // ADD THIS LINE

    this.orgId = this.util.decrypt(localStorage.getItem('OrgId'));
    
    // Set isSystemSuperAdmin from localStorage
    this.isSystemSuperAdmin = localStorage.getItem('isSystemSuperAdmin') === 'true';
    
    // Check if user is system super admin (ur === 'SA')
    const userRole = localStorage.getItem('ur');
    const isSuperAdmin = userRole && this.util.decrypt(userRole) === 'SA';
    
    if (isSuperAdmin) {
      // Fetch all organizations for super admin using the same API as list-org component
      this.getAllService.getAll('orgs').subscribe(
        (data: any) => {
          if (data && data.body && data.body.responseBody) {
            const allOrgs = data.body.responseBody;
            // Map the response to the format needed for the dropdown with full organization names
            this.userOrgList = allOrgs.map((org: any) => ({
              org_id: org.org_id || org.id,
              org_name: org.name || org.org_name, // Use 'name' field from list-org API response
              user_id: org.user_id || null,
              district_name: org.district_name,
              state_name: org.state_name
            }));
            this.cdr.markForCheck();
          } else {
            this.userOrgList = JSON.parse(localStorage.getItem('userOrgList') || '[]');
          }
          this.initializeOrgData();
        },
        (error: any) => {
          console.error('Error fetching all organizations:', error);
          // Fallback to localStorage on error
          this.userOrgList = JSON.parse(localStorage.getItem('userOrgList') || '[]');
          this.initializeOrgData();
        }
      );
    } else {
      // Non-admin users get their organizations from localStorage
      this.userOrgList = JSON.parse(localStorage.getItem('userOrgList') || '[]');
      this.initializeOrgData();
    }
  }

  private initializeOrgData(): void {
    // Initialize selectedUserOrg - convert to integer for proper API calls
    const decryptedOrgId = this.util.decrypt(localStorage.getItem('OrgId'));
    const orgIdAsInt = parseInt(decryptedOrgId, 10);
    
    this.selectedUserOrg = orgIdAsInt;
    this.orgId = orgIdAsInt;
    
    // Find the selected organization
    const selectedOrg = this.userOrgList.find(org => {
      const orgIdInt = parseInt(org.org_id, 10);
      return orgIdInt === orgIdAsInt;
    });

    if (selectedOrg) {
      this.user_id = selectedOrg.user_id ? parseInt(selectedOrg.user_id, 10) : null;
      this.org_id = parseInt(selectedOrg.org_id, 10); // Always convert to integer
      console.log('Organization found:', { org_id: this.org_id, org_name: selectedOrg.org_name });
    } else {
      // If org not found in list, still set org_id as integer for API calls
      this.org_id = orgIdAsInt;
      this.user_id = null;
      console.log('Organization not found in list, using default org_id:', this.org_id);
    }
    
    this.UserRoleId = localStorage.getItem('UserRoleId'); // Adjust based on your storage

    this.getCourseListData();

    // Initialize category data AFTER org_id is set
    this.initializeCategoryData();
    
    // Re-evaluate view permissions now that org_id is established
    this.filterAvailableViewTypes();

    // Complete remaining ngOnInit setup after org_id is properly initialized
    this.completeNgOnInitSetup();
  }

  /**
   * Helper method to safely get org_id as an integer
   * Used to ensure all API calls receive org_id as an integer type
   */
  private getOrgIdAsInteger(): number | null {
    if (!this.org_id) {
      console.warn('org_id is not set');
      return null;
    }
    const parsed = parseInt(this.org_id, 10);
    return isNaN(parsed) ? null : parsed;
  }

  private completeNgOnInitSetup(): void {
    // Get menu access from localStorage
    const menuAccess = JSON.parse(
      this.util.decrypt(localStorage.getItem('menu_access')) || '[]'
    );

    // Filter sections based on menu access
    this.sections = this.sections.filter(section => {
      // Activity Tracker is always visible for everyone
      if (section.title === 'Activity Tracker') {
        return true;
      }

      // Super admin sees everything
      // Assuming `this.isAdmin` is defined and accessible
      if (this.isAdmin) {
        return true;
      }

      // Check if module is permitted by matching section title with menu name
      return menuAccess.some(menu =>
        menu.menu_name.toLowerCase() === section.title.toLowerCase()
      );
    });

    // Automatically load current month data on dashboard load
    setTimeout(() => {
      this.setDefaultCurrentMonthRange();
      // Also initialize the default library view with all data
      this.selectViewType(this.selectedViewType);
    }, 500);

    this.cdr.detectChanges();
  }

  // Initialize year ranges for all chart components
  private initializeChartYearRanges(): void {
    const defaultYear = this.getDefaultYearRange();

    // All View Charts - Questions and Question Papers
    this.selectedNewCourseYearRange = defaultYear;
    this.selectedQuestionPaperCourseYearRange = defaultYear;

    // Assessment Charts
    this.selectedAssessmentLocationYearRange = defaultYear;
    this.selectedAssessmentCourseYearRange = defaultYear;
    this.selectedAssessmentStatusYearRange = defaultYear;
    this.selectedAssessmentEvaluationYearRange = defaultYear;
    this.selectedCandidateAssessmentYearRange = defaultYear;
    this.selectedPassFailYearRange = defaultYear;

    // Library Charts
    this.selectedDifficultyYearRange = defaultYear;
    this.selectedTypeYearRange = defaultYear;
    this.selectedLanguageYearRange = defaultYear;
    this.selectedCategoryYearRange = defaultYear;
  }

  private initializeYearFilter(): void {
    const currentYear = new Date().getFullYear();
    this.availableYears = [];
    for (let year = currentYear; year >= currentYear - 5; year--) {
      this.availableYears.push(year);
    }
  }
  // Add these properties to your component class
  showCompareDialog: boolean = false;
  selectedCompareYearRange: string = '';
  selectedCompareMonth: number | null = null;
  showCompareYearDropdown: boolean = false;
  showCompareMonthDropdown: boolean = false;
  showComparisonResults: boolean = false;
  currentComparisonData: any[] = [];
  compareComparisonData: any[] = [];
  trendSummary: any[] = [];

  // All View - Difficulty Level Month-wise Compare
  showDifficultyLevelMonthCompareDialog: boolean = false;
  selectedDifficultyLevelCompareMonth1: number | null = null;
  selectedDifficultyLevelCompareMonth2: number | null = null;
  showDifficultyLevelCompareMonth1Dropdown: boolean = false;
  showDifficultyLevelCompareMonth2Dropdown: boolean = false;
  showDifficultyLevelMonthComparisonResults: boolean = false;
  currentDifficultyLevelMonthComparisonData: any[] = [];
  compareDifficultyLevelMonthComparisonData: any[] = [];
  difficultyLevelMonthComparisonChart: Chart | null = null;
  difficultyLevelMonthTrendSummary: any[] = [];

  // Content Library - Questions by Type (Language) Month-wise Compare
  showTypeMonthCompareDialog: boolean = false;
  selectedTypeCompareMonth1: number | null = null;
  selectedTypeCompareMonth2: number | null = null;
  showTypeCompareMonth1Dropdown: boolean = false;
  showTypeCompareMonth2Dropdown: boolean = false;
  showTypeMonthComparisonResults: boolean = false;
  currentTypeMonthComparisonData: any[] = [];
  compareTypeMonthComparisonData: any[] = [];
  typeMonthComparisonChart: Chart | null = null;
  typeMonthTrendSummary: any[] = [];

  // Language Month Comparison Properties
  showLanguageMonthCompareDialog: boolean = false;
  selectedLanguageCompareMonth1: number | null = null;
  selectedLanguageCompareMonth2: number | null = null;
  showLanguageCompareMonth1Dropdown: boolean = false;
  showLanguageCompareMonth2Dropdown: boolean = false;
  showLanguageMonthComparisonResults: boolean = false;
  currentLanguageMonthComparisonData: any[] = [];
  compareLanguageMonthComparisonData: any[] = [];
  languageMonthComparisonChart: Chart | null = null;
  languageMonthTrendSummary: any[] = [];

  // Compare Dialog Methods
  openCompareDialog(): void {
    this.showCompareDialog = true;
    this.showComparisonResults = false;
    // Reset compare selections
    this.selectedCompareYearRange = '';
    this.selectedCompareMonth = null;
  }

  closeCompareDialog(): void {
    this.showCompareDialog = false;
    this.showComparisonResults = false;
    this.currentComparisonData = [];
    this.compareComparisonData = [];
  }

  // All View - Difficulty Level Month-wise Compare Methods
  openDifficultyLevelMonthCompareDialog(): void {
    this.showDifficultyLevelMonthCompareDialog = true;
    this.showDifficultyLevelMonthComparisonResults = false;
    this.selectedDifficultyLevelCompareMonth1 = null;
    this.selectedDifficultyLevelCompareMonth2 = null;
  }

  closeDifficultyLevelMonthCompareDialog(): void {
    this.showDifficultyLevelMonthCompareDialog = false;
    this.showDifficultyLevelMonthComparisonResults = false;
    this.currentDifficultyLevelMonthComparisonData = [];
    this.compareDifficultyLevelMonthComparisonData = [];
  }

  toggleDifficultyLevelCompareMonth1Dropdown(): void {
    this.showDifficultyLevelCompareMonth1Dropdown = !this.showDifficultyLevelCompareMonth1Dropdown;
    if (this.showDifficultyLevelCompareMonth1Dropdown) {
      this.showDifficultyLevelCompareMonth2Dropdown = false;
    }
  }

  selectDifficultyLevelCompareMonth1(month: number): void {
    this.selectedDifficultyLevelCompareMonth1 = month;
    this.showDifficultyLevelCompareMonth1Dropdown = false;
  }

  toggleDifficultyLevelCompareMonth2Dropdown(): void {
    this.showDifficultyLevelCompareMonth2Dropdown = !this.showDifficultyLevelCompareMonth2Dropdown;
    if (this.showDifficultyLevelCompareMonth2Dropdown) {
      this.showDifficultyLevelCompareMonth1Dropdown = false;
    }
  }

  selectDifficultyLevelCompareMonth2(month: number): void {
    this.selectedDifficultyLevelCompareMonth2 = month;
    this.showDifficultyLevelCompareMonth2Dropdown = false;
  }

  // Content Library - Questions by Type Month-wise Compare Methods
  openTypeMonthCompareDialog(): void {
    this.showTypeMonthCompareDialog = true;
    this.showTypeMonthComparisonResults = false;
    this.selectedTypeCompareMonth1 = null;
    this.selectedTypeCompareMonth2 = null;
  }

  closeTypeMonthCompareDialog(): void {
    this.showTypeMonthCompareDialog = false;
    this.showTypeMonthComparisonResults = false;
    this.currentTypeMonthComparisonData = [];
    this.compareTypeMonthComparisonData = [];
  }

  toggleTypeCompareMonth1Dropdown(): void {
    this.showTypeCompareMonth1Dropdown = !this.showTypeCompareMonth1Dropdown;
    if (this.showTypeCompareMonth1Dropdown) {
      this.showTypeCompareMonth2Dropdown = false;
    }
  }

  selectTypeCompareMonth1(month: number): void {
    this.selectedTypeCompareMonth1 = month;
    this.showTypeCompareMonth1Dropdown = false;
  }

  toggleTypeCompareMonth2Dropdown(): void {
    this.showTypeCompareMonth2Dropdown = !this.showTypeCompareMonth2Dropdown;
    if (this.showTypeCompareMonth2Dropdown) {
      this.showTypeCompareMonth1Dropdown = false;
    }
  }

  selectTypeCompareMonth2(month: number): void {
    this.selectedTypeCompareMonth2 = month;
    this.showTypeCompareMonth2Dropdown = false;
  }

  loadTypeMonthComparisonData(): void {
    if (!this.selectedTypeCompareMonth1 || !this.selectedTypeCompareMonth2) {
      return;
    }

    this.isLoading = true;
    this.showTypeMonthComparisonResults = true;
    this.fetchTypeMonthComparisonData();
  }

  private fetchTypeMonthComparisonData(): void {
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedTypeCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedTypeCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    // Fetch Month 1 data
    const resp1 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    // Fetch Month 2 data
    const resp2 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Courses: any[] = [];
    let month2Courses: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month1Courses = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processTypeMonthComparisonData(month1Courses, month2Courses);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.processTypeMonthComparisonData(month1Courses, month2Courses);
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month2Courses = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processTypeMonthComparisonData(month1Courses, month2Courses);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.processTypeMonthComparisonData(month1Courses, month2Courses);
        }
      }
    );

    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    }, 2000);
  }

  private processTypeMonthComparisonData(month1Courses: any[], month2Courses: any[]): void {
    // Extract type data from courses - Month 1
    const month1TypeData = this.extractTypeDataFromCourses(month1Courses);
    // Extract type data from courses - Month 2
    const month2TypeData = this.extractTypeDataFromCourses(month2Courses);

    console.log('Month 1 Courses:', month1Courses.length);
    console.log('Month 1 Type Data:', month1TypeData);
    console.log('Month 2 Courses:', month2Courses.length);
    console.log('Month 2 Type Data:', month2TypeData);

    // Store Month 1 data as current
    this.currentTypeMonthComparisonData = month1TypeData.map((item: any) => ({
      name: item.name,
      value: item.value,
      percentage: 0,
      trend: 'neutral'
    }));

    // Store Month 2 data as comparison
    this.compareTypeMonthComparisonData = month2TypeData.map((item: any) => {
      const currentItem = this.currentTypeMonthComparisonData.find(x => x.name === item.name);
      const currentValue = currentItem ? currentItem.value : 0;

      let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
      if (item.value > currentValue) {
        trend = 'positive';
      } else if (item.value < currentValue) {
        trend = 'negative';
      }

      return {
        name: item.name,
        value: item.value,
        percentage: 0,
        trend: trend
      };
    });

    // Schedule chart initialization after DOM has been updated
    this.cdr.detectChanges();
    setTimeout(() => {
      this.initializeTypeMonthComparisonChart();
    }, 200);
  }

  private extractTypeDataFromCourses(courses: any[]): any[] {
    // Extracting type data

    const typeTotals: { [key: string]: number } = {
      'MCQ': 0,
      'True/False': 0,
      'Fill Blanks': 0,
      'Matching': 0,
      'Subjective': 0,
      'Scenario Based': 0,
      'Multi Select': 0,
      'Activity Performance': 0,
      'Audio/Video': 0,
      'Live Viva': 0,
      'File Submission': 0
    };

    if (!courses || courses.length === 0) {
      return [];
    }

    courses.forEach((course, index) => {
      console.log(`Course ${index}:`, course.course_name, 'Breakdown:', course.type_breakdown);
      if (course && course.type_breakdown) {
        // Map all type breakdowns to display names
        typeTotals['MCQ'] += course.type_breakdown.mcq || 0;
        typeTotals['True/False'] += course.type_breakdown.true_false || 0;
        typeTotals['Fill Blanks'] += course.type_breakdown.fill_blanks || 0;
        typeTotals['Matching'] += course.type_breakdown.matching || 0;
        typeTotals['Subjective'] += course.type_breakdown.subjective || 0;
        typeTotals['Scenario Based'] += course.type_breakdown.scenario_based || 0;
        typeTotals['Multi Select'] += course.type_breakdown.multi_select || 0;
        typeTotals['Activity Performance'] += course.type_breakdown.activity_performance || 0;
        typeTotals['Audio/Video'] += course.type_breakdown.audio_video || 0;
        typeTotals['Live Viva'] += course.type_breakdown.live_viva || 0;
        typeTotals['File Submission'] += course.type_breakdown.file_submission || 0;
      }
    });

    console.log('Type Totals:', typeTotals);

    const result = Object.entries(typeTotals)
      .filter(([_, value]) => value > 0) // Only include types with count > 0
      .map(([name, value]) => ({ name, value }));

    console.log('Extracted Type Data:', result);
    return result;
  }

  private initializeTypeMonthComparisonChart(): void {
    console.log('=== INITIALIZING TYPE MONTH COMPARISON CHART ===');

    const canvas = document.getElementById('typeMonthComparisonChart') as HTMLCanvasElement;
    console.log('Canvas found:', !!canvas);

    if (!canvas) {
      console.error('Canvas element not found');
      return;
    }

    if (!this.currentTypeMonthComparisonData || this.currentTypeMonthComparisonData.length === 0) {
      console.error('No current type data available');
      return;
    }

    if (!this.compareTypeMonthComparisonData || this.compareTypeMonthComparisonData.length === 0) {
      console.error('No compare type data available');
      return;
    }

    console.log('Current Data:', this.currentTypeMonthComparisonData);
    console.log('Compare Data:', this.compareTypeMonthComparisonData);

    const typeNames = this.currentTypeMonthComparisonData.map(d => d.name);

    const month1Values = typeNames.map(name => {
      const item = this.currentTypeMonthComparisonData.find(s => s.name === name);
      return item?.value || 0;
    });

    const month2Values = typeNames.map(name => {
      const item = this.compareTypeMonthComparisonData.find(s => s.name === name);
      return item?.value || 0;
    });

    console.log('Chart labels:', typeNames);
    console.log('Month 1 values:', month1Values);
    console.log('Month 2 values:', month2Values);

    if (this.typeMonthComparisonChart) {
      this.typeMonthComparisonChart.destroy();
      this.typeMonthComparisonChart = null;
    }

    const chartHeight = Math.max(typeNames.length * 40, 300);
    const container = canvas.parentElement as HTMLElement;
    if (container) {
      container.style.minHeight = chartHeight + 'px';
    }

    const month1Name = this.getMonthName(this.selectedTypeCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedTypeCompareMonth2!);

    try {
      console.log('Creating Chart.js instance...');
      this.typeMonthComparisonChart = new Chart(canvas, {
        type: 'bar',
        data: {
          labels: typeNames,
          datasets: [
            {
              label: month1Name,
              data: month1Values,
              backgroundColor: '#FF9800',
              borderColor: '#F57C00',
              borderWidth: 1,
              barThickness: 'flex',
              barPercentage: 0.7,
            },
            {
              label: month2Name,
              data: month2Values,
              backgroundColor: '#9C27B0',
              borderColor: '#7B1FA2',
              borderWidth: 1,
              barThickness: 'flex',
              barPercentage: 0.7,
            }
          ]
        },
        options: {
          indexAxis: 'y',
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'top',
            }
          },
          scales: {
            x: {
              beginAtZero: true,
              stacked: false,
              grid: {
                display: true
              }
            },
            y: {
              stacked: false,
              grid: {
                display: false
              }
            }
          }
        }
      });
      console.log('Chart created successfully');
    } catch (error) {
      console.error('Error creating chart:', error);
    }
  }

  openLanguageMonthCompareDialog(): void {
    this.showLanguageMonthCompareDialog = true;
    this.selectedLanguageCompareMonth1 = null;
    this.selectedLanguageCompareMonth2 = null;
    this.showLanguageMonthComparisonResults = false;
    this.currentLanguageMonthComparisonData = [];
    this.compareLanguageMonthComparisonData = [];
  }

  closeLanguageMonthCompareDialog(): void {
    this.showLanguageMonthCompareDialog = false;
    this.selectedLanguageCompareMonth1 = null;
    this.selectedLanguageCompareMonth2 = null;
    this.showLanguageMonthComparisonResults = false;
    this.currentLanguageMonthComparisonData = [];
    this.compareLanguageMonthComparisonData = [];
    if (this.languageMonthComparisonChart) {
      this.languageMonthComparisonChart.destroy();
      this.languageMonthComparisonChart = null;
    }
  }

  toggleLanguageCompareMonth1Dropdown(): void {
    this.showLanguageCompareMonth1Dropdown = !this.showLanguageCompareMonth1Dropdown;
    this.showLanguageCompareMonth2Dropdown = false;
  }

  selectLanguageCompareMonth1(month: number): void {
    this.selectedLanguageCompareMonth1 = month;
    this.showLanguageCompareMonth1Dropdown = false;
  }

  toggleLanguageCompareMonth2Dropdown(): void {
    this.showLanguageCompareMonth2Dropdown = !this.showLanguageCompareMonth2Dropdown;
    this.showLanguageCompareMonth1Dropdown = false;
  }

  selectLanguageCompareMonth2(month: number): void {
    this.selectedLanguageCompareMonth2 = month;
    this.showLanguageCompareMonth2Dropdown = false;
  }

  loadLanguageMonthComparisonData(): void {
    if (!this.selectedLanguageCompareMonth1 || !this.selectedLanguageCompareMonth2) {
      return;
    }

    this.isLoading = true;
    this.showLanguageMonthComparisonResults = true;
    this.fetchLanguageMonthComparisonData();
  }

  private fetchLanguageMonthComparisonData(): void {
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedLanguageCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedLanguageCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    console.log('=== FETCH LANGUAGE MONTH COMPARISON DATA ===');
    console.log('Month 1 Date Range:', formattedMonth1StartDate, 'to', formattedMonth1EndDate);
    console.log('Month 2 Date Range:', formattedMonth2StartDate, 'to', formattedMonth2EndDate);

    // Fetch Month 1 data
    const resp1 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    // Fetch Month 2 data
    const resp2 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Courses: any[] = [];
    let month2Courses: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month1Courses = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processLanguageMonthComparisonData(month1Courses, month2Courses);
        }
      },
      (error) => {
        console.error('Error fetching month 1 language data:', error);
        completedRequests++;
        if (completedRequests === 2) {
          this.processLanguageMonthComparisonData(month1Courses, month2Courses);
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month2Courses = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processLanguageMonthComparisonData(month1Courses, month2Courses);
        }
      },
      (error) => {
        console.error('Error fetching month 2 language data:', error);
        completedRequests++;
        if (completedRequests === 2) {
          this.processLanguageMonthComparisonData(month1Courses, month2Courses);
        }
      }
    );
  }

  private processLanguageMonthComparisonData(month1Courses: any[], month2Courses: any[]): void {
    this.isLoading = false;

    console.log('=== PROCESS LANGUAGE MONTH COMPARISON DATA ===');
    console.log('Month 1 Courses:', month1Courses);
    console.log('Month 2 Courses:', month2Courses);

    const month1Data = this.extractLanguageDataFromCourses(month1Courses);
    const month2Data = this.extractLanguageDataFromCourses(month2Courses);

    console.log('Month 1 Data extracted:', month1Data);
    console.log('Month 2 Data extracted:', month2Data);

    this.currentLanguageMonthComparisonData = month1Data;
    this.compareLanguageMonthComparisonData = month2Data;

    console.log('After assignment - currentLanguageMonthComparisonData:', this.currentLanguageMonthComparisonData);
    console.log('After assignment - compareLanguageMonthComparisonData:', this.compareLanguageMonthComparisonData);
    console.log('Current length:', this.currentLanguageMonthComparisonData.length);
    console.log('Compare length:', this.compareLanguageMonthComparisonData.length);

    // Calculate trends
    this.languageMonthTrendSummary = [];
    const allLanguages = new Set([...month1Data.map(d => d.name), ...month2Data.map(d => d.name)]);

    allLanguages.forEach(language => {
      const month1Item = month1Data.find(d => d.name === language);
      const month2Item = month2Data.find(d => d.name === language);

      const month1Value = month1Item?.value || 0;
      const month2Value = month2Item?.value || 0;

      let trend = 'neutral';
      if (month2Value > month1Value) {
        trend = 'positive';
      } else if (month2Value < month1Value) {
        trend = 'negative';
      }

      this.languageMonthTrendSummary.push({
        category: language,
        value: Math.abs(month2Value - month1Value),
        trend: trend
      });
    });

    console.log('Before cdr.detectChanges - showLanguageMonthComparisonResults:', this.showLanguageMonthComparisonResults);
    this.cdr.detectChanges();
    console.log('After cdr.detectChanges - showLanguageMonthComparisonResults:', this.showLanguageMonthComparisonResults);

    setTimeout(() => {
      console.log('In setTimeout - checking canvas...');
      const canvas = document.getElementById('languageMonthComparisonChart');
      console.log('Canvas exists in setTimeout:', !!canvas);
      this.initializeLanguageMonthComparisonChart();
    }, 200);
  }

  private extractLanguageDataFromCourses(courses: any[]): any[] {
    console.log('=== EXTRACT LANGUAGE DATA FROM COURSES ===');
    console.log('Input courses:', courses);
    console.log('Courses array length:', courses ? courses.length : 0);

    const languageTotals: any = {};

    courses.forEach((course, index) => {
      console.log(`Course ${index}:`, course.course_name, 'language_breakdown:', !!course.language_breakdown);
      if (course.language_breakdown) {
        console.log(`  Language breakdown for ${course.course_name}:`, course.language_breakdown);
        Object.keys(course.language_breakdown).forEach(language => {
          if (!languageTotals[language]) {
            languageTotals[language] = 0;
          }
          languageTotals[language] += course.language_breakdown[language] || 0;
        });
      }
    });

    console.log('Language totals:', languageTotals);

    const result = Object.keys(languageTotals)
      .filter(language => languageTotals[language] > 0)
      .map(language => ({
        name: language,
        value: languageTotals[language]
      }));

    console.log('Final extracted result:', result);
    return result;
  }

  private initializeLanguageMonthComparisonChart(): void {
    console.log('=== INITIALIZING LANGUAGE MONTH COMPARISON CHART ===');

    const canvas = document.getElementById('languageMonthComparisonChart') as HTMLCanvasElement;
    console.log('Canvas found:', !!canvas);

    if (!canvas) {
      console.error('Canvas element not found');
      return;
    }

    if (!this.currentLanguageMonthComparisonData || this.currentLanguageMonthComparisonData.length === 0) {
      console.error('No current language data available');
      return;
    }

    if (!this.compareLanguageMonthComparisonData || this.compareLanguageMonthComparisonData.length === 0) {
      console.error('No compare language data available');
      return;
    }

    console.log('Current Data:', this.currentLanguageMonthComparisonData);
    console.log('Compare Data:', this.compareLanguageMonthComparisonData);

    const languageNames = this.currentLanguageMonthComparisonData.map(d => d.name);

    const month1Values = languageNames.map(name => {
      const item = this.currentLanguageMonthComparisonData.find(s => s.name === name);
      return item?.value || 0;
    });

    const month2Values = languageNames.map(name => {
      const item = this.compareLanguageMonthComparisonData.find(s => s.name === name);
      return item?.value || 0;
    });

    console.log('Chart labels:', languageNames);
    console.log('Month 1 values:', month1Values);
    console.log('Month 2 values:', month2Values);

    if (this.languageMonthComparisonChart) {
      this.languageMonthComparisonChart.destroy();
      this.languageMonthComparisonChart = null;
    }

    const chartHeight = Math.max(languageNames.length * 40, 300);
    const container = canvas.parentElement as HTMLElement;
    if (container) {
      container.style.minHeight = chartHeight + 'px';
    }

    const month1Name = this.getMonthName(this.selectedLanguageCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedLanguageCompareMonth2!);

    try {
      console.log('Creating Chart.js instance...');
      this.languageMonthComparisonChart = new Chart(canvas, {
        type: 'bar',
        data: {
          labels: languageNames,
          datasets: [
            {
              label: month1Name,
              data: month1Values,
              backgroundColor: '#FF9800',
              borderColor: '#F57C00',
              borderWidth: 1,
              barThickness: 'flex',
              barPercentage: 0.7,
            },
            {
              label: month2Name,
              data: month2Values,
              backgroundColor: '#9C27B0',
              borderColor: '#7B1FA2',
              borderWidth: 1,
              barThickness: 'flex',
              barPercentage: 0.7,
            }
          ]
        },
        options: {
          indexAxis: 'y',
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'top',
            }
          },
          scales: {
            x: {
              beginAtZero: true,
              stacked: false,
              grid: {
                display: true
              }
            },
            y: {
              stacked: false,
              grid: {
                display: false
              }
            }
          }
        }
      });
      console.log('Chart created successfully');
    } catch (error) {
      console.error('Error creating chart:', error);
    }
  }

  loadDifficultyLevelMonthComparisonData(): void {
    if (!this.selectedDifficultyLevelCompareMonth1 || !this.selectedDifficultyLevelCompareMonth2) {
      return;
    }

    this.isLoading = true;
    this.showDifficultyLevelMonthComparisonResults = true;
    this.fetchDifficultyLevelMonthComparisonData();
  }

  private fetchDifficultyLevelMonthComparisonData(): void {
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedDifficultyLevelCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedDifficultyLevelCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    // Fetch Month 1 data
    const resp1 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    // Fetch Month 2 data
    const resp2 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Courses: any[] = [];
    let month2Courses: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month1Courses = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processDifficultyLevelMonthComparisonData(month1Courses, month2Courses);
        }
      },
      (error) => {
        console.error('Error fetching month 1 data:', error);
        completedRequests++;
        if (completedRequests === 2) {
          this.processDifficultyLevelMonthComparisonData(month1Courses, month2Courses);
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month2Courses = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processDifficultyLevelMonthComparisonData(month1Courses, month2Courses);
        }
      },
      (error) => {
        console.error('Error fetching month 2 data:', error);
        completedRequests++;
        if (completedRequests === 2) {
          this.processDifficultyLevelMonthComparisonData(month1Courses, month2Courses);
        }
      }
    );

    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    }, 2000);
  }
  // ==================== ASSESSMENT CUSTOMER COMPARE METHODS ====================

  /**
   * Open Assessment Customer Compare Dialog
   */
  openAssessmentCustomerCompareDialog(): void {
    this.showAssessmentCustomerCompareDialog = true;
    this.showAssessmentCustomerComparisonResults = false;
    this.selectedAssessmentCustomerCompareMonth1 = null;
    this.selectedAssessmentCustomerCompareMonth2 = null;
    this.currentAssessmentCustomerComparisonData = [];
    this.compareAssessmentCustomerComparisonData = [];
    
    // Close the chart menu
    this.showAssessmentCustomerChartMenu = false;
  }

  /**
   * Close Assessment Customer Compare Dialog
   */
  closeAssessmentCustomerCompareDialog(): void {
    this.showAssessmentCustomerCompareDialog = false;
    this.showAssessmentCustomerComparisonResults = false;
    this.currentAssessmentCustomerComparisonData = [];
    this.compareAssessmentCustomerComparisonData = [];
    
    // Destroy chart if it exists
    if (this.assessmentCustomerComparisonChart) {
      this.assessmentCustomerComparisonChart.destroy();
      this.assessmentCustomerComparisonChart = null;
    }
  }

  /**
   * Toggle Month 1 Dropdown for Assessment Customer Compare
   */
  toggleAssessmentCustomerCompareMonth1Dropdown(): void {
    this.showAssessmentCustomerCompareMonth1Dropdown = !this.showAssessmentCustomerCompareMonth1Dropdown;
    if (this.showAssessmentCustomerCompareMonth1Dropdown) {
      this.showAssessmentCustomerCompareMonth2Dropdown = false;
    }
  }

  /**
   * Select Month 1 for Assessment Customer Compare
   */
  selectAssessmentCustomerCompareMonth1(month: number): void {
    this.selectedAssessmentCustomerCompareMonth1 = month;
    this.showAssessmentCustomerCompareMonth1Dropdown = false;
  }

  /**
   * Toggle Month 2 Dropdown for Assessment Customer Compare
   */
  toggleAssessmentCustomerCompareMonth2Dropdown(): void {
    this.showAssessmentCustomerCompareMonth2Dropdown = !this.showAssessmentCustomerCompareMonth2Dropdown;
    if (this.showAssessmentCustomerCompareMonth2Dropdown) {
      this.showAssessmentCustomerCompareMonth1Dropdown = false;
    }
  }

  /**
   * Select Month 2 for Assessment Customer Compare
   */
  selectAssessmentCustomerCompareMonth2(month: number): void {
    this.selectedAssessmentCustomerCompareMonth2 = month;
    this.showAssessmentCustomerCompareMonth2Dropdown = false;
  }

  /**
   * Load Assessment Customer Comparison Data
   */
  loadAssessmentCustomerComparisonData(): void {
    if (!this.selectedAssessmentCustomerCompareMonth1 || !this.selectedAssessmentCustomerCompareMonth2) {
      return;
    }

    this.isLoading = true;
    this.showAssessmentCustomerComparisonResults = true;
    
    // Close dropdowns
    this.showAssessmentCustomerCompareMonth1Dropdown = false;
    this.showAssessmentCustomerCompareMonth2Dropdown = false;

    // Fetch comparison data
    this.fetchAssessmentCustomerComparisonDataMonthWise();
  }

  /**
   * Fetch Assessment Customer Comparison Data - Month Wise
   */
  private fetchAssessmentCustomerComparisonDataMonthWise(): void {
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedAssessmentCustomerCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedAssessmentCustomerCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    console.log('Assessment Customer Compare - Month 1:', formattedMonth1StartDate, 'to', formattedMonth1EndDate);
    console.log('Assessment Customer Compare - Month 2:', formattedMonth2StartDate, 'to', formattedMonth2EndDate);

    // Fetch Month 1 data
    const resp1 = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    // Fetch Month 2 data
    const resp2 = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Data: any[] = [];
    let month2Data: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        const response = data['body']?.['responseBody'] || data?.['responseBody'] || data;
        
        // Extract customer assessment data
        if (response?.operationsData?.top_5_customers_by_assessment) {
          const topCustomers = response.operationsData.top_5_customers_by_assessment;
          if (Array.isArray(topCustomers)) {
            month1Data = topCustomers;
          } else if (topCustomers.coalesce && Array.isArray(topCustomers.coalesce)) {
            month1Data = topCustomers.coalesce;
          }
        } else if (response?.operationsData?.assessment_by_customers) {
          month1Data = response.operationsData.assessment_by_customers;
        }
        
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentCustomerComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        console.error('Month 1 API Error:', error);
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentCustomerComparisonDataMonthWise(month1Data, month2Data);
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        const response = data['body']?.['responseBody'] || data?.['responseBody'] || data;
        
        // Extract customer assessment data
        if (response?.operationsData?.top_5_customers_by_assessment) {
          const topCustomers = response.operationsData.top_5_customers_by_assessment;
          if (Array.isArray(topCustomers)) {
            month2Data = topCustomers;
          } else if (topCustomers.coalesce && Array.isArray(topCustomers.coalesce)) {
            month2Data = topCustomers.coalesce;
          }
        } else if (response?.operationsData?.assessment_by_customers) {
          month2Data = response.operationsData.assessment_by_customers;
        }
        
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentCustomerComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        console.error('Month 2 API Error:', error);
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentCustomerComparisonDataMonthWise(month1Data, month2Data);
        }
      }
    );

    // Set loading complete after both requests
    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    }, 2000);
  }

  /**
   * Process Assessment Customer Comparison Data - Month Wise
   */
  private processAssessmentCustomerComparisonDataMonthWise(month1Data: any[], month2Data: any[]): void {
    console.log('Processing Assessment Customer Comparison Data:');
    console.log('Month 1 Data:', month1Data);
    console.log('Month 2 Data:', month2Data);

    // Extract customer data from month 1
    const month1CustomerData = this.extractCustomerDataFromResponse(month1Data);
    const month2CustomerData = this.extractCustomerDataFromResponse(month2Data);

    console.log('Month 1 Extracted:', month1CustomerData);
    console.log('Month 2 Extracted:', month2CustomerData);

    // Store Month 1 data as current
    this.currentAssessmentCustomerComparisonData = month1CustomerData.map((item: any) => ({
      name: item.customer_name || item.name || 'Unknown',
      value: item.count || item.assessment_count || 0,
      percentage: 0,
      trend: 'neutral'
    }));

    // Store Month 2 data as comparison
    this.compareAssessmentCustomerComparisonData = month2CustomerData.map((item: any) => {
      const currentItem = this.currentAssessmentCustomerComparisonData.find(
        x => x.name === (item.customer_name || item.name)
      );
      const currentValue = currentItem ? currentItem.value : 0;
      const compareValue = item.count || item.assessment_count || 0;

      let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
      if (compareValue > currentValue) {
        trend = 'positive';
      } else if (compareValue < currentValue) {
        trend = 'negative';
      }

      return {
        name: item.customer_name || item.name || 'Unknown',
        value: compareValue,
        percentage: 0,
        trend: trend
      };
    });

    // Calculate percentages
    this.calculateCustomerComparisonPercentages();
    
    // Calculate trend summary
    this.calculateCustomerTrendSummaryMonthWise();

    // Initialize comparison chart
    this.cdr.detectChanges();
    setTimeout(() => {
      this.initializeAssessmentCustomerComparisonChart();
    }, 200);
  }

  /**
   * Extract Customer Data from Response
   */
  private extractCustomerDataFromResponse(data: any[]): any[] {
    if (!data || !Array.isArray(data)) {
      return [];
    }

    // If data already has customer_name and count, return as is
    if (data.length > 0 && data[0].customer_name !== undefined) {
      return data;
    }

    // Check if data is in coalesce format
    if (data.length > 0 && data[0].coalesce) {
      return data[0].coalesce;
    }

    return data;
  }

  /**
   * Calculate Customer Comparison Percentages
   */
  private calculateCustomerComparisonPercentages(): void {
    // Calculate for current data
    const currentTotal = this.currentAssessmentCustomerComparisonData.reduce(
      (sum, item) => sum + item.value, 0
    );
    this.currentAssessmentCustomerComparisonData = this.currentAssessmentCustomerComparisonData.map(item => ({
      ...item,
      percentage: currentTotal > 0 ? Math.round((item.value / currentTotal) * 100) : 0
    }));

    // Calculate for compare data
    const compareTotal = this.compareAssessmentCustomerComparisonData.reduce(
      (sum, item) => sum + item.value, 0
    );
    this.compareAssessmentCustomerComparisonData = this.compareAssessmentCustomerComparisonData.map(item => ({
      ...item,
      percentage: compareTotal > 0 ? Math.round((item.value / compareTotal) * 100) : 0
    }));
  }

  /**
   * Calculate Customer Trend Summary
   */
  private calculateCustomerTrendSummaryMonthWise(): void {
    const month1Name = this.getMonthName(this.selectedAssessmentCustomerCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedAssessmentCustomerCompareMonth2!);

    this.assessmentCustomerTrendSummary = [];

    // Get all unique customers from both months
    const allCustomers = new Set<string>();
    this.currentAssessmentCustomerComparisonData.forEach(item => allCustomers.add(item.name));
    this.compareAssessmentCustomerComparisonData.forEach(item => allCustomers.add(item.name));

    // Create detailed comparison for each customer
    Array.from(allCustomers).slice(0, 10).forEach(customerName => {
      const month1Item = this.currentAssessmentCustomerComparisonData.find(
        item => item.name === customerName
      );
      const month2Item = this.compareAssessmentCustomerComparisonData.find(
        item => item.name === customerName
      );

      const month1Value = month1Item ? month1Item.value : 0;
      const month2Value = month2Item ? month2Item.value : 0;

      let trendIcon = '→';
      let trend = 'neutral';
      if (month2Value > month1Value) {
        trendIcon = '↑';
        trend = 'positive';
      } else if (month2Value < month1Value) {
        trendIcon = '↓';
        trend = 'negative';
      }

      this.assessmentCustomerTrendSummary.push({
        name: customerName,
        current: month1Value,
        compare: month2Value,
        change: month2Value - month1Value,
        trend: trendIcon,
        trendType: trend
      });
    });
  }

  /**
   * Initialize Assessment Customer Comparison Chart
   */
  private initializeAssessmentCustomerComparisonChart(): void {
    // Prepare data for chart
    const month1Name = this.getMonthName(this.selectedAssessmentCustomerCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedAssessmentCustomerCompareMonth2!);

    // Get unique customers from both datasets
    const allCustomers = new Set<string>();
    this.currentAssessmentCustomerComparisonData.forEach(item => allCustomers.add(item.name));
    this.compareAssessmentCustomerComparisonData.forEach(item => allCustomers.add(item.name));

    const customerNames: string[] = Array.from(allCustomers).slice(0, 10);
    const month1Data: number[] = [];
    const month2Data: number[] = [];

    customerNames.forEach(customerName => {
      const month1Item = this.currentAssessmentCustomerComparisonData.find(
        item => item.name === customerName
      );
      const month2Item = this.compareAssessmentCustomerComparisonData.find(
        item => item.name === customerName
      );
      month1Data.push(month1Item ? month1Item.value : 0);
      month2Data.push(month2Item ? month2Item.value : 0);
    });

    console.log('Customer Comparison Chart - Names:', customerNames);
    console.log('Month 1 Data:', month1Data);
    console.log('Month 2 Data:', month2Data);

    // Destroy existing chart if it exists
    if (this.assessmentCustomerComparisonChart) {
      this.assessmentCustomerComparisonChart.destroy();
      this.assessmentCustomerComparisonChart = null;
    }

    // Delay chart initialization to ensure DOM is ready
    setTimeout(() => {
      const ctx = document.getElementById('assessmentCustomerComparisonChart') as HTMLCanvasElement;
      if (ctx) {
        try {
          // Set minimum height for horizontal bar chart
          const container = ctx.parentElement;
          if (container) {
            const chartHeight = Math.max(customerNames.length * 40, 300);
            container.style.minHeight = chartHeight + 'px';
          }

          this.assessmentCustomerComparisonChart = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: customerNames,
              datasets: [
                {
                  label: month1Name,
                  data: month1Data,
                  backgroundColor: '#005068',
                  borderColor: '#003d4d',
                  borderWidth: 1,
                  barThickness: 'flex' as any,
                  barPercentage: 0.7
                },
                {
                  label: month2Name,
                  data: month2Data,
                  backgroundColor: '#BFCAD9',
                  borderColor: '#9ba5b8',
                  borderWidth: 1,
                  barThickness: 'flex' as any,
                  barPercentage: 0.7
                }
              ]
            },
            options: {
              indexAxis: 'y' as const,
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  position: 'top' as const,
                  display: true
                },
                title: {
                  display: true,
                  text: `Month-wise Assessment by Customers Comparison: ${month1Name} vs ${month2Name}`
                }
              },
              scales: {
                x: {
                  beginAtZero: true,
                  stacked: false,
                  ticks: {
                    stepSize: 1
                  }
                },
                y: {
                  ticks: {
                    font: {
                      size: 12
                    }
                  }
                }
              }
            }
          });
          console.log('Customer Comparison Chart initialized successfully');
          this.cdr.detectChanges();
        } catch (error) {
          console.error('Error initializing customer comparison chart:', error);
        }
      } else {
        console.warn('Canvas element "assessmentCustomerComparisonChart" not found');
      }
    }, 200);
  }

  /**
   * Get Current Customer Total
   */
  getCurrentCustomerTotal(): number {
    return this.currentAssessmentCustomerComparisonData.reduce((sum, item) => sum + item.value, 0);
  }

  /**
   * Get Compare Customer Total
   */
  getCompareCustomerTotal(): number {
    return this.compareAssessmentCustomerComparisonData.reduce((sum, item) => sum + item.value, 0);
  }

  private processDifficultyLevelMonthComparisonData(month1Courses: any[], month2Courses: any[]): void {
    // Extract difficulty data from courses - Month 1
    const month1DifficultyData = this.extractDifficultyDataFromCourses(month1Courses);
    // Extract difficulty data from courses - Month 2
    const month2DifficultyData = this.extractDifficultyDataFromCourses(month2Courses);

    console.log('Month 1 Courses:', month1Courses.length);
    console.log('Month 1 Difficulty Data:', month1DifficultyData);
    console.log('Month 2 Courses:', month2Courses.length);
    console.log('Month 2 Difficulty Data:', month2DifficultyData);

    // Store Month 1 data as current
    this.currentDifficultyLevelMonthComparisonData = month1DifficultyData.map((item: any) => ({
      name: item.name,
      value: item.value,
      percentage: 0,
      trend: 'neutral'
    }));

    // Store Month 2 data as comparison
    this.compareDifficultyLevelMonthComparisonData = month2DifficultyData.map((item: any) => {
      const currentItem = this.currentDifficultyLevelMonthComparisonData.find(x => x.name === item.name);
      const currentValue = currentItem ? currentItem.value : 0;

      let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
      if (item.value > currentValue) {
        trend = 'positive';
      } else if (item.value < currentValue) {
        trend = 'negative';
      }

      return {
        name: item.name,
        value: item.value,
        percentage: 0,
        trend: trend
      };
    });

    console.log('Current Difficulty Data:', this.currentDifficultyLevelMonthComparisonData);
    console.log('Compare Difficulty Data:', this.compareDifficultyLevelMonthComparisonData);

    // Schedule chart initialization after DOM has been updated
    this.cdr.detectChanges();
    setTimeout(() => {
      this.initializeDifficultyLevelMonthComparisonChart();
    }, 200);
  }

  private extractDifficultyDataFromCourses(courses: any[]): any[] {
    console.log('=== EXTRACTING DIFFICULTY DATA ===');
    console.log('Courses received:', courses);
    console.log('Number of courses:', courses ? courses.length : 0);

    const difficultyTotals: { [key: string]: number } = {
      'Easy': 0,
      'Medium': 0,
      'Hard': 0
    };

    if (!courses || courses.length === 0) {
      console.log('No courses provided for difficulty extraction');
      return [];
    }

    courses.forEach((course, index) => {
      console.log(`Course ${index}:`, course.course_name, 'Breakdown:', course.difficulty_breakdown);
      if (course && course.difficulty_breakdown) {
        difficultyTotals['Easy'] += course.difficulty_breakdown.easy || 0;
        difficultyTotals['Medium'] += course.difficulty_breakdown.medium || 0;
        difficultyTotals['Hard'] += course.difficulty_breakdown.hard || 0;
      }
    });

    console.log('Difficulty Totals:', difficultyTotals);

    const result = Object.entries(difficultyTotals)
      .map(([name, value]) => ({ name, value }));

    console.log('Extracted Difficulty Data:', result);
    return result;
  }

  private initializeDifficultyLevelMonthComparisonChart(): void {
    console.log('=== INITIALIZING DIFFICULTY LEVEL MONTH COMPARISON CHART ===');

    const canvas = document.getElementById('difficultyLevelMonthComparisonChart') as HTMLCanvasElement;
    console.log('Canvas found:', !!canvas);

    if (!canvas) {
      console.error('Canvas element not found');
      return;
    }

    if (!this.currentDifficultyLevelMonthComparisonData || this.currentDifficultyLevelMonthComparisonData.length === 0) {
      console.error('No current difficulty data available');
      return;
    }

    if (!this.compareDifficultyLevelMonthComparisonData || this.compareDifficultyLevelMonthComparisonData.length === 0) {
      console.error('No compare difficulty data available');
      return;
    }

    console.log('Current Data:', this.currentDifficultyLevelMonthComparisonData);
    console.log('Compare Data:', this.compareDifficultyLevelMonthComparisonData);

    const difficultyNames = this.currentDifficultyLevelMonthComparisonData.map(d => d.name);

    const month1Values = difficultyNames.map(name => {
      const item = this.currentDifficultyLevelMonthComparisonData.find(s => s.name === name);
      return item?.value || 0;
    });

    const month2Values = difficultyNames.map(name => {
      const item = this.compareDifficultyLevelMonthComparisonData.find(s => s.name === name);
      return item?.value || 0;
    });

    console.log('Chart labels:', difficultyNames);
    console.log('Month 1 values:', month1Values);
    console.log('Month 2 values:', month2Values);

    if (this.difficultyLevelMonthComparisonChart) {
      this.difficultyLevelMonthComparisonChart.destroy();
      this.difficultyLevelMonthComparisonChart = null;
    }

    const chartHeight = Math.max(difficultyNames.length * 40, 300);
    const container = canvas.parentElement as HTMLElement;
    if (container) {
      container.style.minHeight = chartHeight + 'px';
    }

    const month1Name = this.getMonthName(this.selectedDifficultyLevelCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedDifficultyLevelCompareMonth2!);

    try {
      console.log('Creating Chart.js instance...');
      this.difficultyLevelMonthComparisonChart = new Chart(canvas, {
        type: 'bar',
        data: {
          labels: difficultyNames,
          datasets: [
            {
              label: month1Name,
              data: month1Values,
              backgroundColor: '#4CAF50',
              borderColor: '#45a049',
              borderWidth: 1,
              barThickness: 'flex',
              barPercentage: 0.7,
            },
            {
              label: month2Name,
              data: month2Values,
              backgroundColor: '#2196F3',
              borderColor: '#0b7dda',
              borderWidth: 1,
              barThickness: 'flex',
              barPercentage: 0.7,
            }
          ]
        },
        options: {
          indexAxis: 'y',
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'top',
            }
          },
          scales: {
            x: {
              beginAtZero: true,
              stacked: false,
              grid: {
                display: true
              }
            },
            y: {
              stacked: false,
              grid: {
                display: false
              }
            }
          }
        }
      });
      console.log('Chart created successfully');
    } catch (error) {
      console.error('Error creating chart:', error);
    }
  }

  // Compare Year Dropdown Methods
  toggleCompareYearDropdown(): void {
    this.showCompareYearDropdown = !this.showCompareYearDropdown;
    if (this.showCompareYearDropdown) {
      this.showCompareMonthDropdown = false;
    }
  }

  selectCompareYearRange(yearRange: string): void {
    this.selectedCompareYearRange = yearRange;
    this.showCompareYearDropdown = false;
  }

  // Compare Month Dropdown Methods
  toggleCompareMonthDropdown(): void {
    this.showCompareMonthDropdown = !this.showCompareMonthDropdown;
    if (this.showCompareMonthDropdown) {
      this.showCompareYearDropdown = false;
    }
  }

  selectCompareMonth(month: number | null): void {
    this.selectedCompareMonth = month;
    this.showCompareMonthDropdown = false;
  }

  // Load Comparison Data
  loadComparisonData(): void {
    if (!this.selectedCompareYearRange) {
      return;
    }

    this.isLoading = true;
    this.showComparisonResults = true;

    // Prepare current data for comparison
    this.prepareCurrentComparisonData();

    // Fetch comparison data
    this.fetchComparisonData();
  }

  private prepareCurrentComparisonData(): void {
    // Use current difficulty chart data for comparison
    this.currentComparisonData = this.difficultyChartData
      .filter(item => item.value > 0)
      .map(item => ({
        name: item.name,
        value: item.value,
        percentage: this.getDifficultyPercentage(item),
        trend: 'neutral' // Current data has no trend
      }));
  }

  private fetchComparisonData(): void {
    // Calculate date range for comparison
    let startDate: Date;
    let endDate: Date;

    if (this.selectedCompareMonth) {
      // If month is selected, use specific month within the academic year
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedCompareYearRange);
      if (yearRange) {
        const year = this.selectedCompareMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedCompareMonth - 1, 1);
        endDate = new Date(year, this.selectedCompareMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedCompareMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedCompareMonth, 0);
      }
    } else {
      // If no month selected, use entire academic year
      const dateRange = this.getDateRangeFromYearRange(this.selectedCompareYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');
    const resp = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          this.processComparisonData(response.question_counts);
        } else {
          this.compareComparisonData = [];
          this.trendSummary = [];
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      (error) => {
        this.compareComparisonData = [];
        this.trendSummary = [];
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  private processComparisonData(questionCounts: any[]): void {
    // Aggregate difficulty data for comparison period
    const difficultyTotals = {
      'Easy': 0,
      'Medium': 0,
      'Hard': 0
    };

    questionCounts.forEach(course => {
      if (course.difficulty_breakdown) {
        difficultyTotals['Easy'] += course.difficulty_breakdown.easy || 0;
        difficultyTotals['Medium'] += course.difficulty_breakdown.medium || 0;
        difficultyTotals['Hard'] += course.difficulty_breakdown.hard || 0;
      }
    });

    const totalQuestions = Object.values(difficultyTotals).reduce((sum: number, count: number) => sum + count, 0);

    // Prepare comparison data
    this.compareComparisonData = Object.entries(difficultyTotals)
      .filter(([_, count]) => count > 0)
      .map(([difficulty, count]) => {
        const percentage = totalQuestions > 0 ? ((count / totalQuestions) * 100).toFixed(1) : '0';

        // Find corresponding current data for trend calculation
        const currentItem = this.currentComparisonData.find(item => item.name === difficulty);
        const currentValue = currentItem ? currentItem.value : 0;

        let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
        if (count > currentValue) {
          trend = 'positive';
        } else if (count < currentValue) {
          trend = 'negative';
        }

        return {
          name: difficulty,
          value: count,
          percentage: percentage,
          trend: trend
        };
      });

    // Calculate trend summary
    this.calculateTrendSummary();
  }

  private calculateTrendSummary(): void {
    const currentTotal = this.getCurrentTotalQuestions();
    const compareTotal = this.getCompareTotalQuestions();

    this.trendSummary = [
      {
        category: 'Total Questions',
        value: this.formatTrendValue(compareTotal - currentTotal),
        trend: compareTotal > currentTotal ? 'positive' : compareTotal < currentTotal ? 'negative' : 'neutral'
      }
    ];

    // Add difficulty level trends
    this.currentComparisonData.forEach(currentItem => {
      const compareItem = this.compareComparisonData.find(item => item.name === currentItem.name);
      if (compareItem) {
        const difference = compareItem.value - currentItem.value;
        this.trendSummary.push({
          category: `${currentItem.name} Questions`,
          value: this.formatTrendValue(difference),
          trend: compareItem.trend
        });
      }
    });
  }

  getCurrentTotalQuestions(): number {
    return this.currentComparisonData.reduce((sum, item) => sum + item.value, 0);
  }

  getCompareTotalQuestions(): number {
    return this.compareComparisonData.reduce((sum, item) => sum + item.value, 0);
  }


  // Month filter methods
  toggleMonthDropdown(): void {
    this.showMonthDropdown = !this.showMonthDropdown;
    if (this.showMonthDropdown) {
      this.showYearDropdown = false;
    }
  }





  ngAfterViewInit(): void {
    // Add window resize listener for EChart responsiveness
    window.addEventListener('resize', () => {
      if (this.geographicInsightsChart) {
        this.geographicInsightsChart.resize();
      }
    });

    // Check if welcome guided tour needs to be auto-triggered on first login
    this.tourService.checkAndAutoStartWelcomeTour();
  }

  // Initialize Geographic Insights Chart (India Map with FusionChart)
  initializeGeographicChart(): void {
    try {
      // Use API data if available, otherwise use sample data
      if (!this.geographicInsightsData || this.geographicInsightsData.length === 0) {
        // Sample geographic data for Indian states (fallback)
        this.geographicInsightsData = [
          { state: 'Andhra Pradesh', candidates: 0, assessments: 0, code: 'AP' },
          { state: 'Arunachal Pradesh', candidates: 0, assessments: 0, code: 'AR' },
          { state: 'Assam', candidates: 0, assessments: 0, code: 'AS' },
          { state: 'Bihar', candidates: 0, assessments: 0, code: 'BR' },
          { state: 'Chhattisgarh', candidates: 0, assessments: 0, code: 'CT' },
          { state: 'Delhi', candidates: 0, assessments: 0, code: 'DL' },
          { state: 'Goa', candidates: 0, assessments: 0, code: 'GA' },
          { state: 'Gujarat', candidates: 0, assessments: 0, code: 'GJ' },
          { state: 'Haryana', candidates: 0, assessments: 0, code: 'HR' },
          { state: 'Himachal Pradesh', candidates: 0, assessments: 0, code: 'HP' },
          { state: 'Jharkhand', candidates: 0, assessments: 0, code: 'JH' },
          { state: 'Karnataka', candidates: 0, assessments: 0, code: 'KA' },
          { state: 'Kerala', candidates: 0, assessments: 0, code: 'KL' },
          { state: 'Madhya Pradesh', candidates: 0, assessments: 0, code: 'MP' },
          { state: 'Maharashtra', candidates: 0, assessments: 0, code: 'MH' },
          { state: 'Manipur', candidates: 0, assessments: 0, code: 'MN' },
          { state: 'Meghalaya', candidates: 0, assessments: 0, code: 'ML' },
          { state: 'Mizoram', candidates: 0, assessments: 0, code: 'MZ' },
          { state: 'Nagaland', candidates: 0, assessments: 0, code: 'NL' },
          { state: 'Odisha', candidates: 0, assessments: 0, code: 'OR' },
          { state: 'Punjab', candidates: 0, assessments: 0, code: 'PB' },
          { state: 'Rajasthan', candidates: 0, assessments: 0, code: 'RJ' },
          { state: 'Sikkim', candidates: 0, assessments: 0, code: 'SK' },
          { state: 'Tamil Nadu', candidates: 0, assessments: 0, code: 'TN' },
          { state: 'Telangana', candidates: 0, assessments: 0, code: 'TG' },
          { state: 'Tripura', candidates: 0, assessments: 0, code: 'TR' },
          { state: 'Uttar Pradesh', candidates: 0, assessments: 0, code: 'UP' },
          { state: 'Uttarakhand', candidates: 0, assessments: 0, code: 'UT' },
          { state: 'West Bengal', candidates: 0, assessments: 0, code: 'WB' }
        ];
      }

      // Initialize bar chart after view is loaded
      setTimeout(() => {
        this.initializeGeographicBarChart();
      }, 500);

      this.showGeographicInsightsChart = true;
      console.log('Geographic Chart initialized with', this.geographicInsightsData.length, 'states');
    } catch (error) {
      console.error('Error initializing geographic chart:', error);
      this.showGeographicInsightsChart = false;
    }
  }

  private readonly properStateNames: { [key: string]: string } = {
    'andaman and nicobar': 'Andaman and Nicobar',
    'andhra pradesh': 'Andhra Pradesh',
    'arunachal pradesh': 'Arunachal Pradesh',
    'assam': 'Assam',
    'bihar': 'Bihar',
    'chandigarh': 'Chandigarh',
    'chhattisgarh': 'Chhattisgarh',
    'dadra and nagar haveli': 'Dadra and Nagar Haveli',
    'daman and diu': 'Daman and Diu',
    'delhi': 'Delhi',
    'goa': 'Goa',
    'gujarat': 'Gujarat',
    'haryana': 'Haryana',
    'himachal pradesh': 'Himachal Pradesh',
    'jammu and kashmir': 'Jammu and Kashmir',
    'jharkhand': 'Jharkhand',
    'karnataka': 'Karnataka',
    'kerala': 'Kerala',
    'ladakh': 'Ladakh',
    'lakshadweep': 'Lakshadweep',
    'madhya pradesh': 'Madhya Pradesh',
    'maharashtra': 'Maharashtra',
    'manipur': 'Manipur',
    'meghalaya': 'Meghalaya',
    'mizoram': 'Mizoram',
    'nagaland': 'Nagaland',
    'odisha': 'Odisha',
    'puducherry': 'Puducherry',
    'punjab': 'Punjab',
    'rajasthan': 'Rajasthan',
    'sikkim': 'Sikkim',
    'tamil nadu': 'Tamil Nadu',
    'telangana': 'Telangana',
    'tripura': 'Tripura',
    'uttar pradesh': 'Uttar Pradesh',
    'uttarakhand': 'Uttarakhand',
    'west bengal': 'West Bengal'
  };

  private normalizeGeographicState(rawState: string): string {
    const normalizedKey = (rawState || '').trim().toLowerCase();
    if (!normalizedKey) return '';
    
    // Explicit district mapping
    if (normalizedKey.includes('bengaluru') || normalizedKey.includes('bangalore') || normalizedKey.includes('bengalero')) {
      return 'Karnataka';
    }

    // Return the state name if valid, otherwise empty string (to filter out districts/unknowns)
    return this.properStateNames[normalizedKey] || '';
  }

  private getFilteredGeographicInsightsData(): any[] {
    let data = JSON.parse(JSON.stringify(this.geographicInsightsData));

    const hasCourseFilter = this.selectedGeographicInsightCourseValues && this.selectedGeographicInsightCourseValues.length > 0;
    const hasCustomerFilter = this.selectedGeographicInsightCustomerValues && this.selectedGeographicInsightCustomerValues.length > 0;

    if (hasCourseFilter || hasCustomerFilter) {
      const assessmentStateCountMap = new Map<string, number>();
      const candidateStateCountMap = new Map<string, number>();
      
      const selectedCourses = hasCourseFilter ? this.selectedGeographicInsightCourseValues.map((c: string) => this.normalizeString(c)) : [];
      const selectedCustomers = hasCustomerFilter ? this.selectedGeographicInsightCustomerValues.map((c: string) => this.normalizeString(c)) : [];
      
      if (this.rawAssessmentDetails && Array.isArray(this.rawAssessmentDetails)) {
        this.rawAssessmentDetails.forEach((assessment: any) => {
          let match = true;

          if (hasCourseFilter) {
            if (!assessment.course) {
              match = false;
            } else {
              const courseName = this.normalizeString(assessment.course);
              if (!selectedCourses.includes(courseName)) {
                match = false;
              }
            }
          }

          if (match && hasCustomerFilter) {
            const customerName = assessment.customer_name || assessment.customer;
            if (!customerName) {
              match = false;
            } else {
              const normalizedCustomer = this.normalizeString(customerName);
              if (!selectedCustomers.includes(normalizedCustomer)) {
                match = false;
              }
            }
          }

          if (match) {
            const stateName = this.normalizeGeographicState(assessment.assessment_state || assessment.state || 'Unknown Location').trim().toLowerCase();
            assessmentStateCountMap.set(stateName, (assessmentStateCountMap.get(stateName) || 0) + 1);

            if (assessment.candidate_distribution_by_state && typeof assessment.candidate_distribution_by_state === 'object') {
              Object.keys(assessment.candidate_distribution_by_state).forEach(stateKey => {
                const candidateCount = assessment.candidate_distribution_by_state[stateKey] || 0;
                const candidateStateLower = this.normalizeGeographicState(stateKey).trim().toLowerCase();
                candidateStateCountMap.set(candidateStateLower, (candidateStateCountMap.get(candidateStateLower) || 0) + candidateCount);
              });
            } else {
              const totalCandidates = assessment.total_candidates || assessment.candidates || 0;
              candidateStateCountMap.set(stateName, (candidateStateCountMap.get(stateName) || 0) + totalCandidates);
            }
          }
        });
      }

      data = data.map((d: any) => {
        const lowerState = this.normalizeGeographicState(d.state).trim().toLowerCase();
        d.assessments = assessmentStateCountMap.get(lowerState) || 0;
        d.candidates = candidateStateCountMap.get(lowerState) || 0;
        return d;
      });
    }

    return data;
  }

  private initializeGeographicBarChart(): void {
    try {
      const canvas = document.getElementById('geographicInsightsBarChart') as HTMLCanvasElement;
      if (!canvas) {
        console.error('Geographic chart canvas not found');
        return;
      }

      // Prepare data for chart
      let chartData = this.getFilteredGeographicInsightsData();
      const sortMetric = this.selectedGeographicInsightsFilter === 'candidates' ? 'candidates' : 'assessments';

      chartData = chartData.filter(d => (d[sortMetric] || 0) > 0);

      if (this.selectedGeographicInsightGeographyValues && this.selectedGeographicInsightGeographyValues.length > 0) {
        chartData = chartData.filter(d => this.selectedGeographicInsightGeographyValues.includes(d.state));
      } else {
        chartData = [...chartData].sort((a, b) => (b[sortMetric] || 0) - (a[sortMetric] || 0)).slice(0, 10);
      }

      const stateLabels = chartData.map(d => d.state);
      const candidatesData = chartData.map(d => d.candidates);
      const assessmentsData = chartData.map(d => d.assessments);

      // Destroy existing chart if it exists
      if (this.geographicInsightsChart) {
        this.geographicInsightsChart.destroy();
        this.geographicInsightsChart = null;
      }

      // Determine which dataset to show based on selected filter
      const isShowingCandidates = this.selectedGeographicInsightsFilter === 'candidates';
      const isShowingAssessments = this.selectedGeographicInsightsFilter === 'assessments';
      
      // Build datasets array - show both initially, or only selected one when filtered
      const datasets: any[] = [];
      
      // Show candidates data
      if (isShowingCandidates || (!isShowingCandidates && !isShowingAssessments)) {
        datasets.push({
          label: 'Candidates',
          data: candidatesData,
          backgroundColor: '#4CAF50',
          borderColor: '#388E3C',
          borderWidth: 1,
          barThickness: 'flex' as const,
          barPercentage: 0.7,
          categoryPercentage: 0.8
        });
      }
      
      // Show assessments data
      if (isShowingAssessments || (!isShowingCandidates && !isShowingAssessments)) {
        datasets.push({
          label: 'Assessments',
          data: assessmentsData,
          backgroundColor: '#2196F3',
          borderColor: '#1565C0',
          borderWidth: 1,
          barThickness: 'flex' as const,
          barPercentage: 0.7,
          categoryPercentage: 0.8
        });
      }

      // Create new bar chart
      this.geographicInsightsChart = new Chart(canvas, {
        type: 'bar',
        data: {
          labels: stateLabels,
          datasets: datasets
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          indexAxis: 'y' as const,
          plugins: {
            legend: {
              display: false,
              position: 'top',
              labels: {
                font: { size: 14, weight: 'bold' },
                padding: 15,
                usePointStyle: true
              }
            },
            tooltip: {
              enabled: true,
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              padding: 12,
              titleFont: { size: 13, weight: 'bold' },
              bodyFont: { size: 12 },
              callbacks: {
                label: (context: any) => {
                  return `${context.dataset.label}: ${context.parsed.x}`;
                }
              }
            }
          },
          scales: {
            x: {
              beginAtZero: true,
              ticks: {
                font: { size: 11 },
                callback: function(value: any) {
                  return value;
                }
              },
              title: {
                display: true,
                text: 'Count',
                font: { size: 12, weight: 'bold' }
              }
            },
            y: {
              ticks: {
                font: { size: 11 }
              }
            }
          }
        }
      });

      console.log('Geographic bar chart initialized successfully');
    } catch (error) {
      console.error('Error initializing geographic bar chart:', error);
    }
  }

  initializeLeafletMap(): void {
    try {
      const mapContainer = document.getElementById('geographicInsightsMapContainer');
      
      if (!mapContainer) {
        console.error('Map container not found');
        return;
      }

      // Load Leaflet CSS dynamically if not already loaded
      if (!document.querySelector('link[href*="leaflet"]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
        document.head.appendChild(link);
      }

      // Kill existing map if it exists
      if (this.indiaMap) {
        this.indiaMap.remove();
        this.indiaMap = null;
      }
      
      // Reset white overlay layers array
      this.whiteOverlayLayers = [];

      // Define India boundaries
      const indiaBounds = L.latLngBounds(
        L.latLng(6.4, 68.1),    // Southwest - Kerala/Gujarat
        L.latLng(35.5, 97.4)    // Northeast - Arunachal Pradesh
      );

      // Create map with large world bounds initially
      this.indiaMap = L.map('geographicInsightsMapContainer', {
        center: [20.5937, 78.9629], // India center
        zoom: 5.5,
        zoomControl: true,
        scrollWheelZoom: true,
        minZoom: 4,
        maxZoom: 9
      });

      // Add OpenStreetMap tiles FIRST (will show within India bounds)
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors',
        minZoom: 4,
        maxZoom: 12
      }).addTo(this.indiaMap);

      // Add white background for entire world AFTER tiles
      const whiteBase = L.rectangle([
        [-90, -180],
        [90, 180]
      ], {
        color: 'white',
        weight: 0,
        fillColor: 'white',
        fillOpacity: 1,
        interactive: false
      }).addTo(this.indiaMap);
      this.whiteOverlayLayers.push(whiteBase);

      // Cover areas OUTSIDE India with white - North
      const whiteNorth = L.rectangle([
        [35.5, -180],
        [90, 180]
      ], {
        color: 'white',
        weight: 0,
        fillColor: 'white',
        fillOpacity: 1,
        interactive: false
      }).addTo(this.indiaMap);
      this.whiteOverlayLayers.push(whiteNorth);

      // Cover areas OUTSIDE India - South
      const whiteSouth = L.rectangle([
        [-90, -180],
        [6.4, 180]
      ], {
        color: 'white',
        weight: 0,
        fillColor: 'white',
        fillOpacity: 1,
        interactive: false
      }).addTo(this.indiaMap);
      this.whiteOverlayLayers.push(whiteSouth);

      // Cover areas OUTSIDE India - West (Pakistan, Afghanistan)
      const whiteWest = L.rectangle([
        [6.4, -180],
        [35.5, 68.1]
      ], {
        color: 'white',
        weight: 0,
        fillColor: 'white',
        fillOpacity: 1,
        interactive: false
      }).addTo(this.indiaMap);
      this.whiteOverlayLayers.push(whiteWest);

      // Cover areas OUTSIDE India - East (China, Myanmar, Bangladesh area outside bounds)
      const whiteEast = L.rectangle([
        [6.4, 97.4],
        [35.5, 180]
      ], {
        color: 'white',
        weight: 0,
        fillColor: 'white',
        fillOpacity: 1,
        interactive: false
      }).addTo(this.indiaMap);
      this.whiteOverlayLayers.push(whiteEast);

      // Lock map to India bounds - prevent panning outside
      this.indiaMap.on('drag', () => {
        this.indiaMap!.panInsideBounds(indiaBounds, { animate: false });
      });

      // Re-add white overlays on zoom to keep them on top
      this.indiaMap.on('zoom', () => {
        this.bringWhiteOverlaysToTop();
      });

      this.indiaMap.on('move', () => {
        this.bringWhiteOverlaysToTop();
      });

      // Load and render India GeoJSON with states
      this.renderIndiaStatesOnMap();

    } catch (error) {
      console.error('Error initializing Leaflet map:', error);
    }
  }

  renderIndiaStatesOnMap(): void {
    try {
      // Use high-quality India GeoJSON with proper state boundaries
      // This is from a reliable open-source database
      const geoJsonUrl = 'https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/india.geojson';
      
      const backupUrl = 'https://raw.githubusercontent.com/geohacker/india/master/india_geo.json';

      const attemptLoad = (url: string, isBackup: boolean = false) => {
        fetch(url, { cache: 'no-cache' })
          .then(response => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.json();
          })
          .then((geoJsonData) => {
            console.log(`Successfully loaded GeoJSON from: ${url}`);
            if (geoJsonData && geoJsonData.features) {
              this.renderChoroplethMap(geoJsonData);
            } else {
              throw new Error('Invalid GeoJSON format');
            }
          })
          .catch(error => {
            console.warn(`Failed to load from ${url}: ${error.message}`);
            if (!isBackup) {
              console.log('Trying backup GeoJSON source...');
              attemptLoad(backupUrl, true);
            } else {
              console.error('All GeoJSON sources failed');
              this.renderWithEmbeddedGeoJSON();
            }
          });
      };

      attemptLoad(geoJsonUrl);
    } catch (error) {
      console.error('Error rendering states on map:', error);
      this.renderWithEmbeddedGeoJSON();
    }
  }

  renderWithEmbeddedGeoJSON(): void {
    // Embedded simplified India GeoJSON with state boundaries
    const indiaGeoJSON = {
      type: 'FeatureCollection',
      features: [
        { type: 'Feature', properties: { name: 'Andaman and Nicobar', code: 'AN' }, geometry: { type: 'Polygon', coordinates: [[[92.5, 12.5], [94.5, 12.5], [94.5, 13.5], [92.5, 13.5], [92.5, 12.5]]] } },
        { type: 'Feature', properties: { name: 'Andhra Pradesh', code: 'AP' }, geometry: { type: 'Polygon', coordinates: [[[77, 13], [84, 13], [84, 19], [77, 19], [77, 13]]] } },
        { type: 'Feature', properties: { name: 'Arunachal Pradesh', code: 'AR' }, geometry: { type: 'Polygon', coordinates: [[[91, 27], [97, 27], [97, 29], [91, 29], [91, 27]]] } },
        { type: 'Feature', properties: { name: 'Assam', code: 'AS' }, geometry: { type: 'Polygon', coordinates: [[[88, 24], [97, 24], [97, 28], [88, 28], [88, 24]]] } },
        { type: 'Feature', properties: { name: 'Bihar', code: 'BR' }, geometry: { type: 'Polygon', coordinates: [[[83, 24], [88, 24], [88, 27], [83, 27], [83, 24]]] } },
        { type: 'Feature', properties: { name: 'Chhattisgarh', code: 'CT' }, geometry: { type: 'Polygon', coordinates: [[[80, 20], [85, 20], [85, 24], [80, 24], [80, 20]]] } },
        { type: 'Feature', properties: { name: 'Delhi', code: 'DL' }, geometry: { type: 'Polygon', coordinates: [[[76.8, 28.4], [77.3, 28.4], [77.3, 28.9], [76.8, 28.9], [76.8, 28.4]]] } },
        { type: 'Feature', properties: { name: 'Goa', code: 'GA' }, geometry: { type: 'Polygon', coordinates: [[[73.7, 14.8], [74.3, 14.8], [74.3, 15.8], [73.7, 15.8], [73.7, 14.8]]] } },
        { type: 'Feature', properties: { name: 'Gujarat', code: 'GJ' }, geometry: { type: 'Polygon', coordinates: [[[68, 21], [75, 21], [75, 25], [68, 25], [68, 21]]] } },
        { type: 'Feature', properties: { name: 'Haryana', code: 'HR' }, geometry: { type: 'Polygon', coordinates: [[[76, 27], [77.5, 27], [77.5, 30], [76, 30], [76, 27]]] } },
        { type: 'Feature', properties: { name: 'Himachal Pradesh', code: 'HP' }, geometry: { type: 'Polygon', coordinates: [[[75, 30], [79, 30], [79, 33], [75, 33], [75, 30]]] } },
        { type: 'Feature', properties: { name: 'Jharkhand', code: 'JH' }, geometry: { type: 'Polygon', coordinates: [[[83, 22], [88, 22], [88, 25], [83, 25], [83, 22]]] } },
        { type: 'Feature', properties: { name: 'Karnataka', code: 'KA' }, geometry: { type: 'Polygon', coordinates: [[[74, 12], [79, 12], [79, 18], [74, 18], [74, 12]]] } },
        { type: 'Feature', properties: { name: 'Kerala', code: 'KL' }, geometry: { type: 'Polygon', coordinates: [[[74, 8], [78, 8], [78, 12], [74, 12], [74, 8]]] } },
        { type: 'Feature', properties: { name: 'Madhya Pradesh', code: 'MP' }, geometry: { type: 'Polygon', coordinates: [[[75, 20], [82, 20], [82, 25], [75, 25], [75, 20]]] } },
        { type: 'Feature', properties: { name: 'Maharashtra', code: 'MH' }, geometry: { type: 'Polygon', coordinates: [[[72, 16], [80, 16], [80, 22], [72, 22], [72, 16]]] } },
        { type: 'Feature', properties: { name: 'Manipur', code: 'MN' }, geometry: { type: 'Polygon', coordinates: [[[93.5, 24], [95.5, 24], [95.5, 26], [93.5, 26], [93.5, 24]]] } },
        { type: 'Feature', properties: { name: 'Meghalaya', code: 'ML' }, geometry: { type: 'Polygon', coordinates: [[[90, 24], [93, 24], [93, 26], [90, 26], [90, 24]]] } },
        { type: 'Feature', properties: { name: 'Mizoram', code: 'MZ' }, geometry: { type: 'Polygon', coordinates: [[[92, 22], [94, 22], [94, 24], [92, 24], [92, 22]]] } },
        { type: 'Feature', properties: { name: 'Nagaland', code: 'NL' }, geometry: { type: 'Polygon', coordinates: [[[93, 25], [95, 25], [95, 28], [93, 28], [93, 25]]] } },
        { type: 'Feature', properties: { name: 'Odisha', code: 'OR' }, geometry: { type: 'Polygon', coordinates: [[[83, 18], [88, 18], [88, 22], [83, 22], [83, 18]]] } },
        { type: 'Feature', properties: { name: 'Punjab', code: 'PB' }, geometry: { type: 'Polygon', coordinates: [[[74, 30], [76, 30], [76, 33], [74, 33], [74, 30]]] } },
        { type: 'Feature', properties: { name: 'Rajasthan', code: 'RJ' }, geometry: { type: 'Polygon', coordinates: [[[68, 23], [78, 23], [78, 30], [68, 30], [68, 23]]] } },
        { type: 'Feature', properties: { name: 'Tamil Nadu', code: 'TN' }, geometry: { type: 'Polygon', coordinates: [[[77, 8], [80, 8], [80, 13], [77, 13], [77, 8]]] } },
        { type: 'Feature', properties: { name: 'Telangana', code: 'TG' }, geometry: { type: 'Polygon', coordinates: [[[77, 15], [81, 15], [81, 19], [77, 19], [77, 15]]] } },
        { type: 'Feature', properties: { name: 'Tripura', code: 'TR' }, geometry: { type: 'Polygon', coordinates: [[[91, 23], [92.5, 23], [92.5, 24], [91, 24], [91, 23]]] } },
        { type: 'Feature', properties: { name: 'Uttar Pradesh', code: 'UP' }, geometry: { type: 'Polygon', coordinates: [[[77, 25], [84, 25], [84, 30], [77, 30], [77, 25]]] } },
        { type: 'Feature', properties: { name: 'Uttarakhand', code: 'UT' }, geometry: { type: 'Polygon', coordinates: [[[78, 29], [81, 29], [81, 31], [78, 31], [78, 29]]] } },
        { type: 'Feature', properties: { name: 'West Bengal', code: 'WB' }, geometry: { type: 'Polygon', coordinates: [[[85, 23], [89, 23], [89, 27], [85, 27], [85, 23]]] } }
      ]
    };

    this.renderChoroplethMap(indiaGeoJSON);
  }

  renderChoroplethMap(geoJsonData: any): void {
    try {
      let currentMapData = this.getFilteredGeographicInsightsData().filter(d => (d[this.selectedGeographicInsightsFilter === 'candidates' ? 'candidates' : 'assessments'] || 0) > 0);
      const sortMetricMap = this.selectedGeographicInsightsFilter === 'candidates' ? 'candidates' : 'assessments';

      if (this.selectedGeographicInsightGeographyValues && this.selectedGeographicInsightGeographyValues.length > 0) {
        currentMapData = currentMapData.filter(d => this.selectedGeographicInsightGeographyValues.includes(d.state));
      } else {
        currentMapData = [...currentMapData].sort((a, b) => (b[sortMetricMap] || 0) - (a[sortMetricMap] || 0)).slice(0, 10);
      }

      // Calculate color intensity values
      const maxValue = currentMapData.length > 0 ? Math.max(...currentMapData.map(d => 
        this.selectedGeographicInsightsFilter === 'candidates' ? d.candidates : d.assessments
      )) : 1;
      const minValue = currentMapData.length > 0 ? Math.min(...currentMapData.map(d =>
        this.selectedGeographicInsightsFilter === 'candidates' ? d.candidates : d.assessments
      )) : 0;

      // Create a state data lookup with better matching
      const stateDataMap = new Map<string, any>();
      const stateCodeMap = new Map<string, any>();
      const selectedCourseStateNames = this.getGeographicInsightMatchStatesForSelectedCourses();
      const courseFilterActive = selectedCourseStateNames.size > 0;
      
      currentMapData.forEach(item => {
        const stateName = (item.state || '').toLowerCase().trim();
        const stateCode = (item.code || '').toUpperCase().trim();
        
        if (stateName) stateDataMap.set(stateName, item);
        if (stateCode) stateCodeMap.set(stateCode, item);
      });

      // Extract all property names from GeoJSON to understand the structure
      const sampleFeature = geoJsonData.features?.[0];
      console.log('Sample GeoJSON feature properties:', sampleFeature?.properties);

      // Helper function to find state name from feature
      const getStateNameFromFeature = (feature: any): string => {
        const props = feature.properties || {};
        // Try common property names
        return props.name || props.NAME || props.st_nm || props.State || props.state || 'Unknown';
      };

      // Helper function to find matching state data
      const findStateData = (feature: any): any => {
        const stateName = getStateNameFromFeature(feature);
        const lowerName = stateName.toLowerCase().trim();
        
        // Direct exact match
        if (stateDataMap.has(lowerName)) {
          return stateDataMap.get(lowerName);
        }

        // Partial match
        for (const [key, data] of stateDataMap.entries()) {
          if (lowerName.includes(key) || key.includes(lowerName)) {
            return data;
          }
        }

        return null;
      };

      // Add GeoJSON layer to map
      const geoJsonLayer = L.geoJSON(geoJsonData, {
        style: (feature) => {
          const stateData = findStateData(feature);
          const stateName = getStateNameFromFeature(feature);
          const normalizedStateName = this.normalizeString(stateName);
          const isCourseMatchedState = courseFilterActive && selectedCourseStateNames.has(normalizedStateName);

          let color = '#E8F5E9'; // Default light green
          let borderColor = '#666';

          if (isCourseMatchedState) {
            color = '#7BBF5E';
            borderColor = '#2E7D32';
          } else if (stateData) {
            const value = this.selectedGeographicInsightsFilter === 'candidates' ? 
              stateData.candidates : stateData.assessments;
            const intensity = (value - minValue) / (maxValue - minValue || 1);
            color = this.getColorForIntensity(intensity);
          }

          return {
            fillColor: color,
            color: borderColor,
            weight: 2,
            opacity: 1,
            fillOpacity: 0.8
          };
        },
        onEachFeature: (feature, layer: any) => {
          const stateName = getStateNameFromFeature(feature);
          const stateData = findStateData(feature);

          if (!stateData) return;

          const value = stateData ? 
            (this.selectedGeographicInsightsFilter === 'candidates' ? 
              stateData.candidates : stateData.assessments) : 'N/A';

          const popupContent = `
            <div style="font-family: Arial, sans-serif; font-size: 13px; min-width: 180px;">
              <strong style="color: #333; font-size: 14px; display: block; margin-bottom: 6px;">
                ${stateName}
              </strong>
              <table style="width: 100%; border-collapse: collapse;">
                <tr>
                  <td style="color: #666; padding: 3px 0;">
                    ${this.selectedGeographicInsightsFilter === 'candidates' ? '👥 Candidates' : '📋 Assessments'}:
                  </td>
                  <td style="color: #10B981; font-weight: 700; text-align: right; padding: 3px 0;">
                    ${value}
                  </td>
                </tr>
              </table>
            </div>
          `;

          layer.bindPopup(popupContent);
          layer.bindTooltip(stateName, { 
            permanent: false,
            direction: 'top',
            sticky: true
          });

          // Hover effects with proper typing
          layer.on('mouseover', () => {
            if (layer.setStyle) {
              layer.setStyle({
                weight: 3,
                fillOpacity: 0.95,
                color: '#333'
              });
            }
            layer.openTooltip();
          });

          layer.on('mouseout', () => {
            if (layer.setStyle) {
              layer.setStyle({
                weight: 2,
                fillOpacity: 0.8,
                color: '#666'
              });
            }
          });

          layer.on('click', () => {
            layer.openPopup();
          });
        }
      }).addTo(this.indiaMap!);

      // Fit bounds to show all India with proper zoom
      if (this.indiaMap) {
        try {
          // Use India bounds specifically - Southwest to Northeast
          const indiaBounds = L.latLngBounds(
            L.latLng(6.4, 68.1),    // Southwest
            L.latLng(35.5, 97.4)    // Northeast
          );
          
          this.indiaMap.fitBounds(indiaBounds, { 
            padding: [30, 30],
            maxZoom: 6,
            animate: true
          });
        } catch (e) {
          console.warn('Could not fit bounds:', e);
          this.indiaMap.setView([20.5937, 78.9629], 5.5);
        }
      }

      console.log('Choropleth map rendered successfully');
    } catch (error) {
      console.error('Error rendering choropleth map:', error);
      this.renderCircleMarkers(); // Fallback
    }
  }

  renderCircleMarkers(): void {
    // Fallback to circle markers if GeoJSON fails
    const indiaGeoJSON = {
      type: 'FeatureCollection',
      features: [
        { type: 'Feature', properties: { state: 'Maharashtra', code: 'MH' }, geometry: { type: 'Point', coordinates: [75.7139, 19.7515] } },
        { type: 'Feature', properties: { state: 'Karnataka', code: 'KA' }, geometry: { type: 'Point', coordinates: [75.7139, 15.3173] } },
        { type: 'Feature', properties: { state: 'Tamil Nadu', code: 'TN' }, geometry: { type: 'Point', coordinates: [78.6569, 11.1271] } },
        { type: 'Feature', properties: { state: 'Telangana', code: 'TG' }, geometry: { type: 'Point', coordinates: [78.4740, 17.3850] } },
        { type: 'Feature', properties: { state: 'Delhi', code: 'DL' }, geometry: { type: 'Point', coordinates: [77.2090, 28.7041] } },
        { type: 'Feature', properties: { state: 'Uttar Pradesh', code: 'UP' }, geometry: { type: 'Point', coordinates: [79.0193, 27.1767] } },
        { type: 'Feature', properties: { state: 'Gujarat', code: 'GJ' }, geometry: { type: 'Point', coordinates: [72.6369, 22.2587] } },
        { type: 'Feature', properties: { state: 'Rajasthan', code: 'RJ' }, geometry: { type: 'Point', coordinates: [75.5941, 27.0238] } },
        { type: 'Feature', properties: { state: 'Punjab', code: 'PB' }, geometry: { type: 'Point', coordinates: [75.5761, 31.5497] } },
        { type: 'Feature', properties: { state: 'Haryana', code: 'HR' }, geometry: { type: 'Point', coordinates: [77.0597, 29.0588] } },
        { type: 'Feature', properties: { state: 'West Bengal', code: 'WB' }, geometry: { type: 'Point', coordinates: [88.3639, 24.8407] } },
        { type: 'Feature', properties: { state: 'Bihar', code: 'BR' }, geometry: { type: 'Point', coordinates: [85.3131, 25.0961] } },
        { type: 'Feature', properties: { state: 'Andhra Pradesh', code: 'AP' }, geometry: { type: 'Point', coordinates: [79.0193, 15.9129] } },
        { type: 'Feature', properties: { state: 'Kerala', code: 'KL' }, geometry: { type: 'Point', coordinates: [75.7421, 10.8505] } },
        { type: 'Feature', properties: { state: 'Madhya Pradesh', code: 'MP' }, geometry: { type: 'Point', coordinates: [78.6553, 22.9375] } },
        { type: 'Feature', properties: { state: 'Odisha', code: 'OR' }, geometry: { type: 'Point', coordinates: [85.0980, 20.9517] } }
      ]
    };

    const maxValue = Math.max(...this.geographicInsightsData.map(d => 
      this.selectedGeographicInsightsFilter === 'candidates' ? d.candidates : d.assessments
    ));
    const minValue = Math.min(...this.geographicInsightsData.map(d =>
      this.selectedGeographicInsightsFilter === 'candidates' ? d.candidates : d.assessments
    ));

    indiaGeoJSON.features.forEach(feature => {
      const stateName = feature.properties.state;
      const stateData = this.geographicInsightsData.find(d => d.state === stateName);

      if (stateData) {
        const value = this.selectedGeographicInsightsFilter === 'candidates' ? stateData.candidates : stateData.assessments;
        if (value <= 0) return;
        const intensity = (value - minValue) / (maxValue - minValue);
        const color = this.getColorForIntensity(intensity);
        const radius = 12 + (intensity * 20);

        const circleMarker = L.circleMarker(
          [feature.geometry.coordinates[1], feature.geometry.coordinates[0]],
          {
            radius: radius,
            fillColor: color,
            color: '#333',
            weight: 2,
            opacity: 1,
            fillOpacity: 0.8
          }
        ).addTo(this.indiaMap!);

        const popupText = `<div style="font-family: Arial, sans-serif; font-size: 12px;">
                            <strong style="font-size: 13px; color: #333;">${stateName}</strong><br/>
                            <span style="color: #666;">
                              ${this.selectedGeographicInsightsFilter === 'candidates' ? '👥 Candidates' : '📋 Assessments'}
                            </span>: 
                            <strong style="color: #10B981; font-size: 14px;">${value}</strong>
                          </div>`;
        circleMarker.bindPopup(popupText);
        circleMarker.bindTooltip(stateName, { permanent: false, direction: 'top' });

        circleMarker.on('mouseover', () => {
          circleMarker.setStyle({ weight: 3, opacity: 1, fillOpacity: 0.9 });
          circleMarker.openTooltip();
        });
        circleMarker.on('mouseout', () => {
          circleMarker.setStyle({ weight: 2, opacity: 1, fillOpacity: 0.8 });
        });
        circleMarker.on('click', () => {
          circleMarker.openPopup();
        });
      }
    });

    console.log('Circle markers rendered as fallback');
  }

  updateGeographicVisualization(): void {
    if (this.indiaMap && this.geographicInsightsData) {
      // Add smooth animation - fade transition
      const mapDiv = document.getElementById('geographicInsightsMapContainer');
      if (mapDiv) {
        mapDiv.style.opacity = '0.6';
        mapDiv.style.transition = 'opacity 0.3s ease-in-out';
      }

      // Small delay for smooth animation effect
      setTimeout(() => {
        // Clear ONLY GeoJSON and data layers (keep white overlays and tiles)
        this.indiaMap!.eachLayer((layer: any) => {
          // Skip white overlay layers
          if (this.whiteOverlayLayers.includes(layer)) {
            return;
          }
          
          // Remove only GeoJSON state boundaries
          if (layer instanceof L.GeoJSON) {
            this.indiaMap!.removeLayer(layer);
          }
          // Remove only CircleMarkers that are data visualization
          if (layer instanceof L.CircleMarker && layer.feature) {
            this.indiaMap!.removeLayer(layer);
          }
        });
        
        // Re-render with new filter
        this.renderIndiaStatesOnMap();

        // Fade back to full opacity
        if (mapDiv) {
          mapDiv.style.opacity = '1';
        }
      }, 150);

      // Ensure map stays centered on India during filter change
      setTimeout(() => {
        if (this.indiaMap) {
          this.indiaMap.setView([20.5937, 78.9629], 5.5, { 
            animate: true,
            duration: 0.5
          });
        }
      }, 200);
    }
  }

  // Initialize EChart Map for India Geographic Visualization
  initializeEChartMap(): void {
    try {
const mapContainer = document.querySelector('.geo-map-inner') as HTMLElement;      
      if (!mapContainer) {
        console.error('Map container not found');
        return;
      }

      // Create or get chart instance
      let chartInstance = echarts.getInstanceByDom(mapContainer);
      if (!chartInstance) {
        chartInstance = echarts.init(mapContainer, 'light', { renderer: 'svg' });
      }

      // Load India GeoJSON map
      this.loadIndiaMapData((geoJsonData: any) => {
        // Register map
        echarts.registerMap('India', geoJsonData);

        // Prepare data for visualization
        const selectedCourseStateNames = this.getGeographicInsightMatchStatesForSelectedCourses();
        const selectedMetric = this.selectedGeographicInsightsFilter === 'candidates' ? 'candidates' : 'assessments';
        
        // Filter states that have actual data for selected metric (exclude 0 values)
        let baseStates = this.getFilteredGeographicInsightsData().filter(d => d[selectedMetric] > 0);
        
        if (this.selectedGeographicInsightGeographyValues && this.selectedGeographicInsightGeographyValues.length > 0) {
          baseStates = baseStates.filter(d => this.selectedGeographicInsightGeographyValues.includes(d.state));
        } else {
          baseStates = [...baseStates].sort((a, b) => (b[selectedMetric] || 0) - (a[selectedMetric] || 0)).slice(0, 10);
        }
        
        // Calculate max value from states that have data
        const maxValue = baseStates.length > 0 
          ? Math.max(...baseStates.map(d => d[selectedMetric]))
          : 1;

        const highlightedStateNames = new Set<string>(selectedCourseStateNames);

        const baseMapData = baseStates.map(state => {
          const normalizedStateName = this.normalizeString(state.state);
          const isCourseMatchedState = highlightedStateNames.has(normalizedStateName);
          const dataItem: any = {
            name: state.state,
            value: state[selectedMetric],
            candidates: state.candidates,
            assessments: state.assessments,
            code: state.code
          };

          if (isCourseMatchedState) {
            dataItem.itemStyle = {
              color: '#7BBF5E',
              areaColor: '#7BBF5E',
              borderColor: '#2E7D32',
              borderWidth: 3
            };
            dataItem.emphasis = {
              itemStyle: {
                areaColor: '#7BBF5E',
                borderColor: '#2E7D32',
                borderWidth: 4
              }
            };
          }

          return dataItem;
        });

        const highlightedMapData = baseMapData.filter((item: any) => highlightedStateNames.has(this.normalizeString(item.name)));

        // Chart configuration
        const option: any = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            borderColor: '#333',
            borderWidth: 1,
            textStyle: {
              color: '#333',
              fontSize: 13
            },
            formatter: (params: any) => {
              if (!params.data) return '';
              const data = params.data;
              const isShowingCandidates = selectedMetric === 'candidates';
              
              return `
                <div style="padding: 8px; font-weight: 500; min-width: 250px;">
                  <div style="margin-bottom: 6px; border-bottom: 1px solid #ddd; padding-bottom: 6px;">
                    <strong>${data.name}</strong>
                  </div>
                  <div style="margin: 4px 0;">
                    ${isShowingCandidates ? 
                      `👥 Candidates: <strong>${data.candidates}</strong>` : 
                      `📋 Assessments: <strong>${data.assessments}</strong>`}
                  </div>
                </div>
              `;
            }
          },
          // Top-level visualMap for color gradient based on data values
          visualMap: {
            min: 0,
            max: maxValue,
            text: ['High', 'Low'],
            realtime: true,
            calculable: true,
            dimension: 'value',
            inRange: {
              // Pure green gradient: Light green to Dark green (more candidates = darker)
              color: ['#E8F5E9', '#C8E6C9', '#A5D6A7', '#81C784', '#66BB6A', '#4CAF50', '#388E3C', '#1B5E20']
            },
            textStyle: {
              color: '#333',
              fontSize: 11
            },
            left: '1%',
            bottom: '10%'
          },
          geo: {
            map: 'India',
            roam: true,
            top: 80,
            layoutSize: '100%',   
            zoom: 1.3,            
            label: {
              emphasis: {
                show: true,
                fontSize: 10,
                fontWeight: 'bold',
                color: '#333'
              }
            },
            itemStyle: {
              normal: {
                areaColor: '#F0F0F0',
                borderColor: '#999',
                borderWidth: 1.5
              },
              emphasis: {
                areaColor: '#A5D6A7',
                borderColor: '#333',
                borderWidth: 2
              }
            }
          },
          series: [
            {
              name: selectedMetric === 'candidates' ? 'Candidates' : 'Assessments',
              type: 'map',
              geoIndex: 0,
              data: baseMapData,
              nameProperty: 'name',
              itemStyle: {
                normal: {
                  borderColor: '#999',
                  borderWidth: 1
                },
                emphasis: {
                  areaColor: '#A5D6A7',
                  borderColor: '#333',
                  borderWidth: 2
                }
              },
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true,
                  fontWeight: 'bold',
                  fontSize: 10
                }
              }
            },
            ...(selectedCourseStateNames.size > 0 ? [{
              name: 'Highlighted States',
              type: 'map',
              geoIndex: 0,
              data: highlightedMapData,
              nameProperty: 'name',
              silent: true,
              itemStyle: {
                normal: {
                  areaColor: '#A5D6A7',
                  borderColor: '#2E7D32',
                  borderWidth: 3
                },
                emphasis: {
                  areaColor: '#A5D6A7',
                  borderColor: '#2E7D32',
                  borderWidth: 3
                }
              },
              label: {
                show: false
              },
              z: 10
            }] : [])
          ]
        };

        // Clear existing state and set new option
        chartInstance.clear();
        chartInstance.setOption(option);
        chartInstance.resize();

        this.geographicInsightsChart = chartInstance;
        
        // Apply initial zoom level (200%)
        setTimeout(() => {
  chartInstance.resize();
}, 200);
      });

    } catch (error) {
      console.error('Error initializing EChart map:', error);
      this.showGeographicInsightsChart = false;
    }
  }

  // Load India Map GeoJSON Data
  private loadIndiaMapData(callback: (geoJson: any) => void): void {
    // Try to load from CDN first
    const urls = [
      'https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/india.geojson',
      'https://raw.githubusercontent.com/geohacker/india/master/india_geo.json',
      'https://cdn.jsdelivr.net/npm/india@latest/states.json'
    ];

    const attemptLoad = (urlIndex: number = 0) => {
      if (urlIndex >= urls.length) {
        // Fallback to embedded simplified GeoJSON
        callback(this.getEmbeddedIndiaGeoJSON());
        return;
      }

      fetch(urls[urlIndex], { cache: 'no-cache' })
        .then(response => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.json();
        })
        .then((geoJsonData) => {
          console.log(`Successfully loaded India GeoJSON from: ${urls[urlIndex]}`);
          callback(geoJsonData);
        })
        .catch(error => {
          console.warn(`Failed to load from ${urls[urlIndex]}: ${error.message}`);
          attemptLoad(urlIndex + 1);
        });
    };

    attemptLoad();
  }

  // Embedded simplified India GeoJSON for fallback
  private getEmbeddedIndiaGeoJSON(): any {
    return {
      "type": "FeatureCollection",
      "features": [
        { "type": "Feature", "properties": { "name": "Andaman and Nicobar", "code": "AN" }, "geometry": { "type": "Polygon", "coordinates": [[[92.5, 12.5], [94.5, 12.5], [94.5, 13.5], [92.5, 13.5], [92.5, 12.5]]] } },
        { "type": "Feature", "properties": { "name": "Andhra Pradesh", "code": "AP" }, "geometry": { "type": "Polygon", "coordinates": [[[77, 13], [84, 13], [84, 19], [77, 19], [77, 13]]] } },
        { "type": "Feature", "properties": { "name": "Arunachal Pradesh", "code": "AR" }, "geometry": { "type": "Polygon", "coordinates": [[[91, 27], [97, 27], [97, 29], [91, 29], [91, 27]]] } },
        { "type": "Feature", "properties": { "name": "Assam", "code": "AS" }, "geometry": { "type": "Polygon", "coordinates": [[[88, 24], [97, 24], [97, 28], [88, 28], [88, 24]]] } },
        { "type": "Feature", "properties": { "name": "Bihar", "code": "BR" }, "geometry": { "type": "Polygon", "coordinates": [[[83, 24], [88, 24], [88, 27], [83, 27], [83, 24]]] } },
        { "type": "Feature", "properties": { "name": "Chhattisgarh", "code": "CT" }, "geometry": { "type": "Polygon", "coordinates": [[[80, 20], [85, 20], [85, 24], [80, 24], [80, 20]]] } },
        { "type": "Feature", "properties": { "name": "Delhi", "code": "DL" }, "geometry": { "type": "Polygon", "coordinates": [[[76.8, 28.4], [77.3, 28.4], [77.3, 28.9], [76.8, 28.9], [76.8, 28.4]]] } },
        { "type": "Feature", "properties": { "name": "Goa", "code": "GA" }, "geometry": { "type": "Polygon", "coordinates": [[[73.7, 14.8], [74.3, 14.8], [74.3, 15.8], [73.7, 15.8], [73.7, 14.8]]] } },
        { "type": "Feature", "properties": { "name": "Gujarat", "code": "GJ" }, "geometry": { "type": "Polygon", "coordinates": [[[68, 21], [75, 21], [75, 25], [68, 25], [68, 21]]] } },
        { "type": "Feature", "properties": { "name": "Haryana", "code": "HR" }, "geometry": { "type": "Polygon", "coordinates": [[[76, 27], [77.5, 27], [77.5, 30], [76, 30], [76, 27]]] } },
        { "type": "Feature", "properties": { "name": "Himachal Pradesh", "code": "HP" }, "geometry": { "type": "Polygon", "coordinates": [[[75, 30.5], [79.5, 30.5], [79.5, 33], [75, 33], [75, 30.5]]] } },
        { "type": "Feature", "properties": { "name": "Jharkhand", "code": "JH" }, "geometry": { "type": "Polygon", "coordinates": [[[83, 22], [87.5, 22], [87.5, 25.5], [83, 25.5], [83, 22]]] } },
        { "type": "Feature", "properties": { "name": "Karnataka", "code": "KA" }, "geometry": { "type": "Polygon", "coordinates": [[[74, 12], [79, 12], [79, 18.5], [74, 18.5], [74, 12]]] } },
        { "type": "Feature", "properties": { "name": "Kerala", "code": "KL" }, "geometry": { "type": "Polygon", "coordinates": [[[76, 8], [78, 8], [78, 12.5], [76, 12.5], [76, 8]]] } },
        { "type": "Feature", "properties": { "name": "Madhya Pradesh", "code": "MP" }, "geometry": { "type": "Polygon", "coordinates": [[[74, 21], [83, 21], [83, 26.5], [74, 26.5], [74, 21]]] } },
        { "type": "Feature", "properties": { "name": "Maharashtra", "code": "MH" }, "geometry": { "type": "Polygon", "coordinates": [[[73, 16], [80, 16], [80, 22], [73, 22], [73, 16]]] } },
        { "type": "Feature", "properties": { "name": "Manipur", "code": "MN" }, "geometry": { "type": "Polygon", "coordinates": [[[93.5, 24.5], [95.5, 24.5], [95.5, 25.5], [93.5, 25.5], [93.5, 24.5]]] } },
        { "type": "Feature", "properties": { "name": "Meghalaya", "code": "ML" }, "geometry": { "type": "Polygon", "coordinates": [[[90, 25], [93, 25], [93, 26], [90, 26], [90, 25]]] } },
        { "type": "Feature", "properties": { "name": "Mizoram", "code": "MZ" }, "geometry": { "type": "Polygon", "coordinates": [[[92.5, 21.5], [94.5, 21.5], [94.5, 23.8], [92.5, 23.8], [92.5, 21.5]]] } },
        { "type": "Feature", "properties": { "name": "Nagaland", "code": "NL" }, "geometry": { "type": "Polygon", "coordinates": [[[93.5, 25.5], [95.5, 25.5], [95.5, 27], [93.5, 27], [93.5, 25.5]]] } },
        { "type": "Feature", "properties": { "name": "Odisha", "code": "OR" }, "geometry": { "type": "Polygon", "coordinates": [[[84, 18], [88, 18], [88, 23], [84, 23], [84, 18]]] } },
        { "type": "Feature", "properties": { "name": "Punjab", "code": "PB" }, "geometry": { "type": "Polygon", "coordinates": [[[73, 30], [77, 30], [77, 33], [73, 33], [73, 30]]] } },
        { "type": "Feature", "properties": { "name": "Rajasthan", "code": "RJ" }, "geometry": { "type": "Polygon", "coordinates": [[[68, 24], [77.5, 24], [77.5, 30], [68, 30], [68, 24]]] } },
        { "type": "Feature", "properties": { "name": "Sikkim", "code": "SK" }, "geometry": { "type": "Polygon", "coordinates": [[[87.5, 27.5], [89, 27.5], [89, 28.5], [87.5, 28.5], [87.5, 27.5]]] } },
        { "type": "Feature", "properties": { "name": "Tamil Nadu", "code": "TN" }, "geometry": { "type": "Polygon", "coordinates": [[[78, 8], [80.5, 8], [80.5, 13], [78, 13], [78, 8]]] } },
        { "type": "Feature", "properties": { "name": "Telangana", "code": "TG" }, "geometry": { "type": "Polygon", "coordinates": [[[78.5, 15.5], [85, 15.5], [85, 20], [78.5, 20], [78.5, 15.5]]] } },
        { "type": "Feature", "properties": { "name": "Tripura", "code": "TR" }, "geometry": { "type": "Polygon", "coordinates": [[[91, 22.5], [93, 22.5], [93, 24.5], [91, 24.5], [91, 22.5]]] } },
        { "type": "Feature", "properties": { "name": "Uttar Pradesh", "code": "UP" }, "geometry": { "type": "Polygon", "coordinates": [[[77, 26], [84, 26], [84, 31], [77, 31], [77, 26]]] } },
        { "type": "Feature", "properties": { "name": "Uttarakhand", "code": "UT" }, "geometry": { "type": "Polygon", "coordinates": [[[78.5, 29], [81, 29], [81, 31], [78.5, 31], [78.5, 29]]] } },
        { "type": "Feature", "properties": { "name": "West Bengal", "code": "WB" }, "geometry": { "type": "Polygon", "coordinates": [[[86, 23.5], [89, 23.5], [89, 28.5], [86, 28.5], [86, 23.5]]] } }
      ]
    };
  }

  private bringWhiteOverlaysToTop(): void {
    // Ensure white overlays stay on top using bringToFront
    if (this.whiteOverlayLayers && this.whiteOverlayLayers.length > 0) {
      this.whiteOverlayLayers.forEach((layer: any) => {
        if (layer && layer.bringToFront) {
          try {
            layer.bringToFront();
          } catch (e) {
            // Silently fail if method unavailable
          }
        }
      });
    }
  }

  // Check if filter is applied (Corrected version)
  isFilterApplied(): boolean {
    if (this.selectedRange === 'Custom') {
      return !!(this.startDate && this.endDate);
    }
    return this.selectedRange !== 'Today';
  }

  // Get color based on data intensity
  getColorForIntensity(intensity: number): string {
    // Green (low) to Red (high) gradient
    const colors = [
      '#E8F5E9', // Very Light Green
      '#C8E6C9', // Light Green
      '#A5D6A7', // Medium Light Green
      '#81C784', // Medium Green
      '#66BB6A', // Green
      '#4CAF50', // Dark Green
      '#7CB342', // Yellow-Green
      '#FDD835', // Yellow
      '#FFCA28', // Orange
      '#FFA726'  // Light Red
    ];

    const index = Math.min(Math.floor(intensity * colors.length), colors.length - 1);
    return colors[index];
  }

  // Get display values for questions
  getDisplayTotalQuestions(): number {
    if (!this.isFilterApplied()) return 0;
    if (this.isQuestionPaperInsightFilterApplied()) {
      return this.filteredQuestionPaperInsightCounts.reduce((sum, item) => sum + (item.count || item.question_count || 0), 0);
    }
    return this.getTotalQuestions();
  }

  getDisplayActiveQuestions(): number {
    if (!this.isFilterApplied()) return 0;
    if (this.isQuestionPaperInsightFilterApplied()) {
      return this.filteredQuestionPaperInsightCounts.reduce((sum, item) => {
        return sum + (item.status_breakdown?.active || item.active || 0);
      }, 0);
    }
    return this.questionSummary?.status_summary?.active || 0;
  }

  getDisplayInactiveQuestions(): number {
    if (!this.isFilterApplied()) return 0;
    if (this.isQuestionPaperInsightFilterApplied()) {
      return this.filteredQuestionPaperInsightCounts.reduce((sum, item) => {
        return sum + (item.status_breakdown?.inactive || item.inactive || item.status_breakdown?.archived || item.archived || 0);
      }, 0);
    }
    return (this.questionSummary?.status_summary?.inactive || this.questionSummary?.status_summary?.archived || 0);
  }

  getDisplayQuestionPaperFlaggedQuestions(): number {
    if (!this.isFilterApplied()) return 0;
    if (this.isQuestionPaperInsightFilterApplied()) {
      return this.filteredQuestionPaperInsightCounts.reduce((sum, item) => {
        return sum + (item.paper_status_summary?.flagged_questions || item.flagged_questions || 0);
      }, 0);
    }
    return this.questionSummary?.paper_status_summary?.flagged_questions || this.questionSummary?.flagged_questions || 0;
  }

  // Get display value for courses count
  getDisplayCoursesCount(): number {
    return this.isFilterApplied() ? (this.questionCounts.length || 0) : 0;
  }

  // Get display value for MCQ questions
  getDisplayMCQQuestions(): number {
    return this.isFilterApplied() ? (this.questionSummary?.type_summary?.mcq || 0) : 0;
  }

  // Geographic Insights Zoom Controls (No longer used - kept for backward compatibility)
  increaseGeographicZoom(): void {
    // Zoom functionality not needed with bar chart
  }

  decreaseGeographicZoom(): void {
    // Zoom functionality not needed with bar chart
  }

  private applyGeographicZoom(): void {
    // Zoom functionality not needed with bar chart
  }

  fetchDataBasedOnRange(): void {

    this.getRevisionHistory();

    // Consolidated single request for Contents, Resources, Sales, Finances, and Geography data
    this.getConsolidatedDashboardData();

    this.getOperationsData();

    if (this.selectedViewType === 'assessment' || this.selectedViewType === 'all') {
      this.fetchCandidateAssessmentData(true);
      this.fetchPassFailData(true);
    }
  }

  getConsolidatedDashboardData() {
    this.isLoading = true;
    let { startDate, endDate } = this.formatDateRange(this.rangeType, this.startDate, this.endDate);

    this.service.getConsolidatedDashboardData({ org_id: this.org_id, start_date: startDate, end_date: endDate })
      .subscribe(
        (data: any) => {
          const response = data['body']?.['responseBody'] || data?.['responseBody'];
          if (response) {
            // 1. Process Library Data (Contents)
            if (response.contents) {
              this.processLibraryData(response.contents);
            } else {
              this.setDefaultQuestionData();
            }

            // 2. Process Resources Data
            if (response.resources) {
              const res = response.resources;
              this.usersData = (res.user_counts && res.user_counts.length > 0) ? res.user_counts : [];
              this.rolesData = (res.user_role_counts && res.user_role_counts.length > 0) ? res.user_role_counts : [];
              this.categoriesData = (res.user_categories_counts && res.user_categories_counts.length > 0) ? res.user_categories_counts : [];
            } else {
              this.usersData = [];
              this.rolesData = [];
              this.categoriesData = [];
            }

            // 3. Process Sales Data
            if (response.sales) {
              const sales = response.sales;
              this.leadsData = (sales.leads_counts && sales.leads_counts.length > 0) ? sales.leads_counts : [];
              this.customersData = (sales.customers_counts && sales.customers_counts.length > 0) ? sales.customers_counts : [];
              const totalLeadsCount = this.leadsData.reduce((sum, item) => sum + (Number(item.count) || 0), 0);
              const totalCustomersCount = this.customersData.reduce((sum, item) => sum + (Number(item.count) || 0), 0);
              this.leadCustomerData = [
                { name: 'Leads', data: [totalLeadsCount] },
                { name: 'Customers', data: [totalCustomersCount] }
              ];
            } else {
              this.leadsData = [];
              this.customersData = [];
              this.leadCustomerData = [
                { name: 'Leads', data: [0] },
                { name: 'Customers', data: [0] }
              ];
            }

            // 4. Process Finances Data
            if (response.finances) {
              const fin = response.finances;
              this.billsData = (fin.bills_count && fin.bills_count.length > 0) ? fin.bills_count : [];
              this.invoicesData = (fin.invoices_count && fin.invoices_count.length > 0) ? fin.invoices_count : [];
              this.collectedData = (fin.receipts_count && fin.receipts_count.length > 0) ? fin.receipts_count : [];
            } else {
              this.billsData = [];
              this.invoicesData = [];
              this.collectedData = [];
            }

            // 5. Process Geography Data
            if (response.geography) {
              this.geographyData = response.geography;
              this.initializeCandidateInsightsGeographyData();
            }

            this.isLoading = false;
            setTimeout(() => {
              this.cdr.detectChanges();
            }, 100);
            this.cdr.detectChanges();
          } else {
            this.setDefaultQuestionData();
            this.isLoading = false;
            this.cdr.detectChanges();
          }
        },
        (error) => {
          this.setDefaultQuestionData();
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      );
  }
  // This function is called whenever the startDate or endDate changes
  onDateChange(): void {
    if (this.startDate && this.endDate) {
      // Both startDate and endDate must be selected before calling the function
      this.fetchDataBasedOnRange();
      this.cdr.detectChanges();
    }
  }

  /*toggleSection(index: number): void {
    this.openSection = this.openSection === index ? null : index;
    this.fetchDataBasedOnRange();
    this.cdr.detectChanges();
  }*/

  ngOnDestroy(): void {
    if (this.socketSub) {
      this.socketSub.unsubscribe();
    }
    if (this.difficultyChart) {
      this.difficultyChart.destroy();
    }
    // ADD: Destroy language bar chart
    if (this.languageBarChart) {
      this.languageBarChart.destroy();
    }
    // Dispose EChart instance
    if (this.geographicInsightsChart) {
      if (typeof this.geographicInsightsChart.dispose === 'function') {
        this.geographicInsightsChart.dispose();
      } else if (typeof this.geographicInsightsChart.remove === 'function') {
        this.geographicInsightsChart.remove();
      }
      this.geographicInsightsChart = null;
    }
    this.cdr.detach();
    // Remove window resize listener
    window.removeEventListener('resize', () => {
      if (this.geographicInsightsChart) {
        this.geographicInsightsChart.resize();
      }
    });
  }
  // Tab Selection Logic
  selectTab(tab: string) {
    this.selectedTab = tab; // Set the active tab by title
    this.getRevisionHistory();
    this.cdr.detectChanges();
  }

  formatDateRange(rangeType: string, customStartDate: Date | null = null, customEndDate: Date | null = null): { startDate: string; endDate: string } {
    let startDate: string, endDate: string;
    const today = moment().format('YYYY-MM-DD');

    // Convert rangeType to lowercase for case-insensitive comparison
    const normalizedRangeType = rangeType.toLowerCase();

    switch (normalizedRangeType) {
      case 'this month':
        startDate = moment().startOf('month').format('YYYY-MM-DD') + ' 00:00:00';
        endDate = today + ' 23:59:59';
        break;
      case 'last 30 days':
        startDate = moment().subtract(29, 'days').format('YYYY-MM-DD') + ' 00:00:00';
        endDate = today + ' 23:59:59';
        break;
      case 'last 6 months':
        startDate = moment().subtract(6, 'months').format('YYYY-MM-DD') + ' 00:00:00';
        endDate = today + ' 23:59:59';
        break;
      case 'last 1 year':
        startDate = moment().subtract(1, 'year').format('YYYY-MM-DD') + ' 00:00:00';
        endDate = today + ' 23:59:59';
        break;
      case 'today':
        startDate = today + ' 00:00:00';
        endDate = today + ' 23:59:59';
        break;
      case 'last 7 days':
        startDate = moment().subtract(6, 'days').format('YYYY-MM-DD') + ' 00:00:00';
        endDate = today + ' 23:59:59';
        break;
      case 'custom':
        if (customStartDate && customEndDate) {
          startDate = moment(customStartDate).format('YYYY-MM-DD') + ' 00:00:00';
          endDate = moment(customEndDate).format('YYYY-MM-DD') + ' 23:59:59';
        } else {
          throw new Error("For custom range, both startDate and endDate must be provided.");
        }
        break;
      default:
        throw new Error(`Invalid rangeType: "${rangeType}". Valid options are: 'This month', 'Last 30 days', 'Last 6 months', 'Last 1 year', 'Custom'.`);
    }

    return { startDate, endDate };
  }


  get displayedColumns() {
    // Dynamically filter the columns based on the selectedTab
    return this.selectedTab === 'My Updates'
      ? ASSESSMENT_PLAN_TABLE_COLUMNS.filter(
        (column) => column.dataKey !== 'changedBy'
      )
      : ASSESSMENT_PLAN_TABLE_COLUMNS;
  }

  // Add this method to format JSON data into readable format
  formatStateData(stateData: any): string {
    if (!stateData || stateData === '-') return '-';

    try {
      const data = typeof stateData === 'string' ? JSON.parse(stateData) : stateData;
      if (!data || typeof data !== 'object') return stateData;

      let formatted = '';
      for (const [key, value] of Object.entries(data)) {
        // Skip fields that are just IDs
        if (
          key.toLowerCase().endsWith('_id') ||
          key.toLowerCase().includes('id') && !key.toLowerCase().includes('name')
        ) {
          continue; // Skip this field
        }
        // Optionally, you can whitelist some fields to always show
        // if (['organization_id', ...].includes(key)) continue;

        const formattedKey = this.formatFieldName(key);
        const formattedValue = this.formatValue(key, value);

        // Only add the field if it has a meaningful value (not just "None")
        if (formattedValue !== 'None') {
          formatted += `${formattedKey}: ${formattedValue}\n`;
        }
      }
      return formatted.trim();
    } catch (e) {
      return stateData; // Return original if parsing fails
    }
  }

  hasLibrarySection(): boolean {
    return this.sections.some(section => section.title === 'Library');
  }
  // Helper method to format field names (similar to ng-vertical-timeline)
  formatFieldName(field: string): string {
    return field.replace(/_/g, ' ').replace(/(?:^|\s)\S/g, a => a.toUpperCase());
  }

  // Helper method to format trend values with +/- signs
  formatTrendValue(value: number): string {
    if (value > 0) {
      return `+${value}`;
    } else if (value < 0) {
      return `${value}`;
    }
    return '0';
  }

  // Helper method to format values (similar to ng-vertical-timeline)
  formatValue(field: string, value: any): string {
    if (value === null || value === undefined || value === '') return 'None';

    // Handle boolean values
    if (field.toLowerCase().includes('is_') || field.toLowerCase().includes('active')) {
      return value ? 'Yes' : 'No';
    }

    // Handle date/datetime fields
    if (field.toLowerCase().includes('date') || field.toLowerCase().includes('datetime')) {
      try {
        return new Date(value).toLocaleString();
      } catch (e) {
        return value;
      }
    }

    // Handle arrays
    if (Array.isArray(value)) {
      if (value.length === 0) return 'None';
      // If array of objects, pretty print each object
      if (value.length > 0 && typeof value[0] === 'object') {
        return value.map(v => this.objectToKeyValueString(v)).join('\n\n');
      }
      return value.join(', ');
    }

    // Handle objects
    if (typeof value === 'object') {
      const formatted = this.objectToKeyValueString(value);
      // If the formatted result is just "None", return "None"
      if (formatted.trim() === 'None') return 'None';
      return formatted;
    }

    return value.toString();
  }

  // Helper function to format object as key: value (no quotes)
  objectToKeyValueString(obj: any, indent: string = ''): string {
    if (Array.isArray(obj)) {
      if (obj.length === 0) return 'None';
      return obj.map((item, idx) =>
        `${indent}- ${this.objectToKeyValueString(item, indent + '  ')}`
      ).join('\n');
    } else if (typeof obj === 'object' && obj !== null) {
      return Object.entries(obj)
        .map(([k, v]) => {
          if (typeof v === 'object' && v !== null) {
            return `${indent}${this.formatFieldName(k)}:\n${this.objectToKeyValueString(v, indent + '  ')}`;
          } else {
            return `${indent}${this.formatFieldName(k)}: ${v === null || v === '' ? 'None' : v}`;
          }
        })
        .join('\n');
    } else {
      return obj === null || obj === '' ? 'None' : obj.toString();
    }
  }


  getChangedFields(oldState: any, newState: any): { [key: string]: any } {
    const oldObj = typeof oldState === 'string' ? JSON.parse(oldState) : oldState || {};
    const newObj = typeof newState === 'string' ? JSON.parse(newState) : newState || {};
    const changed: { [key: string]: any } = {};

    for (const key of Object.keys(newObj)) {
      // Skip IDs as before
      if (
        key.toLowerCase().endsWith('_id') ||
        (key.toLowerCase().includes('id') && !key.toLowerCase().includes('name'))
      ) {
        continue;
      }
      // Only include if value changed
      if ((oldObj?.[key] ?? null) !== (newObj?.[key] ?? null)) {
        changed[key] = newObj[key];
      }
    }
    return changed;
  }
  showCourseDropdown: boolean = false;
  selectedCourse: any = null;
  difficultyChart: Chart;


  getRevisionHistory() {
    // Show loading state
    this.isLoading = true;

    let { startDate, endDate } = this.formatDateRange(this.rangeType, this.startDate, this.endDate);
    // Fetch revision history data from the service
    const resp = this.service.getRevisionHistory({ org_id: this.org_id, user_id: this.user_id, start_date: startDate, end_date: endDate });
    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          // Process orgRevisionHistory
          this.orgUpdatesData = (response.orgRevisionHistory && response.orgRevisionHistory.length > 0)
            ? response.orgRevisionHistory
              .sort((a, b) => new Date(b.action_timestamp).getTime() - new Date(a.action_timestamp).getTime())
              .map((history, index) => {
                const changedFields = this.getChangedFields(history.old_values, history.new_values);
                return {
                  sno: index + 1,
                  module: history.table_name,
                  action: history.action === 'i' ? 'Insert' : history.action === 'u' ? 'Update' : 'Delete',
                  changedBy: history.modified_user_fullname || '-',
                  previousState: this.formatStateData(
                    Object.fromEntries(Object.entries(history.old_values || {}).filter(([k]) => k in changedFields))
                  ),
                  currentState: this.formatStateData(changedFields),
                  // modifiedDate: new Date(history.action_timestamp).toLocaleDateString()
                  modifiedDate: moment(history.action_timestamp).format('DD MMM YYYY')
                };
              })
            : [];



          // Process userRevisionHistory
          this.myUpdatesData = (response.userRevisionHistory && response.userRevisionHistory.length > 0)
            ? response.userRevisionHistory
              .sort((a, b) => new Date(b.action_timestamp).getTime() - new Date(a.action_timestamp).getTime())
              .map((history, index) => {
                const changedFields = this.getChangedFields(history.old_values, history.new_values);
                return {
                  sno: index + 1,
                  module: history.table_name,
                  action: history.action === 'i' ? 'Insert' : history.action === 'u' ? 'Update' : 'Delete',
                  previousState: this.formatStateData(
                    Object.fromEntries(Object.entries(history.old_values || {}).filter(([k]) => k in changedFields))
                  ),
                  currentState: this.formatStateData(changedFields),
                  // modifiedDate: new Date(history.action_timestamp).toLocaleDateString()
                  modifiedDate: moment(history.action_timestamp).format('DD MMM YYYY')
                };
              })
            : [];
          this.isLoading = false; // Hide loading state
          this.cdr.detectChanges();
        } else {
          this.orgUpdatesData = [];
          this.myUpdatesData = [];
        }
      },
      (error) => {
        this.isLoading = false; // Hide loading state
        this.orgUpdatesData = [];
        this.myUpdatesData = [];
      }
    );
  }

  getResourcesData() {
    // Show loading state
    this.isLoading = true;

    let { startDate, endDate } = this.formatDateRange(this.rangeType, this.startDate, this.endDate);
    // Fetch revision history data from the service
    const resp = this.service.getResourcesData({ org_id: this.org_id, start_date: startDate, end_date: endDate });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          // Process roles
          this.usersData = (response.user_counts && response.user_counts.length > 0)
            ? response.user_counts
            : [];

          // Process categories
          this.rolesData = (response.user_role_counts && response.user_role_counts.length > 0)
            ? response.user_role_counts
            : [];

          // Process users
          this.categoriesData = (response.user_categories_counts && response.user_categories_counts.length > 0)
            ? response.user_categories_counts
            : [];
          this.isLoading = false;
          this.cdr.detectChanges();
        } else {
          this.rolesData = [];
          this.categoriesData = [];
          this.rolesData = [];
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.isLoading = false; // Hide loading state
        this.rolesData = [];
        this.categoriesData = [];
        this.rolesData = [];
      }
    );
  }

  getOperationsData() {
    // Show loading state
    this.isLoading = true;

    // Ensure org_id is properly converted to integer
    const orgIdAsInt = this.org_id ? parseInt(this.org_id, 10) : null;
    
    if (!orgIdAsInt) {
      console.error('Organization ID is not set. Cannot fetch operations data.');
      this.isLoading = false;
      return;
    }

    let { startDate, endDate } = this.formatDateRange(this.rangeType, this.startDate, this.endDate);
    const requestPayload: any = {
      org_id: orgIdAsInt,
      start_date: startDate,
      end_date: endDate
    };

    if (this.rangeType === 'This month' || this.rangeType === 'Today') {
      requestPayload.selected_month = this.selectedDateFilterMonth;
      requestPayload.selected_year = this.selectedDateFilterYear;
    }

    console.log('Fetching operations data with:', {
      org_id: orgIdAsInt,
      startDate,
      endDate,
      selectedRange: this.selectedRange
    });

    const resp = this.service.getOperationsData(requestPayload);

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        //   console.log('Operations data received:', response?.operationsData);
        if (response) {
          // Cache the operations data for filtering
          this.cachedOperationsDataResponse = response.operationsData;
          
          // Store raw assessment details for customer filtering
          this.rawAssessmentDetails = response.operationsData.assessment_details || [];
          this.assessmentWiseStats = response.operationsData.assessment_wise_stats || [];
          this.rawTop5CustomersByAssessment = response.operationsData.top_5_customers_by_assessment || null;
          
          // Store assessment_wise for language processing
          this.rawAssessmentWise = response.operationsData.pass_fail?.assessment_wise || [];
          
          // Process candidates
          this.candidatesData = (response.operationsData.candidates_counts && response.operationsData.candidates_counts.length > 0) ? response.operationsData.candidates_counts : [];

          // Process assessments
          this.assessmentsData = (response.operationsData.assessments_counts && response.operationsData.assessments_counts.length > 0) ? response.operationsData.assessments_counts : [];

          // Process Assessment Summary Data
          if (response.operationsData) {
            this.totalAssessments = response.operationsData.total_assessments || 0;
            this.totalCandidates = response.operationsData.total_candidates || 0;
            this.totalPlannedAssessments = response.operationsData.total_planned_assessments || 0;
            this.totalExecutedAssessments = response.operationsData.total_executed_assessments || 0;
            this.totalEvaluatedAssessments = response.operationsData.total_evaluated_assessments || 0;
            this.totalPublishedAssessments = response.operationsData.total_published_assessments || 0;
            this.currentMonthPlannedAssessments = response.operationsData.planned_this_month || 0;
            this.nextMonthPlannedAssessments = response.operationsData.planned_next_month || 0;
            this.lastMonthPlannedAssessments = response.operationsData.last_month_planned_assessments || 0;
            
            // Update candidate insights data
            let computedPass = response.operationsData.total_pass_candidates;
            let computedFail = response.operationsData.total_fail_candidates;
            
            if (computedPass === undefined || computedPass === null || computedFail === undefined || computedFail === null) {
              computedPass = 0;
              computedFail = 0;
              if (response.operationsData.course_wise_pass_fail_stats && Array.isArray(response.operationsData.course_wise_pass_fail_stats)) {
                response.operationsData.course_wise_pass_fail_stats.forEach((stat: any) => {
                  computedPass += stat.pass_count || 0;
                  computedFail += stat.fail_count || 0;
                });
              } else if (response.operationsData.state_wise_pass_fail_stats && Array.isArray(response.operationsData.state_wise_pass_fail_stats)) {
                response.operationsData.state_wise_pass_fail_stats.forEach((stat: any) => {
                  computedPass += stat.pass_count || 0;
                  computedFail += stat.fail_count || 0;
                });
              }
            }
            
            this.totalAttempts = response.operationsData.total_attempts || (computedPass + computedFail);
            this.totalPassCandidates = computedPass;
            this.totalFailCandidates = computedFail;
            let computedReassessed = 0;
            if (response.operationsData.reassessment_stats && Array.isArray(response.operationsData.reassessment_stats)) {
              const overallStat = response.operationsData.reassessment_stats.find(
                (stat: any) => (stat.course_name === 'All Courses' && stat.customer_name === 'Overall') ||
                               (stat.course_name?.toLowerCase() === 'all courses' && stat.customer_name?.toLowerCase() === 'overall')
              );
              if (overallStat) {
                computedReassessed = overallStat.reassessed_count || 0;
              } else {
                // Fallback: sum all if there's no overall entry
                response.operationsData.reassessment_stats.forEach((stat: any) => {
                  if (stat.course_name !== 'All Courses') {
                    computedReassessed += stat.reassessed_count || 0;
                  }
                });
              }
            } else {
              computedReassessed = response.operationsData.reassessed_count || 0;
            }
            this.totalReassessedCandidates = computedReassessed;
            
            // Store original values for filtering
            this.originalTotalAttempts = this.totalAttempts;
            this.originalTotalPassCandidates = this.totalPassCandidates;
            this.originalTotalFailCandidates = this.totalFailCandidates;
            this.originalTotalReassessedCandidates = this.totalReassessedCandidates;
            
            this.currentMonthReassessed = response.operationsData.current_month_reassessed || 0;
            this.lastMonthReassessed = response.operationsData.last_month_reassessed || 0;
            
            // Initialize candidate insights donut chart with delay
            setTimeout(() => {
              this.initializeCandidateInsightsDonutChart();
            }, 0);
            //  console.log('Updated assessment summary:', { totalAssessments: this.totalAssessments, totalCandidates: this.totalCandidates });

            // Update assessment status summary
            if (response.operationsData.assessment_status) {
              this.assessmentStatusSummary = {
                active: response.operationsData.assessment_status.active || 0,
                inactive: response.operationsData.assessment_status.inactive || 0,
                deleted: response.operationsData.assessment_status.deleted || 0,
                publish: response.operationsData.assessment_status.publish || 0,
                draft: response.operationsData.assessment_status.draft || 0
              };
            }

            // Update candidate status summary
            if (response.operationsData.candidate_status) {
              this.candidateStatusSummary = {
                active: response.operationsData.candidate_status.active || 0,
                inactive: response.operationsData.candidate_status.inactive || 0,
                deleted: response.operationsData.candidate_status.deleted || 0
              };
            }

            // Update evaluation status summary
            if (response.operationsData.evaluation_status) {
              this.evaluationStatusSummary = {
                completed: response.operationsData.evaluation_status.completed || 0,
                pending: response.operationsData.evaluation_status.pending || 0
              };
            }

            // Process Assessment Location Data
            if (response.operationsData.top_states && response.operationsData.top_states.length > 0) {
              const colors = [
                '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
                '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9', '#F8B195'
              ];
              this.allAssessmentLocations = response.operationsData.top_states.map((location: any, index: number) => ({
                ...location,
                id: location.id || index
              }));
              this.filteredAssessmentLocationList = [...this.allAssessmentLocations];
              this.assessmentLocationChartData = this.allAssessmentLocations.map((location: any, index: number) => ({
                name: location.state || 'Unknown',
                value: location.count || 0,
                color: colors[index % colors.length]
              }));
              this.selectedAssessmentLocationFilterValues = [];
              this.showAssessmentLocationChart = this.assessmentLocationChartData.length > 0;
              setTimeout(() => {
                if (this.showAssessmentLocationChart && document.getElementById('assessmentLocationChart')) {
                  this.initializeAssessmentLocationBarChart();
                }
              }, 0);
            }

            // Process Assessment Course Data
            const coursesData = response.operationsData.top_5_courses_by_assessment || response.operationsData.top_10_courses || response.operationsData.all_courses;
            if (coursesData && coursesData.length > 0) {
              // Normalize data before processing
              const normalizedCourses = coursesData.map((course: any, index: number) => ({
                ...course,
                id: index,
                course: course.course_name || course.course || course.assessment_title || 'Unknown',
                count: course.assessment_count || course.count || 0,
                course_id: course.course_id || index
              }));

              // Process courses - top 5 + Others
              const processedCourses = this.processAssessmentCoursesToTop5WithOthers(normalizedCourses);
              
              const courseColors = [
                '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8',
                '#F7DC6F', '#BB8FCE', '#85C1E9', '#F8B195', '#D7BDE2'
              ];
              
              this.allAssessmentCourses = processedCourses;
              this.filteredAssessmentCourseList = [...this.allAssessmentCourses];
              this.assessmentCourseChartData = this.allAssessmentCourses.map((course: any, index: number) => ({
                name: course.course || 'Unknown',
                value: course.count || 0,
                color: courseColors[index % courseColors.length]
              }));
              this.selectedAssessmentCourseFilterValues = [];
              this.showAssessmentCourseChart = this.assessmentCourseChartData.length > 0;
              setTimeout(() => {
                if (this.showAssessmentCourseChart && document.getElementById('assessmentCourseChart')) {
                  this.initializeAssessmentCourseBarChart();
                }
              }, 200);
            }

            // Process Assessment Insights Filter Data (All Courses without counts)
            if (response.operationsData.all_courses && response.operationsData.all_courses.length > 0) {
              // Extract unique course names (no counts in filter display)
              this.allAssessmentInsightCourses = response.operationsData.all_courses.map((course: any, index: number) => ({
                course: course.course || 'Unknown',
                id: index
              }));
              this.filteredAssessmentInsightCourseList = [...this.allAssessmentInsightCourses];
              this.selectedAssessmentInsightCourseValues = [];
              
              // Sync Candidate Insights courses with Assessment Insights courses
              this.allCandidateInsightCourses = [...this.allAssessmentInsightCourses];
              this.filteredCandidateInsightCourseList = [...this.allAssessmentInsightCourses];
            } else if (response.operationsData.top_5_courses_by_assessment && response.operationsData.top_5_courses_by_assessment.length > 0) {
              // Fallback to top_5_courses_by_assessment if all_courses not available
              this.allAssessmentInsightCourses = response.operationsData.top_5_courses_by_assessment.map((course: any, index: number) => ({
                course: course.course_name || 'Unknown',
                id: index
              }));
              this.filteredAssessmentInsightCourseList = [...this.allAssessmentInsightCourses];
              this.selectedAssessmentInsightCourseValues = [];
              
              // Sync Candidate Insights courses with Assessment Insights courses (from top_5_courses_by_assessment fallback)
              this.allCandidateInsightCourses = [...this.allAssessmentInsightCourses];
              this.filteredCandidateInsightCourseList = [...this.allAssessmentInsightCourses];
            }

            // Extract unique states from raw assessment data for geography filtering
            if (this.rawAssessmentDataWithStateInfo && this.rawAssessmentDataWithStateInfo.length > 0) {
              const uniqueStates = new Set<string>();
              
              this.rawAssessmentDataWithStateInfo.forEach((assessment: any) => {
                if (assessment.state_wise_candidates) {
                  Object.keys(assessment.state_wise_candidates).forEach(state => {
                    if (state && state.trim()) {
                      // Normalize state name: trim and standardize spacing
                      const normalizedState = state.trim().replace(/\s+/g, ' ');
                      uniqueStates.add(normalizedState);
                    }
                  });
                }
              });
              
              // Convert set to array sorted alphabetically
              const sortedStates = Array.from(uniqueStates).sort();
              this.allCandidateInsightGeographies = sortedStates.map((state: string, index: number) => ({
                state: state,
                id: index
              }));
              
              this.filteredCandidateInsightGeographyList = [...this.allCandidateInsightGeographies];
              this.allGeographicInsightGeographies = [...this.allCandidateInsightGeographies];
              this.filteredGeographicInsightGeographyList = [...this.allCandidateInsightGeographies];
            }

            // Process Assessment Status Data
            if (this.assessmentStatusSummary) {
              // Active/Inactive/Deleted Status
              const statusData = [
                { id: 'planned', name: 'Planned', value: response.operationsData?.total_planned_assessments || 0, color: '#C61F1E' },
                { id: 'executed', name: 'Executed', value: response.operationsData?.total_executed_assessments || 0, color: '#0A68A6' },
                { id: 'evaluated', name: 'Evaluated', value: response.operationsData?.total_evaluated_assessments || 0, color: '#FDBF48' },
                { id: 'published', name: 'Published', value: response.operationsData?.total_published_assessments || 0, color: '#279A81' }
              ];

              // Publish/Draft Status
              const publishStatusData = [
                { id: 'published', name: 'Published', value: this.assessmentStatusSummary.publish || 0, color: '#2196F3' },
                { id: 'draft', name: 'Draft', value: this.assessmentStatusSummary.draft || 0, color: '#9C27B0' }
              ];

              this.allAssessmentStatuses = statusData;
              this.filteredAssessmentStatusList = [...statusData];
              this.assessmentStatusChartData = statusData;
              this.allAssessmentPublishStatuses = publishStatusData;
              this.filteredAssessmentPublishList = [...publishStatusData];
              this.selectedAssessmentStatusFilterValues = [];
              this.selectedAssessmentPublishFilterValues = [];
              // Show chart container if there is any status (always true for 3 statuses)
              this.showAssessmentStatusChart = true;
            }

            // Process Assessment Evaluation Data - Show Planned, Executed, Evaluated, Published
            const evaluationData = [
              { id: 'planned', name: 'Planned', value: this.currentMonthPlannedAssessments || this.totalPlannedAssessments || 0, color: '#C61F1E' },
              { id: 'executed', name: 'Executed', value: this.totalExecutedAssessments || 0, color: '#0A68A6' },
              { id: 'evaluated', name: 'Evaluated', value: this.totalEvaluatedAssessments || 0, color: '#FDBF48' },
              { id: 'published', name: 'Published', value: this.totalPublishedAssessments || 0, color: '#FFFDD0' }
            ];

            this.allAssessmentEvaluations = evaluationData;
            this.filteredAssessmentEvaluationList = [...evaluationData];
            this.assessmentEvaluationChartData = evaluationData;
            this.selectedAssessmentEvaluationFilterValues = [];
            this.showAssessmentEvaluationChart = this.assessmentEvaluationChartData.some(item => (item && item.value) ? item.value > 0 : false);
            setTimeout(() => {
              if (this.showAssessmentEvaluationChart && document.getElementById('assessmentEvaluationChart')) {
                this.initializeAssessmentEvaluationPieChart();
              }
            }, 200);

            // Process Candidate Assessment Distribution Data
            if (response.operationsData && ((response.operationsData.pass_fail && response.operationsData.pass_fail.assessment_wise) || response.operationsData.top_5_courses_by_assessment)) {
              // Store raw assessment data with state-wise information for geography filtering
              this.rawAssessmentDataWithStateInfo = response.operationsData.top_5_courses_by_assessment || response.operationsData.pass_fail?.assessment_wise;
              
              const candidateColors = [
                '#3498DB', '#E74C3C', '#2ECC71', '#F39C12', '#9B59B6',
                '#1ABC9C', '#34495E', '#E67E22', '#95A5A6', '#D35400'
              ];
              
              let assessmentData: any[] = [];
              if (response.operationsData.top_5_courses_by_assessment && response.operationsData.top_5_courses_by_assessment.length > 0) {
                assessmentData = response.operationsData.top_5_courses_by_assessment.map((course: any, index: number) => ({
                  name: course.course_name || 'Unknown Course',
                  value: course.total_candidates || 0,
                  assessment_id: course.course_name,
                  assessment_name: course.course_name || 'Unknown Course',
                  color: candidateColors[index % candidateColors.length]
                }));
              } else {
                assessmentData = response.operationsData.pass_fail.assessment_wise.map((assessment: any, index: number) => ({
                  name: assessment.assessment_title || assessment.assessment_name || `Assessment ${assessment.assessment_id}`,
                  value: assessment.candidate_count,
                  assessment_id: assessment.assessment_id,
                  assessment_name: assessment.assessment_title || assessment.assessment_name,
                  color: candidateColors[index % candidateColors.length]
                }));
              }

              // Create overall candidates entry
              const totalCandidatesValue = response.operationsData.total_candidates || 0;
              const overallEntry = {
                name: 'Overall',
                value: totalCandidatesValue,
                is_overall: true,
                color: candidateColors[0]
              };

              this.allCandidateAssessments = [overallEntry, ...assessmentData];
              this.filteredCandidateAssessmentList = [overallEntry, ...assessmentData];
              this.candidateAssessmentChartData = assessmentData.length > 0 ? assessmentData : [overallEntry]; // Show courses instead of overall
              this.showCandidateAssessmentChart = this.candidateAssessmentChartData.length > 0;

              // Refresh Candidate Performance chart data for the current date range
              if (response.operationsData.candidate_data_by_performance && Array.isArray(response.operationsData.candidate_data_by_performance)) {
                this.processCandidatePerformanceData({ candidate_data_by_performance: response.operationsData.candidate_data_by_performance });
              } else {
                this.processCandidatePerformanceData(response.operationsData.pass_fail);
              }
            }
          }

          // Initialize Pass/Fail Chart Data
          if (response.operationsData.pass_fail) {
            const passFailData = response.operationsData.pass_fail;
            this.rawPassFailAssessmentWise = passFailData.assessment_wise || [];
            const passFailColors = ['#2196F3', '#F44336']; // Pass: Blue, Fail: Red

            // Create overall pass/fail entry
            const overallPassFailEntry = {
              name: 'Overall',
              pass_percent: passFailData.overall_pass_percent || 0,
              fail_percent: passFailData.overall_fail_percent || 0,
              pass: Math.round((passFailData.overall_pass_percent || 0) / 100 * 100), // For display if needed
              fail: Math.round((passFailData.overall_fail_percent || 0) / 100 * 100),
              is_overall: true,
              color: passFailColors[0]
            };

            // Create assessment-wise pass/fail entries
            const assessmentPassFailData = (passFailData.assessment_wise || []).map((assessment: any, index: number) => ({
              name: assessment.assessment_name || `Assessment ${assessment.assessment_id}`,
              assessment_id: assessment.assessment_id,
              pass: assessment.pass_count || 0,
              fail: assessment.fail_count || 0,
              candidate_count: assessment.candidate_count || 0,
              color: passFailColors[index % passFailColors.length]
            }));

            this.allPassFailAssessments = [overallPassFailEntry, ...assessmentPassFailData];
            this.filteredPassFailAssessmentList = [overallPassFailEntry, ...assessmentPassFailData];
            this.passFailChartData = [overallPassFailEntry]; // Show only overall initially
            this.showPassFailChart = this.passFailChartData.length > 0;
            setTimeout(() => {
              if (this.showPassFailChart && document.getElementById('passFailChart')) {
                this.initializePassFailDoughnutChart();
              }
            }, 0);
          }

          // Process State-wise Distribution for Geographic Map (Candidates & Assessments combined)
          const uniqueStatesMap = new Map<string, { candidates: number, assessments: number }>();
          
          const normalizeState = (rawState: string) => this.normalizeGeographicState(rawState);

          if (response.operationsData.state_wise_candidate_count && response.operationsData.state_wise_candidate_count.length > 0) {
             response.operationsData.state_wise_candidate_count.forEach((item: any) => {
                const state = normalizeState(item.state);
                if (state) {
                   const existing = uniqueStatesMap.get(state) || { candidates: 0, assessments: 0 };
                   existing.candidates += item.count || 0;
                   uniqueStatesMap.set(state, existing);
                }
             });
          }

          if (response.operationsData.state_wise_assessment_count && response.operationsData.state_wise_assessment_count.length > 0) {
             response.operationsData.state_wise_assessment_count.forEach((item: any) => {
                const state = normalizeState(item.state);
                if (state) {
                   const existing = uniqueStatesMap.get(state) || { candidates: 0, assessments: 0 };
                   existing.assessments += item.count || 0;
                   uniqueStatesMap.set(state, existing);
                }
             });
          }

          this.geographicInsightsData = Array.from(uniqueStatesMap.entries()).map(([state, counts]) => {
             return {
                state: state,
                candidates: counts.candidates,
                assessments: counts.assessments,
                original_state: state
             };
          });

          if (this.geographicInsightsData.length > 0) {
            this.showGeographicInsightsChart = true;
            setTimeout(() => {
              this.initializeGeographicChart();
            }, 0);
          }

          // Process assessments violations
          this.violationsData = (response.violationsData && response.violationsData.violation_count)
            ? [
              { name: 'Violation Count', data: [response.violationsData.violation_count] },
            ]
            : [
              { name: 'Violation Count', data: [0] },
            ];

          this.isLoading = false;
          this.lastDataFetchTimestamp = Date.now(); // Record timestamp for cache optimization
          this.cdr.detectChanges();

          // Initialize assessment charts - always initialize since they're in all views
          setTimeout(() => {
            if (this.showAssessmentLocationChart && document.getElementById('assessmentLocationChart')) {
              this.initializeAssessmentLocationBarChart();
            }
            if (this.showAssessmentCourseChart && document.getElementById('assessmentCourseChart')) {
              this.initializeAssessmentCourseBarChart();
            }
            if (this.showAssessmentStatusChart && document.getElementById('assessmentStatusChart')) {
              this.initializeAssessmentStatusDoughnutChart();
            }
            if (this.showAssessmentEvaluationChart && document.getElementById('assessmentEvaluationChart')) {
              this.initializeAssessmentEvaluationPieChart();
            }
            if (this.showCandidateAssessmentChart && document.getElementById('candidateAssessmentChart')) {
              this.initializeCandidateAssessmentPieChart();
            }
            if (this.showPassFailChart && document.getElementById('passFailChart')) {
              this.initializePassFailDoughnutChart();
            }
          }, 0);
        } else {
          this.candidatesData = [];
          this.assessmentsData = [];
          this.resetAssessmentSummary();
          this.violationsData = [
            { name: 'Violation Count', data: [0] },
          ];
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.isLoading = false; // Hide loading state
        this.candidatesData = [];
        this.assessmentsData = [];
        this.resetAssessmentSummary();
        this.violationsData = [
          { name: 'Violation Count', data: [0] },
        ];
      }
    );
  }

  getGeographyData(forceRefresh = false) {
    if (!forceRefresh && this.geographyData && Object.keys(this.geographyData).length > 0) {
      this.initializeCandidateInsightsGeographyData();
      return;
    }
    // Fetch geography data (states and districts)
    const resp = this.service.getGeography({});

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          console.log('Geography data received:', response);
          // Store geography data for use in dropdowns and filters
          // The response is directly the geography data object with states as keys and districts as values
          this.geographyData = response;
          // Initialize candidate insights geography filter with state names
          this.initializeCandidateInsightsGeographyData();
          this.cdr.detectChanges();
        }
      },
      (error) => {
        console.error('Error fetching geography data:', error);
      }
    );
  }

  initializeCandidateInsightsGeographyData(): void {
    // Extract state names from geography data and populate the filter list
    if (this.geographyData) {
      // Get all state names from the geographyData object (keys are state names)
      const stateNames = Object.keys(this.geographyData);
      // Create an array of objects with state name for the filter
      this.allCandidateInsightGeographies = stateNames.map(state => ({
        geography: state,
        state: state
      }));
      // Initialize filtered lists for Candidate Insights and Geographic Insights
      this.filteredCandidateInsightGeographyList = [...this.allCandidateInsightGeographies];
      this.allGeographicInsightGeographies = [...this.allCandidateInsightGeographies];
      this.filteredGeographicInsightGeographyList = [...this.allCandidateInsightGeographies];
      // Initialize for Pass/Fail (Candidate Data by Assessment) filter
      this.allPassFailGeographies = [...this.allCandidateInsightGeographies];
      this.filteredPassFailGeographyList = [...this.allCandidateInsightGeographies];
      // Initialize for Candidate Performance filter
      this.allCandidatePerformanceGeographies = [...this.allCandidateInsightGeographies];
      this.filteredCandidatePerformanceGeographyList = [...this.allCandidateInsightGeographies];
      // Initialize for Question Paper Insights filter
      this.allQuestionPaperInsightGeographies = [...this.allCandidateInsightGeographies];
      this.filteredQuestionPaperInsightGeographyList = [...this.allCandidateInsightGeographies];
    }
  }

  getCoursesMasterData(forceRefresh = false) {
    if (!forceRefresh && this.coursesData && this.coursesData.length > 0) {
      return;
    }
    // Fetch courses master data
    const resp = this.service.getCoursesMasterData({ org_id: this.org_id });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.coursesMaster) {
          console.log('Courses master data received:', response.coursesMaster);
          
          // Remove duplicate courses based on name
          const uniqueCourses = Array.from(
            new Map(response.coursesMaster.map((course: any) => [course.name, course])).values()
          );
          
          // Store courses data for use in dropdowns and filters (cast as any since API structure differs from typed structure)
          this.coursesData = uniqueCourses as any;
          // Initialize filtered courses list for Assessment Insights filter
          this.filteredAssessmentInsightCourseApiList = [...this.coursesData];
          // Initialize filtered courses list for Candidate Insights filter
          this.filteredCandidateInsightCourseApiList = [...this.coursesData];
          // Initialize filtered courses list for Geographic Insights filter
          this.filteredGeographicInsightCourseApiList = [...this.coursesData];
          // Initialize filtered courses list for Candidate Performance filter
          this.filteredCandidatePerformanceCourseApiList = [...this.coursesData];
          // Initialize filtered courses list for Question Paper Insights filter
          this.filteredQuestionPaperInsightCourseApiList = [...this.coursesData];
          console.log('Deduplicated courses:', this.coursesData.length, 'from', response.coursesMaster.length);
          this.cdr.detectChanges();
        }
      },
      (error) => {
        console.error('Error fetching courses master data:', error);
      }
    );
  }

  getLanguagesMasterData(forceRefresh = false) {
    if (!forceRefresh && this.languagesData && this.languagesData.length > 0) {
      return;
    }
    // Fetch languages master data
    const resp = this.service.getLanguagesMasterData({});

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.languagesMaster) {
          console.log('Languages master data received:', response.languagesMaster);
          // Store languages data for use in dropdowns and filters
          this.languagesData = response.languagesMaster;
          // Initialize filtered languages list with all languages
          this.filteredAssessmentInsightLanguagesList = [...this.languagesData];
          this.filteredAssessmentCourseLanguageList = [...this.languagesData];
          this.filteredDifficultyLanguagesList = [...this.languagesData];
          this.filteredTypeLanguagesList = [...this.languagesData];
          // Initialize for Pass/Fail (Candidate Data by Assessment) filter
          this.allPassFailLanguages = [...this.languagesData];
          this.filteredPassFailLanguageList = [...this.languagesData];
          // Initialize filtered languages list for Candidate Performance filter
          this.filteredCandidatePerformanceLanguageList = [...this.languagesData];
          this.cdr.detectChanges();
        }
      },
      (error) => {
        console.error('Error fetching languages master data:', error);
      }
    );
  }

  getSalesCustomerMasterData(forceRefresh = false) {
    if (!forceRefresh && this.customerMasterData && this.customerMasterData.length > 0) {
      return;
    }
    // Fetch sales customer master data
    const resp = this.service.getSalesCustomerMasterData({ org_id: this.org_id });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.customersMaster) {
          console.log('Sales customers master data received:', response.customersMaster);
          
          // Remove duplicate customers based on name
          const uniqueCustomers = Array.from(
            new Map(response.customersMaster.map((customer: any) => [customer.name, customer])).values()
          );
          
          // Store customers data for use in dropdowns and filters
          this.customerMasterData = uniqueCustomers as any;
          // Initialize filtered customers list for Assessment Insights filter
          this.filteredAssessmentInsightCustomerApiList = [...this.customerMasterData];
          // Initialize filtered customers list for Candidate Insights filter
          this.filteredCandidateInsightCustomerApiList = [...this.customerMasterData];
          // Initialize filtered customers list for Geographic Insights filter
          this.filteredGeographicInsightCustomerApiList = [...this.customerMasterData];
          // Initialize filtered customers list for Assessment Course filter
          this.filteredAssessmentCourseCustomerList = [...this.customerMasterData];
          // Initialize filtered customers list for Pass/Fail (Candidate Data by Assessment) filter
          this.allPassFailCustomers = [...this.customerMasterData];
          this.filteredPassFailCustomerList = [...this.customerMasterData];
          // Initialize filtered customers list for Candidate Performance filter
          this.filteredCandidatePerformanceCustomerApiList = [...this.customerMasterData];
          // Initialize filtered customers list for Question Paper Insights filter
          this.filteredQuestionPaperInsightCustomerApiList = [...this.customerMasterData];
          // Initialize filtered customers list for Question Paper Course filter
          this.filteredQuestionPaperCustomerList = [...this.customerMasterData];
          console.log('Deduplicated customers:', this.customerMasterData.length, 'from', response.customersMaster.length);
          // Update if filter panel is open and customers header is active
          if (this.showQuestionPaperCourseFilterPanel && this.activeQuestionPaperCourseFilterHeader === 'customers') {
            this.filteredQuestionPaperCustomerList = [...this.customerMasterData];
          }
          this.cdr.detectChanges();
        }
      },
      (error) => {
        console.error('Error fetching sales customers master data:', error);
      }
    );
  }

  getAllProduct(forceRefresh = false) {
    if (!forceRefresh && this.allProductData && this.allProductData.length > 0) {
      return;
    }
    // Fetch all product data
    const resp = this.service.getAllProduct({ org_id: this.org_id });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          console.log('All product data received:', response);
          // Store product data
          this.allProductData = response;
          // Initialize filtered list
          this.filteredQuestionPaperProductList = [...this.allProductData];
          // Update if filter panel is open and products header is active
          if (this.showQuestionPaperCourseFilterPanel && this.activeQuestionPaperCourseFilterHeader === 'products') {
            this.filteredQuestionPaperProductList = [...this.allProductData];
          }
          this.cdr.detectChanges();
        }
      },
      (error) => {
        console.error('Error fetching all product data:', error);
      }
    );
  }

  // Reset assessment summary to default values
  private resetAssessmentSummary(): void {
    this.totalAssessments = 0;
    this.totalCandidates = 0;
    this.assessmentStatusSummary = {
      active: 0,
      inactive: 0,
      deleted: 0,
      publish: 0,
      draft: 0
    };
    this.candidateStatusSummary = {
      active: 0,
      inactive: 0,
      deleted: 0
    };
    this.evaluationStatusSummary = {
      completed: 0,
      pending: 0
    };
    // Reset assessment charts
    this.assessmentLocationChartData = [];
    this.assessmentCourseChartData = [];
    this.assessmentStatusChartData = [];
    this.showAssessmentLocationChart = false;
    this.showAssessmentCourseChart = false;
    this.showAssessmentStatusChart = false;
    this.allAssessmentLocations = [];
    this.allAssessmentCourses = [];
    this.allAssessmentStatuses = [];
  }
  getSalesData() {
    // Show loading state
    this.isLoading = true;

    let { startDate, endDate } = this.formatDateRange(this.rangeType, this.startDate, this.endDate);
    // Fetch revision history data from the service
    const resp = this.service.getSalesData({ org_id: this.org_id, start_date: startDate, end_date: endDate });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          // Process leads
          this.leadsData = (response.leads_counts && response.leads_counts.length > 0) ? response.leads_counts : [];

          // Process customers
          this.customersData = (response.customers_counts && response.customers_counts.length > 0) ? response.customers_counts : [];

          // Summarize counts for leads and customers
          const totalLeadsCount = this.leadsData && this.leadsData.length > 0
            ? this.leadsData.reduce((sum, item) => sum + (Number(item.count) || 0), 0)
            : 0;

          const totalCustomersCount = this.customersData && this.customersData.length > 0
            ? this.customersData.reduce((sum, item) => sum + (Number(item.count) || 0), 0)
            : 0;

          // Update the leadCustomerData with the summarized totals
          this.leadCustomerData = [
            { name: 'Leads', data: [totalLeadsCount] },
            { name: 'Customers', data: [totalCustomersCount] }
          ];

          this.isLoading = false;
          this.cdr.detectChanges();
        } else {
          this.leadsData = [];
          this.customersData = [];
          this.leadCustomerData = [
            { name: 'Leads', data: [0] },
            { name: 'Customers', data: [0] }
          ];
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.isLoading = false; // Hide loading state
        this.leadsData = [];
        this.customersData = [];
        this.leadCustomerData = [
          { name: 'Leads', data: [0] },
          { name: 'Customers', data: [0] }
        ];
      }
    );
  }

  getContentsData() {
    let { startDate, endDate } = this.formatDateRange(this.rangeType, this.startDate, this.endDate);
    const resp = this.service.getContentsData({ org_id: this.org_id, start_date: startDate, end_date: endDate });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];

        if (response) {

          // Check what data we actually have
          if (response.courses_counts) {
          }

          if (response.question_counts) {
          }

          // Process the data based on what's available
          this.processLibraryData(response);
          this.isLoading = false;

          // Trigger change detection after data is processed
          setTimeout(() => {
            this.cdr.detectChanges();
          }, 100);

          this.cdr.detectChanges();
        } else {
          this.setDefaultQuestionData();
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.setDefaultQuestionData();
        this.isLoading = false;
      }
    );
  }
  showCourseFilter: boolean = false;
  allCourses: any[] = [];
  allCoursesOrg: any[] = [];
  allCoursesSuperAdmin: any[] = [];
  selectedCourses: string[] = [];
  filteredQuestionCounts: any[] = [];
  filteredQuestionSummary: any;
  // Extract only question counts from response WITHOUT preparing all charts
  // Used by individual chart fetch methods to maintain chart independence
  private extractQuestionCountsFromResponse(response: any): void {
    if (response.question_counts) {
      // Ensure course_id is properly set in question_counts
      // NOTE: We only extract question_counts, NOT the summary
      // Summary should only be updated by global filter fetches (processLibraryData)
      // This ensures chart filters don't affect the summary display
      this.questionCounts = response.question_counts.map(questionCount => {
        // Convert course_id to number if it's string
        const courseId = questionCount.course_id ?
          (typeof questionCount.course_id === 'string' ? parseInt(questionCount.course_id) : questionCount.course_id)
          : null;

        return {
          ...questionCount,
          course_id: courseId
        };
      });
      this.filteredQuestionPaperInsightCounts = [...this.questionCounts];

      if (response.all_courses_org && Array.isArray(response.all_courses_org)) {
        this.allCoursesOrg = response.all_courses_org.map(course => ({
          ...course,
          course_id: course.course_id ? (typeof course.course_id === 'string' ? parseInt(course.course_id, 10) : course.course_id) : null
        }));
      } else {
        this.allCoursesOrg = [];
      }

      if (response.all_courses_super_admin && Array.isArray(response.all_courses_super_admin)) {
        this.allCoursesSuperAdmin = response.all_courses_super_admin.map(course => ({
          ...course,
          course_id: course.course_id ? (typeof course.course_id === 'string' ? parseInt(course.course_id, 10) : course.course_id) : null
        }));
      } else {
        this.allCoursesSuperAdmin = [];
      }

      // Extract top 10 courses by most assessments if available
      if (response.top_10_courses_by_most_assessments && Array.isArray(response.top_10_courses_by_most_assessments)) {
        this.top10CoursesByMostAssessments = response.top_10_courses_by_most_assessments;
      } else {
        this.top10CoursesByMostAssessments = [];
      }

      // Extract top 10 courses by least assessments if available
      if (response.top_10_courses_by_least_assessments && Array.isArray(response.top_10_courses_by_least_assessments)) {
        this.top10CoursesByLeastAssessments = response.top_10_courses_by_least_assessments;
      } else {
        this.top10CoursesByLeastAssessments = [];
      }
    }
  }

  private processLibraryData(response: any): void {

    if (response.question_counts && response.summary) {
      this.evaluationCriteriaList = response.evaluation_criteria_list || [];

      // Ensure course_id is properly set in question_counts
      this.questionCounts = response.question_counts.map(questionCount => {
        // Convert course_id to number if it's string
        const courseId = questionCount.course_id ?
          (typeof questionCount.course_id === 'string' ? parseInt(questionCount.course_id) : questionCount.course_id)
          : null;

        return {
          ...questionCount,
          course_id: courseId
        };
      });

      // PRESERVE original data for summary section - DO NOT update this by chart filters
      this.summaryQuestionCounts = JSON.parse(JSON.stringify(this.questionCounts));
      this.filteredQuestionPaperInsightCounts = [...this.questionCounts];

      if (response.all_courses_org && Array.isArray(response.all_courses_org)) {
        this.allCoursesOrg = response.all_courses_org.map(course => ({
          ...course,
          course_id: course.course_id ? (typeof course.course_id === 'string' ? parseInt(course.course_id, 10) : course.course_id) : null
        }));
      } else {
        this.allCoursesOrg = [];
      }

      if (response.all_courses_super_admin && Array.isArray(response.all_courses_super_admin)) {
        this.allCoursesSuperAdmin = response.all_courses_super_admin.map(course => ({
          ...course,
          course_id: course.course_id ? (typeof course.course_id === 'string' ? parseInt(course.course_id, 10) : course.course_id) : null
        }));
      } else {
        this.allCoursesSuperAdmin = [];
      }

      // Extract top 10 courses by most assessments if available
      if (response.top_10_courses_by_most_assessments && Array.isArray(response.top_10_courses_by_most_assessments)) {
        this.top10CoursesByMostAssessments = response.top_10_courses_by_most_assessments;
      } else {
        this.top10CoursesByMostAssessments = [];
      }

      // Extract top 10 courses by least assessments if available
      if (response.top_10_courses_by_least_assessments && Array.isArray(response.top_10_courses_by_least_assessments)) {
        this.top10CoursesByLeastAssessments = response.top_10_courses_by_least_assessments;
      } else {
        this.top10CoursesByLeastAssessments = [];
      }

      // Extract top 10 courses by language breakdown if available
      if (response.top_10_courses_language_breakdown && Array.isArray(response.top_10_courses_language_breakdown)) {
        this.top10CoursesByLanguageBreakdown = response.top_10_courses_language_breakdown;
      } else {
        this.top10CoursesByLanguageBreakdown = [];
      }

      this.questionSummary = response.summary;
      this.prepareQuestionChartData();
      this.prepareCourseData(this.questionCounts);

      // ADDED: Prepare new course data for "All" view
      this.prepareNewCourseData(this.questionCounts);

      this.prepareQuestionPaperByCourseData(this.questionCounts);
      this.prepareQuestionPaperDifficultyData(this.questionCounts);
      this.prepareQuestionPaperCategoryData(this.questionCounts);
      // Initial difficulty data set karein (all courses)
      this.initializeQuestionPaperData();
      this.prepareDifficultyData(this.questionCounts);
      this.prepareTop10CourseData(this.questionCounts);
      // ADDED: Initial language data set karein (all courses)
      this.prepareLanguageData(this.questionCounts);
      this.prepareCategoryData(this.questionCounts);
      this.prepareTypeData(this.questionCounts);
      this.prepareStatusData(this.questionCounts);
    }
    // If we only have courses_counts (old structure)
    else if (response.courses_counts && Array.isArray(response.courses_counts)) {
      this.processCoursesData(response.courses_counts);

      // ADDED: Prepare language data for courses data as well
      this.prepareLanguageData(this.questionCounts);
    }
    // If the data is nested differently
    else if (typeof response === 'string') {
      try {
        const parsedResponse = JSON.parse(response);
        this.processLibraryData(parsedResponse);
      } catch (e) {
        this.setDefaultQuestionData();
        // ADDED: Set default language data as well
        this.languageChartData = [];
        this.showLanguageDonutChart = false;
      }
    }
    else {
      this.setDefaultQuestionData();
      // ADDED: Set default language data as well
      this.languageChartData = [];
      this.showLanguageDonutChart = false;
    }
  }

  private processCoursesData(coursesData: any[]): void {

    // Convert courses_counts to chart data
    this.coursesData = coursesData;

    // Create question data from courses data for demonstration
    // This is a temporary solution until the API is updated
    this.questionCounts = coursesData.map((course, index) => ({
      course_name: course.date || `Course ${index + 1}`,
      question_count: course.count || 0,
      difficulty_breakdown: {
        easy: Math.floor((course.count || 0) * 0.3),
        medium: Math.floor((course.count || 0) * 0.5),
        hard: Math.floor((course.count || 0) * 0.2)
      },
      type_breakdown: {
        mcq: Math.floor((course.count || 0) * 0.6),
        coding: Math.floor((course.count || 0) * 0.3),
        descriptive: Math.floor((course.count || 0) * 0.1)
      },
      language_breakdown: {
        english: Math.floor((course.count || 0) * 0.7),
        hindi: Math.floor((course.count || 0) * 0.2),
        regional: Math.floor((course.count || 0) * 0.1)
      },
      status_breakdown: {
        active: course.count || 0,
        archived: 0,
        deleted: 0
      }
    }));

    // Create summary from courses data
    const totalQuestions = coursesData.reduce((sum, course) => sum + (course.count || 0), 0);
    this.questionSummary = {
      total_questions: totalQuestions,
      difficulty_summary: {
        easy: Math.floor(totalQuestions * 0.3),
        medium: Math.floor(totalQuestions * 0.5),
        hard: Math.floor(totalQuestions * 0.2)
      },
      type_summary: {
        mcq: Math.floor(totalQuestions * 0.6),
        coding: Math.floor(totalQuestions * 0.3),
        descriptive: Math.floor(totalQuestions * 0.1)
      },
      language_summary: {
        english: Math.floor(totalQuestions * 0.7),
        hindi: Math.floor(totalQuestions * 0.2),
        regional: Math.floor(totalQuestions * 0.1)
      },
      status_summary: {
        active: totalQuestions,
        archived: 0,
        deleted: 0
      },
      label_summary: { with_label: 0, without_label: 0, current_month_total_labeled: 0, last_month_total_labeled: 0 },
      tag_summary: { with_tag: 0, without_tag: 0, current_month_total_tagged: 0, last_month_total_tagged: 0 }
    };

    this.prepareQuestionChartData();
  }
  showDetailedTable: boolean = false; // Add this line

  getFinancesData() {
    // Show loading state
    this.isLoading = true;

    let { startDate, endDate } = this.formatDateRange(this.rangeType, this.startDate, this.endDate);
    // Fetch revision history data from the service
    const resp = this.service.getFinancesData({ org_id: this.org_id, start_date: startDate, end_date: endDate });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          // Process bills
          this.billsData = (response.bills_count && response.bills_count.length > 0) ? response.bills_count : [];

          // Process invoice
          this.invoicesData = (response.invoices_count && response.invoices_count.length > 0) ? response.invoices_count : [];

          // Process collected
          this.collectedData = (response.receipts_count && response.receipts_count.length > 0) ? response.receipts_count : [];

          this.isLoading = false;
          this.cdr.detectChanges();
        } else {
          this.billsData = [];
          this.invoicesData = [];
          this.collectedData = [];
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.isLoading = false; // Hide loading state
        this.billsData = [];
        this.invoicesData = [];
        this.collectedData = [];
      }
    );
  }
  selectCourse(course: any): void {
    this.selectedCourse = course;
    this.showCourseDropdown = false;

    if (course) {
      // Filter data for selected course
      const courseData = this.questionCounts.find(c => c.course_id === course.course_id);
      if (courseData) {
        this.prepareDifficultyData([courseData]);
      }
    } else {
      // Show data for all courses
      this.prepareDifficultyData(this.questionCounts);
    }
  }



  toggleCourseFilter(): void {
    this.showCourseFilter = !this.showCourseFilter;
    if (this.showCourseFilter && this.allCourses.length === 0) {
      this.loadAllCourses();
    }
  }

  loadAllCourses(): void {
    // Replace this with your actual API call to get all courses
    const postData = {
      courseId: 0,
      userRoleId: this.UserRoleId ? parseInt(this.UserRoleId, 10) : 0
    };

    this.courseSrvc.getAllCourses(postData).subscribe(
      (data: any) => {
        const response = data.body.responseBody;
        this.allCourses = response || [];
        this.cdr.markForCheck();
      },
      (err: any) => {
        this.util.errorNotification(err);
        this.allCourses = [];
        this.cdr.markForCheck();
      }
    );
  }


  isCourseSelected(courseId: number): boolean {
    return this.selectedCourseIds.includes(courseId);
  }

  toggleCourseSelection(courseId: number): void {
    const index = this.selectedCourseIds.indexOf(courseId);
    if (index > -1) {
      this.selectedCourseIds.splice(index, 1);
    } else {
      this.selectedCourseIds.push(courseId);
    }
    // Auto-update chart
    this.updateFilteredData();
  }

  selectAllCourses(): void {
    this.selectedCourseIds = this.courseList.map(course => course.course_id);
    this.updateDifficultyChart();
  }
  selectedCourseIds: number[] = [];

  clearAllCourses(): void {
    this.selectedCourseIds = [];
    this.updateDifficultyChart();
  }


  getSelectedCoursesText(): string {
    if (this.selectedCourseIds.length === 0) {
      return 'All Courses';
    } else if (this.selectedCourseIds.length === 1) {
      const selectedCourse = this.courseList.find(course =>
        course.course_id === this.selectedCourseIds[0]
      );
      return selectedCourse ? selectedCourse.course_name : '1 Course Selected';
    } else {
      return `${this.selectedCourseIds.length} Courses Selected`;
    }
  }


  // Add this property to your component class
  showDonutChart: boolean = false;

  // Course question count method
  getCourseQuestionCount(courseId: number): number {
    if (!this.questionCounts) return 0;

    const courseData = this.questionCounts.find(course => course.course_id === courseId);
    return courseData ? courseData.question_count : 0;
  }

  // Question Paper count method
  getCourseQuestionPaperCount(courseId: number): number {
    if (!this.questionCounts) return 0;

    const courseData = this.questionCounts.find(course => course.course_id === courseId);
    return courseData ? courseData.question_paper_count : 0;
  }

  // Modified prepareDifficultyData method
  private prepareDifficultyData(courses: any[]): void {

    if (courses.length === 0) {
      // No courses match the filter criteria
      this.difficultyChartData = [];
      this.showDonutChart = false;

      // Reinitialize chart with empty state
      setTimeout(() => {
        this.initializeDifficultyChart();
      }, 100);
      return;
    }

    if (this.shouldShowOverallDifficulty()) {
      this.prepareOverallDifficultyData(courses);
    } else {
      this.prepareMultipleCoursesData(courses);
    }

    this.showDonutChart = this.difficultyChartData.some(item => item.value > 0);

    // Initialize chart after a brief delay to ensure DOM is updated
    setTimeout(() => {
      this.initializeDifficultyChart();
    }, 100);
  }

  private shouldShowOverallDifficulty(): boolean {
    // Show overall difficulty when:
    // 1. No specific courses are selected (all courses selected)
    // 2. When user selects all courses explicitly
    // 3. When multiple courses are selected but we want to avoid clutter

    const hasCourseFilter = this.selectedDifficultyCourseIds.length > 0;
    const hasDifficultyFilter = this.selectedDifficultyLevels.length > 0;

    // If no specific difficulty courses are selected, show overall difficulty
    if (!hasCourseFilter) {
      return true;
    }

    // If all courses are selected, show overall difficulty
    if (this.selectedDifficultyCourseIds.length === this.courseList.length) {
      return true;
    }

    // If only one course is selected, show course-wise
    if (this.selectedDifficultyCourseIds.length === 1) {
      return false;
    }

    // For multiple courses (2 or more), show course-wise breakdown
    // But if there are too many courses, we might want to show overall
    // Let's set a limit - if more than 5 courses, show overall
    if (this.selectedDifficultyCourseIds.length > 5) {
      return true;
    }

    // Default: show course-wise for 2-5 selected courses
    return false;
  }

  // New method to prepare overall difficulty data (aggregated across all selected courses)
  private prepareOverallDifficultyData(courses: any[]): void {

    this.difficultyChartData = [];

    // Check if question type filter is applied
    const isTypeFilterApplied = this.selectedQuestionTypes && this.selectedQuestionTypes.length > 0;

    // Aggregate difficulty counts across all selected courses
    const difficultyTotals = {
      'Easy': 0,
      'Medium': 0,
      'Hard': 0
    };

    courses.forEach(course => {
      // Use type_difficulty_breakdown if type filter is applied, otherwise use difficulty_breakdown
      if (isTypeFilterApplied && course._type_difficulty_breakdown) {
        // Use aggregated type_difficulty_breakdown for filtered question types
        difficultyTotals['Easy'] += course._type_difficulty_breakdown.easy || 0;
        difficultyTotals['Medium'] += course._type_difficulty_breakdown.medium || 0;
        difficultyTotals['Hard'] += course._type_difficulty_breakdown.hard || 0;
      } else if (course.difficulty_breakdown) {
        // Use original difficulty_breakdown when no type filter
        difficultyTotals['Easy'] += course.difficulty_breakdown.easy || 0;
        difficultyTotals['Medium'] += course.difficulty_breakdown.medium || 0;
        difficultyTotals['Hard'] += course.difficulty_breakdown.hard || 0;
      }
    });

    // Define colors for overall difficulty
    const overallColors = {
      'Easy': '#005068',
      'Medium': '#F9EDDB',
      'Hard': '#dc3545'
    };

    // Create chart data for overall difficulty
    Object.entries(difficultyTotals).forEach(([difficulty, count]) => {
      if (count > 0) {
        this.difficultyChartData.push({
          name: difficulty,
          value: count,
          color: overallColors[difficulty],
          courseName: 'All Courses', // Use generic name for overall view
          originalCourseName: 'All Courses',
          courseId: 0 // Use 0 to indicate overall view
        });
      }
    });

  }

  private prepareSelectedCoursesEvaluationModeData(courses: any[]): void {
    this.difficultyChartData = [];

    const modeColors = {
      Theory: '#005068',
      Practical: '#A0A0FF',
      Viva: '#F9EDDB'
    };

    courses.forEach((course, courseIndex) => {
      const courseName = this.truncateCourseName(course.course_name || `Course ${courseIndex + 1}`);
      const categoryBreakdown = course.question_category_breakdown || {};

      ['Theory', 'Practical', 'Viva'].forEach(mode => {
        const count = Number(categoryBreakdown[mode] || 0);
        if (count > 0) {
          this.difficultyChartData.push({
            name: mode,
            value: count,
            color: modeColors[mode],
            courseName: courseName,
            originalCourseName: course.course_name,
            courseId: course.course_id,
            evaluationMode: mode
          });
        }
      });
    });
  }

  private prepareSelectedCoursesEvaluationModeAggregateData(courses: any[]): void {
    this.difficultyChartData = [];

    const modeColors = {
      Theory: '#005068',
      Practical: '#A0A0FF',
      Viva: '#F9EDDB'
    };

    const aggregateTotals: { [difficulty: string]: { [mode: string]: number } } = {
      easy: { Theory: 0, Practical: 0, Viva: 0 },
      medium: { Theory: 0, Practical: 0, Viva: 0 },
      hard: { Theory: 0, Practical: 0, Viva: 0 }
    };

    courses.forEach(course => {
      const categoryBreakdown = course.question_category_breakdown || {};
      const difficultyBreakdown = course.difficulty_breakdown || {};
      const totalDiff = (difficultyBreakdown.easy || 0) + (difficultyBreakdown.medium || 0) + (difficultyBreakdown.hard || 0);

      if (totalDiff > 0) {
        ['easy', 'medium', 'hard'].forEach(diff => {
          const diffCount = difficultyBreakdown[diff] || 0;
          const proportion = diffCount / totalDiff;
          ['Theory', 'Practical', 'Viva'].forEach(mode => {
            const modeCount = Number(categoryBreakdown[mode] || 0) * proportion;
            aggregateTotals[diff][mode] += Math.ceil(modeCount);
          });
        });
      }
    });

    ['easy', 'medium', 'hard'].forEach(diff => {
      ['Theory', 'Practical', 'Viva'].forEach(mode => {
        const count = aggregateTotals[diff][mode];
        if (count > 0) {
          this.difficultyChartData.push({
            name: mode,
            value: count,
            color: modeColors[mode],
            courseName: 'Selected Courses',
            courseId: 0,
            evaluationMode: mode,
            difficulty: diff
          });
        }
      });
    });
  }

  // Modified prepareMultipleCoursesData method (now only used for course-wise view)
  private prepareMultipleCoursesData(courses: any[]): void {
    this.difficultyChartData = [];

    const courseColors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9',
      '#F8B195', '#F67280', '#C06C84', '#6C5B7B', '#355C7D',
      '#99B898', '#FECEAB', '#FF847C', '#E84A5F', '#2A363B'
    ];

    courses.forEach((course, courseIndex) => {
      const courseColor = courseColors[courseIndex % courseColors.length];
      const courseName = this.truncateCourseName(course.course_name || `Course ${courseIndex + 1}`);

      // ... rest of the method remains the same
      const difficulties = [
        { name: 'Easy', value: course.difficulty_breakdown?.easy || 0 },
        { name: 'Medium', value: course.difficulty_breakdown?.medium || 0 },
        { name: 'Hard', value: course.difficulty_breakdown?.hard || 0 }
      ];

      difficulties.forEach(difficulty => {
        const uniqueColor = this.generateUniqueColor(courseColor, difficulty.name);

        this.difficultyChartData.push({
          name: difficulty.name,
          value: difficulty.value,
          color: uniqueColor,
          courseName: courseName, // Use truncated name here
          originalCourseName: course.course_name,
          courseId: course.course_id,
          difficultyLevel: difficulty.name,
          courseColor: courseColor
        });
      });
    });
  }


  private initializeDifficultyChart(): void {

    const canvas = document.getElementById('difficultyDoughnutChart') as HTMLCanvasElement;

    if (!canvas) {
      return;
    }

    // Destroy existing chart if it exists
    if (this.difficultyChart) {
      this.difficultyChart.destroy();
    }

    // Filter out zero values for better visualization
    const nonZeroData = this.difficultyChartData.filter(item => item.value > 0);

    if (nonZeroData.length === 0) {
      // Show a message or empty state
      this.showDonutChart = false;
      return;
    }

    this.showDonutChart = true;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      try {
        // Create labels based on whether we're showing overall or course-wise data
        const isOverallView = this.shouldShowOverallDifficulty();
        const labels = isOverallView
          ? nonZeroData.map(item => item.name) // Just difficulty names for overall view
          : nonZeroData.map(item => `${this.truncateCourseName(item.courseName)} - ${item.name}`); // Course + difficulty for course-wise

        // Check if this is difficulty breakdown mode for evaluation modes
        const isBreakdownMode = nonZeroData.some(item => item.difficulty);

        if (isBreakdownMode) {
          // Group data by evaluation mode
          const modeGroups: { [mode: string]: { [difficulty: string]: number } } = {};
          const difficulties = new Set<string>();

          nonZeroData.forEach(item => {
            const mode = item.evaluationMode;
            const difficulty = item.difficulty;
            if (!modeGroups[mode]) {
              modeGroups[mode] = {};
            }
            modeGroups[mode][difficulty] = item.value;
            difficulties.add(difficulty);
          });

          const breakdownLabels = Object.keys(modeGroups);
          const datasets = Array.from(difficulties).map(difficulty => ({
            label: difficulty.charAt(0).toUpperCase() + difficulty.slice(1),
            data: breakdownLabels.map(mode => modeGroups[mode][difficulty] || 0),
            backgroundColor: difficulty === 'easy' ? '#28a745' : difficulty === 'medium' ? '#ffc107' : '#dc3545',
            borderColor: difficulty === 'easy' ? '#28a745' : difficulty === 'medium' ? '#ffc107' : '#dc3545',
            borderWidth: 1,
            borderRadius: 4,
            borderSkipped: false,
          }));

          this.difficultyChart = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: breakdownLabels,
              datasets: datasets
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: true,
                  position: 'top'
                },
                tooltip: {
                  callbacks: {
                    label: (context) => {
                      const value = context.raw as number;
                      return `${context.dataset.label}: ${value}`;
                    }
                  }
                },
              },
              scales: {
                x: {
                  stacked: true,
                  title: {
                    display: true,
                    text: 'Evaluation Modes'
                  }
                },
                y: {
                  stacked: true,
                  beginAtZero: true,
                  title: {
                    display: true,
                    text: 'Number of Questions'
                  }
                }
              }
            }
          });
        } else {
          this.difficultyChart = new Chart(ctx, {
            type: 'doughnut',
            data: {
              labels: labels,
              datasets: [{
                data: nonZeroData.map(item => item.value),
                backgroundColor: nonZeroData.map(item => item.color),
                borderColor: '#fff',
                borderWidth: 0,
                hoverOffset: 0,
                hoverBorderWidth: 0,
                hoverBorderColor: 'transparent'
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: false
                },
                tooltip: {
                  callbacks: {
                    label: (context) => {
                      const index = context.dataIndex;
                      const item = nonZeroData[index];
                      const value = context.raw as number;
                      const total = nonZeroData.reduce((sum, dataItem) => sum + dataItem.value, 0);
                      const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';

                      if (isOverallView) {
                        return [
                          `Difficulty: ${item.name}`,
                          `Count: ${value}`,
                          `Percentage: ${percentage}%`
                        ];
                      } else {
                        return [
                          `Course: ${item.courseName}`,
                          `Difficulty: ${item.name}`,
                          `Count: ${value}`,
                          `Percentage: ${percentage}%`
                        ];
                      }
                    }
                  }
                }
              },
              cutout: '60%',
              animation: {
                animateScale: true,
                animateRotate: true
              },
              layout: {
                padding: {
                  top: 10,
                  right: 10,
                  bottom: 20,
                  left: 10
                }
              }
            }
          });
        }
      } catch (error) {
      }
    }
  }
  private debugCourseData(courses: any[]): void {
    courses.forEach((course, index) => {
    });
  }

  // Update the percentage calculation method
  getDifficultyPercentage(item: any): string {
    // Calculate percentage based on total of all displayed data
    const total = this.difficultyChartData.reduce((sum, dataItem) => sum + dataItem.value, 0);
    return total > 0 ? ((item.value / total) * 100).toFixed(1) : '0';
  }

  getTop10Percentage(item: any): string {
    // Calculate percentage based on total of top 10 chart data
    const total = this.top10CourseBarChartData.reduce((sum, dataItem) => sum + dataItem.value, 0);
    return total > 0 ? ((item.value / total) * 100).toFixed(1) : '0';
  }

  getDifficultyChartTitle(): string {
    return 'Questions by Difficulty Level';
  }

  updateFilteredData(): void {

    let filteredCourses = this.questionCounts;

    // Apply course filter
    if (this.selectedCourseIds.length > 0) {
      filteredCourses = this.questionCounts.filter(course =>
        this.selectedCourseIds.includes(course.course_id)
      );
    }

    // Apply difficulty filter
    if (this.selectedDifficultyLevels.length > 0) {
      filteredCourses = this.filterCoursesByDifficulty(filteredCourses);
    }

    // Debug the course data
    this.debugCourseData(filteredCourses);

    // Update the chart with filtered data using new logic
    this.prepareDifficultyData(filteredCourses);

    // Force change detection
    this.cdr.detectChanges();
  }

  exportChartAsPDF(): void {
    this.closeChartMenu();
    if (!this.ensureHasData(this.difficultyChartData)) { return; }

    if (this.difficultyChart) {
      const canvas = this.difficultyChart.canvas;
      const chartImage = canvas.toDataURL('image/png');

      // Create PDF with proper layout
      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Add title
      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');

      const chartTitle = this.shouldShowOverallDifficulty()
        ? 'Overall Question Difficulty Distribution'
        : 'Course-wise Question Difficulty Distribution';

      // Center the title
      const titleWidth = pdf.getTextWidth(chartTitle);
      const titleX = (pageWidth - titleWidth) / 2;
      pdf.text(chartTitle, titleX, 25);

      // Add source/subtitle
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      const subtitle = 'Source: Content Library Analytics';
      const subtitleWidth = pdf.getTextWidth(subtitle);
      const subtitleX = (pageWidth - subtitleWidth) / 2;
      pdf.text(subtitle, subtitleX, 32);

      // Add separator line
      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      // Add chart image at the top left
      const imgProps = pdf.getImageProperties(chartImage);
      const chartWidth = pageWidth * 0.45;
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      const chartX = 20;
      const chartY = 45;

      pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

      // Add Color Legends beside the chart (right side)
      const legendsX = chartX + chartWidth + 10;
      const legendsStartY = chartY;

      // Color Legends Title
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Color Legend', legendsX, legendsStartY);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      let currentLegendY = legendsStartY + 15;

      // Get unique courses and their colors
      const courseColors = new Map();
      const nonZeroData = this.difficultyChartData.filter(item => item.value > 0);

      nonZeroData.forEach(item => {
        if (!courseColors.has(item.courseName)) {
          courseColors.set(item.courseName, item.color);
        }
      });

      // Add course color legends with proper text wrapping
      const maxLegendWidth = pageWidth - legendsX - 15; // Available width for legends

      courseColors.forEach((color, courseName) => {
        // Check if we need to move to next column or page
        if (currentLegendY > chartY + chartHeight - 30) {
          // If running out of vertical space, continue on next column
          // But for now, we'll just let it flow to next page if needed
        }

        // Draw color box
        const rgb = this.hexToRgb(color);
        pdf.setFillColor(rgb.r, rgb.g, rgb.b);
        pdf.rect(legendsX, currentLegendY - 3, 10, 10, 'F');

        // Draw border around color box
        pdf.setDrawColor(100, 100, 100);
        pdf.rect(legendsX, currentLegendY - 3, 10, 10);

        // Course name with text wrapping - use smaller max width for legends
        const maxTextWidth = maxLegendWidth - 15; // Reserve space for color box and margin
        const lines = pdf.splitTextToSize(courseName, maxTextWidth);

        // Draw each line of the course name
        lines.forEach((line: string, index: number) => {
          pdf.text(line, legendsX + 15, currentLegendY + (index * 4));
        });

        // Move Y position based on number of lines
        currentLegendY += (lines.length * 4) + 8; // More spacing between items
      });

      // Calculate position for distribution summary (below the taller of chart or legends)
      const chartBottom = chartY + chartHeight;
      const legendsBottom = currentLegendY;
      const summaryStartY = Math.max(chartBottom, legendsBottom) + 20;

      // Add Distribution Summary title
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Distribution Summary', 20, summaryStartY);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      let currentY = summaryStartY + 15;

      // Calculate totals and percentages
      const totalQuestions = this.difficultyChartData.reduce((sum, item) => sum + item.value, 0);

      if (this.shouldShowOverallDifficulty()) {
        // Show overall difficulty breakdown in a single column
        pdf.setFont('helvetica', 'bold');
        pdf.text('Overall Difficulty Breakdown:', 20, currentY);
        currentY += 8;

        pdf.setFont('helvetica', 'normal');
        nonZeroData.forEach(item => {
          const percentage = this.getDifficultyPercentage(item);
          pdf.text(`${item.name}: ${item.value} (${percentage}%)`, 25, currentY);
          currentY += 5;
        });
      } else {
        // Show course-wise breakdown in multiple columns
        // Group data by course
        const coursesMap = new Map();
        nonZeroData.forEach(item => {
          if (!coursesMap.has(item.courseName)) {
            coursesMap.set(item.courseName, []);
          }
          coursesMap.get(item.courseName).push(item);
        });

        const coursesArray = Array.from(coursesMap.entries());
        const coursesPerRow = 2;
        const courseWidth = (pageWidth - 60) / coursesPerRow;

        // Add course-wise breakdown in grid layout
        for (let i = 0; i < coursesArray.length; i += coursesPerRow) {
          const rowCourses = coursesArray.slice(i, i + coursesPerRow);

          let maxCourseHeight = 0;

          // Process each course in the current row
          rowCourses.forEach(([courseName, difficulties], courseIndex) => {
            const courseX = 20 + (courseIndex * courseWidth);
            let courseY = currentY;

            // Course name with background and text wrapping
            pdf.setFont('helvetica', 'bold');
            pdf.setFillColor(245, 245, 245);

            // Wrap course name to fit within course width
            const courseNameLines = pdf.splitTextToSize(courseName, courseWidth - 20);
            const courseNameHeight = courseNameLines.length * 4 + 6;

            // Draw background for course name
            pdf.rect(courseX, courseY - 5, courseWidth - 15, courseNameHeight, 'F');

            // Draw colored border on left
            const rgb = this.hexToRgb(courseColors.get(courseName));
            pdf.setFillColor(rgb.r, rgb.g, rgb.b);
            pdf.rect(courseX, courseY - 5, 4, courseNameHeight, 'F');

            // Reset fill color for text
            pdf.setFillColor(0, 0, 0);

            // Draw course name lines
            courseNameLines.forEach((line: string, lineIndex: number) => {
              pdf.text(line, courseX + 8, courseY + (lineIndex * 4));
            });

            courseY += courseNameHeight + 8;

            pdf.setFont('helvetica', 'normal');

            // Add difficulties for this course
            difficulties.forEach(item => {
              const percentage = this.getDifficultyPercentage(item);
              const difficultyText = `${item.name}: ${item.value} (${percentage}%)`;

              pdf.text(difficultyText, courseX + 8, courseY);
              courseY += 5;
            });

            // Update max height for this row
            const courseHeight = courseY - currentY;
            if (courseHeight > maxCourseHeight) {
              maxCourseHeight = courseHeight;
            }
          });

          // Move to next row position
          currentY += maxCourseHeight + 20;

          // Add page break if needed
          if (currentY > pageHeight - 50 && i + coursesPerRow < coursesArray.length) {
            pdf.addPage();
            currentY = 20;

            // Add title on new page
            pdf.setFontSize(14);
            pdf.setFont('helvetica', 'bold');
            pdf.text('Distribution Summary (Continued)', 20, currentY);
            currentY += 15;
          }
        }
      }

      // Add total questions and metadata below the distribution summary
      currentY += 10;
      pdf.setFont('helvetica', 'bold');
      pdf.text(`Total Questions: ${totalQuestions}`, 20, currentY);

      // Add filter information
      currentY += 8;
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'italic');

      let filterInfo = `View: ${this.shouldShowOverallDifficulty() ? 'Overall Difficulty' : 'Course-wise Breakdown'}`;
      pdf.text(filterInfo, 20, currentY);

      currentY += 4;
      let dateRangeText = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateRangeText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
      }
      pdf.text(dateRangeText, 20, currentY);

      // Add selected courses info if in course-wise view
      if (!this.shouldShowOverallDifficulty() && this.selectedCourseIds.length > 0) {
        currentY += 4;
        const courseCount = this.selectedCourseIds.length;
        pdf.text(`Selected Courses: ${courseCount} course${courseCount > 1 ? 's' : ''}`, 20, currentY);
      }

      // Add footer at the bottom
      const footerY = pageHeight - 10;
      pdf.setFontSize(8);
      pdf.setFont('helvetica', 'normal');
      pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth / 2, footerY, { align: 'center' });

      const fileName = this.shouldShowOverallDifficulty()
        ? 'overall-difficulty-analysis.pdf'
        : 'course-wise-difficulty-analysis.pdf';

      pdf.save(fileName);
    }
  }
  // Add this helper method to convert hex to RGB
  private hexToRgb(hex: string): { r: number, g: number, b: number } {
    // Remove # if present
    hex = hex.replace(/^#/, '');

    // Parse hex values
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return { r, g, b };
  }
  isCourseSelectedForDifficulty(courseId: number): boolean {
    return this.selectedDifficultyCourseIds.includes(courseId);
  }
  toggleCourseSelectionForDifficulty(courseId: number): void {
    const index = this.selectedDifficultyCourseIds.indexOf(courseId);
    if (index > -1) {
      this.selectedDifficultyCourseIds.splice(index, 1);
    } else {
      this.selectedDifficultyCourseIds.push(courseId);
    }
    this.updateDifficultyFilteredData();
  }
  areAllCoursesSelectedForDifficulty(): boolean {
    if (this.courseList.length === 0) return false;
    return this.selectedDifficultyCourseIds.length === this.courseList.length;
  }

  toggleAllCoursesSelectionForDifficulty(): void {
    if (this.areAllCoursesSelectedForDifficulty()) {
      this.selectedDifficultyCourseIds = [];
    } else {
      this.selectedDifficultyCourseIds = this.courseList.map(course => course.course_id);
    }
    this.updateDifficultyFilteredData();
  }
  isDifficultySelected(difficulty: string): boolean {
    return this.selectedDifficultyLevels.includes(difficulty);
  }

  toggleDifficultySelection(difficulty: string): void {
    const index = this.selectedDifficultyLevels.indexOf(difficulty);
    if (index > -1) {
      this.selectedDifficultyLevels.splice(index, 1);
    } else {
      this.selectedDifficultyLevels.push(difficulty);
    }
    this.updateDifficultyFilteredData();
  }

  private getDifficultyCourseRecordsBySelectedIds(): any[] {
    if (!this.selectedDifficultyCourseIds || this.selectedDifficultyCourseIds.length === 0) {
      return this.questionCounts || [];
    }

    const courseMap = new Map<number, any>();
    const sources = [
      ...(this.questionCounts || []),
      ...(this.allCoursesOrg || []),
      ...(this.allCoursesSuperAdmin || [])
    ];

    sources.forEach(course => {
      const courseId = course && course.course_id ? Number(course.course_id) : null;
      if (courseId && this.selectedDifficultyCourseIds.includes(courseId) && !courseMap.has(courseId)) {
        courseMap.set(courseId, course);
      }
    });

    return this.selectedDifficultyCourseIds
      .map(id => courseMap.get(id))
      .filter(course => course);
  }

  updateDifficultyFilteredData(): void {
    let filteredCourses = this.questionCounts || [];

    // Debug logs for filter state
    console.log('[DEBUG] updateDifficultyFilteredData - selectedDifficultyCourseIds:', this.selectedDifficultyCourseIds);
    console.log('[DEBUG] updateDifficultyFilteredData - selectedDifficultyLevels:', this.selectedDifficultyLevels);
    console.log('[DEBUG] updateDifficultyFilteredData - selectedQuestionTypes:', this.selectedQuestionTypes);
    console.log('[DEBUG] updateDifficultyFilteredData - selectedDifficultyLanguages:', this.selectedDifficultyLanguages);

    // Only apply course filter if courses are selected
    if (this.selectedDifficultyCourseIds.length > 0) {
      filteredCourses = this.getDifficultyCourseRecordsBySelectedIds();
    }

    // Always apply difficulty filter if selected
    if (this.selectedDifficultyLevels.length > 0) {
      filteredCourses = this.filterCoursesByDifficulty(filteredCourses);
    }

    // Apply question type filter for the difficulty chart
    if (this.selectedQuestionTypes.length > 0) {
      
      filteredCourses = this.filterCoursesByQuestionType(filteredCourses);
    }

    // Apply language filter for the difficulty chart
    if (this.selectedDifficultyLanguages.length > 0) {
      filteredCourses = this.filterCoursesByDifficultyLanguages(filteredCourses);
    }

    // Debug: Show filteredCourses result
    console.log('[DEBUG] updateDifficultyFilteredData - filteredCourses:', filteredCourses);

    this.prepareDifficultyData(filteredCourses);
    this.cdr.detectChanges();
  }

  clearDifficultyFilters(): void {
    this.selectedDifficultyCourseIds = [];
    this.selectedDifficultyLevels = [];
    this.selectedQuestionTypes = [];
    this.selectedDifficultyLanguages = [];
    this.courseSearchTerm = '';
    this.difficultySearchTerm = '';
    this.questionTypeSearchTerm = '';
    this.difficultyLanguageSearchTerm = '';
    this.difficultyLanguageSearchTerm = '';
    this.filteredCourseList = [...this.courseList];
    this.filteredDifficultyLevels = [...this.difficultyLevels];
    this.filteredQuestionTypeList = [...this.availableQuestionTypes];
    this.filteredDifficultyLanguagesList = [...this.languagesData];
    this.updateDifficultyFilteredData();
  }

  filterDifficultyLevels(): void {
    if (!this.difficultySearchTerm.trim()) {
      this.filteredDifficultyLevels = [...this.difficultyLevels];
      return;
    }

    const searchTerm = this.difficultySearchTerm.toLowerCase().trim();
    this.filteredDifficultyLevels = this.difficultyLevels.filter(difficulty =>
      difficulty.label.toLowerCase().includes(searchTerm)
    );
  }

  filterDifficultyLanguages(): void {
    if (!this.difficultyLanguageSearchTerm.trim()) {
      this.filteredDifficultyLanguagesList = [...this.languagesData];
      return;
    }

    const searchTerm = this.difficultyLanguageSearchTerm.toLowerCase().trim();
    this.filteredDifficultyLanguagesList = this.languagesData.filter(language =>
      language.name.toLowerCase().includes(searchTerm)
    );
  }

  toggleDifficultyLanguageFilter(language: string): void {
    const index = this.selectedDifficultyLanguages.indexOf(language);
    if (index > -1) {
      this.selectedDifficultyLanguages.splice(index, 1);
    } else {
      this.selectedDifficultyLanguages.push(language);
    }
    this.updateDifficultyFilteredData();
  }

  private getDifficultyBreakdownForSelectedLanguages(course: any, selectedLanguages: string[]): { easy: number; medium: number; hard: number } {
    const totals = { easy: 0, medium: 0, hard: 0 };

    if (!course?.language_difficulty_breakdown || typeof course.language_difficulty_breakdown !== 'object') {
      return totals;
    }

    const selectedLanguageValues = selectedLanguages.map(language => this.normalizeString(language)).filter(Boolean);

    Object.entries(course.language_difficulty_breakdown).forEach(([languageKey, difficultyBreakdown]: [string, any]) => {
      if (!difficultyBreakdown || typeof difficultyBreakdown !== 'object') {
        return;
      }

      const matchingKeys = this.getMatchingLanguageKeys(course.language_difficulty_breakdown, languageKey);
      const isSelectedLanguage = matchingKeys.some(key => {
        const normalizedKey = this.normalizeString(key);
        return selectedLanguageValues.some(selectedLanguage => {
          return normalizedKey === selectedLanguage ||
            normalizedKey.includes(selectedLanguage) ||
            selectedLanguage.includes(normalizedKey);
        });
      });

      if (!isSelectedLanguage) {
        return;
      }

      totals.easy += Number(difficultyBreakdown.easy || 0);
      totals.medium += Number(difficultyBreakdown.medium || 0);
      totals.hard += Number(difficultyBreakdown.hard || 0);
    });

    return totals;
  }

  filterCoursesByDifficultyLanguages(courses: any[]): any[] {
    return courses.map(course => {
      const filteredCourse = { ...course };

      if (filteredCourse.language_difficulty_breakdown) {
        const directBreakdown = this.getDifficultyBreakdownForSelectedLanguages(filteredCourse, this.selectedDifficultyLanguages);
        filteredCourse.difficulty_breakdown = {
          easy: directBreakdown.easy,
          medium: directBreakdown.medium,
          hard: directBreakdown.hard
        };
      } else if (filteredCourse.language_breakdown && filteredCourse.difficulty_breakdown) {
        const getLanguageCount = (breakdown: any, lang: string) => {
          if (!breakdown) return 0;
          const normalizedLang = lang.toLowerCase();
          for (const key in breakdown) {
            if (key.toLowerCase() === normalizedLang) {
              return Number(breakdown[key] || 0);
            }
          }
          return 0;
        };

        const selectedLanguagesTotal = this.selectedDifficultyLanguages.reduce((sum: number, lang: string) => {
          return sum + getLanguageCount(filteredCourse.language_breakdown, lang);
        }, 0);

        const totalQuestions = Object.values(filteredCourse.language_breakdown)
          .reduce((sum: number, count: any) => sum + Number(count), 0) as number;

        if (selectedLanguagesTotal > 0 && totalQuestions > 0) {
          const proportion = selectedLanguagesTotal / totalQuestions;
          filteredCourse.difficulty_breakdown = {
            easy: Math.ceil((filteredCourse.difficulty_breakdown.easy || 0) * proportion),
            medium: Math.ceil((filteredCourse.difficulty_breakdown.medium || 0) * proportion),
            hard: Math.ceil((filteredCourse.difficulty_breakdown.hard || 0) * proportion)
          };

          if (filteredCourse.question_category_breakdown) {
            filteredCourse.question_category_breakdown = {
              Theory: Math.ceil((filteredCourse.question_category_breakdown.Theory || 0) * proportion),
              Practical: Math.ceil((filteredCourse.question_category_breakdown.Practical || 0) * proportion),
              Viva: Math.ceil((filteredCourse.question_category_breakdown.Viva || 0) * proportion)
            };
          }
        } else {
          filteredCourse.difficulty_breakdown = {
            easy: 0,
            medium: 0,
            hard: 0
          };
          if (filteredCourse.question_category_breakdown) {
            filteredCourse.question_category_breakdown = {
              Theory: 0,
              Practical: 0,
              Viva: 0
            };
          }
        }
      }

      return filteredCourse;
    }).filter(course => {
      const total = (course.difficulty_breakdown?.easy || 0) +
                    (course.difficulty_breakdown?.medium || 0) +
                    (course.difficulty_breakdown?.hard || 0);
      return total > 0;
    });
  }

  showFilterPanel: boolean = false;
  courseSearchTerm: string = '';
  difficultySearchTerm: string = '';
  difficultyLanguageSearchTerm: string = '';
  filteredCourseList: any[] = [];
  filteredDifficultyLevels: any[] = [];
  filteredDifficultyLanguagesList: any[] = [];

  difficultyLevels = DIFFICULTY_LEVELS;



  toggleFilterPanel(): void {
    this.showFilterPanel = !this.showFilterPanel;
    if (this.showFilterPanel) {
      this.showChartMenu = false; // Close menu when opening filter
      // Initialize filtered lists when opening panel
      this.filteredCourseList = [...this.courseList];
      this.filteredDifficultyLevels = [...this.difficultyLevels];
      this.filteredQuestionTypeList = [...this.availableQuestionTypes];
      this.filteredDifficultyLanguagesList = [...this.languagesData];
    }
  }
  // Language Chart Methods
  isCourseSelectedForLanguage(courseId: number): boolean {
    return this.selectedLanguageCourseIds.includes(courseId);
  }

  toggleCourseSelectionForLanguage(courseId: number): void {
    const index = this.selectedLanguageCourseIds.indexOf(courseId);
    if (index > -1) {
      this.selectedLanguageCourseIds.splice(index, 1);
    } else {
      this.selectedLanguageCourseIds.push(courseId);
    }
    this.updateLanguageFilteredData();
  }

  areAllCoursesSelectedForLanguage(): boolean {
    if (this.courseList.length === 0) return false;
    return this.selectedLanguageCourseIds.length === this.courseList.length;
  }

  toggleAllCoursesSelectionForLanguage(): void {
    if (this.areAllCoursesSelectedForLanguage()) {
      this.selectedLanguageCourseIds = [];
    } else {
      this.selectedLanguageCourseIds = this.courseList.map(course => course.course_id);
    }
    this.updateLanguageFilteredData();
  }

  updateLanguageFilteredData(): void {

    let filteredCourses = this.questionCounts;

    // Apply course filter
    if (this.selectedLanguageCourseIds.length > 0) {
      filteredCourses = this.questionCounts.filter(course =>
        this.selectedLanguageCourseIds.includes(course.course_id)
      );
    }


    // Apply question type filter
    if (this.selectedLanguageTypes.length > 0) {
      filteredCourses = this.filterCoursesByLanguageTypes(filteredCourses);
    }

    // Apply difficulty level filter
    if (this.selectedLanguageDifficultyLevels.length > 0) {
      filteredCourses = this.filterCoursesByLanguageDifficultyLevels(filteredCourses);
    }

    // Apply evaluation mode filter (with question type filter awareness)
    if (this.selectedLanguageEvaluationModes.length > 0) {
      filteredCourses = this.filterCoursesByLanguageEvaluationModes(filteredCourses, this.selectedLanguageTypes);
    }

    // Apply language filter
    if (this.selectedLanguages.length > 0) {
      filteredCourses = this.filterCoursesByLanguage(filteredCourses);
    }

    this.prepareLanguageData(filteredCourses);
    this.cdr.detectChanges();
  }

  private getMatchingLanguageKeys(languageBreakdown: any, languageValue: string): string[] {
    if (!languageBreakdown || typeof languageBreakdown !== 'object') {
      return [];
    }

    const normalizedTarget = this.normalizeString(languageValue);
    const languageCandidates = new Set<string>();

    // Exact match on breakdown keys
    Object.keys(languageBreakdown).forEach(key => {
      const normalizedKey = this.normalizeString(key);
      if (normalizedKey === normalizedTarget || normalizedKey.includes(normalizedTarget) || normalizedTarget.includes(normalizedKey)) {
        languageCandidates.add(key);
      }
    });

    // Also map language codes or master names to breakdown keys
    const languageNameFromMaster = this.getLanguageName(languageValue);
    const normalizedMasterName = this.normalizeString(languageNameFromMaster);

    if (normalizedMasterName && normalizedMasterName !== normalizedTarget) {
      Object.keys(languageBreakdown).forEach(key => {
        const normalizedKey = this.normalizeString(key);
        if (normalizedKey === normalizedMasterName || normalizedKey.includes(normalizedMasterName) || normalizedMasterName.includes(normalizedKey)) {
          languageCandidates.add(key);
        }
      });
    }

    return Array.from(languageCandidates);
  }

  filterCoursesByLanguage(courses: any[]): any[] {
    return courses.map(course => {
      const filteredCourse = { ...course };

      if (filteredCourse.language_breakdown) {
        const filteredBreakdown: any = {};
        this.selectedLanguages.forEach(languageValue => {
          const matchingKeys = this.getMatchingLanguageKeys(filteredCourse.language_breakdown, languageValue);
          matchingKeys.forEach(key => {
            filteredBreakdown[key] = filteredCourse.language_breakdown[key];
          });
        });

        filteredCourse.language_breakdown = filteredBreakdown;
        filteredCourse.question_count = Object.values(filteredBreakdown)
          .reduce((sum: number, count: number) => sum + count, 0);
      }

      return filteredCourse;
    }).filter(course => course.question_count > 0);
  }

  filterCoursesByLanguageTypes(courses: any[]): any[] {
    return courses.map(course => {
      const filteredCourse = { ...course };

      if (filteredCourse.type_breakdown) {
        const filteredBreakdown: any = {};
        this.selectedLanguageTypes.forEach(type => {
          if (filteredCourse.type_breakdown[type] !== undefined) {
            filteredBreakdown[type] = filteredCourse.type_breakdown[type];
          }
        });

        filteredCourse.type_breakdown = filteredBreakdown;
        const newCount = Object.values(filteredBreakdown)
          .reduce((sum: number, count: any) => sum + (typeof count === 'number' ? count : 0), 0) as number;

        // Proportionally scale language breakdowns based on type filtering
        if (course.question_count > 0 && newCount !== course.question_count) {
          const proportion = newCount / course.question_count;
          
          if (filteredCourse.language_breakdown) {
            const newLang = {};
            Object.keys(filteredCourse.language_breakdown).forEach(lang => {
              newLang[lang] = Math.round((filteredCourse.language_breakdown[lang] || 0) * proportion);
            });
            filteredCourse.language_breakdown = newLang;
          }

          if (filteredCourse.language_difficulty_breakdown) {
            const newLangDiff: any = {};
            Object.keys(filteredCourse.language_difficulty_breakdown).forEach(lang => {
              newLangDiff[lang] = {};
              Object.keys(filteredCourse.language_difficulty_breakdown[lang]).forEach(diff => {
                newLangDiff[lang][diff] = Math.round((filteredCourse.language_difficulty_breakdown[lang][diff] || 0) * proportion);
              });
            });
            filteredCourse.language_difficulty_breakdown = newLangDiff;
          }

          if (filteredCourse.language_evaluation_breakdown) {
            const newLangEval: any = {};
            Object.keys(filteredCourse.language_evaluation_breakdown).forEach(lang => {
              newLangEval[lang] = {};
              Object.keys(filteredCourse.language_evaluation_breakdown[lang]).forEach(mode => {
                newLangEval[lang][mode] = Math.round((filteredCourse.language_evaluation_breakdown[lang][mode] || 0) * proportion);
              });
            });
            filteredCourse.language_evaluation_breakdown = newLangEval;
          }
        }
        filteredCourse.question_count = newCount;
      }

      return filteredCourse;
    }).filter(course => course.question_count > 0);
  }

  filterCoursesByLanguageDifficultyLevels(courses: any[]): any[] {
    return courses.map(course => {
      const filteredCourse = { ...course };

      if (filteredCourse.difficulty_breakdown) {
        const filteredBreakdown = {};
        this.selectedLanguageDifficultyLevels.forEach(level => {
          if (filteredCourse.difficulty_breakdown[level] !== undefined) {
            filteredBreakdown[level] = filteredCourse.difficulty_breakdown[level];
          }
        });

        filteredCourse.difficulty_breakdown = filteredBreakdown;
        filteredCourse.question_count = Object.values(filteredBreakdown)
          .reduce((sum: number, count: number) => sum + count, 0);
      }

      // Also filter language_difficulty_breakdown if it exists
      if (filteredCourse.language_difficulty_breakdown) {
        const filteredLanguageBreakdown: any = {};
        Object.keys(filteredCourse.language_difficulty_breakdown).forEach(language => {
          filteredLanguageBreakdown[language] = {};
          this.selectedLanguageDifficultyLevels.forEach(level => {
            if (filteredCourse.language_difficulty_breakdown[language][level] !== undefined) {
              filteredLanguageBreakdown[language][level] = filteredCourse.language_difficulty_breakdown[language][level];
            }
          });
        });
        filteredCourse.language_difficulty_breakdown = filteredLanguageBreakdown;

        // Update language_breakdown exactly based on filtered difficulty
        if (filteredCourse.language_breakdown) {
          const newLang: any = {};
          Object.keys(filteredLanguageBreakdown).forEach(lang => {
            const sum = (Object.values(filteredLanguageBreakdown[lang]) as number[]).reduce((s: number, v: number) => s + v, 0);
            if (sum > 0) newLang[lang] = sum;
          });
          filteredCourse.language_breakdown = newLang;
        }
      } else if (filteredCourse.language_breakdown && filteredCourse.difficulty_breakdown) {
        // Compute language_difficulty_breakdown assuming proportional distribution
        const totalDifficulty = (Object.values(filteredCourse.difficulty_breakdown) as number[]).reduce((sum: number, count: number) => sum + count, 0);
        if (totalDifficulty > 0) {
          const languageDifficultyBreakdown = {};
          Object.keys(filteredCourse.language_breakdown).forEach(language => {
            languageDifficultyBreakdown[language] = {};
            this.selectedLanguageDifficultyLevels.forEach(level => {
              const proportion = (filteredCourse.difficulty_breakdown[level] as number) / totalDifficulty;
              languageDifficultyBreakdown[language][level] = Math.round((filteredCourse.language_breakdown[language] as number) * proportion);
            });
          });
          filteredCourse.language_difficulty_breakdown = languageDifficultyBreakdown;
        }
      }

      return filteredCourse;
    }).filter(course => course.question_count > 0);
  }

  // Updated: Accept selectedTypes for filtering
  filterCoursesByLanguageEvaluationModes(courses: any[], selectedTypes: string[] = []): any[] {
    // Map of which question types belong to each evaluation mode
    const evaluationModeTypeMapping: { [key: string]: string[] } = {
      'Theory': ['mcq', 'true_false', 'fill_blanks', 'matching', 'subjective', 'scenario_based', 'multi_select'],
      'Practical': ['activity_performance', 'file_submission'],
      'Viva': ['audio_video', 'live_viva']
    };

    return courses.map(course => {
      const filteredCourse = { ...course };

      // Filter question_category_breakdown by selected evaluation modes
      if (filteredCourse.question_category_breakdown) {
        const filteredBreakdown: any = {};
        this.selectedLanguageEvaluationModes.forEach(mode => {
          // If question types are selected, only count those types for this mode
          if (selectedTypes.length > 0 && course.type_breakdown) {
            // Only count types for this mode and selected types
            const allowedTypes = evaluationModeTypeMapping[mode] || [];
            let sum = 0;
            selectedTypes.forEach(type => {
              if (allowedTypes.includes(type) && course.type_breakdown[type] !== undefined) {
                sum += Number(course.type_breakdown[type]) || 0;
              }
            });
            filteredBreakdown[mode] = sum;
          } else {
            // No type filter, use all data for this mode
            if (filteredCourse.question_category_breakdown[mode] !== undefined) {
              filteredBreakdown[mode] = filteredCourse.question_category_breakdown[mode];
            }
          }
        });
        filteredCourse.question_category_breakdown = filteredBreakdown;
        filteredCourse.question_count = Object.values(filteredBreakdown)
          .reduce((sum: number, count: number) => sum + count, 0);
      }

      // Also filter language_evaluation_breakdown if it exists
      if (filteredCourse.language_evaluation_breakdown) {
        const filteredLanguageBreakdown: any = {};
        Object.keys(filteredCourse.language_evaluation_breakdown).forEach(language => {
          filteredLanguageBreakdown[language] = {};
          this.selectedLanguageEvaluationModes.forEach(mode => {
            if (filteredCourse.language_evaluation_breakdown[language][mode] !== undefined) {
              filteredLanguageBreakdown[language][mode] = filteredCourse.language_evaluation_breakdown[language][mode];
            }
          });
        });
        filteredCourse.language_evaluation_breakdown = filteredLanguageBreakdown;

        // Update language_breakdown exactly based on filtered evaluation modes
        if (filteredCourse.language_breakdown) {
          const newLang: any = {};
          Object.keys(filteredLanguageBreakdown).forEach(lang => {
            const sum = (Object.values(filteredLanguageBreakdown[lang]) as number[]).reduce((s: number, v: number) => s + v, 0);
            if (sum > 0) newLang[lang] = sum;
          });
          filteredCourse.language_breakdown = newLang;
        }
      } else if (filteredCourse.language_breakdown && filteredCourse.question_category_breakdown) {
        // Compute language_evaluation_breakdown assuming proportional distribution
        const totalEvaluation = (Object.values(filteredCourse.question_category_breakdown) as number[]).reduce((sum: number, count: number) => sum + count, 0);
        if (totalEvaluation > 0) {
          const languageEvaluationBreakdown: any = {};
          Object.keys(filteredCourse.language_breakdown).forEach(language => {
            languageEvaluationBreakdown[language] = {};
            this.selectedLanguageEvaluationModes.forEach(mode => {
              const proportion = (filteredCourse.question_category_breakdown[mode] as number) / totalEvaluation;
              languageEvaluationBreakdown[language][mode] = Math.round((filteredCourse.language_breakdown[language] as number) * proportion);
            });
          });
          filteredCourse.language_evaluation_breakdown = languageEvaluationBreakdown;
        }
      }

      return filteredCourse;
    }).filter(course => course.question_count > 0);
  }

  filterHeaders = [
    { key: 'courses', name: 'Courses' },
    { key: 'difficulty', name: 'Difficulty Level' },
    { key: 'questionTypes', name: 'Question Type' },
    { key: 'language', name: 'Language' },
  ];

  activeFilterHeader: string = 'courses';

  questionTypes = [
    { label: 'MCQ', value: 'mcq' },
    { label: 'Coding', value: 'coding' },
    { label: 'Descriptive', value: 'descriptive' }
  ];

  languages = [
    { label: 'English', value: 'english' },
    { label: 'Hindi', value: 'hindi' },
    { label: 'Regional', value: 'regional' }
  ];

  // Add these properties to your component class
  showChartMenu: boolean = false;
  showTableModalFlag: boolean = false;
  showQuestionPaperTableModalFlag: boolean = false;
  showQuestionPaperCompareDialog: boolean = false;

  // Three-dot menu methods
  toggleChartMenu(): void {
    this.showChartMenu = !this.showChartMenu;
    if (this.showChartMenu) {
      this.showFilterPanel = false; // Close filter when opening menu
    }
  }

  closeChartMenu(): void {
    this.showChartMenu = false;
  }

  // Show table modal
  showTableModal(): void {
    this.closeChartMenu();
    this.showTableModalFlag = true;
  }

  // Close table modal
  closeTableModal(): void {
    this.showTableModalFlag = false;
  }

  // Show Question Paper table modal
  showQuestionPaperTableModal(): void {
    this.closeChartMenu();
    this.showQuestionPaperTableModalFlag = true;
  }

  // Close Question Paper table modal
  closeQuestionPaperTableModal(): void {
    this.showQuestionPaperTableModalFlag = false;
  }


  exportChartAsPNG(): void {
    this.closeChartMenu();
    if (!this.ensureHasData(this.difficultyChartData)) { return; }

    if (this.difficultyChart) {
      // Create a container to combine chart and information
      const container = document.createElement('div');
      container.style.cssText = `
      position: fixed;
      left: -10000px;
      top: -10000px;
      width: 1400px;
      background: white;
      padding: 40px;
      border: 1px solid #ccc;
      z-index: 10000;
      font-family: Arial, sans-serif;
    `;

      // Create header
      const header = document.createElement('div');
      header.style.cssText = `
      text-align: center;
      margin-bottom: 40px;
      padding-bottom: 20px;
      border-bottom: 3px solid #005068;
    `;

      const title = document.createElement('h1');
      title.textContent = 'Question Difficulty Distribution';
      title.style.cssText = `
      margin: 0 0 12px 0;
      color: #005068;
      font-size: 32px;
      font-weight: bold;
    `;

      const subtitle = document.createElement('p');
      subtitle.textContent = 'Source: Content Library Analytics';
      subtitle.style.cssText = `
      margin: 0;
      color: #666;
      font-size: 16px;
    `;

      header.appendChild(title);
      header.appendChild(subtitle);

      // Create top row for chart and legends
      const topRow = document.createElement('div');
      topRow.style.cssText = `
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 60px;
      margin-bottom: 40px;
      padding: 30px;
      background: #f8f9fa;
      border-radius: 15px;
      min-height: 500px;
    `;

      // Chart container (larger and expanded)
      const chartContainer = document.createElement('div');
      chartContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 2;
      min-height: 500px;
    `;

      // Create a high-quality chart render
      const chartWrapper = document.createElement('div');
      chartWrapper.style.cssText = `
      width: 500px;
      height: 500px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: white;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      padding: 20px;
      box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    `;

      // Get the original chart canvas
      const originalCanvas = this.difficultyChart.canvas;

      // Create a high-resolution canvas
      const highResCanvas = document.createElement('canvas');
      highResCanvas.width = 800; // Higher resolution
      highResCanvas.height = 800;

      const ctx = highResCanvas.getContext('2d');
      if (ctx) {
        // Scale up for better quality
        ctx.scale(2, 2);

        // Set white background
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, highResCanvas.width, highResCanvas.height);

        // Draw the chart with better quality
        ctx.drawImage(originalCanvas, 0, 0, 400, 400);
      }

      const chartImg = document.createElement('img');
      chartImg.src = highResCanvas.toDataURL('image/png', 1.0); // Maximum quality
      chartImg.style.cssText = `
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 10px;
      object-fit: contain;
    `;

      chartWrapper.appendChild(chartImg);
      chartContainer.appendChild(chartWrapper);

      // Legends container
      const legendsContainer = document.createElement('div');
      legendsContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 25px;
      flex: 1;
      min-width: 320px;
      max-width: 350px;
    `;

      // Color Legend Container
      const colorLegendContainer = document.createElement('div');
      colorLegendContainer.style.cssText = `
      background: white;
      padding: 30px;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    `;

      const colorLegendTitle = document.createElement('h3');
      colorLegendTitle.textContent = 'Color Legend';
      colorLegendTitle.style.cssText = `
      margin: 0 0 25px 0;
      color: #005068;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      border-bottom: 3px solid #f0f0f0;
      padding-bottom: 15px;
    `;

      colorLegendContainer.appendChild(colorLegendTitle);

      // Add course color legend only
      const courseLegend = document.createElement('div');
      courseLegend.style.cssText = `
      margin-bottom: 10px;
    `;

      const courseLegendTitle = document.createElement('h4');
      courseLegendTitle.textContent = 'Courses';
      courseLegendTitle.style.cssText = `
      margin: 0 0 20px 0;
      color: #333;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    `;

      courseLegend.appendChild(courseLegendTitle);

      // Get unique courses and their colors
      const courseColors = new Map();
      const nonZeroData = this.difficultyChartData.filter(item => item.value > 0);

      nonZeroData.forEach(item => {
        if (!courseColors.has(item.courseName)) {
          courseColors.set(item.courseName, item.color);
        }
      });

      // Add course color items with better styling
      courseColors.forEach((color, courseName) => {
        const courseItem = document.createElement('div');
        courseItem.style.cssText = `
        display: flex;
        align-items: flex-start;
        margin-bottom: 16px;
        padding: 12px;
        background: #f8f9fa;
        border-radius: 10px;
        border-left: 5px solid ${color};
        transition: all 0.3s ease;
      `;

        const colorBox = document.createElement('div');
        colorBox.style.cssText = `
        width: 24px;
        height: 24px;
        background-color: ${color};
        border: 3px solid #fff;
        border-radius: 8px;
        margin-right: 15px;
        margin-top: 2px;
        box-shadow: 0 3px 8px rgba(0,0,0,0.2);
        flex-shrink: 0;
      `;

        const courseNameSpan = document.createElement('span');
        courseNameSpan.textContent = courseName;
        courseNameSpan.style.cssText = `
        font-size: 16px;
        font-weight: 500;
        color: #333;
        line-height: 1.4;
        word-wrap: break-word;
        flex: 1;
      `;

        courseItem.appendChild(colorBox);
        courseItem.appendChild(courseNameSpan);
        courseLegend.appendChild(courseItem);
      });

      colorLegendContainer.appendChild(courseLegend);
      legendsContainer.appendChild(colorLegendContainer);

      // Add legends to top row
      topRow.appendChild(chartContainer);
      topRow.appendChild(legendsContainer);

      // Distribution Summary Section
      const distributionSection = document.createElement('div');
      distributionSection.style.cssText = `
      margin-top: 40px;
    `;

      const distributionTitle = document.createElement('h2');
      distributionTitle.textContent = 'Distribution Summary';
      distributionTitle.style.cssText = `
      margin: 0 0 30px 0;
      color: #005068;
      font-size: 28px;
      font-weight: bold;
      text-align: center;
      border-bottom: 3px solid #005068;
      padding-bottom: 15px;
    `;

      distributionSection.appendChild(distributionTitle);

      // Create course grid (2 courses per row)
      const coursesMap = new Map();
      nonZeroData.forEach(item => {
        if (!coursesMap.has(item.courseName)) {
          coursesMap.set(item.courseName, []);
        }
        coursesMap.get(item.courseName).push(item);
      });

      const coursesArray = Array.from(coursesMap.entries());

      // Create rows with 2 courses each
      for (let i = 0; i < coursesArray.length; i += 2) {
        const row = document.createElement('div');
        row.style.cssText = `
        display: flex;
        gap: 40px;
        margin-bottom: 40px;
        justify-content: center;
      `;

        // Add courses for this row
        for (let j = 0; j < 2 && (i + j) < coursesArray.length; j++) {
          const [courseName, difficulties] = coursesArray[i + j];
          const courseColor = courseColors.get(courseName);

          const courseCard = document.createElement('div');
          courseCard.style.cssText = `
          flex: 1;
          background: white;
          padding: 30px;
          border-radius: 15px;
          border: 3px solid #e0e0e0;
          border-left: 8px solid ${courseColor};
          min-width: 350px;
          max-width: 400px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.15);
        `;

          // Course header
          const courseHeader = document.createElement('h3');
          courseHeader.textContent = courseName;
          courseHeader.style.cssText = `
          margin: 0 0 25px 0;
          color: #333;
          font-size: 20px;
          font-weight: bold;
          border-bottom: 3px solid #f0f0f0;
          padding-bottom: 15px;
          text-align: center;
          word-wrap: break-word;
          line-height: 1.3;
        `;

          courseCard.appendChild(courseHeader);

          // Create table-like structure for difficulties
          const tableContainer = document.createElement('div');
          tableContainer.style.cssText = `
          width: 100%;
        `;

          // Add difficulties for this course
          difficulties.forEach(item => {
            const percentage = this.getDifficultyPercentage(item);

            const rowDiv = document.createElement('div');
            rowDiv.style.cssText = `
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
            font-size: 16px;
            padding: 12px 0;
            border-bottom: 2px solid #f5f5f5;
          `;

            const difficultyLabel = document.createElement('span');
            difficultyLabel.textContent = `${item.name}:`;
            difficultyLabel.style.cssText = `
            font-weight: bold;
            color: #333;
            font-size: 16px;
          `;

            const valueSpan = document.createElement('span');
            valueSpan.textContent = `${item.value} (${percentage}%)`;
            valueSpan.style.cssText = `
            color: #666;
            font-weight: 600;
            font-size: 16px;
          `;

            rowDiv.appendChild(difficultyLabel);
            rowDiv.appendChild(valueSpan);
            tableContainer.appendChild(rowDiv);
          });

          courseCard.appendChild(tableContainer);
          row.appendChild(courseCard);
        }

        distributionSection.appendChild(row);
      }

      // Total and footer section
      const totalQuestions = this.difficultyChartData.reduce((sum, item) => sum + item.value, 0);

      const totalSection = document.createElement('div');
      totalSection.style.cssText = `
      margin-top: 50px;
      padding: 30px;
      background: #f8f9fa;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      text-align: center;
    `;

      const totalLabel = document.createElement('div');
      totalLabel.style.cssText = `
      font-weight: bold;
      margin-bottom: 20px;
      font-size: 20px;
      color: #005068;
    `;
      totalLabel.textContent = `Total Questions: ${totalQuestions}`;

      const metadataContainer = document.createElement('div');
      metadataContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-size: 15px;
      color: #666;
      margin-bottom: 20px;
    `;

      // View information
      const viewInfo = document.createElement('div');
      viewInfo.style.cssText = `
      font-weight: 500;
    `;
      viewInfo.textContent = `View: ${this.shouldShowOverallDifficulty() ? 'Overall Difficulty' : 'Course-wise Breakdown'}`;

      // Date information
      const dateInfo = document.createElement('div');
      let dateText = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
      }
      dateInfo.textContent = dateText;

      // Selected courses info
      if (!this.shouldShowOverallDifficulty() && this.selectedCourseIds.length > 0) {
        const courseInfo = document.createElement('div');
        const courseCount = this.selectedCourseIds.length;
        courseInfo.textContent = `Selected Courses: ${courseCount} course${courseCount > 1 ? 's' : ''}`;
        courseInfo.style.fontWeight = '500';
        metadataContainer.appendChild(courseInfo);
      }

      // Footer
      const footer = document.createElement('div');
      footer.style.cssText = `
      text-align: center;
      margin-top: 20px;
      padding-top: 20px;
      border-top: 3px solid #ddd;
      font-size: 14px;
      color: #666;
      font-style: italic;
    `;
      footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;

      metadataContainer.appendChild(viewInfo);
      metadataContainer.appendChild(dateInfo);

      totalSection.appendChild(totalLabel);
      totalSection.appendChild(metadataContainer);
      totalSection.appendChild(footer);

      // Assemble the container
      container.appendChild(header);
      container.appendChild(topRow);
      container.appendChild(distributionSection);
      container.appendChild(totalSection);

      document.body.appendChild(container);

      // Use html2canvas with higher quality settings
      html2canvas(container, {
        scale: 2, // Higher scale for better quality
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: container.offsetWidth,
        height: container.offsetHeight
      }).then(canvas => {
        const link = document.createElement('a');
        link.download = 'question-difficulty-analysis.png';
        link.href = canvas.toDataURL('image/png', 1.0);
        link.click();

        // Clean up
        document.body.removeChild(container);
      });
    }
  }


  // Helper method to get difficulty color
  private getDifficultyColor(difficulty: string): string {
    const difficultyColors = {
      'Easy': '#005068',
      'Medium': '#F9EDDB',
      'Hard': '#dc3545'
    };

    return difficultyColors[difficulty] || '#6c757d';
  }

  // Convert hex color to rgba with opacity
  private hexToRgba(hex: string, alpha: number): string {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  // Process assessment courses - limit to top 5 + Others
  private processAssessmentCoursesToTop5WithOthers(courses: any[]): any[] {
    if (!courses || courses.length === 0) return [];

    // Sort by count descending if not already sorted
    const sorted = [...courses].sort((a, b) => (b.count || 0) - (a.count || 0));

    if (sorted.length <= 5) {
      return sorted;
    }

    // Take top 5
    const top5 = sorted.slice(0, 5);

    // Sum remaining courses as "Others"
    const othersData = sorted.slice(5);
    const othersCount = othersData.reduce((sum, course) => sum + (course.count || 0), 0);

    if (othersCount > 0) {
      top5.push({
        course: 'Others',
        count: othersCount,
        course_id: 'others'
      });
    }

    return top5;
  }

  // Enhanced table export with course names
  // Update your imports at the top

  // Then update the exportTableAsPDF method
  exportTableAsPDF(): void {
    const totalQuestions = this.difficultyChartData.reduce((sum, item) => sum + item.value, 0);
    let dateInfo = `Date Range: ${this.selectedRange}`;
    if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
      dateInfo += ` | From: ${this.formatDisplayDate(this.startDate)} To: ${this.formatDisplayDate(this.endDate)}`;
    }
    dateInfo += ` | Total Questions: ${totalQuestions}`;

    const tableData = this.difficultyChartData
      .filter(item => item.value > 0)
      .map(item => [
        item.courseName || 'Unknown Course',
        item.name,
        item.value.toString(),
        `${this.getDifficultyPercentage(item)}%`
      ]);

    this.generateProfessionalPDF(
      'Question Difficulty Distribution - Detailed Report',
      tableData,
      ['Course Name', 'Difficulty Level', 'Count', 'Percentage'],
      'question-difficulty-detailed-report.pdf',
      dateInfo
    );
  }
  // Export table as PNG
  // Export table as PNG
  exportTableAsPNG(): void {
    const tableElement = document.querySelector('.modal-table') as HTMLElement;

    if (tableElement) {
      // Create a container for the table with styling
      const container = document.createElement('div');
      container.style.cssText = `
      position: fixed;
      left: -10000px;
      top: -10000px;
      background: white;
      padding: 30px;
      z-index: 10000;
      max-width: 900px;
      width: 900px;
      font-family: Arial, sans-serif;
    `;

      // Add title and header - MOVE THIS TO TOP
      const header = document.createElement('div');
      header.style.cssText = `
      text-align: center;
      margin-bottom: 25px;
      padding-bottom: 15px;
      border-bottom: 2px solid #005068;
    `;

      const title = document.createElement('h2');
      title.textContent = 'Question Difficulty Distribution - Detailed Table';
      title.style.cssText = `
      margin: 0 0 12px 0;
      color: #005068;
      font-size: 24px;
      font-weight: bold;
    `;

      const totalQuestions = this.difficultyChartData.reduce((sum, item) => sum + item.value, 0);
      const subtitle = document.createElement('p');
      subtitle.textContent = `Date Range: ${this.selectedRange} | Total Questions: ${totalQuestions}`;
      subtitle.style.cssText = `
      margin: 0;
      color: #666;
      font-size: 14px;
    `;

      header.appendChild(title);
      header.appendChild(subtitle);

      // Clone and style the table
      const tableClone = tableElement.cloneNode(true) as HTMLElement;
      tableClone.style.cssText = `
      width: 100%;
      border-collapse: collapse;
      font-family: Arial, sans-serif;
      font-size: 13px;
      margin-bottom: 20px;
    `;

      // Style table headers and cells for better appearance
      const thElements = tableClone.querySelectorAll('th');
      thElements.forEach(th => {
        (th as HTMLElement).style.cssText = `
        background: #005068;
        color: white;
        padding: 12px 15px;
        text-align: left;
        font-weight: bold;
        border: 1px solid #ddd;
      `;
      });

      const tdElements = tableClone.querySelectorAll('td');
      tdElements.forEach(td => {
        (td as HTMLElement).style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;
      });

      const trElements = tableClone.querySelectorAll('tr');
      trElements.forEach((tr, index) => {
        if (index > 0) { // Skip header row
          (tr as HTMLElement).style.cssText = `
          background: ${index % 2 === 0 ? '#f9f9f9' : 'white'};
        `;
        }
      });

      // Add footer
      const footer = document.createElement('div');
      footer.style.cssText = `
      text-align: center;
      margin-top: 20px;
      padding-top: 15px;
      border-top: 1px solid #ddd;
      font-size: 12px;
      color: #666;
      font-style: italic;
    `;
      footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;

      // Assemble container in correct order: Header -> Table -> Footer
      container.appendChild(header);
      container.appendChild(tableClone);
      container.appendChild(footer);

      document.body.appendChild(container);

      html2canvas(container, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff'
      }).then(canvas => {
        const link = document.createElement('a');
        link.download = 'question-difficulty-table.png';
        link.href = canvas.toDataURL('image/png');
        link.click();

        // Clean up
        document.body.removeChild(container);
      });
    }
  }
  getDisplayTotalQuestionPapers(): number {
    if (!this.isFilterApplied()) return 0;

    if (this.questionSummary && typeof this.questionSummary.total_question_papers === 'number') {
      return this.questionSummary.total_question_papers;
    }

    return this.questionCounts ? this.questionCounts.reduce((total, course) => {
      return total + (course.question_paper_count || course.total_question_papers || 0);
    }, 0) : 0;
  }

  // Active Question Papers count
  getDisplayActiveQuestionPapers(): number {
    if (!this.isFilterApplied() || !this.questionCounts) return 0;

    return this.questionCounts.reduce((total, course) => {
      return total + (course.paper_status_breakdown?.active || 0);
    }, 0);
  }
  getDisplayQuestionsWithLabel(): number {
    if (!this.isFilterApplied()) return 0;

    if (this.summaryQuestionCounts && this.summaryQuestionCounts.length > 0) {
      return this.summaryQuestionCounts.reduce((total, course) => {
        return total + (course.label_breakdown?.with_label || 0);
      }, 0);
    }
    
    return this.questionSummary?.label_summary?.with_label || 0;
  }

  getDisplayQuestionsWithoutLabel(): number {
    if (!this.isFilterApplied()) return 0;

    if (this.summaryQuestionCounts && this.summaryQuestionCounts.length > 0) {
      return this.summaryQuestionCounts.reduce((total, course) => {
        return total + (course.label_breakdown?.without_label || 0);
      }, 0);
    }
    
    return this.questionSummary?.label_summary?.without_label || 0;
  }
  getDisplayCoursesWithPapers(): number {
    return this.isFilterApplied() ?
      (this.questionCounts.filter(course => course.question_paper_count > 0).length || 0) : 0;
  }
  // Top 10 Course Chart Properties
  showTop10CourseBarChart: boolean = false;
  top10CourseBarChartData: any[] = [];
  top10CourseBarChart: Chart;
  top10CoursesByMostAssessments: any[] = []; // Store most assessments data
  top10CoursesByLeastAssessments: any[] = []; // Store least assessments data
  top10CoursesByLanguageBreakdown: any[] = []; // Store language breakdown data
  selectedTop10CourseYearRange: string = '';
  selectedTop10CourseMonth: number = new Date().getMonth() + 1;
  showTop10CourseYearDropdown: boolean = false;
  showTop10CourseMonthDropdown: boolean = false;
  showTop10CourseChartMenu: boolean = false;
  showTop10CourseTableModalFlag: boolean = false;
  selectedTop10Metric: string = 'questions';

  // Top 10 Course Filter Panel Properties
  showTop10CourseFilterPanel: boolean = false;
  activeTop10CourseFilterHeader: string = 'courses';
  top10CourseFilterHeaders = [
    { key: 'courses', name: 'Courses' },
    { key: 'status', name: 'Status' },
    { key: 'categories', name: 'Categories' },
    { key: 'languages', name: 'Languages' },
    { key: 'questionTypes', name: 'Question Types' },
    { key: 'difficulty', name: 'Difficulty Level' }
  ];
  selectedTop10CourseFilterCourseIds: number[] = [];
  filteredTop10CourseList: any[] = [];
  top10CourseSearchTerm: string = '';

  // Top 10 Course Compare Dialog Properties
  showTop10CourseCompareDialog: boolean = false;
  selectedTop10CourseCompareMonth1: number | null = null;
  selectedTop10CourseCompareMonth2: number | null = null;
  showTop10CourseCompareMonth1Dropdown: boolean = false;
  showTop10CourseCompareMonth2Dropdown: boolean = false;
  showTop10CourseComparisonResults: boolean = false;
  currentTop10CourseComparisonData: any[] = [];
  compareTop10CourseComparisonData: any[] = [];
  top10CourseTrendSummary: any[] = [];
  top10CourseComparisonChart: Chart | null = null;

  // Add these properties to your component class
  selectedTop10CourseFilterType: string = 'courses';
  selectedTop10CourseFilterValues: any[] = [];
  top10CourseFilterSearchTerm: string = '';
  filteredTop10CourseFilterOptions: any[] = [];

  // Initialize Top 10 Course Bar Chart
  private initializeTop10CourseBarChart(): void {

    const canvas = document.getElementById('top10CourseBarChart') as HTMLCanvasElement;

    if (!canvas) {
      return;
    }

    // Destroy existing chart if it exists
    if (this.top10CourseBarChart) {
      this.top10CourseBarChart.destroy();
    }

    // Filter out zero values (except for Question Papers and Assessments views)
    const nonZeroData = (this.selectedTop10Metric === 'questionPapers' || this.selectedTop10Metric === 'assessments' || this.selectedTop10Metric === 'least-assessments' || this.selectedTop10Metric === 'language-breakdown')
      ? this.top10CourseBarChartData
      : this.top10CourseBarChartData.filter(item => item.value > 0);


    if (nonZeroData.length === 0) {
      this.showTop10CourseBarChart = false;

      // Clear canvas and show message
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = '#999';
        ctx.font = '16px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('No Course Data Available', canvas.width / 2, canvas.height / 2);
      }
      return;
    }

    this.showTop10CourseBarChart = true;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      try {
        // Check if language breakdown view - create stacked bar chart
        if (this.selectedTop10Metric === 'language-breakdown') {
          this.initializeLanguageBreakdownStackedChart(ctx, nonZeroData);
        } else {
          // Regular single dataset bar chart for other metrics
          this.initializeRegularTop10CourseChart(ctx, nonZeroData);
        }

      } catch (error) {
        this.showTop10CourseBarChart = false;
      }
    }
  }

  private initializeLanguageBreakdownStackedChart(ctx: CanvasRenderingContext2D, nonZeroData: any[]): void {
    // Extract all unique languages
    const languagesSet = new Set<string>();
    const languageColors: Map<string, string> = new Map();

    nonZeroData.forEach(course => {
      if (course.languages && Array.isArray(course.languages)) {
        course.languages.forEach((lang: any) => {
          const langName = lang.language || lang.name || 'Unknown';
          languagesSet.add(langName);
        });
      }
    });

    const uniqueLanguages = Array.from(languagesSet);

    // Define colors for languages
    const languageColorPalette = [
      '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8',
      '#F7DC6F', '#BB8FCE', '#85C1E9', '#F8B88B', '#AED6F1'
    ];

    uniqueLanguages.forEach((lang, index) => {
      languageColors.set(lang, languageColorPalette[index % languageColorPalette.length]);
    });

    // Prepare labels and datasets
    const labels = nonZeroData.map(item => item.name);
    const datasets: any[] = [];

    // Create a dataset for each language
    uniqueLanguages.forEach((language, langIndex) => {
      const languageData = nonZeroData.map(course => {
        if (course.languages && Array.isArray(course.languages)) {
          const langObj = course.languages.find((l: any) => (l.language || l.name) === language);
          return langObj ? (langObj.count || 0) : 0;
        }
        return 0;
      });

      datasets.push({
        label: language,
        data: languageData,
        backgroundColor: languageColors.get(language) || languageColorPalette[langIndex % languageColorPalette.length],
        borderColor: 'rgba(0, 0, 0, 0.1)',
        borderWidth: 1,
        borderRadius: 2
      });
    });

    this.top10CourseBarChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            stacked: true,
            beginAtZero: true,
            title: {
              display: true,
              text: 'Number of Questions',
              font: {
                size: 12,
                weight: 'bold'
              }
            },
            grid: {
              color: 'rgba(0,0,0,0.1)'
            },
            ticks: {
              stepSize: 1,
              precision: 0
            }
          },
          x: {
            stacked: true,
            title: {
              display: true,
              text: 'Top 10 Courses/Job Roles',
              font: {
                size: 12,
                weight: 'bold'
              }
            },
            grid: {
              display: false
            }
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: true,
            mode: 'index',
            intersect: false,
            callbacks: {
              title: (context) => {
                if (!context || context.length === 0) return '';
                const dataIndex = context[0].dataIndex;
                const item = nonZeroData[dataIndex];
                return item ? `#${item.rank} - ${item.originalName || item.courseName || item.name}` : '';
              },
              label: (context) => {
                const languageName = context.dataset.label;
                const count = context.parsed.y || 0;
                // Only show labels for languages with data (count > 0)
                if (count > 0) {
                  return `${languageName}: ${count}`;
                }
                return '';
              }
            }
          }
        },
        animation: {
          duration: 1000,
          easing: 'easeOutQuart'
        }
      }
    });
  }

  private initializeRegularTop10CourseChart(ctx: CanvasRenderingContext2D, nonZeroData: any[]): void {
    // Prepare chart data - use truncated names for labels
    const labels = nonZeroData.map(item => item.name);
    const data = nonZeroData.map(item => item.value);
    const backgroundColors = nonZeroData.map(item => item.color);

    this.top10CourseBarChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          label: this.getTop10MetricLabel(),
          data: data,
          backgroundColor: backgroundColors,
          borderColor: backgroundColors.map(color => this.darkenColor(color, 20)),
          borderWidth: 1,
          borderRadius: 4,
          borderSkipped: false,
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: true,
            callbacks: {
              // Show full course name and rank in tooltip
              title: (context) => {
                const tooltipItem = Array.isArray(context) ? context[0] : context;
                const index = tooltipItem?.dataIndex;
                if (index === undefined || index === null) {
                  return '';
                }
                const item = nonZeroData[index];
                return item ? `#${item.rank} - ${item.originalName || item.courseName || item.name}` : '';
              },
              label: (context) => {
                const tooltipItem = Array.isArray(context) ? context[0] : context;
                const index = tooltipItem?.dataIndex;
                if (index === undefined || index === null) {
                  return '';
                }
                const item = nonZeroData[index];
                const value = (tooltipItem?.raw as number) ?? item?.value ?? 0;
                const total = data.reduce((sum, val) => sum + val, 0);
                const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                const metricLabel = this.getTop10MetricLabel();

                if (!item) {
                  return `${metricLabel}: ${value} (${percentage}%)`;
                }

                return `${metricLabel}: ${value} (${percentage}%)`;
              }
            }
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: `Number of ${this.getTop10MetricLabel()}`,
              font: {
                size: 12,
                weight: 'bold'
              }
            },
            grid: {
              color: 'rgba(0,0,0,0.1)'
            },
            ticks: {
              stepSize: 1,
              precision: 0
            }
          },
          x: {
            title: {
              display: true,
              text: 'Top 10 Courses/Job Roles',
              font: {
                size: 12,
                weight: 'bold'
              }
            },
            grid: {
              display: false
            },
            ticks: {
              autoSkip: true,
              maxRotation: 45,
              minRotation: 0,
              callback: function (value, index, values) {
                const label = this.getLabelForValue(value as number);
                return label;
              }
            }
          }
        },
        layout: {
          padding: {
            top: 20,
            right: 10,
            bottom: 20,
            left: 10
          }
        },
        animation: {
          duration: 1000,
          easing: 'easeOutQuart'
        }
      }
    });
  }
  // Get percentage for top 10 course chart
  getTop10CoursePercentage(item: any): string {
    if (!item || !this.top10CourseBarChartData || this.top10CourseBarChartData.length === 0) {
      return '0';
    }

    const total = this.top10CourseBarChartData.reduce((sum, dataItem) => {
      return sum + (dataItem?.value || 0);
    }, 0);

    return total > 0 ? (((item.value || 0) / total) * 100).toFixed(1) : '0';
  }
  // Dropdown Methods for Top 10 Course Chart
  toggleTop10CourseYearDropdown(): void {
    this.showTop10CourseYearDropdown = !this.showTop10CourseYearDropdown;
    if (this.showTop10CourseYearDropdown) {
      this.showTop10CourseMonthDropdown = false;
    }
  }

  selectTop10CourseYearRange(yearRange: string): void {
    this.selectedTop10CourseYearRange = yearRange;
    this.showTop10CourseYearDropdown = false;
    this.applyTop10CourseMonthYearFilter();
  }

  toggleTop10CourseMonthDropdown(): void {
    this.showTop10CourseMonthDropdown = !this.showTop10CourseMonthDropdown;
    if (this.showTop10CourseMonthDropdown) {
      this.showTop10CourseYearDropdown = false;
    }
  }

  selectTop10CourseMonth(month: number): void {
    this.selectedTop10CourseMonth = month;
    this.showTop10CourseMonthDropdown = false;
    this.applyTop10CourseMonthYearFilter();
  }

  applyTop10CourseMonthYearFilter(): void {

    this.showTop10CourseYearDropdown = false;
    this.showTop10CourseMonthDropdown = false;
    this.fetchTop10CourseFilteredData();
  }

  private fetchTop10CourseFilteredData(): void {

    this.isLoading = true;

    let startDate: Date;
    let endDate: Date;

    if (this.selectedTop10CourseMonth) {
      const yearRange = this.availableYearRanges.find(yr => yr.value === this.selectedTop10CourseYearRange);
      if (yearRange) {
        const year = this.selectedTop10CourseMonth <= 3 ? yearRange.endYear : yearRange.startYear;
        startDate = new Date(year, this.selectedTop10CourseMonth - 1, 1);
        endDate = new Date(year, this.selectedTop10CourseMonth, 0);
      } else {
        const currentYear = new Date().getFullYear();
        startDate = new Date(currentYear, this.selectedTop10CourseMonth - 1, 1);
        endDate = new Date(currentYear, this.selectedTop10CourseMonth, 0);
      }
    } else {
      const dateRange = this.getDateRangeFromYearRange(this.selectedTop10CourseYearRange);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');
    const resp = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    });

    resp.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {
          // Process the data like other charts
          if (response.question_counts) {
            this.questionCounts = response.question_counts.map(questionCount => {
              const courseId = questionCount.course_id ?
                (typeof questionCount.course_id === 'string' ? parseInt(questionCount.course_id) : questionCount.course_id)
                : null;
              return {
                ...questionCount,
                course_id: courseId
              };
            });
            // DO NOT update this.questionSummary - keep original summary section unchanged
          }

          // Prepare top 10 course data
          this.prepareTop10CourseData(this.questionCounts);
        } else {
          this.top10CourseBarChartData = [];
          this.showTop10CourseBarChart = false;
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      (error) => {
        this.top10CourseBarChartData = [];
        this.showTop10CourseBarChart = false;
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }
  toggleTop10CourseFilterPanel(): void {
    this.showTop10CourseFilterPanel = !this.showTop10CourseFilterPanel;

    if (this.showTop10CourseFilterPanel) {
      this.filteredTop10CourseList = [...this.courseList];
      this.activeTop10CourseFilterHeader = this.selectedTop10CourseFilterType;
      this.cdr.detectChanges();
    }
  }
  // Set active filter header with single filter logic
  setActiveTop10CourseFilterHeader(headerKey: string): void {
    this.activeTop10CourseFilterHeader = headerKey;
    this.selectedTop10CourseFilterType = headerKey;

    // Only clear filter values if switching to a different filter type
    if (headerKey !== 'courses') {
      // Keep the current filter values if they belong to the same type
      if (this.selectedTop10CourseFilterType !== headerKey) {
        this.selectedTop10CourseFilterValues = [];
      }
    }

    this.top10CourseFilterSearchTerm = '';
    this.filterTop10CourseOptions();
  }

  // Get filter options based on current filter type
  getTop10CourseFilterOptions(): any[] {
    let options: any[] = [];

    switch (this.selectedTop10CourseFilterType) {
      case 'status':
        options = this.availableStatus;
        break;
      case 'categories':
        options = this.availableCategories;
        break;
      case 'languages':
        options = this.availableLanguages;
        break;
      case 'questionTypes':
        options = this.availableQuestionTypes;
        break;
      case 'difficulty':
        options = this.difficultyLevels;
        break;
      default:
        options = [];
    }

    // Apply search filter
    if (this.top10CourseFilterSearchTerm.trim()) {
      const searchTerm = this.top10CourseFilterSearchTerm.toLowerCase().trim();
      options = options.filter(option =>
        option.label?.toLowerCase().includes(searchTerm) ||
        option.name?.toLowerCase().includes(searchTerm)
      );
    }

    return options;
  }

  // Check if a filter value is selected
  isTop10CourseFilterSelected(filterValue: any): boolean {
    return this.selectedTop10CourseFilterValues.includes(filterValue);
  }

  // Single filter selection logic
  toggleTop10CourseFilterSelection(filterValue: any): void {
    const index = this.selectedTop10CourseFilterValues.indexOf(filterValue);

    if (index > -1) {
      // Remove if already selected
      this.selectedTop10CourseFilterValues.splice(index, 1);
    } else {
      // Add to selection (multiple selections allowed within same filter type)
      this.selectedTop10CourseFilterValues.push(filterValue);
    }

    this.updateTop10CourseFilteredData();
  }

  // Clear all filters
  clearTop10CourseFilters(): void {
    this.selectedTop10CourseFilterValues = [];
    this.selectedTop10CourseFilterType = 'courses';
    this.activeTop10CourseFilterHeader = 'courses';
    this.updateTop10CourseFilteredData();
  }

  // Filter search for options
  filterTop10CourseOptions(): void {
    // The filtering is handled in getTop10CourseFilterOptions()
    this.cdr.detectChanges();
  }

  // Get active filter header name for display
  getActiveFilterHeaderName(): string {
    const header = this.top10CourseFilterHeaders.find(h => h.key === this.activeTop10CourseFilterHeader);
    return header ? header.name : 'Filter';
  }
  // Course selection methods for Top 10 Course chart
  isCourseSelectedForTop10CourseFilter(courseId: number): boolean {
    return this.selectedTop10CourseFilterCourseIds.includes(courseId);
  }

  toggleCourseSelectionForTop10CourseFilter(courseId: number): void {
    const index = this.selectedTop10CourseFilterCourseIds.indexOf(courseId);
    if (index > -1) {
      this.selectedTop10CourseFilterCourseIds.splice(index, 1);
    } else {
      this.selectedTop10CourseFilterCourseIds.push(courseId);
    }
    this.updateTop10CourseFilteredData();
  }

  areAllCoursesSelectedForTop10CourseFilter(): boolean {
    if (this.courseList.length === 0) return false;
    return this.selectedTop10CourseFilterCourseIds.length === this.courseList.length;
  }

  toggleAllCoursesSelectionForTop10CourseFilter(): void {
    if (this.areAllCoursesSelectedForTop10CourseFilter()) {
      this.selectedTop10CourseFilterCourseIds = [];
    } else {
      this.selectedTop10CourseFilterCourseIds = this.courseList.map(course => course.course_id);
    }
    this.updateTop10CourseFilteredData();
  }

  isCoursesSelectionIndeterminateForTop10CourseFilter(): boolean {
    return this.selectedTop10CourseFilterCourseIds.length > 0 &&
      this.selectedTop10CourseFilterCourseIds.length < this.courseList.length;
  }

  // Update filtered data for Top 10 Course chart
  updateTop10CourseFilteredData(): void {


    let filteredCourses = this.questionCounts;

    // Apply course filter
    if (this.selectedTop10CourseFilterCourseIds.length > 0) {
      filteredCourses = this.questionCounts.filter(course =>
        this.selectedTop10CourseFilterCourseIds.includes(course.course_id)
      );
    }

    // Apply single filter logic (status, category, language, type, difficulty)
    if (this.selectedTop10CourseFilterValues.length > 0) {
      filteredCourses = this.applyTop10CourseSingleFilter(filteredCourses);
    }

    this.prepareTop10CourseData(filteredCourses);
    this.cdr.detectChanges();
  }

  // Helper methods for question counts
  getStatusQuestionCount(statusCode: string): number {
    if (!this.questionCounts) return 0;
    let total = 0;
    this.questionCounts.forEach(course => {
      const statusCount = course.status_breakdown?.[statusCode] || 0;
      total += statusCount;
    });
    return total;
  }

  getCategoryQuestionCount(categoryCode: string): number {
    if (!this.questionCounts) return 0;
    let total = 0;
    this.questionCounts.forEach(course => {
      const categoryCount = course.question_category_breakdown?.[categoryCode] || 0;
      total += categoryCount;
    });
    return total;
  }

  getLanguageQuestionCount(languageCode: string): number {
    if (!this.questionCounts) return 0;
    let total = 0;
    this.questionCounts.forEach(course => {
      const languageCount = course.language_breakdown?.[languageCode] || 0;
      total += languageCount;
    });
    return total;
  }

  getQuestionTypeCountForType(typeCode: string): number {
    if (!this.questionCounts) return 0;
    let total = 0;
    this.questionCounts.forEach(course => {
      const typeCount = course.type_breakdown?.[typeCode] || 0;
      total += typeCount;
    });
    return total;
  }

  getDifficultyQuestionCount(difficulty: string): number {
    if (!this.questionCounts) return 0;
    let total = 0;
    this.questionCounts.forEach(course => {
      const difficultyCount = course.difficulty_breakdown?.[difficulty] || 0;
      total += difficultyCount;
    });
    return total;
  }

  // Initialize the filtered course list
  private initializeTop10CourseData(): void {

    this.selectedTop10CourseYearRange = this.selectedYearRange;
    this.selectedTop10CourseMonth = new Date().getMonth() + 1;
    this.selectedTop10Metric = 'questions';

    // Initialize filtered course list
    this.filteredTop10CourseList = [...this.courseList];
    this.filteredTop10CourseFilterOptions = [];

  }

  selectTop10Metric(metric: string): void {
    this.selectedTop10Metric = metric;
    
    // Use appropriate data source based on selected metric
    if (metric === 'assessments') {
      this.prepareTop10CoursesFromAssessmentData();
    } else if (metric === 'least-assessments') {
      this.prepareTop10CoursesFromLeastAssessmentData();
    } else if (metric === 'language-breakdown') {
      this.prepareTop10CoursesFromLanguageBreakdownData();
    } else {
      this.prepareTop10CourseData(this.questionCounts);
    }
  }
  // Export Methods for Top 10 Course Chart
  exportTop10CourseChartAsPDF(): void {
    this.closeTop10CourseChartMenu();
    if (!this.ensureHasData(this.top10CourseBarChartData)) { return; }

    if (this.top10CourseBarChart) {
      const canvas = this.top10CourseBarChart.canvas;
      const chartImage = canvas.toDataURL('image/png');

      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Add title
      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Top 10 Courses/Job Roles - Question Distribution', pageWidth / 2, 25, { align: 'center' });

      // Add source
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      pdf.text('Source: Content Library Analytics', pageWidth / 2, 32, { align: 'center' });

      // Add separator
      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      // Add chart image
      const imgProps = pdf.getImageProperties(chartImage);
      const chartWidth = pageWidth * 0.8;
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      const chartX = (pageWidth - chartWidth) / 2;
      const chartY = 45;

      pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

      // Add distribution summary
      const summaryStartY = chartY + chartHeight + 20;
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Top 10 Courses Distribution', 20, summaryStartY);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      let currentY = summaryStartY + 15;
      const totalQuestions = this.top10CourseBarChartData.reduce((sum, item) => sum + item.value, 0);

      this.top10CourseBarChartData.forEach(item => {
        const percentage = this.getTop10CoursePercentage(item);
        pdf.text(`#${item.rank} - ${item.name}: ${item.value} (${percentage}%)`, 25, currentY);
        currentY += 5;
      });

      // Add total and metadata
      currentY += 10;
      pdf.setFont('helvetica', 'bold');
      pdf.text(`Total Questions: ${totalQuestions}`, 20, currentY);

      currentY += 8;
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'italic');

      let dateRangeText = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateRangeText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
      }
      pdf.text(dateRangeText, 20, currentY);

      // Add footer
      const footerY = pageHeight - 10;
      pdf.setFontSize(8);
      pdf.setFont('helvetica', 'normal');
      pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth / 2, footerY, { align: 'center' });

      pdf.save('top-10-courses-analysis.pdf');
    }
  }

  exportTop10CourseChartAsPNG(): void {
    this.closeTop10CourseChartMenu();
    if (!this.ensureHasData(this.top10CourseBarChartData)) { return; }

    if (this.top10CourseBarChart) {
      // Create a container to combine chart and information
      const container = document.createElement('div');
      container.style.cssText = `
      position: fixed;
      left: -10000px;
      top: -10000px;
      width: 1400px;
      background: white;
      padding: 40px;
      border: 1px solid #ccc;
      z-index: 10000;
      font-family: Arial, sans-serif;
    `;

      // Create header
      const header = document.createElement('div');
      header.style.cssText = `
      text-align: center;
      margin-bottom: 40px;
      padding-bottom: 20px;
      border-bottom: 3px solid #005068;
    `;

      const title = document.createElement('h1');
      title.textContent = 'Top 10 Courses/Job Roles - Question Distribution';
      title.style.cssText = `
      margin: 0 0 12px 0;
      color: #005068;
      font-size: 32px;
      font-weight: bold;
    `;

      const subtitle = document.createElement('p');
      subtitle.textContent = 'Source: Content Library Analytics';
      subtitle.style.cssText = `
      margin: 0;
      color: #666;
      font-size: 16px;
    `;

      header.appendChild(title);
      header.appendChild(subtitle);

      // Create top row for chart and legends
      const topRow = document.createElement('div');
      topRow.style.cssText = `
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 60px;
      margin-bottom: 40px;
      padding: 30px;
      background: #f8f9fa;
      border-radius: 15px;
      min-height: 500px;
    `;

      // Chart container
      const chartContainer = document.createElement('div');
      chartContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 2;
      min-height: 500px;
    `;

      // Create a high-quality chart render
      const chartWrapper = document.createElement('div');
      chartWrapper.style.cssText = `
      width: 500px;
      height: 500px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: white;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      padding: 20px;
      box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    `;

      // Get the original chart canvas
      const originalCanvas = this.top10CourseBarChart.canvas;

      // Create a high-resolution canvas
      const highResCanvas = document.createElement('canvas');
      highResCanvas.width = 800;
      highResCanvas.height = 800;

      const ctx = highResCanvas.getContext('2d');
      if (ctx) {
        // Scale up for better quality
        ctx.scale(2, 2);

        // Set white background
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, highResCanvas.width, highResCanvas.height);

        // Draw the chart with better quality
        ctx.drawImage(originalCanvas, 0, 0, 400, 400);
      }

      const chartImg = document.createElement('img');
      chartImg.src = highResCanvas.toDataURL('image/png', 1.0);
      chartImg.style.cssText = `
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 10px;
      object-fit: contain;
    `;

      chartWrapper.appendChild(chartImg);
      chartContainer.appendChild(chartWrapper);

      // Legends container
      const legendsContainer = document.createElement('div');
      legendsContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 25px;
      flex: 1;
      min-width: 320px;
      max-width: 350px;
    `;

      // Distribution Summary Section
      const distributionSection = document.createElement('div');
      distributionSection.style.cssText = `
      margin-top: 40px;
    `;

      const distributionTitle = document.createElement('h2');
      distributionTitle.textContent = 'Top 10 Courses Distribution';
      distributionTitle.style.cssText = `
      margin: 0 0 30px 0;
      color: #005068;
      font-size: 28px;
      font-weight: bold;
      text-align: center;
      border-bottom: 3px solid #005068;
      padding-bottom: 15px;
    `;

      distributionSection.appendChild(distributionTitle);

      // Create course list with ranks
      const courseList = document.createElement('div');
      courseList.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 15px;
    `;

      this.top10CourseBarChartData.forEach(item => {
        const courseItem = document.createElement('div');
        courseItem.style.cssText = `
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        background: #f8f9fa;
        border-radius: 10px;
        border-left: 5px solid ${item.color};
      `;

        const rankAndName = document.createElement('div');
        rankAndName.style.cssText = `
        display: flex;
        align-items: center;
        gap: 15px;
        flex: 1;
      `;

        const rankBadge = document.createElement('span');
        rankBadge.textContent = `#${item.rank}`;
        rankBadge.style.cssText = `
        background: ${item.color};
        color: white;
        padding: 5px 10px;
        border-radius: 20px;
        font-weight: bold;
        font-size: 14px;
        min-width: 40px;
        text-align: center;
      `;

        const courseName = document.createElement('span');
        courseName.textContent = item.originalName || item.courseName || item.name;
        courseName.style.cssText = `
        font-weight: 500;
        font-size: 16px;
        color: #333;
      `;

        const courseStats = document.createElement('div');
        courseStats.style.cssText = `
        text-align: right;
      `;

        const count = document.createElement('div');
        count.textContent = `${item.value} questions`;
        count.style.cssText = `
        font-weight: bold;
        font-size: 16px;
        color: #005068;
      `;

        const percentage = document.createElement('div');
        percentage.textContent = `${this.getTop10CoursePercentage(item)}%`;
        percentage.style.cssText = `
        font-size: 14px;
        color: #666;
      `;

        rankAndName.appendChild(rankBadge);
        rankAndName.appendChild(courseName);
        courseStats.appendChild(count);
        courseStats.appendChild(percentage);
        courseItem.appendChild(rankAndName);
        courseItem.appendChild(courseStats);
        courseList.appendChild(courseItem);
      });

      distributionSection.appendChild(courseList);

      // Total and footer section
      const totalQuestions = this.top10CourseBarChartData.reduce((sum, item) => sum + item.value, 0);

      const totalSection = document.createElement('div');
      totalSection.style.cssText = `
      margin-top: 50px;
      padding: 30px;
      background: #f8f9fa;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      text-align: center;
    `;

      const totalLabel = document.createElement('div');
      totalLabel.style.cssText = `
      font-weight: bold;
      margin-bottom: 20px;
      font-size: 20px;
      color: #005068;
    `;
      totalLabel.textContent = `Total Questions in Top 10: ${totalQuestions}`;

      const metadataContainer = document.createElement('div');
      metadataContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-size: 15px;
      color: #666;
      margin-bottom: 20px;
    `;

      // Date information
      const dateInfo = document.createElement('div');
      let dateText = `Date Range: ${this.selectedRange}`;
      if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
        dateText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
      }
      dateInfo.textContent = dateText;

      // Footer
      const footer = document.createElement('div');
      footer.style.cssText = `
      text-align: center;
      margin-top: 20px;
      padding-top: 20px;
      border-top: 3px solid #ddd;
      font-size: 14px;
      color: #666;
      font-style: italic;
    `;
      footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;

      metadataContainer.appendChild(dateInfo);

      totalSection.appendChild(totalLabel);
      totalSection.appendChild(metadataContainer);
      totalSection.appendChild(footer);

      // Assemble the container
      container.appendChild(header);
      container.appendChild(topRow);
      container.appendChild(distributionSection);
      container.appendChild(totalSection);

      document.body.appendChild(container);

      // Use html2canvas with higher quality settings
      html2canvas(container, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: container.offsetWidth,
        height: container.offsetHeight
      }).then(canvas => {
        const link = document.createElement('a');
        link.download = 'top-10-courses-analysis.png';
        link.href = canvas.toDataURL('image/png', 1.0);
        link.click();

        // Clean up
        document.body.removeChild(container);
      });
    }
  }
  // Table Export Methods for Top 10 Course Chart
  exportTop10CourseTableAsPDF(): void {
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();

    // Add title
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Top 10 Courses/Job Roles - Detailed Report', pageWidth / 2, 20, { align: 'center' });

    // Add summary information
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');

    const totalQuestions = this.top10CourseBarChartData.reduce((sum, item) => sum + item.value, 0);

    let dateInfo = `Date Range: ${this.selectedRange}`;
    if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
      dateInfo += ` | From: ${this.formatDisplayDate(this.startDate)} To: ${this.formatDisplayDate(this.endDate)}`;
    }
    dateInfo += ` | Total Questions: ${totalQuestions}`;

    pdf.text(dateInfo, pageWidth / 2, 28, { align: 'center' });

    // Create table data
    const tableData = this.top10CourseBarChartData
      .filter(item => item.value > 0)
      .map(item => [
        item.rank.toString(),
        item.originalName || item.courseName || item.name,
        item.value.toString(),
        `${this.getTop10CoursePercentage(item)}%`
      ]);

    // Use autoTable
    autoTable(pdf, {
      startY: 35,
      head: [['Rank', 'Course Name', 'Question Count', 'Percentage']],
      body: tableData,
      theme: 'grid',
      headStyles: {
        fillColor: [0, 80, 104], // #005068
        textColor: 255,
        fontStyle: 'bold',
        fontSize: 10
      },
      styles: {
        fontSize: 9,
        cellPadding: 4,
        lineColor: [0, 0, 0],
        lineWidth: 0.1
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      },
      columnStyles: {
        0: { cellWidth: 'auto', fontStyle: 'bold' }, // Rank
        1: { cellWidth: 'auto' }, // Course Name
        2: { cellWidth: 'auto' }, // Count
        3: { cellWidth: 'auto' }  // Percentage
      },
      margin: { top: 35 }
    });

    // Add footer
    const finalY = (pdf as any).lastAutoTable?.finalY || 100;
    pdf.setFontSize(8);
    pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth / 2, finalY + 10, { align: 'center' });

    pdf.save('top-10-courses-detailed-report.pdf');
  }

  exportTop10CourseTableAsPNG(): void {
    // Create a container for the table with styling
    const container = document.createElement('div');
    container.style.cssText = `
    position: fixed;
    left: -10000px;
    top: -10000px;
    background: white;
    padding: 30px;
    z-index: 10000;
    max-width: 900px;
    width: 900px;
    font-family: Arial, sans-serif;
  `;

    // Add title and header
    const header = document.createElement('div');
    header.style.cssText = `
    text-align: center;
    margin-bottom: 25px;
    padding-bottom: 15px;
    border-bottom: 2px solid #005068;
  `;

    const title = document.createElement('h2');
    title.textContent = 'Top 10 Courses/Job Roles - Detailed Table';
    title.style.cssText = `
    margin: 0 0 12px 0;
    color: #005068;
    font-size: 24px;
    font-weight: bold;
  `;

    const totalQuestions = this.top10CourseBarChartData.reduce((sum, item) => sum + item.value, 0);
    const subtitle = document.createElement('p');
    subtitle.textContent = `Date Range: ${this.selectedRange} | Total Questions: ${totalQuestions}`;
    subtitle.style.cssText = `
    margin: 0;
    color: #666;
    font-size: 14px;
  `;

    header.appendChild(title);
    header.appendChild(subtitle);

    // Create table manually
    const tableClone = this.createTop10CourseTableForExport();
    container.appendChild(header);
    container.appendChild(tableClone);

    // Add footer
    const footer = document.createElement('div');
    footer.style.cssText = `
    text-align: center;
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid #ddd;
    font-size: 12px;
    color: #666;
    font-style: italic;
  `;
    footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;
    container.appendChild(footer);

    document.body.appendChild(container);

    html2canvas(container, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff'
    }).then(canvas => {
      const link = document.createElement('a');
      link.download = 'top-10-courses-table.png';
      link.href = canvas.toDataURL('image/png');
      link.click();

      // Clean up
      document.body.removeChild(container);
    });
  }

  // Helper method to create top 10 course table for export
  private createTop10CourseTableForExport(): HTMLElement {
    const table = document.createElement('table');
    table.style.cssText = `
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
    font-size: 13px;
    margin-bottom: 20px;
  `;

    // Create table header
    const thead = document.createElement('thead');
    const headerRow = document.createElement('tr');

    const headers = ['Rank', 'Course Name', 'Question Count', 'Percentage'];
    headers.forEach(headerText => {
      const th = document.createElement('th');
      th.textContent = headerText;
      th.style.cssText = `
      background: #005068;
      color: white;
      padding: 12px 15px;
      text-align: left;
      font-weight: bold;
      border: 1px solid #ddd;
    `;
      headerRow.appendChild(th);
    });

    thead.appendChild(headerRow);
    table.appendChild(thead);

    // Create table body
    const tbody = document.createElement('tbody');

    this.top10CourseBarChartData
      .filter(item => item.value > 0)
      .forEach((item, index) => {
        const row = document.createElement('tr');
        row.style.cssText = `
        background: ${index % 2 === 0 ? '#f9f9f9' : 'white'};
      `;

        const rankCell = document.createElement('td');
        rankCell.textContent = item.rank.toString();
        rankCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
        font-weight: bold;
      `;

        const courseCell = document.createElement('td');
        courseCell.textContent = item.originalName || item.courseName || item.name;
        courseCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        const countCell = document.createElement('td');
        countCell.textContent = item.value.toString();
        countCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        const percentageCell = document.createElement('td');
        percentageCell.textContent = `${this.getTop10CoursePercentage(item)}%`;
        percentageCell.style.cssText = `
        padding: 10px 15px;
        border: 1px solid #ddd;
        text-align: left;
      `;

        row.appendChild(rankCell);
        row.appendChild(courseCell);
        row.appendChild(countCell);
        row.appendChild(percentageCell);
        tbody.appendChild(row);
      });

    table.appendChild(tbody);
    return table;
  }
  // Compare Dialog Methods for Top 10 Course Chart
  openTop10CourseCompareDialog(): void {
    this.showTop10CourseCompareDialog = true;
    this.showTop10CourseComparisonResults = false;
    this.selectedTop10CourseCompareMonth1 = null;
    this.selectedTop10CourseCompareMonth2 = null;
  }

  closeTop10CourseCompareDialog(): void {
    this.showTop10CourseCompareDialog = false;
    this.showTop10CourseComparisonResults = false;
    this.currentTop10CourseComparisonData = [];
    this.compareTop10CourseComparisonData = [];
  }

  // Compare Month Dropdown Methods for Top 10 Course Chart
  toggleTop10CourseCompareMonth1Dropdown(): void {
    this.showTop10CourseCompareMonth1Dropdown = !this.showTop10CourseCompareMonth1Dropdown;
    if (this.showTop10CourseCompareMonth1Dropdown) {
      this.showTop10CourseCompareMonth2Dropdown = false;
    }
  }

  selectTop10CourseCompareMonth1(value: number) {
    this.selectedTop10CourseCompareMonth1 = value;
    this.showTop10CourseCompareMonth1Dropdown = false; 
  }

  toggleTop10CourseCompareMonth2Dropdown(): void {
    this.showTop10CourseCompareMonth2Dropdown = !this.showTop10CourseCompareMonth2Dropdown;
    if (this.showTop10CourseCompareMonth2Dropdown) {
      this.showTop10CourseCompareMonth1Dropdown = false;
    }
  }

  selectTop10CourseCompareMonth2(value: number) {
    this.selectedTop10CourseCompareMonth2 = value;
    this.showTop10CourseCompareMonth2Dropdown = false; 
  }

  // Load Top 10 Course Comparison Data - Month Wise
  loadTop10CourseComparisonDataMonthWise(): void {
    if (!this.selectedTop10CourseCompareMonth1 || !this.selectedTop10CourseCompareMonth2) {
      return;
    }

    this.isLoading = true;
    this.showTop10CourseComparisonResults = true;

    // Fetch comparison data
    this.fetchTop10CourseComparisonDataMonthWise();
  }

  private fetchTop10CourseComparisonDataMonthWise(): void {
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedTop10CourseCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedTop10CourseCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    // Fetch Month 1 data
    const resp1 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    // Fetch Month 2 data
    const resp2 = this.service.getContentsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Data: any[] = [];
    let month2Data: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month1Data = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processTop10CourseComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.compareTop10CourseComparisonData = [];
          this.top10CourseTrendSummary = [];
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.question_counts) {
          month2Data = response.question_counts;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processTop10CourseComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.compareTop10CourseComparisonData = [];
          this.top10CourseTrendSummary = [];
        }
      }
    );

    // Set loading complete after both requests
    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    }, 200);
  }

  private processTop10CourseComparisonDataMonthWise(month1Data: any[], month2Data: any[]): void {
    // Type guard to check if course data is valid
    const isValidCourse = (course: any): course is { course_name: string; question_count: number } => {
      return course &&
        course.course_name &&
        typeof course.question_count === 'number' &&
        course.question_count > 0;
    };

    // Process Month 1 data - top 10 courses
    const validMonth1Courses = month1Data.filter(isValidCourse);
    const sortedMonth1Courses = [...validMonth1Courses].sort((a, b) =>
      b.question_count - a.question_count
    );
    const topMonth1Courses = sortedMonth1Courses.slice(0, 10);
    const otherMonth1Total = sortedMonth1Courses.slice(10).reduce((sum, course) =>
      sum + course.question_count, 0
    );

    // Process Month 2 data - top 10 courses
    const validMonth2Courses = month2Data.filter(isValidCourse);
    const sortedMonth2Courses = [...validMonth2Courses].sort((a, b) =>
      b.question_count - a.question_count
    );
    const topMonth2Courses = sortedMonth2Courses.slice(0, 10);
    const otherMonth2Total = sortedMonth2Courses.slice(10).reduce((sum, course) =>
      sum + course.question_count, 0
    );

    // Store Month 1 data
    const month1Totals: { [key: string]: number } = {};
    topMonth1Courses.forEach(course => {
      month1Totals[course.course_name] = course.question_count;
    });
    if (otherMonth1Total > 0) {
      month1Totals['Others'] = otherMonth1Total;
    }

    this.currentTop10CourseComparisonData = Object.entries(month1Totals)
      .filter(([_, count]) => count > 0)
      .map(([courseName, count]) => ({
        name: courseName,
        value: count,
        percentage: '0',
        trend: 'neutral'
      }));

    // Store Month 2 data
    const month2Totals: { [key: string]: number } = {};
    topMonth2Courses.forEach(course => {
      month2Totals[course.course_name] = course.question_count;
    });
    if (otherMonth2Total > 0) {
      month2Totals['Others'] = otherMonth2Total;
    }

    this.compareTop10CourseComparisonData = Object.entries(month2Totals)
      .filter(([_, count]) => count > 0)
      .map(([courseName, count]) => {
        const currentItem = this.currentTop10CourseComparisonData.find(item => item.name === courseName);
        const currentValue = currentItem ? currentItem.value : 0;

        let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
        if (count > currentValue) {
          trend = 'positive';
        } else if (count < currentValue) {
          trend = 'negative';
        }

        return {
          name: courseName,
          value: count,
          percentage: '0',
          trend: trend
        };
      });

    // Calculate trend summary and initialize chart
    this.calculateTop10CourseTrendSummaryMonthWise();
  }

  private calculateTop10CourseTrendSummaryMonthWise(): void {
    const month1Name = this.getMonthName(this.selectedTop10CourseCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedTop10CourseCompareMonth2!);

    // Create summary with month names
    this.top10CourseTrendSummary = [];

    // Get all unique courses from both months
    const allCourses = new Set<string>();
    this.currentTop10CourseComparisonData.forEach(item => allCourses.add(item.name));
    this.compareTop10CourseComparisonData.forEach(item => allCourses.add(item.name));

    // Create detailed comparison for each course
    Array.from(allCourses).slice(0, 10).forEach(courseName => {
      const month1Item = this.currentTop10CourseComparisonData.find(item => item.name === courseName);
      const month2Item = this.compareTop10CourseComparisonData.find(item => item.name === courseName);

      const month1Value = month1Item ? month1Item.value : 0;
      const month2Value = month2Item ? month2Item.value : 0;

      let trendIcon = '→';
      if (month2Value > month1Value) {
        trendIcon = '↑'; // Positive trend
      } else if (month2Value < month1Value) {
        trendIcon = '↓'; // Negative trend
      }

      this.top10CourseTrendSummary.push({
        name: courseName,
        current: month1Value,
        compare: month2Value,
        change: month2Value - month1Value,
        trend: trendIcon
      });
    });

    // Initialize comparison chart
    this.initializeTop10CourseComparisonChart();
  }

  private initializeTop10CourseComparisonChart(): void {
    // Prepare data for chart
    const month1Name = this.getMonthName(this.selectedTop10CourseCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedTop10CourseCompareMonth2!);

    // Get unique courses from both datasets
    const allCourses = new Set<string>();
    this.currentTop10CourseComparisonData.forEach(item => allCourses.add(item.name));
    this.compareTop10CourseComparisonData.forEach(item => allCourses.add(item.name));

    const courseNames: string[] = Array.from(allCourses).slice(0, 10);
    const month1Data: number[] = [];
    const month2Data: number[] = [];

    courseNames.forEach(courseName => {
      const month1Item = this.currentTop10CourseComparisonData.find(item => item.name === courseName);
      const month2Item = this.compareTop10CourseComparisonData.find(item => item.name === courseName);
      month1Data.push(month1Item ? month1Item.value : 0);
      month2Data.push(month2Item ? month2Item.value : 0);
    });

    // Destroy existing chart if it exists
    if (this.top10CourseComparisonChart) {
      this.top10CourseComparisonChart.destroy();
    }

    // Delay chart initialization to ensure DOM is ready
    setTimeout(() => {
      const ctx = document.getElementById('top10CourseComparisonChart') as HTMLCanvasElement;
      if (ctx) {
        this.top10CourseComparisonChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: courseNames,
            datasets: [
              {
                label: month1Name,
                data: month1Data,
                backgroundColor: '#FF9800',
                borderColor: '#F57C00',
                borderWidth: 1
              },
              {
                label: month2Name,
                data: month2Data,
                backgroundColor: '#9C27B0',
                borderColor: '#7B1FA2',
                borderWidth: 1
              }
            ]
          },
          options: {
            indexAxis: 'y',
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: true,
                position: 'top'
              }
            },
            scales: {
              x: {
                beginAtZero: true,
                stacked: false,
                grid: {
                  display: true
                }
              },
              y: {
                stacked: false
              }
            }
          }
        });
      }
    }, 200);
  }

  // Update the filtered data preparation method
  private prepareTop10CourseData(courses: any[]): void {
    if (!courses || courses.length === 0) {
      this.top10CourseBarChartData = [];
      this.showTop10CourseBarChart = false;
      this.cdr.detectChanges();
      return;
    }

    // Apply course filter if any
    let filteredCourses = courses;
    if (this.selectedTop10CourseFilterCourseIds.length > 0) {
      filteredCourses = courses.filter(course =>
        this.selectedTop10CourseFilterCourseIds.includes(course.course_id)
      );
    }

    // Apply single filter logic (status, category, language, type, difficulty)
    if (this.selectedTop10CourseFilterValues.length > 0) {
      filteredCourses = this.applyTop10CourseSingleFilter(filteredCourses);
    }

    // Filter out courses with valid metric value for the selected Top 10 metric
    const validCourses = filteredCourses.filter(course =>
      course && course.course_name && (this.getTop10MetricValue(course) > 0)
    );

    if (validCourses.length === 0) {
      this.top10CourseBarChartData = [];
      this.showTop10CourseBarChart = false;
      this.cdr.detectChanges();
      return;
    }

    const sortedCourses = [...validCourses].sort((a, b) =>
      this.getTop10MetricValue(b) - this.getTop10MetricValue(a)
    );

    const top10Courses = sortedCourses.slice(0, 10);

    const courseColors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8'
    ];

    this.top10CourseBarChartData = [];

    top10Courses.forEach((course, index) => {
      const truncatedName = this.truncateCourseName(course.course_name, 15);
      this.top10CourseBarChartData.push({
        name: truncatedName,
        originalName: course.course_name,
        value: this.getTop10MetricValue(course),
        color: courseColors[index % courseColors.length],
        courseName: course.course_name,
        courseId: course.course_id,
        rank: index + 1
      });
    });

    this.showTop10CourseBarChart = this.top10CourseBarChartData.length > 0;
    this.cdr.detectChanges();

    if (this.showTop10CourseBarChart) {
      setTimeout(() => {
        this.initializeTop10CourseBarChart();
      }, 100);
    }
  }

  // Handle assessment data preparation - data is already top 10 sorted
  private prepareTop10CoursesFromAssessmentData(): void {
    // First, try to use the dedicated top_10_courses_by_most_assessments data
    if (this.top10CoursesByMostAssessments && this.top10CoursesByMostAssessments.length > 0) {
      this.prepareAssessmentChartFromData(this.top10CoursesByMostAssessments);
      return;
    }

    // Fallback: Try to use questionCounts data if it has assessment_count
    if (this.questionCounts && this.questionCounts.length > 0) {
      const coursesCopyWithAssessments = this.questionCounts
        .filter(course => course && course.course_name && (course.assessment_count || 0) > 0)
        .map(course => ({
          ...course,
          assessment_count: course.assessment_count || 0
        }))
        .sort((a, b) => (b.assessment_count || 0) - (a.assessment_count || 0))
        .slice(0, 10);

      if (coursesCopyWithAssessments.length > 0) {
        this.prepareAssessmentChartFromData(coursesCopyWithAssessments);
        return;
      }
    }

    // If no assessment data available, show error
    this.top10CourseBarChartData = [];
    this.showTop10CourseBarChart = false;
    this.cdr.detectChanges();
  }

  private prepareAssessmentChartFromData(assessmentData: any[]): void {
    if (!assessmentData || assessmentData.length === 0) {
      this.top10CourseBarChartData = [];
      this.showTop10CourseBarChart = false;
      this.cdr.detectChanges();
      return;
    }

    const courseColors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8'
    ];

    this.top10CourseBarChartData = [];

    // Convert assessment data to chart format
    assessmentData.forEach((course, index) => {
      const truncatedName = this.truncateCourseName(course.course_name, 15);
      this.top10CourseBarChartData.push({
        name: truncatedName,
        originalName: course.course_name,
        value: course.assessment_count || 0,
        color: courseColors[index % courseColors.length],
        courseName: course.course_name,
        courseId: course.course_id || null,
        rank: index + 1
      });
    });

    this.showTop10CourseBarChart = this.top10CourseBarChartData.length > 0;
    this.cdr.detectChanges();

    if (this.showTop10CourseBarChart) {
      setTimeout(() => {
        this.initializeTop10CourseBarChart();
      }, 100);
    }
  }

  private prepareTop10CoursesFromLeastAssessmentData(): void {
    // First, try to use the dedicated top_10_courses_by_least_assessments data
    if (this.top10CoursesByLeastAssessments && this.top10CoursesByLeastAssessments.length > 0) {
      this.prepareAssessmentChartFromData(this.top10CoursesByLeastAssessments);
      return;
    }

    // Fallback: Try to use questionCounts data if it has assessment_count
    if (this.questionCounts && this.questionCounts.length > 0) {
      const coursesCopyWithAssessments = this.questionCounts
        .filter(course => course && course.course_name && (course.assessment_count || 0) >= 0)
        .map(course => ({
          ...course,
          assessment_count: course.assessment_count || 0
        }))
        .sort((a, b) => (a.assessment_count || 0) - (b.assessment_count || 0))
        .slice(0, 10);

      if (coursesCopyWithAssessments.length > 0) {
        this.prepareAssessmentChartFromData(coursesCopyWithAssessments);
        return;
      }
    }

    // If no assessment data available, show error
    this.top10CourseBarChartData = [];
    this.showTop10CourseBarChart = false;
    this.cdr.detectChanges();
  }

  // Handle language breakdown data preparation
  private prepareTop10CoursesFromLanguageBreakdownData(): void {
    if (this.top10CoursesByLanguageBreakdown && this.top10CoursesByLanguageBreakdown.length > 0) {
      this.prepareLanguageBreakdownChartData(this.top10CoursesByLanguageBreakdown);
      return;
    }
    // If no language breakdown data available, show error
    this.top10CourseBarChartData = [];
    this.showTop10CourseBarChart = false;
    this.cdr.detectChanges();
  }

  // Prepare language breakdown chart data - shows courses with their dominant language
  private prepareLanguageBreakdownChartData(languageData: any[]): void {
    if (!languageData || languageData.length === 0) {
      this.top10CourseBarChartData = [];
      this.showTop10CourseBarChart = false;
      this.cdr.detectChanges();
      return;
    }

    const courseColors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8'
    ];

    this.top10CourseBarChartData = [];

    // Process each course and find its dominant language
    languageData.slice(0, 10).forEach((course, index) => {
      const truncatedName = this.truncateCourseName(course.course_name, 15);

      let dominantLanguage = null;
      let maxCount = 0;
      let totalCount = 0;
      let languagesArray = [];

      // Handle language_breakdown object structure
      if (course.language_breakdown && typeof course.language_breakdown === 'object') {
        // Convert object to array for processing
        languagesArray = Object.entries(course.language_breakdown).map(([language, count]) => ({
          language: language,
          count: count as number
        }));

        // Find dominant language and calculate total
        languagesArray.forEach((lang: any) => {
          const count = lang.count || 0;
          totalCount += count;
          if (count > maxCount) {
            maxCount = count;
            dominantLanguage = lang;
          }
        });
      } else if (course.languages && Array.isArray(course.languages)) {
        // Fallback for old array structure
        languagesArray = course.languages;
        course.languages.forEach((lang: any) => {
          const count = lang.count || 0;
          totalCount += count;
          if (count > maxCount) {
            maxCount = count;
            dominantLanguage = lang;
          }
        });
      } else {
        // Fallback if no language data
        totalCount = course.language_count || course.count || 0;
        dominantLanguage = { language: 'Unknown', count: totalCount };
        languagesArray = [dominantLanguage];
      }

      this.top10CourseBarChartData.push({
        name: truncatedName,
        originalName: course.course_name,
        value: totalCount,
        color: courseColors[index % courseColors.length],
        courseName: course.course_name,
        courseId: course.course_id || null,
        rank: index + 1,
        languages: languagesArray, // Store language array for tooltip
        dominantLanguage: dominantLanguage // Store dominant language info
      });
    });

    this.showTop10CourseBarChart = this.top10CourseBarChartData.length > 0;
    this.cdr.detectChanges();

    if (this.showTop10CourseBarChart) {
      setTimeout(() => {
        this.initializeTop10CourseBarChart();
      }, 100);
    }
  }

  private getTop10MetricLabel(): string {
    if (this.selectedTop10Metric === 'questionPapers') {
      return 'Question Papers';
    } else if (this.selectedTop10Metric === 'assessments') {
      return 'Assessments';
    } else if (this.selectedTop10Metric === 'least-assessments') {
      return 'Least Assessments';
    } else if (this.selectedTop10Metric === 'language-breakdown') {
      return 'Language Breakdown';
    }
    return 'Questions';
  }

  private getTop10MetricValue(course: any): number {
    if (!course) {
      return 0;
    }
    if (this.selectedTop10Metric === 'questionPapers') {
      return course.question_paper_count || course.total_question_papers || 0;
    } else if (this.selectedTop10Metric === 'assessments') {
      return course.assessment_count || course.total_assessments || 0;
    } else if (this.selectedTop10Metric === 'least-assessments') {
      return course.assessment_count || course.total_assessments || 0;
    } else if (this.selectedTop10Metric === 'language-breakdown') {
      return course.language_count || course.count || 0;
    }
    return course.question_count || 0;
  }

  private applyTop10CourseSingleFilter(courses: any[]): any[] {
    if (this.selectedTop10CourseFilterValues.length === 0) {
      return courses;
    }

    const filterType = this.selectedTop10CourseFilterType;
    const filterValues = this.selectedTop10CourseFilterValues;


    switch (filterType) {
      case 'status':
        return courses.map(course => {
          const filteredCourse = { ...course };
          if (filteredCourse.status_breakdown) {
            const filteredBreakdown = {};
            filterValues.forEach(status => {
              if (filteredCourse.status_breakdown[status] !== undefined) {
                filteredBreakdown[status] = filteredCourse.status_breakdown[status];
              }
            });
            filteredCourse.status_breakdown = filteredBreakdown;
            filteredCourse.question_count = Object.values(filteredBreakdown)
              .reduce((sum: number, count: number) => sum + count, 0);
          }
          return filteredCourse;
        }).filter(course => course.question_count > 0);

      case 'categories':
        return courses.map(course => {
          const filteredCourse = { ...course };
          if (filteredCourse.question_category_breakdown) {
            const filteredBreakdown = {};
            filterValues.forEach(category => {
              if (filteredCourse.question_category_breakdown[category] !== undefined) {
                filteredBreakdown[category] = filteredCourse.question_category_breakdown[category];
              }
            });
            filteredCourse.question_category_breakdown = filteredBreakdown;
            filteredCourse.question_count = Object.values(filteredBreakdown)
              .reduce((sum: number, count: number) => sum + count, 0);
          }
          return filteredCourse;
        }).filter(course => course.question_count > 0);

      case 'languages':
        return courses.map(course => {
          const filteredCourse = { ...course };
          if (filteredCourse.language_breakdown) {
            const filteredBreakdown = {};
            filterValues.forEach(language => {
              if (filteredCourse.language_breakdown[language] !== undefined) {
                filteredBreakdown[language] = filteredCourse.language_breakdown[language];
              }
            });
            filteredCourse.language_breakdown = filteredBreakdown;
            filteredCourse.question_count = Object.values(filteredBreakdown)
              .reduce((sum: number, count: number) => sum + count, 0);
          }
          return filteredCourse;
        }).filter(course => course.question_count > 0);

      case 'questionTypes':
        return courses.map(course => {
          const filteredCourse = { ...course };
          if (filteredCourse.type_breakdown) {
            const filteredBreakdown = {};
            filterValues.forEach(type => {
              if (filteredCourse.type_breakdown[type] !== undefined) {
                filteredBreakdown[type] = filteredCourse.type_breakdown[type];
              }
            });
            filteredCourse.type_breakdown = filteredBreakdown;
            filteredCourse.question_count = Object.values(filteredBreakdown)
              .reduce((sum: number, count: number) => sum + count, 0);
          }
          return filteredCourse;
        }).filter(course => course.question_count > 0);

      case 'difficulty':
        return courses.map(course => {
          const filteredCourse = { ...course };
          if (filteredCourse.difficulty_breakdown) {
            const filteredBreakdown = {};
            filterValues.forEach(difficulty => {
              if (filteredCourse.difficulty_breakdown[difficulty] !== undefined) {
                filteredBreakdown[difficulty] = filteredCourse.difficulty_breakdown[difficulty];
              }
            });
            filteredCourse.difficulty_breakdown = filteredBreakdown;
            filteredCourse.question_count = Object.values(filteredBreakdown)
              .reduce((sum: number, count: number) => sum + count, 0);
          }
          return filteredCourse;
        }).filter(course => course.question_count > 0);

      default:
        return courses;
    }
  }

  // Update filter header count method
  getTop10CourseFilterHeaderCount(headerKey: string): number {
    switch (headerKey) {
      case 'courses':
        return this.selectedTop10CourseFilterCourseIds.length;
      case 'status':
      case 'categories':
      case 'languages':
      case 'questionTypes':
      case 'difficulty':
        return headerKey === this.selectedTop10CourseFilterType ?
          this.selectedTop10CourseFilterValues.length : 0;
      default:
        return 0;
    }
  }

  // Helper methods for template
  getTop10CourseFilterTypeName(): string {
    const header = this.top10CourseFilterHeaders.find(f => f.key === this.selectedTop10CourseFilterType);
    return header ? header.name : this.selectedTop10CourseFilterType;
  }

  getActiveTop10CourseFilterHeaderName(): string {
    const header = this.top10CourseFilterHeaders.find(f => f.key === this.activeTop10CourseFilterHeader);
    return header ? header.name : this.activeTop10CourseFilterHeader;
  }

  // Course selection methods for top 10 course chart
  isCourseSelectedForTop10Course(courseId: number): boolean {
    return this.selectedTop10CourseFilterType === 'courses' &&
      this.selectedTop10CourseFilterValues.includes(courseId);
  }

  toggleCourseSelectionForTop10Course(courseId: number): void {
    if (this.selectedTop10CourseFilterType !== 'courses') {
      this.selectedTop10CourseFilterType = 'courses';
      this.selectedTop10CourseFilterValues = [];
    }
    this.toggleTop10CourseFilterSelection(courseId);
  }


  // Filter search methods for top 10 course chart
  filterTop10CourseCourses(): void {
    if (!this.top10CourseSearchTerm.trim()) {
      this.filteredTop10CourseList = [...this.courseList];
      return;
    }

    const searchTerm = this.top10CourseSearchTerm.toLowerCase().trim();
    this.filteredTop10CourseList = this.courseList.filter(course =>
      course.course_name.toLowerCase().includes(searchTerm)
    );
  }


  areAllCoursesSelectedForTop10Course(): boolean {
    return this.selectedTop10CourseFilterType === 'courses' &&
      this.selectedTop10CourseFilterValues.length === this.courseList.length;
  }


  toggleAllCoursesSelectionForTop10Course(): void {
    if (this.selectedTop10CourseFilterType !== 'courses') {
      this.selectedTop10CourseFilterType = 'courses';
    }

    if (this.areAllCoursesSelectedForTop10Course()) {
      this.selectedTop10CourseFilterValues = [];
    } else {
      this.selectedTop10CourseFilterValues = this.courseList.map(course => course.course_id);
    }
    this.updateTop10CourseFilteredData();
  }
  isStatusSelectedForTop10Course(statusCode: string): boolean {
    return this.selectedTop10CourseFilterType === 'status' &&
      this.selectedTop10CourseFilterValues.includes(statusCode);
  }

  toggleStatusSelectionForTop10Course(statusCode: string): void {
    if (this.selectedTop10CourseFilterType !== 'status') {
      this.selectedTop10CourseFilterType = 'status';
      this.selectedTop10CourseFilterValues = [];
    }
    this.toggleTop10CourseFilterSelection(statusCode);
  }

  areAllStatusSelectedForTop10Course(): boolean {
    return this.selectedTop10CourseFilterType === 'status' &&
      this.selectedTop10CourseFilterValues.length === this.availableStatus.length;
  }

  toggleAllStatusSelectionForTop10Course(): void {
    if (this.selectedTop10CourseFilterType !== 'status') {
      this.selectedTop10CourseFilterType = 'status';
    }

    if (this.areAllStatusSelectedForTop10Course()) {
      this.selectedTop10CourseFilterValues = [];
    } else {
      this.selectedTop10CourseFilterValues = this.availableStatus.map(status => status.value);
    }
    this.updateTop10CourseFilteredData();
  }

  isStatusSelectionIndeterminateForTop10Course(): boolean {
    return this.selectedTop10CourseFilterType === 'status' &&
      this.selectedTop10CourseFilterValues.length > 0 &&
      this.selectedTop10CourseFilterValues.length < this.availableStatus.length;
  }
  getFilteredTop10CourseStatus(): any[] {
    if (!this.top10CourseSearchTerm.trim()) {
      return this.availableStatus;
    }
    const searchTerm = this.top10CourseSearchTerm.toLowerCase().trim();
    return this.availableStatus.filter(status =>
      status.label.toLowerCase().includes(searchTerm)
    );
  }

  getStatusQuestionCountForTop10Course(statusCode: string): number {
    if (!this.questionCounts) return 0;
    let total = 0;
    this.questionCounts.forEach(course => {
      const statusCount = course.status_breakdown?.[statusCode] || 0;
      total += statusCount;
    });
    return total;
  }
  isCategorySelectedForTop10Course(categoryCode: string): boolean {
    return this.selectedTop10CourseFilterType === 'categories' &&
      this.selectedTop10CourseFilterValues.includes(categoryCode);
  }

  toggleCategorySelectionForTop10Course(categoryCode: string): void {
    if (this.selectedTop10CourseFilterType !== 'categories') {
      this.selectedTop10CourseFilterType = 'categories';
      this.selectedTop10CourseFilterValues = [];
    }
    this.toggleTop10CourseFilterSelection(categoryCode);
  }

  areAllCategoriesSelectedForTop10Course(): boolean {
    return this.selectedTop10CourseFilterType === 'categories' &&
      this.selectedTop10CourseFilterValues.length === this.availableCategories.length;
  }

  toggleAllCategoriesSelectionForTop10Course(): void {
    if (this.selectedTop10CourseFilterType !== 'categories') {
      this.selectedTop10CourseFilterType = 'categories';
    }

    if (this.areAllCategoriesSelectedForTop10Course()) {
      this.selectedTop10CourseFilterValues = [];
    } else {
      this.selectedTop10CourseFilterValues = this.availableCategories.map(category => category.value);
    }
    this.updateTop10CourseFilteredData();
  }

  isCategoriesSelectionIndeterminateForTop10Course(): boolean {
    return this.selectedTop10CourseFilterType === 'categories' &&
      this.selectedTop10CourseFilterValues.length > 0 &&
      this.selectedTop10CourseFilterValues.length < this.availableCategories.length;
  }

  getFilteredTop10CourseCategories(): any[] {
    if (!this.top10CourseSearchTerm.trim()) {
      return this.availableCategories;
    }
    const searchTerm = this.top10CourseSearchTerm.toLowerCase().trim();
    return this.availableCategories.filter(category =>
      category.label.toLowerCase().includes(searchTerm)
    );
  }

  isCoursesSelectionIndeterminateForTop10Course(): boolean {
    return this.selectedTop10CourseFilterType === 'courses' &&
      this.selectedTop10CourseFilterValues.length > 0 &&
      this.selectedTop10CourseFilterValues.length < this.courseList.length;
  }
  // Chart Menu Methods for Top 10 Course Chart
  toggleTop10CourseChartMenu(): void {
    this.showTop10CourseChartMenu = !this.showTop10CourseChartMenu;
  }

  closeTop10CourseChartMenu(): void {
    this.showTop10CourseChartMenu = false;
  }

  // Table Modal Methods for Top 10 Course Chart
  showTop10CourseTableModal(): void {
    this.closeTop10CourseChartMenu();
    this.showTop10CourseTableModalFlag = true;
  }
  getTop10CourseTableData(): any[] {
    return this.top10CourseBarChartData
      .filter(item => item.value > 0)
      .map((item, index) => {
        const baseData = {
          rank: item.rank || index + 1,
          courseName: item.originalName || item.courseName || item.name,
          questionCount: item.value,
          percentage: this.getTop10CoursePercentage(item),
          color: item.color,
          courseId: item.courseId
        };

        // Add language breakdown for language-breakdown metric
        if (this.selectedTop10Metric === 'language-breakdown' && item.languages && item.languages.length > 0) {
          const dominantLang = item.dominantLanguage;
          const dominantText = dominantLang ?
            `${dominantLang.language || dominantLang.name}: ${dominantLang.count || 0}` :
            'No language data';

          const allLanguages = item.languages
            .map((lang: any) => `${lang.language || lang.name}: ${lang.count || 0}`)
            .join(', ');

          baseData['dominantLanguage'] = dominantText;
          baseData['languageBreakdown'] = allLanguages;
        }

        return baseData;
      });
  }
  getTotalTop10CourseQuestions(): number {
    return this.top10CourseBarChartData.reduce((sum, item) => sum + item.value, 0);
  }
  getRankColor(rank: number): string {
    const rankColors = [
      '#ffff', // 1st - Primary
      '#ffff', // 2nd - Red
      '#ffff', // 3rd - Green
      '#ffff', // 4th - Yellow
      '#ffff', // 5th - Purple
      '#ffff', // 6th - Orange
      '#ffff', // 7th - Teal
      '#ffff', // 8th - Pink
      '#ffff', // 9th - Gray
      '#fff'  // 10th - Primary
    ];
    return rankColors[rank - 1] || '#6c757d';
  }

  onTop10CourseTableRowClick(courseData: any): void {
    // You can add drill-down functionality here
    // For example, navigate to course details or show more info
  }

  // 5. Add these methods for sorting (optional but useful):
  top10CourseTableSortColumn: string = 'rank';
  top10CourseTableSortDirection: 'asc' | 'desc' = 'asc';

  sortTop10CourseTable(column: string): void {
    if (this.top10CourseTableSortColumn === column) {
      this.top10CourseTableSortDirection = this.top10CourseTableSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.top10CourseTableSortColumn = column;
      this.top10CourseTableSortDirection = 'asc';
    }

    this.top10CourseBarChartData.sort((a, b) => {
      let comparison = 0;
      switch (column) {
        case 'rank':
          comparison = a.rank - b.rank;
          break;
        case 'courseName':
          comparison = (a.originalName || a.courseName).localeCompare(b.originalName || b.courseName);
          break;
        case 'questionCount':
          comparison = a.value - b.value;
          break;
        case 'percentage':
          const aPercent = parseFloat(this.getTop10CoursePercentage(a));
          const bPercent = parseFloat(this.getTop10CoursePercentage(b));
          comparison = aPercent - bPercent;
          break;
      }
      return this.top10CourseTableSortDirection === 'asc' ? comparison : -comparison;
    });
  }

  getSortIcon(column: string): string {
    if (this.top10CourseTableSortColumn !== column) {
      return '↕️';
    }
    return this.top10CourseTableSortDirection === 'asc' ? '↑' : '↓';
  }

  closeTop10CourseTableModal(): void {
    this.showTop10CourseTableModalFlag = false;
  }

  filterLanguages(): void {
    if (!this.languageSearchTerm.trim()) {
      this.filteredLanguageList = [...this.languagesData];
      return;
    }

    const searchTerm = this.languageSearchTerm.toLowerCase().trim();
    this.filteredLanguageList = this.languagesData.filter(language =>
      language.name.toLowerCase().includes(searchTerm)
    );
  }

  // Update the getLanguageFilterHeaderCount method
  getLanguageFilterHeaderCount(headerKey: string): number {
    switch (headerKey) {
      case 'courses':
        return this.selectedCourseIds.length;
      case 'languages':
        return this.selectedLanguages.length;
      case 'questionTypes':
        return this.selectedLanguageTypes.length;
      case 'evaluationMode':
        return this.selectedLanguageEvaluationModes.length;
      default:
        return 0;
    }
  }

  closeLanguageFilterPanel(): void {
    this.showLanguageFilterPanel = false;
    this.languageSearchTerm = '';
    this.languageTypeSearchTerm = '';
    this.filteredLanguageList = [...this.languagesData];
    this.filteredLanguageTypeList = [...this.availableQuestionTypes];
    this.filteredLanguageEvaluationModesList = ['Theory', 'Practical', 'Viva'];
  }

  areAllCoursesSelected(): boolean {
    if (this.courseList.length === 0) return false;
    return this.selectedCourseIds.length === this.courseList.length;
  }

  isCoursesSelectionIndeterminate(): boolean {
    return this.selectedCourseIds.length > 0 &&
      this.selectedCourseIds.length < this.courseList.length;
  }
  toggleAllCoursesSelection(): void {
    if (this.areAllCoursesSelected()) {
      this.selectedCourseIds = [];
    } else {
      this.selectedCourseIds = this.courseList.map(course => course.course_id);
    }
    // Auto-update chart
    this.updateFilteredData();
  }


  getTotalCoursesCount(): number {
    if (!this.questionCounts) return 0;
    return this.questionCounts.reduce((sum, course) => sum + course.question_count, 0);
  }

  // Difficulty Level Methods
  areAllDifficultiesSelected(): boolean {
    return this.selectedDifficultyLevels.length === this.difficultyLevels.length;
  }

  isDifficultiesSelectionIndeterminate(): boolean {
    return this.selectedDifficultyLevels.length > 0 &&
      this.selectedDifficultyLevels.length < this.difficultyLevels.length;
  }

  toggleAllDifficultiesSelection(): void {
    if (this.areAllDifficultiesSelected()) {
      this.selectedDifficultyLevels = [];
    } else {
      this.selectedDifficultyLevels = this.difficultyLevels.map(d => d.value);
    }
    // Auto-update chart
    this.updateFilteredData();
  }


  getTotalDifficultiesCount(): number {
    if (!this.questionCounts) return 0;
    let total = 0;
    this.difficultyLevels.forEach(difficulty => {
      total += this.getDifficultyQuestionCount(difficulty.value);
    });
    return total;
  }

  // Question Type Methods
  areAllQuestionTypesSelected(): boolean {
    return this.selectedQuestionTypes.length === this.availableQuestionTypes.length;
  }

  isQuestionTypesSelectionIndeterminate(): boolean {
    return this.selectedQuestionTypes.length > 0 &&
      this.selectedQuestionTypes.length < this.availableQuestionTypes.length;
  }

  toggleAllQuestionTypesSelection(): void {
    if (this.areAllQuestionTypesSelected()) {
      this.selectedQuestionTypes = [];
    } else {
      this.selectedQuestionTypes = this.availableQuestionTypes.map(type => type.value);
    }
    // Auto-update difficulty chart only
    this.updateDifficultyFilteredData();
  }

  getTotalQuestionTypesCount(): number {
    if (!this.questionSummary) return 0;

    const typeSummary = this.questionSummary.type_summary as { [key: string]: number };
    return Object.values(typeSummary).reduce((sum: number, count: number) => sum + count, 0);
  }
  getTotalLanguagesCount(): number {
    if (!this.questionSummary) return 0;

    const languageSummary = this.questionSummary.language_summary as { [key: string]: number };
    return Object.values(languageSummary).reduce((sum: number, count: number) => sum + count, 0);
  }
  // Methods
  setActiveFilterHeader(headerKey: string): void {
    this.activeFilterHeader = headerKey;
  }

  getFilterHeaderCount(headerKey: string): number {
    switch (headerKey) {
      case 'courses':
        return this.selectedCourseIds.length;
      case 'difficulty':
        return this.selectedDifficultyLevels.length;
      case 'questionTypes':
        return this.selectedQuestionTypes.length;
      case 'languages':
        return this.selectedLanguages.length;
      default:
        return 0;
    }
  }

  // Question Type Methods
  isQuestionTypeSelected(type: string): boolean {
    return this.selectedQuestionTypes.includes(type);
  }
  toggleQuestionTypeSelection(type: string): void {
    const index = this.selectedQuestionTypes.indexOf(type);
    if (index > -1) {
      this.selectedQuestionTypes.splice(index, 1);
    } else {
      this.selectedQuestionTypes.push(type);
    }
    // Auto-update difficulty chart only (not the type chart)
    this.updateDifficultyFilteredData();
  }

  getQuestionTypeCount(type: string): number {
    if (!this.questionSummary) return 0;
    return this.questionSummary.type_summary[type] || 0;
  }


  getLanguageCount(language: string): number {
    if (!this.questionSummary) return 0;
    return this.questionSummary.language_summary[language] || 0;
  }
  getTotalSelectedFilters(): number {
    return this.selectedCourseIds.length +
      this.selectedDifficultyLevels.length +
      this.selectedQuestionTypes.length +
      this.selectedLanguages.length;
  }
  selectAllDifficulties(): void {
    this.selectedDifficultyLevels = this.difficultyLevels.map(d => d.value);
  }

  clearAllDifficulties(): void {
    this.selectedDifficultyLevels = [];
  }

  // Check if any filters are active
  hasActiveFilters(): boolean {
    return this.selectedCourseIds.length > 0 || this.selectedDifficultyLevels.length > 0;
  }


  filterCoursesByDifficulty(courses: any[]): any[] {

    return courses.map(course => {
      // Create a copy of the course with filtered difficulty breakdown
      const filteredCourse = { ...course };

      if (filteredCourse.difficulty_breakdown) {
        // Filter the difficulty breakdown
        const filteredBreakdown = {};
        this.selectedDifficultyLevels.forEach(difficulty => {
          if (filteredCourse.difficulty_breakdown[difficulty] !== undefined) {
            filteredBreakdown[difficulty] = filteredCourse.difficulty_breakdown[difficulty];
          }
        });

        filteredCourse.difficulty_breakdown = filteredBreakdown;

        // Recalculate total question count for this course based on filtered difficulties
        filteredCourse.question_count = Object.values(filteredBreakdown)
          .reduce((sum: number, count: number) => sum + count, 0);
      }

      return filteredCourse;
    }).filter(course => course.question_count > 0); // Only include courses with questions in selected difficulties
  }
  // Close filter on escape key
  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent): void {
    // Close organization dropdown
    if (this.showOrgDropdown) {
      this.showOrgDropdown = false;
    }
    
    // Content Library
    this.showFilterPanel = false;
    this.showTypeFilterPanel = false;
    this.showLanguageFilterPanel = false;
    this.showCategoryFilterPanel = false;
    this.showStatusFilterPanel = false;
    this.showCourseFilterPanel = false;
    this.showQuestionPaperCourseFilterPanel = false;
    this.showQuestionPaperDifficultyFilterPanel = false;
    this.showTop10CourseFilterPanel = false;

    // Assessment
    this.showAssessmentLocationFilterPanel = false;
    this.showAssessmentCourseFilterPanel = false;
    this.showAssessmentStatusFilterPanel = false;
    this.showAssessmentEvaluationFilterPanel = false;
    this.showCandidateAssessmentFilterPanel = false;
    this.showPassFailFilterPanel = false;
    this.showDifficultyFilterPanel = false;
    this.showAssessmentCustomerFilterPanel = false;
    this.showAssessmentLanguageFilterPanel = false;
    this.showAssessmentInsightFilterPanel = false;
    this.showCandidateInsightFilterPanel = false;
    this.showQuestionPaperInsightFilterPanel = false;
    this.showGeographicInsightFilterPanel = false;
    this.showCandidatePerformanceFilterPanel = false;

    // New Course
    this.showNewCourseFilterPanel = false;
    this.showQuestionPaperCategoryFilterPanel = false;
  }


  // Apply filters method
  applyFilters(): void {
    this.closeFilterPanel();
    this.updateFilteredData();
  }

  // Reset filters method
  resetFilters(): void {
    this.selectedCourseIds = [];
    this.selectedDifficultyLevels = [];
    this.closeFilterPanel();
    this.updateFilteredData();
  }

  getSelectedFiltersText(): string {
    const courseCount = this.selectedCourseIds.length;
    const difficultyCount = this.selectedDifficultyLevels.length;

    if (courseCount === 0 && difficultyCount === 0) {
      return 'All Courses & Difficulties';
    }

    const parts = [];

    if (courseCount > 0) {
      parts.push(`${courseCount} Course${courseCount > 1 ? 's' : ''}`);
    }

    if (difficultyCount > 0) {
      const difficultyLabels = this.selectedDifficultyLevels
        .map(diff => this.difficultyLevels.find(d => d.value === diff)?.label)
        .filter(Boolean);
      parts.push(difficultyLabels.join(', '));
    }

    return parts.join(' • ');
  }
  closeFilterPanel(): void {
    this.showFilterPanel = false;
    this.courseSearchTerm = '';
    this.filteredCourseList = [...this.courseList];
  }

  // Generate unique color for each course-difficulty combination
  private generateUniqueColor(baseColor: string, difficulty: string): string {
    // Convert hex to RGB
    let R = parseInt(baseColor.substring(1, 3), 16);
    let G = parseInt(baseColor.substring(3, 5), 16);
    let B = parseInt(baseColor.substring(5, 7), 16);

    // Adjust brightness based on difficulty
    let brightnessAdjustment = 1;
    switch (difficulty) {
      case 'Easy':
        brightnessAdjustment = 1.2; // Lightest
        break;
      case 'Medium':
        brightnessAdjustment = 1.0; // Normal
        break;
      case 'Hard':
        brightnessAdjustment = 0.8; // Darkest
        break;
    }

    R = Math.min(255, Math.floor(R * brightnessAdjustment));
    G = Math.min(255, Math.floor(G * brightnessAdjustment));
    B = Math.min(255, Math.floor(B * brightnessAdjustment));

    const RR = R.toString(16).padStart(2, '0');
    const GG = G.toString(16).padStart(2, '0');
    const BB = B.toString(16).padStart(2, '0');

    return `#${RR}${GG}${BB}`;
  }


  // Update the existing methods to use new data structure
  updateDifficultyChart(): void {
    if (this.selectedCourseIds.length === 0) {
      // Show data for all courses
      this.prepareDifficultyData(this.questionCounts);
    } else {
      // Filter courses based on selected course_ids
      const filteredCourses = this.questionCounts.filter(course =>
        this.selectedCourseIds.includes(course.course_id)
      );
      this.prepareDifficultyData(filteredCourses);
    }
  }
  // Component properties for Question Papers
  selectedQuestionPaperCourseIds: number[] = [];
  selectedQuestionPaperStatuses: string[] = [];
  selectedQuestionPaperVersions: string[] = [];
  paperStatuses = [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'archived', label: 'Archived' },
    { value: 'deleted', label: 'Deleted' }
  ];
  availableVersions = [
    { value: 'v1', label: 'Version 1' },
    { value: 'v2', label: 'Version 2' },
    { value: 'v3', label: 'Version 3' }
  ];

  // Question Paper Chart Data
  questionPaperChartData: any[] = [];
  questionPaperChart: Chart;
  evaluationCriteriaList: any[] = [];
  // Prepare question paper data for chart
  // Prepare question paper data for chart
  private prepareQuestionPaperData(courses: any[]): void {

    if (!courses || courses.length === 0) {
      this.questionPaperChartData = [];
      this.showDonutChart = false;
      return;
    }

    // Check if we should show overall or course-wise
    if (this.shouldShowOverallQuestionPapers()) {
      this.prepareOverallQuestionPaperData(courses);
    } else {
      this.prepareMultipleCoursesQuestionPaperData(courses);
    }

    this.showDonutChart = this.questionPaperChartData.some(item => item.value > 0);

    // Initialize the chart
    setTimeout(() => {
      this.initializeQuestionPaperChart();
    }, 100);
  }

  // Prepare overall question paper data (aggregated)
  private prepareOverallQuestionPaperData(courses: any[]): void {

    this.questionPaperChartData = [];

    // Aggregate status counts across all selected courses
    const statusTotals = {
      'active': 0,
      'inactive': 0,
      'archived': 0,
      'deleted': 0
    };

    courses.forEach(course => {
      if (course.paper_status_breakdown) {
        statusTotals['active'] += course.paper_status_breakdown.active || 0;
        statusTotals['inactive'] += course.paper_status_breakdown.inactive || 0;
        statusTotals['archived'] += course.paper_status_breakdown.archived || 0;
        statusTotals['deleted'] += course.paper_status_breakdown.deleted || 0;
      }
    });

    // Define colors for overall status
    const overallColors = {
      'active': '#005068',
      'inactive': '#C71E1D',
      'archived': '#F9EDDB',
      'deleted': '#BFCAD9'
    };

    // Create chart data for overall status
    Object.entries(statusTotals).forEach(([status, count]) => {
      if (count > 0) {
        this.questionPaperChartData.push({
          name: status,
          value: count,
          color: overallColors[status],
          courseName: 'All Courses',
          originalCourseName: 'All Courses',
          courseId: 0,
          status: this.getStatusLabel(status)
        });
      }
    });

  }

  // Prepare course-wise question paper data
  private prepareMultipleCoursesQuestionPaperData(courses: any[]): void {
    this.questionPaperChartData = [];

    const courseColors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9',
      '#F8B195', '#F67280', '#C06C84', '#6C5B7B', '#355C7D',
      '#99B898', '#FECEAB', '#FF847C', '#E84A5F', '#2A363B'
    ];

    courses.forEach((course, courseIndex) => {
      const courseColor = courseColors[courseIndex % courseColors.length];
      const courseName = this.truncateCourseName(course.course_name || `Course ${courseIndex + 1}`);

      const statuses = [
        { name: 'active', value: course.paper_status_breakdown?.active || 0 },
        { name: 'inactive', value: course.paper_status_breakdown?.inactive || 0 },
        { name: 'archived', value: course.paper_status_breakdown?.archived || 0 },
        { name: 'deleted', value: course.paper_status_breakdown?.deleted || 0 }
      ];

      statuses.forEach(status => {
        if (status.value > 0) {
          const uniqueColor = this.generateUniqueColor(courseColor, status.name);

          this.questionPaperChartData.push({
            name: status.name,
            value: status.value,
            color: uniqueColor,
            courseName: courseName,
            originalCourseName: course.course_name,
            courseId: course.course_id,
            status: this.getStatusLabel(status.name),
            courseColor: courseColor
          });
        }
      });
    });
  }

  // Initialize the question paper chart
  private initializeQuestionPaperChart(): void {

    const canvas = document.getElementById('questionPaperDoughnutChart') as HTMLCanvasElement;

    if (!canvas) {
      return;
    }

    // Destroy existing chart if it exists
    if (this.questionPaperChart) {
      this.questionPaperChart.destroy();
    }

    // Filter out zero values for better visualization
    const nonZeroData = this.questionPaperChartData.filter(item => item.value > 0);

    if (nonZeroData.length === 0) {
      this.showDonutChart = false;
      return;
    }

    this.showDonutChart = true;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      try {
        // Create labels based on whether we're showing overall or course-wise data
        const isOverallView = this.shouldShowOverallQuestionPapers();
        const labels = isOverallView
          ? nonZeroData.map(item => item.status)
          : nonZeroData.map(item => `${this.truncateCourseName(item.courseName)} - ${item.status}`);

        this.questionPaperChart = new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: labels,
            datasets: [{
              data: nonZeroData.map(item => item.value),
              backgroundColor: nonZeroData.map(item => item.color),
              borderColor: '#fff',
              borderWidth: 0,
              hoverOffset: 0,
              hoverBorderWidth: 0,
              hoverBorderColor: 'transparent'
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  label: (context) => {
                    const index = context.dataIndex;
                    const item = nonZeroData[index];
                    const value = context.raw as number;
                    const total = nonZeroData.reduce((sum, dataItem) => sum + dataItem.value, 0);
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';

                    if (isOverallView) {
                      return [
                        `Status: ${item.status}`,
                        `Count: ${value}`,
                        `Percentage: ${percentage}%`
                      ];
                    } else {
                      return [
                        `Course: ${item.courseName}`,
                        `Status: ${item.status}`,
                        `Count: ${value}`,
                        `Percentage: ${percentage}%`
                      ];
                    }
                  }
                }
              }
            },
            cutout: '60%',
            animation: {
              animateScale: true,
              animateRotate: true
            },
            layout: {
              padding: {
                top: 10,
                right: 10,
                bottom: 20,
                left: 10
              }
            }
          }
        });
      } catch (error) {
      }
    }
  }

  // Determine whether to show overall or course-wise view for question papers
  private shouldShowOverallQuestionPapers(): boolean {
    const hasCourseFilter = this.selectedQuestionPaperCourseIds.length > 0;
    const hasStatusFilter = this.selectedQuestionPaperStatuses.length > 0;

    if (!hasCourseFilter) {
      return true;
    }

    if (this.selectedQuestionPaperCourseIds.length === this.courseList.length) {
      return true;
    }

    if (this.selectedQuestionPaperCourseIds.length === 1) {
      return false;
    }

    if (this.selectedQuestionPaperCourseIds.length > 5) {
      return true;
    }

    return false;
  }

  // Update filtered data for question papers
  updateQuestionPaperFilteredData(): void {

    let filteredCourses = this.questionCounts;

    // Apply course filter
    if (this.selectedQuestionPaperCourseIds.length > 0) {
      filteredCourses = this.questionCounts.filter(course =>
        this.selectedQuestionPaperCourseIds.includes(course.course_id)
      );
    }

    // Apply status filter
    if (this.selectedQuestionPaperStatuses.length > 0) {
      filteredCourses = this.filterCoursesByStatus(filteredCourses);
    }

    // Update the chart with filtered data
    this.prepareQuestionPaperData(filteredCourses);
    this.cdr.detectChanges();
  }

  // Filter courses by status
  filterCoursesByStatus(courses: any[]): any[] {

    return courses.map(course => {
      const filteredCourse = { ...course };

      if (filteredCourse.paper_status_breakdown) {
        const filteredBreakdown = {};
        this.selectedQuestionPaperStatuses.forEach(status => {
          if (filteredCourse.paper_status_breakdown[status] !== undefined) {
            filteredBreakdown[status] = filteredCourse.paper_status_breakdown[status];
          }
        });

        filteredCourse.paper_status_breakdown = filteredBreakdown;
        filteredCourse.question_paper_count = Object.values(filteredBreakdown)
          .reduce((sum: number, count: number) => sum + count, 0);
      }

      return filteredCourse;
    }).filter(course => course.question_paper_count > 0);
  }

  // Course selection methods for question papers
  isCourseSelectedForQuestionPapers(courseId: number): boolean {
    return this.selectedQuestionPaperCourseIds.includes(courseId);
  }

  toggleCourseSelectionForQuestionPapers(courseId: number): void {
    const index = this.selectedQuestionPaperCourseIds.indexOf(courseId);
    if (index > -1) {
      this.selectedQuestionPaperCourseIds.splice(index, 1);
    } else {
      this.selectedQuestionPaperCourseIds.push(courseId);
    }
    this.updateQuestionPaperFilteredData();
  }

  areAllCoursesSelectedForQuestionPapers(): boolean {
    if (this.courseList.length === 0) return false;
    return this.selectedQuestionPaperCourseIds.length === this.courseList.length;
  }

  toggleAllCoursesSelectionForQuestionPapers(): void {
    if (this.areAllCoursesSelectedForQuestionPapers()) {
      this.selectedQuestionPaperCourseIds = [];
    } else {
      this.selectedQuestionPaperCourseIds = this.courseList.map(course => course.course_id);
    }
    this.updateQuestionPaperFilteredData();
  }

  isCoursesSelectionIndeterminateForQuestionPapers(): boolean {
    return this.selectedQuestionPaperCourseIds.length > 0 &&
      this.selectedQuestionPaperCourseIds.length < this.courseList.length;
  }

  // Status selection methods for question papers
  isStatusSelected(status: string): boolean {
    return this.selectedQuestionPaperStatuses.includes(status);
  }

  toggleStatusSelection(status: string): void {
    const index = this.selectedQuestionPaperStatuses.indexOf(status);
    if (index > -1) {
      this.selectedQuestionPaperStatuses.splice(index, 1);
    } else {
      this.selectedQuestionPaperStatuses.push(status);
    }
    this.updateQuestionPaperFilteredData();
  }

  areAllStatusesSelected(): boolean {
    return this.selectedQuestionPaperStatuses.length === this.paperStatuses.length;
  }

  toggleAllStatusesSelection(): void {
    if (this.areAllStatusesSelected()) {
      this.selectedQuestionPaperStatuses = [];
    } else {
      this.selectedQuestionPaperStatuses = this.paperStatuses.map(s => s.value);
    }
    this.updateQuestionPaperFilteredData();
  }

  isStatusesSelectionIndeterminate(): boolean {
    return this.selectedQuestionPaperStatuses.length > 0 &&
      this.selectedQuestionPaperStatuses.length < this.paperStatuses.length;
  }

  // Version selection methods
  isVersionSelected(version: string): boolean {
    return this.selectedQuestionPaperVersions.includes(version);
  }

  toggleVersionSelection(version: string): void {
    const index = this.selectedQuestionPaperVersions.indexOf(version);
    if (index > -1) {
      this.selectedQuestionPaperVersions.splice(index, 1);
    } else {
      this.selectedQuestionPaperVersions.push(version);
    }
    this.updateQuestionPaperFilteredData();
  }

  areAllVersionsSelected(): boolean {
    return this.selectedQuestionPaperVersions.length === this.availableVersions.length;
  }

  toggleAllVersionsSelection(): void {
    if (this.areAllVersionsSelected()) {
      this.selectedQuestionPaperVersions = [];
    } else {
      this.selectedQuestionPaperVersions = this.availableVersions.map(v => v.value);
    }
    this.updateQuestionPaperFilteredData();
  }

  isVersionsSelectionIndeterminate(): boolean {
    return this.selectedQuestionPaperVersions.length > 0 &&
      this.selectedQuestionPaperVersions.length < this.availableVersions.length;
  }

  // Helper methods
  getStatusLabel(status: string): string {
    const statusObj = this.paperStatuses.find(s => s.value === status);
    return statusObj ? statusObj.label : status;
  }

  getStatusQuestionPaperCount(status: string): number {
    let total = 0;
    this.questionCounts.forEach(course => {
      if (course.paper_status_breakdown && course.paper_status_breakdown[status]) {
        total += course.paper_status_breakdown[status];
      }
    });
    return total;
  }

  getQuestionPaperPercentage(item: any): string {
    const total = this.questionPaperChartData.reduce((sum, dataItem) => sum + dataItem.value, 0);
    return total > 0 ? ((item.value / total) * 100).toFixed(1) : '0';
  }

  // Get category color based on category code
  getCategoryColor(categoryCode: string): string {
    const categoryColors: { [key: string]: string } = {
      'Theory': '#015C96',
      'Practical': '#C61E1C',
      'Viva': '#FFCC64'
    };
    return categoryColors[categoryCode] || '#95A5A6';
  }

  // Filter courses based on search term
  filterCourses(): void {
    if (!this.courseSearchTerm.trim()) {
      this.filteredCourseList = [...this.courseList];
      return;
    }

    const searchTerm = this.courseSearchTerm.toLowerCase().trim();
    this.filteredCourseList = this.courseList.filter(course =>
      course.course_name.toLowerCase().includes(searchTerm)
    );
  }

  // ============================================================
  // HELPER METHODS FOR STANDARDIZED PDF EXPORTS
  // ============================================================

  /**
   * Generate a professional PDF with consistent formatting
   * @param title - Report title
   * @param tableData - Array of rows, each row is an array of cell values
   * @param headers - Array of header column names
   * @param filename - Output PDF filename
   * @param subtitle - Optional subtitle with date/filter info
   */
  private generateProfessionalPDF(
    title: string,
    tableData: string[][],
    headers: string[],
    filename: string,
    subtitle?: string
  ): void {
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();

    // Title
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'bold');
    pdf.text(title, pageWidth / 2, 20, { align: 'center' });

    // Subtitle with date and info
    if (subtitle) {
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      pdf.text(subtitle, pageWidth / 2, 28, { align: 'center' });
    }

    // Create table
    autoTable(pdf, {
      startY: subtitle ? 35 : 28,
      head: [headers],
      body: tableData,
      theme: 'grid',
      headStyles: {
        fillColor: [0, 80, 104], // #005068 - consistent color
        textColor: 255,
        fontStyle: 'bold',
        fontSize: 10
      },
      styles: {
        fontSize: 9,
        cellPadding: 5,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        textColor: [0, 0, 0]
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      },
      margin: { top: 40, right: 10, bottom: 20, left: 10 }
    });

    // Footer with generation date
    const finalY = (pdf as any).lastAutoTable?.finalY || 100;
    pdf.setFontSize(8);
    pdf.setFont('helvetica', 'italic');
    pdf.text(`Generated on: ${new Date().toLocaleDateString()} at ${new Date().toLocaleTimeString()}`, pageWidth / 2, finalY + 10, { align: 'center' });

    pdf.save(filename);
  }

  /**
   * Generate a professional PNG image of a table with consistent styling
   * @param title - Table title
   * @param subtitle - Subtitle with date/filter info
   * @param tableData - 2D array of table data
   * @param headers - Column headers
   * @param filename - Output PNG filename
   */
  private generateProfessionalTablePNG(
    title: string,
    subtitle: string,
    tableData: string[][],
    headers: string[],
    filename: string
  ): void {
    const container = document.createElement('div');
    container.style.cssText = `
      position: fixed;
      left: -10000px;
      top: -10000px;
      background: white;
      padding: 30px;
      z-index: 10000;
      max-width: 1000px;
      width: 1000px;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    `;

    // Header
    const header = document.createElement('div');
    header.style.cssText = `
      text-align: center;
      margin-bottom: 25px;
      padding-bottom: 15px;
      border-bottom: 3px solid #005068;
    `;

    const titleEl = document.createElement('h2');
    titleEl.textContent = title;
    titleEl.style.cssText = `
      margin: 0 0 12px 0;
      color: #005068;
      font-size: 24px;
      font-weight: bold;
      letter-spacing: 0.5px;
    `;

    const subtitleEl = document.createElement('p');
    subtitleEl.textContent = subtitle;
    subtitleEl.style.cssText = `
      margin: 0;
      color: #666;
      font-size: 13px;
      font-weight: 500;
    `;

    header.appendChild(titleEl);
    header.appendChild(subtitleEl);
    container.appendChild(header);

    // Table
    const table = document.createElement('table');
    table.style.cssText = `
      width: 100%;
      border-collapse: collapse;
      margin: 20px 0;
      font-size: 13px;
    `;

    // Table header
    const thead = table.createTHead();
    const headerRow = thead.insertRow();
    headerRow.style.cssText = `
      background-color: #005068;
      color: white;
      font-weight: bold;
      text-align: left;
      border-bottom: 2px solid #005068;
    `;

    headers.forEach(header => {
      const th = headerRow.insertCell();
      th.textContent = header;
      th.style.cssText = `
        padding: 12px;
        border: 1px solid #ddd;
        font-weight: bold;
        background-color: #005068;
        color: white;
      `;
    });

    // Table body
    const tbody = table.createTBody();
    tableData.forEach((row, idx) => {
      const tr = tbody.insertRow();
      tr.style.cssText = `
        background-color: ${idx % 2 === 0 ? '#f5f5f5' : 'white'};
        border-bottom: 1px solid #ddd;
      `;
      row.forEach((cell) => {
        const td = tr.insertCell();
        td.textContent = cell;
        td.style.cssText = `
          padding: 10px 12px;
          border: 1px solid #ddd;
          text-align: left;
        `;
      });
    });

    container.appendChild(table);

    // Footer
    const footer = document.createElement('p');
    footer.textContent = `Generated on: ${new Date().toLocaleDateString()} | Page 1`;
    footer.style.cssText = `
      text-align: center;
      font-size: 11px;
      color: #999;
      margin-top: 20px;
      padding-top: 15px;
      border-top: 1px solid #ddd;
    `;
    container.appendChild(footer);

    document.body.appendChild(container);

    html2canvas(container, { scale: 2, backgroundColor: '#ffffff' }).then(canvas => {
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = filename;
      link.click();
      document.body.removeChild(container);
    }).catch(error => {
      document.body.removeChild(container);
    });
  }

  // ==================== ASSESSMENT LOCATION CHART METHODS ====================
  openAssessmentLocationCompareDialog(): void {
    this.showAssessmentLocationCompareDialog = true;
    this.showAssessmentLocationComparisonResults = false;
    this.selectedAssessmentLocationCompareMonth1 = null;
    this.selectedAssessmentLocationCompareMonth2 = null;
  }

  closeAssessmentLocationCompareDialog(): void {
    this.showAssessmentLocationCompareDialog = false;
    this.showAssessmentLocationComparisonResults = false;
    this.currentAssessmentLocationComparisonData = [];
    this.compareAssessmentLocationComparisonData = [];
  }

  toggleAssessmentLocationCompareMonth1Dropdown(): void {
    this.showAssessmentLocationCompareMonth1Dropdown = !this.showAssessmentLocationCompareMonth1Dropdown;
    if (this.showAssessmentLocationCompareMonth1Dropdown) {
      this.showAssessmentLocationCompareMonth2Dropdown = false;
    }
  }

  selectAssessmentLocationCompareMonth1(month: number): void {
    this.selectedAssessmentLocationCompareMonth1 = month;
    this.showAssessmentLocationCompareMonth1Dropdown = false;
  }

  toggleAssessmentLocationCompareMonth2Dropdown(): void {
    this.showAssessmentLocationCompareMonth2Dropdown = !this.showAssessmentLocationCompareMonth2Dropdown;
    if (this.showAssessmentLocationCompareMonth2Dropdown) {
      this.showAssessmentLocationCompareMonth1Dropdown = false;
    }
  }

  selectAssessmentLocationCompareMonth2(month: number): void {
    this.selectedAssessmentLocationCompareMonth2 = month;
    this.showAssessmentLocationCompareMonth2Dropdown = false;
  }

  loadAssessmentLocationComparisonData(): void {
    if (!this.selectedAssessmentLocationCompareMonth1 || !this.selectedAssessmentLocationCompareMonth2) {
      return;
    }

    this.isLoading = true;
    this.showAssessmentLocationComparisonResults = true;

    // Fetch comparison data
    this.fetchAssessmentLocationComparisonDataMonthWise();
  }

  private fetchAssessmentLocationComparisonDataMonthWise(): void {
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedAssessmentLocationCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedAssessmentLocationCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    // Fetch Month 1 data
    const resp1 = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    // Fetch Month 2 data
    const resp2 = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Data: any[] = [];
    let month2Data: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        console.log('Month 1 API Full Response:', data);
        let response = data?.body?.responseBody || data?.responseBody || data;
        console.log('Month 1 Extracted Response:', response);

        // Extract location data from top_states or top_districts
        if (response?.operationsData?.top_states) {
          month1Data = response.operationsData.top_states;
          console.log('Month 1 Location Counts (top_states):', month1Data);
        } else if (response?.operationsData?.top_districts) {
          month1Data = response.operationsData.top_districts;
          console.log('Month 1 Location Counts (top_districts):', month1Data);
        } else if (response?.operationsData?.location_counts) {
          month1Data = response.operationsData.location_counts;
          console.log('Month 1 Location Counts (location_counts):', month1Data);
        } else if (response && response.location_counts) {
          month1Data = response.location_counts;
          console.log('Month 1 Location Counts (Legacy):', month1Data);
        } else if (Array.isArray(response)) {
          month1Data = response;
          console.log('Month 1 Location Counts (Direct Array):', month1Data);
        } else {
          console.warn('Month 1: No location data found in response');
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentLocationComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        console.error('Month 1 API Error:', error);
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentLocationComparisonDataMonthWise(month1Data, month2Data);
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        console.log('Month 2 API Full Response:', data);
        let response = data?.body?.responseBody || data?.responseBody || data;
        console.log('Month 2 Extracted Response:', response);

        // Extract location data from top_states or top_districts
        if (response?.operationsData?.top_states) {
          month2Data = response.operationsData.top_states;
          console.log('Month 2 Location Counts (top_states):', month2Data);
        } else if (response?.operationsData?.top_districts) {
          month2Data = response.operationsData.top_districts;
          console.log('Month 2 Location Counts (top_districts):', month2Data);
        } else if (response?.operationsData?.location_counts) {
          month2Data = response.operationsData.location_counts;
          console.log('Month 2 Location Counts (location_counts):', month2Data);
        } else if (response && response.location_counts) {
          month2Data = response.location_counts;
          console.log('Month 2 Location Counts (Legacy):', month2Data);
        } else if (Array.isArray(response)) {
          month2Data = response;
          console.log('Month 2 Location Counts (Direct Array):', month2Data);
        } else {
          console.warn('Month 2: No location data found in response');
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentLocationComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        console.error('Month 2 API Error:', error);
        if (completedRequests === 2) {
          this.compareAssessmentLocationComparisonData = [];
        }
      }
    );

    // Set loading complete after both requests
    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    }, 2000);
  }

  private processAssessmentLocationComparisonDataMonthWise(month1Data: any[], month2Data: any[]): void {
    // Type guard to check if count is a number
    const isValidLocation = (location: any): location is { state: string; count: number } => {
      return location &&
        (location.state || location.location_name) &&
        typeof (location.count ?? location.assessment_count) === 'number' &&
        (location.count ?? location.assessment_count) > 0;
    };

    // Process Month 1 data
    const validMonth1Locations = month1Data.filter(isValidLocation).map((loc: any) => ({
      state: loc.state || loc.location_name,
      count: loc.count ?? loc.assessment_count
    }));
    const sortedMonth1Locations = [...validMonth1Locations].sort((a, b) =>
      b.count - a.count
    );
    const topMonth1Locations = sortedMonth1Locations.slice(0, 10);
    const otherMonth1LocationsTotal = sortedMonth1Locations.slice(10).reduce((sum, location) =>
      sum + location.count, 0
    );

    // Process Month 2 data
    const validMonth2Locations = month2Data.filter(isValidLocation).map((loc: any) => ({
      state: loc.state || loc.location_name,
      count: loc.count ?? loc.assessment_count
    }));
    const sortedMonth2Locations = [...validMonth2Locations].sort((a, b) =>
      b.count - a.count
    );
    const topMonth2Locations = sortedMonth2Locations.slice(0, 10);
    const otherMonth2LocationsTotal = sortedMonth2Locations.slice(10).reduce((sum, location) =>
      sum + location.count, 0
    );

    // Store Month 1 data as current
    const month1Totals: { [key: string]: number } = {};
    topMonth1Locations.forEach(location => {
      month1Totals[location.state] = location.count;
    });
    if (otherMonth1LocationsTotal > 0) {
      month1Totals['Others'] = otherMonth1LocationsTotal;
    }

    this.currentAssessmentLocationComparisonData = Object.entries(month1Totals)
      .filter(([_, count]) => count > 0)
      .map(([locationName, count]) => ({
        name: locationName,
        value: count,
        percentage: '0',
        trend: 'neutral'
      }));

    // Store Month 2 data as comparison
    const month2Totals: { [key: string]: number } = {};
    topMonth2Locations.forEach(location => {
      month2Totals[location.state] = location.count;
    });
    if (otherMonth2LocationsTotal > 0) {
      month2Totals['Others'] = otherMonth2LocationsTotal;
    }

    this.compareAssessmentLocationComparisonData = Object.entries(month2Totals)
      .filter(([_, count]) => count > 0)
      .map(([locationName, count]) => {
        const currentItem = this.currentAssessmentLocationComparisonData.find(item => item.name === locationName);
        const currentValue = currentItem ? currentItem.value : 0;

        let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
        if (count > currentValue) {
          trend = 'positive';
        } else if (count < currentValue) {
          trend = 'negative';
        }

        return {
          name: locationName,
          value: count,
          percentage: '0',
          trend: trend
        };
      });

    // Initialize comparison chart
    this.initializeAssessmentLocationComparisonChart();
  }

  private initializeAssessmentLocationComparisonChart(): void {
    // Prepare data for chart
    const month1Name = this.getMonthName(this.selectedAssessmentLocationCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedAssessmentLocationCompareMonth2!);

    // Get unique locations from both datasets
    const allLocations = new Set<string>();
    this.currentAssessmentLocationComparisonData.forEach(item => allLocations.add(item.name));
    this.compareAssessmentLocationComparisonData.forEach(item => allLocations.add(item.name));

    const locationNames: string[] = Array.from(allLocations).slice(0, 10);
    const month1Data: number[] = [];
    const month2Data: number[] = [];

    locationNames.forEach(locationName => {
      const month1Item = this.currentAssessmentLocationComparisonData.find(item => item.name === locationName);
      const month2Item = this.compareAssessmentLocationComparisonData.find(item => item.name === locationName);
      month1Data.push(month1Item ? month1Item.value : 0);
      month2Data.push(month2Item ? month2Item.value : 0);
    });

    // Destroy existing chart if it exists
    if (this.assessmentLocationComparisonChart) {
      this.assessmentLocationComparisonChart.destroy();
    }

    // Delay chart initialization to ensure DOM is ready
    setTimeout(() => {
      const ctx = document.getElementById('assessmentLocationComparisonChart') as HTMLCanvasElement;
      if (ctx) {
        this.assessmentLocationComparisonChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: locationNames,
            datasets: [
              {
                label: month1Name,
                data: month1Data,
                backgroundColor: '#005068',
                borderColor: '#003d4d',
                borderWidth: 1
              },
              {
                label: month2Name,
                data: month2Data,
                backgroundColor: '#BFCAD9',
                borderColor: '#9ba5b8',
                borderWidth: 1
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: true,
            indexAxis: 'y' as const,
            plugins: {
              legend: {
                position: 'top' as const
              },
              title: {
                display: true,
                text: `Month-wise Assessments Comparison: ${month1Name} vs ${month2Name}`
              }
            },
            scales: {
              x: {
                beginAtZero: true,
                stacked: false
              }
            }
          }
        });
      }
    }, 100);
  }

  openAssessmentLocationTableModal(): void {
    this.showAssessmentLocationChartMenu = false;
    this.showAssessmentLocationTableModal = true;
  }

  closeAssessmentLocationTableModal(): void {
    this.showAssessmentLocationTableModal = false;
  }

  exportAssessmentLocationAsPDF(): void {
    this.showAssessmentLocationChartMenu = false;
    if (!this.ensureHasData(this.assessmentLocationChartData)) { return; }
    if (this.assessmentLocationChart) {
      const canvas = this.assessmentLocationChart.canvas;
      const chartImage = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');
      const chartTitle = 'Assessments by Location';
      const titleWidth = pdf.getTextWidth(chartTitle);
      const titleX = (pageWidth - titleWidth) / 2;
      pdf.text(chartTitle, titleX, 25);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      const subtitle = 'Source: Assessment Planning Analytics';
      const subtitleWidth = pdf.getTextWidth(subtitle);
      const subtitleX = (pageWidth - subtitleWidth) / 2;
      pdf.text(subtitle, subtitleX, 32);

      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      const imgProps = pdf.getImageProperties(chartImage);
      const chartWidth = pageWidth - 40;
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      pdf.addImage(chartImage, 'PNG', 20, 45, chartWidth, chartHeight);

      pdf.save('Assessments_by_Location.pdf');
    }
  }

  exportAssessmentLocationAsPNG(): void {
    this.showAssessmentLocationChartMenu = false;
    if (!this.ensureHasData(this.assessmentLocationChartData)) { return; }
    if (this.assessmentLocationChart) {
      const canvas = this.assessmentLocationChart.canvas;
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = 'Assessments_by_Location.png';
      link.click();
    }
  }

  // ==================== ASSESSMENT COURSE CHART METHODS ====================
  openAssessmentCourseCompareDialog(): void {
    this.showAssessmentCourseCompareDialog = true;
    this.showAssessmentCourseComparisonResults = false;
    this.selectedAssessmentCourseCompareMonth1 = null;
    this.selectedAssessmentCourseCompareMonth2 = null;
  }

  closeAssessmentCourseCompareDialog(): void {
    this.showAssessmentCourseCompareDialog = false;
    this.showAssessmentCourseComparisonResults = false;
    this.currentAssessmentCourseComparisonData = [];
    this.compareAssessmentCourseComparisonData = [];
  }

  toggleAssessmentCourseCompareMonth1Dropdown(): void {
    this.showAssessmentCourseCompareMonth1Dropdown = !this.showAssessmentCourseCompareMonth1Dropdown;
    if (this.showAssessmentCourseCompareMonth1Dropdown) {
      this.showAssessmentCourseCompareMonth2Dropdown = false;
    }
  }

  selectAssessmentCourseCompareMonth1(month: number): void {
    this.selectedAssessmentCourseCompareMonth1 = month;
    this.showAssessmentCourseCompareMonth1Dropdown = false;
  }

  toggleAssessmentCourseCompareMonth2Dropdown(): void {
    this.showAssessmentCourseCompareMonth2Dropdown = !this.showAssessmentCourseCompareMonth2Dropdown;
    if (this.showAssessmentCourseCompareMonth2Dropdown) {
      this.showAssessmentCourseCompareMonth1Dropdown = false;
    }
  }

  selectAssessmentCourseCompareMonth2(month: number): void {
    this.selectedAssessmentCourseCompareMonth2 = month;
    this.showAssessmentCourseCompareMonth2Dropdown = false;
  }

  loadAssessmentCourseComparisonData(): void {
    if (!this.selectedAssessmentCourseCompareMonth1 || !this.selectedAssessmentCourseCompareMonth2) {
      return;
    }

    this.isLoading = true;
    this.showAssessmentCourseComparisonResults = true;

    // Fetch comparison data
    this.fetchAssessmentCourseComparisonDataMonthWise();
  }

  private fetchAssessmentCourseComparisonDataMonthWise(): void {
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedAssessmentCourseCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedAssessmentCourseCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    console.log('Assessment Course - Month 1 Date Range:', formattedMonth1StartDate, 'to', formattedMonth1EndDate);
    console.log('Assessment Course - Month 2 Date Range:', formattedMonth2StartDate, 'to', formattedMonth2EndDate);

    // Fetch Month 1 data
    const resp1 = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    // Fetch Month 2 data
    const resp2 = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Data: any[] = [];
    let month2Data: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        console.log('Assessment Course - Month 1 API Full Response:', data);
        console.log('Assessment Course - Month 1 Response Body:', data?.body);
        console.log('Assessment Course - Month 1 Response Keys:', Object.keys(data || {}));

        let response = data?.body?.responseBody || data?.responseBody || data;
        console.log('Assessment Course - Month 1 Extracted Response:', response);
        console.log('Assessment Course - Month 1 OperationsData Keys:', Object.keys(response?.operationsData || {}));
        console.log('Assessment Course - Month 1 Full Response Structure:', JSON.stringify(response, null, 2));

        // Extract course data from top_10_courses or all_courses
        if (response?.operationsData?.top_10_courses) {
          month1Data = response.operationsData.top_10_courses;
          console.log('Assessment Course - Month 1 Course Counts (top_10_courses):', month1Data);
        } else if (response?.operationsData?.all_courses) {
          month1Data = response.operationsData.all_courses;
          console.log('Assessment Course - Month 1 Course Counts (all_courses):', month1Data);
        } else if (response?.operationsData?.course_counts) {
          month1Data = response.operationsData.course_counts;
          console.log('Assessment Course - Month 1 Course Counts (course_counts):', month1Data);
        } else if (response && response.course_counts) {
          month1Data = response.course_counts;
          console.log('Assessment Course - Month 1 Course Counts (Legacy):', month1Data);
        } else if (Array.isArray(response)) {
          month1Data = response;
          console.log('Assessment Course - Month 1 Course Counts (Direct Array):', month1Data);
        } else {
          console.warn('Assessment Course - Month 1: No course data found in response. Available keys:', Object.keys(response?.operationsData || {}));
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentCourseComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        console.error('Assessment Course - Month 1 API Error:', error);
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentCourseComparisonDataMonthWise(month1Data, month2Data);
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        console.log('Assessment Course - Month 2 API Full Response:', data);
        console.log('Assessment Course - Month 2 Response Body:', data?.body);
        console.log('Assessment Course - Month 2 Response Keys:', Object.keys(data || {}));

        let response = data?.body?.responseBody || data?.responseBody || data;
        console.log('Assessment Course - Month 2 Extracted Response:', response);
        console.log('Assessment Course - Month 2 OperationsData Keys:', Object.keys(response?.operationsData || {}));
        console.log('Assessment Course - Month 2 Full Response Structure:', JSON.stringify(response, null, 2));

        // Extract course data from top_10_courses or all_courses
        if (response?.operationsData?.top_10_courses) {
          month2Data = response.operationsData.top_10_courses;
          console.log('Assessment Course - Month 2 Course Counts (top_10_courses):', month2Data);
        } else if (response?.operationsData?.all_courses) {
          month2Data = response.operationsData.all_courses;
          console.log('Assessment Course - Month 2 Course Counts (all_courses):', month2Data);
        } else if (response?.operationsData?.course_counts) {
          month2Data = response.operationsData.course_counts;
          console.log('Assessment Course - Month 2 Course Counts (course_counts):', month2Data);
        } else if (response && response.course_counts) {
          month2Data = response.course_counts;
          console.log('Assessment Course - Month 2 Course Counts (Legacy):', month2Data);
        } else if (Array.isArray(response)) {
          month2Data = response;
          console.log('Assessment Course - Month 2 Course Counts (Direct Array):', month2Data);
        } else {
          console.warn('Assessment Course - Month 2: No course data found in response. Available keys:', Object.keys(response?.operationsData || {}));
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentCourseComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        console.error('Assessment Course - Month 2 API Error:', error);
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentCourseComparisonDataMonthWise(month1Data, month2Data);
        }
      }
    );

    // Set loading complete after both requests
    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    }, 3000);
  }

  private processAssessmentCourseComparisonDataMonthWise(month1Data: any[], month2Data: any[]): void {
    console.log('Assessment Course - Processing Comparison Data:');
    console.log('Assessment Course - Month 1 Raw Data:', month1Data);
    console.log('Assessment Course - Month 2 Raw Data:', month2Data);

    // Type guard to check if count is a number - be more lenient with the property names
    const isValidCourse = (course: any): boolean => {
      const count = course?.count ?? course?.assessment_count ?? 0;
      const courseName = course?.course || course?.course_name || course?.course_id;
      return course &&
        courseName &&
        typeof count === 'number' &&
        count > 0;
    };

    // Process Month 1 data
    const validMonth1Courses = month1Data.filter(isValidCourse).map((course: any) => ({
      name: course.course || course.course_name || `Course ${course.course_id}`,
      count: course.count ?? course.assessment_count ?? 0
    }));
    console.log('Assessment Course - Valid Month 1 Courses:', validMonth1Courses);

    const sortedMonth1Courses = [...validMonth1Courses].sort((a, b) =>
      b.count - a.count
    );
    const topMonth1Courses = sortedMonth1Courses.slice(0, 10);
    const otherMonth1CoursesTotal = sortedMonth1Courses.slice(10).reduce((sum, course) =>
      sum + course.count, 0
    );

    // Process Month 2 data
    const validMonth2Courses = month2Data.filter(isValidCourse).map((course: any) => ({
      name: course.course || course.course_name || `Course ${course.course_id}`,
      count: course.count ?? course.assessment_count ?? 0
    }));
    console.log('Assessment Course - Valid Month 2 Courses:', validMonth2Courses);

    const sortedMonth2Courses = [...validMonth2Courses].sort((a, b) =>
      b.count - a.count
    );
    const topMonth2Courses = sortedMonth2Courses.slice(0, 10);
    const otherMonth2CoursesTotal = sortedMonth2Courses.slice(10).reduce((sum, course) =>
      sum + course.count, 0
    );

    // Store Month 1 data as current
    const month1Totals: { [key: string]: number } = {};
    topMonth1Courses.forEach(course => {
      month1Totals[course.name] = course.count;
    });
    if (otherMonth1CoursesTotal > 0) {
      month1Totals['Others'] = otherMonth1CoursesTotal;
    }

    this.currentAssessmentCourseComparisonData = Object.entries(month1Totals)
      .filter(([_, count]) => count > 0)
      .map(([courseName, count]) => ({
        name: courseName,
        value: count,
        percentage: '0',
        trend: 'neutral'
      }));
    console.log('Assessment Course - Current Comparison Data (Month 1):', this.currentAssessmentCourseComparisonData);

    // Store Month 2 data as comparison
    const month2Totals: { [key: string]: number } = {};
    topMonth2Courses.forEach(course => {
      month2Totals[course.name] = course.count;
    });
    if (otherMonth2CoursesTotal > 0) {
      month2Totals['Others'] = otherMonth2CoursesTotal;
    }

    this.compareAssessmentCourseComparisonData = Object.entries(month2Totals)
      .filter(([_, count]) => count > 0)
      .map(([courseName, count]) => {
        const currentItem = this.currentAssessmentCourseComparisonData.find(item => item.name === courseName);
        const currentValue = currentItem ? currentItem.value : 0;

        let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
        if (count > currentValue) {
          trend = 'positive';
        } else if (count < currentValue) {
          trend = 'negative';
        }

        return {
          name: courseName,
          value: count,
          percentage: '0',
          trend: trend
        };
      });
    console.log('Assessment Course - Compare Comparison Data (Month 2):', this.compareAssessmentCourseComparisonData);

    // Initialize comparison chart
    this.cdr.detectChanges();
    this.initializeAssessmentCourseComparisonChart();
  }

  private initializeAssessmentCourseComparisonChart(): void {
    // Prepare data for chart
    const month1Name = this.getMonthName(this.selectedAssessmentCourseCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedAssessmentCourseCompareMonth2!);

    // Get unique courses from both datasets
    const allCourses = new Set<string>();
    this.currentAssessmentCourseComparisonData.forEach(item => allCourses.add(item.name));
    this.compareAssessmentCourseComparisonData.forEach(item => allCourses.add(item.name));

    const courseNames: string[] = Array.from(allCourses).slice(0, 10);
    const month1Data: number[] = [];
    const month2Data: number[] = [];

    courseNames.forEach(courseName => {
      const month1Item = this.currentAssessmentCourseComparisonData.find(item => item.name === courseName);
      const month2Item = this.compareAssessmentCourseComparisonData.find(item => item.name === courseName);
      month1Data.push(month1Item ? month1Item.value : 0);
      month2Data.push(month2Item ? month2Item.value : 0);
    });

    console.log('Assessment Course - Chart Initialization');
    console.log('Assessment Course - Course Names:', courseNames);
    console.log('Assessment Course - Month 1 Data:', month1Data);
    console.log('Assessment Course - Month 2 Data:', month2Data);

    // Destroy existing chart if it exists
    if (this.assessmentCourseComparisonChart) {
      this.assessmentCourseComparisonChart.destroy();
    }

    // Delay chart initialization to ensure DOM is ready
    setTimeout(() => {
      const ctx = document.getElementById('assessmentCourseComparisonChart') as HTMLCanvasElement;
      if (ctx) {
        try {
          // Set minimum height for horizontal bar chart
          const container = ctx.parentElement;
          if (container) {
            const chartHeight = Math.max(courseNames.length * 40, 300);
            container.style.minHeight = chartHeight + 'px';
          }

          this.assessmentCourseComparisonChart = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: courseNames,
              datasets: [
                {
                  label: month1Name,
                  data: month1Data,
                  backgroundColor: '#005068',
                  borderColor: '#003d4d',
                  borderWidth: 1,
                  barThickness: 'flex',
                  barPercentage: 0.7
                },
                {
                  label: month2Name,
                  data: month2Data,
                  backgroundColor: '#BFCAD9',
                  borderColor: '#9ba5b8',
                  borderWidth: 1,
                  barThickness: 'flex',
                  barPercentage: 0.7
                }
              ]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              indexAxis: 'y' as const,
              plugins: {
                legend: {
                  position: 'top' as const,
                  display: true
                },
                title: {
                  display: true,
                  text: `Month-wise Assessments Comparison: ${month1Name} vs ${month2Name}`
                },
                filler: {
                  propagate: true
                }
              },
              scales: {
                x: {
                  beginAtZero: true,
                  stacked: false,
                  ticks: {
                    stepSize: 1
                  }
                },
                y: {
                  ticks: {
                    font: {
                      size: 12
                    }
                  }
                }
              }
            }
          });
          console.log('Assessment Course - Chart initialized successfully');
          this.cdr.detectChanges();
        } catch (error) {
          console.error('Assessment Course - Error initializing chart:', error);
        }
      } else {
        console.warn('Assessment Course - Canvas element "assessmentCourseComparisonChart" not found');
      }
    }, 200);
  }

  openAssessmentCourseTableModal(): void {
    this.showAssessmentCourseChartMenu = false;
    this.showAssessmentCourseTableModal = true;
  }

  closeAssessmentCourseTableModal(): void {
    this.showAssessmentCourseTableModal = false;
  }

  exportAssessmentCourseAsPDF(): void {
    this.showAssessmentCourseChartMenu = false;
    if (!this.ensureHasData(this.assessmentCourseChartData)) { return; }
    
    if (this.assessmentCourseChart) {
      // Set white background for the canvas to prevent transparency artifacts causing blur
      const canvas = this.assessmentCourseChart.canvas;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.restore();
      }

      const chartImage = canvas.toDataURL('image/png', 1.0);
      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Add title
      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');
      const chartTitle = 'Assessments by Course/Job Role';
      const titleWidth = pdf.getTextWidth(chartTitle);
      const titleX = (pageWidth - titleWidth) / 2;
      pdf.text(chartTitle, titleX, 25);

      // Add source/subtitle
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      const subtitle = 'Source: Assessment Planning Analytics';
      const subtitleWidth = pdf.getTextWidth(subtitle);
      const subtitleX = (pageWidth - subtitleWidth) / 2;
      pdf.text(subtitle, subtitleX, 32);

      // Add separator line
      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      // Add chart image
      const imgProps = pdf.getImageProperties(chartImage);
      const maxChartWidth = 130; // Limit width to prevent stretching and blurriness
      let chartWidth = pageWidth - 40;
      if (chartWidth > maxChartWidth) {
        chartWidth = maxChartWidth;
      }
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      const chartX = (pageWidth - chartWidth) / 2; // Center the chart horizontally
      const chartY = 45;

      pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

      // Add data summary below chart
      let currentY = chartY + chartHeight + 15;

      pdf.setFontSize(12);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Summary (Assessments Count):', 20, currentY);
      currentY += 8;

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      const totalAssessments = this.assessmentCourseChartData.reduce((sum, item) => sum + (item.value || 0), 0);
      
      this.assessmentCourseChartData.forEach(item => {
        const percentage = totalAssessments > 0 ? ((item.value || 0) / totalAssessments * 100).toFixed(1) : '0.0';
        const text = `${item.name}: ${item.value || 0} (${percentage}%)`;
        pdf.text(text, 20, currentY);
        currentY += 5;

        if (currentY > pageHeight - 20) {
          pdf.addPage();
          currentY = 20;
        }
      });
      
      // Add Total
      currentY += 3;
      pdf.setFont('helvetica', 'bold');
      pdf.text(`Total Assessments: ${totalAssessments}`, 20, currentY);

      pdf.save('Assessments_by_Course.pdf');
    }
  }

  exportAssessmentCourseAsPNG(): void {
    this.showAssessmentCourseChartMenu = false;
    if (!this.ensureHasData(this.assessmentCourseChartData)) { return; }
    
    if (this.assessmentCourseChart) {
      const container = document.createElement('div');
      container.style.cssText = `
        position: fixed;
        left: -10000px;
        top: -10000px;
        width: 1200px;
        background: white;
        padding: 40px;
        border: 1px solid #ccc;
        z-index: 10000;
        font-family: Arial, sans-serif;
      `;

      const header = document.createElement('div');
      header.style.cssText = `
        text-align: center;
        margin-bottom: 30px;
        padding-bottom: 20px;
        border-bottom: 2px solid #005068;
      `;

      const title = document.createElement('h1');
      title.textContent = 'Assessments by Course/Job Role';
      title.style.cssText = `
        margin: 0 0 10px 0;
        color: #005068;
        font-size: 28px;
        font-weight: bold;
      `;

      const subtitle = document.createElement('p');
      subtitle.textContent = 'Source: Assessment Planning Analytics';
      subtitle.style.cssText = 'margin: 0; color: #666; font-size: 14px;';

      header.appendChild(title);
      header.appendChild(subtitle);
      container.appendChild(header);

      const mainContent = document.createElement('div');
      mainContent.style.cssText = 'display: flex; gap: 40px; align-items: flex-start;';

      const canvas = this.assessmentCourseChart.canvas;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.restore();
      }
      
      const chartImg = document.createElement('img');
      chartImg.src = canvas.toDataURL('image/png', 1.0);
      chartImg.style.cssText = 'width: 55%; height: auto; border: 1px solid #eee; border-radius: 4px; padding: 10px; background: white;';
      mainContent.appendChild(chartImg);

      const infoSection = document.createElement('div');
      infoSection.style.cssText = 'width: 40%;';

      const infoTitle = document.createElement('h3');
      infoTitle.textContent = 'Summary';
      infoTitle.style.cssText = 'margin-top: 0; color: #005068; font-size: 20px; margin-bottom: 15px; border-bottom: 1px solid #eee; padding-bottom: 10px;';
      infoSection.appendChild(infoTitle);

      const totalAssessments = this.assessmentCourseChartData.reduce((sum, item) => sum + (item.value || 0), 0);

      this.assessmentCourseChartData.forEach((item, index) => {
        const itemDiv = document.createElement('div');
        itemDiv.style.cssText = `
          padding: 10px 15px;
          margin-bottom: 8px;
          background-color: ${index % 2 === 0 ? '#f9f9f9' : '#ffffff'};
          border-left: 4px solid ${item.color || '#005068'};
          border-radius: 3px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        `;

        const percentage = totalAssessments > 0 ? ((item.value || 0) / totalAssessments * 100).toFixed(1) : '0.0';

        itemDiv.innerHTML = `
          <span style="font-weight: 500; color: #333; max-width: 70%; word-break: break-word;">${item.name}</span>
          <span style="font-weight: bold; color: #005068;">${item.value || 0} <span style="font-size: 12px; color: #666; font-weight: normal;">(${percentage}%)</span></span>
        `;

        infoSection.appendChild(itemDiv);
      });
      
      const totalDiv = document.createElement('div');
      totalDiv.style.cssText = `
        padding: 12px 15px;
        margin-top: 15px;
        background-color: #005068;
        color: white;
        border-radius: 3px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: bold;
      `;
      totalDiv.innerHTML = `
        <span>Total Assessments</span>
        <span>${totalAssessments}</span>
      `;
      infoSection.appendChild(totalDiv);

      mainContent.appendChild(infoSection);
      container.appendChild(mainContent);

      const footer = document.createElement('div');
      footer.style.cssText = `
        margin-top: 30px;
        text-align: center;
        color: #999;
        font-size: 12px;
        border-top: 1px solid #eee;
        padding-top: 15px;
      `;
      footer.textContent = `Generated on ${new Date().toLocaleString()}`;
      container.appendChild(footer);

      document.body.appendChild(container);

      html2canvas(container, {
        backgroundColor: '#ffffff',
        scale: 2,
        logging: false,
        useCORS: true
      }).then((renderedCanvas: HTMLCanvasElement) => {
        const link = document.createElement('a');
        link.href = renderedCanvas.toDataURL('image/png', 1.0);
        link.download = 'Assessments_by_Course.png';
        link.click();
        document.body.removeChild(container);
      }).catch((err: any) => {
        console.error('Error generating PNG:', err);
        document.body.removeChild(container);
      });
    }
  }

  // ==================== ASSESSMENT STATUS CHART METHODS ====================
  openAssessmentStatusCompareDialog(): void {
    this.showAssessmentStatusCompareDialog = true;
    this.showAssessmentStatusComparisonResults = false;
    this.selectedAssessmentStatusCompareMonth1 = null;
    this.selectedAssessmentStatusCompareMonth2 = null;
  }

  closeAssessmentStatusCompareDialog(): void {
    this.showAssessmentStatusCompareDialog = false;
    this.showAssessmentStatusComparisonResults = false;
    this.currentAssessmentStatusComparisonData = [];
    this.compareAssessmentStatusComparisonData = [];
  }

  toggleAssessmentStatusCompareMonth1Dropdown(): void {
    this.showAssessmentStatusCompareMonth1Dropdown = !this.showAssessmentStatusCompareMonth1Dropdown;
    if (this.showAssessmentStatusCompareMonth1Dropdown) {
      this.showAssessmentStatusCompareMonth2Dropdown = false;
    }
  }

  selectAssessmentStatusCompareMonth1(month: number): void {
    this.selectedAssessmentStatusCompareMonth1 = month;
    this.showAssessmentStatusCompareMonth1Dropdown = false;
  }

  toggleAssessmentStatusCompareMonth2Dropdown(): void {
    this.showAssessmentStatusCompareMonth2Dropdown = !this.showAssessmentStatusCompareMonth2Dropdown;
    if (this.showAssessmentStatusCompareMonth2Dropdown) {
      this.showAssessmentStatusCompareMonth1Dropdown = false;
    }
  }

  selectAssessmentStatusCompareMonth2(month: number): void {
    this.selectedAssessmentStatusCompareMonth2 = month;
    this.showAssessmentStatusCompareMonth2Dropdown = false;
  }

  loadAssessmentStatusComparisonDataMonthWise(): void {
    if (!this.selectedAssessmentStatusCompareMonth1 || !this.selectedAssessmentStatusCompareMonth2) {
      return;
    }

    this.isLoading = true;
    this.showAssessmentStatusComparisonResults = true;

    // Fetch comparison data
    this.fetchAssessmentStatusComparisonDataMonthWise();
  }

  private fetchAssessmentStatusComparisonDataMonthWise(): void {
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedAssessmentStatusCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedAssessmentStatusCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    console.log('Assessment Status - Month 1 Date Range:', formattedMonth1StartDate, 'to', formattedMonth1EndDate);
    console.log('Assessment Status - Month 2 Date Range:', formattedMonth2StartDate, 'to', formattedMonth2EndDate);

    // Fetch Month 1 data
    const resp1 = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    // Fetch Month 2 data
    const resp2 = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Data: any[] = [];
    let month2Data: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        console.log('Assessment Status - Month 1 API Full Response:', data);
        console.log('Assessment Status - Month 1 Response Body:', data?.body);
        console.log('Assessment Status - Month 1 Response Keys:', Object.keys(data || {}));

        let response = data?.body?.responseBody || data?.responseBody || data;
        console.log('Assessment Status - Month 1 Extracted Response:', response);

        // Extract assessment_status from operationsData
        if (response?.operationsData?.assessment_status) {
          const statusObj = response.operationsData.assessment_status;
          // Convert object to array format
          month1Data = Object.entries(statusObj).map(([status, count]) => ({
            status: status,
            count: count as number
          }));
          console.log('Assessment Status - Month 1 Status Counts:', month1Data);
        } else if (response && response.status_counts) {
          month1Data = response.status_counts;
          console.log('Assessment Status - Month 1 Status Counts (Legacy):', month1Data);
        } else {
          console.warn('Assessment Status - Month 1: No assessment_status found in response. Response structure:', JSON.stringify(response, null, 2));
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentStatusComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        console.error('Assessment Status - Month 1 API Error:', error);
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentStatusComparisonDataMonthWise(month1Data, month2Data);
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        console.log('Assessment Status - Month 2 API Full Response:', data);
        console.log('Assessment Status - Month 2 Response Body:', data?.body);
        console.log('Assessment Status - Month 2 Response Keys:', Object.keys(data || {}));

        let response = data?.body?.responseBody || data?.responseBody || data;
        console.log('Assessment Status - Month 2 Extracted Response:', response);

        // Extract assessment_status from operationsData
        if (response?.operationsData?.assessment_status) {
          const statusObj = response.operationsData.assessment_status;
          // Convert object to array format
          month2Data = Object.entries(statusObj).map(([status, count]) => ({
            status: status,
            count: count as number
          }));
          console.log('Assessment Status - Month 2 Status Counts:', month2Data);
        } else if (response && response.status_counts) {
          month2Data = response.status_counts;
          console.log('Assessment Status - Month 2 Status Counts (Legacy):', month2Data);
        } else {
          console.warn('Assessment Status - Month 2: No assessment_status found in response. Response structure:', JSON.stringify(response, null, 2));
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentStatusComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        console.error('Assessment Status - Month 2 API Error:', error);
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentStatusComparisonDataMonthWise(month1Data, month2Data);
        }
      }
    );

    // Set loading complete after both requests
    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    }, 3000);
  }

  private processAssessmentStatusComparisonDataMonthWise(month1Data: any[], month2Data: any[]): void {
    console.log('Assessment Status - Processing Comparison Data:');
    console.log('Assessment Status - Month 1 Raw Data:', month1Data);
    console.log('Assessment Status - Month 2 Raw Data:', month2Data);

    // Type guard to check if count is a number
    const isValidStatus = (status: any): status is { status: string; count: number } => {
      return status &&
        typeof (status.count) === 'number' &&
        (status.count) > 0;
    };

    // Process Month 1 data
    const validMonth1Statuses = month1Data.filter(isValidStatus).map((stat: any) => ({
      status: stat.status || stat.assessment_status,
      count: stat.count ?? stat.assessment_count
    }));
    console.log('Assessment Status - Valid Month 1 Statuses:', validMonth1Statuses);

    const month1Totals: { [key: string]: number } = {};
    validMonth1Statuses.forEach(status => {
      month1Totals[status.status] = status.count;
    });

    this.currentAssessmentStatusComparisonData = Object.entries(month1Totals)
      .filter(([_, count]) => count > 0)
      .map(([statusName, count]) => ({
        name: statusName,
        value: count,
        percentage: '0',
        trend: 'neutral'
      }));
    console.log('Assessment Status - Current Comparison Data (Month 1):', this.currentAssessmentStatusComparisonData);

    // Process Month 2 data
    const validMonth2Statuses = month2Data.filter(isValidStatus).map((stat: any) => ({
      status: stat.status || stat.assessment_status,
      count: stat.count ?? stat.assessment_count
    }));
    console.log('Assessment Status - Valid Month 2 Statuses:', validMonth2Statuses);

    const month2Totals: { [key: string]: number } = {};
    validMonth2Statuses.forEach(status => {
      month2Totals[status.status] = status.count;
    });

    this.compareAssessmentStatusComparisonData = Object.entries(month2Totals)
      .filter(([_, count]) => count > 0)
      .map(([statusName, count]) => {
        const currentItem = this.currentAssessmentStatusComparisonData.find(item => item.name === statusName);
        const currentValue = currentItem ? currentItem.value : 0;

        let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
        if (count > currentValue) {
          trend = 'positive';
        } else if (count < currentValue) {
          trend = 'negative';
        }

        return {
          name: statusName,
          value: count,
          percentage: '0',
          trend: trend
        };
      });
    console.log('Assessment Status - Compare Comparison Data (Month 2):', this.compareAssessmentStatusComparisonData);

    // Initialize comparison chart
    this.cdr.detectChanges();
    this.initializeAssessmentStatusComparisonChart();
  }

  private initializeAssessmentStatusComparisonChart(): void {
    // Prepare data for chart
    const month1Name = this.getMonthName(this.selectedAssessmentStatusCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedAssessmentStatusCompareMonth2!);

    // Get unique statuses from both datasets
    const allStatuses = new Set<string>();
    this.currentAssessmentStatusComparisonData.forEach(item => allStatuses.add(item.name));
    this.compareAssessmentStatusComparisonData.forEach(item => allStatuses.add(item.name));

    const statusNames: string[] = Array.from(allStatuses);
    const month1Data: number[] = [];
    const month2Data: number[] = [];

    statusNames.forEach(statusName => {
      const month1Item = this.currentAssessmentStatusComparisonData.find(item => item.name === statusName);
      const month2Item = this.compareAssessmentStatusComparisonData.find(item => item.name === statusName);
      month1Data.push(month1Item ? month1Item.value : 0);
      month2Data.push(month2Item ? month2Item.value : 0);
    });

    console.log('Assessment Status - Chart Initialization');
    console.log('Assessment Status - Status Names:', statusNames);
    console.log('Assessment Status - Month 1 Data:', month1Data);
    console.log('Assessment Status - Month 2 Data:', month2Data);

    // Destroy existing chart if it exists
    if (this.assessmentStatusComparisonChart) {
      this.assessmentStatusComparisonChart.destroy();
    }

    // Delay chart initialization to ensure DOM is ready
    setTimeout(() => {
      const ctx = document.getElementById('assessmentStatusComparisonChart') as HTMLCanvasElement;
      if (ctx) {
        try {
          this.assessmentStatusComparisonChart = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: statusNames,
              datasets: [
                {
                  label: month1Name,
                  data: month1Data,
                  backgroundColor: '#FF9800',
                  borderColor: '#F57C00',
                  borderWidth: 1
                },
                {
                  label: month2Name,
                  data: month2Data,
                  backgroundColor: '#9C27B0',
                  borderColor: '#7B1FA2',
                  borderWidth: 1
                }
              ]
            },
            options: {
              indexAxis: 'y',
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: true,
                  position: 'top'
                }
              },
              scales: {
                x: {
                  beginAtZero: true,
                  stacked: false,
                  grid: {
                    display: true
                  }
                },
                y: {
                  stacked: false
                }
              }
            }
          });
          console.log('Assessment Status - Chart initialized successfully');
          this.cdr.detectChanges();
        } catch (error) {
          console.error('Assessment Status - Error initializing chart:', error);
        }
      } else {
        console.warn('Assessment Status - Canvas element "assessmentStatusComparisonChart" not found');
      }
    }, 200);
  }

  openAssessmentStatusTableModal(): void {
    this.showAssessmentStatusChartMenu = false;
    this.showAssessmentStatusTableModal = true;
  }

  closeAssessmentStatusTableModal(): void {
    this.showAssessmentStatusTableModal = false;
  }

  exportAssessmentStatusAsPDF(): void {
    if (!this.ensureHasData(this.assessmentStatusChartData)) { return; }
    this.showAssessmentStatusChartMenu = false;
    
    if (this.assessmentStatusChart) {
      const canvas = this.assessmentStatusChart.canvas;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.restore();
      }

      const chartImage = canvas.toDataURL('image/png', 1.0);
      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Add title
      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');
      const chartTitle = 'Assessments by Status';
      const titleWidth = pdf.getTextWidth(chartTitle);
      const titleX = (pageWidth - titleWidth) / 2;
      pdf.text(chartTitle, titleX, 25);

      // Add source/subtitle
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      const subtitle = 'Source: Assessment Planning Analytics';
      const subtitleWidth = pdf.getTextWidth(subtitle);
      const subtitleX = (pageWidth - subtitleWidth) / 2;
      pdf.text(subtitle, subtitleX, 32);

      // Add separator line
      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      // Add chart image
      const imgProps = pdf.getImageProperties(chartImage);
      const maxChartWidth = 130;
      let chartWidth = pageWidth - 40;
      if (chartWidth > maxChartWidth) {
        chartWidth = maxChartWidth;
      }
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      const chartX = (pageWidth - chartWidth) / 2;
      const chartY = 45;

      pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

      // Add data summary below chart
      let currentY = chartY + chartHeight + 15;

      pdf.setFontSize(12);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Summary (Assessments Count):', 20, currentY);
      currentY += 8;

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      const totalAssessments = this.assessmentStatusChartData.reduce((sum, item) => sum + (item.value || 0), 0);
      
      this.assessmentStatusChartData.forEach(item => {
        const percentage = totalAssessments > 0 ? ((item.value || 0) / totalAssessments * 100).toFixed(1) : '0.0';
        const text = `${item.name}: ${item.value || 0} (${percentage}%)`;
        pdf.text(text, 20, currentY);
        currentY += 5;

        if (currentY > pageHeight - 20) {
          pdf.addPage();
          currentY = 20;
        }
      });
      
      // Add Total
      currentY += 3;
      pdf.setFont('helvetica', 'bold');
      pdf.text(`Total Assessments: ${totalAssessments}`, 20, currentY);

      pdf.save('Assessments_by_Status.pdf');
    }
  }

  exportAssessmentStatusAsPNG(): void {
    this.showAssessmentStatusChartMenu = false;
    if (!this.ensureHasData(this.assessmentStatusChartData)) { return; }
    
    if (this.assessmentStatusChart) {
      const container = document.createElement('div');
      container.style.cssText = `
        position: fixed;
        left: -10000px;
        top: -10000px;
        width: 1200px;
        background: white;
        padding: 40px;
        border: 1px solid #ccc;
        z-index: 10000;
        font-family: Arial, sans-serif;
      `;

      const header = document.createElement('div');
      header.style.cssText = `
        text-align: center;
        margin-bottom: 30px;
        padding-bottom: 20px;
        border-bottom: 2px solid #005068;
      `;

      const title = document.createElement('h1');
      title.textContent = 'Assessments by Status';
      title.style.cssText = `
        margin: 0 0 10px 0;
        color: #005068;
        font-size: 28px;
        font-weight: bold;
      `;

      const subtitle = document.createElement('p');
      subtitle.textContent = 'Source: Assessment Planning Analytics';
      subtitle.style.cssText = 'margin: 0; color: #666; font-size: 14px;';

      header.appendChild(title);
      header.appendChild(subtitle);
      container.appendChild(header);

      const mainContent = document.createElement('div');
      mainContent.style.cssText = 'display: flex; gap: 40px; align-items: flex-start;';

      const canvas = this.assessmentStatusChart.canvas;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.restore();
      }
      
      const chartImg = document.createElement('img');
      chartImg.src = canvas.toDataURL('image/png', 1.0);
      chartImg.style.cssText = 'width: 55%; height: auto; border: 1px solid #eee; border-radius: 4px; padding: 10px; background: white;';
      mainContent.appendChild(chartImg);

      const infoSection = document.createElement('div');
      infoSection.style.cssText = 'width: 40%;';

      const infoTitle = document.createElement('h3');
      infoTitle.textContent = 'Summary';
      infoTitle.style.cssText = 'margin-top: 0; color: #005068; font-size: 20px; margin-bottom: 15px; border-bottom: 1px solid #eee; padding-bottom: 10px;';
      infoSection.appendChild(infoTitle);

      const totalAssessments = this.assessmentStatusChartData.reduce((sum, item) => sum + (item.value || 0), 0);

      this.assessmentStatusChartData.forEach((item, index) => {
        const itemDiv = document.createElement('div');
        itemDiv.style.cssText = `
          padding: 10px 15px;
          margin-bottom: 8px;
          background-color: ${index % 2 === 0 ? '#f9f9f9' : '#ffffff'};
          border-left: 4px solid ${item.color || '#005068'};
          border-radius: 3px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        `;

        const nameSpan = document.createElement('span');
        nameSpan.textContent = item.name;
        nameSpan.style.cssText = 'font-weight: bold; color: #333; font-size: 14px;';

        const valueSpan = document.createElement('span');
        const percentage = totalAssessments > 0 ? ((item.value || 0) / totalAssessments * 100).toFixed(1) : '0.0';
        valueSpan.textContent = `${item.value || 0} (${percentage}%)`;
        valueSpan.style.cssText = 'color: #666; font-size: 14px; font-weight: 500;';

        itemDiv.appendChild(nameSpan);
        itemDiv.appendChild(valueSpan);
        infoSection.appendChild(itemDiv);
      });

      const totalDiv = document.createElement('div');
      totalDiv.style.cssText = `
        margin-top: 15px;
        padding-top: 15px;
        border-top: 2px solid #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: bold;
        color: #005068;
        font-size: 16px;
      `;
      
      const totalLabel = document.createElement('span');
      totalLabel.textContent = 'Total Assessments';
      const totalValue = document.createElement('span');
      totalValue.textContent = totalAssessments.toString();
      
      totalDiv.appendChild(totalLabel);
      totalDiv.appendChild(totalValue);
      infoSection.appendChild(totalDiv);

      mainContent.appendChild(infoSection);
      container.appendChild(mainContent);

      document.body.appendChild(container);

      html2canvas(container, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff'
      }).then(canvas => {
        document.body.removeChild(container);
        const imgData = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = imgData;
        link.download = 'Assessments_by_Status.png';
        link.click();
      }).catch(err => {
        document.body.removeChild(container);
        console.error('Error generating PNG:', err);
        this.util.simpleDialog({ title: 'Error', message: 'Failed to generate PNG' });
      });
    }
  }

  // ==================== ASSESSMENT EVALUATION CHART METHODS ====================
  openAssessmentEvaluationCompareDialog(): void {
    this.showAssessmentEvaluationCompareDialog = true;
    this.showAssessmentEvaluationComparisonResults = false;
    this.selectedAssessmentEvaluationCompareMonth1 = null;
    this.selectedAssessmentEvaluationCompareMonth2 = null;
  }

  closeAssessmentEvaluationCompareDialog(): void {
    this.showAssessmentEvaluationCompareDialog = false;
    this.showAssessmentEvaluationComparisonResults = false;
    this.currentAssessmentEvaluationComparisonData = [];
    this.compareAssessmentEvaluationComparisonData = [];
  }

  openAssessmentEvaluationTableModal(): void {
    this.showAssessmentEvaluationChartMenu = false;
    this.showAssessmentEvaluationTableModal = true;
  }

  closeAssessmentEvaluationTableModal(): void {
    this.showAssessmentEvaluationTableModal = false;
  }

  exportAssessmentEvaluationAsPDF(): void {
    if (!this.ensureHasData(this.assessmentEvaluationChartData)) { return; }
    this.showAssessmentEvaluationChartMenu = false;
    
    if (this.assessmentEvaluationChart) {
      const canvas = this.assessmentEvaluationChart.canvas;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.restore();
      }

      const chartImage = canvas.toDataURL('image/png', 1.0);
      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Add title
      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');
      const chartTitle = 'Assessments by Evaluation Status';
      const titleWidth = pdf.getTextWidth(chartTitle);
      const titleX = (pageWidth - titleWidth) / 2;
      pdf.text(chartTitle, titleX, 25);

      // Add source/subtitle
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      const subtitle = 'Source: Assessment Planning Analytics';
      const subtitleWidth = pdf.getTextWidth(subtitle);
      const subtitleX = (pageWidth - subtitleWidth) / 2;
      pdf.text(subtitle, subtitleX, 32);

      // Add separator line
      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      // Add chart image
      const imgProps = pdf.getImageProperties(chartImage);
      const maxChartWidth = 130;
      let chartWidth = pageWidth - 40;
      if (chartWidth > maxChartWidth) {
        chartWidth = maxChartWidth;
      }
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      const chartX = (pageWidth - chartWidth) / 2;
      const chartY = 45;

      pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

      // Add data summary below chart
      let currentY = chartY + chartHeight + 15;

      pdf.setFontSize(12);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Summary (Assessments Count):', 20, currentY);
      currentY += 8;

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      const totalAssessments = this.assessmentEvaluationChartData.reduce((sum, item) => sum + (item.value || 0), 0);
      
      this.assessmentEvaluationChartData.forEach(item => {
        const percentage = totalAssessments > 0 ? ((item.value || 0) / totalAssessments * 100).toFixed(1) : '0.0';
        const text = `${item.name}: ${item.value || 0} (${percentage}%)`;
        pdf.text(text, 20, currentY);
        currentY += 5;

        if (currentY > pageHeight - 20) {
          pdf.addPage();
          currentY = 20;
        }
      });
      
      // Add Total
      currentY += 3;
      pdf.setFont('helvetica', 'bold');
      pdf.text(`Total Assessments: ${totalAssessments}`, 20, currentY);

      pdf.save('Assessments_by_Evaluation.pdf');
    }
  }

  exportAssessmentEvaluationAsPNG(): void {
    if (!this.ensureHasData(this.assessmentEvaluationChartData)) { return; }
    this.showAssessmentEvaluationChartMenu = false;
    
    if (this.assessmentEvaluationChart) {
      const container = document.createElement('div');
      container.style.cssText = `
        position: fixed;
        left: -10000px;
        top: -10000px;
        width: 1200px;
        background: white;
        padding: 40px;
        border: 1px solid #ccc;
        z-index: 10000;
        font-family: Arial, sans-serif;
      `;

      const header = document.createElement('div');
      header.style.cssText = `
        text-align: center;
        margin-bottom: 30px;
        padding-bottom: 20px;
        border-bottom: 2px solid #005068;
      `;

      const title = document.createElement('h1');
      title.textContent = 'Assessments by Evaluation Status';
      title.style.cssText = `
        margin: 0 0 10px 0;
        color: #005068;
        font-size: 28px;
        font-weight: bold;
      `;

      const subtitle = document.createElement('p');
      subtitle.textContent = 'Source: Assessment Planning Analytics';
      subtitle.style.cssText = 'margin: 0; color: #666; font-size: 14px;';

      header.appendChild(title);
      header.appendChild(subtitle);
      container.appendChild(header);

      const mainContent = document.createElement('div');
      mainContent.style.cssText = 'display: flex; gap: 40px; align-items: flex-start;';

      const canvas = this.assessmentEvaluationChart.canvas;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.restore();
      }
      
      const chartImg = document.createElement('img');
      chartImg.src = canvas.toDataURL('image/png', 1.0);
      chartImg.style.cssText = 'width: 55%; height: auto; border: 1px solid #eee; border-radius: 4px; padding: 10px; background: white;';
      mainContent.appendChild(chartImg);

      const infoSection = document.createElement('div');
      infoSection.style.cssText = 'width: 40%;';

      const infoTitle = document.createElement('h3');
      infoTitle.textContent = 'Summary';
      infoTitle.style.cssText = 'margin-top: 0; color: #005068; font-size: 20px; margin-bottom: 15px; border-bottom: 1px solid #eee; padding-bottom: 10px;';
      infoSection.appendChild(infoTitle);

      const totalAssessments = this.assessmentEvaluationChartData.reduce((sum, item) => sum + (item.value || 0), 0);

      this.assessmentEvaluationChartData.forEach((item, index) => {
        const itemDiv = document.createElement('div');
        itemDiv.style.cssText = `
          padding: 10px 15px;
          margin-bottom: 8px;
          background-color: ${index % 2 === 0 ? '#f9f9f9' : '#ffffff'};
          border-left: 4px solid ${item.color || '#005068'};
          border-radius: 3px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        `;

        const nameSpan = document.createElement('span');
        nameSpan.textContent = item.name;
        nameSpan.style.cssText = 'font-weight: bold; color: #333; font-size: 14px;';

        const valueSpan = document.createElement('span');
        const percentage = totalAssessments > 0 ? ((item.value || 0) / totalAssessments * 100).toFixed(1) : '0.0';
        valueSpan.textContent = `${item.value || 0} (${percentage}%)`;
        valueSpan.style.cssText = 'color: #666; font-size: 14px; font-weight: 500;';

        itemDiv.appendChild(nameSpan);
        itemDiv.appendChild(valueSpan);
        infoSection.appendChild(itemDiv);
      });

      const totalDiv = document.createElement('div');
      totalDiv.style.cssText = `
        margin-top: 15px;
        padding-top: 15px;
        border-top: 2px solid #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: bold;
        color: #005068;
        font-size: 16px;
      `;
      
      const totalLabel = document.createElement('span');
      totalLabel.textContent = 'Total Assessments';
      const totalValue = document.createElement('span');
      totalValue.textContent = totalAssessments.toString();
      
      totalDiv.appendChild(totalLabel);
      totalDiv.appendChild(totalValue);
      infoSection.appendChild(totalDiv);

      mainContent.appendChild(infoSection);
      container.appendChild(mainContent);

      document.body.appendChild(container);

      html2canvas(container, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff'
      }).then(canvas => {
        document.body.removeChild(container);
        const imgData = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = imgData;
        link.download = 'Assessments_by_Evaluation.png';
        link.click();
      }).catch(err => {
        document.body.removeChild(container);
        console.error('Error generating PNG:', err);
        this.util.simpleDialog({ title: 'Error', message: 'Failed to generate PNG' });
      });
    }
  }

  toggleAssessmentEvaluationCompareMonth1Dropdown(): void {
    this.showAssessmentEvaluationCompareMonth1Dropdown = !this.showAssessmentEvaluationCompareMonth1Dropdown;
    if (this.showAssessmentEvaluationCompareMonth1Dropdown) {
      this.showAssessmentEvaluationCompareMonth2Dropdown = false;
    }
  }

  selectAssessmentEvaluationCompareMonth1(month: number): void {
    this.selectedAssessmentEvaluationCompareMonth1 = month;
    this.showAssessmentEvaluationCompareMonth1Dropdown = false;
  }

  toggleAssessmentEvaluationCompareMonth2Dropdown(): void {
    this.showAssessmentEvaluationCompareMonth2Dropdown = !this.showAssessmentEvaluationCompareMonth2Dropdown;
    if (this.showAssessmentEvaluationCompareMonth2Dropdown) {
      this.showAssessmentEvaluationCompareMonth1Dropdown = false;
    }
  }

  selectAssessmentEvaluationCompareMonth2(month: number): void {
    this.selectedAssessmentEvaluationCompareMonth2 = month;
    this.showAssessmentEvaluationCompareMonth2Dropdown = false;
  }

  loadAssessmentEvaluationComparisonDataMonthWise(): void {
    if (!this.selectedAssessmentEvaluationCompareMonth1 || !this.selectedAssessmentEvaluationCompareMonth2) {
      return;
    }

    this.isLoading = true;
    this.showAssessmentEvaluationComparisonResults = true;

    // Fetch comparison data
    this.fetchAssessmentEvaluationComparisonDataMonthWise();
  }

  private fetchAssessmentEvaluationComparisonDataMonthWise(): void {
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedAssessmentEvaluationCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedAssessmentEvaluationCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    // Fetch Month 1 data
    const resp1 = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    // Fetch Month 2 data
    const resp2 = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Data: any[] = [];
    let month2Data: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        console.log('Assessment Evaluation - Month 1 API Full Response:', data);
        let response = data?.body?.responseBody || data?.responseBody || data;
        console.log('Assessment Evaluation - Month 1 Extracted Response:', response);

        // Extract evaluation status data from operationsData.evaluation_status
        if (response?.operationsData?.evaluation_status) {
          const evalObj = response.operationsData.evaluation_status;
          month1Data = Object.entries(evalObj).map(([evaluation, count]: [string, any]) => ({
            evaluation: evaluation,
            count: count as number
          }));
          console.log('Assessment Evaluation - Month 1 Evaluation Data:', month1Data);
        } else if (response && response.evaluation_counts && Array.isArray(response.evaluation_counts)) {
          month1Data = response.evaluation_counts;
          console.log('Assessment Evaluation - Month 1 Evaluation Counts (Legacy):', month1Data);
        } else {
          console.warn('Assessment Evaluation - Month 1: No evaluation data found in response');
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentEvaluationComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        console.error('Assessment Evaluation - Month 1 API Error:', error);
        completedRequests++;
        if (completedRequests === 2) {
          this.compareAssessmentEvaluationComparisonData = [];
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        console.log('Assessment Evaluation - Month 2 API Full Response:', data);
        let response = data?.body?.responseBody || data?.responseBody || data;
        console.log('Assessment Evaluation - Month 2 Extracted Response:', response);

        // Extract evaluation status data from operationsData.evaluation_status
        if (response?.operationsData?.evaluation_status) {
          const evalObj = response.operationsData.evaluation_status;
          month2Data = Object.entries(evalObj).map(([evaluation, count]: [string, any]) => ({
            evaluation: evaluation,
            count: count as number
          }));
          console.log('Assessment Evaluation - Month 2 Evaluation Data:', month2Data);
        } else if (response && response.evaluation_counts && Array.isArray(response.evaluation_counts)) {
          month2Data = response.evaluation_counts;
          console.log('Assessment Evaluation - Month 2 Evaluation Counts (Legacy):', month2Data);
        } else {
          console.warn('Assessment Evaluation - Month 2: No evaluation data found in response');
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentEvaluationComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        console.error('Assessment Evaluation - Month 2 API Error:', error);
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentEvaluationComparisonDataMonthWise(month1Data, month2Data);
        }
      }
    );

    // Set loading complete after both requests
    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    }, 200);
  }

  private processAssessmentEvaluationComparisonDataMonthWise(month1Data: any[], month2Data: any[]): void {
    console.log('Assessment Evaluation - Processing Comparison Data:');
    console.log('Assessment Evaluation - Month 1 Raw Data:', month1Data);
    console.log('Assessment Evaluation - Month 2 Raw Data:', month2Data);

    // Type guard to check if count is a number
    const isValidEvaluation = (evaluation: any): boolean => {
      const count = evaluation?.count ?? evaluation?.evaluation_count ?? 0;
      return evaluation &&
        (evaluation.evaluation || evaluation.evaluation_status) &&
        typeof count === 'number' &&
        count > 0;
    };

    // Process Month 1 data
    const validMonth1Evaluations = month1Data.filter(isValidEvaluation).map((evalItem: any) => ({
      evaluation: evalItem.evaluation || evalItem.evaluation_status,
      count: evalItem.count ?? evalItem.evaluation_count
    }));
    console.log('Assessment Evaluation - Valid Month 1 Evaluations:', validMonth1Evaluations);

    const month1Totals: { [key: string]: number } = {};
    validMonth1Evaluations.forEach(evaluation => {
      month1Totals[evaluation.evaluation] = evaluation.count;
    });

    this.currentAssessmentEvaluationComparisonData = Object.entries(month1Totals)
      .filter(([_, count]) => count > 0)
      .map(([evaluationName, count]) => ({
        name: evaluationName,
        value: count,
        percentage: '0',
        trend: 'neutral'
      }));
    console.log('Assessment Evaluation - Current Comparison Data (Month 1):', this.currentAssessmentEvaluationComparisonData);

    // Process Month 2 data
    const validMonth2Evaluations = month2Data.filter(isValidEvaluation).map((evalItem: any) => ({
      evaluation: evalItem.evaluation || evalItem.evaluation_status,
      count: evalItem.count ?? evalItem.evaluation_count
    }));
    console.log('Assessment Evaluation - Valid Month 2 Evaluations:', validMonth2Evaluations);

    const month2Totals: { [key: string]: number } = {};
    validMonth2Evaluations.forEach(evaluation => {
      month2Totals[evaluation.evaluation] = evaluation.count;
    });

    this.compareAssessmentEvaluationComparisonData = Object.entries(month2Totals)
      .filter(([_, count]) => count > 0)
      .map(([evaluationName, count]) => {
        const currentItem = this.currentAssessmentEvaluationComparisonData.find(item => item.name === evaluationName);
        const currentValue = currentItem ? currentItem.value : 0;

        let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
        if (count > currentValue) {
          trend = 'positive';
        } else if (count < currentValue) {
          trend = 'negative';
        }

        return {
          name: evaluationName,
          value: count,
          percentage: '0',
          trend: trend
        };
      });
    console.log('Assessment Evaluation - Compare Comparison Data (Month 2):', this.compareAssessmentEvaluationComparisonData);

    // Initialize comparison chart
    this.initializeAssessmentEvaluationComparisonChart();
  }

  private initializeAssessmentEvaluationComparisonChart(): void {
    // Prepare data for chart
    const month1Name = this.getMonthName(this.selectedAssessmentEvaluationCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedAssessmentEvaluationCompareMonth2!);

    // Get unique evaluations from both datasets
    const allEvaluations = new Set<string>();
    this.currentAssessmentEvaluationComparisonData.forEach(item => allEvaluations.add(item.name));
    this.compareAssessmentEvaluationComparisonData.forEach(item => allEvaluations.add(item.name));

    const evaluationNames: string[] = Array.from(allEvaluations);
    const month1Data: number[] = [];
    const month2Data: number[] = [];

    evaluationNames.forEach(evaluationName => {
      const month1Item = this.currentAssessmentEvaluationComparisonData.find(item => item.name === evaluationName);
      const month2Item = this.compareAssessmentEvaluationComparisonData.find(item => item.name === evaluationName);
      month1Data.push(month1Item ? month1Item.value : 0);
      month2Data.push(month2Item ? month2Item.value : 0);
    });

    console.log('Assessment Evaluation - Chart Initialization');
    console.log('Assessment Evaluation - Evaluation Names:', evaluationNames);
    console.log('Assessment Evaluation - Month 1 Data:', month1Data);
    console.log('Assessment Evaluation - Month 2 Data:', month2Data);

    // Destroy existing chart if it exists
    if (this.assessmentEvaluationComparisonChart) {
      this.assessmentEvaluationComparisonChart.destroy();
    }

    // Delay chart initialization to ensure DOM is ready
    setTimeout(() => {
      try {
        const ctx = document.getElementById('assessmentEvaluationComparisonChart') as HTMLCanvasElement;
        if (ctx) {
          this.assessmentEvaluationComparisonChart = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: evaluationNames,
              datasets: [
                {
                  label: month1Name,
                  data: month1Data,
                  backgroundColor: '#FF9800',
                  borderColor: '#F57C00',
                  borderWidth: 1
                },
                {
                  label: month2Name,
                  data: month2Data,
                  backgroundColor: '#9C27B0',
                  borderColor: '#7B1FA2',
                  borderWidth: 1
                }
              ]
            },
            options: {
              indexAxis: 'y',
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: true,
                  position: 'top'
                }
              },
              scales: {
                x: {
                  beginAtZero: true,
                  stacked: false,
                  grid: {
                    display: true
                  }
                },
                y: {
                  stacked: false
                }
              }
            }
          });
          console.log('Assessment Evaluation - Chart initialized successfully');
          this.cdr.detectChanges();
        } else {
          console.error('Assessment Evaluation - Canvas element not found');
        }
      } catch (error) {
        console.error('Assessment Evaluation - Chart initialization error:', error);
      }
    }, 200);
  }

  // ==================== CANDIDATE ASSESSMENT CHART METHODS ====================
  openCandidateAssessmentCompareDialog(): void {
    this.showCandidateAssessmentCompareDialog = true;
    this.showCandidateAssessmentComparisonResults = false;
    this.selectedCandidateAssessmentCompareMonth1 = null;
    this.selectedCandidateAssessmentCompareMonth2 = null;
  }

  closeCandidateAssessmentCompareDialog(): void {
    this.showCandidateAssessmentCompareDialog = false;
    this.showCandidateAssessmentComparisonResults = false;
    this.currentCandidateAssessmentComparisonData = [];
    this.compareCandidateAssessmentComparisonData = [];
  }

  toggleCandidateAssessmentCompareMonth1Dropdown(): void {
    this.showCandidateAssessmentCompareMonth1Dropdown = !this.showCandidateAssessmentCompareMonth1Dropdown;
    if (this.showCandidateAssessmentCompareMonth1Dropdown) {
      this.showCandidateAssessmentCompareMonth2Dropdown = false;
    }
  }

  selectCandidateAssessmentCompareMonth1(month: number): void {
    this.selectedCandidateAssessmentCompareMonth1 = month;
    this.showCandidateAssessmentCompareMonth1Dropdown = false;
  }

  toggleCandidateAssessmentCompareMonth2Dropdown(): void {
    this.showCandidateAssessmentCompareMonth2Dropdown = !this.showCandidateAssessmentCompareMonth2Dropdown;
    if (this.showCandidateAssessmentCompareMonth2Dropdown) {
      this.showCandidateAssessmentCompareMonth1Dropdown = false;
    }
  }

  selectCandidateAssessmentCompareMonth2(month: number): void {
    this.selectedCandidateAssessmentCompareMonth2 = month;
    this.showCandidateAssessmentCompareMonth2Dropdown = false;
  }

  loadCandidateAssessmentComparisonData(): void {
    if (!this.selectedCandidateAssessmentCompareMonth1 || !this.selectedCandidateAssessmentCompareMonth2) {
      return;
    }

    this.isLoading = true;
    this.showCandidateAssessmentComparisonResults = true;

    // Fetch comparison data
    this.fetchCandidateAssessmentComparisonDataMonthWise();
  }

  private fetchCandidateAssessmentComparisonDataMonthWise(): void {
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedCandidateAssessmentCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedCandidateAssessmentCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    // Fetch Month 1 data
    const resp1 = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    // Fetch Month 2 data
    const resp2 = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Data: any[] = [];
    let month2Data: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.assessment_candidates) {
          month1Data = response.assessment_candidates;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processCandidateAssessmentComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.compareCandidateAssessmentComparisonData = [];
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response && response.assessment_candidates) {
          month2Data = response.assessment_candidates;
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processCandidateAssessmentComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        completedRequests++;
        if (completedRequests === 2) {
          this.compareCandidateAssessmentComparisonData = [];
        }
      }
    );

    // Set loading complete after both requests
    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    }, 2000);
  }

  private processCandidateAssessmentComparisonDataMonthWise(month1Data: any[], month2Data: any[]): void {
    // Type guard to check if candidate_count is a number
    const isValidAssessment = (assessment: any): assessment is { assessment_id: string | number; candidate_count: number } => {
      return assessment &&
        (assessment.assessment_id || assessment.assessment_name) &&
        typeof assessment.candidate_count === 'number' &&
        assessment.candidate_count > 0;
    };

    // Process Month 1 data
    const validMonth1Assessments = month1Data.filter(isValidAssessment).map((assessment: any) => ({
      assessment_id: assessment.assessment_id,
      assessment_name: assessment.assessment_title || assessment.assessment_name || `Assessment ${assessment.assessment_id}`,
      candidate_count: assessment.candidate_count
    }));
    const sortedMonth1Assessments = [...validMonth1Assessments].sort((a, b) =>
      b.candidate_count - a.candidate_count
    );
    const topMonth1Assessments = sortedMonth1Assessments.slice(0, 10);
    const otherMonth1AssessmentsTotal = sortedMonth1Assessments.slice(10).reduce((sum, assessment) =>
      sum + assessment.candidate_count, 0
    );

    // Process Month 2 data
    const validMonth2Assessments = month2Data.filter(isValidAssessment).map((assessment: any) => ({
      assessment_id: assessment.assessment_id,
      assessment_name: assessment.assessment_title || assessment.assessment_name || `Assessment ${assessment.assessment_id}`,
      candidate_count: assessment.candidate_count
    }));
    const sortedMonth2Assessments = [...validMonth2Assessments].sort((a, b) =>
      b.candidate_count - a.candidate_count
    );
    const topMonth2Assessments = sortedMonth2Assessments.slice(0, 10);
    const otherMonth2AssessmentsTotal = sortedMonth2Assessments.slice(10).reduce((sum, assessment) =>
      sum + assessment.candidate_count, 0
    );

    // Store Month 1 data as current
    const month1Totals: { [key: string]: number } = {};
    topMonth1Assessments.forEach(assessment => {
      month1Totals[assessment.assessment_name] = assessment.candidate_count;
    });
    if (otherMonth1AssessmentsTotal > 0) {
      month1Totals['Others'] = otherMonth1AssessmentsTotal;
    }

    this.currentCandidateAssessmentComparisonData = Object.entries(month1Totals)
      .filter(([_, count]) => count > 0)
      .map(([assessmentName, count]) => ({
        name: assessmentName,
        value: count,
        percentage: '0',
        trend: 'neutral'
      }));

    // Store Month 2 data as comparison
    const month2Totals: { [key: string]: number } = {};
    topMonth2Assessments.forEach(assessment => {
      month2Totals[assessment.assessment_name] = assessment.candidate_count;
    });
    if (otherMonth2AssessmentsTotal > 0) {
      month2Totals['Others'] = otherMonth2AssessmentsTotal;
    }

    this.compareCandidateAssessmentComparisonData = Object.entries(month2Totals)
      .filter(([_, count]) => count > 0)
      .map(([assessmentName, count]) => {
        const currentItem = this.currentCandidateAssessmentComparisonData.find(item => item.name === assessmentName);
        const currentValue = currentItem ? currentItem.value : 0;

        let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
        if (count > currentValue) {
          trend = 'positive';
        } else if (count < currentValue) {
          trend = 'negative';
        }

        return {
          name: assessmentName,
          value: count,
          percentage: '0',
          trend: trend
        };
      });

    // Initialize comparison chart
    this.initializeCandidateAssessmentComparisonChart();
  }

  private initializeCandidateAssessmentComparisonChart(): void {
    // Prepare data for chart
    const month1Name = this.getMonthName(this.selectedCandidateAssessmentCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedCandidateAssessmentCompareMonth2!);

    // Get unique assessments from both datasets
    const allAssessments = new Set<string>();
    this.currentCandidateAssessmentComparisonData.forEach(item => allAssessments.add(item.name));
    this.compareCandidateAssessmentComparisonData.forEach(item => allAssessments.add(item.name));

    const assessmentNames: string[] = Array.from(allAssessments).slice(0, 10);
    const month1Data: number[] = [];
    const month2Data: number[] = [];

    assessmentNames.forEach(assessmentName => {
      const month1Item = this.currentCandidateAssessmentComparisonData.find(item => item.name === assessmentName);
      const month2Item = this.compareCandidateAssessmentComparisonData.find(item => item.name === assessmentName);
      month1Data.push(month1Item ? month1Item.value : 0);
      month2Data.push(month2Item ? month2Item.value : 0);
    });

    // Destroy existing chart if it exists
    if (this.candidateAssessmentComparisonChart) {
      this.candidateAssessmentComparisonChart.destroy();
    }

    // Delay chart initialization to ensure DOM is ready
    setTimeout(() => {
      const ctx = document.getElementById('candidateAssessmentComparisonChart') as HTMLCanvasElement;
      if (ctx) {
        this.candidateAssessmentComparisonChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: assessmentNames,
            datasets: [
              {
                label: month1Name,
                data: month1Data,
                backgroundColor: '#005068',
                borderColor: '#003d4d',
                borderWidth: 1
              },
              {
                label: month2Name,
                data: month2Data,
                backgroundColor: '#BFCAD9',
                borderColor: '#9ba5b8',
                borderWidth: 1
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: true,
            indexAxis: 'y' as const,
            plugins: {
              legend: {
                position: 'top' as const
              },
              title: {
                display: true,
                text: `Month-wise Candidates Comparison: ${month1Name} vs ${month2Name}`
              }
            },
            scales: {
              x: {
                beginAtZero: true,
                stacked: false
              }
            }
          }
        });
      }
    }, 100);
  }

  openCandidateAssessmentTableModal(): void {
    this.showCandidateAssessmentChartMenu = false;
    this.showCandidateAssessmentTableModal = true;
  }

  closeCandidateAssessmentTableModal(): void {
    this.showCandidateAssessmentTableModal = false;
  }

  exportCandidateAssessmentAsPDF(): void {
    if (!this.ensureHasData(this.candidateAssessmentChartData)) { return; }
    this.showCandidateAssessmentChartMenu = false;
    if (this.candidateAssessmentChart) {
      const canvas = this.candidateAssessmentChart.canvas;
      const chartImage = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();

      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');
      const chartTitle = 'Candidates by Assessment';
      const titleWidth = pdf.getTextWidth(chartTitle);
      const titleX = (pageWidth - titleWidth) / 2;
      pdf.text(chartTitle, titleX, 25);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      const subtitle = 'Source: Assessment Planning Analytics';
      const subtitleWidth = pdf.getTextWidth(subtitle);
      const subtitleX = (pageWidth - subtitleWidth) / 2;
      pdf.text(subtitle, subtitleX, 32);

      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      const imgProps = pdf.getImageProperties(chartImage);
      const chartWidth = pageWidth - 40;
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      pdf.addImage(chartImage, 'PNG', 20, 45, chartWidth, chartHeight);

      pdf.save('Candidates_by_Assessment.pdf');
    }
  }

  exportCandidateAssessmentAsPNG(): void {
    if (!this.ensureHasData(this.candidateAssessmentChartData)) { return; }
    this.showCandidateAssessmentChartMenu = false;
    if (this.candidateAssessmentChart) {
      const canvas = this.candidateAssessmentChart.canvas;
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = 'Candidates_by_Assessment.png';
      link.click();
    }
  }

  // Assessment Customer Chart Export Methods
  openAssessmentCustomerTableModal(): void {
    this.showAssessmentCustomerChartMenu = false;
    this.showAssessmentCustomerTableModal = true;
  }

  closeAssessmentCustomerTableModal(): void {
    this.showAssessmentCustomerTableModal = false;
  }

/**
 * Export Assessment by Customers Chart as PDF
 * Matches the format of Assessment by Course/Job Role export
 */
exportAssessmentCustomerAsPDF(): void {
  this.showAssessmentCustomerChartMenu = false;
  
  if (!this.ensureHasData(this.assessmentCustomerChartData)) { 
    return; 
  }
  
  if (this.assessmentCustomerChart) {
    // Set white background for the canvas
    const canvas = this.assessmentCustomerChart.canvas;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.save();
      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.restore();
    }

    const chartImage = canvas.toDataURL('image/png', 1.0);
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    // Add title
    pdf.setFontSize(18);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Assessment by Customers', pageWidth / 2, 25, { align: 'center' });

    // Add source
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');
    pdf.text('Source: Assessment Planning Analytics', pageWidth / 2, 32, { align: 'center' });

    // Add separator
    pdf.setDrawColor(200, 200, 200);
    pdf.line(20, 38, pageWidth - 20, 38);

    // Add chart image
    const imgProps = pdf.getImageProperties(chartImage);
    const chartWidth = pageWidth * 0.8;
    const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
    const chartX = (pageWidth - chartWidth) / 2;
    const chartY = 45;

    pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

    // Add distribution summary
    const summaryStartY = chartY + chartHeight + 20;
    pdf.setFontSize(14);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Distribution Summary', 20, summaryStartY);

    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');

    let currentY = summaryStartY + 15;
    const totalAssessments = this.assessmentCustomerChartData.reduce((sum, item) => sum + item.value, 0);

    this.assessmentCustomerChartData.forEach(item => {
      const percentage = totalAssessments > 0 ? ((item.value / totalAssessments) * 100).toFixed(1) : '0';
      const text = `${item.name}: ${item.value} (${percentage}%)`;
      pdf.text(text, 25, currentY);
      currentY += 5;
    });

    // Add total and metadata
    currentY += 10;
    pdf.setFont('helvetica', 'bold');
    pdf.text(`Total Assessments: ${totalAssessments}`, 20, currentY);

    currentY += 8;
    pdf.setFontSize(9);
    pdf.setFont('helvetica', 'italic');

    let dateRangeText = `Date Range: ${this.selectedRange}`;
    if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
      dateRangeText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
    }
    pdf.text(dateRangeText, 20, currentY);

    // Add footer
    const footerY = pageHeight - 10;
    pdf.setFontSize(8);
    pdf.setFont('helvetica', 'normal');
    pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth / 2, footerY, { align: 'center' });

    pdf.save('assessment-by-customers.pdf');
  }
}

/**
 * Export Assessment by Customers Chart as PNG
 * Matches the format of Assessment by Course/Job Role export
 */
exportAssessmentCustomerAsPNG(): void {
  this.showAssessmentCustomerChartMenu = false;
  
  if (!this.ensureHasData(this.assessmentCustomerChartData)) { 
    return; 
  }
  
  if (this.assessmentCustomerChart) {
    // Create a container to combine chart and information
    const container = document.createElement('div');
    container.style.cssText = `
      position: fixed;
      left: -10000px;
      top: -10000px;
      width: 1400px;
      background: white;
      padding: 40px;
      border: 1px solid #ccc;
      z-index: 10000;
      font-family: Arial, sans-serif;
    `;

    // Create header
    const header = document.createElement('div');
    header.style.cssText = `
      text-align: center;
      margin-bottom: 40px;
      padding-bottom: 20px;
      border-bottom: 3px solid #005068;
    `;

    const title = document.createElement('h1');
    title.textContent = 'Assessment by Customers';
    title.style.cssText = `
      margin: 0 0 12px 0;
      color: #005068;
      font-size: 32px;
      font-weight: bold;
    `;

    const subtitle = document.createElement('p');
    subtitle.textContent = 'Source: Assessment Planning Analytics';
    subtitle.style.cssText = `
      margin: 0;
      color: #666;
      font-size: 16px;
    `;

    header.appendChild(title);
    header.appendChild(subtitle);

    // Create top row for chart and legends
    const topRow = document.createElement('div');
    topRow.style.cssText = `
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 60px;
      margin-bottom: 40px;
      padding: 30px;
      background: #f8f9fa;
      border-radius: 15px;
      min-height: 500px;
    `;

    // Chart container
    const chartContainer = document.createElement('div');
    chartContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 2;
      min-height: 500px;
    `;

    // Create a high-quality chart render
    const chartWrapper = document.createElement('div');
    chartWrapper.style.cssText = `
      width: 500px;
      height: 500px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: white;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      padding: 20px;
      box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    `;

    // Get the original chart canvas
    const originalCanvas = this.assessmentCustomerChart.canvas;

    // Create a high-resolution canvas
    const highResCanvas = document.createElement('canvas');
    highResCanvas.width = 800;
    highResCanvas.height = 800;

    const ctx = highResCanvas.getContext('2d');
    if (ctx) {
      // Scale up for better quality
      ctx.scale(2, 2);

      // Set white background
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, highResCanvas.width, highResCanvas.height);

      // Draw the chart with better quality
      ctx.drawImage(originalCanvas, 0, 0, 400, 400);
    }

    const chartImg = document.createElement('img');
    chartImg.src = highResCanvas.toDataURL('image/png', 1.0);
    chartImg.style.cssText = `
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 10px;
      object-fit: contain;
    `;

    chartWrapper.appendChild(chartImg);
    chartContainer.appendChild(chartWrapper);

    // Legends container
    const legendsContainer = document.createElement('div');
    legendsContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 25px;
      flex: 1;
      min-width: 320px;
      max-width: 350px;
    `;

    // Color Legend Container
    const colorLegendContainer = document.createElement('div');
    colorLegendContainer.style.cssText = `
      background: white;
      padding: 30px;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    `;

    const colorLegendTitle = document.createElement('h3');
    colorLegendTitle.textContent = 'Color Legend';
    colorLegendTitle.style.cssText = `
      margin: 0 0 25px 0;
      color: #005068;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      border-bottom: 3px solid #f0f0f0;
      padding-bottom: 15px;
    `;

    colorLegendContainer.appendChild(colorLegendTitle);

    // Add customer color legend
    const customerLegend = document.createElement('div');
    customerLegend.style.cssText = `
      margin-bottom: 10px;
    `;

    const customerLegendTitle = document.createElement('h4');
    customerLegendTitle.textContent = 'Customers';
    customerLegendTitle.style.cssText = `
      margin: 0 0 20px 0;
      color: #333;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    `;

    customerLegend.appendChild(customerLegendTitle);

    // Get unique customers and their colors
    const customerColors = new Map();
    const nonZeroData = this.assessmentCustomerChartData.filter(item => item.value > 0);

    // Use the same color palette as assessment course chart
    const palette = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF',
      '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9', '#F8B195'
    ];

    nonZeroData.forEach((item, index) => {
      customerColors.set(item.name, palette[index % palette.length]);
    });

    // Add customer color items with better styling
    customerColors.forEach((color, customerName) => {
      const customerItem = document.createElement('div');
      customerItem.style.cssText = `
        display: flex;
        align-items: flex-start;
        margin-bottom: 16px;
        padding: 12px;
        background: #f8f9fa;
        border-radius: 10px;
        border-left: 5px solid ${color};
        transition: all 0.3s ease;
      `;

      const colorBox = document.createElement('div');
      colorBox.style.cssText = `
        width: 24px;
        height: 24px;
        background-color: ${color};
        border: 3px solid #fff;
        border-radius: 8px;
        margin-right: 15px;
        margin-top: 2px;
        box-shadow: 0 3px 8px rgba(0,0,0,0.2);
        flex-shrink: 0;
      `;

      const customerNameSpan = document.createElement('span');
      customerNameSpan.textContent = customerName;
      customerNameSpan.style.cssText = `
        font-size: 16px;
        font-weight: 500;
        color: #333;
        line-height: 1.4;
        word-wrap: break-word;
        flex: 1;
      `;

      customerItem.appendChild(colorBox);
      customerItem.appendChild(customerNameSpan);
      customerLegend.appendChild(customerItem);
    });

    colorLegendContainer.appendChild(customerLegend);
    legendsContainer.appendChild(colorLegendContainer);

    // Add legends to top row
    topRow.appendChild(chartContainer);
    topRow.appendChild(legendsContainer);

    // Distribution Summary Section
    const distributionSection = document.createElement('div');
    distributionSection.style.cssText = `
      margin-top: 40px;
    `;

    const distributionTitle = document.createElement('h2');
    distributionTitle.textContent = 'Distribution Summary';
    distributionTitle.style.cssText = `
      margin: 0 0 30px 0;
      color: #005068;
      font-size: 28px;
      font-weight: bold;
      text-align: center;
      border-bottom: 3px solid #005068;
      padding-bottom: 15px;
    `;

    distributionSection.appendChild(distributionTitle);

    // Create customer card
    const customerCard = document.createElement('div');
    customerCard.style.cssText = `
      background: white;
      padding: 30px;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      border-left: 8px solid #005068;
      max-width: 900px;
      margin: 0 auto;
      box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    `;

    // Customer header
    const customerHeader = document.createElement('h3');
    customerHeader.textContent = 'Assessment Distribution by Customer';
    customerHeader.style.cssText = `
      margin: 0 0 25px 0;
      color: #333;
      font-size: 20px;
      font-weight: bold;
      border-bottom: 3px solid #f0f0f0;
      padding-bottom: 15px;
      text-align: center;
    `;

    customerCard.appendChild(customerHeader);

    // Create table-like structure for customers
    const tableContainer = document.createElement('div');
    tableContainer.style.cssText = `
      width: 100%;
    `;

    // Add header row
    const headerRow = document.createElement('div');
    headerRow.style.cssText = `
      display: grid;
      grid-template-columns: 2fr 1fr 1fr;
      gap: 20px;
      margin-bottom: 20px;
      padding: 15px;
      background: #f8f9fa;
      border-radius: 10px;
      font-weight: bold;
      color: #333;
      border-bottom: 2px solid #ddd;
    `;

    const headerCustomer = document.createElement('div');
    headerCustomer.textContent = 'Customer Name';
    headerCustomer.style.cssText = 'font-weight: bold; color: #005068;';

    const headerCount = document.createElement('div');
    headerCount.textContent = 'Assessments';
    headerCount.style.cssText = 'font-weight: bold; color: #005068; text-align: center;';

    const headerPercentage = document.createElement('div');
    headerPercentage.textContent = 'Percentage';
    headerPercentage.style.cssText = 'font-weight: bold; color: #005068; text-align: right;';

    headerRow.appendChild(headerCustomer);
    headerRow.appendChild(headerCount);
    headerRow.appendChild(headerPercentage);
    tableContainer.appendChild(headerRow);

    // Add data rows
    const totalAssessments = this.assessmentCustomerChartData.reduce((sum, item) => sum + item.value, 0);

    nonZeroData.forEach(item => {
      const percentage = totalAssessments > 0 ? ((item.value / totalAssessments) * 100).toFixed(1) : '0';

      const rowDiv = document.createElement('div');
      rowDiv.style.cssText = `
        display: grid;
        grid-template-columns: 2fr 1fr 1fr;
        gap: 20px;
        align-items: center;
        padding: 15px;
        border-bottom: 2px solid #f5f5f5;
        margin-bottom: 10px;
        border-radius: 8px;
        transition: background 0.3s ease;
      `;

      const customerName = document.createElement('span');
      customerName.textContent = item.name;
      customerName.style.cssText = `
        font-weight: 500;
        color: #333;
        font-size: 16px;
      `;

      const customerCount = document.createElement('span');
      customerCount.textContent = item.value.toString();
      customerCount.style.cssText = `
        color: #666;
        font-weight: 600;
        font-size: 16px;
        text-align: center;
      `;

      const customerPercentage = document.createElement('span');
      customerPercentage.textContent = `${percentage}%`;
      customerPercentage.style.cssText = `
        color: #666;
        font-weight: 600;
        font-size: 16px;
        text-align: right;
      `;

      rowDiv.appendChild(customerName);
      rowDiv.appendChild(customerCount);
      rowDiv.appendChild(customerPercentage);
      tableContainer.appendChild(rowDiv);
    });

    customerCard.appendChild(tableContainer);
    distributionSection.appendChild(customerCard);

    // Total and footer section
    const totalSection = document.createElement('div');
    totalSection.style.cssText = `
      margin-top: 50px;
      padding: 30px;
      background: #f8f9fa;
      border-radius: 15px;
      border: 3px solid #e0e0e0;
      text-align: center;
    `;

    const totalLabel = document.createElement('div');
    totalLabel.style.cssText = `
      font-weight: bold;
      margin-bottom: 20px;
      font-size: 20px;
      color: #005068;
    `;
    totalLabel.textContent = `Total Assessments: ${totalAssessments}`;

    const metadataContainer = document.createElement('div');
    metadataContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-size: 15px;
      color: #666;
      margin-bottom: 20px;
    `;

    // Date information
    const dateInfo = document.createElement('div');
    let dateText = `Date Range: ${this.selectedRange}`;
    if (this.selectedRange === 'Custom' && this.startDate && this.endDate) {
      dateText += ` (${this.formatDisplayDate(this.startDate)} - ${this.formatDisplayDate(this.endDate)})`;
    }
    dateInfo.textContent = dateText;

    // Footer
    const footer = document.createElement('div');
    footer.style.cssText = `
      text-align: center;
      margin-top: 20px;
      padding-top: 20px;
      border-top: 3px solid #ddd;
      font-size: 14px;
      color: #666;
      font-style: italic;
    `;
    footer.textContent = `Generated on: ${new Date().toLocaleDateString()}`;

    metadataContainer.appendChild(dateInfo);

    totalSection.appendChild(totalLabel);
    totalSection.appendChild(metadataContainer);
    totalSection.appendChild(footer);

    // Assemble the container
    container.appendChild(header);
    container.appendChild(topRow);
    container.appendChild(distributionSection);
    container.appendChild(totalSection);

    document.body.appendChild(container);

    // Use html2canvas with higher quality settings
    html2canvas(container, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      logging: false,
      width: container.offsetWidth,
      height: container.offsetHeight
    }).then(canvas => {
      const link = document.createElement('a');
      link.download = 'assessment-by-customers-analysis.png';
      link.href = canvas.toDataURL('image/png', 1.0);
      link.click();

      // Clean up
      document.body.removeChild(container);
    });
  }
}

  // Candidate Performance Chart Methods
  selectCandidatePerformanceToggle(toggle: string): void {
    this.candidatePerformanceSelectedToggle = toggle;
    // Re-initialize chart with new toggle
    setTimeout(() => {
      const canvas = document.getElementById('candidatePerformanceChart') as HTMLCanvasElement;
      if (canvas) {
        this.initializeCandidatePerformanceChart();
      }
    }, 50);
  }

  onCandidatePerformanceChartHover(event: MouseEvent): void {
    if (!this.candidatePerformanceChart) return;
    
    const canvas = this.candidatePerformanceChart.canvas as HTMLCanvasElement;
    const rect = canvas.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    
    // Get the chart coordinates to find hovered bar
    try {
      const canvasOffset = { x: 0, y: 0 };
      let canvasElement = canvas;
      while (canvasElement) {
        canvasOffset.x += canvasElement.offsetLeft;
        canvasOffset.y += canvasElement.offsetTop;
        canvasElement = canvasElement.offsetParent as HTMLCanvasElement;
      }
      
      const scaleX = canvas.width / canvas.offsetWidth;
      const scaleY = canvas.height / canvas.offsetHeight;
      const relX = (event.clientX - canvasOffset.x) * scaleX;
      
      // Get data X coordinate
      if (this.candidatePerformanceChart.scales && this.candidatePerformanceChart.scales['x']) {
        const dataX = this.candidatePerformanceChart.scales['x'].getValueForPixel(relX);
        this.hoveredCandidatePerformanceIndex = Math.round(dataX || 0);
      }
    } catch (e) {
      console.log('Chart hover error:', e);
    }
    
    // Update tooltip display
    if (this.candidatePerformanceChart.options.plugins?.tooltip) {
      this.candidatePerformanceChart.options.plugins['tooltip'].enabled = true;
    }
  }

  onCandidatePerformanceChartLeave(): void {
    this.hoveredCandidatePerformanceIndex = null;
    if (this.candidatePerformanceChart) {
      this.candidatePerformanceChart.update('none');
    }
  }

  initializeCandidatePerformanceChart(): void {
    console.log('initializeCandidatePerformanceChart called');
    console.log('Chart labels:', this.candidatePerformanceChartLabels);
    console.log('Show chart flag:', this.showCandidatePerformanceChart);
    
    if (this.candidatePerformanceChartLabels.length === 0) {
      console.warn('No chart labels available, labels:', this.candidatePerformanceChartLabels);
      this.loadCandidatePerformanceData();
      return;
    }

    const chartCanvas = document.getElementById('candidatePerformanceChart') as HTMLCanvasElement;
    if (!chartCanvas) {
      console.error('Canvas element not found with id candidatePerformanceChart');
      return;
    }

    console.log('Canvas element found, context:', chartCanvas.getContext('2d'));

    // Destroy existing chart if it exists
    if (this.candidatePerformanceChart) {
      console.log('Destroying existing chart');
      this.candidatePerformanceChart.destroy();
    }

    const ctx = chartCanvas.getContext('2d');
    if (!ctx) {
      console.error('Could not get 2d context from canvas');
      return;
    }

    // Color palette for course-wise colors
    const courseColors = ['#015C96', '#2B78A9', '#FF6F59', '#DF7E7D', '#FFCC64', '#FFCC64'];
    
    // Apply colors to each bar based on course index
    const barColors = this.candidatePerformanceTotalCandidateCounts.map((_, index) => 
      courseColors[index % courseColors.length]
    );

    // Create bar chart showing total candidate count per course with course-wise colors
    this.candidatePerformanceChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.candidatePerformanceChartLabels,
        datasets: [
          {
            label: 'Candidates',
            data: this.candidatePerformanceTotalCandidateCounts,
            backgroundColor: barColors,
            borderColor: barColors,
            borderWidth: 1,
            borderRadius: [4, 4, 0, 0],
            barPercentage: 1,
            hoverBackgroundColor: barColors.map(color => {
              // Darken hover color
              return color === '#FFFFFF' ? '#f0f0f0' : color;
            }),
            hoverBorderColor: barColors
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'x',
        plugins: {
          legend: {
            display: false,
            position: 'bottom',
            labels: {
              font: { size: 12, weight: 'bold' },
              padding: 15,
              usePointStyle: false,
              boxWidth: 15,
              boxHeight: 15
            }
          },
          tooltip: {
            enabled: true,
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            padding: 12,
            titleFont: { size: 14, weight: 'bold' },
            bodyFont: { size: 12 },
            mode: 'index',
            intersect: false,
            callbacks: {
              label: (context) => {
                const value = context.parsed.y;
                let passCount = this.candidatePerformancePassData[context.dataIndex] || 0;
                let failCount = this.candidatePerformanceFailData[context.dataIndex] || 0;
                
                // Show pass/fail breakdown based on toggle selection
                if (this.candidatePerformanceSelectedToggle === 'pass') {
                  const passPercentage = value > 0 ? ((passCount / value) * 100).toFixed(2) : '0.00';
                  return `Pass: ${passCount} (${passPercentage}%)`;
                } else {
                  const failPercentage = value > 0 ? ((failCount / value) * 100).toFixed(2) : '0.00';
                  return `Fail: ${failCount} (${failPercentage}%)`;
                }
              },
              afterLabel: (context) => {
                const value = context.parsed.y;
                return `Total Candidates: ${value}`;
              }
            }
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            ticks: {
              font: { size: 11 }
            },
            grid: {
              display: false
            }
          },
          y: {
            beginAtZero: true,
            ticks: {
              font: { size: 11 },
              callback: (value) => value.toString()
            },
            grid: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          }
        }
      }
    });

    console.log('Chart initialized successfully');
    this.candidatePerformanceChart.resize();
  }

  initializeAssessmentCustomerChart(): void {
    console.log('initializeAssessmentCustomerChart called');
    console.log('Chart labels:', this.assessmentCustomerChartLabels);
    console.log('Show chart flag:', this.showAssessmentCustomerChart);

    if (this.assessmentCustomerChartLabels.length === 0) {
      console.warn('No chart labels available for assessment customer chart');
      return;
    }

    const canvases = document.querySelectorAll('#assessmentCustomerChart');
    let chartCanvas: HTMLCanvasElement | null = null;

    if (canvases && canvases.length > 0) {
      for (let i = 0; i < canvases.length; i++) {
        const el = canvases[i] as HTMLCanvasElement;
        if (el.offsetParent !== null || el.getBoundingClientRect().height > 0) {
          chartCanvas = el;
          break;
        }
      }
      if (!chartCanvas) {
        chartCanvas = canvases[canvases.length - 1] as HTMLCanvasElement;
      }
    } else {
      chartCanvas = document.getElementById('assessmentCustomerChart') as HTMLCanvasElement;
    }

    if (!chartCanvas) {
      console.error('Canvas element not found with id assessmentCustomerChart');
      return;
    }

    console.log('Canvas element found, context:', chartCanvas.getContext('2d'));

    // Destroy existing chart if it exists
    if (this.assessmentCustomerChart) {
      console.log('Destroying existing assessment customer chart');
      this.assessmentCustomerChart.destroy();
    }

    const ctx = chartCanvas.getContext('2d');
    if (!ctx) {
      console.error('Could not get 2d context from canvas');
      return;
    }

    // Color palette for customer-wise colors
    const customerColors = ['#015C96', '#2B78A9', '#FF6F59', '#DF7E7D', '#FFCC64', '#FFCC64'];

    // Apply colors to each bar based on customer index
    const barColors = this.assessmentCustomerChartValues.map((_, index) =>
      customerColors[index % customerColors.length]
    );

    // Create bar chart showing assessment count per customer
    this.assessmentCustomerChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.assessmentCustomerChartLabels,
        datasets: [
          {
            label: 'Assessments',
            data: this.assessmentCustomerChartValues,
            backgroundColor: barColors,
            borderColor: barColors,
            borderWidth: 1,
            borderRadius: [4, 4, 0, 0],
            barPercentage: 1,
            hoverBackgroundColor: barColors.map(color => {
              // Darken hover color
              return color === '#FFFFFF' ? '#f0f0f0' : color;
            }),
            hoverBorderColor: barColors
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'x',
        plugins: {
          legend: {
            display: false,
            position: 'bottom',
            labels: {
              font: { size: 12, weight: 'bold' },
              padding: 15,
              usePointStyle: false,
              boxWidth: 15,
              boxHeight: 15
            }
          },
          tooltip: {
            enabled: true,
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            padding: 12,
            titleFont: { size: 14, weight: 'bold' },
            bodyFont: { size: 12 },
            mode: 'index',
            intersect: false,
            callbacks: {
              label: (context) => {
                const value = context.parsed.y;
                return `Assessments: ${value}`;
              }
            }
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            ticks: {
              font: { size: 11 }
            },
            grid: {
              display: false
            }
          },
          y: {
            beginAtZero: true,
            ticks: {
              font: { size: 11 },
              callback: (value) => value.toString()
            },
            grid: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          }
        }
      }
    });

    console.log('Assessment customer chart initialized successfully');
    this.assessmentCustomerChart.resize();
  }

  loadCandidatePerformanceData(): void {
    try {
      // Get the assessment data from the dashboard service or internal cache
      const assessmentData = this.candidatePerformanceRawData || [];
      if (assessmentData.length === 0) {
        this.showCandidatePerformanceChart = false;
        this.candidatePerformanceChartLabels = [];
        this.candidatePerformancePassData = [];
        this.candidatePerformanceFailData = [];
        this.candidatePerformanceTotalCandidateCounts = [];
        return;
      }
      this.processCandidatePerformanceData({ assessment_wise: assessmentData });
    } catch (error) {
      console.error('Error loading candidate performance data:', error);
      this.showCandidatePerformanceChart = false;
    }
  }

  processCandidatePerformanceData(passFailData: any): void {
    try {
      const performanceList = passFailData?.candidate_data_by_performance ?? passFailData?.assessment_wise ?? [];
      if (!performanceList || performanceList.length === 0) {
        this.showCandidatePerformanceChart = false;
        this.candidatePerformanceChartLabels = [];
        this.candidatePerformancePassData = [];
        this.candidatePerformanceFailData = [];
        this.candidatePerformanceTotalCandidateCounts = [];
        console.log('No candidate performance data available');
        return;
      }

      console.log('Processing candidate performance data:', performanceList);

      // Save raw performance data for later use
      this.candidatePerformanceRawData = performanceList;

      // Apply course/geography/customer/language filter if any filter is selected using assessment_wise_stats mapping
      const hasCourseFilter = this.selectedCandidatePerformanceCourseValues && this.selectedCandidatePerformanceCourseValues.length > 0;
      const hasGeographyFilter = this.selectedCandidatePerformanceGeographyValues && this.selectedCandidatePerformanceGeographyValues.length > 0;
      const hasCustomerFilter = this.selectedCandidatePerformanceCustomerValues && this.selectedCandidatePerformanceCustomerValues.length > 0;
      const hasLanguageFilter = this.selectedCandidatePerformanceLanguageValues && this.selectedCandidatePerformanceLanguageValues.length > 0;

      if (hasCourseFilter || hasGeographyFilter || hasCustomerFilter || hasLanguageFilter) {
        const statsSource = this.assessmentWiseStats && this.assessmentWiseStats.length > 0
          ? this.assessmentWiseStats
          : (passFailData?.assessment_wise_stats || []);

        const normalizeName = (name: string) => name ? String(name).trim().toLowerCase() : '';

        const matchedStats = statsSource.filter((stat: any) => {
          const detail = this.rawAssessmentDetails.find((d: any) => String(d.assessment_id) === String(stat.assessment_id));

          // 1. Course Filter
          if (hasCourseFilter) {
            const selectedCourses = this.selectedCandidatePerformanceCourseValues.map(c => normalizeName(c));
            const courseFromStat = stat.course_name || stat.course || '';
            const courseFromDetail = detail ? (detail.course || detail.course_name || detail.course_title || '') : '';
            
            const matchesStatCourse = courseFromStat && selectedCourses.includes(normalizeName(courseFromStat));
            const matchesDetailCourse = courseFromDetail && selectedCourses.includes(normalizeName(courseFromDetail));

            if (!matchesStatCourse && !matchesDetailCourse) {
              return false;
            }
          }

          // 2. Geography Filter
          if (hasGeographyFilter) {
            const selectedGeographies = this.selectedCandidatePerformanceGeographyValues.map(g => normalizeName(g));
            const stateFromStat = stat.assessment_state || stat.state || stat.state_name || '';
            const stateFromDetail = detail ? (detail.assessment_state || detail.state || detail.state_name || '') : '';
            
            const matchesStatState = stateFromStat && selectedGeographies.includes(normalizeName(stateFromStat));
            const matchesDetailState = stateFromDetail && selectedGeographies.includes(normalizeName(stateFromDetail));

            if (!matchesStatState && !matchesDetailState) {
              return false;
            }
          }

          // 3. Customer Filter
          if (hasCustomerFilter) {
            const selectedCustomers = this.selectedCandidatePerformanceCustomerValues.map(c => normalizeName(c));
            const customerFromStat = stat.customer_name || stat.customer || '';
            const customerFromDetail = detail ? (detail.customer || detail.customer_name || detail.customer_name_display || '') : '';
            
            const matchesStatCustomer = customerFromStat && selectedCustomers.includes(normalizeName(customerFromStat));
            const matchesDetailCustomer = customerFromDetail && selectedCustomers.includes(normalizeName(customerFromDetail));

            if (!matchesStatCustomer && !matchesDetailCustomer) {
              return false;
            }
          }

          // 4. Language Filter
          if (hasLanguageFilter) {
            const selectedLanguages = this.selectedCandidatePerformanceLanguageValues.map(l => normalizeName(l));
            const langFromStat = stat.language_name || stat.language || stat.assessment_language || '';
            const langFromDetail = detail ? (detail.language || detail.language_name || detail.assessment_language || '') : '';
            
            const matchesStatLang = langFromStat && selectedLanguages.includes(normalizeName(langFromStat));
            const matchesDetailLang = langFromDetail && selectedLanguages.includes(normalizeName(langFromDetail));

            if (!matchesStatLang && !matchesDetailLang) {
              return false;
            }
          }

          return true;
        });

        // Clear existing datasets to avoid stale data if no match is found
        this.candidatePerformanceChartLabels = [];
        this.candidatePerformancePassData = [];
        this.candidatePerformanceFailData = [];
        this.candidatePerformanceTotalCandidateCounts = [];

        if (matchedStats.length > 0) {
          // Sort assessments by total candidates descending
          matchedStats.sort((a: any, b: any) => (b.total_candidates || 0) - (a.total_candidates || 0));
          
          this.candidatePerformanceChartLabels = matchedStats.map((stat: any) => stat.assessment_name || `Assessment ${stat.assessment_id}`);
          this.candidatePerformancePassData = matchedStats.map((stat: any) => stat.pass_count || 0);
          this.candidatePerformanceFailData = matchedStats.map((stat: any) => stat.fail_count || 0);
          this.candidatePerformanceTotalCandidateCounts = matchedStats.map((stat: any) => stat.total_candidates || 0);
          this.candidatePerformanceRawData = performanceList;
          
          // Show chart if we have data
          this.showCandidatePerformanceChart = this.candidatePerformanceChartLabels.length > 0;
          this.cdr.detectChanges();
          
          if (this.showCandidatePerformanceChart) {
            setTimeout(() => {
              const canvas = document.getElementById('candidatePerformanceChart') as HTMLCanvasElement;
              if (canvas) {
                this.initializeCandidatePerformanceChart();
              }
            }, 150);
          }
        } else {
          this.showCandidatePerformanceChart = false;
          this.cdr.detectChanges();
        }
        return;
      }

      let filteredPerformanceList = performanceList;

      // Apply geography filter if any geography is selected
      if (this.selectedCandidatePerformanceGeographyValues && this.selectedCandidatePerformanceGeographyValues.length > 0) {
        const selectedCourseIdsFromStates = this.getCandidatePerformanceCourseIdsForSelectedStates(passFailData);

        if (selectedCourseIdsFromStates.size > 0) {
          filteredPerformanceList = filteredPerformanceList.filter((item: any) => {
            const itemCourseId = item.course_id || item.id || item.assessment_id;
            return itemCourseId !== undefined && itemCourseId !== null && selectedCourseIdsFromStates.has(String(itemCourseId));
          });
          console.log('Filtered performance list by geography via assessment_wise state->course_id lookup:', filteredPerformanceList);
        } else {
          // Fallback: if mapping data unavailable, use candidate data geography fields
          filteredPerformanceList = filteredPerformanceList.filter((item: any) => {
            const itemGeography = item.state || item.state_name || item.geography || item.location || 'Unknown';
            return this.selectedCandidatePerformanceGeographyValues.includes(itemGeography);
          });
          console.log('Filtered performance list by geography fallback item state:', filteredPerformanceList);
        }
      }

      // Apply customer filter if any customer is selected
      if (this.selectedCandidatePerformanceCustomerValues && this.selectedCandidatePerformanceCustomerValues.length > 0) {
        const selectedCourseIdsFromCustomers = this.getCandidatePerformanceCourseIdsForSelectedCustomers();

        if (selectedCourseIdsFromCustomers.size > 0) {
          filteredPerformanceList = filteredPerformanceList.filter((item: any) => {
            const itemCourseId = item.course_id || item.id || item.assessment_id;
            return itemCourseId !== undefined && itemCourseId !== null && selectedCourseIdsFromCustomers.has(String(itemCourseId));
          });
          console.log('Filtered performance list by customer via assessment_details customer_name->course_id:', filteredPerformanceList);
        } else {
          // Fallback to direct customer field in candidate_data_by_performance if assessment_details mapping missing
          filteredPerformanceList = filteredPerformanceList.filter((item: any) => {
            const itemCustomer = item.customer_name || item.customer || item.organization_name || item.organization || 'Unknown';
            return this.selectedCandidatePerformanceCustomerValues.includes(itemCustomer);
          });
          console.log('Filtered performance list by customer fallback item customer:', filteredPerformanceList);
        }
      }

      // Apply language filter if any language is selected
      if (this.selectedCandidatePerformanceLanguageValues && this.selectedCandidatePerformanceLanguageValues.length > 0) {
        const selectedCourseIdsFromLanguages = this.getCandidatePerformanceCourseIdsForSelectedLanguages(passFailData);

        if (selectedCourseIdsFromLanguages.size > 0) {
          filteredPerformanceList = filteredPerformanceList.filter((item: any) => {
            const itemCourseId = item.course_id || item.id || item.assessment_id;
            return itemCourseId !== undefined && itemCourseId !== null && selectedCourseIdsFromLanguages.has(String(itemCourseId));
          });
          console.log('Filtered performance list by language via assessment_wise language->course_id lookup:', filteredPerformanceList);
        } else {
          // Fallback: meta language field in candidate_data_by_performance
          filteredPerformanceList = filteredPerformanceList.filter((item: any) => {
            const itemLanguage = item.language_name || item.language || item.assessment_language || 'Unknown';
            return this.selectedCandidatePerformanceLanguageValues.includes(itemLanguage);
          });
          console.log('Filtered performance list by language fallback item language:', filteredPerformanceList);
        }
      }

      // Transform performance data to course/category-based grouping
      const courseMap = new Map<string, {
        course_name: string;
        pass: number;
        fail: number;
        candidate_count: number;
      }>();
      
      filteredPerformanceList.forEach((item: any, index: number) => {
        const fallbackCourseName = item.category || item.assessment_title || item.assessment_name || `Category ${index + 1}`;
        const courseIdKey = item.course_id !== undefined && item.course_id !== null
          ? String(item.course_id)
          : item.category
            ? String(item.category)
            : item.assessment_id !== undefined && item.assessment_id !== null
              ? `assessment-${item.assessment_id}`
              : `item-${index}`;
        const courseName = item.category || item.course_name || item.course_title || fallbackCourseName || 'Unknown Course';

        const pass = item.pass_count ?? item.pass ?? 0;
        const fail = item.fail_count ?? item.fail ?? 0;
        const candidate_count = item.candidate_count ?? 0;

        if (courseMap.has(courseIdKey)) {
          const existing = courseMap.get(courseIdKey)!;
          existing.pass += pass;
          existing.fail += fail;
          existing.candidate_count += candidate_count;
        } else {
          courseMap.set(courseIdKey, {
            course_name: courseName,
            pass,
            fail,
            candidate_count
          });
        }
      });

      console.log('Course map:', courseMap);

      const sortedCourses = Array.from(courseMap.entries());
      if (!passFailData?.candidate_data_by_performance) {
        console.log('Using assessment_wise fallback, sorting top 5 courses.');
        sortedCourses.sort((a, b) => {
          const totalA = a[1].candidate_count;
          const totalB = b[1].candidate_count;
          return totalB - totalA;
        });
        sortedCourses.splice(5);
      } else {
        console.log('Using candidate_data_by_performance response, enforcing top 5 courses and Others aggregation.');

        const nonOthers = sortedCourses.filter(([_, data]) => data.course_name !== 'Others');
        const othersEntries = sortedCourses.filter(([_, data]) => data.course_name === 'Others');

        nonOthers.sort((a, b) => b[1].candidate_count - a[1].candidate_count);

        const topFive = nonOthers.slice(0, 5);
        const rest = nonOthers.slice(5).map(([_, data]) => data);

        if (othersEntries.length > 0) {
          rest.push(...othersEntries.map(([_, data]) => data));
        }

        if (rest.length > 0) {
          const aggregatedOthers = rest.reduce((acc, item) => {
            acc.pass += item.pass;
            acc.fail += item.fail;
            acc.candidate_count += item.candidate_count;
            return acc;
          }, {
            course_name: 'Others',
            pass: 0,
            fail: 0,
            candidate_count: 0
          });
          topFive.push(['Others', aggregatedOthers] as [string, { course_name: string; pass: number; fail: number; candidate_count: number }]);
        }

        sortedCourses.length = 0;
        sortedCourses.push(...topFive);
      }

      console.log('Sorted courses:', sortedCourses);

      // Extract labels and data arrays
      this.candidatePerformanceChartLabels = sortedCourses.map(([_, data]) => data.course_name);
      this.candidatePerformancePassData = sortedCourses.map(([_, data]) => data.pass);
      this.candidatePerformanceFailData = sortedCourses.map(([_, data]) => data.fail);
      this.candidatePerformanceTotalCandidateCounts = sortedCourses.map(([_, data]) => data.candidate_count);
      this.candidatePerformanceRawData = performanceList;

      console.log('Chart labels:', this.candidatePerformanceChartLabels);
      console.log('Pass data:', this.candidatePerformancePassData);
      console.log('Fail data:', this.candidatePerformanceFailData);
      console.log('Total candidate counts:', this.candidatePerformanceTotalCandidateCounts);

      // Show chart if we have data
      this.showCandidatePerformanceChart = this.candidatePerformanceChartLabels.length > 0;

      console.log('Show chart:', this.showCandidatePerformanceChart);

      // Trigger change detection so canvas element is rendered
      this.cdr.detectChanges();

      // Initialize the chart
      if (this.showCandidatePerformanceChart) {
        // Wait for canvas element to be rendered
        setTimeout(() => {
          const canvas = document.getElementById('candidatePerformanceChart') as HTMLCanvasElement;
          if (canvas) {
            console.log('Canvas element found, initializing chart');
            this.initializeCandidatePerformanceChart();
          } else {
            console.error('Canvas element not found with id: candidatePerformanceChart');
          }
        }, 150);
      }
    } catch (error) {
      console.error('Error processing candidate performance data:', error);
      this.showCandidatePerformanceChart = false;
      this.cdr.detectChanges();
    }
  }

  private getCandidatePerformanceCourseIdsForSelectedStates(passFailData: any): Set<string> {
    const states = (this.selectedCandidatePerformanceGeographyValues || []).map((s: string) => this.normalizeString(s)).filter(Boolean);
    if (!states.length) {
      return new Set<string>();
    }

    const assessmentWise = passFailData?.assessment_wise || this.rawPassFailAssessmentWise || [];
    if (!Array.isArray(assessmentWise) || assessmentWise.length === 0) {
      return new Set<string>();
    }

    const matchedCourseIds = new Set<string>();

    assessmentWise.forEach((assessment: any) => {
      const stateValue = this.normalizeString(assessment.assessment_state || assessment.state || assessment.state_name || '');
      if (!stateValue) {
        return;
      }
      if (states.includes(stateValue)) {
        const cId = assessment.course_id ?? assessment.id ?? assessment.assessment_course_id ?? assessment.course_id;
        if (cId !== undefined && cId !== null && cId !== '') {
          matchedCourseIds.add(String(cId));
        }
      }
    });

    console.log('Derived course IDs from selected states:', Array.from(matchedCourseIds));
    return matchedCourseIds;
  }

  private getCandidatePerformanceCourseIdsForSelectedCustomers(): Set<string> {
    const selectedCustomers = (this.selectedCandidatePerformanceCustomerValues || []).map((c: string) => this.normalizeString(c)).filter(Boolean);
    if (selectedCustomers.length === 0) {
      return new Set<string>();
    }

    if (!Array.isArray(this.rawAssessmentDetails) || this.rawAssessmentDetails.length === 0) {
      return new Set<string>();
    }

    const matchedCourseIds = new Set<string>();

    this.rawAssessmentDetails.forEach((detail: any) => {
      const detailCustomerName = this.normalizeString(detail.customer_name || detail.customer || detail.customer_name_display || '');
      if (detailCustomerName && selectedCustomers.includes(detailCustomerName)) {
        const cId = detail.course_id ?? detail.assessment_course_id ?? detail.assessment_id ?? detail.id;
        if (cId !== undefined && cId !== null && cId !== '') {
          matchedCourseIds.add(String(cId));
        }
      }
    });

    console.log('Derived course IDs from selected customers:', Array.from(matchedCourseIds));
    return matchedCourseIds;
  }

  private getCandidatePerformanceCourseIdsForSelectedLanguages(passFailData: any): Set<string> {
    const selectedLanguages = (this.selectedCandidatePerformanceLanguageValues || []).map((l: string) => this.normalizeString(l)).filter(Boolean);
    if (selectedLanguages.length === 0) {
      return new Set<string>();
    }

    const assessmentWise = passFailData?.assessment_wise || this.rawPassFailAssessmentWise || [];
    if (!Array.isArray(assessmentWise) || assessmentWise.length === 0) {
      return new Set<string>();
    }

    const matchedCourseIds = new Set<string>();

    assessmentWise.forEach((assessment: any) => {
      const assessmentLanguagesRaw = assessment.language || assessment.language_name || assessment.assessment_language;
      const assessmentLanguages = Array.isArray(assessmentLanguagesRaw)
        ? assessmentLanguagesRaw
        : (assessmentLanguagesRaw ? [assessmentLanguagesRaw] : []);

      const normalizedAssessmentLanguages = assessmentLanguages
        .map((lang: any) => this.normalizeString(lang || ''))
        .filter(Boolean);

      if (normalizedAssessmentLanguages.some((lang: string) => selectedLanguages.includes(lang))) {
        const cId = assessment.course_id ?? assessment.id ?? assessment.assessment_course_id;
        if (cId !== undefined && cId !== null && cId !== '') {
          matchedCourseIds.add(String(cId));
        }
      }
    });

    console.log('Derived course IDs from selected languages:', Array.from(matchedCourseIds));
    return matchedCourseIds;
  }

processAssessmentCustomerData(assessmentDetails: any | any[]): void {
  try {
    // Get the customer data source
    let customerDataArray: any[] = [];
    
    // Try to get data from rawTop5CustomersByAssessment first
    if (this.rawTop5CustomersByAssessment && Array.isArray(this.rawTop5CustomersByAssessment)) {
      customerDataArray = this.rawTop5CustomersByAssessment;
      console.log('Using rawTop5CustomersByAssessment:', customerDataArray);
    } else if (Array.isArray(assessmentDetails)) {
      customerDataArray = assessmentDetails;
    } else if (assessmentDetails && typeof assessmentDetails === 'object') {
      // Check for coalesce wrapper
      if (Array.isArray(assessmentDetails.coalesce)) {
        customerDataArray = assessmentDetails.coalesce;
      } else if (Array.isArray(assessmentDetails.data)) {
        customerDataArray = assessmentDetails.data;
      } else {
        customerDataArray = [assessmentDetails];
      }
    }

    if (!customerDataArray || customerDataArray.length === 0) {
      if (!this.assessmentCustomerChartDataLoaded) {
        this.showAssessmentCustomerChart = false;
        this.assessmentCustomerChartLabels = [];
        this.assessmentCustomerChartValues = [];
      }
      console.log('No assessment customer data available');
      this.cdr.detectChanges();
      return;
    }

    console.log('Processing assessment customer data:', customerDataArray);
    console.log('Selected customer filter values:', this.selectedAssessmentCustomerCustomerValues);
    console.log('Selected course filter values:', this.selectedAssessmentCustomerCourseValues);

    // STEP 1: Apply customer filter if any customer is selected
    let filteredData = customerDataArray;
    
    if (this.selectedAssessmentCustomerCustomerValues && this.selectedAssessmentCustomerCustomerValues.length > 0) {
      const selectedCustomers = this.selectedAssessmentCustomerCustomerValues.map(c => this.normalizeString(c));
      console.log('Normalized selected customers:', selectedCustomers);
      
      filteredData = customerDataArray.filter(item => {
        // Get customer name from various possible fields
        const itemCustomerRaw = item.customer_name || item.customer || item.name || '';
        const itemCustomer = this.normalizeString(itemCustomerRaw);
        
        // Check if this item's customer matches any selected customer
        const matches = selectedCustomers.some(selected => {
          const isMatch = itemCustomer === selected || 
                          itemCustomer.includes(selected) || 
                          selected.includes(itemCustomer);
          return isMatch;
        });
        
        if (matches) {
          console.log(`Item matched customer: "${itemCustomerRaw}" -> "${itemCustomer}" matches selected`);
        }
        return matches;
      });
      
      console.log('After customer filter, items:', filteredData.length);
    }

    // STEP 2: Apply course filter if any course is selected
    if (this.selectedAssessmentCustomerCourseValues && this.selectedAssessmentCustomerCourseValues.length > 0) {
      const selectedCourses = this.selectedAssessmentCustomerCourseValues.map(c => this.normalizeString(c));
      console.log('Normalized selected courses:', selectedCourses);
      
      filteredData = filteredData.filter(item => {
        const itemCourseRaw = item.course_name || item.course || '';
        const itemCourse = this.normalizeString(itemCourseRaw);
        
        const matches = selectedCourses.some(selected => {
          return itemCourse === selected || 
                 itemCourse.includes(selected) || 
                 selected.includes(itemCourse);
        });
        
        if (matches) {
          console.log(`Item matched course: "${itemCourseRaw}" -> "${itemCourse}" matches selected`);
        }
        return matches;
      });
      
      console.log('After course filter, items:', filteredData.length);
    }

    // STEP 3: Group by customer name and aggregate counts
    const customerMap = new Map<string, { name: string; count: number }>();
    
    filteredData.forEach((item: any) => {
      let rawCustomerName = item.customer_name || item.customer || item.name || '';
      
      // Fallback: Check tags array for Customer tag if direct customer field is empty or 'No Customer'
      if ((!rawCustomerName || rawCustomerName === 'No Customer') && item.tags) {
        let tagsList = item.tags;
        if (typeof tagsList === 'string') {
          try { tagsList = JSON.parse(tagsList); } catch (e) {}
        }
        if (Array.isArray(tagsList)) {
          const custTag = tagsList.find((t: any) => t && (t.key === 'Customer' || t.type === 'Customer' || t.Customer));
          if (custTag) {
            rawCustomerName = custTag.Customer || custTag.value || custTag.name || custTag.customer_name || '';
          }
        }
      }

      if (rawCustomerName && rawCustomerName.trim() !== '' && rawCustomerName.trim() !== 'No Customer') {
        const customerName = rawCustomerName.trim();
        
        // Get count from various possible fields
        let count = 1;
        if (item.assessment_count !== undefined) {
          count = item.assessment_count;
        } else if (item.count !== undefined) {
          count = item.count;
        } else if (item.value !== undefined) {
          count = item.value;
        } else if (item.total_candidates !== undefined) {
          count = 1; // Each assessment entry counts as 1 assessment
        }
        
        // Ensure count is a number
        count = Number(count) || 1;
        
        if (customerMap.has(customerName)) {
          const existing = customerMap.get(customerName)!;
          existing.count += count;
        } else {
          customerMap.set(customerName, { name: customerName, count });
        }
      }
    });

    console.log('Customer map after grouping:', Array.from(customerMap.entries()));

    // If no data after filtering, show empty state
    if (customerMap.size === 0) {
      console.log('No matching customer data found for selected filters');
      this.showAssessmentCustomerChart = false;
      this.assessmentCustomerChartLabels = [];
      this.assessmentCustomerChartValues = [];
      this.assessmentCustomerChartData = [];
      this.cdr.detectChanges();
      return;
    }

    // STEP 4: Sort and prepare final data
    let finalEntries = Array.from(customerMap.entries())
      .sort((a, b) => b[1].count - a[1].count);

    // STEP 5: Handle "Others" aggregation
    // Check if "Others" is already in the data
    const othersIndex = finalEntries.findIndex(([name]) => name.toLowerCase() === 'others');
    let hasOthers = othersIndex !== -1;
    
    let topEntries: [string, { name: string; count: number }][] = [];
    let othersCount = 0;
    
    if (hasOthers) {
      // If "Others" exists, keep it as is (it's pre-aggregated from API)
      topEntries = finalEntries.slice(0, 5);
    } else if (finalEntries.length > 5) {
      // Top 5 + Others
      topEntries = finalEntries.slice(0, 5);
      const rest = finalEntries.slice(5);
      othersCount = rest.reduce((sum, [, data]) => sum + data.count, 0);
      
      if (othersCount > 0) {
        topEntries.push(['Others', { name: 'Others', count: othersCount }]);
      }
    } else {
      // 5 or fewer entries, show all
      topEntries = finalEntries;
    }

    // STEP 6: Set chart data
    this.assessmentCustomerChartLabels = topEntries.map(([name]) => name);
    this.assessmentCustomerChartValues = topEntries.map(([, data]) => data.count);
    this.assessmentCustomerChartData = topEntries.map(([name, data]) => ({
      name: name,
      value: data.count
    }));

    console.log('Final chart labels:', this.assessmentCustomerChartLabels);
    console.log('Final chart values:', this.assessmentCustomerChartValues);

    // STEP 7: Show/hide chart
    const hasValidData = this.assessmentCustomerChartLabels.length > 0 && 
                         this.assessmentCustomerChartValues.some(v => v > 0);
    
    this.showAssessmentCustomerChart = hasValidData;
    if (this.showAssessmentCustomerChart) {
      this.assessmentCustomerChartDataLoaded = true;
    }

    // STEP 8: Initialize chart
    this.cdr.detectChanges();
    
    if (this.showAssessmentCustomerChart) {
      setTimeout(() => {
        const canvases = document.querySelectorAll('#assessmentCustomerChart');
        const canvas = (canvases && canvases.length > 0) ? canvases[0] : document.getElementById('assessmentCustomerChart');
        if (canvas) {
          console.log('Canvas found, initializing assessment customer chart');
          this.initializeAssessmentCustomerChart();
        } else {
          console.warn('Canvas not found for assessment customer chart');
        }
      }, 200);
    }
  } catch (error) {
    console.error('Error processing assessment customer data:', error);
    this.showAssessmentCustomerChart = false;
    this.cdr.detectChanges();
  }
}

  processAssessmentLanguageData(languageStats: any[]): void {
    try {
      if (!languageStats || languageStats.length === 0) {
        this.showAssessmentLanguageChart = false;
        this.assessmentLanguageChartLabels = [];
        this.assessmentLanguageChartValues = [];
        console.log('No assessment language data available');
        return;
      }

      const languageMap = new Map<string, number>();

      languageStats.forEach((item: any) => {
        if (item.language && typeof item.language === 'string') {
          const normalized = item.language.trim();
          
          // If language filter is applied, only count selected languages
          if (this.selectedAssessmentLanguageLanguageValues.length > 0) {
            if (!this.selectedAssessmentLanguageLanguageValues.includes(normalized)) {
              return; // Skip languages that are not selected
            }
          }
          
          let count = 0;
          const hasCourseFilter = this.selectedAssessmentLanguageCourseValues.length > 0;
          const hasCustomerFilter = this.selectedAssessmentLanguageCustomerValues.length > 0;

          if ((hasCourseFilter || hasCustomerFilter) && Array.isArray(item.assessments)) {
            item.assessments.forEach((assessment: any) => {
              let match = true;
              if (hasCourseFilter && assessment.course_name && !this.selectedAssessmentLanguageCourseValues.includes(assessment.course_name)) {
                match = false;
              }
              if (hasCustomerFilter && assessment.customer_name && !this.selectedAssessmentLanguageCustomerValues.includes(assessment.customer_name)) {
                match = false;
              }
              if (match) {
                count++;
              }
            });
          } else {
            count = item.assessment_count || 0;
          }
          
          if (count > 0) {
            languageMap.set(normalized, (languageMap.get(normalized) || 0) + count);
          }
        }
      });

      if (languageMap.size === 0) {
        this.showAssessmentLanguageChart = false;
        this.assessmentLanguageChartLabels = [];
        this.assessmentLanguageChartValues = [];
        console.log('No valid language entries found');
        return;
      }

      const sortedLanguages = Array.from(languageMap.entries()).sort((a, b) => b[1] - a[1]);
      const top5 = sortedLanguages.slice(0, 5);
      const rest = sortedLanguages.slice(5);

      let finalLanguages = top5;
      if (rest.length > 0) {
        const othersCount = rest.reduce((sum, [, cnt]) => sum + cnt, 0);
        finalLanguages = [...top5, ['Others', othersCount]];
      }

      this.assessmentLanguageChartLabels = finalLanguages.map(([lang]) => lang);
      this.assessmentLanguageChartValues = finalLanguages.map(([, cnt]) => cnt);
      this.showAssessmentLanguageChart = this.assessmentLanguageChartLabels.length > 0;

      this.cdr.detectChanges();

      if (this.showAssessmentLanguageChart) {
        setTimeout(() => {
          const canvas = document.getElementById('assessmentLanguageChart') as HTMLCanvasElement;
          if (canvas) {
            this.initializeAssessmentLanguagePieChart();
          }
        }, 150);
      }
    } catch (error) {
      console.error('Error processing assessment language data:', error);
      this.showAssessmentLanguageChart = false;
      this.cdr.detectChanges();
    }
  }

  private initializeAssessmentLanguagePieChart(): void {
    const canvas = document.getElementById('assessmentLanguageChart') as HTMLCanvasElement;
    if (!canvas) {
      console.warn('Assessment language chart canvas not found');
      return;
    }

    if (!this.assessmentLanguageChartLabels.length || !this.assessmentLanguageChartValues.length) {
      this.showAssessmentLanguageChart = false;
      return;
    }

    if (this.assessmentLanguageChart) {
      this.assessmentLanguageChart.destroy();
    }

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      console.error('Unable to get context for assessment language chart');
      return;
    }

    const backgroundColors = [
      '#005068', '#BFCAD9', '#C71E1D', '#A0A0FF', '#A0FFFF', '#F9EDDB', '#98D8C8', '#BB8FCE', '#85C1E9', '#F8B195'
    ];

    this.assessmentLanguageChart = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: this.assessmentLanguageChartLabels,
        datasets: [{
          data: this.assessmentLanguageChartValues,
          backgroundColor: this.assessmentLanguageChartLabels.map((_, i) => backgroundColors[i % backgroundColors.length]),
          borderColor: '#fff',
          borderWidth: 0,
          hoverOffset: 8
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (ctx) => {
                const value = ctx.raw as number;
                const total = this.assessmentLanguageChartValues.reduce((s, v) => s + v, 0);
                const pct = total > 0 ? ((value / total) * 100).toFixed(2) : '0.00';
                return `${ctx.label}: ${value} (${pct}%)`;
              }
            }
          }
        }
      }
    });
  }

  openAssessmentLanguageCompareDialog(): void {
    this.showAssessmentLanguageCompareDialog = true;
    this.showAssessmentLanguageComparisonResults = false;
    this.selectedAssessmentLanguageCompareMonth1 = null;
    this.selectedAssessmentLanguageCompareMonth2 = null;
  }

  closeAssessmentLanguageCompareDialog(): void {
    this.showAssessmentLanguageCompareDialog = false;
    this.showAssessmentLanguageComparisonResults = false;
    this.currentAssessmentLanguageComparisonData = [];
    this.compareAssessmentLanguageComparisonData = [];
  }

  toggleAssessmentLanguageCompareMonth1Dropdown(): void {
    this.showAssessmentLanguageCompareMonth1Dropdown = !this.showAssessmentLanguageCompareMonth1Dropdown;
    if (this.showAssessmentLanguageCompareMonth1Dropdown) {
      this.showAssessmentLanguageCompareMonth2Dropdown = false;
    }
  }

  selectAssessmentLanguageCompareMonth1(month: number): void {
    this.selectedAssessmentLanguageCompareMonth1 = month;
    this.showAssessmentLanguageCompareMonth1Dropdown = false;
  }

  toggleAssessmentLanguageCompareMonth2Dropdown(): void {
    this.showAssessmentLanguageCompareMonth2Dropdown = !this.showAssessmentLanguageCompareMonth2Dropdown;
    if (this.showAssessmentLanguageCompareMonth2Dropdown) {
      this.showAssessmentLanguageCompareMonth1Dropdown = false;
    }
  }

  selectAssessmentLanguageCompareMonth2(month: number): void {
    this.selectedAssessmentLanguageCompareMonth2 = month;
    this.showAssessmentLanguageCompareMonth2Dropdown = false;
  }

  loadAssessmentLanguageComparisonData(): void {
    if (!this.selectedAssessmentLanguageCompareMonth1 || !this.selectedAssessmentLanguageCompareMonth2) {
      return;
    }

    this.isLoading = true;
    this.showAssessmentLanguageComparisonResults = true;

    // Fetch comparison data
    this.fetchAssessmentLanguageComparisonDataMonthWise();
  }

  private fetchAssessmentLanguageComparisonDataMonthWise(): void {
    const currentYear = new Date().getFullYear();

    // For Month 1
    const month1 = this.selectedAssessmentLanguageCompareMonth1!;
    const year1 = month1 <= 3 ? currentYear + 1 : currentYear;
    const month1StartDate = new Date(year1, month1 - 1, 1);
    const month1EndDate = new Date(year1, month1, 0);

    // For Month 2
    const month2 = this.selectedAssessmentLanguageCompareMonth2!;
    const year2 = month2 <= 3 ? currentYear + 1 : currentYear;
    const month2StartDate = new Date(year2, month2 - 1, 1);
    const month2EndDate = new Date(year2, month2, 0);

    const formattedMonth1StartDate = moment(month1StartDate).format('YYYY-MM-DD');
    const formattedMonth1EndDate = moment(month1EndDate).format('YYYY-MM-DD');
    const formattedMonth2StartDate = moment(month2StartDate).format('YYYY-MM-DD');
    const formattedMonth2EndDate = moment(month2EndDate).format('YYYY-MM-DD');

    console.log('Assessment Language - Month 1 Date Range:', formattedMonth1StartDate, 'to', formattedMonth1EndDate);
    console.log('Assessment Language - Month 2 Date Range:', formattedMonth2StartDate, 'to', formattedMonth2EndDate);

    // Fetch Month 1 data
    const resp1 = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedMonth1StartDate,
      end_date: formattedMonth1EndDate
    });

    // Fetch Month 2 data
    const resp2 = this.service.getOperationsData({
      org_id: this.org_id,
      start_date: formattedMonth2StartDate,
      end_date: formattedMonth2EndDate
    });

    let month1Data: any[] = [];
    let month2Data: any[] = [];
    let completedRequests = 0;

    resp1.subscribe(
      (data: any) => {
        console.log('Assessment Language - Month 1 API Full Response:', data);
        console.log('Assessment Language - Month 1 Response Body:', data?.body);
        console.log('Assessment Language - Month 1 Response Keys:', Object.keys(data || {}));

        let response = data?.body?.responseBody || data?.responseBody || data;
        console.log('Assessment Language - Month 1 Extracted Response:', response);
        console.log('Assessment Language - Month 1 OperationsData Keys:', Object.keys(response?.operationsData || {}));
        console.log('Assessment Language - Month 1 Full Response Structure:', JSON.stringify(response, null, 2));

        // Extract language data from top_10_languages or all_languages
        if (response?.operationsData?.top_10_languages) {
          month1Data = response.operationsData.top_10_languages;
          console.log('Assessment Language - Month 1 Language Counts (top_10_languages):', month1Data);
        } else if (response?.operationsData?.all_languages) {
          month1Data = response.operationsData.all_languages;
          console.log('Assessment Language - Month 1 Language Counts (all_languages):', month1Data);
        } else if (response?.operationsData?.language_counts) {
          month1Data = response.operationsData.language_counts;
          console.log('Assessment Language - Month 1 Language Counts (language_counts):', month1Data);
        } else if (response && response.language_counts) {
          month1Data = response.language_counts;
          console.log('Assessment Language - Month 1 Language Counts (Legacy):', month1Data);
        } else if (Array.isArray(response)) {
          month1Data = response;
          console.log('Assessment Language - Month 1 Language Counts (Direct Array):', month1Data);
        } else {
          console.warn('Assessment Language - Month 1: No language data found in response. Available keys:', Object.keys(response?.operationsData || {}));
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentLanguageComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        console.error('Assessment Language - Month 1 API Error:', error);
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentLanguageComparisonDataMonthWise(month1Data, month2Data);
        }
      }
    );

    resp2.subscribe(
      (data: any) => {
        console.log('Assessment Language - Month 2 API Full Response:', data);
        console.log('Assessment Language - Month 2 Response Body:', data?.body);
        console.log('Assessment Language - Month 2 Response Keys:', Object.keys(data || {}));

        let response = data?.body?.responseBody || data?.responseBody || data;
        console.log('Assessment Language - Month 2 Extracted Response:', response);
        console.log('Assessment Language - Month 2 OperationsData Keys:', Object.keys(response?.operationsData || {}));
        console.log('Assessment Language - Month 2 Full Response Structure:', JSON.stringify(response, null, 2));

        // Extract language data from top_10_languages or all_languages
        if (response?.operationsData?.top_10_languages) {
          month2Data = response.operationsData.top_10_languages;
          console.log('Assessment Language - Month 2 Language Counts (top_10_languages):', month2Data);
        } else if (response?.operationsData?.all_languages) {
          month2Data = response.operationsData.all_languages;
          console.log('Assessment Language - Month 2 Language Counts (all_languages):', month2Data);
        } else if (response?.operationsData?.language_counts) {
          month2Data = response.operationsData.language_counts;
          console.log('Assessment Language - Month 2 Language Counts (language_counts):', month2Data);
        } else if (response && response.language_counts) {
          month2Data = response.language_counts;
          console.log('Assessment Language - Month 2 Language Counts (Legacy):', month2Data);
        } else if (Array.isArray(response)) {
          month2Data = response;
          console.log('Assessment Language - Month 2 Language Counts (Direct Array):', month2Data);
        } else {
          console.warn('Assessment Language - Month 2: No language data found in response. Available keys:', Object.keys(response?.operationsData || {}));
        }
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentLanguageComparisonDataMonthWise(month1Data, month2Data);
        }
      },
      (error) => {
        console.error('Assessment Language - Month 2 API Error:', error);
        completedRequests++;
        if (completedRequests === 2) {
          this.processAssessmentLanguageComparisonDataMonthWise(month1Data, month2Data);
        }
      }
    );

    // Set loading complete after both requests
    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    }, 3000);
  }

  private processAssessmentLanguageComparisonDataMonthWise(month1Data: any[], month2Data: any[]): void {
    console.log('Assessment Language - Processing Comparison Data:');
    console.log('Assessment Language - Month 1 Raw Data:', month1Data);
    console.log('Assessment Language - Month 2 Raw Data:', month2Data);

    // Type guard to check if count is a number - be more lenient with the property names
    const isValidLanguage = (language: any): boolean => {
      const count = language?.count ?? language?.assessment_count ?? 0;
      const languageName = language?.language || language?.language_name || language?.language_id;
      return language &&
        languageName &&
        typeof count === 'number' &&
        count > 0;
    };

    // Process Month 1 data
    const validMonth1Languages = month1Data.filter(isValidLanguage).map((language: any) => ({
      name: language.language || language.language_name || `Language ${language.language_id}`,
      count: language.count ?? language.assessment_count ?? 0
    }));
    console.log('Assessment Language - Valid Month 1 Languages:', validMonth1Languages);

    const sortedMonth1Languages = [...validMonth1Languages].sort((a, b) =>
      b.count - a.count
    );
    const topMonth1Languages = sortedMonth1Languages.slice(0, 10);
    const otherMonth1LanguagesTotal = sortedMonth1Languages.slice(10).reduce((sum, language) =>
      sum + language.count, 0
    );

    // Process Month 2 data
    const validMonth2Languages = month2Data.filter(isValidLanguage).map((language: any) => ({
      name: language.language || language.language_name || `Language ${language.language_id}`,
      count: language.count ?? language.assessment_count ?? 0
    }));
    console.log('Assessment Language - Valid Month 2 Languages:', validMonth2Languages);

    const sortedMonth2Languages = [...validMonth2Languages].sort((a, b) =>
      b.count - a.count
    );
    const topMonth2Languages = sortedMonth2Languages.slice(0, 10);
    const otherMonth2LanguagesTotal = sortedMonth2Languages.slice(10).reduce((sum, language) =>
      sum + language.count, 0
    );

    // Store Month 1 data as current
    const month1Totals: { [key: string]: number } = {};
    topMonth1Languages.forEach(language => {
      month1Totals[language.name] = language.count;
    });
    if (otherMonth1LanguagesTotal > 0) {
      month1Totals['Others'] = otherMonth1LanguagesTotal;
    }

    this.currentAssessmentLanguageComparisonData = Object.entries(month1Totals)
      .filter(([_, count]) => count > 0)
      .map(([languageName, count]) => ({
        name: languageName,
        value: count,
        percentage: '0',
        trend: 'neutral'
      }));
    console.log('Assessment Language - Current Comparison Data (Month 1):', this.currentAssessmentLanguageComparisonData);

    // Store Month 2 data as comparison
    const month2Totals: { [key: string]: number } = {};
    topMonth2Languages.forEach(language => {
      month2Totals[language.name] = language.count;
    });
    if (otherMonth2LanguagesTotal > 0) {
      month2Totals['Others'] = otherMonth2LanguagesTotal;
    }

    this.compareAssessmentLanguageComparisonData = Object.entries(month2Totals)
      .filter(([_, count]) => count > 0)
      .map(([languageName, count]) => {
        const currentItem = this.currentAssessmentLanguageComparisonData.find(item => item.name === languageName);
        const currentValue = currentItem ? currentItem.value : 0;

        let trend: 'positive' | 'negative' | 'neutral' = 'neutral';
        if (count > currentValue) {
          trend = 'positive';
        } else if (count < currentValue) {
          trend = 'negative';
        }

        return {
          name: languageName,
          value: count,
          percentage: '0',
          trend: trend
        };
      });
    console.log('Assessment Language - Compare Comparison Data (Month 2):', this.compareAssessmentLanguageComparisonData);

    // Initialize comparison chart
    this.cdr.detectChanges();
    this.initializeAssessmentLanguageComparisonChart();
  }

  private initializeAssessmentLanguageComparisonChart(): void {
    // Prepare data for chart
    const month1Name = this.getMonthName(this.selectedAssessmentLanguageCompareMonth1!);
    const month2Name = this.getMonthName(this.selectedAssessmentLanguageCompareMonth2!);

    // Get unique languages from both datasets
    const allLanguages = new Set<string>();
    this.currentAssessmentLanguageComparisonData.forEach(item => allLanguages.add(item.name));
    this.compareAssessmentLanguageComparisonData.forEach(item => allLanguages.add(item.name));

    const languageNames: string[] = Array.from(allLanguages).slice(0, 10);
    const month1Data: number[] = [];
    const month2Data: number[] = [];

    languageNames.forEach(languageName => {
      const month1Item = this.currentAssessmentLanguageComparisonData.find(item => item.name === languageName);
      const month2Item = this.compareAssessmentLanguageComparisonData.find(item => item.name === languageName);
      month1Data.push(month1Item ? month1Item.value : 0);
      month2Data.push(month2Item ? month2Item.value : 0);
    });

    console.log('Assessment Language - Chart Initialization');
    console.log('Assessment Language - Language Names:', languageNames);
    console.log('Assessment Language - Month 1 Data:', month1Data);
    console.log('Assessment Language - Month 2 Data:', month2Data);

    // Destroy existing chart if it exists
    if (this.assessmentLanguageComparisonChart) {
      this.assessmentLanguageComparisonChart.destroy();
    }

    // Delay chart initialization to ensure DOM is ready
    setTimeout(() => {
      const ctx = document.getElementById('assessmentLanguageComparisonChart') as HTMLCanvasElement;
      if (ctx) {
        try {
          // Set minimum height for horizontal bar chart
          const container = ctx.parentElement;
          if (container) {
            const chartHeight = Math.max(languageNames.length * 40, 300);
            container.style.minHeight = chartHeight + 'px';
          }

          this.assessmentLanguageComparisonChart = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: languageNames,
              datasets: [
                {
                  label: month1Name,
                  data: month1Data,
                  backgroundColor: '#005068',
                  borderColor: '#003d4d',
                  borderWidth: 1,
                  barThickness: 'flex',
                  barPercentage: 0.7
                },
                {
                  label: month2Name,
                  data: month2Data,
                  backgroundColor: '#BFCAD9',
                  borderColor: '#9ba5b8',
                  borderWidth: 1,
                  barThickness: 'flex',
                  barPercentage: 0.7
                }
              ]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              indexAxis: 'y' as const,
              plugins: {
                legend: {
                  position: 'top' as const,
                  display: true
                },
                title: {
                  display: true,
                  text: `Month-wise Assessments Comparison: ${month1Name} vs ${month2Name}`
                },
                filler: {
                  propagate: true
                }
              },
              scales: {
                x: {
                  beginAtZero: true,
                  stacked: false,
                  ticks: {
                    stepSize: 1
                  }
                },
                y: {
                  ticks: {
                    font: {
                      size: 12
                    }
                  }
                }
              }
            }
          });
          console.log('Assessment Language - Chart initialized successfully');
          this.cdr.detectChanges();
        } catch (error) {
          console.error('Assessment Language - Error initializing chart:', error);
        }
      } else {
        console.warn('Assessment Language - Canvas element "assessmentLanguageComparisonChart" not found');
      }
    }, 200);
  }

  openAssessmentLanguageTableModal(): void {
    this.showAssessmentLanguageChartMenu = false;
    this.showAssessmentLanguageTableModal = true;
  }

  closeAssessmentLanguageTableModal(): void {
    this.showAssessmentLanguageTableModal = false;
  }

  exportAssessmentLanguageAsPDF(): void {
    this.showAssessmentLanguageChartMenu = false;
    if (!this.ensureHasData(this.assessmentLanguageChartValues)) { return; }
    
    if (this.assessmentLanguageChart) {
      // Set white background for the canvas to prevent transparency artifacts causing blur
      const canvas = this.assessmentLanguageChart.canvas;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.restore();
      }

      const chartImage = canvas.toDataURL('image/png', 1.0);
      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Add title
      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');
      const chartTitle = 'Assessments by Language';
      const titleWidth = pdf.getTextWidth(chartTitle);
      const titleX = (pageWidth - titleWidth) / 2;
      pdf.text(chartTitle, titleX, 25);

      // Add source/subtitle
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      const subtitle = 'Source: Assessment Planning Analytics';
      const subtitleWidth = pdf.getTextWidth(subtitle);
      const subtitleX = (pageWidth - subtitleWidth) / 2;
      pdf.text(subtitle, subtitleX, 32);

      // Add separator line
      pdf.setDrawColor(200, 200, 200);
      pdf.line(20, 38, pageWidth - 20, 38);

      // Add chart image
      const imgProps = pdf.getImageProperties(chartImage);
      const maxChartWidth = 130; // Limit width to prevent stretching and blurriness
      let chartWidth = pageWidth - 40;
      if (chartWidth > maxChartWidth) {
        chartWidth = maxChartWidth;
      }
      const chartHeight = (imgProps.height * chartWidth) / imgProps.width;
      const chartX = (pageWidth - chartWidth) / 2; // Center the chart horizontally
      const chartY = 45;

      pdf.addImage(chartImage, 'PNG', chartX, chartY, chartWidth, chartHeight);

      // Add data summary below chart
      let currentY = chartY + chartHeight + 15;

      pdf.setFontSize(12);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Summary (Assessments Count):', 20, currentY);
      currentY += 8;

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');

      const totalAssessments = this.assessmentLanguageChartValues.reduce((sum, val) => sum + (val || 0), 0);
      
      this.assessmentLanguageChartLabels.forEach((label, index) => {
        const value = this.assessmentLanguageChartValues[index] || 0;
        const percentage = totalAssessments > 0 ? ((value / totalAssessments) * 100).toFixed(1) : '0.0';
        const text = `${label}: ${value} (${percentage}%)`;
        pdf.text(text, 20, currentY);
        currentY += 5;

        if (currentY > pageHeight - 20) {
          pdf.addPage();
          currentY = 20;
        }
      });
      
      // Add Total
      currentY += 3;
      pdf.setFont('helvetica', 'bold');
      pdf.text(`Total Assessments: ${totalAssessments}`, 20, currentY);

      pdf.save('Assessments_by_Language.pdf');
    }
  }

  exportAssessmentLanguageAsPNG(): void {
    this.showAssessmentLanguageChartMenu = false;
    if (!this.ensureHasData(this.assessmentLanguageChartValues)) { return; }
    
    if (this.assessmentLanguageChart) {
      const container = document.createElement('div');
      container.style.cssText = `
        position: fixed;
        left: -10000px;
        top: -10000px;
        width: 1200px;
        background: white;
        padding: 40px;
        border: 1px solid #ccc;
        z-index: 10000;
        font-family: Arial, sans-serif;
      `;

      const header = document.createElement('div');
      header.style.cssText = `
        text-align: center;
        margin-bottom: 30px;
        padding-bottom: 20px;
        border-bottom: 2px solid #005068;
      `;

      const title = document.createElement('h1');
      title.textContent = 'Assessments by Language';
      title.style.cssText = `
        margin: 0 0 10px 0;
        color: #005068;
        font-size: 28px;
        font-weight: bold;
      `;

      const subtitle = document.createElement('p');
      subtitle.textContent = 'Source: Assessment Planning Analytics';
      subtitle.style.cssText = 'margin: 0; color: #666; font-size: 14px;';

      header.appendChild(title);
      header.appendChild(subtitle);
      container.appendChild(header);

      const mainContent = document.createElement('div');
      mainContent.style.cssText = 'display: flex; gap: 40px; align-items: flex-start;';

      const canvas = this.assessmentLanguageChart.canvas;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.restore();
      }
      
      const chartImg = document.createElement('img');
      chartImg.src = canvas.toDataURL('image/png', 1.0);
      chartImg.style.cssText = 'width: 55%; height: auto; border: 1px solid #eee; border-radius: 4px; padding: 10px; background: white;';
      mainContent.appendChild(chartImg);

      const infoSection = document.createElement('div');
      infoSection.style.cssText = 'width: 40%;';

      const infoTitle = document.createElement('h3');
      infoTitle.textContent = 'Summary';
      infoTitle.style.cssText = 'margin-top: 0; color: #005068; font-size: 20px; margin-bottom: 15px; border-bottom: 1px solid #eee; padding-bottom: 10px;';
      infoSection.appendChild(infoTitle);

      const totalAssessments = this.assessmentLanguageChartValues.reduce((sum, val) => sum + (val || 0), 0);
      
      const candidateColors = [
        '#3498DB', '#E74C3C', '#2ECC71', '#F39C12', '#9B59B6',
        '#1ABC9C', '#34495E', '#E67E22', '#95A5A6', '#D35400'
      ];

      this.assessmentLanguageChartLabels.forEach((label, index) => {
        const value = this.assessmentLanguageChartValues[index] || 0;
        const color = candidateColors[index % candidateColors.length];
        const itemDiv = document.createElement('div');
        itemDiv.style.cssText = `
          padding: 10px 15px;
          margin-bottom: 8px;
          background-color: ${index % 2 === 0 ? '#f9f9f9' : '#ffffff'};
          border-left: 4px solid ${color};
          border-radius: 3px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        `;

        const percentage = totalAssessments > 0 ? ((value / totalAssessments) * 100).toFixed(1) : '0.0';

        itemDiv.innerHTML = `
          <span style="font-weight: 500; color: #333; max-width: 70%; word-break: break-word;">${label}</span>
          <span style="font-weight: bold; color: #005068;">${value} <span style="font-size: 12px; color: #666; font-weight: normal;">(${percentage}%)</span></span>
        `;

        infoSection.appendChild(itemDiv);
      });
      
      const totalDiv = document.createElement('div');
      totalDiv.style.cssText = `
        padding: 12px 15px;
        margin-top: 15px;
        background-color: #005068;
        color: white;
        border-radius: 3px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: bold;
      `;
      totalDiv.innerHTML = `
        <span>Total Assessments</span>
        <span>${totalAssessments}</span>
      `;
      infoSection.appendChild(totalDiv);

      mainContent.appendChild(infoSection);
      container.appendChild(mainContent);

      const footer = document.createElement('div');
      footer.style.cssText = `
        margin-top: 30px;
        text-align: center;
        color: #999;
        font-size: 12px;
        border-top: 1px solid #eee;
        padding-top: 15px;
      `;
      footer.textContent = `Generated on ${new Date().toLocaleString()}`;
      container.appendChild(footer);

      document.body.appendChild(container);

      html2canvas(container, {
        backgroundColor: '#ffffff',
        scale: 2,
        logging: false,
        useCORS: true
      }).then((renderedCanvas: HTMLCanvasElement) => {
        const link = document.createElement('a');
        link.href = renderedCanvas.toDataURL('image/png', 1.0);
        link.download = 'Assessments_by_Language.png';
        link.click();
        document.body.removeChild(container);
      }).catch((err: any) => {
        console.error('Error generating PNG:', err);
        document.body.removeChild(container);
      });
    }
  }

  exportAssessmentLanguageTableAsPDF(): void {
    if (!this.ensureHasData(this.assessmentLanguageChartValues)) { return; }
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();
    let yPosition = 20;
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Assessments by Language - Report', 14, yPosition);
    yPosition += 10;
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');
    pdf.text('Generated on: ' + new Date().toLocaleDateString(), 14, yPosition);
    yPosition += 10;
    const headers = ['Language', 'Assessment Count'];
    const tableData = this.assessmentLanguageChartLabels.map((label, i) => [label, (this.assessmentLanguageChartValues[i] || 0).toString()]);

    (pdf as any).autoTable({
      head: [headers],
      body: tableData,
      startY: yPosition,
      margin: { left: 14, right: 14 },
      theme: 'grid',
      headerStyles: { fillColor: [52, 152, 219], textColor: 255, fontStyle: 'bold' },
      alternateRowStyles: { fillColor: [245, 245, 245] }
    });

    pdf.save('Assessments_by_Language.pdf');
  }

  exportCandidatePerformanceTableAsPDF(): void {
    if (this.candidatePerformanceChartLabels.length === 0) { return; }
    const pdf = new jsPDF();
    let yPosition = 20;

    // Title
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Candidate Data by Performance - Report', 14, yPosition);
    yPosition += 10;

    // Date and filter info
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');
    pdf.text('Generated on: ' + new Date().toLocaleDateString(), 14, yPosition);
    yPosition += 5;
    pdf.text('Filter: ' + (this.candidatePerformanceSelectedToggle === 'pass' ? 'Pass' : 'Fail'), 14, yPosition);
    yPosition += 10;

    // Table Headers
    const isAssessmentWise = (this.selectedCandidatePerformanceCourseValues && this.selectedCandidatePerformanceCourseValues.length > 0) ||
                             (this.selectedCandidatePerformanceGeographyValues && this.selectedCandidatePerformanceGeographyValues.length > 0) ||
                             (this.selectedCandidatePerformanceCustomerValues && this.selectedCandidatePerformanceCustomerValues.length > 0) ||
                             (this.selectedCandidatePerformanceLanguageValues && this.selectedCandidatePerformanceLanguageValues.length > 0);
    const firstHeader = isAssessmentWise ? 'Assessment' : 'Course';
    const headers = [firstHeader, 'Candidate Count', this.candidatePerformanceSelectedToggle === 'pass' ? 'Pass %' : 'Fail %'];
    const tableData = this.candidatePerformanceChartLabels.map((course, i) => {
      const passCount = this.candidatePerformancePassData[i] || 0;
      const failCount = this.candidatePerformanceFailData[i] || 0;
      const total = this.candidatePerformanceTotalCandidateCounts[i] || (passCount + failCount) || 0;
      const percentage = total > 0
        ? (this.candidatePerformanceSelectedToggle === 'pass' 
            ? ((passCount / total) * 100).toFixed(2)
            : ((failCount / total) * 100).toFixed(2))
        : '0.00';
      
      return [
        course,
        total.toString(),
        percentage + '%'
      ];
    });

    (pdf as any).autoTable({
      head: [headers],
      body: tableData,
      startY: yPosition,
      margin: { left: 14, right: 14 },
      theme: 'grid',
      headerStyles: {
        fillColor: [52, 152, 219],
        textColor: 255,
        fontStyle: 'bold'
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      }
    });

    pdf.save('Candidate_Performance_Report.pdf');
  }

  // Assessment Table Export Methods
  exportAssessmentLocationTableAsPDF(): void {
    if (!this.ensureHasData(this.assessmentLocationChartData)) { return; }
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    let yPosition = 20;

    // Title
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Assessments by Location - Report', 14, yPosition);
    yPosition += 10;

    // Date
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');
    pdf.text('Generated on: ' + new Date().toLocaleDateString(), 14, yPosition);
    yPosition += 10;

    // Table Headers
    const headers = ['Location', 'Count', 'Percentage (%)'];
    const tableData = this.assessmentLocationChartData.map(item => [
      item.name,
      item.value.toString(),
      this.getAssessmentLocationPercentage(item)
    ]);

    (pdf as any).autoTable({
      head: [headers],
      body: tableData,
      startY: yPosition,
      margin: { left: 14, right: 14 },
      theme: 'grid',
      headerStyles: {
        fillColor: [52, 152, 219],
        textColor: 255,
        fontStyle: 'bold'
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      }
    });

    pdf.save('Assessments_by_Location.pdf');
  }
  showCourseDownloadSubMenu = false;
  showQuestionPaperCourseDownloadSubMenu = false;

  toggleCourseDownloadSubMenu() {
    this.showCourseDownloadSubMenu = !this.showCourseDownloadSubMenu;
  }

  toggleQuestionPaperCourseDownloadSubMenu() {
    this.showQuestionPaperCourseDownloadSubMenu = !this.showQuestionPaperCourseDownloadSubMenu;
  }

  exportAssessmentCourseTableAsPDF(): void {
    if (!this.ensureHasData(this.assessmentCourseChartData)) { return; }
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();
    let yPosition = 20;

    // Title
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Assessments by Course/Job Role - Report', 14, yPosition);
    yPosition += 10;

    // Date
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');
    pdf.text('Generated on: ' + new Date().toLocaleDateString(), 14, yPosition);
    yPosition += 10;

    // Table Headers
    const headers = ['Course', 'Count', 'Percentage (%)'];
    const tableData = this.assessmentCourseChartData.map(item => [
      item.name,
      item.value.toString(),
      this.getAssessmentCoursePercentage(item)
    ]);

    (pdf as any).autoTable({
      head: [headers],
      body: tableData,
      startY: yPosition,
      margin: { left: 14, right: 14 },
      theme: 'grid',
      headerStyles: {
        fillColor: [52, 152, 219],
        textColor: 255,
        fontStyle: 'bold'
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      }
    });

    pdf.save('Assessments_by_Course.pdf');
  }

  exportAssessmentStatusTableAsPDF(): void {
    if (!this.ensureHasData(this.assessmentStatusChartData)) { return; }
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();
    let yPosition = 20;

    // Title
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Assessments by Status - Report', 14, yPosition);
    yPosition += 10;

    // Date
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');
    pdf.text('Generated on: ' + new Date().toLocaleDateString(), 14, yPosition);
    yPosition += 10;

    // Table Headers
    const headers = ['Status', 'Count', 'Percentage (%)'];
    const tableData = this.assessmentStatusChartData.map(item => [
      item.name,
      item.value.toString(),
      this.getAssessmentStatusPercentage(item)
    ]);

    (pdf as any).autoTable({
      head: [headers],
      body: tableData,
      startY: yPosition,
      margin: { left: 14, right: 14 },
      theme: 'grid',
      headerStyles: {
        fillColor: [52, 152, 219],
        textColor: 255,
        fontStyle: 'bold'
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      }
    });

    pdf.save('Assessments_by_Status.pdf');
  }

  exportCandidateAssessmentTableAsPDF(): void {
    if (!this.ensureHasData(this.candidateAssessmentChartData)) { return; }
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();
    let yPosition = 20;

    // Title
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Candidates by Assessment - Report', 14, yPosition);
    yPosition += 10;

    // Date
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');
    pdf.text('Generated on: ' + new Date().toLocaleDateString(), 14, yPosition);
    yPosition += 10;

    // Table Headers
    const headers = ['Assessment', 'Count', 'Percentage (%)'];
    const tableData = this.candidateAssessmentChartData.map(item => [
      item.name,
      item.value.toString(),
      this.getCandidateAssessmentPercentage(item)
    ]);

    (pdf as any).autoTable({
      head: [headers],
      body: tableData,
      startY: yPosition,
      margin: { left: 14, right: 14 },
      theme: 'grid',
      headerStyles: {
        fillColor: [52, 152, 219],
        textColor: 255,
        fontStyle: 'bold'
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      }
    });

    pdf.save('Candidates_by_Assessment.pdf');
  }

  exportPassFailTableAsPDF(): void {
    if (!this.ensureHasData(this.passFailChartData)) { return; }
    const pdf = new jsPDF();
    let yPosition = 20;

    // Title
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Pass/Fail by Assessment - Report', 14, yPosition);
    yPosition += 10;

    // Date
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');
    pdf.text('Generated on: ' + new Date().toLocaleDateString(), 14, yPosition);
    yPosition += 10;

    // Table Headers
    const headers = ['Assessment', 'Pass', 'Fail', 'Pass %'];
    const tableData = this.passFailChartData.map(item => [
      item.name,
      (item.pass || 0).toString(),
      (item.fail || 0).toString(),
      this.getPassFailPercentage(item)
    ]);

    (pdf as any).autoTable({
      head: [headers],
      body: tableData,
      startY: yPosition,
      margin: { left: 14, right: 14 },
      theme: 'grid',
      headerStyles: {
        fillColor: [52, 152, 219],
        textColor: 255,
        fontStyle: 'bold'
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      }
    });

    pdf.save('PassFail_by_Assessment.pdf');
  }

  // Assessment Customer Table Export Methods
  exportAssessmentCustomerTableAsPDF(): void {
    if (!this.ensureHasData(this.assessmentCustomerChartData)) { return; }
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();
    let yPosition = 20;

    // Title
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Assessment by Customers - Report', 14, yPosition);
    yPosition += 10;

    // Date
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');
    pdf.text('Generated on: ' + new Date().toLocaleDateString(), 14, yPosition);
    yPosition += 10;

    // Table Headers
    const headers = ['Customer', 'Assessment Count'];
    const tableData = this.assessmentCustomerChartData.map(item => [
      item.name,
      item.value.toString()
    ]);

    (pdf as any).autoTable({
      head: [headers],
      body: tableData,
      startY: yPosition,
      margin: { left: 14, right: 14 },
      theme: 'grid',
      headerStyles: {
        fillColor: [52, 152, 219],
        textColor: 255,
        fontStyle: 'bold'
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      }
    });

    pdf.save('Assessment_by_Customers.pdf');
  }
 
  
}

